import { HUBS_AR, HUBS_EN } from "./i18n-hubs.js";
import { CONNECTIONS_AR, CONNECTIONS_EN } from "./i18n-connections.js";
import { HR_OPEN_ISSUES_AR, HR_OPEN_ISSUES_EN } from "./i18n-hr-open-issues.js";
import { HR_PM_B_AR, HR_PM_B_EN } from "./i18n-hr-pm-b.js";
import { HR_PM_C_AR, HR_PM_C_EN } from "./i18n-hr-pm-c.js";
import { HR_SMALL_FEATURES_AR, HR_SMALL_FEATURES_EN } from "./i18n-hr-small-features.js";
import { COMMON_CHANGE_AR, COMMON_CHANGE_EN } from "./i18n-common-change.js";
import { HR_PAYROLL_FEATURES_AR, HR_PAYROLL_FEATURES_EN } from "./i18n-hr-payroll-features.js";
import { HR_GOV_PAYROLL_AR, HR_GOV_PAYROLL_EN } from "./i18n-hr-gov-payroll.js";
import { HR_REVIEW_B_AR, HR_REVIEW_B_EN } from "./i18n-hr-review-b.js";
import { HR_REVIEW_C_AR, HR_REVIEW_C_EN } from "./i18n-hr-review-c.js";
import { HR_REVIEW_D_AR, HR_REVIEW_D_EN } from "./i18n-hr-review-d.js";
import { HR_BENEFITS_AR, HR_BENEFITS_EN } from "./i18n-hr-benefits.js";
import { EXTENSIONS_AR, EXTENSIONS_EN } from "./i18n-extensions.js";
import { FEEDBACK_AR, FEEDBACK_EN } from "./i18n-feedback.js";
import { ACTIVITIES_AR, ACTIVITIES_EN } from "./i18n-activities.js";
import { INVENTORY_AR, INVENTORY_EN } from "./i18n-inventory.js";
import { DOC_TEMPLATES_AR, DOC_TEMPLATES_EN } from "./i18n-doc-templates.js";
import { ATTACHMENTS_AR, ATTACHMENTS_EN } from "./i18n-attachments.js";
import { CORE_HOOKS_AR, CORE_HOOKS_EN } from "./i18n-core-hooks.js";
import { COMMENTS_AR, COMMENTS_EN } from "./i18n-comments.js";
import { APPROVALS_AR, APPROVALS_EN } from "./i18n-approvals.js";
import { OPPORTUNITIES_AR, OPPORTUNITIES_EN } from "./i18n-opportunities.js";
import { CAMPAIGNS_AR, CAMPAIGNS_EN } from "./i18n-campaigns.js";
import { TARGETS_AR, TARGETS_EN } from "./i18n-targets.js";
import { CONSOLE_AR, CONSOLE_EN } from "./i18n-console.js";
import { GOV_SA_AR, GOV_SA_EN } from "./i18n-gov-sa.js";
import { RENDERER_AR, RENDERER_EN } from "./i18n-renderer.js";
import { OFFLINE_AR, OFFLINE_EN } from "./i18n-offline.js";
import { OUTBOX_AR, OUTBOX_EN } from "./i18n-outbox.js";
import { BOARD_AR, BOARD_EN } from "./i18n-board.js";
import { TIMELINE_AR, TIMELINE_EN } from "./i18n-timeline.js";
import { CALENDAR_AR, CALENDAR_EN } from "./i18n-calendar.js";
import { ASSIGNMENTS_AR, ASSIGNMENTS_EN } from "./i18n-assignments.js";
import { REPORT_AR, REPORT_EN } from "./i18n-report.js";
import { SETTINGS_AR, SETTINGS_EN } from "./i18n-settings.js";
import { PAPER_AR, PAPER_EN } from "./i18n-paper.js";
import { LINES_AR, LINES_EN } from "./i18n-lines.js";
import { CORE_SCREENS_AR, CORE_SCREENS_EN } from "./i18n-core-screens.js";
import { HR_LISTS_AR, HR_LISTS_EN } from "./i18n-hr-lists.js";
import { HR_TIME_AR, HR_TIME_EN } from "./i18n-hr-time.js";
import { INVOICING_SALES_AR, INVOICING_SALES_EN } from "./i18n-invoicing-sales.js";
import { HR_CYCLE_AR, HR_CYCLE_EN } from "./i18n-hr-cycle.js";
import { REACH_AR, REACH_EN } from "./i18n-reach.js";
import { EVENTS_AR, EVENTS_EN } from "./i18n-events.js";
import { CONSENT_AR, CONSENT_EN } from "./i18n-consent.js";
import { IMPORTS_AR, IMPORTS_EN } from "./i18n-imports.js";
import { FINANCE_DOCS_AR, FINANCE_DOCS_EN } from "./i18n-finance-docs.js";
import { ACCOUNTING_WORK_AR, ACCOUNTING_WORK_EN } from "./i18n-accounting-work.js";
import { INVOICING_AR, INVOICING_EN } from "./i18n-invoicing.js";
import { HOME_SHELL_AR, HOME_SHELL_EN } from "./i18n-home-shell.js";
import { HOME_AR, HOME_EN } from "./i18n-home.js";
import { PARTIES_AR, PARTIES_EN } from "./i18n-parties.js";
import { PRIVACY_AR, PRIVACY_EN } from "./i18n-privacy.js";
import { PROFILE_AR, PROFILE_EN } from "./i18n-profile.js";
import { LEGAL_AR, LEGAL_EN } from "./i18n-legal.js";
import { FINANCE_DESK_AR, FINANCE_DESK_EN } from "./i18n-finance-desk.js";
import { ANALYTICS_AR, ANALYTICS_EN } from "./i18n-analytics.js";
import { PLATFORM_RECORD_AR, PLATFORM_RECORD_EN } from "./i18n-platform-record.js";
import { LIST_QUERY_AR, LIST_QUERY_EN } from "./i18n-list-query.js";
import { INBOX_AR, INBOX_EN } from "./i18n-inbox.js";
import { AUTOMATION_AR, AUTOMATION_EN } from "./i18n-automation.js";
import { SAVED_VIEWS_AR, SAVED_VIEWS_EN } from "./i18n-saved-views.js";
import { TEAMS_AR, TEAMS_EN } from "./i18n-teams.js";
import { APP_AR, APP_EN } from "./i18n-app.js";
import { PERMISSIONS_AR, PERMISSIONS_EN } from "./i18n-permissions.js";
const EN = {
    ...HUBS_EN,
    ...CONNECTIONS_EN,
    ...HR_OPEN_ISSUES_EN,
    ...HR_PM_B_EN,
    ...HR_PM_C_EN,
    ...HR_SMALL_FEATURES_EN,
    ...COMMON_CHANGE_EN,
    ...HR_PAYROLL_FEATURES_EN,
    ...HR_GOV_PAYROLL_EN,
    ...HR_REVIEW_B_EN,
    ...HR_REVIEW_C_EN,
    ...HR_REVIEW_D_EN,
    ...HR_BENEFITS_EN,
    ...EXTENSIONS_EN,
    ...FEEDBACK_EN,
    ...ACTIVITIES_EN,
    ...INVENTORY_EN,
    ...DOC_TEMPLATES_EN,
    ...ATTACHMENTS_EN,
    ...CORE_HOOKS_EN,
    ...COMMENTS_EN,
    ...APPROVALS_EN,
    ...OPPORTUNITIES_EN,
    ...CAMPAIGNS_EN,
    ...TARGETS_EN,
    ...CONSOLE_EN,
    ...GOV_SA_EN,
    ...RENDERER_EN,
    ...OFFLINE_EN,
    ...OUTBOX_EN,
    ...BOARD_EN,
    ...TIMELINE_EN,
    ...CALENDAR_EN,
    ...ASSIGNMENTS_EN,
    ...REPORT_EN,
    ...SETTINGS_EN,
    ...PAPER_EN,
    ...LINES_EN,
    ...CORE_SCREENS_EN,
    ...HR_LISTS_EN,
    ...HR_TIME_EN,
    ...INVOICING_SALES_EN,
    ...HR_CYCLE_EN,
    ...REACH_EN,
    ...EVENTS_EN,
    ...CONSENT_EN,
    ...IMPORTS_EN,
    ...FINANCE_DOCS_EN,
    ...ACCOUNTING_WORK_EN,
    ...INVOICING_EN,
    ...HOME_SHELL_EN,
    ...HOME_EN,
    ...PARTIES_EN,
    ...PRIVACY_EN,
    ...PLATFORM_RECORD_EN,
    ...LIST_QUERY_EN,
    ...INBOX_EN,
    ...AUTOMATION_EN,
    ...SAVED_VIEWS_EN,
    ...TEAMS_EN,
    ...APP_EN,
    ...PERMISSIONS_EN,
    ...FINANCE_DESK_EN,
    ...PROFILE_EN,
    ...LEGAL_EN,
    ...ANALYTICS_EN,
    'state.unavailable': 'Not reachable right now',
    'state.forbidden': 'You do not have access to this',
    'state.timeout': 'This took too long to answer',
    'state.loading': 'Loading…',
    'state.empty': 'Nothing here yet',
    'state.narrowed': 'Nothing matches what you are looking for',
    'state.planned': 'Not part of this version yet',
    'state.saving': 'Saving…',
    'state.saved': 'Saved',
    'screen.unsupported': 'This screen uses something this version cannot render',
    'screen.unsupported.details': 'Technical details',
    'screen.arrivesLater': 'its screens arrive with the module bundle in Phase 2',
    'screen.noAddress': 'the registry has no address for the unit that hosts this module',
    'field.unsupported': 'This setting has a type this version cannot edit',
    'action.notYet': 'This action is declared but cannot be carried out by this version yet',
    'action.held.pending': 'Checking whether this can be done here',
    'action.held.no': 'This cannot be done here yet',
    'action.revealOnce': 'Copy this and send it to them yourself. It is not stored, and it will not be shown again.',
    'action.refused': 'That was not accepted',
    'action.forThisRow': 'For this row',
    'action.more': 'More actions',
    'action.close': 'Close',
    'action.noPath': 'This row no longer says where the action should go',
    'action.cancel': 'Cancel',
    'action.copy': 'Copy',
    'action.copied': 'Copied',
    'action.follow.working': 'Sending…',
    'change.listHistory': "Change history",
    'change.formHistory': "History",
    'change.what': "Action",
    'change.who': "By",
    'change.when': "When",
    'change.from': "From",
    'change.record': "Record",
    'change.fields': "{n} fields changed",
    'change.field': "Field",
    'change.before': "Before",
    'change.after': "After",
    'change.snapshot': "The record after the change",
    'change.snapshot.deleted': "The record as it was when removed",
    'change.hidden': "Hidden — needs a permission you do not hold",
    'change.openForm': "Open the form",
    'change.gone': "The record was removed; there is no form to open.",
    'change.system': "The system",
    'change.origin.service': "The system",
    'change.origin.migration': "An update of the system",
    'change.origin.anonymous': "Before signing in",
    'change.none': "No changes recorded yet.",
    'change.yes': "Yes",
    'change.no': "No",
    'change.summary.create': "added it",
    'change.summary.update': "changed {n} fields",
    'change.summary.delete': "removed it",
    'change.summary.status': "changed its status",
    'change.field.user.email': "Email",
    'change.field.user.password_hash': "Password",
    'change.field.user.status': "Status",
    'change.field.user.locale': "Language",
    'change.field.user.name': "Name",
    'change.field.user.phone': "Phone",
    'change.field.user.job_title': "Job title",
    'change.field.user.must_change_password': "Must change password at next sign-in",
    'change.field.user.kind': "Account kind",
    'change.field.user.password_chosen': "Password chosen by its holder",
    'change.field.portal_account.user_id': "Account",
    'change.field.portal_account.party_id': "Party",
    'change.field.portal_account.status': "Status",
    'change.field.portal_account.source': "Invited for",
    'change.field.portal_account.invited_by': "Invited by",
    'change.field.portal_account.accepted_at': "Accepted",
    'change.field.portal_account.suspended_at': "Suspended",
    'change.field.portal_account.suspended_by': "Suspended by",
    'change.field.portal_account.token_hash': "Invitation link",
    'change.field.portal_account.expires_at': "Invitation expires",
    'change.field.portal_account.cancelled_at': "Invitation withdrawn",
    'change.field.user.secret_sealed': "Authenticator secret",
    'change.field.user.confirmed_at': "Two-step sign-in confirmed at",
    'change.field.user.pending_sealed': "Authenticator secret offered, not yet confirmed",
    'change.field.user.recovery_code_hashes': "Recovery codes",
    'change.field.user.locked_until': "Locked after wrong codes until",
    'change.field.user.disabled_at': "Two-step sign-in turned off at",
    'change.field.home_layout.pages': "Home pages",
    'change.field.home_layout.archived': "Removed home pages and cards",
    'change.field.member.user_id': "User",
    'change.field.member.invited_by': "Invited by",
    'change.field.member.accepted_at': "Joined on",
    'change.field.member.suspended_at': "Suspended on",
    'change.field.member.suspended_by': "Suspended by",
    'change.field.member.party_id': "Person",
    'change.field.member.service_ends_on': "Service ends on",
    'change.field.member.service_access_until': "Sign-in kept until",
    'change.field.member.service_end_ref': "End of service reference",
    'change.field.member.source': "How they joined",
    'change.field.invitation.name': "Name",
    'change.field.invitation.job_title': "Job title",
    'change.field.member.role_id': "Role",
    'change.field.role.key': "Key",
    'change.field.role.name': "Name",
    'change.field.role.is_system': "Built-in role",
    'change.field.role.description': "Description",
    'change.field.role.name_ar': "Arabic name",
    'change.field.role.description_ar': "Arabic description",
    'change.field.role.colour': "Colour",
    'change.field.role.permission_key': "Permission",
    'change.field.role.requires_second_factor': "Requires two-step sign-in",
    'change.field.invitation.token_hash': "Invitation link",
    'change.field.invitation.email': "Email",
    'change.field.invitation.role_keys': "Roles",
    'change.field.invitation.invited_by': "Invited by",
    'change.field.invitation.expires_at': "Expires on",
    'change.field.invitation.accepted_at': "Accepted on",
    'change.field.invitation.cancelled_at': "Cancelled on",
    'change.field.invitation.cancelled_by': "Cancelled by",
    'change.field.invitation.party_id': "Person",
    'change.field.workspace.key': "Key",
    'change.field.workspace.name': "Name",
    'change.field.workspace.plan': "Plan",
    'change.field.workspace.status': "Status",
    'change.field.workspace.module_key': "Module",
    'change.field.workspace.unit_key': "Unit",
    'change.field.workspace.tier': "Tier",
    'change.field.workspace.default_unit_tier': "Units' default tier",
    'change.field.workspace.state': "Request",
    'change.field.workspace.name_ar': "Name in Arabic",
    'change.field.workspace.name_en': "Name in English",
    'change.field.workspace.logo_file_id': "Logo",
    'change.field.post.author_user': "Written by",
    'change.field.post.kind': "Kind",
    'change.field.post.body': "Text",
    'change.field.post.poll_closes_at': "Poll closes",
    'change.field.post.poll_results': "Results shown",
    'change.field.post.withdrawn_at': "Withdrawn on",
    'change.field.post.withdrawn_by': "Withdrawn by",
    'change.field.party.kind': "Kind",
    'change.field.party.display_name': "Name",
    'change.field.party.status': "Status",
    'change.field.party.merged_into': "Merged into",
    'change.field.party.merged_into_status': "Status of the record merged into",
    'change.field.party.residency': "Residency",
    'change.field.party.purpose': "Address type",
    'change.field.party.line1': "Address line 1",
    'change.field.party.line2': "Address line 2",
    'change.field.party.city': "City",
    'change.field.party.region': "Region",
    'change.field.party.postcode': "Postal code",
    'change.field.party.country': "Country",
    'change.field.party.is_primary': "Primary",
    'change.field.party.street': "Street",
    'change.field.party.building_number': "Building number",
    'change.field.party.district': "District",
    'change.field.party.additional_number': "Additional number",
    'change.field.party.unit_number': "Unit number",
    'change.field.party.short_address': "Short address",
    'change.field.party.label': "Account name",
    'change.field.party.holder_name': "Account holder",
    'change.field.party.account_number': "Account number",
    'change.field.party.bic': "BIC",
    'change.field.party.currency': "Currency",
    'change.field.party.last4': "Last four digits",
    'change.field.party.fingerprint': "Account fingerprint",
    'change.field.party.verified_at': "Verified on",
    'change.field.party.retired_at': "Retired on",
    'change.field.party.scheme': "Identifier type",
    'change.field.party.value': "Identifier",
    'change.field.party.valid_from': "Valid from",
    'change.field.party.valid_to': "Valid to",
    'change.field.party.buyer_scheme': "Buyer identifier type (ZATCA)",
    'change.field.party.legal_name': "Legal name",
    'change.field.party.trading_name': "Trading name",
    'change.field.party.legal_form': "Legal form",
    'change.field.party.registration_date': "Registration date",
    'change.field.party.given_name': "First name",
    'change.field.party.middle_name': "Middle name",
    'change.field.party.family_name': "Family name",
    'change.field.party.prefix': "Title",
    'change.field.party.suffix': "Suffix",
    'change.field.party.to_id': "Related party",
    'change.field.party.role': "Relationship",
    'change.field.party.source': "Source system",
    'change.field.party.source_key': "Key in the source system",
    'change.field.party.source_id': "Merged record",
    'change.field.party.reason': "Reason",
    'change.field.party.merged_by': "Merged by",
    'change.field.party.merged_at': "Merged on",
    'change.field.file.state': "State",
    'change.field.file.content_type': "File type",
    'change.field.file.filename': "File name",
    'change.field.file.declared_size': "Declared size",
    'change.field.file.size': "Size",
    'change.field.file.ref_module': "Attached in module",
    'change.field.file.ref_entity': "Attached to",
    'change.field.file.ref_id': "Attached to record",
    'change.field.file.uploaded_by': "Uploaded by",
    'change.field.file.expires_at': "Expires on",
    'change.field.file.ready_at': "Ready on",
    'change.field.file.failure': "Failure",
    'change.field.activity_retention.days': "Days kept",
    'change.field.setting.group_key': "Group",
    'change.field.setting.version': "Version",
    'change.field.setting.key': "Setting",
    'change.field.setting.value': "Value",
    'nav.audit.changes': "Change history",
    'screen.audit.changes.title': "Change history",
    'screen.audit.changes.lede': "Every addition, edit, removal and change of status: who, when and what changed, field by field.",
    'screen.audit.changes.column.occurred_at': "When",
    'screen.audit.changes.column.actor_name': "Who",
    'screen.audit.changes.column.action': "What",
    'screen.audit.changes.column.label': "Record",
    'screen.audit.changes.column.screen': "Screen",
    'screen.audit.changes.column.change_count': "Fields",
    'screen.audit.changes.column.ip': "Address",
    'screen.audit.changes.filter.action': "What",
    'screen.audit.changes.filter.occurred_at': "When",
    'screen.audit.changes.filter.screen': "Screen",
    'screen.audit.changes.filter.actor_name': "Who",
    'screen.audit.changes.stat.all': "Changes",
    'screen.audit.changes.stat.created': "Added",
    'screen.audit.changes.stat.updated': "Edited",
    'screen.audit.changes.stat.deleted': "Removed",
    'screen.audit.changes.action.details': "Details",
    'value.action.create': "Added",
    'value.action.update': "Edited",
    'value.action.delete': "Removed",
    'value.action.status': "Status changed",
    'list.linkFilter': "Showing only: {filters}.",
    'list.linkFilter.clear': "Show everything",
    'option.days.120': "120 days",
    'option.days.90': "90 days",
    'option.days.60': "60 days",
    'option.days.30': "30 days",
    'option.days.14': "14 days",
    'option.days.7': "7 days",
    'screen.calendar.occasions.action.create.section.occasion': "The occasion",
    'screen.calendar.occasions.action.create.section.days': "Days",
    'screen.calendar.occasions.action.create.section.scope': "Where it applies",
    'screen.documents.items.action.attach.section.document': "The document",
    'screen.documents.items.action.attach.section.owner': "Whose it is",
    'screen.documents.items.action.attach.section.validity': "Validity",
    'screen.documents.items.action.attach.section.notes': "Notes",
    'screen.documents.types.action.create.section.type': "The type",
    'screen.documents.types.action.create.section.expiry': "Expiry and reminders",
    'screen.documents.types.action.create.section.keeping': "Keeping",
    'screen.notifications.rules.action.create.section.when': "When",
    'screen.notifications.rules.action.create.section.who': "Who is told",
    'screen.notifications.rules.action.create.section.importance': "Importance and escalation",
    'screen.notifications.rules.action.edit.section.when': "When",
    'screen.notifications.rules.action.edit.section.who': "Who is told",
    'screen.notifications.rules.action.edit.section.importance': "Importance and escalation",
    'screen.einvoicing.sellers.action.create.section.seller': "The seller",
    'screen.einvoicing.sellers.action.create.section.address': "National address",
    'chips.add': "Search to add…",
    'chips.remove': "Remove {label}",
    'keyvalue.name': "Name",
    'keyvalue.value': "Value",
    'keyvalue.remove': "Remove this row",
    'keyvalue.add': "+ Add a condition",
    'field.after': "Must be on or after {start}.",
    'form.span': "{days}, both ends counted.",
    'unit.span_days.zero': '{n} days',
    'unit.span_days.one': '{n} day',
    'unit.span_days.two': '{n} days',
    'unit.span_days.few': '{n} days',
    'unit.span_days.many': '{n} days',
    'unit.span_days.other': '{n} days',
    'form.required': "Required.",
    'form.missing': "Fill in: {fields}.",
    'form.unsaved': "You have changes that are not saved. Leave this form without them?",
    'form.keepEditing': "Keep editing",
    'form.discard': "Discard and leave",
    'form.saveNext': "Save and add another",
    'form.savedNext': "Saved. The form is ready for the next one.",
    'form.openSaved': "Open the saved record",
    'form.now': "Now: {value}",
    'form.secret.current': "Now: set · {value} — leave it empty to keep it",
    'form.secret.unset': "Not set yet",
    'screen.parties.parties.action.add_address.section.national': "National address",
    'screen.parties.parties.action.add_address.section.national.help': "The address as registered with the national address service.",
    'screen.parties.parties.action.add_address.section.abroad': "Address abroad",
    'unit.sar': "SAR",
    'unit.percent': "%",
    'unit.day': "days",
    'unit.month': "months",
    'unit.year': "years",
    'unit.minute': "min",
    'unit.metre': "m",
    'field.format.code': "Latin letters, digits and _ . - @ only.",
    'field.format.email': "An email address, like name@example.com.",
    'field.format.phone': "A phone number of 9 to 15 digits, + allowed at the start.",
    'field.format.vat': "15 digits, starting and ending with 3.",
    'field.format.cr': "10 digits.",
    'field.format.national_id': "10 digits, starting with 1 (national ID) or 2 (iqama).",
    'field.format.postcode': "5 digits.",
    'field.format.building': "4 digits.",
    'form.check': "Check the marked fields.",
    'option.colour.blue': "Blue",
    'option.colour.green': "Green",
    'option.colour.teal': "Teal",
    'option.colour.amber': "Amber",
    'option.colour.red': "Red",
    'option.colour.pink': "Pink",
    'option.colour.violet': "Violet",
    'option.colour.grey': "Grey",
    'option.sa_region.riyadh': "Riyadh",
    'option.sa_region.makkah': "Makkah",
    'option.sa_region.madinah': "Madinah",
    'option.sa_region.eastern_province': "Eastern Province",
    'option.sa_region.qassim': "Qassim",
    'option.sa_region.asir': "Asir",
    'option.sa_region.tabuk': "Tabuk",
    'option.sa_region.hail': "Hail",
    'option.sa_region.northern_borders': "Northern Borders",
    'option.sa_region.jazan': "Jazan",
    'option.sa_region.najran': "Najran",
    'option.sa_region.al_bahah': "Al Bahah",
    'option.sa_region.al_jawf': "Al Jawf",
    'action.done': 'Done',
    /** Between several values in one cell. A comma in English; Arabic has its own. */
    /* What a value means, asked as value.{column}.{value}. These belong to identity's data rather
       than to the shell, and they live here until a module can ship a catalogue of its own; a miss
       shows the value itself, so a module whose words are not here is legible, not broken. */
    'value.is_system.true': 'System',
    'value.is_system.false': 'Custom',
    'value.second_factor.true': 'In use',
    'value.second_factor.false': 'Not set up',
    'value.requires_second_factor.true': 'Required',
    'value.requires_second_factor.false': 'Not required',
    'value.status.active': 'Active',
    'value.status.suspended': 'Paused',
    'value.status.after_service': 'Service ended',
    'value.status.invited': 'Invited',
    'value.status.expired': 'Expired',
    'value.enabled.true': 'On',
    'value.enabled.false': 'Off',
    'value.core.true': 'Core',
    'value.core.false': 'Optional',
    'list.all': 'All',
    'list.closed': 'Closed',
    'grid.rows': 'Resource',
    'grid.action.view': 'View',
    'grid.action.create': 'Create',
    'grid.action.update': 'Edit',
    'grid.action.delete': 'Delete',
    'grid.action.manage': 'Manage',
    'grid.others': 'Other permissions',
    'grid.count': '{held} of {of}',
    'grid.all': 'All',
    'grid.none': 'None',
    'grid.added': 'added',
    'grid.removed': 'removed',
    'grid.granted': 'granted',
    'list.search': 'Search',
    'list.results': '{n:results}',
    'list.showing': 'Showing {n} of {total}',
    'list.results.filtered': 'after filtering',
    'list.sort.asc': 'Sort ascending',
    'list.sort.desc': 'Sort descending',
    'list.sort.none': 'Clear sort',
    'list.sort.by': 'Sort by {column}',
    'list.column.options': 'Options for {column}',
    'list.column.filter': 'Filter by this column…',
    'list.advanced': 'Advanced filters',
    'list.advanced.description': 'One condition per line; the comparisons come from the column type. You choose how they combine — all of them, or any — and a group in parentheses carries its own relation.',
    'list.advanced.none': 'This screen declares no columns to filter on.',
    'list.match': 'Match',
    'list.match.all': 'all conditions',
    'list.match.any': 'any condition',
    'list.match.following': 'below',
    'list.match.inGroup': 'in this group',
    'list.condition.add': 'Add condition',
    'list.condition.remove': 'Remove condition',
    'list.condition.field': 'Column',
    'list.condition.operator': 'Comparison',
    'list.condition.value': 'Value',
    'list.condition.values': 'Values',
    'list.group.add': 'Add group',
    'list.group.remove': 'Remove group',
    'list.filters.clear': 'Clear all',
    'list.empty.title': 'No data to show right now',
    'list.narrowed.title': 'Nothing matches these conditions',
    'list.narrowed.lede': 'The figures above have not moved: they are counted over everything, not over what the filters left.',
    'list.apply': 'Apply',
    'list.and': 'and',
    'list.or': 'or',
    'list.between.from': 'From',
    'list.between.to': 'To',
    'list.between.text': 'between {from} and {to}',
    'op.contains': 'contains',
    'op.starts': 'starts with',
    'op.eq': 'equals',
    'op.in': 'is one of',
    'op.gt': 'greater than',
    'op.lt': 'less than',
    'op.between': 'between',
    'op.on': 'on',
    'op.before': 'before',
    'op.after': 'after',
    'op.is': 'is',
    'list.page.range': 'Showing {from}–{to} of {total}',
    'list.page.size': 'Per page',
    'list.page.nav': 'Pages',
    'list.page.prev': 'Previous page',
    'list.page.next': 'Next page',
    'list.export': 'Export',
    'list.export.description': 'The file is built from the same query that draws the list — the sort and the filters as you set them — never from the rows in view alone.',
    'list.export.scope': 'Scope',
    'list.export.filtered': 'All results after filtering ({n})',
    'list.export.page': 'This page only ({n})',
    'list.export.selected': 'Selected rows ({n})',
    'list.export.selected.short': 'Export selected',
    'list.export.format': 'Format',
    'list.export.format.csv': 'Opens anywhere; UTF-8 with a byte-order mark so Excel reads Arabic as Arabic',
    'list.export.columns': 'Columns',
    'list.export.columns.shown': 'The columns shown',
    'list.export.columns.all': 'Every column of the screen',
    'list.export.download': 'Download',
    'list.selection.count': '{n} selected',
    'list.selection.onPage': '{n} on this page',
    'list.selection.clear': 'Clear selection',
    'list.pick': 'Select this row',
    // A row's box and its buttons say which row: forty «Select this row» and forty «Edit» name none (screen-reader review, 2026-10-27).
    'list.pickRow': 'Select {name}',
    'action.onRow': '{action}: {name}',
    'list.pickPage': 'Select every row on this page',
    'list.bulk.title': '{action} — {n} rows?',
    'list.bulk.description': 'The server judges each row on its own: a row that breaks a rule is refused and the reason is shown; the rest go through.',
    'list.bulk.willRun': 'Will run on',
    'list.bulk.willSkip': 'Does not apply to',
    'list.bulk.skipWhy': 'rows this action is not offered on',
    'list.bulk.outcome': '{done} done',
    'list.bulk.outcome.refused': '{refused} refused',
    'lookup.placeholder': 'Type to search…',
    'lookup.add': 'Add "{text}"',
    'lookup.none': 'Nothing matches',
    'lookup.clear': 'Clear',
    'lookup.noCreate': 'That screen has no create action to open',
    'lookup.createForbidden': 'Adding one here needs a permission you do not hold',
    'file.choose': 'Choose a file',
    'file.change': 'Change',
    'file.remove': 'Remove',
    'file.tooLarge': 'Larger than {limit}',
    'file.storing': 'Uploading…',
    'file.notStored': 'The file was not uploaded: {reason}',
    'file.store.noMedia': 'Files cannot be uploaded here: the file store is not enabled in this workspace.',
    'file.store.refused': 'The file store refused the upload.',
    'file.store.unreachable': 'The file store could not be reached.',
    'file.chooseMany': 'Choose files',
    'file.add': 'Add a file',
    'file.tooMany': 'At most {limit} files',
    'audio.record': 'Record',
    'audio.stop': 'Stop',
    'audio.recording': 'Recording {elapsed}',
    'audio.limit': 'Up to {limit}',
    'audio.unsupported': 'This browser cannot record sound. Attach a recording as a file instead.',
    'audio.denied': 'The microphone was not allowed. Allow it in the browser\'s settings and try again.',
    'audio.failed': 'No microphone could be used.',
    'value.separator': ', ',
    'value.everything': 'Everything',
    'value.yes': 'Yes',
    'value.no': 'No',
    'value.source.default': 'from the platform',
    'value.source.override': 'set here',
    'value.source.unset': 'no value yet',
    'action.save': 'Save',
    'action.reset': 'Use the platform value',
    'action.resetShort': 'Reset',
    'action.undo': 'Undo',
    'action.retry': 'Try again',
    'action.signOut': 'Sign out',
    'wizard.lede': 'An assistant writes these questions from what this system offers and what each setting accepts. It never sees your data, and it will never ask for a password or a key. You can skip all of it.',
    'wizard.reportFailed': 'Everything above happened, but the assistant could not be told about part of it. It will be offered again next time; finishing it again is safe.',
    'wizard.writing': 'Writing the next question…',
    'wizard.question.n': 'Question {n}',
    'wizard.byAssistant': 'written by the assistant',
    'wizard.answered': 'What you have answered',
    'wizard.change': 'Change',
    'wizard.setAside': '{n} later answers set aside — the questions changed.',
    'wizard.nothingChosen': 'Nothing chosen',
    'wizard.continue': 'Continue',
    'wizard.backToQuestions': 'Back to the questions',
    'wizard.review.title': 'What will happen',
    'wizard.review.summaryCaption': 'The assistant’s summary of what it understood',
    'wizard.review.turnsOn': 'Turns on',
    'wizard.review.writes': 'Writes',
    'wizard.review.pulledInBy': 'comes with {by}',
    'wizard.review.nothing': 'Nothing is chosen to turn on.',
    'wizard.review.toDefault': 'back to the default',
    'wizard.apply.modules': 'turn on {n}',
    'wizard.apply.settings': 'write {n}',
    'wizard.apply.join': ' and ',
    'wizard.apply.and': 'Finish: {what}',
    'wizard.apply.nothing': 'Finish',
    'wizard.applying': 'Applying…',
    'wizard.result.title': 'Done',
    'wizard.result.count': '{ok} done · {refused} refused',
    'wizard.outcome.ok': 'done',
    'wizard.outcome.rejected': 'refused',
    'wizard.outcome.forbidden': 'not allowed',
    'wizard.outcome.unavailable': 'unreachable',
    'wizard.outcome.timeout': 'timed out',
    'wizard.outcome.skipped': 'not done',
    'wizard.notTried': 'not tried, because turning on what you chose was refused',
    'wizard.noWorkspaceAddress': 'the workspace unit has no address yet',
    'wizard.continueAnyway': 'Open the workspace anyway',
    'wizard.open': 'Open the workspace',
    'wizard.next.title': 'What to set up next',
    'wizard.next.lede': 'What you switched on is ready to be set up. Start with the first, or come back to these from each one’s setup section.',
    'wizard.next.start': 'Start setting up',
    'wizard.resume.title': 'Something was left unfinished',
    'wizard.resume.lede': 'A setup was confirmed earlier and not finished — {n} part(s) went through. What is ticked below is still to do; untick anything you would rather leave.',
    'wizard.finish': 'Finish the rest',
    'wizard.fallback.noAssistant': 'No assistant is deployed — these two questions work without one.',
    'wizard.fallback.unavailable': 'The assistant could not be reached — these two questions work without it.',
    'wizard.fallback.refused': 'The assistant’s answer could not be used — these two questions work without it.',
    'setup.title': 'Welcome',
    'setup.name.title': 'What do your colleagues call you?',
    'setup.name.help': 'Shown in the sidebar and on everything you prepare or approve, instead of your email address.',
    'setup.name.required': 'Write your name, 120 characters at most.',
    'setup.lede': 'Two questions, and this workspace is ready to work in.',
    'setup.step.pack': 'What is this workspace for?',
    'setup.step.modules': 'What it starts with',
    'setup.step.of': 'Step {n} of 2',
    'setup.back': 'Back',
    'setup.skip': 'Skip',
    'setup.noPacks': 'There are no starter packs yet. What the workspace uses can be turned on from its settings.',
    'setup.finish': 'Turn on {n} and finish',
    'setup.notHere': 'This system does not have: {keys}. The rest still applies.',
    'module.settings': 'Settings',
    'module.activity_log': 'Activity log',
    'module.tags': 'Tags',
    'module.media': 'Files',
    'auth.email': 'Email',
    'auth.identifier': 'Email or mobile number',
    'auth.password': 'Password',
    'auth.signIn': 'Sign in',
    'invite.heading': 'Invitation',
    'invite.title': 'Join {workspace}',
    'assistant.open': 'Ask the assistant',
    'assistant.title': 'Assistant',
    'assistant.close': 'Close the assistant',
    'assistant.new': 'New conversation',
    'assistant.placeholder': 'Ask about anything in the system…',
    'assistant.send': 'Send',
    'assistant.pick': 'Pick part of the page',
    'assistant.picking': 'Click any part of the page, or Tab and Enter. Esc to stop.',
    'assistant.pickCancel': 'Stop picking',
    'assistant.removePick': 'Remove {what}',
    'assistant.thinking': 'Working on it…',
    'assistant.intro': 'I know every part of the system and read what your account can read. Ask about a screen, a record, or how to do something — or pick part of the page and ask about it.',
    'assistant.example.1': 'What can I do in this workspace?',
    'assistant.example.2': 'Explain what is on this page',
    'assistant.example.3': 'How do I invite a new user?',
    'assistant.explainPage': 'Explain the current screen',
    'assistant.howItWorks': 'I keep none of your system\'s data: I know how it is built, not what is in it. When you ask, I read only what I need, with your access, and write you the answer. Your conversations are kept for you alone.',
    'assistant.proposal': 'Proposed values for {form}',
    'assistant.proposal.form': 'the open form',
    'assistant.apply': 'Apply to the form',
    'assistant.applied': 'Applied — review them and press Save yourself.',
    'assistant.proposalGone': 'That form is no longer open.',
    'assistant.filledMark': 'Assistant',
    'assistant.yes': 'Yes',
    'assistant.no': 'No',
    'assistant.photo.button': 'Fill from photo',
    'assistant.photo.hint': 'Take or choose a photo of the document; the assistant reads it into this form, and you apply what you agree with.',
    'assistant.photo.reading': 'Reading the photo…',
    'assistant.photo.trace': 'Read a photo into the form',
    'assistant.photo.nothing': 'Nothing in the photo matched this form\'s fields.',
    'assistant.photo.unsure': 'Check these before you apply them; the photo was unclear there: {fields}',
    'assistant.photo.failed': 'The photo could not be read. {reason}',
    'assistant.photo.off': 'Reading photos with the assistant is turned off for this workspace.',
    'assistant.photo.notImage': 'That file is not a photo the browser can read.',
    'assistant.photo.noFields': 'This form has no field a photo can fill.',
    'assistant.photo.tooLarge': 'The photo is larger than {limit}.',
    'assistant.error.limit': 'The assistant has reached its limit for now. Try again later.',
    'assistant.error.unavailable': 'The assistant cannot be reached right now.',
    'assistant.error.slow': 'The model took too long to answer. Ask again, or ask a shorter question.',
    'assistant.error.key': 'The assistant\u2019s model key was refused. The platform owner needs to renew it.',
    'assistant.error.busy': 'The model is busy right now. Try again in a minute.',
    'assistant.error.model': 'The model could not answer: {detail}',
    'assistant.error.long': 'This conversation is too long. Start a new one.',
    'assistant.error.context': 'The assistant could not take this page\u2019s description of the system. Report it, and it will be fixed.',
    'assistant.error.failed': 'The assistant could not answer: {detail}',
    'assistant.trace.read': 'Read {what}',
    'assistant.trace.describe': 'Looked at how {what} works',
    'assistant.trace.api': 'Looked up the read routes of {what}',
    'assistant.trace.call': 'Read {what}',
    'assistant.trace.page': 'Read this page',
    'assistant.trace.find': 'Looked for {what} in the system',
    'assistant.trace.open': 'Opened {what}',
    'assistant.trace.form': 'Opened the form {what}',
    'assistant.trace.fill': 'Proposed values for the form',
    'assistant.trace.highlight': 'Pointed at part of the page',
    'assistant.trace.failed': 'A step failed',
    // A home-page card proposed from a sentence (POST /home/cards/propose), refused with a reason.
    'assistant.refusal.home.prompt': 'Write what the card should show, in at most {max} characters.',
    'assistant.refusal.home.request': 'The request for a card could not be read. Reload the page and try again.',
    'assistant.refusal.home.catalogue': 'There are no routes to build a card from, or more than {max}. Reload the page and try again.',
    'assistant.refusal.home.actions': 'The actions offered for the card’s forms are more than {max}, or not in the expected form. Reload the page and try again.',
    'assistant.refusal.home.sample': 'The sample of fields sent with the request is not names and types only, or has more than {max} for one route.',
    'assistant.refusal.home.current': 'The card being changed is not a valid card. Build a new one instead.',
    'assistant.refusal.home.none': 'The assistant did not propose a card. Try saying it another way.',
    'assistant.refusal.home.invalid': 'The assistant proposed a card that is not valid. Try saying it another way.',
    'assistant.refusal.home.write': 'The proposed source {path} changes data or is not a read a card may make. A card only reads.',
    'assistant.refusal.home.blank': 'The proposed source {path} leaves part of its path blank. Name a list rather than one record.',
    'assistant.refusal.home.route': 'The proposed source {path} is not one of the routes you can read.',
    'assistant.refusal.home.param': '"{name}" is not a parameter of {path}.',
    'assistant.refusal.home.field': '"{field}" is not a field of {path}.',
    'assistant.refusal.home.paged_group': '{path} answers one page at a time, so a chart of it would count only that page. Ask for a count or a table instead.',
    'assistant.refusal.home.paged_filter': '{path} answers one page at a time, so a filter on the card would narrow only that page. Narrow the route itself instead.',
    'assistant.refusal.home.paged_sort': '{path} answers one page at a time, so sorting it on the card would order only that page.',
    'assistant.refusal.home.explanation': 'The assistant did not explain the card in both languages. Try again.',
    'assistant.refusal.home.conversation': 'This card\'s conversation could not be named in that form. Close the card and open it again.',
    'assistant.mode.right': 'Dock on the right',
    'assistant.mode.left': 'Dock on the left',
    'assistant.mode.box': 'Chat box — drag it anywhere',
    'assistant.mode.full': 'Whole page',
    'assistant.drag': 'Drag to move the assistant; let go at the left or right edge to dock it',
    'assistant.history': 'Earlier conversations',
    'assistant.history.kept': 'Your conversations are kept for you alone, for {days} days after you last use them.',
    'assistant.history.empty': 'No earlier conversations yet.',
    'assistant.history.meta': '{n} questions · {when}',
    'assistant.history.delete': 'Delete “{title}”',
    'invite.lede.new': 'You were invited to this workspace. Choose your name and a password to join it.',
    'invite.lede.account': 'This address already has an account. Sign in with its password to join this workspace too.',
    'invite.name': 'Your name',
    'invite.newPassword': 'Choose a password',
    'invite.passwordAgain': 'The password again',
    'invite.passwordHelp': 'At least {n} characters.',
    'invite.passwordShort': 'The password needs at least {n} characters.',
    'invite.passwordMismatch': 'The two passwords are not the same.',
    'invite.accept': 'Join the workspace',
    'invite.acceptSignIn': 'Sign in and join',
    'invite.until': 'This link works until {date}, once.',
    'invite.closed.unknown': 'This link does not work: the invitation was withdrawn or replaced by a newer link. Ask whoever invited you for a new one.',
    'invite.closed.accepted': 'This invitation was already accepted. Sign in to reach the workspace.',
    'invite.closed.expired': 'This invitation expired. Ask whoever invited you to send a new link.',
    'invite.closed.unavailable': 'The invitation could not be read right now. Try the link again shortly.',
    'auth.chooseWorkspace': 'Choose a workspace',
    'auth.choosePortal': 'Choose a portal',
    'auth.group.workspaces': 'Workspaces',
    'auth.group.portals': 'Portals',
    'auth.portalWord': 'Portal',
    'portal.title': 'Portal',
    'portal.menu.label': 'My account',
    'portal.menu.account': 'My account',
    'portal.menu.switch': 'Switch to {workspace}\'s portal',
    'portal.menu.signOut': 'Sign out',
    'portal.account.title': 'My account',
    'portal.account.back': 'Back to the portal',
    'portal.empty.title': 'Nothing is shared with you here yet',
    'portal.empty.description': 'When {workspace} shares something with you, it appears here.',
    'portal.tab.failed': 'This section cannot be loaded now.',
    'portal.tab.retry': 'Try again',
    'portal.back': 'Back to the list',
    'portalInvite.heading': 'Portal invitation',
    'portalInvite.lede': 'You were invited to {workspace}\'s portal.',
    'portalInvite.lede.by': '{inviter} invited you to {workspace}\'s portal.',
    'portalInvite.hasPassword': 'You already have a password. Accept, then sign in with it.',
    'portalInvite.newPassword': 'Choose a password',
    'portalInvite.passwordAgain': 'The password again',
    'portalInvite.passwordHelp': 'At least {n} characters.',
    'portalInvite.passwordShort': 'The password needs at least {n} characters.',
    'portalInvite.passwordMismatch': 'The two passwords are not the same.',
    'portalInvite.accept': 'Accept the invitation',
    'portalInvite.acceptSetPassword': 'Accept and set the password',
    'portalInvite.until': 'This link works until {date}, once.',
    'portalInvite.closed.unknown': 'This link does not work: the invitation was withdrawn or replaced by a newer link. Ask for a new one.',
    'portalInvite.closed.accepted': 'This invitation has been used. Sign in to reach the portal.',
    'portalInvite.closed.expired': 'This invitation has expired; ask for a new one.',
    'portalInvite.closed.unavailable': 'The invitation could not be read right now. Try the link again shortly.',
    'auth.signOutUnconfirmed': 'You are signed out here, but identity did not confirm it. Sign out again when it is reachable.',
    'auth.secondStep.title': 'Two-step sign-in',
    'auth.secondStep.lede': 'Enter the six-digit code your authenticator application shows for {workspace}.',
    'auth.secondStep.code': 'Code',
    'auth.secondStep.recoveryCode': 'Recovery code',
    'auth.secondStep.useRecovery': 'My phone is not at hand: use a recovery code',
    'auth.secondStep.useCode': 'Use the authenticator instead',
    'auth.secondStep.continue': 'Continue',
    'auth.secondStep.back': 'Choose another workspace',
    'auth.secondStep.enrolFirst': '{workspace} requires two-step sign-in. Set it up now; you are let in once the first code is confirmed.',
    'auth.secondStep.locked': 'Too many wrong codes. Try again in {minutes} minutes.',
    'identity.refusal.second_factor.code_required': 'Enter the code from your authenticator application.',
    'identity.refusal.second_factor.not_enrolled': 'This workspace requires two-step sign-in. Set it up first.',
    'identity.refusal.second_factor.wrong_code': 'That code is not right.',
    'identity.refusal.second_factor.locked': 'Too many wrong codes. Try again in {minutes} minutes.',
    'identity.refusal.second_factor.nothing_pending': 'There is no new authenticator waiting for a code. Start again.',
    'identity.refusal.second_factor.not_configured': 'Two-step sign-in is not available on this installation: it has no key to keep authenticator secrets with (SECOND_FACTOR_KEK).',
    'identity.refusal.second_factor.password_required': 'Enter your current password.',
    'identity.refusal.second_factor.wrong_password': 'That is not your current password.',
    'identity.refusal.home.stale': 'Your home pages were changed in another window. Reload them and try again.',
    'identity.refusal.home.version': 'This save does not say which version of your home pages it was made from. Reload them and try again.',
    'identity.refusal.member.name_required': 'Enter the person\'s name. Nobody is added by e-mail address alone.',
    'identity.refusal.sign_in.wrong_credentials': 'The email, mobile number or password is not right.',
    'identity.refusal.sign_in.ambiguous_phone': 'This mobile number belongs to more than one account. Sign in with your email instead.',
    'identity.refusal.sign_in.too_many_attempts': 'Too many attempts. Try again in {minutes} minutes.',
    'identity.refusal.workspace_unknown': 'No company has this code. Check it and try again.',
    'identity.refusal.branding.nothing': 'Write the name in Arabic, in English, or both.',
    'identity.refusal.branding.name_ar': 'The name in Arabic is text of up to 120 characters.',
    'identity.refusal.branding.name_en': 'The name in English is text of up to 120 characters.',
    'media.refusal.logo.file_id': 'Choose an image, or remove the logo.',
    'media.refusal.logo.not_found': 'This file is not in this workspace.',
    'media.refusal.logo.not_ready': 'The image has not finished uploading.',
    'media.refusal.logo.type': 'A logo is a PNG, JPEG or WebP image.',
    'media.refusal.logo.size': 'The image is too large for a logo: 2 MB at most.',
    'media.refusal.logo.none': 'This workspace has no logo.',
    'identity.refusal.workspace_lookup.too_many': 'Too many tries. Wait a minute and try again.',
    'identity.refusal.phone.taken': 'Another account already uses this mobile number. Each person signs in with their own.',
    'identity.refusal.portal.party_required': 'Choose the party to invite.',
    'identity.refusal.portal.module_required': 'Choose the module whose portal the party is invited to.',
    'identity.refusal.portal.unknown_party': 'There is no such active party in this workspace.',
    'identity.refusal.portal.no_contact': 'This party has neither an email nor a mobile number to be invited on. Add one to its record first.',
    'identity.refusal.portal.no_portal': 'The module {module} has no portal in this workspace.',
    'identity.refusal.portal.already_active': 'This party already signs in to the portal.',
    'identity.refusal.portal.suspended': 'This party\'s portal account is suspended. Resume it instead.',
    'identity.refusal.portal.not_suspended': 'This portal account is not suspended.',
    'identity.refusal.portal.account_taken': 'The account with this party\'s email or mobile number already signs in to this portal as another party.',
    'identity.refusal.portal.ambiguous_phone': 'This mobile number belongs to more than one account. Give the party an email.',
    'identity.refusal.portal.unknown_account': 'There is no such portal account in this workspace.',
    'identity.refusal.portal.no_account': 'You have no active portal account in this workspace, or it is suspended.',
    'identity.refusal.portal.external_account': 'This account belongs to a person outside the workspace (a portal account). It cannot be a member.',
    'identity.refusal.portal_invitation.unknown': 'This invitation link is not valid. Ask for a new one.',
    'identity.refusal.portal_invitation.accepted': 'This invitation was already accepted. Sign in instead.',
    'identity.refusal.portal_invitation.expired': 'This invitation has expired. Ask for a new one.',
    'identity.refusal.role.portal_permission': 'A portal permission is never put on a role: {keys}',
    'identity.refusal.password.wrong_current': 'That is not your current password.',
    'identity.refusal.password.too_short': 'A password needs at least {min} characters.',
    'identity.refusal.password.unchanged': 'Choose a password different from the one you have.',
    'identity.refusal.home.shape': 'This is not a list of pages and cards.',
    'identity.refusal.home.too_many_pages': 'You can have at most {max} home pages.',
    'identity.refusal.home.too_many_cards': 'A page can hold at most {max} cards.',
    'identity.refusal.home.too_many_hubs': 'Only one page can be the workspace hub.',
    'identity.refusal.home.page_shape': 'This page has something a home page does not have.',
    'identity.refusal.home.page_id': 'This page has no valid identifier.',
    'identity.refusal.home.page_id_duplicate': 'Two pages have the same identifier.',
    'identity.refusal.home.page_kind': 'A page is either the workspace hub or a page of cards.',
    'identity.refusal.home.hub': 'A hub page names its hub, and only a hub page does.',
    'identity.refusal.home.hub_cards': 'The hub page shows the hub itself; it holds no cards of its own.',
    'identity.refusal.home.title': 'Give the page a name in Arabic and in English, each up to {max} characters.',
    'identity.refusal.home.card_invalid': 'This card is not valid: {reason}',
    'identity.refusal.home.card_id_duplicate': 'Two cards have the same identifier.',
    'identity.refusal.home.not_archived': 'There is no removed page or card with this identifier.',
    'identity.refusal.home.card_page_gone': 'The page this card was on is no longer on your home. Restore the page first.',
    'nav.noModules': 'No modules are enabled for this workspace yet',
    'settings.title': 'Settings',
    'settings.lede': 'What this workspace decides for itself, and what it takes from the platform.',
    'nav.modules': 'Modules',
    'nav.globals': 'Quick access',
    'nav.home': 'Home',
    'screen.missing.title': 'This screen is not available',
    'screen.missing.module': 'Its module is not enabled in this workspace. A workspace administrator can enable it.',
    'screen.missing.screen': 'You do not have access to this screen, or the link is not right.',
    'screen.missing.home': 'Go to Home',
    'nav.search': 'Search',
    'nav.favourites': 'Favourites',
    'nav.favourites.none': 'Nothing pinned yet — star a screen in the list below.',
    'nav.favourite.add': 'Pin to favourites',
    'nav.favourite.remove': 'Unpin',
    'nav.recents': 'Recent',
    'nav.recents.none': 'Screens and records you open will be listed here.',
    // Quiet sub-headings inside a sidebar unit: its daily work first, under no word, then these.
    'nav.section.follow_up': 'Follow-up',
    'nav.section.setup': 'Setup',
    // Beside a list whose rows each open a record page of their own.
    'nav.quick': 'Quick access',
    'nav.category.current': 'Current area',
    'nav.category.short': 'Area',
    'nav.units': 'Units',
    'nav.category.switch': 'Switch area',
    // The switcher's button when the current line belongs to a family of lines (module.json → family).
    'nav.category.in_family': '{family} › {line}',
    'notifications.title': 'Notifications',
    'palette.records': 'Records',
    'hub.approvals.waiting': '{n} waiting for your decision',
    'notifications.none': 'No notifications',
    'notifications.about': 'About: {name}',
    'notifications.due': 'Was due {day}',
    'notifications.repeats': 'Told {n}',
    'notifications.late_for': 'Late for {days}',
    'notifications.open_item': 'Open: {item}',
    'notifications.acknowledge_item': 'Acknowledge: {item}',
    'notifications.markRead_item': 'Mark as read: {item}',
    'notifications.open': 'Open',
    'search.placeholder': 'Search people, records, screens…',
    'palette.title': 'Go to',
    'palette.hint': 'Search people, records, screens and actions…',
    'palette.nothing': 'Nothing matches that',
    'palette.actions': 'Actions',
    'nav.toggle': 'Show or hide the module list',
    'nav.skipToContent': 'Skip to content',
    'nav.trail': 'Where you are',
    'locale.switch': 'Language',
    // The lines of work, the sidebar's first level. The keys are module.schema.json's
    // $defs.categoryKey.enum and shell/src/categories.test.ts fails if a key here is missing a word.
    'category.finance': 'Finance',
    'category.people': 'Human resources',
    'category.parties': 'Parties',
    'category.platform': 'Platform',
    'category.administration': 'Administration',
    'category.unit': 'Unit',
    'category.unfiled': 'Unfiled',
    'group.sales': 'Sales',
    'group.purchases': 'Purchases',
    'group.bank': 'Bank',
    'group.ledger': 'Ledger',
    'group.reports': 'Reports and analytics',
    'group.setup': 'Setup',
    'group.einvoicing': 'E-invoicing',
    // The finance units, by the task a person comes to do.
    'group.treasury': 'Treasury and banks',
    'group.general_ledger': 'General accounting',
    'group.tax_einvoicing': 'Tax',
    'group.statements': 'Financial statements',
    'group.settings_export': 'Settings and export',
    'editor.back': 'Back to the list',
    'nav.accounting.accounts': 'Accounts',
    'nav.accounting.balance_sheet': 'Statement of financial position',
    'nav.accounting.deposits': 'Customer advances',
    'nav.accounting.dimension_values': 'Dimension values',
    'nav.accounting.dimensions': 'Dimensions',
    'nav.accounting.entries': 'Journal entries',
    'nav.accounting.fiscal_years': 'Fiscal years',
    'nav.accounting.income_statement': 'Income statement',
    'nav.accounting.journals': 'Journals',
    'nav.accounting.lock_dates': 'Lock dates',
    'nav.accounting.opening': 'Opening balances',
    'nav.accounting.periods': 'Periods and closing',
    'nav.accounting.posting_rules': 'Posting rules',
    'nav.accounting.receivables': 'Receivables',
    'nav.accounting.tax_codes': 'Tax codes',
    'nav.accounting.tax_rules': 'Tax rules',
    'nav.accounting.trial_balance': 'Trial balance',
    'nav.activity_log.activity': 'Activity',
    'nav.calendar.occasions': 'Occasions',
    'nav.documents.items': 'Documents',
    'nav.notifications.items': 'Notifications',
    'nav.einvoicing.connector': 'FATOORA connection',
    'nav.einvoicing.devices': 'EGS units',
    'nav.einvoicing.edocuments': 'E-invoices',
    'nav.einvoicing.sellers': 'Seller details',
    'nav.einvoicing.submissions': 'Submission log',
    'nav.identity.modules': 'Units',
    'nav.identity.people': 'Users',
    'nav.identity.roles': 'Roles and permissions',
    'nav.invoicing.aging_ap': 'Payables aging',
    'nav.invoicing.aging_ar': 'Receivables aging',
    'nav.invoicing.bank_reconciliation': 'Bank reconciliation',
    'nav.invoicing.chart_mappings': 'External chart mapping',
    'nav.invoicing.customer_statements': 'Party balances',
    'nav.invoicing.documents': 'Invoices',
    'nav.invoicing.export_batches': 'External accounting export',
    'nav.invoicing.payments': 'Receipt and payment vouchers',
    'nav.invoicing.tax_register': 'Tax invoice register',
    'nav.invoicing.vat_return': 'VAT return',
    'nav.invoicing.vendor_bills': 'Vendor bills',
    'nav.invoicing.wht_statement': 'Withholding tax statement',
    'nav.media.media': 'Files',
    'nav.module.accounting': 'Accounting',
    'nav.module.activity_log': 'Activity log',
    'nav.module.audit': 'Change history',
    'nav.module.privacy': 'Personal data',
    'nav.module.chat': 'Assistant chat',
    'nav.module.calendar': 'Calendar',
    'nav.module.documents': 'Documents',
    'nav.module.notifications': 'Notifications',
    'nav.module.einvoicing': 'E-invoicing',
    'nav.module.identity': 'Identity',
    'nav.module.invoicing': 'Invoicing',
    'nav.module.media': 'Files',
    'nav.module.parties': 'Parties',
    'nav.module.settings': 'Settings',
    'nav.module.tags': 'Tags',
    'nav.parties.parties': 'Parties',
    'nav.settings.settings': 'Settings',
    'value.account_type.asset': 'Asset',
    'value.account_type.asset_bank': 'Bank',
    'value.account_type.asset_cash': 'Cash',
    'value.account_type.asset_current': 'Current asset',
    'value.account_type.asset_non_current': 'Non-current asset',
    'value.account_type.asset_receivable': 'Receivable',
    'value.account_type.customer_deposit': 'Customer advances',
    'value.account_type.equity': 'Equity',
    'value.account_type.expense': 'Expense',
    'value.account_type.income': 'Income',
    'value.account_type.liability': 'Liability',
    'value.account_type.liability_current': 'Current liability',
    'value.account_type.liability_non_current': 'Non-current liability',
    'value.account_type.liability_payable': 'Payable',
    'value.account_type.off_balance': 'Off balance',
    'value.bucket.0_30': '0–30 days',
    'value.bucket.31_60': '31–60 days',
    'value.bucket.61_90': '61–90 days',
    'value.bucket.over_90': 'Over 90 days',
    'value.buyer_type.*': 'Any',
    'value.buyer_type.b2b': 'Business',
    'value.buyer_type.b2c': 'Consumer',
    'value.buyer_type.non_resident': 'Non-resident',
    'value.buyer_type.resident': 'Resident',
    'value.calendar.gregorian': 'Gregorian',
    'value.calendar.hijri': 'Hijri',
    'value.circuit_open.false': 'Closed',
    'value.circuit_open.true': 'Open',
    'value.classification.simplified': 'Simplified',
    'value.classification.standard': 'Standard',
    'value.direction.inbound': 'Inbound',
    'value.direction.outbound': 'Outbound',
    'value.deductible.full': 'Full',
    'value.deductible.none': 'None',
    'value.deductible.partial': 'Partial',
    'value.environment.issue_only': 'Issue only',
    'value.environment.production': 'Production',
    'value.environment.sandbox': 'Sandbox',
    'value.format.csv': 'CSV',
    'value.format.json': 'JSON',
    'value.journal_type.bank': 'Bank',
    'value.journal_type.cash': 'Cash',
    'value.journal_type.general': 'General',
    'value.journal_type.purchase': 'Purchase',
    'value.journal_type.purchases': 'Purchases',
    'value.journal_type.sale': 'Sale',
    'value.journal_type.sales': 'Sales',
    'value.journal_type.zakat': 'Zakat',
    'value.kind.credit_note': 'Credit note',
    'value.kind.customer_invoice': 'Customer invoice',
    'value.kind.debit_note': 'Debit note',
    'value.kind.organisation': 'Organisation',
    'value.kind.person': 'Person',
    'value.kind.vendor_bill': 'Vendor bill',
    'value.match_kind.bank_charge': 'Bank charge',
    'value.match_kind.item': 'Open item',
    'value.method.bank': 'Bank',
    'value.method.card': 'Card',
    'value.method.cash': 'Cash',
    'value.method.other': 'Other',
    'value.path.clearance': 'Clearance',
    'value.path.not_required': 'Not required',
    'value.path.reporting': 'Reporting',
    'value.presentation.credit': 'Credit',
    'value.presentation.debit': 'Debit',
    'value.presentation.income_statement': 'Income statement',
    'value.presentation.off_balance': 'Off balance',
    'value.presentation.statement_of_financial_position': 'Statement of financial position',
    'value.residency.non_resident': 'Non-resident',
    'value.residency.resident': 'Resident',
    'value.report_status.cleared': 'Cleared',
    'value.report_status.not_required': 'Not required',
    'value.report_status.pending': 'Pending',
    'value.report_status.rejected': 'Rejected',
    'value.report_status.reported': 'Reported',
    'value.response_status.error': 'Error',
    'value.response_status.ok': 'Accepted',
    'value.response_status.rejected': "Rejected",
    'value.response_status.unreachable': "Unreachable",
    'value.retry_class.none': 'None',
    'value.retry_class.permanent': 'Permanent',
    'value.retry_class.retryable': 'Retryable',
    'value.retry_class.terminal': 'Terminal',
    'value.retry_class.transient': 'Transient',
    'value.scope.documents': 'Documents',
    'value.scope.journal_items': 'Journal items',
    'value.source_kind.account': 'Account',
    'value.source_kind.import': 'Imported',
    'value.source_kind.journal': 'Journal',
    'value.source_kind.manual': 'Manual',
    'value.source_kind.tax_code': 'Tax code',
    'value.state.closed': 'Closed',
    'value.state.closing': 'Closing',
    'value.state.confirmed': 'Confirmed',
    'value.state.exported': 'Exported',
    'value.state.open': 'Open',
    'value.state.reopened': 'Reopened',
    'value.status.closed': 'Closed',
    'value.status.closing': 'Closing',
    'value.status.open': 'Open',
    'value.status.reopened': 'Reopened',
    'value.status.password_pending': "Awaiting a password",
    'value.supply_destination.*': 'Any',
    'value.supply_destination.domestic': 'Domestic',
    'value.supply_destination.export': 'Export',
    'value.supply_destination.gcc': 'GCC',
    'value.tax_type.exempt': 'Exempt',
    'value.tax_type.out_of_scope': 'Out of scope',
    'value.tax_type.standard': 'Standard',
    'value.tax_type.vat': 'VAT',
    'value.tax_type.withholding': 'Withholding tax',
    'value.tax_type.zero': 'Zero-rated',
    'value.state.draft': 'Draft',
    'value.state.posted': 'Posted',
    'value.state.validated': 'Validated',
    'value.state.cancelled_by_note': 'Cancelled by note',
    'value.state.reversed': 'Reversed',
    'value.state.ready': 'Ready',
    'value.state.pending': 'Pending',
    'value.state.failed': 'Failed',
    'editor.field.name': 'Name',
    'editor.field.date': 'Date',
    'editor.field.csv': 'CSV',
    'editor.address.street': 'Street',
    'editor.address.buildingNumber': 'Building number',
    'editor.address.district': 'District',
    'editor.address.city': 'City',
    'editor.address.region': 'Region',
    'editor.address.postcode': 'Postcode',
    'editor.address.country': 'Country',
    'editor.address.additionalNumber': 'Additional number',
    'editor.address.unitNumber': 'Unit number',
    'editor.address.complete': 'Address is complete',
    'editor.address.incomplete': 'Missing: {list}',
    'editor.address.buildingDigits': 'building number must be four digits',
    'editor.line.description': 'Description',
    'editor.line.quantity': 'Quantity',
    'editor.line.unitPrice': 'Price',
    'editor.line.discount': 'Discount',
    'editor.line.taxCode': 'Tax code',
    'editor.line.taxRate': 'Rate %',
    'editor.line.account': 'Account',
    'editor.line.expenseAccount': 'Expense account',
    'editor.line.add': 'Add a line',
    'editor.line.remove': 'Remove this line',
    'editor.line.net': 'Net',
    'editor.entry.total': 'Total',
    'editor.opening.format': 'account_code,debit,credit — one line each, a header row optional.',
    'editor.opening.fromFile': 'Read a file instead',
    'editor.bank.amountHint': 'Leave empty to match the whole line.',
    'editor.export.scope.journalItems': 'Journal items',
    'editor.export.scope.documents': 'Documents',
    'editor.export.externalRefHint': 'The reference the receiving system gave this batch.',
    'editor.invoice.title': 'Customer invoice',
    'editor.invoice.partyId': 'Customer',
    'editor.invoice.vat': 'VAT number',
    'editor.invoice.salesJournal': 'Sales journal',
    'editor.invoice.issueOn': 'Issue date',
    'editor.invoice.dueOn': 'Due date',
    'editor.invoice.dueOnHint': 'Left empty, it is the issue date plus the payment term, or the issue date.',
    'editor.invoice.address': 'National address',
    'editor.invoice.totals': 'Net {net} + tax {tax} = total {total} SAR — half-up, two decimals, 0.01 tolerance',
    'editor.invoice.zatca': 'E-invoice classification',
    'editor.invoice.classification': 'Classification',
    'editor.invoice.standard': 'Standard (B2B)',
    'editor.invoice.simplified': 'Simplified (B2C)',
    'editor.invoice.override': 'Recorded override reason',
    'editor.invoice.saveIssue': 'Save and issue',
    'editor.saveDraft': 'Save draft',
    'editor.draft.saved': 'Saved as a draft. It stays a draft until it is issued: open it again from the list to finish it.',
    'editor.draft.loading': 'Opening the draft…',
    'editor.draft.failed': 'The draft could not be opened: {reason}',
    'editor.draft.final': 'This document is {state}. An issued document is not edited; it is corrected by a credit or debit note.',
    'editor.draft.status.posted': 'issued',
    'editor.draft.status.validated': 'validated',
    'editor.draft.status.cancelled_by_note': 'cancelled by a note',
    'editor.vendor.saveIssue': 'Save and issue',
    'editor.vendor.held': 'Saved as a draft and not issued: {reason}. The draft is still yours to change: fix it here, or fix what stopped it, and issue again.',
    'editor.vendor.issued': 'Vendor bill {id} issued.',
    'editor.invoice.saved': 'Invoice {id} issued.',
    'editor.invoice.qr': 'QR {qr}',
    'editor.invoice.qrPending': 'QR appears after issue when a seller and device exist',
    'editor.invoice.classificationAuto': "Automatic, from the VAT number",
    'editor.invoice.held': "Saved as a draft and not issued: {reason}. The draft is still yours to change: fix it here, or fix what stopped it (a tax code to confirm, a period to open), and issue again.",
    'editor.invoice.issueAgain': "Issue again",
    'editor.invoice.party': "Customer",
    'editor.vendor.title': 'Vendor bill',
    'editor.vendor.partyId': 'Vendor id',
    'editor.vendor.residency': 'Residency',
    'editor.vendor.resident': 'Resident',
    'editor.vendor.nonResident': 'Non-resident',
    'editor.vendor.purchaseJournal': 'Purchase journal',
    'editor.vendor.wht': 'Non-resident withholding',
    'editor.vendor.whtCode': 'Withholding tax code',
    'editor.vendor.whtRate': 'Withholding rate %',
    'editor.vendor.payable': 'Net {net} + tax {vat} − withholding {wht} = payable {payable}',
    'editor.vendor.whtNote': 'Withholding posts to a liability and does not enter the e-invoice.',
    'editor.vendor.issueOn': "Bill date",
    'editor.vendor.dueOn': "Due date",
    'editor.vendor.dueOnHint': "Left empty, it is the bill date plus the payment term, or the bill date.",
    'editor.vendor.party': "Vendor",
    'editor.entry.periodBanner': 'Period follows the date {date} — posting to a locked period is refused (ACC-3). A posted entry is not edited.',
    'editor.entry.journalId': 'Journal id',
    'editor.entry.narration': 'Narration',
    'editor.entry.debit': 'Debit',
    'editor.entry.credit': 'Credit',
    'editor.entry.difference': 'Difference (debit − credit): {amount}',
    'editor.entry.post': 'Post',
    'editor.entry.posted': 'Posted #{number}',
    'editor.entry.journal': "Journal",
    'editor.opening.lede': 'Opening balances post through a general journal only. The counterpart is usually equity 300000 from the starter chart.',
    'editor.opening.import': 'Import opening',
    'editor.opening.posted': 'Opening posted #{number}',
    'editor.bank.statement': 'Statement',
    'editor.bank.journalId': 'Bank journal id',
    'editor.bank.import': 'Import',
    'editor.bank.match': 'Matching',
    'editor.bank.lineId': 'Statement line id',
    'editor.bank.itemId': 'Open item id',
    'editor.bank.amount': 'Amount (must not exceed the line)',
    'editor.bank.matchItem': 'Match item',
    'editor.bank.charge': 'Match as bank charge',
    'editor.bank.difference': 'Statement {id} difference {amount}',
    'editor.bank.chooseFirst': "Import a statement, or open one already imported, to match its lines.",
    'editor.bank.csvHint': "booked_on,amount,narration — with that header line first. Money out is negative.",
    'editor.bank.item': "Open item",
    'editor.bank.journal': "Bank journal",
    'editor.bank.line': "Statement line",
    'editor.bank.open': "A statement already imported",
    'editor.export.produce': 'Produce',
    'editor.export.periodFrom': 'Period from',
    'editor.export.periodTo': 'Period to',
    'editor.export.scope': 'Scope',
    'editor.export.format': 'Format',
    'editor.export.produceAction': 'Produce export',
    'editor.export.confirm': 'Confirm (second person)',
    'editor.export.batchId': 'Batch id',
    'editor.export.externalRef': 'External reference',
    'editor.export.confirmAction': 'Confirm',
    'editor.export.result': 'Batch {id} lines {lines}',
    'editor.backToList': "Back to the list",
    'screen.accounting.accounts.action.create': "New account",
    'screen.accounting.accounts.action.create.field.account_type': "Type",
    'screen.accounting.accounts.action.create.field.code': "Code",
    'screen.accounting.accounts.action.create.field.name_ar': "Name (Arabic)",
    'screen.accounting.accounts.action.create.field.name_en': "Name (English)",
    'screen.accounting.accounts.action.create.field.code.help': "Six digits. The first digit follows the chart: 1 assets, 2 liabilities, 3 equity, 4 income, 5 expenses.",
    'screen.accounting.accounts.action.create.field.presentation': "Statement",
    'screen.accounting.accounts.action.create.field.reconcilable': "Reconcilable",
    'screen.accounting.accounts.action.create.field.reconcilable.help': "Receivable and payable accounts are reconciled against payments. Only reconcilable receivable accounts appear under receivables.",
    'screen.accounting.accounts.action.import_coa': "Import starter chart",
    'screen.accounting.accounts.action.retire': "Retire",
    'screen.accounting.accounts.column.account_type': "Type",
    'screen.accounting.accounts.column.code': "Code",
    'screen.accounting.accounts.column.name_ar': "Name",
    'screen.accounting.accounts.column.presentation': "Presentation",
    'screen.accounting.accounts.title': "Accounts",
    'screen.accounting.balance_sheet.column.account_type': "Type",
    'screen.accounting.balance_sheet.column.balance': "Balance",
    'screen.accounting.balance_sheet.column.code': "Code",
    'screen.accounting.balance_sheet.column.name_ar': "Account",
    'screen.accounting.balance_sheet.title': 'Statement of financial position',
    'screen.accounting.deposits.action.post_deposit': 'Post an advance',
    'screen.accounting.deposits.action.post_deposit.field.amount': "Amount",
    'screen.accounting.deposits.action.post_deposit.field.cash_account_id': "Cash or bank account",
    'screen.accounting.deposits.action.post_deposit.field.date': "Date",
    'screen.accounting.deposits.action.post_deposit.field.deposit_account_id': "Customer deposits account",
    'screen.accounting.deposits.action.post_deposit.field.journal_id': "Journal",
    'screen.accounting.deposits.action.post_deposit.field.narration_ar': "Narration",
    'screen.accounting.deposits.action.post_deposit.field.party_id': "Customer",
    'screen.accounting.deposits.action.post_deposit.field.cash_account_id.help': "A cash or bank account.",
    'screen.accounting.deposits.action.post_deposit.field.deposit_account_id.help': "An account of type customer deposit.",
    'screen.accounting.deposits.column.account_type': "Type",
    'screen.accounting.deposits.column.code': "Code",
    'screen.accounting.deposits.column.name_ar': "Name",
    'screen.accounting.deposits.lede': "Post a customer advance: debit cash/bank, credit a customer_deposit liability.",
    'screen.accounting.deposits.title': 'Customer advances',
    'screen.accounting.deposits.column.entry_date': "Date",
    'screen.accounting.deposits.lede.list': 'Advances received from customers before an invoice: debit cash or bank, credit the customer advances account.',
    'screen.accounting.deposits.empty': "No customer deposits posted yet.",
    'screen.accounting.opening.lede.short': "The opening balances, as one balanced entry: import a file, whose every line is checked before anything posts, or paste the balances.",
    'screen.accounting.opening.empty': "No opening balances imported yet.",
    'screen.einvoicing.period.column.missing_count': "Not sent",
    'screen.accounting.dimension_values.action.create': "New value",
    'screen.accounting.dimension_values.action.create.field.code': "Code",
    'screen.accounting.dimension_values.action.create.field.dimension_id': "Dimension",
    'screen.accounting.dimension_values.action.create.field.name_ar': "Name (AR)",
    'screen.accounting.dimension_values.action.create.field.name_en': "Name (EN)",
    'screen.accounting.dimension_values.action.retire': "Retire",
    'screen.accounting.dimension_values.column.code': "Code",
    'screen.accounting.dimension_values.column.dimension_id': "Dimension",
    'screen.accounting.dimension_values.column.name_ar': "Name (AR)",
    'screen.accounting.dimension_values.column.name_en': "Name (EN)",
    'screen.accounting.dimension_values.title': "Dimension values",
    'screen.accounting.dimensions.action.create': "New dimension",
    'screen.accounting.dimensions.action.create.field.code': "Code",
    'screen.accounting.dimensions.action.create.field.name_ar': "Name (AR)",
    'screen.accounting.dimensions.action.create.field.name_en': "Name (EN)",
    'screen.accounting.dimensions.action.import_pack': "Import starter dimensions",
    'screen.accounting.dimensions.action.retire': "Retire",
    'screen.accounting.dimensions.column.code': "Code",
    'screen.accounting.dimensions.column.name_ar': "Name (AR)",
    'screen.accounting.dimensions.column.name_en': "Name (EN)",
    'screen.accounting.dimensions.title': "Dimensions",
    'screen.accounting.entries.action.create': "New journal entry",
    'screen.accounting.entries.action.reverse': "Reverse",
    'screen.accounting.entries.action.reverse.field.reason': "Reason (required if you posted this entry)",
    'screen.accounting.entries.column.branch': "Branch",
    'screen.accounting.entries.column.entry_date': "Date",
    'screen.accounting.entries.column.narration_ar': "Narration",
    'screen.accounting.entries.column.number': "Number",
    'screen.accounting.entries.column.posted_by': "Posted by",
    'screen.accounting.entries.column.state': "State",
    'screen.accounting.entries.filter.branch': "Branch",
    'screen.accounting.entries.lede': "Posted entries. Filter by branch after the branch dimension is imported.",
    'screen.accounting.entries.title': "Journal entries",
    'screen.accounting.entry_new.lede': "Write the lines, then post. A posted entry is not edited — reverse it instead.",
    'screen.accounting.entry_new.title': "New journal entry",
    'screen.accounting.fiscal_years.action.create': "New fiscal year",
    'screen.accounting.fiscal_years.action.create.field.calendar': "Calendar",
    'screen.accounting.fiscal_years.action.create.field.ends_on': "Ends on",
    'screen.accounting.fiscal_years.action.create.field.name_ar': "Name (Arabic)",
    'screen.accounting.fiscal_years.action.create.field.starts_on': "Starts on",
    'screen.accounting.fiscal_years.action.create.field.name_en': "Name (English)",
    'screen.accounting.fiscal_years.column.calendar': "Calendar",
    'screen.accounting.fiscal_years.column.ends_on': "To",
    'screen.accounting.fiscal_years.column.name_ar': "Name",
    'screen.accounting.fiscal_years.column.starts_on': "From",
    'screen.accounting.fiscal_years.column.status': "Status",
    'screen.accounting.fiscal_years.lede': "Create the fiscal year first, then add periods under it.",
    'screen.accounting.fiscal_years.title': "Fiscal years",
    'screen.accounting.income_statement.column.account_type': "Type",
    'screen.accounting.income_statement.column.amount': "Amount",
    'screen.accounting.income_statement.column.code': "Code",
    'screen.accounting.income_statement.column.name_ar': "Account",
    'screen.accounting.income_statement.title': "Income statement",
    'screen.accounting.journals.action.create': "New journal",
    'screen.accounting.journals.action.create.field.code': "Code",
    'screen.accounting.journals.action.create.field.journal_type': "Type",
    'screen.accounting.journals.action.create.field.name_ar': "Name (Arabic)",
    'screen.accounting.journals.action.create.field.code.help': "A short code such as SALES or BANK1. It cannot be changed later.",
    'screen.accounting.journals.action.create.field.default_account_id': "Default account",
    'screen.accounting.journals.action.create.field.default_account_id.help': "The journal's own side of what it books by itself. Bank and cash journals need one before they can take a payment or import a statement.",
    'screen.accounting.journals.action.create.field.name_en': "Name (English)",
    'screen.accounting.journals.action.retire': "Retire",
    'screen.accounting.journals.action.edit': "Edit",
    'screen.accounting.journals.action.edit.field.default_account_id': "Default account",
    'screen.accounting.journals.action.edit.field.default_account_id.help': "Bank and cash journals need one before they can take a payment or import a statement.",
    'screen.accounting.journals.action.edit.field.name_ar': "Name (Arabic)",
    'screen.accounting.journals.action.edit.field.name_en': "Name (English)",
    'screen.accounting.journals.column.code': "Code",
    'screen.accounting.journals.column.journal_type': "Type",
    'screen.accounting.journals.column.name_ar': "Name",
    'screen.accounting.journals.column.next_number': "Next number",
    'screen.accounting.journals.title': "Journals",
    'screen.accounting.lock_dates.action.set_locks': "Set lock dates",
    'screen.accounting.lock_dates.action.set_locks.field.fiscal_lock_on': "Books locked up to",
    'screen.accounting.lock_dates.action.set_locks.field.tax_lock_on': "Tax locked up to",
    'screen.accounting.lock_dates.action.set_locks.field.fiscal_lock_on.help': "No entry dated on or before this day can be posted or changed.",
    'screen.accounting.lock_dates.action.set_locks.field.tax_lock_on.help': "Usually the end of the last VAT return filed. Both dates are saved together.",
    'screen.accounting.lock_dates.column.fiscal_lock_on': "Fiscal lock",
    'screen.accounting.lock_dates.column.set_by': "Set by",
    'screen.accounting.lock_dates.column.tax_lock_on': "Tax lock",
    'screen.accounting.lock_dates.column.updated_at': "Updated",
    'screen.accounting.lock_dates.lede': "Fiscal and tax lock dates. Posting on or before a lock is refused (ACC-3).",
    'screen.accounting.lock_dates.title': "Lock dates",
    'screen.accounting.opening.action.import_csv': "Import opening CSV",
    'screen.accounting.opening.action.import_csv.field.csv': "Balances (CSV)",
    'screen.accounting.opening.action.import_csv.field.date': "Date",
    'screen.accounting.opening.action.import_csv.field.journal_id': "Journal",
    'screen.accounting.opening.action.import_csv.field.csv.help': "One line per account: account_code,debit,credit — with that header line first.",
    'screen.accounting.opening.action.import_csv.field.journal_id.help': "A general journal.",
    'screen.accounting.opening.column.entry_date': "Date",
    'screen.accounting.opening.column.narration_ar': "Narration",
    'screen.accounting.opening.column.number': "Number",
    'screen.accounting.opening.column.state': "State",
    'screen.accounting.opening.lede': "Import opening balances as a balanced general-journal entry. Contra typically equity 300000 from the starter chart.",
    'screen.accounting.opening.title': "Opening balances",
    'screen.accounting.periods.action.close': "Close",
    'screen.accounting.periods.action.review_close': "Check and close",
    'screen.accounting.periods.action.create': "New period",
    'screen.accounting.periods.action.create.field.ends_on': "Ends on",
    'screen.accounting.periods.action.create.field.fiscal_year_id': "Fiscal year",
    'screen.accounting.periods.action.create.field.name_ar': "Name (Arabic)",
    'screen.accounting.periods.action.create.field.starts_on': "Starts on",
    'screen.accounting.periods.action.reopen': "Reopen",
    'screen.accounting.periods.action.reopen.field.reason': "Reason",
    'screen.accounting.periods.column.ends_on': "To",
    'screen.accounting.periods.column.name_ar': "Period",
    'screen.accounting.periods.column.starts_on': "From",
    'screen.accounting.periods.column.status': "Status",
    'screen.accounting.periods.title': "Periods",
    'screen.accounting.posting_rules.action.create': "New posting rule",
    'screen.accounting.posting_rules.action.create.field.credit_account_id': "Credit account",
    'screen.accounting.posting_rules.action.create.field.debit_account_id': "Debit account",
    'screen.accounting.posting_rules.action.create.field.line_kind': "Line kind",
    'screen.accounting.posting_rules.action.create.field.priority': "Priority",
    'screen.accounting.posting_rules.action.create.field.source_module': "Source module",
    'screen.accounting.posting_rules.action.create.field.priority.help': "Lower runs first. Empty means 100.",
    'screen.accounting.posting_rules.action.create.field.tax_code_id': "Tax code",
    'screen.accounting.posting_rules.action.create.field.valid_from': "Valid from",
    'screen.accounting.posting_rules.action.retire': "Retire",
    'screen.accounting.posting_rules.column.credit_account_id': "Credit account",
    'screen.accounting.posting_rules.column.debit_account_id': "Debit account",
    'screen.accounting.posting_rules.column.line_kind': "Line kind",
    'screen.accounting.posting_rules.column.priority': "Priority",
    'screen.accounting.posting_rules.column.source_module': "Source module",
    'screen.accounting.posting_rules.column.valid_from': "Valid from",
    'screen.accounting.posting_rules.title': "Posting rules",
    'screen.accounting.receivables.action.write_off': 'Write off as bad debt',
    'screen.accounting.receivables.action.open_entry': 'Open the entry',
    'screen.accounting.receivables.column.entry_id': 'Entry',
    'screen.accounting.receivables.action.write_off.field.date': "Date",
    'screen.accounting.receivables.action.write_off.field.expense_account_id': "Expense account",
    'screen.accounting.receivables.action.write_off.field.journal_id': "Journal",
    'screen.accounting.receivables.action.write_off.field.reason': "Reason",
    'screen.accounting.receivables.action.write_off.field.expense_account_id.help': "An expense account, usually bad debts.",
    'screen.accounting.receivables.column.account_code': "Account",
    'screen.accounting.receivables.column.account_name_ar': "Name",
    'screen.accounting.receivables.column.debit': "Open debit",
    'screen.accounting.receivables.column.due_on': "Due",
    'screen.accounting.receivables.column.entry_date': "Date",
    'screen.accounting.receivables.column.entry_number': "Entry #",
    'screen.accounting.receivables.column.party_id': 'Customer',
    'screen.accounting.receivables.lede': "Open receivable lines. Write-off posts an expense and marks the line reconciled.",
    'screen.accounting.receivables.title': "Receivables",
    'screen.accounting.tax_codes.action.confirm': "Confirm",
    'screen.accounting.tax_codes.action.confirm.field.tax_account_id': "Tax account",
    'screen.accounting.tax_codes.action.confirm.field.tax_account_id.help': "Where the tax on this code is posted. Required for standard and withholding codes; left empty for zero-rated, exempt and out-of-scope codes.",
    'screen.accounting.tax_codes.action.import_pack': "Import VAT tax pack",
    'screen.accounting.tax_codes.action.retire': "Retire",
    'screen.accounting.tax_codes.column.code': "Code",
    'screen.accounting.tax_codes.column.confirmed_by': "Confirmed by",
    'screen.accounting.tax_codes.column.enabled': "Enabled",
    'screen.accounting.tax_codes.column.name_ar': "Name",
    'screen.accounting.tax_codes.column.rate': "Rate %",
    'screen.accounting.tax_codes.column.tax_type': "Type",
    'screen.accounting.tax_codes.column.valid_from': "Valid from",
    'screen.accounting.tax_codes.lede': "VAT tax pack (SA localisation). Codes import disabled until a named person confirms each one.",
    'screen.accounting.tax_codes.title': "Tax codes",
    'screen.accounting.tax_rules.action.create': "New tax rule",
    'screen.accounting.tax_rules.action.create.field.buyer_type': "Buyer",
    'screen.accounting.tax_rules.action.create.field.line_kind': "Line kind",
    'screen.accounting.tax_rules.action.create.field.priority': "Priority",
    'screen.accounting.tax_rules.action.create.field.supply_destination': "Supply destination",
    'screen.accounting.tax_rules.action.create.field.tax_code_id': "Tax code",
    'screen.accounting.tax_rules.action.create.field.valid_from': "Valid from",
    'screen.accounting.tax_rules.action.create.field.priority.help': "Lower runs first. Empty means 100.",
    'screen.accounting.tax_rules.action.create.field.valid_to': "Valid to",
    'screen.accounting.tax_rules.action.retire': "Retire",
    'screen.accounting.tax_rules.column.buyer_type': "Buyer type",
    'screen.accounting.tax_rules.column.line_kind': "Line kind",
    'screen.accounting.tax_rules.column.priority': "Priority",
    'screen.accounting.tax_rules.column.supply_destination': "Supply destination",
    'screen.accounting.tax_rules.column.tax_code_id': "Tax code",
    'screen.accounting.tax_rules.column.valid_from': "Valid from",
    'screen.accounting.tax_rules.title': "Tax rules",
    'screen.accounting.trial_balance.column.balance': "Balance",
    'screen.accounting.trial_balance.column.code': "Code",
    'screen.accounting.trial_balance.column.credit': "Credit",
    'screen.accounting.trial_balance.column.debit': "Debit",
    'screen.accounting.trial_balance.column.name_ar': "Account",
    'screen.accounting.trial_balance.title': "Trial balance",
    'screen.einvoicing.connector.action.configure': "Configure sandbox",
    'screen.einvoicing.connector.action.configure.field.vault_secret_ref': "Vault secret reference",
    'screen.einvoicing.connector.action.production': "Switch to production (irreversible)",
    'screen.einvoicing.connector.action.production.field.vault_secret_ref': "Production vault secret reference",
    'screen.einvoicing.connector.column.circuit_open': "Circuit open",
    'screen.einvoicing.connector.column.consecutive_failures': "Failures",
    'screen.einvoicing.connector.column.environment': "Environment",
    'screen.einvoicing.connector.column.vault_secret_ref': "Vault ref",
    'screen.einvoicing.connector.lede': "Sandbox first. Unreachable is never treated as accepted. Switching to production is recorded and irreversible. Certificates stay in the vault.",
    'screen.einvoicing.connector.title': 'FATOORA connection',
    'screen.einvoicing.devices.action.create': 'New EGS unit',
    'screen.einvoicing.devices.action.create.field.branch_code': "Branch",
    'screen.einvoicing.devices.action.create.field.label': "Label",
    'screen.einvoicing.devices.action.create.field.sales_journal_id': "Sales journal",
    'screen.einvoicing.devices.action.create.field.sales_journal_id.help': "A journal of type sale.",
    'screen.einvoicing.devices.action.onboard': "Onboard (vault refs only)",
    'screen.einvoicing.devices.action.onboard.field.compliance_csid_ref': "Compliance CSID vault ref",
    'screen.einvoicing.devices.action.onboard.field.csr_vault_ref': "CSR vault ref",
    'screen.einvoicing.devices.action.onboard.field.otp_vault_ref': "OTP vault ref",
    'screen.einvoicing.devices.action.onboard.field.production_csid_ref': "Production CSID vault ref",
    'screen.einvoicing.devices.column.branch_code': "Branch",
    'screen.einvoicing.devices.column.label': "Label",
    'screen.einvoicing.devices.column.next_icv': "Next ICV",
    'screen.einvoicing.devices.column.sales_journal_id': "Sales journal",
    'screen.einvoicing.devices.column.state': "State",
    'screen.einvoicing.devices.title': 'EGS units',
    'screen.einvoicing.edocuments.action.submit': "Submit to the Authority",
    'screen.einvoicing.edocuments.column.created_at': "Created",
    'screen.einvoicing.edocuments.column.document_id': "Document",
    'screen.einvoicing.edocuments.column.icv': "ICV",
    'screen.einvoicing.edocuments.column.report_status': 'Status at the authority',
    'screen.einvoicing.edocuments.column.uuid': "UUID",
    'screen.einvoicing.edocuments.title': 'E-invoices',
    'screen.einvoicing.sellers.action.create': "New seller",
    'screen.einvoicing.sellers.action.create.field.branch_code': "Branch",
    'screen.einvoicing.sellers.action.create.field.city': "City",
    'screen.einvoicing.sellers.action.create.field.cr_number': "CR number",
    'screen.einvoicing.sellers.action.create.field.legal_name_ar': "Legal name (AR)",
    'screen.einvoicing.sellers.action.create.field.legal_name_en': "Legal name (EN)",
    'screen.einvoicing.sellers.action.create.field.vat_number': "VAT number",
    'screen.einvoicing.sellers.column.branch_code': "Branch",
    'screen.einvoicing.sellers.column.city': "City",
    'screen.einvoicing.sellers.column.cr_number': "CR",
    'screen.einvoicing.sellers.column.legal_name_ar': "Legal name",
    'screen.einvoicing.sellers.column.vat_number': "VAT",
    'screen.einvoicing.sellers.title': 'Seller details',
    'screen.einvoicing.submissions.column.attempt_no': "Attempt",
    'screen.einvoicing.submissions.column.created_at': "When",
    'screen.einvoicing.submissions.column.edocument_id': "E-document",
    'screen.einvoicing.submissions.column.document_id': "Document",
    'screen.einvoicing.submissions.column.document_number': "Invoice number",
    'screen.einvoicing.submissions.column.party_name': "Party",
    'screen.einvoicing.edocuments.column.document_number': "Invoice number",
    'screen.einvoicing.edocuments.column.party_name': "Party",
    'screen.einvoicing.submissions.column.environment': "Environment",
    'screen.einvoicing.submissions.column.response_status': "Response",
    'screen.einvoicing.submissions.column.retry_class': "Retry",
    'screen.einvoicing.submissions.lede': "Masked request log — secrets and certificates never appear. Unreachable is retryable; rejected is not.",
    'screen.einvoicing.submissions.title': 'Submission log',
    'screen.invoicing.aging_ap.column.bucket': "Bucket",
    'screen.invoicing.aging_ap.column.days': "Days",
    'screen.invoicing.aging_ap.column.issue_on': "Bill date",
    'screen.invoicing.aging_ap.column.number': "Number",
    'screen.invoicing.aging_ap.column.open_amount': "Open",
    'screen.invoicing.aging_ap.column.party_id': "Vendor",
    'screen.invoicing.aging_ap.title': "Payables aging",
    'screen.invoicing.aging_ar.column.bucket': "Bucket",
    'screen.invoicing.aging_ar.column.days': "Days",
    'screen.invoicing.aging_ar.column.issue_on': "Issue",
    'screen.invoicing.aging_ar.column.number': "Number",
    'screen.invoicing.aging_ar.column.open_amount': "Open",
    'screen.invoicing.aging_ar.column.party_id': 'Customer',
    'screen.invoicing.aging_ar.title': "Receivables aging",
    'screen.invoicing.aging_ar.lede.by_party': "What each customer owes, by how long past its due day. A document with no due day is due on its issue day.",
    'screen.invoicing.aging_ar.column.party_name': "Customer",
    'screen.invoicing.aging_ar.column.total': "Open",
    'screen.invoicing.aging_ar.column.overdue': "Overdue",
    'screen.invoicing.aging_ar.column.not_due': "Not due",
    'screen.invoicing.aging_ar.column.days_1_30': "1–30 days",
    'screen.invoicing.aging_ar.column.days_31_60': "31–60 days",
    'screen.invoicing.aging_ar.column.days_61_90': "61–90 days",
    'screen.invoicing.aging_ar.column.days_over_90': "Over 90 days",
    'screen.invoicing.aging_ar.column.documents': "Documents",
    'screen.invoicing.aging_ar.column.oldest_days': "Oldest, days late",
    'screen.invoicing.aging_ar.stat.total': "Open",
    'screen.invoicing.aging_ar.stat.overdue': "Overdue",
    'screen.invoicing.aging_ar.column.late': "Overdue",
    'screen.invoicing.aging_ar.column.very_late': "Over 90 days",
    'screen.invoicing.aging_ar.stat.over_90': "Over 90 days",
    'screen.invoicing.aging_ap.lede.by_party': "What each supplier owes, by how long past its due day. A document with no due day is due on its issue day.",
    'screen.invoicing.aging_ap.column.party_name': "Supplier",
    'screen.invoicing.aging_ap.column.total': "Open",
    'screen.invoicing.aging_ap.column.overdue': "Overdue",
    'screen.invoicing.aging_ap.column.not_due': "Not due",
    'screen.invoicing.aging_ap.column.days_1_30': "1–30 days",
    'screen.invoicing.aging_ap.column.days_31_60': "31–60 days",
    'screen.invoicing.aging_ap.column.days_61_90': "61–90 days",
    'screen.invoicing.aging_ap.column.days_over_90': "Over 90 days",
    'screen.invoicing.aging_ap.column.documents': "Documents",
    'screen.invoicing.aging_ap.column.oldest_days': "Oldest, days late",
    'screen.invoicing.aging_ap.stat.total': "Open",
    'screen.invoicing.aging_ap.stat.overdue': "Overdue",
    'screen.invoicing.aging_ap.column.late': "Overdue",
    'screen.invoicing.aging_ap.column.very_late': "Over 90 days",
    'screen.invoicing.aging_ap.stat.over_90': "Over 90 days",
    'screen.invoicing.bank_reconciliation.action.import': "Import CSV",
    'screen.invoicing.bank_reconciliation.action.import.field.csv': "Statement lines (CSV)",
    'screen.invoicing.bank_reconciliation.action.import.field.journal_id': "Bank journal",
    'screen.invoicing.bank_reconciliation.action.import.field.statement_on': "Statement date",
    'screen.invoicing.bank_reconciliation.action.import.field.csv.help': "One line per movement: booked_on,amount,narration — with that header line first. Money out is negative.",
    'screen.invoicing.bank_reconciliation.action.import.field.journal_id.help': "A bank journal with a default account.",
    'screen.invoicing.bank_reconciliation.action.reconcile': "Match or charge",
    'screen.invoicing.bank_reconciliation.column.id': "Id",
    'screen.invoicing.bank_reconciliation.column.journal_id': "Journal",
    'screen.invoicing.bank_reconciliation.column.line_count': "Lines",
    'screen.invoicing.bank_reconciliation.column.statement_on': "Statement date",
    'screen.invoicing.bank_reconciliation.column.unmatched_count': "Unmatched",
    'screen.invoicing.bank_reconciliation.lede': "CSV import is idempotent on fingerprint. Match statement lines to open bank items, or post a bank charge. Unmatch while the period is open.",
    'screen.invoicing.bank_reconciliation.title': "Bank reconciliation",
    'screen.invoicing.bank_match.lede': "Match a statement line to an open item, or post it as a bank charge.",
    'screen.invoicing.bank_match.title': "Match or charge",
    'screen.invoicing.chart_mappings.action.upsert': "Save mapping",
    'screen.invoicing.chart_mappings.action.upsert.field.external_account': "Account in the other system",
    'screen.invoicing.chart_mappings.action.upsert.field.source_code': "Account",
    'screen.invoicing.chart_mappings.action.upsert.field.source_kind': "Mapping of",
    'screen.invoicing.chart_mappings.column.external_account': "External account",
    'screen.invoicing.chart_mappings.column.source_code': "Local code",
    'screen.invoicing.chart_mappings.column.source_kind': "Kind",
    'screen.invoicing.chart_mappings.lede': "Map local account, tax, and journal codes to the external system's accounts. An export refuses and names any code that has no mapping.",
    'screen.invoicing.chart_mappings.title': "External chart mapping",
    'screen.invoicing.customer_statements.column.ap_open': "Payable open",
    'screen.invoicing.customer_statements.column.ar_open': "Receivable open",
    'screen.invoicing.customer_statements.column.party_id': "Party",
    'screen.invoicing.customer_statements.column.party_name': "Party",
    'screen.invoicing.customer_statements.lede': "Open amounts receivable and payable by party.",
    'screen.invoicing.customer_statements.title': "Party balances",
    'screen.invoicing.documents.action.create': "New invoice",
    'screen.invoicing.documents.action.credit': "Credit note",
    'screen.invoicing.documents.action.credit.field.reason_code': "Reason",
    'screen.invoicing.documents.action.credit.field.reason_code.help': "Why the invoice is being credited, as it will appear on the credit note.",
    'screen.invoicing.documents.action.issue': "Issue",
    'screen.invoicing.documents.action.edit': "Edit draft",
    'screen.invoicing.documents.column.branch_code': "Branch",
    'screen.invoicing.documents.column.can_credit': "Can credit",
    'screen.invoicing.documents.column.classification': "Classification",
    'screen.invoicing.documents.column.issue_on': "Issue date",
    'screen.invoicing.documents.column.kind': "Kind",
    'screen.invoicing.documents.column.number': "Number",
    'screen.invoicing.documents.column.party_id': 'Customer',
    'screen.invoicing.documents.column.state': "State",
    'screen.invoicing.documents.column.total': "Total",
    'screen.invoicing.documents.filter.branch_code': "Branch",
    'screen.invoicing.documents.title': "Invoices",
    'screen.invoicing.invoice_new.lede': "Party, national address, lines and classification. «Save draft» keeps it to finish later; «Save and issue» issues it, and an issued invoice is corrected only by a credit or debit note.",
    'screen.invoicing.invoice_new.title': "New invoice",
    'screen.invoicing.export_batches.action.confirm': "Confirm with external refs",
    'screen.invoicing.export_batches.action.confirm.field.external_batch_ref': "External batch reference",
    'screen.invoicing.export_batches.action.create': "Produce export",
    'screen.invoicing.export_batches.action.create.field.format': "Format",
    'screen.invoicing.export_batches.action.create.field.period_from': "From",
    'screen.invoicing.export_batches.action.create.field.period_to': "To",
    'screen.invoicing.export_batches.action.create.field.scope': "What to export",
    'screen.invoicing.export_batches.column.format': "Format",
    'screen.invoicing.export_batches.column.id': "Id",
    'screen.invoicing.export_batches.column.line_count': "Lines",
    'screen.invoicing.export_batches.column.period_from': "From",
    'screen.invoicing.export_batches.column.period_to': "To",
    'screen.invoicing.export_batches.column.scope': "Scope",
    'screen.invoicing.export_batches.column.state': "State",
    'screen.invoicing.export_batches.lede': "CSV/JSON batches per period. The same scope is never exported twice. A second person confirms with the external references.",
    'screen.invoicing.export_batches.title': "External accounting export",
    'screen.invoicing.payments.action.allocate': "Allocate",
    'screen.invoicing.payments.action.allocate.field.amount': "Amount",
    'screen.invoicing.payments.action.allocate.field.document_id': "Document",
    'screen.invoicing.payments.action.allocate.field.document_id.help': "A posted document of the same party.",
    'screen.invoicing.payments.action.allocate.field.amount.help': "Starts at what is still open on the payment.",
    'screen.invoicing.payments.action.create': "Record payment",
    'screen.invoicing.payments.action.create.field.amount': "Amount",
    'screen.invoicing.payments.action.create.field.direction': "Direction",
    'screen.invoicing.payments.action.create.field.journal_id': "Journal",
    'screen.invoicing.payments.action.create.field.method': "Method",
    'screen.invoicing.payments.action.create.field.paid_on': "Date",
    'screen.invoicing.payments.action.create.field.party_id': "Party",
    'screen.invoicing.payments.action.create.field.provider_ref': "Bank reference",
    'screen.invoicing.payments.action.create.field.journal_id.help': "A bank or cash journal with a default account.",
    'screen.invoicing.payments.action.create.field.paid_on.help': "Empty means today.",
    'screen.invoicing.payments.action.create.field.provider_ref.help': "The reference on the bank transfer. The same reference is never recorded twice.",
    'screen.invoicing.payments.column.allocated_total': "Allocated",
    'screen.invoicing.payments.column.amount': "Amount",
    'screen.invoicing.payments.column.direction': "Direction",
    'screen.invoicing.payments.column.id': "Id",
    'screen.invoicing.payments.column.method': "Method",
    'screen.invoicing.payments.column.open_amount': "Open",
    'screen.invoicing.payments.column.paid_on': "Paid on",
    'screen.invoicing.payments.column.party_id': "Party",
    'screen.invoicing.payments.column.provider_ref': 'Bank reference',
    'screen.invoicing.payments.column.state': "State",
    'screen.invoicing.payments.lede': 'Receipt and payment vouchers. A repeated bank reference returns the stored voucher and never posts twice.',
    'screen.invoicing.payments.title': 'Receipt and payment vouchers',
    'screen.invoicing.tax_register.column.classification': "Classification",
    'screen.invoicing.tax_register.column.issue_on': "Date",
    'screen.invoicing.tax_register.column.kind': "Kind",
    'screen.invoicing.tax_register.column.number': "Number",
    'screen.invoicing.tax_register.column.party_id': "Party",
    'screen.invoicing.tax_register.column.party_name': "Party",
    'screen.invoicing.tax_register.column.subtotal': "Net",
    'screen.invoicing.tax_register.column.tax_total': "Tax",
    'screen.invoicing.tax_register.column.total': "Total",
    'screen.invoicing.tax_register.column.withholding_total': "WHT",
    'screen.invoicing.tax_register.title': "Tax invoice register",
    'screen.invoicing.vat_return.action.file': "Mark as filed (sets tax lock)",
    'screen.invoicing.vat_return.action.file.field.to': "Period end",
    'screen.invoicing.vat_return.action.file.field.to.help': "Empty means today.",
    'screen.invoicing.vat_return.column.amount': "Amount",
    'screen.invoicing.vat_return.column.key': "Box",
    'screen.invoicing.vat_return.column.label_ar': "Description",
    'screen.invoicing.vat_return.column.net': "Net",
    'screen.invoicing.vat_return.column.tax': "Tax",
    'screen.invoicing.vat_return.lede': "The return's boxes for the period, numbered as on the authority's form. «Mark as filed» sets the tax lock date; the return is filed on the authority's portal.",
    'screen.invoicing.vat_return.title': "VAT return",
    'screen.invoicing.vendor_bills.action.create': "New vendor bill",
    'screen.invoicing.vendor_bills.action.issue': "Issue",
    'screen.invoicing.vendor_bills.action.edit': "Edit draft",
    'screen.invoicing.vendor_bills.column.branch_code': "Branch",
    'screen.invoicing.vendor_bills.column.can_pay': "Can pay",
    'screen.invoicing.vendor_bills.column.issue_on': "Bill date",
    'screen.invoicing.vendor_bills.column.number': "Number",
    'screen.invoicing.vendor_bills.column.open_amount': "Open",
    'screen.invoicing.vendor_bills.column.party_id': "Vendor",
    'screen.invoicing.vendor_bills.column.state': "State",
    'screen.invoicing.vendor_bills.column.total': "Total",
    'screen.invoicing.vendor_bills.column.withholding_total': "Withholding",
    'screen.invoicing.vendor_bills.filter.branch_code': "Branch",
    'screen.invoicing.vendor_bills.lede': "Purchase bills. Withholding applies only to non-resident vendors and is posted to a liability — it is not included on an e-invoice.",
    'screen.invoicing.vendor_bills.title': "Vendor bills",
    'screen.invoicing.vendor_bill_new.lede': "Vendor, lines and withholding for non-residents. Save keeps a draft.",
    'screen.invoicing.vendor_bill_new.title': "New vendor bill",
    'screen.invoicing.wht_statement.column.bill_count': "Bills",
    'screen.invoicing.wht_statement.column.bill_total': "Bill total",
    'screen.invoicing.wht_statement.column.display_name': "Name",
    'screen.invoicing.wht_statement.column.party_id': "Vendor",
    'screen.invoicing.wht_statement.column.withholding_total': "Withholding",
    'screen.invoicing.wht_statement.lede': "Server-computed withholding per vendor for the selected period. Settlement is filed on the Authority portal.",
    'screen.invoicing.wht_statement.title': 'Withholding tax statement',
    'screen.parties.parties.action.add_address': "Add address",
    'screen.parties.parties.action.add_address.field.additional_number': "Additional number",
    'screen.parties.parties.action.add_address.field.additional_number.help': "Four digits when present.",
    'screen.parties.parties.action.add_address.field.short_address': "Short address",
    'screen.parties.parties.action.add_address.field.short_address.help': "Four letters then four digits, such as RNAD4521.",
    'screen.parties.parties.action.add_address.field.building_number': "Premise number",
    'screen.parties.parties.action.add_address.field.building_number.help': "Four digits (national address).",
    'screen.parties.parties.action.add_address.field.city': "City",
    'screen.parties.parties.action.add_address.field.country': "Country",
    'screen.parties.parties.action.add_address.field.country.help': "ISO 3166-1 alpha-2, upper case (e.g. SA).",
    'screen.parties.parties.action.add_address.field.district': "District",
    'screen.parties.parties.action.add_address.field.line1': "Address line",
    'screen.parties.parties.action.add_address.field.postcode': "Postcode",
    'screen.parties.parties.action.add_address.field.purpose': "Purpose",
    'screen.parties.parties.action.add_address.field.purpose.option.billing': "Billing",
    'screen.parties.parties.action.add_address.field.purpose.option.correspondence': "Correspondence",
    'screen.parties.parties.action.add_address.field.purpose.option.registered': "Registered",
    'screen.parties.parties.action.add_address.field.purpose.option.shipping': "Shipping",
    'screen.parties.parties.action.add_address.field.region': "Region",
    'screen.parties.parties.action.add_address.field.street': "Street",
    'screen.parties.parties.action.add_address.field.unit_number': "Unit number",
    'screen.parties.parties.action.add_address.field.is_primary': "Primary address",
    'screen.parties.parties.action.add_address.field.is_primary.help': "The one an invoice uses. Choosing it clears the previous primary.",
    'screen.parties.parties.action.add_address.field.line2': "Address line 2",
    'screen.parties.parties.action.add_identifier': "Add identifier",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme': "ZATCA buyer scheme",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.700': "700",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.CRN': "CRN",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.GCC': "GCC",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.IQA': "IQA",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.MLS': "MLS",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.MOM': "MOM",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.NAT': "NAT",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.OTH': "OTH",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.SAG': "SAG",
    'screen.parties.parties.action.add_identifier.field.scheme': "Scheme",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_cr': "Commercial registration",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_vat': "VAT (SA)",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_iqama': "Iqama",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_nid': "National ID",
    'screen.parties.parties.action.add_identifier.field.value': "Value",
    'screen.parties.parties.action.add_identifier.field.value.help': "VAT: 15 digits starting and ending with 3. Commercial registration: 10 digits. National ID: 10 digits starting with 1; iqama: starting with 2.",
    'screen.parties.parties.action.create': "New",
    'screen.parties.parties.action.create.field.display_name': "Name",
    'screen.parties.parties.action.create.field.kind': "Kind",
    'screen.parties.parties.action.create.field.kind.option.organisation': "Organisation",
    'screen.parties.parties.action.create.field.kind.option.person': "Person",
    'screen.parties.parties.action.create.field.residency': "Residency",
    'screen.parties.parties.action.create.field.residency.option.non_resident': "Non-resident",
    'screen.parties.parties.action.create.field.residency.option.resident': "Resident",
    'screen.parties.parties.action.edit': "Edit",
    'screen.parties.parties.action.edit.field.display_name': "Name",
    'screen.parties.parties.action.edit.field.residency': "Residency",
    'screen.parties.parties.action.edit.field.residency.option.non_resident': "Non-resident",
    'screen.parties.parties.action.edit.field.residency.option.resident': "Resident",
    'screen.parties.parties.column.display_name': "Name",
    'screen.parties.parties.column.kind': "Kind",
    'screen.parties.parties.column.residency': "Residency",
    'screen.parties.parties.column.status': "Status",
    'screen.parties.parties.title': "Parties",
    'account.title': 'My account',
    'account.lede': 'What you are called here, and how you sign in.',
    'account.about': 'About you',
    'account.name': 'Name',
    'account.jobTitle': 'Job title',
    'account.phone': 'Telephone',
    'account.language': 'Language',
    'account.password': 'Password',
    'account.passwordWarning': 'Changing it ends every session, including this one. You will sign in again.',
    'account.currentPassword': 'Current password',
    'account.newPassword': 'New password',
    'account.repeatPassword': 'Repeat it',
    'account.passwordsDiffer': 'Those two are not the same.',
    'account.changePassword': 'Change my password',
    'account.open': 'My account',
    'account.signedOutAfterPassword': 'Your password was changed. Sign in again.',
    'account.workspaces': 'Workspaces',
    'theme.label': 'Appearance',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.system': 'System',
    'account.unknown': 'Signed in',
    'account.choosePassword': "Choose your own password",
    'account.choosePasswordLede': "You signed in with a temporary password. Nothing else works until you choose your own; then sign in again with it.",
    'account.choosePasswordSave': "Save and sign in again",
    'account.passwordChosen': "Your password is set. Sign in with it.",
    'account.serviceWindow': "Your service ended on {ended_on}; you have access here until {access_until}.",
    'account.temporaryPassword': "Temporary password",
    'account.secondFactor': "Two-step sign-in",
    'account.secondFactor.lede': "A code from an authenticator application on your phone, asked for when you enter a workspace whose roles require it.",
    'account.secondFactor.off': "Not set up.",
    'account.secondFactor.on': "On since {date}. {count} recovery codes left.",
    'account.secondFactor.notConfigured': "Not available on this installation yet: it has no key to keep authenticator secrets with. Whoever runs it sets SECOND_FACTOR_KEK.",
    'account.secondFactor.setUp': "Set up",
    'account.secondFactor.replace': "Replace the authenticator",
    'account.secondFactor.newCodes': "New recovery codes",
    'account.secondFactor.turnOff': "Turn off",
    'account.secondFactor.passwordFor': "Your current password, to confirm it is you.",
    'account.secondFactor.secretTitle': "Add this to your authenticator",
    'account.secondFactor.secretLede': "Open an authenticator application (Google Authenticator, Microsoft Authenticator, Aegis, 1Password…) and add an entry by typing this key, or by pasting the link into one that reads links. It is shown this once.",
    'account.secondFactor.secret': "Key",
    'account.secondFactor.uri': "Link (otpauth)",
    'account.secondFactor.confirmLede': "Then enter the code it shows, to prove the entry works.",
    'account.secondFactor.confirm': "Confirm",
    'account.secondFactor.codesTitle': "Your recovery codes",
    'account.secondFactor.codesLede': "Each opens a workspace once when your phone is not at hand. Keep them somewhere safe: they are not shown again, and new ones replace them.",
    'account.secondFactor.enrolled': "Two-step sign-in is on.",
    'account.secondFactor.disabled': "Two-step sign-in is off.",
    'settings.readOnly': 'View only',
    'settings.problems': 'Values that no longer fit their schema',
    'settings.unaddressable': 'This setting cannot be addressed safely: {key}',
    'settings.search': 'Search the groups and their settings',
    'settings.stat.groups': 'Groups',
    'settings.stat.overridden': 'Decided here',
    'settings.problems.count': '{count} problems',
    'settings.changedBy': 'Last changed by {by}, {at}',
    'settings.history': 'History',
    'settings.restore.title': 'Restore the platform value of «{name}»?',
    'settings.restore.description': 'The decision this workspace made in {group} is taken away, and the platform\'s value applies from now on. The history keeps what it was.',
    'settings.restore.confirm': 'Restore',
    'settings.noMatch': 'No group and no setting matches «{search}». The figures above still count every group.',
    'screen.accounting.tax_codes.column.exemption_reason_code': "Exemption reason",
    'screen.accounting.tax_codes.column.deductible': "Deductible",
    'screen.einvoicing.devices.filter.branch_code': "Branch",
    'screen.einvoicing.edocuments.column.previous_hash': "Previous hash",
    'screen.einvoicing.edocuments.column.hash': "Hash",
    'screen.einvoicing.edocuments.column.qr_payload': "QR",
    'screen.einvoicing.edocuments.column.can_submit': "Can submit",
    'screen.einvoicing.sellers.action.create.field.building_number': "Building number",
    'screen.einvoicing.sellers.action.create.field.street': "Street",
    'screen.einvoicing.sellers.action.create.field.district': "District",
    'screen.einvoicing.sellers.action.create.field.region': "Region",
    'screen.einvoicing.sellers.action.create.field.postcode': "Postal code",
    'screen.einvoicing.sellers.action.create.field.country': "Country",
    'screen.einvoicing.sellers.filter.branch_code': "Branch",
    'screen.invoicing.documents.column.currency': "Currency",
    'derived.rows': "Rows",
    'screen.einvoicing.sellers.column.building_number': "Building no.",
    'screen.einvoicing.sellers.column.district': "District",
    'screen.einvoicing.sellers.column.postcode': "Postal code",
    'screen.einvoicing.sellers.column.address_complete': "Address",
    'screen.einvoicing.sellers.stat.incomplete': "Address incomplete",
    'screen.einvoicing.edocuments.column.path': "Channel",
    'value.address_complete.true': "Complete",
    'value.address_complete.false': "Incomplete",
    'group.operations': 'Daily operations',
    'group.reconciliation': 'Reconciliation and follow-up',
    'group.closing': 'Closing and reports',
    'group.configuration': 'Configuration',
    // hr · org — graduated from the screens catalogue
    "group.organisation": "Organisation",
    "value.status.retired": "Retired",
    // hr · scheduling — graduated from the screens catalogue
    "value.rotation.fixed": "Fixed",
    "value.rotation.monthly": "Monthly",
    "value.rotation.weekly": "Weekly",
    "value.severity.overdue": "Critical",
    "value.severity.warning": "Warning",
    "value.status.draft": "Draft",
    "value.status.locked": "Locked",
    "value.status.published": "Published",
    // hr · leave — graduated from the screens catalogue
    "group.leave": "Leave",
    "value.leave_type.annual": "Annual",
    "value.leave_type.bereavement": "Bereavement",
    "value.leave_type.bereavement_sibling": "Bereavement — brother or sister",
    "value.leave_type.emergency": "Emergency",
    "value.leave_type.exams": "Exams",
    "value.leave_type.hajj": "Hajj",
    "value.leave_type.iddah": "Iddah",
    "value.leave_type.marriage": "Marriage",
    "value.leave_type.maternity": "Maternity",
    "value.leave_type.newborn": "Birth of a child",
    "value.leave_type.sick": "Sick",
    "value.leave_type.unpaid": "Unpaid",
    "value.leave_type.widowhood": "Death of a husband",
    "value.leave_type.maternity_sick_child": "Month for a sick or disabled newborn",
    "value.leave_type.maternity_extension": "Maternity extension (unpaid)",
    "value.leave_type.time_off_in_lieu": "Time off in lieu of overtime",
    "value.status.approved": "Approved",
    "value.status.back_at_work": "Back at work",
    "value.status.late_return": "Late returning",
    "value.status.on_leave": "On leave",
    "value.status.rejected": "Refused",
    "value.status.sent_back": "Sent back",
    "value.status.submitted": "Awaiting a decision",
    "value.status.unconfirmed": "Awaiting confirmation",
    "value.tier.full": "Full wage",
    "value.tier.three_quarters": "Three quarters",
    "value.tier.unpaid": "Unpaid",
    // hr · discipline
    "group.conduct": "Discipline and grievances",
    "value.art80_ground.absence": "Absence without cause beyond the legal limit, after a warning",
    "value.art80_ground.abuse_of_position": "Unlawfully using the position for personal gain",
    "value.art80_ground.assault": "Assault on the employer, the manager or a superior",
    "value.art80_ground.deliberate_loss": "Deliberate material loss to the employer (reported to the authorities within 24 hours)",
    "value.art80_ground.disclosure": "Disclosing the employer's industrial or commercial secrets",
    "value.art80_ground.dishonour": "Misconduct, or an act against honour or integrity",
    "value.art80_ground.essential_duties": "Failing essential duties, lawful orders or safety instructions after a written warning",
    "value.art80_ground.forgery": "Obtaining the job by forgery",
    "value.group_name.attendance": "Attendance and hours",
    "value.group_name.conduct": "Conduct",
    "value.group_name.custody": "Custody",
    "value.group_name.organisation": "Organisation of work",
    "value.group_name.performance": "Performance",
    "value.group_name.safety": "Safety",
    "value.outcome.overturned": "The penalty falls",
    "value.outcome.upheld": "The penalty stands",
    "value.payroll_effect.applied": "Applied",
    "value.payroll_effect.partly_applied": "Partly applied — days still carried",
    "value.payroll_effect.cancelled": "Cancelled",
    "value.payroll_effect.held": "Held",
    "value.payroll_effect.none": "No pay effect",
    "value.payroll_effect.pending": "Not applied yet",
    "value.penalty.deduction": "Deduction of days' wage",
    "value.penalty.defer_promotion": "Deferring promotion",
    "value.penalty.demotion": "Demotion",
    "value.penalty.dismissal": "Dismissal under Art. 80",
    "value.penalty.final_warning": "Final written warning",
    "value.penalty.suspension": "Suspension without pay",
    "value.penalty.warning": "Written warning",
    "value.penalty.withhold_increment": "Withholding the annual increment",
    "value.status.cancelled": "Cancelled",
    "value.status.held": "Held for a grievance",
    "value.status.investigating": "Under investigation",
    // hr · rewards
    "value.kind.allowance": "Allowance",
    "value.kind.one_off": "One-off bonus",
    "value.kind.periodic": "Periodic incentive",
    "value.kind.recognition": "Recognition",
    "value.status.paid": "Paid",
    "value.status.proposed": "Proposed",
    // hr · training
    "group.development": "Performance and development",
    "value.kind.credential": "Credential",
    "value.kind.first_aid": "First aid",
    "value.kind.induction": "Induction",
    "value.kind.safety": "Safety and evacuation",
    "value.kind.site_orientation": "Site orientation",
    "value.kind.supervisory": "Supervisory skills",
    "value.mandatory_for.everyone": "Everyone",
    "value.mandatory_for.new_joiners": "New joiners",
    "value.mandatory_for.none": "Optional",
    "value.mandatory_for.site_staff": "Site staff",
    "value.mandatory_for.supervisors": "Supervisors",
    "value.result.expired": "Expired",
    "value.result.failed": "Did not pass",
    "value.result.passed": "Passed",
    "value.result.scheduled": "Scheduled",
    "value.result.withdrawn": "Withdrawn",
    // hr · employees — graduated from the screens catalogue
    "group.employment": "Employees",
    "value.category.external_cover": "External temporary cover",
    "value.category.extra_shift": "Permanent, extra shift under own number",
    "value.category.gosi": "Permanent, registered with GOSI",
    "value.category.no_gosi": "Permanent, not registered with GOSI",
    "value.contract_type.fixed_term": "Fixed term",
    "value.contract_type.flexible": "Flexible",
    "value.contract_type.indefinite": "Open-ended",
    "value.contract_type.seasonal": "Seasonal",
    "value.kind.amendment": "Amendment",
    "value.kind.original": "Original",
    "value.kind.renewal": "Renewal",
    "value.reason_code.art_80": "Dismissed under Article 80",
    "value.reason_code.art_81": "Left under Article 81",
    "value.reason_code.contract_end": "The contract term ended",
    "value.reason_code.death": "Death",
    "value.reason_code.employer_notice": "Ended by the employer with notice",
    "value.reason_code.force_majeure": "Force majeure",
    "value.reason_code.mutual_agreement": "Both parties agreed",
    "value.reason_code.probation": "Ended during probation",
    "value.reason_code.resignation": "Resignation",
    "value.reason_code.retirement": "Retirement",
    "value.status.absent": "Absent without leave",
    "value.status.applied": "In effect",
    "value.status.attested": "Attested",
    "value.status.blacklisted": "Blacklisted",
    "value.status.candidate": "Candidate",
    "value.status.ended": "Ended",
    "value.status.ending": "Ending soon",
    "value.status.hiring": "Waiting to join",
    "value.status.signed": "Signed",
    "value.status.superseded": "Superseded",
    "value.status.terminated": "Service ended",
    "value.type.allowance_change": "Allowance change",
    "value.type.category_change": "Category change",
    "value.type.contract_amendment": "Contract amendment",
    "value.type.contract_renewal": "Contract renewal",
    "value.type.pay_change": "Pay change",
    "value.type.promotion": "Promotion",
    "value.type.reinstatement": "Reinstatement",
    "value.type.suspension": "Suspension",
    "value.type.termination": "End of service",
    "value.type.title_change": "Title change",
    "value.type.transfer": "Transfer",
    // hr · leave accounts — opened from the employees module's events
    'screen.activity_log.entries.column.name': "What",
    'screen.activity_log.entries.column.occurred_at': "When",
    'screen.activity_log.entries.column.producer': "From",
    'screen.activity_log.entries.title': "Activity",
    'screen.activity_log.entries.lede': "Every fact the modules published about this workspace, newest first. What changed field by field is in the change history.",
    'screen.activity_log.entries.column.version': "Version",
    'screen.activity_log.entries.stat.entries': "Entries",
    'screen.activity_log.entries.stat.last_7_days': "In the last 7 days",
    'screen.activity_log.entries.stat.retention_days': "Kept for (days)",
    'screen.activity_log.entries.action.retention': "Retention",
    'screen.activity_log.entries.action.retention.field.days': "Keep entries for (days)",
    'screen.activity_log.entries.action.retention.field.days.help': "Between 1 and 3,650. The current value is the figure above the list. Older entries go when the log is pruned.",
    'screen.activity_log.entries.action.prune': "Prune now",
    'screen.activity_log.entries.action.prune.note': "Entries older than the retention were removed. Pruning again later removes what has aged since.",
    'screen.activity_log.entries.action.prune.removed': "Entries removed",
    'screen.activity_log.entries.action.details': "Details",
    'screen.activity_log.entries.action.details.note': "What this entry may show: which records and what happened to them. Names, amounts and other values are left out; only their keys are listed.",
    'screen.activity_log.entries.action.details.event': "Event",
    'screen.activity_log.entries.action.details.fields': "Records and states",
    'screen.activity_log.entries.action.details.hidden': "Also carried, not shown",
    'activity.producer.identity': "Core",
    'activity.producer.tags': "Tags",
    'activity.producer.common': "Common services",
    'activity.producer.hr': "HR",
    'activity.producer.accounting': "Accounting",
    'activity.producer.gov_sa': "Government services",
    'activity.producer.assistant': "Assistant",
    'activity.producer.crm': "Customer relationships",
    'activity.producer.projects': "Projects",
    'activity.producer.ads': "Ads",
    'activity.producer.marketing': "Marketing",
    'value.subject_field.party_ref': "The party",
    'value.subject_field.owner_ref': "The owner",
    'value.subject_field.party_id': "The party",
    'value.subject_field.employee_id': "The employee",
    'value.subject_field.employment_id': "The employee",
    'value.subject_field.user_id': "The member",
    'value.subject_field.member_id': "The member",
    'value.subject_field.assignee_id': "Whoever it is assigned to",
    'value.subject_field.requested_by': "Whoever asked",
    'value.subject_field.submitted_by': "Whoever submitted it",
    'value.subject_field.manager_ref': "The manager",
    'activity.event.identity.capture_captcha.set': "Captcha for public forms set",
    'activity.event.identity.capture_key.changed': "Capture key changed",
    'activity.event.identity.capture_key.issued': "Capture key issued for a public form",
    'activity.event.identity.capture_key.revoked': "Capture key revoked",
    'capture.refusal.bad_key': "This form's key is not valid.",
    'capture.refusal.revoked': "This form's key has been revoked.",
    'capture.refusal.wrong_target': "This form's key does not reach where the form sends.",
    'capture.refusal.undeclared': "This form is no longer taking submissions.",
    'capture.refusal.edge': "This submission did not arrive through a door allowed to admit it.",
    'change.field.capture_captcha.provider': 'Captcha provider',
    'change.field.capture_captcha.secret_sealed': 'Captcha secret (sealed)',
    'change.field.capture_captcha.set_by': 'Set by',
    'change.field.capture_captcha.site_key': 'Captcha site key',
    'change.field.capture_key.captcha': 'Asks for captcha',
    'change.field.capture_key.created_by': 'Issued by',
    'change.field.capture_key.name': 'Name',
    'change.field.capture_key.origins': 'Allowed sites',
    'change.field.capture_key.rate_per_minute': 'Submissions a minute',
    'change.field.capture_key.revoked_at': 'Revoked on',
    'change.field.capture_key.revoked_by': 'Revoked by',
    'change.field.capture_key.secret_hash': 'Key (hashed)',
    'change.field.capture_key.target': 'Sends to',
    'change.field.party_match.outcome': 'Outcome',
    'change.field.party_match.party_id': 'Party',
    'change.field.party_match.requested_by': 'Asked by',
    'change.field.party_match.resolution': 'Decision',
    'change.field.party_match.resolved_at': 'Decided on',
    'change.field.party_match.resolved_by': 'Decided by',
    'change.field.party_match.review_status': 'Review',
    'change.field.party_match.source': 'Source',
    'change.field.party_match.source_key': 'Source reference',
    'change.field.consent_purpose.key': 'Key',
    'change.field.consent_purpose.name_ar': 'Name in Arabic',
    'change.field.consent_purpose.name_en': 'Name in English',
    'change.field.consent_purpose.retired_at': 'Retired on',
    'change.field.consent_purpose.retired_by': 'Retired by',
    'change.field.consent_purpose.status': 'Status',
    'capture.refusal.origin': "This form does not accept submissions from this website.",
    'capture.refusal.rate_limited': "Too many submissions in the last minute. Try again shortly.",
    'capture.refusal.captcha_failed': "The captcha was not solved.",
    'capture.refusal.captcha_unavailable': "The captcha cannot be checked now. Try again shortly.",
    'capture.refusal.too_large': "This submission is larger than the form accepts.",
    'capture.refusal.payload': "Some fields of this submission are missing or not in the expected form.",
    'capture.refusal.idempotency': "This submission carries no valid Idempotency-Key.",
    'capture.refusal.duplicate': "This Idempotency-Key was sent before with another submission.",
    'capture.refusal.bound': "This submission is not the one that was admitted.",
    'capture.refusal.token': "This route takes only a submission admitted for it.",
    'activity.event.identity.invitation.withdrawn': "Invitation withdrawn",
    'activity.event.identity.member.added': "Member added",
    'activity.event.identity.member.party_linked': "Member linked to a person",
    'activity.event.identity.member.party_unlinked': "Member unlinked from a person",
    'activity.event.identity.member.password_reset': "Password reset",
    'activity.event.identity.member.roles_changed': "Member's roles changed",
    'activity.event.identity.member.service_ended': "Member's service ended",
    'activity.event.identity.member.service_end_kept': "Member's service ended; their sign-in was kept for review",
    'activity.event.identity.member.sessions_ended': "Member's sessions ended",
    'activity.event.identity.member.updated': "Member updated",
    'activity.event.identity.module.moved': "Module moved to another unit",
    'activity.event.identity.module.registered': "Module registered",
    'activity.event.identity.permission.registered': "Permission registered",
    'activity.event.identity.role.created': "Role created",
    'activity.event.identity.role.deleted': "Role deleted",
    'activity.event.identity.role.duplicated': "Role copied",
    'activity.event.identity.role.members_changed': "Role's members changed",
    'activity.event.identity.role.permissions_changed': "Role's permissions changed",
    'activity.event.identity.role.updated': "Role updated",
    'activity.event.identity.tenant.created': "Workspace created",
    'activity.event.identity.tenant.modules_enabled': "Modules turned on",
    'activity.event.identity.tenant.tier_changed': "Tier changed",
    'activity.event.identity.tenant.renamed': "Workspace renamed",
    'activity.event.identity.tenant.setup_completed': "Workspace set up",
    'activity.event.identity.unit.registered': "Unit registered",
    'activity.event.identity.user.invited': "User invited",
    'activity.event.identity.user.joined': "User joined",
    'activity.event.identity.user.removed': "User removed",
    'activity.event.media.file.uploaded': "File uploaded",
    'activity.event.parties.address.changed': "Party's address changed",
    'activity.event.parties.bank_account.changed': "Party's bank account changed",
    'activity.event.parties.identifier.changed': "Party's number changed",
    'activity.event.parties.party.archived': "Party archived",
    'activity.event.parties.party.changed': "Party changed",
    'activity.event.parties.party.created': "Party created",
    'activity.event.parties.party.merged': "Parties merged",
    'activity.event.settings.value.changed': "Setting changed",
    'activity.event.tags.tag.attached': "Tag attached",
    'screen.calendar.occasions.action.approve': "Approve",
    'screen.calendar.occasions.action.create': "New occasion",
    'screen.calendar.occasions.action.create.field.gregorian_from': "From",
    'screen.calendar.occasions.action.create.field.gregorian_to': "To",
    'screen.calendar.occasions.action.create.field.hijri_from': "Hijri from",
    'screen.calendar.occasions.action.create.field.hijri_from.help': "Leave empty to take it from the Gregorian date by the workspace’s Hijri reference. Write it (YYYY-MM-DD) when the announced date differs from the table.",
    'screen.calendar.occasions.action.create.field.hijri_to': "Hijri to",
    'screen.calendar.occasions.action.create.field.hijri_to.help': "Leave empty to take it from the Gregorian date by the workspace’s Hijri reference. Write it (YYYY-MM-DD) when the announced date differs from the table.",
    'screen.calendar.occasions.action.create.field.key': "Key",
    'screen.calendar.occasions.action.create.field.kind': "Kind",
    'screen.calendar.occasions.action.create.field.kind.option.custom': "Other",
    'screen.calendar.occasions.action.create.field.kind.option.eid_adha': "Eid al-Adha",
    'screen.calendar.occasions.action.create.field.kind.option.eid_fitr': "Eid al-Fitr",
    'screen.calendar.occasions.action.create.field.kind.option.founding_day': "Founding Day",
    'screen.calendar.occasions.action.create.field.kind.option.national_day': "National Day",
    'screen.calendar.occasions.action.create.field.kind.option.ramadan': "Ramadan",
    'screen.calendar.occasions.action.create.field.kind.option.season': "Local season",
    'screen.calendar.occasions.action.create.field.location_ref': "Location",
    'screen.calendar.occasions.action.create.field.location_ref.help': "Only when it applies to one location: that location’s reference, as the module that owns locations writes it.",
    'screen.calendar.occasions.action.create.field.name_ar': "Name (Arabic)",
    'screen.calendar.occasions.action.create.field.name_en': "Name (English)",
    'screen.calendar.occasions.action.create.field.scope': "Applies to",
    'screen.calendar.occasions.action.create.field.scope.option.all': "The whole workspace",
    'screen.calendar.occasions.action.create.field.scope.option.location': "One location",
    'screen.calendar.occasions.action.edit': "Edit",
    'screen.calendar.occasions.action.edit.field.gregorian_from': "From",
    'screen.calendar.occasions.action.edit.field.gregorian_to': "To",
    'screen.calendar.occasions.action.edit.field.hijri_from': "Hijri from",
    'screen.calendar.occasions.action.edit.field.hijri_from.help': "Leave empty to take it from the Gregorian date by the workspace’s Hijri reference. Write it (YYYY-MM-DD) when the announced date differs from the table.",
    'screen.calendar.occasions.action.edit.field.hijri_to': "Hijri to",
    'screen.calendar.occasions.action.edit.field.hijri_to.help': "Leave empty to take it from the Gregorian date by the workspace’s Hijri reference. Write it (YYYY-MM-DD) when the announced date differs from the table.",
    'screen.calendar.occasions.action.edit.field.name_ar': "Name (Arabic)",
    'screen.calendar.occasions.action.edit.field.name_en': "Name (English)",
    'screen.calendar.occasions.action.withdraw': "Withdraw",
    'screen.calendar.occasions.action.withdraw.field.reason': "Why",
    'screen.calendar.occasions.column.gregorian_from': "From",
    'screen.calendar.occasions.column.gregorian_to': "To",
    'screen.calendar.occasions.column.hijri_from': "Hijri from",
    'screen.calendar.occasions.column.id': "Id",
    'screen.calendar.occasions.column.key': "Key",
    'screen.calendar.occasions.column.kind': "Kind",
    'screen.calendar.occasions.column.name_ar': "Occasion",
    'screen.calendar.occasions.column.name_en': "Name (English)",
    'screen.calendar.occasions.column.scope': "Scope",
    'screen.calendar.occasions.column.status': "Status",
    'screen.calendar.occasions.lede': "The dates this workspace has approved, and those still proposed.",
    'screen.calendar.occasions.stat.approved': "Approved",
    'screen.calendar.occasions.stat.proposed': "Awaiting approval",
    'screen.calendar.occasions.title': "Occasions",
    'screen.documents.items.action.create': "New",
    'screen.documents.items.action.create.field.name': "Name",
    'screen.documents.items.column.created_at': "Created",
    'screen.documents.items.column.name': "Name",
    'screen.documents.items.title': "Documents",
    'screen.calendar.occasions.stat.draft': "Awaiting approval",
    'screen.identity.modules.action.disable': "Turn off",
    'screen.identity.modules.action.enable': "Turn on",
    'screen.identity.modules.action.rename': "Rename workspace",
    'screen.identity.modules.action.rename.field.name': "Workspace name",
    'screen.identity.modules.action.names': "Name in each language",
    'screen.identity.modules.action.names.field.name_ar': "Name in Arabic",
    'screen.identity.modules.action.names.field.name_en': "Name in English",
    'screen.identity.modules.action.names.field.help': "Left empty, the workspace name is shown.",
    'screen.identity.modules.action.logo': "Workspace logo",
    'screen.identity.modules.action.logo.field.logo': "Logo",
    'screen.identity.modules.action.logo.field.logo.help': "A PNG, JPEG or WebP image of up to 2 MB. The employee app and the sign-in screen show it.",
    'screen.identity.modules.action.logo.field.remove': "Remove the current logo",
    'screen.identity.modules.column.core': "Kind",
    'screen.identity.modules.column.description': "What it does",
    'screen.identity.modules.column.enabled': "Status",
    'screen.identity.modules.column.key': "Key",
    'screen.identity.modules.column.name': "Unit",
    'screen.identity.modules.column.modules': "Modules",
    'screen.identity.modules.column.requires': "Needs",
    'screen.identity.modules.column.required_by': "Needed by",
    'screen.identity.modules.lede': "What this workspace runs, and what it could. A unit is switched on with all its modules, and with the units it needs.",
    'screen.identity.modules.stat.available': "Available",
    'screen.identity.modules.stat.on': "Running here",
    'screen.identity.modules.title': "Units",
    'screen.identity.unit_modules.title': "Modules",
    'screen.identity.unit_modules.empty': "This unit has no module that shows anything.",
    'screen.identity.unit.title': "Unit",
    'screen.identity.unit.tab.modules': "Modules",
    'screen.identity.unit.column.name': "Unit",
    'screen.identity.unit.column.key': "Key",
    'screen.identity.unit.column.enabled': "State",
    'screen.identity.unit.state.true': "On",
    'screen.identity.unit.state.false': "Off",
    'screen.identity.unit.column.modules': "Modules",
    'screen.identity.unit.column.modules_on': "Modules on",
    'screen.identity.unit.column.requires': "Needs",
    'screen.identity.unit.column.required_by': "Needed by",
    'screen.identity.unit.column.module_control': "Modules switched one by one",
    'screen.identity.modules.column.tier': "Tier",
    'screen.identity.modules.column.tier_requested': "Tier asked for",
    'screen.identity.unit.column.tier': "Tier",
    'screen.identity.unit.column.tier_requested': "Tier asked for",
    'screen.identity.unit.tier.basic': "Basic",
    'screen.identity.unit.tier.standard': "Standard",
    'screen.identity.unit.tier.advanced': "Advanced",
    'screen.identity.modules.action.request_tier': "Ask for another tier",
    'screen.identity.modules.action.request_tier.field.tier': "Tier",
    'screen.identity.modules.action.request_tier.field.tier.help': "The system administrator approves the change; until then the unit stays as it is. Changing a tier hides or shows screens and never changes data.",
    'screen.identity.modules.action.request_tier.field.reason': "Why",
    'screen.identity.modules.action.cancel_tier_request': "Withdraw the tier request",
    'screen.identity.unit_modules.column.name': "Module",
    'screen.identity.unit_modules.column.key': "Key",
    'screen.identity.unit_modules.column.enabled': "Status",
    'screen.identity.unit_modules.column.required_by': "Required by",
    'screen.identity.unit_modules.column.switchable': "Can be switched here",
    'screen.identity.unit_modules.action.enable': "Turn on",
    'screen.identity.unit_modules.action.disable': "Turn off",
    'screen.identity.people.action.edit': "Edit",
    'screen.identity.people.action.edit.field.job_title': "Job title",
    'screen.identity.people.action.edit.field.name': "Name",
    'screen.identity.people.action.edit.field.name.help': "What to call them. Left empty, the screen shows their address.",
    'screen.identity.people.action.edit.field.phone': "Telephone",
    'screen.identity.people.action.invite': "Invite by link",
    'screen.identity.people.action.invite.field.email': "Email",
    'screen.identity.people.action.invite.field.roles': "Roles",
    'screen.identity.people.action.invite.field.roles.help': "Nothing ticked means the member role. They choose their own password when they accept.",
    'screen.identity.people.action.invite.reveal.expires_at': "Valid until",
    'screen.identity.people.action.invite.reveal.link': "Invitation link",
    'screen.identity.people.action.reissue.reveal.link': "Invitation link",
    'screen.identity.people.action.invite.reveal.email_delivery': "Email",
    'screen.identity.people.action.reissue.reveal.email_delivery': "Email",
    'screen.identity.people.action.invite.field.send_email': "Email the link to them",
    'screen.identity.people.action.reissue.field.send_email': "Email the new link to them",
    'screen.identity.people.action.invite.field.send_email.help': "Uses the installation's mail settings. The link is also shown to you once, to copy.",
    'screen.identity.people.action.reissue.field.send_email.help': "The old link stops working. The new one is also shown to you once, to copy.",
    'screen.identity.people.follow.sent': "Sent to {address}",
    'screen.identity.people.follow.pending': "The mail server did not take it yet; it will be retried and appears in the delivery log.",
    'screen.identity.people.follow.failed': "Not sent: {last_error}. Copy the link and pass it on.",
    'screen.identity.people.follow.skipped': "Not emailed: copy the link and pass it on.",
    'screen.identity.people.action.reissue': "Send a new link",
    'screen.identity.people.action.reissue.reveal.expires_at': "Valid until",
    'screen.identity.people.action.reissue_live': "Send a new link",
    'screen.identity.people.action.reissue_live.reveal.expires_at': "Valid until",
    'screen.identity.people.action.reissue_live.reveal.token': "Invitation token",
    'screen.identity.people.action.remove': "Remove",
    'screen.identity.people.action.resume': "Let back in",
    'screen.identity.people.action.roles': "Set roles",
    'screen.identity.people.action.roles.field.roles': "What they may do here",
    'screen.identity.people.action.suspend': "Suspend",
    'screen.identity.people.action.withdraw': "Withdraw",
    'screen.identity.people.action.add': "Add user",
    'screen.identity.people.column.accepted_at': "Joined",
    'screen.identity.people.column.second_factor': "Two-step",
    'screen.identity.people.column.service_access_until': "Sign-in until",
    'screen.identity.people.status.access_until': "Sign-in until {service_access_until}",
    'screen.identity.people.column.email': "Email",
    'screen.identity.people.column.job_title': "Job title",
    'screen.identity.people.column.name': "User",
    'screen.identity.people.column.roles': "Role keys",
    'screen.identity.people.column.status': "Status",
    'screen.identity.people.column.last_seen_at': "Last active",
    'screen.identity.people.column.role_list': "Roles",
    'screen.identity.people.filter.roles': "Role",
    'screen.identity.people.lede': "Everyone who can sign in to this workspace, and everyone who has been asked to.",
    'screen.identity.people.stat.active': "Active",
    'screen.identity.people.stat.pending': "Pending invitations",
    'screen.identity.people.stat.people': "Users",
    'screen.identity.people.stat.suspended': "Suspended",
    'screen.identity.people.title': "Users",
    'screen.identity.roles.action.create': "New role",
    'screen.identity.roles.action.create.field.description': "What it is for",
    'screen.identity.roles.action.create.field.description.help': "One sentence. A person choosing between eleven roles is otherwise choosing between eleven names.",
    'screen.identity.roles.action.create.field.key': "Key",
    'screen.identity.roles.action.create.field.key.help': "Lowercase, no spaces. It is what the role is called in permissions and cannot be changed.",
    'screen.identity.roles.action.create.field.name': "Name",
    'screen.identity.roles.action.delete': "Delete",
    'screen.identity.roles.action.duplicate': "Duplicate",
    'screen.identity.roles.action.duplicate.field.key': "Key",
    'screen.identity.roles.action.duplicate.field.key.help': "Lowercase, no spaces. It cannot be changed afterwards.",
    'screen.identity.roles.action.duplicate.field.name': "Name",
    'screen.identity.roles.action.edit': "Edit",
    'screen.identity.roles.action.edit.field.colour': "Colour",
    'screen.identity.roles.action.edit.field.colour.option.amber': "amber",
    'screen.identity.roles.action.edit.field.colour.option.blue': "blue",
    'screen.identity.roles.action.edit.field.colour.option.green': "green",
    'screen.identity.roles.action.edit.field.colour.option.neutral': "neutral",
    'screen.identity.roles.action.edit.field.colour.option.red': "red",
    'screen.identity.roles.action.edit.field.colour.option.violet': "violet",
    'screen.identity.roles.action.edit.field.description': "What it is for",
    'screen.identity.roles.action.edit.field.name': "Name",
    'screen.identity.roles.action.edit.field.name_ar': "Name in Arabic",
    'screen.identity.roles.action.edit.field.name_ar.help': "Shown on Arabic pages; left empty, the English name is used.",
    'screen.identity.roles.action.edit.field.description_ar': "What it is for, in Arabic",
    'screen.identity.roles.action.members': "Members",
    'screen.identity.roles.action.members.field.members': "Who holds this role",
    'screen.identity.roles.action.permissions': "Set permissions",
    'screen.identity.roles.action.permissions.field.permissions': "What this role may do",
    'screen.identity.roles.column.colour': "Colour",
    'screen.identity.roles.column.requires_second_factor': "Two-step sign-in",
    'screen.identity.roles.action.second_factor': "Two-step sign-in",
    'screen.identity.roles.action.second_factor.field.required': "Holding this role requires it",
    'screen.identity.roles.action.second_factor.field.required.help': "Whoever holds this role enters a code from an authenticator application when entering this workspace. Somebody without one is asked to set it up at their next sign-in; a session already open signs in again with a code. Only somebody holding everything the role carries may change this.",
    'screen.identity.roles.column.description': "What it is for",
    'screen.identity.roles.column.is_system': "Kind",
    'screen.identity.roles.column.key': "Key",
    'screen.identity.roles.column.members': "Members",
    'screen.identity.roles.column.name': "Role",
    'screen.identity.roles.column.name_ar': "In Arabic",
    'screen.identity.roles.column.description_ar': "What it is for, in Arabic",
    'screen.identity.roles.column.permission_count': "Permissions",
    'screen.identity.roles.column.permissions': "Reaches",
    'screen.identity.roles.lede': "Group permissions into reusable bundles. A person may hold more than one.",
    'screen.identity.roles.stat.custom': "Custom",
    'screen.identity.roles.stat.system': "System",
    'screen.identity.roles.stat.total': "Total roles",
    'screen.identity.roles.title': "Roles and permissions",
    'screen.media.files.column.content_type': "Type",
    'screen.media.files.column.created_at': "Added",
    'screen.media.files.column.filename': "File",
    'screen.media.files.column.size': "Size",
    'screen.media.files.column.state': "State",
    'screen.media.files.title': "Files",
    'screen.media.files.lede': "Files uploaded to this workspace; an upload that never finished stays pending until it expires.",
    'screen.media.files.column.failure': "Why it failed",
    'screen.media.files.stat.files': "Files",
    'screen.media.files.stat.ready': "Ready",
    'screen.media.files.stat.pending': "Pending",
    'screen.media.files.action.prune': "Sweep expired uploads",
    'screen.media.files.action.prune.note': "Pending uploads whose signature had expired were removed, with whatever reached storage. An upload still in its window is left alone.",
    'screen.media.files.action.prune.removed': "Uploads removed",
    'screen.media.files.action.delete': "Delete",
    'media.state.ready': "Ready",
    'media.state.pending': "Pending",
    'media.state.failed': "Failed",
    'screen.notifications.items.action.create': "New",
    'screen.notifications.items.action.create.field.name': "Name",
    'screen.notifications.items.column.created_at': "Created",
    'screen.notifications.items.column.name': "Name",
    'screen.notifications.items.title': "Notifications",
    'screen.parties.parties.stat.active': "Active",
    'screen.parties.parties.stat.archived': "Archived",
    'screen.parties.parties.stat.merged': "Merged away",
    'screen.parties.parties.stat.parties': "Parties",
    'screen.settings.groups.column.name': "Group",
    'screen.settings.groups.column.problems': "Problems",
    'screen.settings.groups.column.version': "Version",
    'screen.settings.groups.title': "Settings",
    'screen.identity.roles.stat.system.detail': "Part of every workspace",
    'screen.identity.roles.stat.custom.detail': "Made here, and editable",
    'screen.identity.people.stat.suspended.detail': "Cannot work here for now",
    'screen.identity.people.stat.password_pending': "Awaiting a password",
    'screen.identity.people.stat.password_pending.detail': "Signed in with a temporary one",
    'screen.identity.people.stat.follow_up': "Need follow-up",
    'screen.identity.people.tab.follow_up': "Need follow-up",
    'screen.identity.role.title': "Role",
    'screen.identity.role.column.modules': "Modules it reaches",
    'screen.identity.role.tab.permissions': "Permissions",
    'screen.identity.role.tab.holders': "Who holds it",
    'screen.identity.role.tab.settings': "Settings",
    'screen.identity.role.table.permissions': "What this role may do",
    'screen.identity.role.permission.name': "Permission",
    'screen.identity.role.permission.module_name': "Module",
    'screen.identity.role.permission.key': "Key",
    'screen.identity.role.permission.retired': "Offered",
    'screen.identity.role.permission.retired.true': "No longer offered",
    'screen.identity.role.permission.retired.false': "Offered",
    'screen.identity.role.note.fifteen_minutes': "A change reaches the people who hold this role within 15 minutes, when their sign-in renews.",
    'screen.identity.role_holders.title': "Who holds this role",
    'screen.identity.role_holders.column.membership_id': "Membership",
    'screen.identity.role_holders.empty': "Nobody holds this role yet.",
    'screen.identity.role_holders.action.add': "Give it to…",
    'screen.identity.role_holders.action.add.field.add': "Members",
    'screen.identity.role_holders.action.remove': "Take off this role",
    'screen.identity.people.action.add.field.how': "How do they sign in the first time?",
    'screen.identity.people.action.add.field.how.option.invite': "Send them an invitation link",
    'screen.identity.people.action.add.field.how.option.password': "Make a temporary password",
    'screen.identity.people.action.add.field.roles.help_any': "None ticked: member by a link, employee by a password.",
    'screen.identity.member.column.name': "Name",
    'screen.identity.member.column.linked': "Linked to a person",
    'screen.identity.member.alert.new_password': "New temporary password",
    'screen.identity.member.table.permissions': "What they may do, and which role gives it",
    'screen.identity.member.permission.from': "From the role",
    'screen.identity.member.note.fifteen_minutes': "A change to their roles reaches them within 15 minutes, when their sign-in renews.",
    'screen.identity.member.card.roles': "Roles in this workspace",
    'screen.identity.member.card.details': "Details",
    'screen.identity.member.card.details.note': "Name, telephone and job title belong to their account, so a change shows in every workspace they are in.",
    'screen.identity.member.card.membership': "Membership",
    'screen.identity.member_sessions.title': "Open sessions",
    'screen.identity.member_sessions.column.device': "Device",
    'screen.identity.people.stat.follow_up.detail': "Still on a temporary password, or not yet in",
    'screen.invoicing.documents.lede': "A posted invoice is not edited: a correction is a credit or debit note that names it and carries one of the authority's reasons.",
    // hr · attendance
    "group.attendance": "Attendance and schedules",
    "value.day_status.present": "Present",
    "value.day_status.late": "Late",
    "value.day_status.left_early": "Left early",
    "value.day_status.incomplete": "One punch missing",
    "value.day_status.absent": "Absent",
    "value.day_status.on_leave": "On leave",
    "value.day_status.in_shift": "On shift now",
    "value.source.device": "Reader",
    "value.source.app": "Field app",
    "value.source.manual": "Manual",
    "value.source.review": "An appraisal",
    "value.source.imported": "File",
    "value.stage.counting": "Counting",
    "value.stage.warning": "Warning",
    "value.stage.review": "Review",
    "value.template.daily": "Daily",
    "value.template.historical": "Historical",
    "value.template.device": "Reader",
    // An import's states, general to every unit that reads a file before applying it.
    "value.import_status.reviewing": "Waiting to be read",
    "value.import_status.pending_approval": "Waiting for approval",
    "value.import_status.approved": "Approved, ready to apply",
    "value.import_status.applied": "Applied",
    "value.import_status.undone": "Undone",
    "value.import_status.refused": "Refused",
    "value.import_status.cancelled": "Discarded",
    // hr · offboarding
    "value.art87_ground.childbirth": "Within three months of giving birth",
    "value.art87_ground.force_majeure": "Force majeure beyond the worker",
    "value.art87_ground.marriage": "Within six months of her marriage",
    "value.ended_by.employer": "The employer",
    "value.ended_by.worker": "The employee",
    "value.owner.custody": "Custody",
    "value.owner.employee": "The employee",
    "value.owner.finance": "Finance",
    "value.owner.hr": "Human resources",
    "value.owner.it": "IT",
    "value.owner.manager": "City manager",
    "value.status.cleared": "Confirmed",
    "value.status.clearing": "Clearing",
    "value.status.closed_out": "Closed",
    "value.status.deferred": "Deferred",
    "value.status.disputed": "Disputed",
    "value.status.filed": "Filed",
    "value.status.overdue": "Overdue",
    "value.status.pending": "Pending",
    "value.status.settled": "Settled",
    "value.status.unrecovered": "Not recovered",
    "value.status.withdrawn": "Withdrawn",
    "value.status.destroyed": "Destroyed",
    "value.wage_period.monthly": "Paid monthly",
    "value.wage_period.other": "Paid otherwise",
    'editor.choices.accounts': "the chart of accounts",
    'editor.choices.journals': "the journals",
    'editor.choices.noBankJournal': "There is no bank journal yet. Add one under Journals, with the type Bank and a default account.",
    'editor.choices.noPurchaseJournal': "There is no purchase journal yet. Add one under Journals, with the type Purchase.",
    'editor.choices.noSalesJournal': "There is no sales journal yet. Add one under Journals, with the type Sale.",
    'editor.choices.parties': "the parties register",
    'editor.choices.taxCodes': "the tax codes",
    'editor.choices.unreachable': "Could not read {what} ({state}).",
    'editor.need.balanced': "debits equal to credits, above zero",
    'editor.need.entryLines': "every line with an account and either a debit or a credit",
    'editor.need.journal': "the journal",
    'editor.need.lines': "every line with a description, a quantity, a price and an account",
    'editor.need.party': "the customer",
    'editor.need.purchaseJournal': "the purchase journal",
    'editor.need.salesJournal': "the sales journal",
    'editor.need.vendor': "the vendor",
    'editor.needs': "Still needed: {list}",
    // hr · benefits
    "group.benefits": "Custody and benefits",
    "nav.module.gosi": "GOSI",
    "nav.module.mudad": "Mudad (WPS)",
    "nav.module.setup": "Setup conversation",
    "value.cover_status.covered": "Covered",
    "value.cover_status.ended": "Ended",
    "value.cover_status.ending": "Ending",
    "value.cover_status.not_covered": "Not on cover",
    "value.cover_status.unconfirmed": "Waiting for the insurer",
    "value.covers.employee": "The employee",
    "value.covers.employee_spouse": "The employee and spouse",
    "value.covers.family": "The employee and family",
    "value.covers_parents.false": "Family only",
    "value.covers_parents.true": "Carries parents",
    "value.relation.daughter": "Daughter",
    "value.relation.father": "Father",
    "value.relation.mother": "Mother",
    "value.relation.son": "Son",
    "value.relation.spouse": "Spouse",
    "value.status.accruing": "Being earned",
    "value.status.cashed": "Paid in cash",
    "value.status.covered": "Covered",
    "value.status.due": "Due",
    "value.status.in_force": "In force",
    "value.status.ticketed": "Ticket issued",
    "value.statutory.false": "Optional",
    "value.statutory.true": "Required by law",
    "value.ticket_class.business": "Business",
    "value.ticket_class.economy": "Economy",
    "value.ticket_class.first": "First",
    // hr · recruitment
    "group.recruitment": "Recruitment and onboarding",
    "value.channel.agency": "Agency",
    "value.channel.job_board": "Job board",
    "value.channel.other": "Other",
    "value.channel.referral": "Referral",
    "value.channel.social": "Social media",
    "value.channel.walk_in": "Walked in",
    "value.channel.website": "Website",
    "value.credential_required.false": "Not required",
    "value.credential_required.true": "Required",
    "value.flag.age_outside_range": "Outside the age range",
    "value.flag.below_qualification": "Below the qualification",
    "value.flag.blacklisted": "On the blacklist",
    "value.flag.meets_all": "Meets the criteria",
    "value.flag.no_credential": "No credential",
    "value.flag.short_experience": "Short of experience",
    "value.flag.under_age": "Under the working age",
    "value.has_credential.false": "Does not hold it",
    "value.has_credential.true": "Holds it",
    "value.min_qualification.bachelor": "Bachelor's",
    "value.min_qualification.diploma": "Diploma",
    "value.min_qualification.doctorate": "Doctorate",
    "value.min_qualification.intermediate": "Intermediate",
    "value.min_qualification.master": "Master's",
    "value.min_qualification.none": "None",
    "value.min_qualification.primary": "Primary",
    "value.min_qualification.secondary": "Secondary",
    "value.next_step.await_joining": "Waiting to start",
    "value.next_step.decide": "Decide",
    "value.next_step.hire": "Hire",
    "value.next_step.interview": "Schedule an interview",
    "value.next_step.no_show": "Did not report",
    "value.next_step.none": "Nothing to do",
    "value.next_step.offer": "Make an offer",
    "value.next_step.record_result": "Record the interview",
    "value.next_step.screen": "Screen",
    "value.qualification.bachelor": "Bachelor's",
    "value.qualification.diploma": "Diploma",
    "value.qualification.doctorate": "Doctorate",
    "value.qualification.intermediate": "Intermediate",
    "value.qualification.master": "Master's",
    "value.qualification.none": "None",
    "value.qualification.primary": "Primary",
    "value.qualification.secondary": "Secondary",
    "value.recommendation.hire": "Hire",
    "value.recommendation.hold": "Keep on the list",
    "value.recommendation.reject": "Refuse",
    "value.result.cancelled": "Cancelled",
    "value.status.filled": "Filled",
    "value.status.hired": "Hired",
    "value.status.interview": "Interview",
    "value.status.lifted": "Lifted",
    "value.status.offered": "Offered",
    "value.status.screening": "Screening",
    "value.status.waiting": "On the waiting list",
    // hr · grievances
    "value.decision.accepted": "Accepted — a contested penalty falls",
    "value.decision.partly_accepted": "Partly accepted",
    "value.decision.rejected": "Rejected — a contested penalty stands",
    "value.decision.upheld": "Upheld",
    "value.decision.partly_upheld": "Partly upheld",
    "value.decision.dismissed": "Dismissed",
    "value.decision.adopted": "Adopted",
    "value.decision.noted": "Noted",
    "value.decision.declined": "Not taken up",
    "value.hold_state.applied": "Already deducted",
    "value.hold_state.held": "Held until decided",
    "value.hold_state.none": "No pay effect",
    "value.hold_state.released": "Hold lifted",
    "value.kind.colleague": "Complaint about a colleague",
    "value.kind.conditions": "Conditions of work",
    "value.kind.pay": "Pay complaint",
    "value.kind.penalty": "Objection to a penalty",
    "value.kind.suggestion": "Suggestion or remark",
    "value.kind.supervisor": "Complaint about a supervisor",
    "value.route.committee": "Grievance committee",
    "value.route.hr": "Human resources",
    "value.status.decided": "Decided, not yet served",
    "value.status.heard": "Worker heard",
    // hr · assets
    "group.custody": "Custody",
    "value.category.office": "Office — counted every 12 months",
    "value.category.operational": "Operational — counted every 6 months",
    "value.cause.accident": "Accident",
    "value.cause.normal_wear": "Normal wear",
    "value.cause.unknown": "Unknown",
    "value.cause.worker_fault": "The worker's error",
    "value.condition.damaged": "Damaged",
    "value.condition.good": "Good",
    "value.condition.lost": "Lost",
    "value.condition.needs_maintenance": "Needs maintenance",
    "value.condition.retired": "Out of use",
    "value.issue_grade.acceptable": "Acceptable",
    "value.issue_grade.excellent": "Excellent",
    "value.issue_grade.good": "Good",
    "value.return_reason.long_leave": "Long leave",
    "value.return_reason.other": "Other",
    "value.return_reason.role_change": "Change of job",
    "value.return_reason.termination": "End of service",
    "value.return_reason.transfer": "Transfer",
    "value.return_state.damaged": "Damaged",
    "value.return_state.intact": "Intact",
    "value.return_state.lost": "Lost",
    "value.return_state.needs_maintenance": "Needs maintenance",
    "value.stage.approved": "Approved",
    "value.stage.cancelled": "Cancelled",
    "value.stage.filed": "To assess",
    "value.damage_stage.filed": "To assess",
    "value.damage_stage.review": "Awaiting approval",
    "value.damage_stage.approved": "Approved",
    "value.damage_stage.cancelled": "Cancelled",
    "value.status.counting": "Counting",
    "value.status.handed_over": "Handed over",
    "value.status.return_overdue": "Late back",
    "value.status.returned": "Returned",
    'member.activity.forbidden': "Reading the activity log needs its own permission.",
    'member.activity.none': "Nothing recorded about them yet.",
    'member.back': "Back to users",
    'member.field.added_by': "Added by",
    'member.field.elsewhere': "Other workspaces",
    'member.field.email': "Email",
    'member.field.job_title': "Job title",
    'member.field.joined': "Joined",
    'member.field.last_seen': "Last here",
    'member.field.phone': "Telephone",
    'member.field.roles': "Roles",
    'member.missing': "Open a user from the list of users.",
    'member.never': "Not yet",
    'member.nobody': "Joined by invitation, before this was recorded",
    'member.passwordPending': "Still on a temporary password: they must choose their own at their next sign-in.",
    'member.permissions.everything': "Everything, now and later",
    'member.permissions.from': "From",
    'member.permissions.none': "No permissions: they can sign in and look after their own account, nothing more.",
    'member.sessions.device': "Opened from",
    'member.sessions.end': "End",
    'member.sessions.endAll': "End every session here",
    'member.sessions.lastUsed': "Last used",
    'member.sessions.none': "No open sessions here.",
    'member.sessions.started': "Started",
    'member.sessions.unknownDevice': "Unknown device",
    'member.suspended': "Suspended here: they cannot work in this workspace until they are let back in.",
    'member.afterService': "Their service ended on {service_ends_on}. Until {service_access_until} they may still sign in, to what the modules allow after a service and nothing else.",
    'member.tab.activity': "Activity",
    'member.tab.permissions': "Permissions",
    'member.tab.profile': "Profile",
    'member.tab.sessions': "Sessions",
    'member.confirm.reset': "A new temporary password is generated and shown to you once. Their current password stops working, every session they have here ends, and they must choose their own at their next sign-in.",
    'member.confirm.end': "Every session they have open in this workspace ends. They can sign in again with their password.",
    'member.confirm.suspend': "They cannot work in this workspace until they are let back in, and their sessions here end. Other workspaces they belong to are not affected.",
    'member.confirm.resume': "They can sign in to this workspace again, with the roles they had.",
    'member.confirm.resetSecondFactor': "Their authenticator and recovery codes stop working, every session they have here ends, and they set it up again at their next sign-in. For somebody who lost their phone and their codes.",
    'member.field.second_factor': "Two-step sign-in",
    'member.secondFactor.on': "In use",
    'member.secondFactor.off': "Not set up",
    'screen.identity.people.action.reset_second_factor': "Reset two-step sign-in",
    'screen.identity.member.lede': "Who they are here, what they may do and why, where they are signed in, and what they did.",
    'screen.identity.member.title': "User",
    'screen.identity.people.action.add.field.email': "Email",
    'screen.identity.people.action.add.field.email.help': "If this address already has an account in another workspace, it is added as it is and keeps its own password.",
    'screen.identity.people.action.add.field.job_title': "Job title",
    'screen.identity.people.action.add.field.name': "Name",
    'screen.identity.people.action.add.field.roles': "Roles",
    'screen.identity.people.action.add.field.roles.help': "Nothing ticked means the employee role. A password is generated, shown to you once, and must be changed at first sign-in.",
    'screen.identity.people.action.add.reveal.email': "Email",
    'screen.identity.people.action.add.reveal.temporary_password': "Temporary password",
    'screen.identity.people.action.end_sessions': "Sign out everywhere here",
    'screen.identity.people.action.open': "Open",
    'screen.identity.people.action.reset_password': "Reset password",
    'screen.identity.people.action.reset_password.reveal.email': "Email",
    'screen.identity.people.action.reset_password.reveal.temporary_password': "Temporary password",
    'value.roles.admin': "Administrator",
    'value.roles.employee': "Employee",
    'value.roles.member': "Member",
    'value.roles.owner': "Owner",
    // hr · performance
    "value.band.exceeds": "Exceeds expectations",
    "value.band.meets": "Meets expectations",
    "value.band.needs_improvement": "Needs improvement",
    "value.band.outstanding": "Outstanding",
    "value.band.unsatisfactory": "Unsatisfactory",
    "value.recommendation.confirm": "Confirm in the job",
    "value.recommendation.extend": "Extend the probation",
    "value.recommendation.terminate": "End during probation",
    "value.review_kind.periodic": "Periodic appraisal",
    "value.review_kind.probation": "Probation appraisal",
    "value.scope_kind.all": "Everyone in service",
    "value.scope_kind.department": "A department",
    "value.scope_kind.position": "A position",
    "value.stage.calibration": "HR calibration",
    "value.stage.final": "Final",
    "value.stage.manager": "Manager's rating",
    "value.stage.objected": "Objected to",
    "value.stage.self": "Self-assessment",
    "value.stage.withdrawn": "Withdrawn",
    "value.status.archived": "Archived",
    "value.status.running": "Running",
    "value.waiting_on.employee": "The employee",
    "value.waiting_on.hr": "HR",
    "value.waiting_on.manager": "The manager",
    // hr · onboarding — the hiring journey
    "value.how.by_owner": "Done by its owner's event",
    "value.how.by_hand": "Marked by hand: its owner has no event yet",
    "value.how.event": "Done by its owner's event",
    "value.how.route": "Recorded by its owner",
    "value.how.manual": "Marked by hand",
    "value.stage.before_start": "Before the first day",
    "value.stage.start_day": "First day",
    "value.stage.probation": "Probation",
    "value.stage.completed": "Completed",
    // hr · attendance readers (#59)
    "value.device_status.pending": "Waiting to be placed",
    "value.device_status.faulty": "Out of service",
    "value.device_status.offline": "Offline",
    "value.device_status.active": "Working",
    "value.device_status.retired": "Inactive",
    "value.match.unmatched": "Nobody",
    "value.match.explicit": "Mapped by hand",
    "value.match.numeric_part": "By the digits of the employee number",
    "value.match.exact": "By the whole employee number",
    "value.bridge_status.active": "In use",
    "value.bridge_status.revoked": "Revoked",
    // hr · payroll
    "value.kind.main": "Main run",
    "value.kind.supplementary": "Supplementary",
    "value.kind.settlement": "Final settlement",
    "value.wps_file.not_generated": "Not generated",
    "value.wps_file.generated": "Generated",
    "value.wps_file.uploaded": "Uploaded",
    "value.wps_file.rejected": "Rejected by the bank",
    "value.status.preparing": "Preparing",
    "value.status.review": "In review",
    "value.origin.contract": "Contract",
    "value.origin.attendance": "Attendance",
    "value.origin.leave": "Leave",
    "value.origin.discipline": "Discipline",
    "value.origin.assets": "Custody",
    "value.origin.rewards": "Rewards",
    "value.origin.benefits": "Benefits",
    "value.origin.offboarding": "End of service",
    "value.origin.gosi": "GOSI",
    "value.origin.entered": "Entered by hand",
    "value.capped.capped": "Capped",
    "value.capped.within_cap": "Within the caps",
    "value.kind.earning": "Earning",
    "value.kind.deduction": "Deduction",
    "value.kind.employer_cost": "Employer cost",
    "value.method.fixed": "Fixed amount",
    "value.method.percent": "Percentage",
    "value.method.formula": "Formula",
    "value.periodicity.monthly": "Monthly",
    "value.periodicity.one_off": "One-off",
    "value.nationality.citizen": "Citizen",
    "value.nationality.non_citizen": "Not a citizen",
    "value.payment_method.bank": "Bank transfer (WPS)",
    "value.payment_method.cash": "Cash",
    "value.status.details_complete": "Complete",
    "value.status.details_missing": "Missing something",
    "group.payroll": "Payroll",
    // platform · export
    'list.export.format.xlsx': 'An Excel workbook: numbers, money and dates as real cells, the filters written above the table, the header row frozen',
    'list.export.format.pdf': 'A print layout of the same table. Your browser’s print dialog opens — choose “Save as PDF” as the printer',
    'list.export.format.docx': 'A Word document of the same table, with the filters written above it, on the screen’s paper size, right to left for Arabic',
    'list.export.print': 'Open print view',
    'export.hijri': 'Hijri',
    'export.sort.asc': 'ascending',
    'export.sort.desc': 'descending',
    'export.meta.filters': 'Filters',
    'export.meta.filters.none': 'None — every row',
    'export.meta.sort': 'Order',
    'export.meta.rows': 'Rows',
    'export.meta.at': 'Exported on',
    'export.meta.by': 'Exported by',
    'export.meta.by.unknown': 'Not recorded',
    // platform · notifications
    "notifications.unread": "{n} unread",
    "notifications.criticalOpen": "{n} critical — waiting for you to acknowledge",
    "notifications.readAll": "Mark all as read",
    "notifications.markRead": "Mark as read",
    "notifications.acknowledge": "Acknowledge",
    "notifications.announcement": "Announcement",
    "notifications.unavailable": "Notifications could not be read right now.",
    "notifications.emptyHint": "What your workspace tells you appears here.",
    "nav.notifications.rules": "Notification rules",
    "nav.notifications.deliveries": "Notification log",
    "nav.notifications.announcements": "Announcements",
    "nav.notifications.receipts": "Read receipts",
    "value.importance.info": "Information",
    "value.importance.warning": "Needs attention",
    "value.importance.critical": "Critical — must be acknowledged",
    "value.stage.primary": "First notice",
    "value.stage.escalation": "Escalation",
    "value.progress.delivered": "Not read yet",
    "value.progress.pending": "Sending",
    "value.progress.sent": "Sent",
    "value.progress.failed": "Not sent",
    "value.progress.read": "Read",
    "value.progress.awaiting_ack": "Awaiting acknowledgement",
    "value.progress.acknowledged": "Acknowledged",
    "value.channel.in_app": "In the app",
    "value.channel.email": "Email",
    "value.channel.whatsapp": "WhatsApp",
    "value.channel.sms": "SMS",
    "value.channel.portal": "Portal",
    "value.publication.draft": "Draft",
    "value.publication.published": "Published",
    "value.publication.withdrawn": "Withdrawn",
    "value.audience.all": "Everybody in the workspace",
    "value.audience.roles": "Chosen roles",
    "value.receipt.read": "Read",
    "value.receipt.unread": "Not read yet",
    "notifications.refusal.required": "{field} is required.",
    "notifications.refusal.too_long": "At most {max} characters.",
    "notifications.refusal.stale": "Somebody changed this since you opened it. Reopen it and try again.",
    "notifications.refusal.identity_forbidden": "Naming people by role needs permission to read the workspace's roles.",
    "notifications.refusal.identity_unavailable": "The roles could not be checked right now. Try again shortly.",
    "notifications.refusal.email_not_configured": "Email is not set up on this installation, so the link has to be passed on by hand.",
    "notifications.refusal.no_link": "The app's address is not set (SHELL_ORIGINS), so there is no link to send.",
    "notifications.refusal.portal_invitation.no_channel": "Neither this party's email nor its mobile number can be reached on a channel set up here, so the link has to be passed on by hand.",
    "notifications.refusal.portal.no_party": "This portal session names no party. Sign in again.",
    "notifications.portal.feed": "Notifications",
    "activity.event.identity.portal.invited": "Invited to the portal",
    "notifications.refusal.invitation.not_found": "This invitation can no longer be accepted: it was accepted, withdrawn, reissued, or it expired.",
    "notifications.refusal.invitation.identity_forbidden": "Your session was not accepted for this invitation. Sign in again and retry.",
    "notifications.refusal.invitation.identity_unavailable": "The invitation could not be confirmed right now. Try again shortly.",
    "notifications.refusal.rule.event_shape": "An event is named in dotted lower-case words, like leave.approved.",
    "notifications.refusal.rule.own_event": "A rule cannot listen to the notifications module itself.",
    "notifications.refusal.rule.no_roles": "Choose at least one role to tell, or name the person the event names.",
    "notifications.refusal.rule.role_shape": "\"{value}\" is not a role.",
    "notifications.refusal.rule.unknown_role": "This workspace has no role \"{value}\".",
    "notifications.refusal.rule.importance": "Choose information, needs attention, or critical.",
    "notifications.refusal.rule.no_channels": "Choose at least one channel.",
    "notifications.refusal.rule.channel_shape": "\"{value}\" is not a channel.",
    "notifications.refusal.rule.channel_unavailable": "{value} is not set up on this installation.",
    "notifications.refusal.rule.critical_needs_app": "A critical alert is acknowledged in the app, so it must be sent there too.",
    "notifications.refusal.rule.escalation_pair": "Escalation needs both a delay and the roles to tell.",
    "notifications.refusal.rule.escalation_not_critical": "Only a critical alert escalates.",
    "notifications.refusal.rule.escalation_minutes": "Between {min} and {max} minutes.",
    "notifications.refusal.rule.condition_shape": "Line {line}: write field = value.",
    "notifications.refusal.rule.condition_twice": "Line {line}: {field} is already named.",
    "notifications.refusal.rule.too_many_conditions": "At most {max} conditions.",
    "notifications.refusal.rule.not_found": "No such rule.",
    "notifications.refusal.rule.already_retired": "This rule is already off.",
    "notifications.refusal.rule.already_active": "This rule is already on.",
    "notifications.refusal.delivery.not_found": "No such notification for you.",
    "notifications.refusal.delivery.not_critical": "Only a critical alert is acknowledged; this one is simply read.",
    "notifications.refusal.delivery.already_acknowledged": "You have already acknowledged this alert.",
    "notifications.refusal.announcement.audience": "Send it to everybody or to chosen roles.",
    "notifications.refusal.announcement.roles_for_all": "An announcement to everybody names no roles.",
    "notifications.refusal.announcement.not_found": "No such announcement.",
    "notifications.refusal.announcement.withdrawn": "A withdrawn announcement is not edited; write a new one.",
    "notifications.refusal.announcement.not_draft": "Only a draft is published.",
    "notifications.refusal.announcement.not_published": "Only a published announcement is withdrawn.",
    "notifications.refusal.announcement.comments_allowed": "Say yes or no to comments.",
    "notifications.refusal.announcement.comments_closed": "Comments are not open on this announcement.",
    "notifications.refusal.reaction.kind": "A reaction is like, celebrate or thanks.",
    "notifications.refusal.thanks.not_a_member": "Only a member of this workspace can be thanked.",
    "notifications.refusal.thanks.to_self": "You cannot thank yourself.",
    "notifications.refusal.thanks.public": "Say whether everybody sees it: yes or no.",
    "notifications.refusal.chat.not_a_member": "Only a member of this workspace can be written to.",
    "notifications.refusal.chat.to_self": "You cannot write to yourself.",
    "notifications.refusal.chat.not_found": "No such chat.",
    "notifications.refusal.chat.before": "Start from a message of this chat.",
    "notifications.refusal.chat.limit": "Ask for between 1 and 100 messages.",
    "notifications.refusal.chat.key_reused": "This request was already used for a message in another chat.",
    "notifications.refusal.chat.retention": "Keep chat messages in view between 30 days and ten years.",
    "notifications.refusal.chat.pinned": "Say whether the chat is pinned: yes or no.",
    "notifications.refusal.chat.mute": "Mute until a time, or until you unmute it — not both.",
    "notifications.refusal.chat.mute_until": "Mute until a time from now to a year ahead.",
    "notifications.refusal.push.token": "This is not a push token the phone was given.",
    "notifications.refusal.push.platform": "The phone is Android or iOS.",
    "notifications.refusal.push.device_id": "This is not the app's id for this phone.",
    "notifications.refusal.post.not_found": "No such post.",
    "notifications.refusal.post.not_yours": "Only its author, or whoever manages announcements, can withdraw a post.",
    "notifications.refusal.post.not_a_poll": "This post is not a poll.",
    "notifications.refusal.post.before": "Start from a post of the feed.",
    "notifications.refusal.post.limit": "Ask for between 1 and 50 posts.",
    "notifications.refusal.poll.shape": "A poll is its answers, when it closes, and when its counts are shown.",
    "notifications.refusal.poll.options": "A poll has from 2 to 6 answers.",
    "notifications.refusal.poll.option_text": "Each answer is 1 to 200 characters.",
    "notifications.refusal.poll.duplicate": "Two answers are the same.",
    "notifications.refusal.poll.closes_at": "A poll closes between 5 minutes and 90 days from now.",
    "notifications.refusal.poll.results": "Show the counts always, after voting, or after the poll closes.",
    "notifications.refusal.poll.closed": "This poll has closed.",
    "notifications.refusal.poll.option": "Choose one of the poll's answers.",
    "notifications.refusal.poll.already_voted": "You have already voted in this poll.",
    "screen.notifications.rules.title": "Notification rules",
    "screen.notifications.rules.lede": "When an event happens, who is told, where, and how urgently. A change here applies to the next event — nothing is deployed.",
    "screen.notifications.rules.stat.active": "On",
    "screen.notifications.rules.stat.critical": "Critical",
    "screen.notifications.rules.stat.critical.detail": "Stay open until acknowledged",
    "screen.notifications.rules.stat.retired": "Off",
    "screen.notifications.rules.column.name": "Rule",
    "screen.notifications.rules.column.event_name": "When",
    "screen.notifications.rules.column.roles": "Tell",
    "screen.notifications.rules.column.channels": "Channels",
    "screen.notifications.rules.column.importance": "Importance",
    "screen.notifications.rules.column.escalate_after_minutes": "Escalates after (min)",
    "screen.notifications.rules.column.alerts": "Alerts raised",
    "screen.notifications.rules.column.last_alert_at": "Last alert",
    "screen.notifications.rules.column.status": "Status",
    "screen.notifications.rules.column.condition_text": "Conditions",
    "screen.notifications.rules.column.escalate_to": "Escalate to",
    "screen.notifications.rules.column.id": "Id",
    "screen.notifications.rules.action.create": "New rule",
    "screen.notifications.rules.action.edit": "Edit",
    "screen.notifications.rules.action.retire": "Switch off",
    "screen.notifications.rules.action.restore": "Switch on",
    "screen.notifications.rules.field.name": "Name",
    "screen.notifications.rules.field.name.help": "What the person reads in their bell, e.g. Leave approved.",
    "screen.notifications.rules.field.event_name": "When this happens",
    "screen.notifications.rules.field.conditions": "Only when",
    "screen.notifications.rules.field.conditions.help": "Optional. Each row is a field of the event's payload and the value it must have. Every row must hold.",
    "screen.notifications.rules.field.roles": "Tell these roles",
    "screen.notifications.rules.field.channels": "Channels",
    "screen.notifications.rules.field.channels.help": "Every channel is listed. One not switched on for this workspace yet says so: the rule keeps it, its messages are logged as not sent, and it starts once it is switched on.",
    "screen.notifications.rules.field.importance": "Importance",
    "screen.notifications.rules.field.escalate_after_minutes": "Escalate after (minutes)",
    "screen.notifications.rules.field.escalate_after_minutes.help": "Critical only. Left empty, it never escalates.",
    "screen.notifications.rules.field.escalate_to": "Escalate to",
    "screen.notifications.deliveries.title": "Notification log",
    "screen.notifications.deliveries.lede": "Who was told, about what, on which channel — whether they read it, and for a critical alert who acknowledged it and when. The latest 500.",
    "screen.notifications.deliveries.column.created_at": "Told",
    "screen.notifications.deliveries.column.rule_name": "Alert",
    "screen.notifications.deliveries.column.recipient": "Recipient",
    "screen.notifications.deliveries.column.channel": "Channel",
    "screen.notifications.deliveries.column.importance": "Importance",
    "screen.notifications.deliveries.column.progress": "State",
    "screen.notifications.deliveries.column.read_at": "Read",
    "screen.notifications.deliveries.column.acknowledged_at": "Acknowledged",
    "screen.notifications.deliveries.column.acknowledged_by_email": "Acknowledged by",
    "screen.notifications.deliveries.column.stage": "Stage",
    "screen.notifications.deliveries.column.escalated_at": "Escalated",
    "screen.notifications.deliveries.column.event_name": "Event",
    "screen.notifications.deliveries.column.occurred_at": "Happened",
    "screen.notifications.deliveries.column.last_error": "Provider said",
    "screen.notifications.deliveries.column.event_id": "Event id",
    "screen.notifications.deliveries.column.id": "Id",
    "screen.notifications.deliveries.column.skip_reason": "Not sent because",
    "screen.notifications.deliveries.column.provider_status": "Provider reports",
    "value.progress.skipped": "Not sent",
    "value.skip_reason.no_member": "No sign-in here",
    "value.skip_reason.not_permitted": "May not see it",
    "value.skip_reason.opted_out": "Opted out",
    "value.skip_reason.not_opted_in": "Not opted in",
    "value.skip_reason.no_address": "No address",
    "value.skip_reason.no_phone": "No WhatsApp number",
    "value.skip_reason.template_not_approved": "Template not approved",
    "value.skip_reason.muted": "Muted by the member",
    "value.provider_status.sent": "Sent",
    "value.provider_status.delivered": "Delivered",
    "value.provider_status.read": "Read",
    "value.provider_status.failed": "Failed",
    "screen.notifications.rules.field.roles.help": "Roles, the person the event names, or both. A rule that tells nobody is refused.",
    "screen.notifications.rules.field.subject_field": "Tell the person the event names",
    "screen.notifications.rules.field.subject_field.help": "Optional. The payload field holding the person's id — party_ref on HR's events, owner_ref on a document. The person is told only if they may see what it is about.",
    "screen.notifications.rules.field.subject_permission": "Only if the person may",
    "screen.notifications.rules.field.subject_permission.help": "Required with a person field. What the person must hold, through any of their roles, to be told.",
    "screen.notifications.rules.column.subject_field": "Tell the person named by",
    "screen.notifications.rules.column.subject_permission": "Only if they may",
    "screen.notifications.rules.column.pack": "From pack",
    "screen.notifications.rules.action.import_pack": "Import a pack",
    "screen.notifications.rules.field.pack": "Pack",
    "screen.notifications.rules.field.pack.help": "Rules that tell the person an event names, with WhatsApp templates as drafts. A rule already imported is kept as it is.",
    "screen.notifications.rules.field.locale": "Name the rules in",
    "screen.notifications.rules.field.pack_roles.help": "For a pack whose rules tell roles rather than the person (late approvals): who is told.",
    "screen.notifications.rules.field.pack_escalate_to.help": "For a critical rule of such a pack: who is told when nobody acknowledges within the delay.",
    "screen.notifications.rules.field.pack_escalate_after.help": "Left empty, the pack's own delay.",
    "value.locale.ar": "Arabic",
    "value.locale.en": "English",
    "nav.notifications.templates": "WhatsApp templates",
    "screen.notifications.templates.title": "WhatsApp templates",
    "screen.notifications.templates.lede": "The WhatsApp templates Meta approved, one per kind of notice and language.",
    "screen.notifications.templates.stat.approved": "Approved by Meta",
    "screen.notifications.templates.stat.waiting": "Not sendable yet",
    "screen.notifications.templates.stat.waiting.detail": "Draft, submitted, rejected or paused",
    "screen.notifications.templates.column.kind": "Notice",
    "screen.notifications.templates.column.locale": "Language",
    "screen.notifications.templates.column.provider_name": "Name at Meta",
    "screen.notifications.templates.column.language_code": "Meta language code",
    "screen.notifications.templates.column.status": "Status",
    "screen.notifications.templates.column.body": "Text submitted",
    "screen.notifications.templates.column.rules": "Rules sending on WhatsApp",
    "screen.notifications.templates.column.updated_at": "Changed",
    "screen.notifications.templates.column.link": "Opens in the app",
    "screen.notifications.templates.column.id": "Id",
    "screen.notifications.templates.action.edit": "Record Meta's answer",
    "screen.notifications.templates.field.provider_name": "Name at Meta",
    "screen.notifications.templates.field.provider_name.help": "Exactly as submitted: lower case, digits and underscores.",
    "screen.notifications.templates.field.language_code": "Meta language code",
    "screen.notifications.templates.field.status": "Meta's answer",
    "screen.notifications.templates.field.status.help": "Only an approved template is sent.",
    "value.template_language.ar": "Arabic (ar)",
    "value.template_language.en": "English (en)",
    "value.template_language.en_US": "English, US (en_US)",
    "value.template_language.en_GB": "English, UK (en_GB)",
    "value.template_status.draft": "Not submitted yet",
    "value.template_status.submitted": "Submitted, awaiting review",
    "value.template_status.approved": "Approved — may be sent",
    "value.template_status.rejected": "Rejected",
    "value.template_status.paused": "Paused by Meta",
    "notifications.refusal.rule.subject_shape": "\"{value}\" is not a payload field.",
    "notifications.refusal.rule.permission_without_subject": "A permission is asked of the person the event names; this rule names nobody.",
    "notifications.refusal.rule.subject_needs_permission": "Name what the person must be allowed to see to be told.",
    "notifications.refusal.rule.permission_shape": "\"{value}\" is not a permission key.",
    "notifications.refusal.consent.channel": "The bell is always kept, and WhatsApp is chosen on your person record; here, choose email or SMS.",
    "notifications.refusal.consent.choice": "Say yes or no.",
    "notifications.refusal.template.name_shape": "A WhatsApp template is named in lower case, digits and underscores.",
    "notifications.refusal.template.language_shape": "A language code as Meta writes it: ar, en, en_US.",
    "notifications.refusal.template.status": "A status Meta gives: submitted, approved, rejected or paused.",
    "notifications.refusal.template.not_found": "No such template.",
    "notifications.refusal.pack.unknown": "No pack \"{value}\" ships with this build, nor a recipe with a module this workspace has on.",
    "notifications.refusal.pack.nothing": "The recipe \"{value}\" ships nothing for notifications: its automation rules are imported in automation.",
    "notifications.refusal.recipe.identity_forbidden": "Identity did not let you read which modules this workspace has on.",
    "notifications.refusal.recipe.identity_unavailable": "Identity could not say which modules this workspace has on. Try again shortly.",
    "notifications.refusal.permissions_unavailable": "The permissions could not be checked right now. Try again shortly.",
    "notifications.refusal.rule.unknown_permission": "No module declares the permission \"{value}\".",
    "notifications.refusal.pack.invalid": "The pack \"{value}\" is not sound and cannot be imported. Tell the product team.",
    "notifications.refusal.workspace.id": "This is not a workspace.",
    "notifications.refusal.workspace.demo": "Choose whether the workspace is a demo.",
    "notifications.refusal.connection.demo_only": "A demo connection sends nothing, and only a workspace the platform marked as a demo may have one.",
    "webhooks.refusal.required": "{field} is required.",
    "webhooks.refusal.too_long": "At most {max} characters.",
    "webhooks.refusal.event_shape": "\"{value}\" is not an event name.",
    "webhooks.refusal.own_event": "A web hook cannot send the web hooks' own events.",
    "webhooks.refusal.url": "This is not a web address.",
    "webhooks.refusal.url_https": "Events are sent over https only.",
    "webhooks.refusal.url_credentials": "Remove the user name and password from the address: the signature proves who sends.",
    "webhooks.refusal.url_host": "Name the server by its host name, not by its number.",
    "webhooks.refusal.url_not_allowed": "{value} is not among the hosts this installation sends web hooks to.",
    "webhooks.refusal.condition_shape": "Write one condition per line: field = value.",
    "webhooks.refusal.condition_twice": "\"{value}\" is named twice.",
    "webhooks.refusal.too_many_conditions": "At most {max} conditions.",
    "webhooks.refusal.disable_after": "Between {min} and {max} failures in a row.",
    "webhooks.refusal.version": "Open the web hook again and retry.",
    "webhooks.refusal.stale": "Someone changed this since you opened it. Open it again.",
    "webhooks.refusal.not_found": "This web hook is not in this workspace.",
    "webhooks.refusal.delivery_not_found": "This delivery is not in this workspace.",
    "webhooks.refusal.delivery_not_failed": "Only a delivery that failed is sent again.",
    "webhooks.refusal.retired": "This web hook is retired and is not changed.",
    "webhooks.refusal.not_active": "Only a web hook that is on can be paused.",
    "webhooks.refusal.too_many": "At most {max} web hooks in a workspace: retire one first.",
    "webhooks.refusal.no_key": "This installation has no key to seal the web hook's signing key with. The operator sets it.",
    "notifications.refusal.webhook.handshake": "Not the verify token this installation set.",
    "notifications.refusal.webhook.signature": "The signature does not verify.",
    "screen.notifications.announcements.title": "Announcements",
    "screen.notifications.announcements.lede": "A message to everybody or to chosen roles, shown in each person's bell. Editing a published one makes a new version, and everybody reads it again.",
    "screen.notifications.announcements.stat.published": "Published",
    "screen.notifications.announcements.stat.draft": "Drafts",
    "screen.notifications.announcements.column.title": "Title",
    "screen.notifications.announcements.column.audience": "Audience",
    "screen.notifications.announcements.column.roles": "Roles",
    "screen.notifications.announcements.column.version": "Version",
    "screen.notifications.announcements.column.recipients": "Sent to",
    "screen.notifications.announcements.column.read": "Read",
    "screen.notifications.announcements.column.published_at": "Published",
    "screen.notifications.announcements.column.publication": "Status",
    "screen.notifications.announcements.column.body": "Text",
    "screen.notifications.announcements.column.id": "Id",
    "screen.notifications.announcements.action.create": "New announcement",
    "screen.notifications.announcements.action.edit": "Edit",
    "screen.notifications.announcements.action.publish": "Publish",
    "screen.notifications.announcements.action.withdraw": "Withdraw",
    "screen.notifications.announcements.field.title": "Title",
    "screen.notifications.announcements.field.body": "Text",
    "screen.notifications.announcements.field.body.help": "Changing a published announcement sends it again as a new version.",
    "screen.notifications.announcements.field.audience": "To",
    "screen.notifications.announcements.field.roles": "Roles",
    "screen.notifications.announcements.field.roles.help": "Only when it goes to chosen roles.",
    "screen.notifications.announcements.field.comments_allowed": "Members may comment",
    "screen.notifications.receipts.title": "Read receipts",
    "screen.notifications.receipts.lede": "Everybody each announcement's current version went to, and whether they have read it.",
    "screen.notifications.receipts.stat.read": "Read",
    "screen.notifications.receipts.stat.unread": "Not read yet",
    "screen.notifications.receipts.column.title": "Announcement",
    "screen.notifications.receipts.column.version": "Version",
    "screen.notifications.receipts.column.recipient": "Recipient",
    "screen.notifications.receipts.column.delivered_at": "Sent",
    "screen.notifications.receipts.column.read_at": "Read",
    "screen.notifications.receipts.column.receipt": "Receipt",
    "screen.notifications.receipts.column.publication": "Status",
    "screen.notifications.receipts.column.id": "Id",
    // platform · calendar
    "nav.calendar.year": "Year view",
    "nav.calendar.settings": "Calendar settings",
    "screen.calendar.occasions.stat.withdrawn": "Withdrawn",
    "screen.calendar.occasions.column.hijri_to": "Hijri to",
    "screen.calendar.occasions.column.pack": "From pack",
    "screen.calendar.occasions.column.location_ref": "Location",
    "screen.calendar.occasions.column.can_approve": "Can approve",
    "screen.calendar.occasions.column.can_withdraw": "Can withdraw",
    "screen.calendar.occasions.action.import": "Import a year",
    "screen.calendar.occasions.action.import.field.pack": "Pack",
    "screen.calendar.occasions.action.import.field.year": "Year",
    "screen.calendar.occasions.action.import.field.year.help": "The Gregorian year. Every date arrives awaiting approval, computed from the table: check each against the announcement before somebody else approves it.",
    "screen.calendar.occasions.action.withdraw.field.reason.help": "Kept with the occasion and sent to every module that read the dates.",
    "screen.calendar.settings.title": "Calendar settings",
    "screen.calendar.settings.section.dates": "Dates and time",
    "screen.calendar.settings.section.dates.lede": "How Hijri dates are converted and shown, and which day “today” is.",
    "screen.calendar.settings.section.workweek": "Working week",
    "screen.calendar.settings.section.workweek.lede": "The days off and the hours a working day runs.",
    "screen.calendar.settings.lede": "How Hijri dates are converted and shown, and which time zone the days are counted in.",
    "screen.calendar.settings.column.hijri_reference": "Hijri reference",
    "screen.calendar.settings.column.hijri_display": "Hijri date on screens",
    "screen.calendar.settings.column.time_zone": "Time zone",
    "screen.calendar.settings.column.today": "Today there",
    "screen.calendar.settings.column.version": "Version",
    "screen.calendar.settings.action.edit": "Change",
    "screen.calendar.settings.field.hijri_reference": "Hijri reference",
    "screen.calendar.settings.field.hijri_reference.help": "Used when a date is converted: a pack’s import, an occasion typed without its Hijri date, the year view.",
    "screen.calendar.settings.field.hijri_display": "Hijri date on screens",
    "screen.calendar.settings.field.time_zone": "Time zone",
    "screen.calendar.settings.field.time_zone.help": "Decides which day “today” is for every date in the workspace.",
    "screen.calendar.year.title": "Year view",
    "screen.calendar.year.lede": "The year month by month, each with the Hijri months it spans, and every occasion in it — approved, or still waiting for somebody to approve it.",
    "value.hijri_reference.umm_al_qura": "Umm al-Qura table",
    "value.hijri_reference.tabular": "Tabular (arithmetical)",
    "value.hijri_display.inline": "Beside the Gregorian date",
    "value.hijri_display.tooltip": "On hover only",
    "value.kind.ramadan": "Ramadan",
    "value.kind.eid_fitr": "Eid al-Fitr",
    "value.kind.eid_adha": "Eid al-Adha",
    "value.kind.national_day": "National Day",
    "value.kind.founding_day": "Founding Day",
    "value.kind.season": "Local season",
    "value.kind.custom": "Other",
    "value.scope.all": "The whole workspace",
    "value.scope.location": "One location",
    "calendar.hijri.month.1": "Muharram",
    "calendar.hijri.month.2": "Safar",
    "calendar.hijri.month.3": "Rabi al-Awwal",
    "calendar.hijri.month.4": "Rabi al-Thani",
    "calendar.hijri.month.5": "Jumada al-Ula",
    "calendar.hijri.month.6": "Jumada al-Akhirah",
    "calendar.hijri.month.7": "Rajab",
    "calendar.hijri.month.8": "Shaban",
    "calendar.hijri.month.9": "Ramadan",
    "calendar.hijri.month.10": "Shawwal",
    "calendar.hijri.month.11": "Dhu al-Qadah",
    "calendar.hijri.month.12": "Dhu al-Hijjah",
    "calendar.year.previous": "Previous year",
    "calendar.year.next": "Next year",
    "calendar.year.title_of": "The year {year}",
    "calendar.year.approved_count": "{n} approved",
    "calendar.year.proposed_count": "{n} awaiting approval",
    "calendar.year.this_month": "This month",
    "calendar.year.month_empty": "No occasions.",
    "calendar.year.empty.title": "Nothing planned for this year",
    "calendar.year.empty.description": "Import the year from a pack on the Occasions screen, or add an occasion there. Each arrives awaiting approval.",
    "calendar.year.location": "Only at {ref}",
    "calendar.year.status.proposed": "Awaiting approval",
    "calendar.year.status.approved": "Approved",
    "platform.refusal.calendar.required": "This is required.",
    "platform.refusal.calendar.too_long": "This is longer than {max} characters.",
    "platform.refusal.calendar.key_shape": "A key is lower-case letters, digits, dash or underscore, starting with a letter.",
    "platform.refusal.calendar.key_taken": "That key is already an occasion in this workspace.",
    "platform.refusal.calendar.kind": "Choose one of the kinds offered.",
    "platform.refusal.calendar.day": "Write the day as YYYY-MM-DD, and a day that exists.",
    "platform.refusal.calendar.hijri_day": "Write the Hijri date as YYYY-MM-DD, month 1–12 and day 1–30.",
    "platform.refusal.calendar.range": "The last day cannot be before the first.",
    "platform.refusal.calendar.span": "An occasion lasts at most {max} days.",
    "platform.refusal.calendar.range_too_wide": "Ask for at most {max} days at once.",
    "platform.refusal.calendar.scope": "It applies to the whole workspace or to one location.",
    "platform.refusal.calendar.location_needed": "An occasion for one location names it.",
    "platform.refusal.calendar.location_not_allowed": "An occasion for the whole workspace names no location.",
    "platform.refusal.calendar.time_zone": "That is not a time zone this server knows. Use a name such as Africa/Cairo, or UTC.",
    "platform.refusal.calendar.reference": "Choose the Umm al-Qura table or the tabular calendar.",
    "platform.refusal.calendar.display": "Choose beside the date, or on hover only.",
    "platform.refusal.calendar.language": "Choose Arabic or English.",
    "platform.refusal.calendar.year": "That year is outside the years this calendar covers.",
    "platform.refusal.calendar.pack": "No such pack ships with this installation.",
    "platform.refusal.calendar.already_approved": "This occasion is already approved.",
    "platform.refusal.calendar.withdrawn": "This occasion was withdrawn. Edit it to propose it again.",
    "platform.refusal.calendar.own_proposal": "Whoever proposed these dates does not approve them. Another approver does.",
    "platform.refusal.calendar.stale": "The settings changed since you opened them. Reload and try again.",
    "platform.refusal.calendar.not_found": "No such occasion here.",
    // platform · forms — the form builder, and the shared field validator (packages/fields)
    "nav.module.forms": "Forms",
    "nav.forms.my_requests": "My requests",
    "nav.forms.requests": "Requests",
    "nav.forms.catalogue": "Request forms",
    "nav.forms.builder": "Form builder",
    "screen.forms.catalogue.title": "Request forms",
    "screen.forms.catalogue.lede": "The forms this workspace has built, one row per revision.",
    "screen.forms.catalogue.stat.published": "Published",
    "screen.forms.catalogue.stat.draft": "Drafts",
    "screen.forms.catalogue.stat.open_requests": "Open requests",
    "screen.forms.catalogue.column.name_ar": "Form",
    "screen.forms.catalogue.column.name_en": "Name (English)",
    "screen.forms.catalogue.column.key": "Key",
    "screen.forms.catalogue.column.revision": "Revision",
    "screen.forms.catalogue.column.status": "Status",
    "screen.forms.catalogue.column.audience": "For",
    "screen.forms.catalogue.column.fields": "Fields",
    "screen.forms.catalogue.column.steps": "Steps",
    "screen.forms.catalogue.column.open_requests": "Open",
    "screen.forms.catalogue.column.published_at": "Published",
    "screen.forms.catalogue.column.category": "Category",
    "screen.forms.catalogue.column.updated_at": "Changed",
    "screen.forms.catalogue.column.can_publish": "Can publish",
    "screen.forms.catalogue.column.can_revise": "Can revise",
    "screen.forms.catalogue.column.can_archive": "Can archive",
    "screen.forms.catalogue.column.id": "Id",
    "screen.forms.catalogue.action.create": "New form",
    "screen.forms.catalogue.action.create.field.key": "Key",
    "screen.forms.catalogue.action.create.field.key.help": "Lower-case letters, digits and underscores. It never changes: a module that acts on this form's approvals matches on it.",
    "screen.forms.catalogue.action.create.field.name_ar": "Name (Arabic)",
    "screen.forms.catalogue.action.create.field.name_en": "Name (English)",
    "screen.forms.catalogue.action.builder": "Open the builder",
    "screen.forms.catalogue.action.publish": "Publish",
    "screen.forms.catalogue.action.revise": "Edit as a new revision",
    "screen.forms.catalogue.action.archive": "Close to new requests",
    "screen.forms.requests.title": "Requests",
    "screen.forms.requests.lede": "Every request submitted through a built form, those waiting on your decision first. Open one to read it as it was submitted and decide your step.",
    "screen.forms.requests.stat.mine_to_decide": "Waiting on you",
    "screen.forms.requests.stat.overdue": "Past their hours",
    "screen.forms.requests.stat.sent_back": "With the submitter",
    "screen.forms.requests.stat.approved": "Approved",
    "screen.forms.requests.column.number": "No.",
    "screen.forms.requests.column.form_ar": "Form",
    "screen.forms.requests.column.status": "Status",
    "screen.forms.requests.column.step_ar": "Waiting on",
    "screen.forms.requests.column.submitted_by": "Submitted by",
    "screen.forms.requests.column.submitted_at": "Submitted",
    "screen.forms.requests.column.due_at": "Decide by",
    "screen.forms.requests.column.decided_at": "Decided",
    "screen.forms.requests.column.form_en": "Form (English)",
    "screen.forms.requests.column.definition_key": "Form",
    "screen.forms.requests.column.definition_revision": "Revision",
    "screen.forms.requests.column.approver_role": "Decided by role",
    "screen.forms.requests.column.overdue": "Overdue",
    "screen.forms.requests.column.can_decide": "Yours to decide",
    "screen.forms.requests.column.id": "Id",
    "screen.forms.requests.action.decide": "Decide",
    "screen.forms.requests.action.open": "Open",
    "screen.forms.builder.title": "Form builder",
    "screen.forms.builder.lede": "Sections and fields on one side, what the selected field asks on the other, the approval path under them, and the form as its audience will see it beside everything.",
    "screen.forms.my_requests.title": "My requests",
    "screen.forms.my_requests.lede": "The forms that are for you, and what became of every request you sent: where it waits, what was decided, and what was sent back for you to correct.",
    "value.forms_request.submitted": "Awaiting a decision",
    "value.forms_request.sent_back": "Sent back to you",
    "value.forms_request.approved": "Approved",
    "value.forms_request.rejected": "Refused",
    "value.forms_request.withdrawn": "Withdrawn",
    "value.forms_definition.draft": "Draft",
    "value.forms_definition.published": "Published",
    "value.forms_definition.archived": "Archived",
    "forms.ref.hint.employee_ref": "The employee's reference as HR shows it.",
    "forms.ref.hint.location_ref": "The work location's reference as HR shows it.",
    "forms.ref.hint.attachment": "The reference of a document already filed in Documents.",
    "forms.ref.gap.employee_ref": "Typed as a reference for now: this unit cannot read HR, so the choice list arrives when HR offers a lookup the shell can call.",
    "forms.ref.gap.location_ref": "Typed as a reference for now: this unit cannot read HR's locations, so the choice list arrives with a lookup HR offers.",
    "forms.ref.gap.attachment": "A reference to a document for now: uploading from the form arrives when Documents takes uploads.",
    "forms.datetime.time": "Time",
    "forms.yes": "Yes",
    "forms.no": "No",
    "forms.step.by_role": "Decided by a holder of {role}",
    "forms.step.by_manager": "Decided by the submitter's manager",
    "forms.approver.role": "A role",
    "forms.approver.manager_of_submitter": "The submitter's manager",
    "forms.review.no_row": "Open a request from the list.",
    "forms.review.submitted_by": "Submitted by",
    "forms.review.submitted_at": "Submitted",
    "forms.review.revision": "Form and revision",
    "forms.review.may_edit": "This step may correct what was submitted before approving it; what you change is recorded.",
    "forms.review.history": "What happened",
    "forms.review.reason": "Reason",
    "forms.review.reason.hint": "Required to send back or refuse: it is what the submitter reads.",
    "forms.review.approve": "Approve",
    "forms.review.return": "Send back",
    "forms.review.reject": "Refuse",
    "forms.review.own": "You submitted this request, so you do not decide it.",
    "forms.history.submit": "Submitted by {actor}",
    "forms.history.resubmit": "Sent again by {actor}",
    "forms.history.approve": "Step {step} approved by {actor}",
    "forms.history.return": "Sent back at step {step} by {actor}",
    "forms.history.reject": "Refused at step {step} by {actor}",
    "forms.history.withdraw": "Withdrawn by {actor}",
    "forms.history.changed": "changed {fields}",
    "forms.submit": "Submit",
    "forms.resubmit": "Send again",
    "forms.submit.fix": "Some answers need correcting — each is marked where it is.",
    "forms.submit.done": "Request {number} is sent.",
    "forms.withdraw.done": "Request {number} is withdrawn.",
    "forms.withdraw.title": "Withdraw request {number}?",
    "forms.withdraw.lede": "It stays in your list, marked withdrawn, and nothing comes of it.",
    "forms.mine.available": "Forms for you",
    "forms.mine.available.lede": "What you can ask for here without writing to anyone.",
    "forms.mine.none_available": "No form is for you yet",
    "forms.mine.none_available.lede": "A form appears here once it is published for a role you hold.",
    "forms.mine.fill": "Fill in",
    "forms.mine.steps": "{count} approval steps",
    "forms.mine.sent": "What you sent",
    "forms.mine.none_sent": "You have not sent a request yet",
    "forms.mine.waiting_on": "Waiting on: {step}",
    "forms.mine.returned_because": "Sent back to you: {reason}",
    "forms.mine.open": "Open",
    "forms.mine.correct": "Correct and send again",
    "forms.mine.correct.lede": "The form as it was when you first sent it.",
    "forms.mine.withdraw": "Withdraw",
    "forms.builder.form": "Form",
    "forms.builder.choose": "Choose a form",
    "forms.builder.revision": "Revision {n}",
    "forms.builder.unsaved": "Not saved",
    "forms.builder.refresh_roles": "Refresh roles",
    "forms.builder.roles_refreshed": "Who holds which role is up to date: {n} members.",
    "forms.builder.holders": "{n} holding it",
    "forms.builder.new": "New form",
    "forms.builder.publish": "Publish",
    "forms.builder.revise": "Edit as a new revision",
    "forms.builder.saved": "Saved.",
    "forms.builder.refused": "Not saved: {n} things to correct.",
    "forms.builder.published": "Published as revision {revision}. Its audience sees it now.",
    "forms.builder.not_publishable": "Not published: {n} things are missing.",
    "forms.builder.frozen": "This revision is {status} and is read here, not edited. Edit it as a new revision.",
    "forms.builder.discard": "Leave this form without saving?",
    "forms.builder.discard.lede": "The changes made since the last save are lost.",
    "forms.builder.discard.confirm": "Leave without saving",
    "forms.builder.empty": "No form yet",
    "forms.builder.empty.lede": "Start one: a key, a name in both languages, then its fields and who decides it.",
    "forms.builder.key": "Key",
    "forms.builder.key.help": "Lower-case letters, digits and underscores; it never changes.",
    "forms.builder.field_key.help": "What the approved event names this answer by.",
    "forms.builder.name_ar": "Name (Arabic)",
    "forms.builder.name_en": "Name (English)",
    "forms.builder.header": "The form",
    "forms.builder.description_ar": "Description (Arabic)",
    "forms.builder.description_en": "Description (English)",
    "forms.builder.category": "Category",
    "forms.builder.icon": "Mark",
    "forms.builder.audience": "Who it is for",
    "forms.builder.audience.hint": "Anyone holding one of these roles sees it and may submit it.",
    "forms.builder.no_roles": "Who holds which role is not known here yet — refresh roles.",
    "forms.builder.structure": "Sections and fields",
    "forms.builder.structure.lede": "In the order the form is read. Pick a field to say what it asks.",
    "forms.builder.add_section": "Add a section",
    "forms.builder.add_field": "Add a field",
    "forms.builder.new_field": "Field {n}",
    "forms.builder.new_section": "Section {n}",
    "forms.builder.option": "Option {n}",
    "forms.builder.no_fields": "No field yet",
    "forms.builder.no_fields.lede": "Add the first one from “Add a field”.",
    "forms.builder.remove_section": "Remove this section",
    "forms.builder.label_ar": "Label (Arabic)",
    "forms.builder.label_en": "Label (English)",
    "forms.builder.has_problem": "To correct",
    "forms.builder.conditional": "Conditional",
    "forms.builder.up": "Move up",
    "forms.builder.down": "Move down",
    "forms.builder.remove_field": "Remove this field",
    "forms.builder.conditions_cleared": "{n} fields shown only on the removed field are now always shown.",
    "forms.builder.move_breaks_condition": "A field shown on a condition sits below the field it depends on; this move would put it above.",
    "forms.builder.inspector": "The selected field",
    "forms.builder.pick_field": "Pick a field on the left to say what it asks.",
    "forms.builder.type": "Type",
    "forms.builder.help_ar": "Help (Arabic)",
    "forms.builder.help_en": "Help (English)",
    "forms.builder.section": "Section",
    "forms.builder.required": "Required",
    "forms.builder.options": "Choices",
    "forms.builder.add_option": "Add a choice",
    "forms.builder.remove_option": "Remove this choice",
    "forms.builder.option_value": "Value",
    "forms.builder.visible_when": "Shown",
    "forms.builder.visible_when.hint": "Only when an earlier answer equals a value — nothing more elaborate.",
    "forms.builder.always": "Always",
    "forms.builder.equals": "When it is",
    "forms.builder.steps": "Approval path",
    "forms.builder.steps.lede": "Each step is decided by a holder of its role, never by whoever submitted the request.",
    "forms.builder.add_step": "Add a step",
    "forms.builder.remove_step": "Remove this step",
    "forms.builder.approver_kind": "Decided by",
    "forms.builder.approver_role": "Role",
    "forms.builder.sla_hours": "Hours",
    "forms.builder.may_return": "Sends back",
    "forms.builder.may_edit": "Corrects",
    "forms.builder.preview": "As it will be seen",
    "forms.builder.preview.lede": "Drawn by the component its audience fills it in through, from this draft as it stands.",
    "forms.builder.as_submitter": "As a submitter",
    "forms.builder.as_approver": "As an approver",
    "forms.builder.unnamed_step": "Step {n}",
    "forms.builder.no_steps": "No approval step yet",
    "forms.builder.clear_preview": "Clear",
    "forms.builder.check": "Check as if submitted",
    "forms.builder.check_ok": "These answers would be accepted.",
    "forms.builder.check_refused": "{n} answers would be refused — each is marked.",
    "forms.icon.file": "File",
    "forms.icon.clipboard": "Clipboard",
    "forms.icon.calendar": "Calendar",
    "forms.icon.user": "Person",
    "forms.icon.users": "People",
    "forms.icon.star": "Star",
    "forms.icon.shield": "Shield",
    "forms.icon.tag": "Tag",
    "forms.icon.clock": "Clock",
    "forms.icon.check": "Check",
    "forms.icon.globe": "Globe",
    "forms.icon.settings": "Settings",
    "forms.type.text": "Short text",
    "forms.type.textarea": "Long text",
    "forms.type.number": "Number",
    "forms.type.money": "Amount",
    "forms.type.date": "Date",
    "forms.type.datetime": "Date and time",
    "forms.type.select": "One choice",
    "forms.type.multiselect": "Several choices",
    "forms.type.boolean": "Yes / no",
    "forms.type.employee_ref": "An employee",
    "forms.type.location_ref": "A work location",
    "forms.type.attachment": "An attachment",
    "forms.rule.min": "At least",
    "forms.rule.max": "At most",
    "forms.rule.min_count": "Choose at least",
    "forms.rule.max_count": "Choose at most",
    "forms.rule.min_length": "Shortest (characters)",
    "forms.rule.max_length": "Longest (characters)",
    "forms.rule.pattern": "Pattern",
    "forms.rule.integer": "Whole numbers only",
    "forms.refusal.required": "{field} is required.",
    "forms.refusal.too_long": "At most {max} characters.",
    "forms.refusal.version_shape": "The version read is a whole number.",
    "forms.refusal.stale": "Somebody changed this since you opened it; open it again.",
    "forms.refusal.own_permission": "A form declares no permission of its own: who may use it is the forms permissions and its audience of roles.",
    "forms.refusal.key_shape": "A key is lower-case letters, digits and underscores, starting with a letter.",
    "forms.refusal.key_taken": "A form with this key already exists.",
    "forms.refusal.draft_exists": "This form already has a draft; open it.",
    "forms.refusal.steps_shape": "The approval path is a list of steps.",
    "forms.refusal.too_many_steps": "At most {max} steps.",
    "forms.refusal.step_name_required": "Step {step} needs a name in both languages.",
    "forms.refusal.approver_kind": "That is not a kind of approver.",
    "forms.refusal.approver_role": "Step {step} is decided by a role: name it.",
    "forms.refusal.sla_hours": "Hours to decide are a whole number from {min} to {max}.",
    "forms.refusal.audience_shape": "The audience is a list of roles.",
    "forms.refusal.audience_unsupported": "An audience by {by} needs a module this unit cannot ask yet; roles only.",
    "forms.refusal.role_key": "“{role}” is not a role key.",
    "forms.refusal.too_many_roles": "At most {max} roles.",
    "forms.refusal.publish_no_field": "A form needs at least one field before it is published.",
    "forms.refusal.publish_no_step": "A form needs an approval path — at least one step — before it is published.",
    "forms.refusal.publish_no_audience": "A form needs an audience — at least one role it is for — before it is published.",
    "forms.refusal.manager_unresolvable": "Step {step}: the submitter's manager cannot be resolved here yet — it needs the reporting line and a link from a user to an employment.",
    "forms.refusal.roles_unknown": "Who holds which role is not known here yet; refresh roles first.",
    "forms.refusal.role_unheld": "Nobody holds the role “{role}”, so step {step} could never be decided.",
    "forms.refusal.no_form": "No such form.",
    "forms.refusal.definition_frozen": "A {status} revision is not edited in place; edit it as a new revision.",
    "forms.refusal.icon": "That is not a mark the screen draws.",
    "forms.refusal.document_type_key": "A document type key is lower-case letters, digits, dot, dash or underscore.",
    "forms.refusal.not_draft": "Only a draft is published.",
    "forms.refusal.not_published": "Only a published revision is closed.",
    "forms.refusal.already_draft": "This revision is a draft already; edit it.",
    "forms.refusal.roles_forbidden": "Identity refused to say who holds which role: it needs permission to view members.",
    "forms.refusal.roles_unavailable": "Identity did not answer; try again shortly.",
    "forms.refusal.form_revised": "This form was changed since you opened it; open it again.",
    "forms.refusal.form_closed": "This form no longer takes requests.",
    "forms.refusal.not_in_audience": "This form is not for you.",
    "forms.refusal.not_yours": "Only the person who submitted a request does this.",
    "forms.refusal.decided": "This request is decided and can no longer be withdrawn.",
    "forms.refusal.not_returned": "Only a request sent back to you is sent again.",
    "forms.refusal.no_request": "No such request.",
    "forms.refusal.not_waiting": "Nothing on this request waits for a decision.",
    "forms.refusal.own_request": "Whoever submitted a request never decides it.",
    "forms.refusal.not_your_step": "This step is decided by a holder of “{role}”.",
    "forms.refusal.reason_required": "Say why — it is what the person who submitted it reads.",
    "forms.refusal.return_not_allowed": "This step does not send requests back; approve or refuse.",
    "forms.refusal.edit_not_allowed": "This step does not change what was submitted.",
    "fields.refusal.sections_shape": "A section has a key and a label in both languages.",
    "fields.refusal.too_many_sections": "At most {max} sections.",
    "fields.refusal.key_shape": "A key is lower-case letters, digits and underscores, starting with a letter, at most {max}.",
    "fields.refusal.key_taken": "“{key}” is used twice.",
    "fields.refusal.label_required": "A label is needed in both Arabic and English.",
    "fields.refusal.label_too_long": "A label is at most {max} characters.",
    "fields.refusal.rule_shape": "This rule is not written the way it is read.",
    "fields.refusal.rule_not_allowed": "A {type} field takes no “{rule}” rule.",
    "fields.refusal.pattern_invalid": "This pattern is not a regular expression.",
    "fields.refusal.rule_range": "The lower bound is above the upper one.",
    "fields.refusal.options_shape": "A choice has a value and a label in both languages.",
    "fields.refusal.options_not_allowed": "A {type} field has no choices.",
    "fields.refusal.options_required": "A choice field needs at least one choice.",
    "fields.refusal.too_many_options": "At most {max} choices.",
    "fields.refusal.option_value_shape": "A choice's value is letters, digits, space, dot, dash or underscore, at most 64.",
    "fields.refusal.option_duplicate": "The choice “{value}” is listed twice.",
    "fields.refusal.fields_shape": "The fields are a list.",
    "fields.refusal.too_many_fields": "A form has at most {max} fields.",
    "fields.refusal.type_unknown": "“{type}” is not a field type the screen draws.",
    "fields.refusal.section_unknown": "There is no section “{section}”.",
    "fields.refusal.section_required": "A form laid out in sections puts every field in one.",
    "fields.refusal.help_too_long": "Help is at most {max} characters.",
    "fields.refusal.visible_when_shape": "A condition names one field and the value it must equal.",
    "fields.refusal.visible_when_self": "A field cannot depend on itself.",
    "fields.refusal.visible_when_unknown": "“{field}” is not a field above this one.",
    "fields.refusal.visible_when_type": "A condition compares a choice, a yes/no, a text or a number — “{field}” is a {type}.",
    "fields.refusal.visible_when_value": "That value is not one “{field}” can hold.",
    "fields.refusal.default_invalid": "The default would itself be refused.",
    "fields.refusal.not_text": "This is not text.",
    "fields.refusal.too_short": "At least {min} characters.",
    "fields.refusal.too_long": "At most {max} characters.",
    "fields.refusal.pattern": "This is not written the way the form asks.",
    "fields.refusal.not_number": "This is not a number.",
    "fields.refusal.not_integer": "A whole number.",
    "fields.refusal.below_min": "At least {min}.",
    "fields.refusal.above_max": "At most {max}.",
    "fields.refusal.not_money": "This is not an amount.",
    "fields.refusal.money_places": "At most {places} decimal places.",
    "fields.refusal.not_date": "A day, written YYYY-MM-DD.",
    "fields.refusal.before_min": "On or after {min}.",
    "fields.refusal.after_max": "On or before {max}.",
    "fields.refusal.not_datetime": "A day and a time.",
    "fields.refusal.not_choice": "This is not one of the choices.",
    "fields.refusal.not_choices": "These are not all among the choices.",
    "fields.refusal.too_few": "Choose at least {min}.",
    "fields.refusal.too_many": "Choose at most {max}.",
    "fields.refusal.not_boolean": "Yes or no.",
    "fields.refusal.not_reference": "This is not a reference.",
    "fields.refusal.values_shape": "The answers are sent as an object keyed by field.",
    "fields.refusal.unknown_field": "This form has no field “{field}”.",
    "fields.refusal.required": "This field is required.",
    "fields.refusal.must_confirm": "This has to be ticked.",
    // platform · documents
    'nav.documents.owner': "Documents by owner",
    'nav.documents.types': "Document types",
    'value.status.valid': "Valid",
    'value.status.expiring': "Ending soon",
    'value.owner_kind.party': "A party",
    'value.owner_kind.company': "The company",
    'value.applies_to.party': "A party",
    'value.applies_to.company': "The company",
    'value.retention_category.identity': "Identity document",
    'value.retention_category.licence': "Licence or permit",
    'value.retention_category.contract': "Contract",
    'value.retention_category.personnel': "Personnel record",
    'value.retention_category.qualification': "Qualification",
    'value.retention_category.regulation': "Regulation or policy",
    'value.retention_category.corporate': "Company record",
    'value.retention_category.general': "General",
    'documents.items.title': "Documents",
    'documents.items.lede': "Every document the workspace keeps, whose it is, and when it stops being valid. An end date changes only by renewing with the new copy.",
    'documents.items.stat.valid': "Valid",
    'documents.items.stat.expiring': "Ending soon",
    'documents.items.stat.expired': "Expired — to renew",
    'documents.items.col.type': "Document",
    'documents.items.col.type_name_en': "Document (English)",
    'documents.items.col.owner': "Owner",
    'documents.items.col.owner_kind': "Whose",
    'documents.items.col.owner_ref': "Owner reference",
    'documents.items.col.number': "Number",
    'documents.items.col.expires_on': "Ends on",
    'documents.items.col.days_left': "Days left",
    'documents.items.col.status': "Validity",
    'documents.items.col.version_no': "Version",
    'documents.items.col.file_name': "Copy",
    'documents.items.col.title': "Title",
    'documents.items.col.citation': "Cited as",
    'documents.items.col.issued_on': "Issued on",
    'documents.items.col.keep_until': "Kept until",
    'documents.items.col.created_at': "Filed",
    'documents.items.col.record_status': "Record",
    'documents.items.col.is_regulation': "Regulation",
    'documents.items.col.id': "Id",
    'documents.items.action.attach': "Attach a document",
    'documents.items.action.regulation': "New regulation",
    'documents.items.action.renew': "Renew",
    'documents.items.action.new_version': "New version",
    'documents.items.action.edit': "Edit details",
    'documents.items.action.withdraw': "Withdraw",
    'documents.items.field.type_id': "Type",
    'documents.items.field.type_key.regulation': "Regulation",
    'documents.items.field.owner_kind': "Whose",
    'documents.items.field.owner_kind.party': "A person or organisation",
    'documents.items.field.owner_kind.company': "The company",
    'documents.items.field.owner_ref': "Owner reference",
    'documents.items.field.owner_ref.help': "Written module.entity:id — for example parties.party:01J… or employees.employment:01J…. Leave empty for the company.",
    'documents.items.field.owner_label': "Owner's name",
    'documents.items.field.owner_label.help': "How the owner is shown in this register.",
    'documents.items.field.number': "Number",
    'documents.items.field.issued_on': "Issued on",
    'documents.items.field.expires_on': "Ends on",
    'documents.items.field.expires_on.help': "Required when the type expires.",
    'documents.items.field.new_expires_on': "New end date",
    'documents.items.field.file': "The copy",
    'documents.items.field.file.help': "A PDF, an image or a Word file, up to 10 MB.",
    'documents.items.field.new_file': "The new copy",
    'documents.items.field.new_file.help': "A renewal is accepted only with the new copy.",
    'documents.items.field.title': "Title",
    'documents.items.field.notes': "Notes",
    'documents.items.field.ref_key': "Key",
    'documents.items.field.ref_key.help': "What other modules cite it by, with its version: penalties becomes penalties@1. Lower-case letters, digits and underscores.",
    'documents.items.field.decision_number': "Decision number",
    'documents.items.field.effective_on': "In force from",
    'documents.items.field.reason': "Why",
    'documents.items.field.reason.help': "The document is kept, with who withdrew it and why.",
    'documents.types.title': "Document types",
    'documents.types.lede': "The kinds of document this workspace keeps: whose each is, whether it ends, when to be told before it does, and how long it is kept once it no longer counts.",
    'documents.types.col.name_ar': "Type",
    'documents.types.col.name_en': "Name (English)",
    'documents.types.col.key': "Key",
    'documents.types.col.applies_to': "Whose",
    'documents.types.col.expires': "Ends",
    'documents.types.col.alerts': "Alert days before the end",
    'documents.types.col.retention_category': "Kept as",
    'documents.types.col.retention_years': "Years kept after",
    'documents.types.col.legal_hold': "Legal hold",
    'documents.types.col.documents': "Documents",
    'documents.types.col.status': "Status",
    'documents.types.col.builtin': "Supplied by the platform",
    'documents.types.col.id': "Id",
    'documents.types.action.create': "New type",
    'documents.types.action.edit': "Edit",
    'documents.types.action.retire': "Stop using",
    'documents.types.field.name_ar': "Name (Arabic)",
    'documents.types.field.name_en': "Name (English)",
    'documents.types.field.key': "Key",
    'documents.types.field.key.help': "What other modules name this type by. Lower-case letters, digits and underscores; it does not change.",
    'documents.types.field.applies_to': "Whose",
    'documents.types.field.expires': "It has an end date",
    'documents.types.field.alert_days': "Alert days before the end",
    'documents.types.field.alert_days.help': "Tick the days before the expiry to be reminded on, each said once. Left untouched, 90, 60 and 30 apply; untick them all for no reminders.",
    'documents.types.field.retention_category': "Kept as",
    'documents.types.field.retention_years': "Years kept after it stops counting",
    'documents.types.field.retention_years.help': "Counted from when it is renewed, withdrawn or expires. Nothing is kept forever by default.",
    'documents.types.field.legal_hold': "Legal hold",
    'documents.types.field.legal_hold.help': "While on, no document of this type is destroyed, whatever its retention says.",
    'documents.owner.title': "Documents by owner",
    'documents.owner.lede': "Everything one person, organisation or the company holds: what is valid, what ends soon, and what needs renewing — with the copy of each.",
    'documents.owner.pick': "Whose documents",
    'documents.owner.pick.hint': "Everyone the register holds documents for, and the company. Somebody with none yet can be typed by reference.",
    'documents.owner.pick.placeholder': "Type a name or a reference",
    'documents.owner.pick.none': "Nobody by that name holds a document",
    'documents.owner.pick.by_reference': "Open \"{ref}\"",
    'documents.owner.pick.reference_shape': "A reference is written module.entity:id, for example employees.employment:01J…",
    'documents.owner.owner': "Owner",
    'documents.owner.company': "The company",
    'documents.owner.counts': "{documents} documents · {expiring} ending soon · {expired} expired",
    'documents.owner.empty.title': "Choose whose documents to see",
    'documents.owner.empty.description': "Pick a person, an organisation or the company above.",
    'documents.owner.none': "No documents yet",
    'documents.owner.attach': "Attach a document",
    'documents.owner.attach.title': "Attach a document",
    'documents.owner.attach.submit': "Attach",
    'documents.owner.attach.type_placeholder': "Choose a type",
    'documents.owner.attach.no_types': "No document type applies to this owner yet. Add one under Document types.",
    'documents.owner.attach.no_end': "This type does not end.",
    'documents.owner.attached': "Attached. Its alerts start from its end date.",
    'documents.owner.renew': "Renew",
    'documents.owner.renew.title': "Renew with the new copy",
    'documents.owner.renew.description': "The current version is kept, linked to this one. A new end date is accepted only with the new copy.",
    'documents.owner.renew.submit': "Renew",
    'documents.owner.renew.was': "It ended on {date}.",
    'documents.owner.renewed': "Renewed. The previous version is kept with it.",
    'documents.owner.new_version': "New version",
    'documents.owner.open': "Open the copy",
    'documents.owner.open_failed': "The copy could not be opened",
    'documents.owner.cancel': "Cancel",
    'documents.owner.ends_in': "Ends on {date} — {days} days left",
    'documents.owner.ended': "Ended on {date} — {days} days ago",
    'documents.owner.ends_on': "Ended on {date}",
    'documents.owner.no_end': "No end date",
    'documents.owner.in_force_from': "In force from {date}",
    'documents.owner.version': "version {n}",
    'documents.refusal.required': "{field} is required.",
    'documents.refusal.too_long': "{field} is longer than {max} characters.",
    'documents.refusal.date': "{field} must be a date written YYYY-MM-DD.",
    'documents.refusal.boolean': "{field} is yes or no.",
    'documents.refusal.alert_days': "Alert days are whole numbers from 1 to 365, such as 90, 60, 30.",
    'documents.refusal.owner_kind': "The owner is a person or organisation, or the company.",
    'documents.refusal.owner_ref_shape': "The owner is written module.entity:id, for example parties.party:01J…",
    'documents.refusal.file_type': "A document's copy is a PDF, an image or a Word file.",
    'documents.refusal.within': "Count the days ahead in whole days, from 1 to 365.",
    'documents.establishment_documents.title': "Establishment documents",
    'documents.establishment_documents.col.expired': "Expired",
    'documents.establishment_documents.col.expiring': "End within 30 days",
    'documents.establishment_documents.link': "Documents",
    'documents.refusal.file_empty': "The file is empty.",
    'documents.refusal.file_too_large': "The file is larger than {max_mb} MB.",
    'documents.refusal.file_required': "The end date changes only with the new copy of the document. Attach it.",
    'documents.refusal.file_same': "That is the copy the current version already has. A renewal carries the new one.",
    'documents.refusal.file_in_use': "That file is already the copy of another document.",
    'documents.refusal.media_missing': "There is no such file in this workspace.",
    'documents.refusal.media_refused': "The file store did not accept the file: {reason}",
    'documents.refusal.media_forbidden': "You may not upload or read files here. Ask for the files permission.",
    'documents.refusal.media_unavailable': "The file store did not answer. Nothing was saved; try again.",
    'documents.refusal.stale': "Somebody changed this since you opened it. Read it again.",
    'documents.refusal.conflict': "Another change got there first. Read it again.",
    'documents.refusal.retention_category': "That is not a retention category.",
    'documents.refusal.retention_years': "Keep it for a whole number of years from 1 to 100. Nothing is kept forever by default.",
    'documents.refusal.type_key_shape': "A key is lower-case letters, digits and underscores, starting with a letter.",
    'documents.refusal.type_key_taken': "The key {key} already names a type.",
    'documents.refusal.type_not_found': "No such document type.",
    'documents.refusal.type_retired': "This type is no longer in use and takes no new documents.",
    'documents.refusal.type_builtin': "This type is supplied by the platform, and other modules cite it.",
    'documents.refusal.type_fixed': "{field} is what this type's documents were attached under, and does not change.",
    'documents.refusal.applies_to': "This type's owner is not this kind of owner.",
    'documents.refusal.expires_not_applicable': "This type does not end.",
    'documents.refusal.expires_before_issued': "It cannot end before it was issued ({issued_on}).",
    'documents.refusal.not_found': "No such document.",
    'documents.refusal.not_current': "This is not the current version. Act on the newest one.",
    'documents.refusal.destroyed': "This document was destroyed when its retention ended. Its record is kept; its copy is not.",
    'documents.refusal.no_copy': "This document has no copy yet. Renew it with one.",
    'documents.refusal.not_linked': "Your sign-in is linked to no person in this workspace, so no document is yours. Ask an administrator to link it.",
    'documents.refusal.hold_already': "This document is already on legal hold.",
    'documents.refusal.hold_not_set': "This document is not on legal hold.",
    'documents.refusal.anchor_not_set': "No end was recorded for this owner, so there is nothing to clear.",
    'documents.refusal.regulation_fixed': "A regulation's decision and date change only with a new version.",
    'documents.refusal.regulation_key_taken': "A regulation with the key {key} exists. A new version is a renewal of it.",
    'documents.refusal.regulation_not_found': "No regulation {key} in force.",
    'documents.refusal.regulation_version': "A version is a whole number from 1.",
    'documents.refusal.effective_after_previous': "A new version takes effect after the one it replaces ({previous}).",
    // hr · payroll transfers
    "value.id_type.national_id": "National ID",
    "value.id_type.iqama": "Iqama",
    "value.id_type.passport": "Passport",
    "value.id_type.border": "Border number",
    "value.register.register_checked": "No difference",
    "value.register.register_differs": "Differs from the register",
    "value.register.register_unchecked": "Not checked",
    "value.payment_status.paid": "Paid",
    "value.payment_status.rejected": "Rejected by the bank",
    "value.payment_status.pending": "Awaiting the bank",
    "value.resolution.supplementary": "Paid again by a supplementary run",
    "value.resolution.other": "Paid another way",
    // gov_sa · shared words of the unit's screens
    "group.government": "Government",
    "gov_sa.action.cancel": "Cancel",
    "gov_sa.action.download": "Download",
    "gov_sa.action.open": "Open",
    "gov_sa.action.save": "Save",
    "gov_sa.field.change_file": "Choose another file",
    "gov_sa.field.choose_file": "Choose a file",
    "gov_sa.field.csv_or_xlsx": "CSV or Excel (XLSX), as the portal exports it. Up to 5 MB.",
    "gov_sa.field.empty_is_today": "Empty is today.",
    "gov_sa.field.note": "Note",
    "gov_sa.field.reason": "Why",
    "gov_sa.field.remove_file": "Remove",
    "gov_sa.field.required": "required",
    "gov_sa.format.csv": "CSV",
    "gov_sa.format.xlsx": "Excel (XLSX)",
    "gov_sa.refusal.amount": "Enter an amount above zero, with at most two decimals.",
    "gov_sa.refusal.date": "Write the date as YYYY-MM-DD.",
    "gov_sa.refusal.duplicate": "That was already recorded.",
    "gov_sa.refusal.file_empty": "The file is empty.",
    "gov_sa.refusal.file_too_large": "The file is larger than {max_mb} MB.",
    "gov_sa.refusal.file_unreadable": "The file could not be read. Save it as CSV (UTF-8) or XLSX and try again.",
    "gov_sa.refusal.future": "That day has not come yet.",
    "gov_sa.refusal.hr_forbidden": "HR refused: you do not hold the permission there.",
    "gov_sa.refusal.hr_timeout": "HR did not answer in time. Try again.",
    "gov_sa.refusal.hr_unavailable": "HR did not answer ({reason}).",
    "gov_sa.refusal.idempotency_mismatch": "This request key was already used for another request.",
    "gov_sa.refusal.not_found": "Not found.",
    "gov_sa.refusal.one_of": "Choose one of: {values}.",
    "gov_sa.refusal.range": "Enter a value from {min} to {max}.",
    "gov_sa.refusal.required": "This is required.",
    "gov_sa.refusal.too_long": "At most {max} characters.",
    // gov_sa · gosi
    "nav.gosi.worklist": "GOSI worklist",
    "nav.gosi.submissions": "GOSI submissions",
    "nav.gosi.reconcile": "GOSI reconciliation",
    "nav.gosi.rates": "GOSI rates",
    "value.kind.register": "Registration",
    "value.kind.wage_update": "Wage update",
    "value.kind.exclude": "Exclusion",
    "value.kind.maternity_notice": "Maternity compensation notice",
    "value.stage.to_report": "To report",
    "value.stage.waiting": "Not joined yet",
    "value.stage.in_submission": "In a submission",
    "value.stage.done": "Done",
    "value.scheme.old": "Old scheme",
    "value.scheme.new": "New scheme",
    "value.scheme.non_citizen": "Non-citizen",
    "value.branch.annuities": "Annuities",
    "value.branch.saned": "SANED (unemployment)",
    "value.branch.hazards": "Occupational hazards",
    "value.source.pack": "Rates pack",
    "value.status.confirmed": "Confirmed",
    "gov_sa.gosi.channel.file": "A file uploaded on the portal",
    "gov_sa.gosi.channel.portal_manual": "Entered by hand on the portal",
    "gov_sa.gosi.scheme.old.long": "Old — contributed before 3 July 2024",
    "gov_sa.gosi.scheme.new.long": "New — first registered on or after 3 July 2024",
    "gov_sa.gosi.scheme.non_citizen.long": "Non-citizen — occupational hazards only",
    "gov_sa.gosi.submission_status.prepared": "Prepared",
    "gov_sa.gosi.submission_status.submitted": "Sent, awaiting GOSI",
    "gov_sa.gosi.submission_status.accepted": "Accepted",
    "gov_sa.gosi.submission_status.rejected": "Rejected",
    "gov_sa.gosi.submission_status.withdrawn": "Withdrawn",
    "gov_sa.gosi.mismatch.missing_contributor": "Not on GOSI's list",
    "gov_sa.gosi.mismatch.registered_not_employed": "Listed, no longer here",
    "gov_sa.gosi.mismatch.wage_differs": "Wage differs",
    "gov_sa.gosi.mismatch.scheme_mismatch": "Scheme differs",
    "gov_sa.gosi.mismatch.missing_contributor.todo": "Working here and not on GOSI's list: register them — the worklist has an item, or refresh it from HR.",
    "gov_sa.gosi.mismatch.registered_not_employed.todo": "On GOSI's list and not working here: exclude them, or the establishment keeps paying for them.",
    "gov_sa.gosi.mismatch.wage_differs.todo": "Basic + housing in HR differs from GOSI's wage: update the contributory wage, or correct the contract.",
    "gov_sa.gosi.mismatch.scheme_mismatch.todo": "GOSI and HR disagree on the scheme: check the first registration date — one of them is wrong.",
    "gov_sa.gosi.worklist.screen.title": "GOSI worklist",
    "gov_sa.gosi.worklist.screen.lede": "What the establishment must report to GOSI, once per fact with its due day; nothing reaches GOSI by itself.",
    "gov_sa.gosi.worklist.col.employee": "Employee",
    "gov_sa.gosi.worklist.col.employee_number": "Employee number",
    "gov_sa.gosi.worklist.col.id_number": "ID number",
    "gov_sa.gosi.worklist.col.kind": "To report",
    "gov_sa.gosi.worklist.col.effective_on": "Takes effect",
    "gov_sa.gosi.worklist.col.due_on": "Due by",
    "gov_sa.gosi.worklist.col.days_left": "Days left",
    "gov_sa.gosi.worklist.col.overdue": "Overdue",
    "gov_sa.gosi.worklist.col.scheme": "Scheme",
    "gov_sa.gosi.worklist.col.needs_review": "Scheme to decide",
    "gov_sa.gosi.worklist.col.stage": "Stage",
    "gov_sa.gosi.worklist.col.reference": "GOSI reference",
    "gov_sa.gosi.worklist.col.refreshed_at": "HR data as of",
    "gov_sa.gosi.worklist.col.can_done": "You may mark this done",
    "gov_sa.gosi.worklist.col.can_reopen": "You may reopen this",
    "gov_sa.gosi.worklist.col.can_classify": "You may set the scheme",
    "gov_sa.gosi.worklist.col.can_withdraw": "You may withdraw this",
    "gov_sa.gosi.worklist.stat.overdue": "Overdue",
    "gov_sa.gosi.worklist.stat.open": "To report",
    "gov_sa.gosi.worklist.stat.review": "Scheme to decide",
    "gov_sa.gosi.worklist.stat.sent": "In a submission",
    "gov_sa.gosi.worklist.action.prepare": "Prepare a submission",
    "gov_sa.gosi.worklist.action.prepare.field.kind": "What to send",
    "gov_sa.gosi.worklist.action.prepare.field.channel": "How it goes to GOSI",
    "gov_sa.gosi.worklist.action.prepare.field.format": "File",
    "gov_sa.gosi.worklist.action.prepare.field.format.help": "The file follows this product's template — confirm it against GOSI's current bulk format before relying on it.",
    "gov_sa.gosi.worklist.action.refresh": "Refresh from HR",
    "gov_sa.gosi.worklist.action.done": "Mark done",
    "gov_sa.gosi.worklist.action.done.field.reference": "GOSI reference",
    "gov_sa.gosi.worklist.action.done.field.reference.help": "The number the portal gave the transaction.",
    "gov_sa.gosi.worklist.action.done.field.done_on": "Done on",
    "gov_sa.gosi.worklist.action.classify": "Set the scheme",
    "gov_sa.gosi.worklist.action.classify.field.scheme.help": "Decided by the first registration anywhere in GOSI, not by joining here. Somebody with prior GOSI history is old-scheme.",
    "gov_sa.gosi.worklist.action.classify.field.note": "Evidence",
    "gov_sa.gosi.worklist.action.classify.field.note.help": "What the decision rests on — the GOSI certificate, the previous employer.",
    "gov_sa.gosi.worklist.action.reopen": "Reopen",
    "gov_sa.gosi.worklist.action.withdraw": "Not to report",
    "gov_sa.gosi.worklist.action.exempt": "Not subject to GOSI",
    "gov_sa.gosi.worklist.action.exempt.field.reason.help": "HR shows the employee as exempt from this.",
    "gov_sa.gosi.worklist.col.can_exempt": "You may mark this exempt",
    "gov_sa.gosi.rates.screen.title": "GOSI contribution rates",
    "gov_sa.gosi.rates.screen.lede": "One dated rate per scheme and branch on basic plus housing up to the ceiling; payroll uses a row once it is confirmed.",
    "gov_sa.gosi.rates.col.scheme": "Scheme",
    "gov_sa.gosi.rates.col.branch": "Branch",
    "gov_sa.gosi.rates.col.effective_from": "From",
    "gov_sa.gosi.rates.col.employee_rate": "Employee %",
    "gov_sa.gosi.rates.col.employer_rate": "Employer %",
    "gov_sa.gosi.rates.col.wage_ceiling": "Wage ceiling",
    "gov_sa.gosi.rates.col.in_force": "In force today",
    "gov_sa.gosi.rates.col.source": "Source",
    "gov_sa.gosi.rates.col.status": "Status",
    "gov_sa.gosi.rates.col.note": "Note",
    "gov_sa.gosi.rates.col.confirmed_at": "Confirmed",
    "gov_sa.gosi.rates.col.can_confirm": "You may confirm this",
    "gov_sa.gosi.rates.col.can_withdraw": "You may withdraw this",
    "gov_sa.gosi.rates.stat.unconfirmed": "To confirm",
    "gov_sa.gosi.rates.stat.in_force": "In force today",
    "gov_sa.gosi.rates.action.import_pack": "Load the rates pack",
    "gov_sa.gosi.rates.action.add": "Add a dated rate",
    "gov_sa.gosi.rates.action.confirm": "Confirm",
    "gov_sa.gosi.rates.action.withdraw": "Withdraw",
    "gov_sa.gosi.rates.field.percent.help": "A percent: 9, 0.75, 10.5.",
    "gov_sa.gosi.rates.field.wage_floor": "Wage floor",
    "gov_sa.gosi.rates.field.wage_ceiling.help": "SAR 45,000 as the sources state it — confirm.",
    "gov_sa.gosi.rates.field.note": "Source",
    "gov_sa.gosi.rates.field.note.help": "Where the figure comes from — somebody else confirms it against that text.",
    "gov_sa.gosi.submissions.screen.title": "GOSI submissions",
    "gov_sa.gosi.submissions.screen.lede": "What was sent to GOSI, attempt by attempt. Sent is not accepted: it is done when GOSI answers with a reference. A rejected one stays until retried — the same submission again, so nobody is registered twice.",
    "gov_sa.gosi.submissions.template_note": "Files follow this product's template — confirm it against GOSI's current bulk format before go-live. Nothing here talks to GOSI: upload the file on the portal yourself and record what GOSI answered.",
    "gov_sa.gosi.submissions.empty": "Nothing sent to GOSI yet",
    "gov_sa.gosi.submissions.empty.detail": "Prepare a submission from the GOSI worklist: it gathers what is waiting to be reported into one file.",
    "gov_sa.gosi.submissions.tab_empty": "None here.",
    "gov_sa.gosi.submissions.attempt": "attempt {n}",
    "gov_sa.gosi.submissions.attempts": "Attempts",
    "gov_sa.gosi.submissions.items": "{count} people",
    "gov_sa.gosi.submissions.sent_on": "Sent on {day}",
    "gov_sa.gosi.submissions.prepared_at": "Prepared on {day}",
    "gov_sa.gosi.submissions.sent_not_accepted": "Sent is not accepted: record GOSI's answer when it comes.",
    "gov_sa.gosi.submissions.reference": "GOSI reference: {reference}",
    "gov_sa.gosi.submissions.rejected_because": "Rejected: {reason}",
    "gov_sa.gosi.submissions.details": "Details",
    "gov_sa.gosi.submissions.mark_sent": "Record as sent",
    "gov_sa.gosi.submissions.mark_sent.detail": "The file went up on the portal, or the items were entered there by hand. GOSI has not answered yet.",
    "gov_sa.gosi.submissions.sent_day": "Sent on",
    "gov_sa.gosi.submissions.record_answer": "Record GOSI's answer",
    "gov_sa.gosi.submissions.record_answer.detail": "Accepted closes every item with GOSI's reference. Rejected keeps them here with the reason until you retry.",
    "gov_sa.gosi.submissions.accepted.detail": "GOSI gave a reference for the transaction.",
    "gov_sa.gosi.submissions.rejected.detail": "GOSI refused it, with a reason.",
    "gov_sa.gosi.submissions.reference_label": "GOSI reference",
    "gov_sa.gosi.submissions.reason_label": "GOSI's reason",
    "gov_sa.gosi.submissions.retry": "Retry",
    "gov_sa.gosi.submissions.retry.detail": "The next attempt of the same submission: the file is written again from what HR says now. Nobody is added twice.",
    "gov_sa.gosi.submissions.withdraw": "Withdraw",
    "gov_sa.gosi.submissions.withdraw.detail": "The submission is given up and its people go back to the worklist.",
    "gov_sa.gosi.submissions.done.sent": "Recorded as sent.",
    "gov_sa.gosi.submissions.done.accepted": "Accepted: every item is done with GOSI's reference.",
    "gov_sa.gosi.submissions.done.rejected": "Recorded as rejected. Fix the cause and retry.",
    "gov_sa.gosi.submissions.done.retried": "Prepared again as the next attempt. Download the new file.",
    "gov_sa.gosi.submissions.done.withdrawn": "Withdrawn. Its people are back on the worklist.",
    "gov_sa.gosi.settings.open": "Deadlines",
    "gov_sa.gosi.settings.title": "GOSI deadlines",
    "gov_sa.gosi.settings.detail": "The figures the worklist's due days come from. The defaults are the reading the owner adopted on 2026-09-26 (15 days to register and to exclude), pending the lawyer's review.",
    "gov_sa.gosi.settings.register_within_days": "Days to register after joining",
    "gov_sa.gosi.settings.exclude_within_days": "Days to exclude after the last day",
    "gov_sa.gosi.settings.new_scheme_from": "New scheme from",
    "gov_sa.gosi.settings.new_scheme_from.help": "A first registration on or after this day is the new scheme (Royal Decree M/273).",
    "gov_sa.gosi.settings.maternity_leave_types": "Leave types that are a maternity leave",
    "gov_sa.gosi.settings.maternity_leave_types.help": "The leave types that count as maternity leave (maternity leave by default). Each such leave granted sends one compensation notice to GOSI.",
    "gov_sa.gosi.settings.maternity_notice_within_days": "Days to notify GOSI of a maternity leave",
    "gov_sa.refusal.gosi.type_key": "A leave type key is lower-case letters, digits, dot, dash or underscore ({key}).",
    "gov_sa.gosi.settings.confirm": "Adopted reading, pending the lawyer's review.",
    "gov_sa.gosi.settings.saved": "Saved. Due days of new items follow the new figures.",
    "gov_sa.gosi.reconcile.screen.title": "GOSI reconciliation",
    "gov_sa.gosi.reconcile.screen.lede": "Compare GOSI's Active Contributors report with HR: who is missing on either side, and whose wage or scheme differs.",
    "gov_sa.gosi.reconcile.import": "GOSI's report",
    "gov_sa.gosi.reconcile.import.detail": "Export \"Active Contributors\" from the GOSI portal and choose the file. HR is asked who works here with your own permissions.",
    "gov_sa.gosi.reconcile.file": "Report file",
    "gov_sa.gosi.reconcile.compare": "Compare with HR",
    "gov_sa.gosi.reconcile.expected": "Columns read (under any of these headers, Arabic or English) — ⚠ to confirm against a real report:",
    "gov_sa.gosi.reconcile.column.id_number": "ID number",
    "gov_sa.gosi.reconcile.column.name": "Name",
    "gov_sa.gosi.reconcile.column.basic": "Basic wage",
    "gov_sa.gosi.reconcile.column.housing": "Housing allowance",
    "gov_sa.gosi.reconcile.column.wage": "Contributory wage",
    "gov_sa.gosi.reconcile.column.joined_on": "Joining date",
    "gov_sa.gosi.reconcile.column.nationality": "Nationality",
    "gov_sa.gosi.reconcile.column.scheme": "Scheme",
    "gov_sa.gosi.reconcile.result": "What {file} says against HR",
    "gov_sa.gosi.reconcile.rows": "Contributors in the report",
    "gov_sa.gosi.reconcile.matched": "Matching HR",
    "gov_sa.gosi.reconcile.mismatches": "Differences",
    "gov_sa.gosi.reconcile.all_match": "GOSI and HR agree on everybody.",
    "gov_sa.gosi.reconcile.none_of_kind": "None of this kind.",
    "gov_sa.gosi.reconcile.hr_says": "HR says",
    "gov_sa.gosi.reconcile.gosi_says": "GOSI says",
    "gov_sa.gosi.reconcile.history": "Earlier reports",
    "gov_sa.gosi.reconcile.history.empty": "No report imported yet.",
    "gov_sa.gosi.reconcile.mismatch_count": "{count} differences",
    "gov_sa.refusal.gosi.days": "A whole number of days from 1 to 90.",
    "gov_sa.refusal.gosi.branch_id": "A branch is chosen from the list of branches.",
    "gov_sa.refusal.gosi.percent": "A rate is a percent below 100 with at most four decimals: 9, 0.75.",
    "gov_sa.refusal.gosi.floor": "The floor must sit below the ceiling.",
    "gov_sa.refusal.gosi.rate_exists": "A {branch} rate for the {scheme} scheme already starts on {effective_from}.",
    "gov_sa.refusal.gosi.rate_not_unconfirmed": "Only an unconfirmed rate is confirmed.",
    "gov_sa.refusal.gosi.rate_own": "Whoever typed or proposed a rate does not confirm it; somebody else checks it against GOSI's text.",
    "gov_sa.refusal.gosi.rate_published": "A confirmed rate was published and payroll may have used it. Add a later dated row instead.",
    "gov_sa.refusal.gosi.item_not_open": "Only an open item is changed this way (it is {status}).",
    "gov_sa.refusal.gosi.item_not_done": "Only a done item is reopened.",
    "gov_sa.refusal.gosi.item_in_submission": "The item is in a submission: its outcome closes it. Withdraw the submission to change it.",
    "gov_sa.refusal.gosi.done_by_authority": "GOSI accepted this in a submission. Correct it with a new submission, not by reopening.",
    "gov_sa.refusal.gosi.not_registration": "Only a registration has a scheme.",
    "gov_sa.refusal.gosi.scheme_unknown": "Say which scheme {employee} is registered under first.",
    "gov_sa.refusal.gosi.not_refreshed": "HR has not said who {employee} is yet: refresh the worklist from HR.",
    "gov_sa.refusal.gosi.no_effective_day": "The day it takes effect for {employee} is not known yet.",
    "gov_sa.refusal.gosi.items_not_ready": "Some items are not ready to send. Fix them, or leave them out.",
    "gov_sa.refusal.gosi.item_unavailable": "An item named is not open, not of this kind, or already in a submission.",
    "gov_sa.refusal.gosi.nothing_to_submit": "Nothing of this kind is waiting to be sent.",
    "gov_sa.refusal.gosi.submission_status": "The submission is {status}, and this step does not apply.",
    "gov_sa.refusal.gosi.report_columns": "The report has no column for {missing}. Found: {found}.",
    // gov_sa · mudad
    "nav.mudad.files": "WPS files",
    "nav.mudad.compliance": "WPS compliance",
    "nav.mudad.establishment": "Establishment (WPS)",
    "nav.mudad.layouts": "WPS file layouts",
    "nav.mudad.advances": "Advance files",
    "nav.mudad.banks": "Approved banks",
    "value.kind.salary": "Mudad file",
    "value.kind.direct_transfer": "Direct transfer",
    "value.kind.advance": "Advance",
    "value.source.builtin": "Built in",
    "value.source.data": "Added",
    "value.standing.meets": "Meets the threshold",
    "value.standing.below": "Below the threshold",
    "value.standing.no_data": "No status yet",
    "gov_sa.mudad.file_status.not_generated": "No file yet",
    "gov_sa.mudad.file_status.generated": "Generated",
    "gov_sa.mudad.file_status.uploaded": "Uploaded",
    "gov_sa.mudad.file_status.status_imported": "Status imported",
    "gov_sa.mudad.file_status.withdrawn": "Withdrawn",
    "gov_sa.mudad.line_status.none": "No status yet",
    "gov_sa.mudad.line_status.paid": "Paid",
    "gov_sa.mudad.line_status.rejected": "Rejected",
    "gov_sa.mudad.line_status.pending": "Pending",
    "gov_sa.mudad.clock.no_pay_date": "Not paid yet: the WPS clock starts on the pay day.",
    "gov_sa.mudad.clock.on_time": "Upload on Mudad by {due} — {days} days left. ⚠ 30 days after the pay day, to confirm.",
    "gov_sa.mudad.clock.late": "{days} days past {due}: exposed to SAR {exposure} (3,000 × {workers} workers) and an inspection visit. ⚠ To confirm.",
    "gov_sa.mudad.clock.services_frozen": "{months} months late: SAR {exposure} exposure, and the ministry's services are frozen except work permits. ⚠ To confirm.",
    "gov_sa.mudad.clock.free_transfer": "{months} months late: SAR {exposure} exposure, every service frozen, and workers may transfer without the employer's approval. ⚠ To confirm.",
    "gov_sa.mudad.files.screen.title": "WPS files",
    "gov_sa.mudad.files.screen.lede": "A paid run's wage-protection file, checked row by row before it exists, with the clock the ministry runs on it. Upload it on Mudad yourself, record the day here, then import Mudad's status report — nothing here talks to Mudad or a bank.",
    "gov_sa.mudad.files.template_note": "The file follows the layout chosen — this product's documented CSV unless a bank's layout was added. Confirm it against the bank's or Mudad's template before go-live.",
    "gov_sa.mudad.files.runs": "Runs to file",
    "gov_sa.mudad.files.runs.detail": "Approved and paid runs from payroll, with the WPS clock from each pay day.",
    "gov_sa.mudad.files.payroll_silent": "Payroll did not answer ({reason}); only the runs this screen already knows are shown.",
    "gov_sa.mudad.files.no_runs": "No approved or paid run yet",
    "gov_sa.mudad.files.no_runs.detail": "A run appears here once it is approved in payroll.",
    "gov_sa.mudad.files.pay_date": "Paid on {day}",
    "gov_sa.mudad.files.not_paid_yet": "Approved, not paid yet",
    "gov_sa.mudad.files.employees": "{count} employees",
    "gov_sa.mudad.files.generate": "Generate the WPS file",
    "gov_sa.mudad.files.generate.detail": "Every row is checked first — IBAN, identity number, net, the run's total. People not in GOSI or not paid by bank go to a separate direct-transfer list.",
    "gov_sa.mudad.files.layout": "Layout",
    "gov_sa.mudad.files.layout.hint": "Add a bank's exact layout on the layouts screen.",
    "gov_sa.mudad.files.made": "{kind}: {rows} rows, SAR {total}",
    "gov_sa.mudad.files.files": "Files",
    "gov_sa.mudad.files.none": "No file yet",
    "gov_sa.mudad.files.none.detail": "Generate one from a run above.",
    "gov_sa.mudad.files.tab_empty": "None here.",
    "gov_sa.mudad.files.rows_total": "{rows} rows · SAR {total}",
    "gov_sa.mudad.files.uploaded_on": "Uploaded on {day}",
    "gov_sa.mudad.files.direct_note": "Not for Mudad: people not registered in GOSI or not paid by bank, to pay by direct transfer or by hand.",
    "gov_sa.mudad.files.uploaded_not_paid": "Uploaded is not paid: import Mudad's status report to know who was.",
    "gov_sa.mudad.files.paid_count": "{count} paid",
    "gov_sa.mudad.files.rejected_count": "{count} rejected",
    "gov_sa.mudad.files.pending_count": "{count} pending",
    "gov_sa.mudad.files.lines": "Lines and statuses",
    "gov_sa.mudad.files.no_iban": "No IBAN",
    "gov_sa.mudad.files.withdraw": "Withdraw",
    "gov_sa.mudad.files.withdraw.detail": "The file is not uploaded and will not be: a new one can be generated.",
    "gov_sa.mudad.files.mark_uploaded": "Record the upload",
    "gov_sa.mudad.files.mark_uploaded.detail": "You uploaded the file on Mudad. The clock stops here; who was paid comes with the status report.",
    "gov_sa.mudad.files.uploaded_day": "Uploaded on",
    "gov_sa.mudad.files.import_status": "Import the status report",
    "gov_sa.mudad.files.import_status.detail": "Mudad's payment status report for this file. Each row is matched by identity number; what payroll has not been told is sent to it once.",
    "gov_sa.mudad.files.status_report": "Status report",
    "gov_sa.mudad.files.import": "Import",
    "gov_sa.mudad.files.imports": "Reports imported",
    "gov_sa.mudad.files.import_counts": "{matched} matched, {unmatched} not in the file",
    "gov_sa.mudad.files.hr_state.sent": "Payroll told",
    "gov_sa.mudad.files.hr_state.failed": "Payroll not told",
    "gov_sa.mudad.files.hr_state.nothing": "Nothing new",
    "gov_sa.mudad.files.hr.sent": "Payroll was told {rows} statuses.",
    "gov_sa.mudad.files.hr.failed": "Payroll did not answer: send it again from the file's lines.",
    "gov_sa.mudad.files.hr.nothing": "Payroll already knew every status.",
    "gov_sa.mudad.files.resend": "Send to payroll again",
    "gov_sa.mudad.files.done.uploaded": "Recorded as uploaded.",
    "gov_sa.mudad.files.done.withdrawn": "Withdrawn.",
    "gov_sa.mudad.files.done.imported": "Imported: {paid} paid, {rejected} rejected, {pending} pending, {unmatched} not in the file.",
    "gov_sa.mudad.files.done.resent": "Sent again.",
    "gov_sa.mudad.compliance.screen.title": "WPS compliance",
    "gov_sa.mudad.compliance.screen.lede": "Each month's paid ratio from Mudad's reports; the threshold is a setting — confirm the one your establishment is held to.",
    "gov_sa.mudad.compliance.col.month": "Month",
    "gov_sa.mudad.compliance.col.employees": "Employees",
    "gov_sa.mudad.compliance.col.paid": "Paid",
    "gov_sa.mudad.compliance.col.rejected": "Rejected",
    "gov_sa.mudad.compliance.col.pending": "Pending",
    "gov_sa.mudad.compliance.col.unknown": "No status yet",
    "gov_sa.mudad.compliance.col.ratio": "Ratio",
    "gov_sa.mudad.compliance.col.threshold": "Threshold",
    "gov_sa.mudad.compliance.col.standing": "Standing",
    "gov_sa.mudad.compliance.stat.below": "Months below the threshold",
    "gov_sa.mudad.compliance.stat.rejected": "Transfers rejected",
    "gov_sa.mudad.compliance.stat.pending": "Transfers pending",
    "gov_sa.mudad.compliance.action.threshold": "Set the threshold",
    "gov_sa.mudad.compliance.field.threshold": "Threshold (%)",
    "gov_sa.mudad.compliance.field.threshold.help": "The monthly share of employees paid through WPS the establishment is held to. ⚠ 80 or 90 — confirm.",
    // gov_sa · the compliance page (mudad.establishment)
    "nav.mudad.establishments": "Establishments",
    "entity.mudad.establishment": "the establishment",
    "gov_sa.mudad.establishments.title": "Establishments",
    "gov_sa.mudad.establishments.lede": "What the authorities ask for, on one page, for each establishment.",
    "gov_sa.mudad.establishment.name": "Establishment name",
    "gov_sa.mudad.establishment.name.help": "How the establishment is called on its compliance page, as «Head office».",
    "screen.mudad.overview.title": "Compliance",
    "gov_sa.mudad.overview.col.label": "Establishment",
    "gov_sa.mudad.overview.col.name": "Name",
    "gov_sa.mudad.overview.col.wps_run_id": "Payroll run",
    "gov_sa.mudad.overview.col.wps_period": "Payroll period",
    "gov_sa.mudad.overview.col.wps_pay_date": "Pay day",
    "gov_sa.mudad.overview.col.wps_file": "WPS file",
    "gov_sa.mudad.overview.col.wps_due_on": "WPS file due",
    "gov_sa.mudad.overview.col.wps_days_left": "Days left",
    "gov_sa.mudad.overview.col.wps_stage": "WPS clock",
    "gov_sa.mudad.overview.col.wps_month": "Latest month",
    "gov_sa.mudad.overview.col.wps_ratio": "Compliance ratio",
    "gov_sa.mudad.overview.col.wps_threshold": "Threshold",
    "gov_sa.mudad.overview.col.wps_standing": "Standing",
    "gov_sa.mudad.overview.col.can_manage": "Can change the settings",
    "gov_sa.mudad.overview.wps_file.not_generated": "no file written yet",
    "gov_sa.mudad.overview.wps_file.generated": "written, not uploaded",
    "gov_sa.mudad.overview.wps_stage.on_time": "Within the window",
    "gov_sa.mudad.overview.wps_stage.late": "Late",
    "gov_sa.mudad.overview.wps_stage.services_frozen": "Services frozen",
    "gov_sa.mudad.overview.wps_stage.free_transfer": "Workers may transfer",
    "gov_sa.mudad.overview.wps_stage.no_pay_date": "No pay day",
    "gov_sa.mudad.overview.wps_stage.uploaded": "Uploaded",
    "gov_sa.mudad.overview.action.settings": "Establishment details",
    "gov_sa.mudad.overview.subtitle.cr": "CR {value}",
    "gov_sa.mudad.overview.subtitle.mudad": "Mudad {value}",
    "gov_sa.mudad.overview.monogram": "Es",
    "gov_sa.mudad.overview.alert.wps_due": "The WPS file of the payroll paid on {wps_pay_date} has not gone up to Mudad",
    "gov_sa.mudad.overview.alert.wps_below": "Paid through WPS in {wps_month}: {wps_ratio}%, below the {wps_threshold}% the establishment is held to",
    "gov_sa.mudad.establishment_wps.title": "Wage protection (Mudad) — {month:month}",
    "gov_sa.mudad.establishment_wps.col.month": "Month",
    "gov_sa.mudad.establishment_wps.col.standing": "Against the threshold",
    "gov_sa.mudad.establishment_wps.standing.meets": "Meets the threshold",
    "gov_sa.mudad.establishment_wps.standing.below": "Below the threshold",
    "gov_sa.mudad.establishment_wps.standing.no_data": "No status yet",
    "gov_sa.mudad.establishment_wps.col.paid": "Accepted",
    "gov_sa.mudad.establishment_wps.paid_words": "{paid} of {employees}",
    "gov_sa.mudad.establishment_wps.col.rejected": "Rejected",
    "gov_sa.mudad.establishment_wps.col.ratio": "Compliance ratio",
    "gov_sa.mudad.establishment_wps.ratio_words": "{ratio}%",
    "gov_sa.mudad.establishment_wps.col.top_reason": "Rejected for",
    "gov_sa.mudad.establishment_wps.link": "Mudad files",
    "gov_sa.mudad.establishment_wps.empty": "No status report from Mudad has been imported yet.",
    "gov_sa.gosi.establishment.title": "Social insurance (GOSI)",
    "gov_sa.gosi.establishment.col.kind": "Item",
    "gov_sa.gosi.establishment.kind.register": "Registration",
    "gov_sa.gosi.establishment.kind.wage_update": "Wage update",
    "gov_sa.gosi.establishment.kind.exclude": "Exclusion",
    "gov_sa.gosi.establishment.col.stage": "Status",
    "gov_sa.gosi.establishment.stage.waiting": "Not joined yet",
    "gov_sa.gosi.establishment.stage.to_report": "To report",
    "gov_sa.gosi.establishment.stage.in_submission": "In a submission",
    "gov_sa.gosi.establishment.col.employment_id": "Employment",
    "gov_sa.gosi.establishment.link": "GOSI worklist",
    "gov_sa.gosi.establishment.empty": "Nothing is waiting to be reported to GOSI.",
    "gov_sa.gosi.establishment.due.title": "GOSI items to report",
    "gov_sa.gosi.establishment.due.alert": "GOSI items to report: {count}",
    "gov_sa.gosi.establishment.reconciliation.title": "Monthly reconciliation with GOSI",
    "gov_sa.gosi.establishment.reconciliation.col.mismatches": "Differences",
    "gov_sa.gosi.establishment.reconciliation.col.differs": "Differs",
    "gov_sa.gosi.establishment.reconciliation.alert": "Monthly reconciliation with GOSI: {mismatches} to work through",
    "unit.differences.zero": "{n} differences",
    "unit.differences.one": "{n} difference",
    "unit.differences.two": "{n} differences",
    "unit.differences.few": "{n} differences",
    "unit.differences.many": "{n} differences",
    "unit.differences.other": "{n} differences",
    "gov_sa.mudad.establishment.screen.title": "Establishment (WPS)",
    "gov_sa.mudad.establishment.screen.lede": "How the ministry, Mudad and the bank know this establishment, and the WPS figures the clock and the compliance ratio are computed with. Every figure marked ⚠ is to confirm before go-live.",
    "gov_sa.mudad.establishment.identity": "The establishment",
    "gov_sa.mudad.establishment.identity.detail": "Checked for their shape when saved; the WPS file carries them.",
    "gov_sa.mudad.establishment.figures": "WPS figures ⚠",
    "gov_sa.mudad.establishment.figures.detail": "What the clock, the fine and the ratio are computed with. The defaults are what public sources say; confirm each.",
    "gov_sa.mudad.establishment.read_only": "You may see these settings; changing them needs the establishment settings permission.",
    "gov_sa.mudad.establishment.saved": "Saved.",
    "gov_sa.mudad.establishment.cr_number": "Commercial registration",
    "gov_sa.mudad.establishment.cr_number.help": "Ten digits.",
    "gov_sa.mudad.establishment.unified_number": "Unified number",
    "gov_sa.mudad.establishment.unified_number.help": "The ministry's number for the establishment: ten digits starting 7 (700…).",
    "gov_sa.mudad.establishment.mudad_establishment_id": "Mudad establishment ID",
    "gov_sa.mudad.establishment.mudad_establishment_id.help": "As Mudad shows it after the establishment signed up.",
    "gov_sa.mudad.establishment.bank_name": "Bank",
    "gov_sa.mudad.establishment.bank_name.help": "The bank that pays the wages.",
    "gov_sa.mudad.establishment.account_iban": "Establishment IBAN",
    "gov_sa.mudad.establishment.account_iban.help": "SA and 22 digits; its check digits are verified.",
    "gov_sa.mudad.establishment.bank_code": "Bank code",
    "gov_sa.mudad.establishment.bank_code.help": "Two digits: the IBAN's digits 5–6.",
    "gov_sa.mudad.establishment.signatory_name": "Authorised signatory",
    "gov_sa.mudad.establishment.signatory_name.help": "Who approves payments on Mudad and at the bank.",
    "gov_sa.mudad.establishment.signatory_id_number": "Signatory's ID number",
    "gov_sa.mudad.establishment.signatory_id_number.help": "National ID (1…) or iqama (2…).",
    "gov_sa.mudad.establishment.default_layout": "Default file layout",
    "gov_sa.mudad.establishment.default_layout.help": "What a file is written in unless another layout is chosen.",
    "gov_sa.mudad.establishment.upload_window_days": "Days to upload after the pay day",
    "gov_sa.mudad.establishment.upload_window_days.help": "⚠ 30 since 1 March 2025 (was 60).",
    "gov_sa.mudad.establishment.fine_per_worker": "Fine per worker (SAR)",
    "gov_sa.mudad.establishment.fine_per_worker.help": "⚠ 3,000 per the ministry's WPS page; the 2026 violations table was not read.",
    "gov_sa.mudad.establishment.freeze_after_months": "Months late before services freeze",
    "gov_sa.mudad.establishment.freeze_after_months.help": "⚠ 2.",
    "gov_sa.mudad.establishment.transfer_after_months": "Months late before free transfer",
    "gov_sa.mudad.establishment.transfer_after_months.help": "⚠ 3.",
    "gov_sa.mudad.establishment.compliance_threshold": "Compliance threshold (%)",
    "gov_sa.mudad.establishment.compliance_threshold.help": "⚠ 80 or 90 — sources disagree.",
    "gov_sa.mudad.layouts.screen.title": "WPS file layouts",
    "gov_sa.mudad.layouts.screen.lede": "The layouts WPS files are written in; confirm each against the bank's or Mudad's template before go-live.",
    "gov_sa.mudad.layouts.col.key": "Key",
    "gov_sa.mudad.layouts.col.name": "Name",
    "gov_sa.mudad.layouts.col.source": "Kind",
    "gov_sa.mudad.layouts.col.status": "Status",
    "gov_sa.mudad.layouts.col.created_at": "Added",
    "gov_sa.mudad.layouts.col.can_retire": "You may retire this",
    "gov_sa.mudad.layouts.action.add": "Add a bank layout",
    "gov_sa.mudad.layouts.action.retire": "Retire",
    "gov_sa.mudad.advances.screen.title": "Advance files",
    "gov_sa.mudad.advances.screen.lede": "Each advance payroll paid, with its own WPS file carrying the advance mark, apart from the run's.",
    "gov_sa.mudad.advances.col.employment_id": "Employee",
    "gov_sa.mudad.advances.col.paid_on": "Paid on",
    "gov_sa.mudad.advances.col.file_status": "File",
    "gov_sa.mudad.advances.col.filename": "File name",
    "gov_sa.mudad.advances.col.total": "Amount",
    "gov_sa.mudad.advances.col.run_id": "Run",
    "gov_sa.mudad.advances.col.advance_id": "Advance",
    "gov_sa.mudad.advances.col.can_generate": "You may write its file",
    "gov_sa.mudad.advances.file_status.not_generated": "Not written",
    "gov_sa.mudad.advances.file_status.generated": "Written",
    "gov_sa.mudad.advances.file_status.uploaded": "Uploaded",
    "gov_sa.mudad.advances.file_status.status_imported": "Status imported",
    "gov_sa.mudad.advances.action.generate": "Write the advance file",
    "gov_sa.mudad.banks.screen.title": "Approved banks",
    "gov_sa.mudad.banks.screen.lede": "The banks this workspace pays through; while any is approved, a line to an unlisted bank is refused.",
    "gov_sa.mudad.banks.col.code": "Code",
    "gov_sa.mudad.banks.col.name_ar": "Name",
    "gov_sa.mudad.banks.col.name_en": "Name in English",
    "gov_sa.mudad.banks.col.bic": "SWIFT code",
    "gov_sa.mudad.banks.col.valid_from": "From",
    "gov_sa.mudad.banks.col.lines": "Lines paid through it",
    "gov_sa.mudad.banks.col.status": "Status",
    "gov_sa.mudad.banks.col.can_retire": "You may retire this",
    "gov_sa.mudad.banks.status.approved": "Approved",
    "gov_sa.mudad.banks.status.retired": "Retired",
    "gov_sa.mudad.banks.action.add": "Approve a bank",
    "gov_sa.mudad.banks.action.retire": "Retire",
    "gov_sa.mudad.banks.field.code.help": "The two digits a Saudi IBAN carries after SA and its check digits (SA03 80…: 80).",
    "gov_sa.mudad.layouts.field.key.help": "Lower-case letters, digits, dash: alrajhi-sif.",
    "gov_sa.mudad.layouts.field.spec": "Layout (JSON)",
    "gov_sa.mudad.layouts.field.spec.help": "delimiter (\",\" \";\" \"|\" or \"\" for fixed width), header_row, bom, eol (crlf|lf), extension (csv|txt), and records.header / line / footer: lists of columns, each a field (line.id_number, line.iban, line.net, file.total, file.rows, establishment.unified_number …) or a literal, with format (amount, halalas, yyyymmdd, ddmmyyyy, hhmm, digits) and width.",
    "gov_sa.refusal.mudad.iban_missing": "Row {row} ({employee}) is paid by bank and has no IBAN.",
    "gov_sa.refusal.mudad.iban_shape": "Row {row} ({employee}): an IBAN is SA and 22 digits.",
    "gov_sa.refusal.mudad.iban_checksum": "Row {row} ({employee}): the IBAN fails its check digits.",
    "gov_sa.refusal.mudad.bank_code": "The bank code {bank_code} is not the IBAN's own ({iban_bank}).",
    "gov_sa.refusal.mudad.bank_code_shape": "A bank code is the two digits a Saudi IBAN carries after SA and its check digits.",
    "gov_sa.refusal.mudad.id_missing": "Row {row} ({employee}) has no identity number.",
    "gov_sa.refusal.mudad.id_type": "Row {row} ({employee}): an identity type this file does not know.",
    "gov_sa.refusal.mudad.id_shape": "Row {row} ({employee}): the number is not the shape of a {id_type} (national ID 1…, iqama 2…, ten digits).",
    "gov_sa.refusal.mudad.amount": "Row {row} ({employee}): {fields} is not an amount.",
    "gov_sa.refusal.mudad.net": "Row {row} ({employee}): the net {net} is not basic + housing + transport + other − deductions ({expected}).",
    "gov_sa.refusal.mudad.net_negative": "Row {row} ({employee}): a negative net ({net}) cannot be transferred.",
    "gov_sa.refusal.mudad.total": "The lines add up to {lines}, the run's net is {run}.",
    "gov_sa.refusal.mudad.advance_unknown": "Payroll has not said it paid this advance.",
    "gov_sa.refusal.mudad.advance_lines_unavailable": "Payroll did not answer for this advance ({reason}), so no file was written.",
    "gov_sa.refusal.mudad.advance_other": "Payroll's line is for another advance or employee ({answered}).",
    "gov_sa.refusal.mudad.advance_general": "An advance file never carries the general entitlement: the line carries {fields}.",
    "gov_sa.refusal.mudad.advance_amount": "The advance is not an amount above zero.",
    "gov_sa.refusal.mudad.bank_not_approved": "Row {row} ({name}): the IBAN names bank {bank_code}, which the register does not approve on the pay day.",
    "gov_sa.warning.mudad.banks_empty": "No bank is approved in the register yet, so the banks were not checked.",
    "gov_sa.refusal.mudad.bic_shape": "A Saudi SWIFT code is four letters, SA, two characters and an optional branch.",
    "gov_sa.refusal.mudad.bank_exists": "Bank {code} is already approved; retire it before approving another row.",
    "gov_sa.refusal.mudad.bank_retired": "The bank is already retired.",
    "gov_sa.refusal.mudad.run_total_unknown": "Payroll did not say what the run's net is.",
    "gov_sa.refusal.mudad.file_invalid": "The run's lines have problems; no file was written.",
    "gov_sa.refusal.mudad.run_unknown": "Payroll has no such run.",
    "gov_sa.refusal.mudad.run_status": "The run is {status}: a WPS file is written for an approved or paid run.",
    "gov_sa.refusal.mudad.no_lines": "The run has no transfer lines.",
    "gov_sa.refusal.mudad.file_exists": "A {kind} file of this run already exists ({status}). Withdraw it before writing another.",
    "gov_sa.refusal.mudad.file_status": "The file is {status}, and this step does not apply.",
    "gov_sa.refusal.mudad.file_withdrawn": "A withdrawn file is not handed out.",
    "gov_sa.refusal.mudad.not_for_mudad": "The direct-transfer list does not go to Mudad.",
    "gov_sa.refusal.mudad.establishment_missing": "The layout needs the establishment's {field}: fill it in on the establishment screen.",
    "gov_sa.refusal.mudad.cr_number": "A commercial registration number is ten digits.",
    "gov_sa.refusal.mudad.unified_number": "The unified number is ten digits starting 7.",
    "gov_sa.refusal.mudad.signatory_id": "The signatory's identity number is ten digits starting 1 or 2.",
    "gov_sa.refusal.mudad.layout_key": "A layout key is lower-case letters, digits, dash or underscore, and not \"default\".",
    "gov_sa.refusal.mudad.layout_key_taken": "That key is already used.",
    "gov_sa.refusal.mudad.layout_spec": "The layout is not valid: {detail}",
    "gov_sa.refusal.mudad.layout_unknown": "No active layout has that key.",
    "gov_sa.refusal.mudad.layout_retired": "The layout is already retired.",
    "gov_sa.refusal.mudad.layout_in_use": "This is the establishment's default layout; choose another first.",
    "gov_sa.refusal.mudad.report_columns": "The report has no column for {missing}. Found: {found}.",
    "gov_sa.refusal.mudad.no_import": "No status report was imported for this file.",
    "gov_sa.warning.mudad.id_check_digit": "Row {row} ({employee}): the identity number's check digit does not verify. The row was kept — ⚠ the algorithm is not confirmed; check the number.",
    // identity · member ↔ person (#58)
    "screen.identity.people.column.person": "Person",
    "screen.identity.people.action.link_person": "This user is…",
    "screen.identity.people.action.link_person.field.party_id": "Person",
    "screen.identity.people.action.link_person.field.party_id.help": "The person on the register this user is. Only people nobody else is linked to are offered. From their next sign-in they see their own employment, payslips, leave and attendance.",
    "screen.identity.people.action.unlink_person": "Unlink the person",
    "screen.identity.people.action.unlink_person.field.reason": "Why",
    "screen.identity.people.action.unlink_person.field.reason.help": "Kept in the activity log. Their sessions in this workspace end, so nothing goes on showing them that person’s data.",
    "member.field.person": "Person",
    "member.person.none": "Not linked to a person",
    "member.field.service_ends_on": "Last working day",
    "member.field.source": "How they joined",
    "member.source.bootstrap": "Opened the workspace",
    "member.source.invitation": "Accepted an invitation",
    "member.source.added": "Added by an administrator",
    "member.source.admin_invitation": "Accepted an administrator's invitation",
    "member.source.unrecorded": "Not recorded (joined before this was kept)",
    "member.field.service_end_kept": "End of service",
    "member.serviceEndKept": "hr ended this person's service ({ref}). This sign-in was kept: it did not come from the employment and holds other roles. Review its roles.",
    // hr · self_service (#58)
    "group.self_service": "My services",
    "value.has_geofence.true": "Set",
    "value.has_geofence.false": "None",
    "value.invitation.not_asked": "Not asked for",
    "value.invitation.sent": "Made — copy the token below",
    "value.invitation.forbidden": "Not made: you may not invite people, or not with the employee role",
    "value.invitation.already_linked": "Not made: that address is already a user, or this person is already linked to one",
    "value.invitation.unavailable": "Not made: sign-in service did not answer — invite them from the users screen",
    // The hire as a page, and linking the person hired to a user already in the workspace.
    "value.system_access.none": "No system access",
    "value.system_access.invite": "Invite them by email",
    "value.system_access.user": "Link to an existing user",
    "value.user_link.not_asked": "Not asked for",
    "value.user_link.linked": "Linked — they see their own records from their next sign-in",
    "value.user_link.forbidden": "Not linked: you may not link users to people",
    "value.user_link.already_linked": "Not linked: that user is already somebody, or this person is already another user",
    "value.user_link.refused": "Not linked: the sign-in service refused it — see why below",
    "value.user_link.unavailable": "Not linked: sign-in service did not answer — link them from the users screen",
    // A list table draws five columns (three on a phone); the rest open under a row.
    'list.columns.shown': 'Showing {shown} of {total} columns',
    'list.columns.all': 'Show all columns',
    'list.stat.narrow': 'Show only the rows this figure counts',
    'list.columns.few': 'Show {n} columns',
    'list.expand.head': 'The other columns',
    'list.row.expand': 'Show the other columns',
    'list.row.collapse': 'Collapse',
    'list.folded.options': 'Sort or filter by the other columns',
    'list.folded.asc': '{column} — ascending',
    'list.folded.desc': '{column} — descending',
    'list.folded.filter': 'Filter by {column}…',
    'list.export.columns.heads': 'The {n} columns in the table',
    "record.position": "{at} of {of}",
    "record.prev": "Previous",
    "record.next": "Next",
    "record.back": "Back to {list}",
    "record.more": "More actions",
    "record.tab.overview": "Overview",
    "record.tab.history": "Change history",
    "record.alert.act": "Needs you",
    "record.alert.wait": "Waiting on others",
    "record.alert.info": "For your information",
    "record.alert.more": "+{n} more that need you",
    "record.alert.open": "Open it",
    "record.door.own": "Your own",
    "record.door.team": "As their manager",
    "record.card.asOf": "As of {at}",
    "record.due.late": "{days} late",
    "record.due.today": "Today",
    "record.due.in": "In {days}",
    "record.change.direct": "Direct edit",
    "record.change.correction": "Request a correction",
    "record.change.decision": "By decision",
    "record.change.immutable": "Does not change",
    "record.show": "Show",
    "record.hide": "Hide",
    "record.card.forbidden": "You have no permission to see this section",
    "record.card.unavailable": "Could not load {title} now",
    "record.card.timeout": "{title} took too long to answer",
    "record.open": "Open record",
    "record.open.named": "Open record: {name}",
    "ref.col.employment": "Employee",
    "ref.col.manager": "Manager",
    "ref.col.department": "Department",
    "ref.col.candidate": "Candidate",
    "ref.col.party": "Party",
    "ref.col.item": "Asset",
    "record.card.all": "View all",
    "record.card.ungrouped": "Uncategorised",
    "record.card.allCount": "View all ({n})",
    "record.card.meter.of": "{figure} of {whole}",
    "record.card.meter.share": "{share}%",
    "record.card.meter.none": "No target set",
    "record.cards.more": "+{n:more_sections}",
    "record.cards.fewer": "Show fewer sections",
    "record.from": "from {module}",
    "record.via": "via {entity}",
    "record.asIssued": "as at issue",
    "record.notFound": "This record could not be found, or it is not in this workspace",
    "record.navLabel": "Moving through the list",
    "record.headLabel": "The record's head",
    "record.alertsLabel": "Alerts",
    "screen.invoicing.document.action.pay": "Record a payment",
    "screen.invoicing.document.title": "Invoice",
    "screen.invoicing.document.column.party_name": "Customer, as at issue",
    "screen.invoicing.document.column.party_vat": "VAT number",
    "screen.invoicing.document.column.supply_on": "Supply date",
    "screen.invoicing.document.column.due_on": "Due",
    "screen.invoicing.document.column.allocated_total": "Paid",
    "screen.invoicing.document.column.open_amount": "Outstanding",
    "screen.invoicing.document.column.can_pay": "Payable",
    "screen.invoicing.document.column.journal_entry_id": "Journal entry",
    "screen.invoicing.document.alert.payment_due": "Outstanding — record a payment or allocate one",
    // ── finance record pages (begin) ──
    "unit.days.zero": "{n} days",
    "unit.days.one": "{n} day",
    "unit.days.two": "{n} days",
    "unit.days.few": "{n} days",
    "unit.days.many": "{n} days",
    "unit.days.other": "{n} days",
    "unit.results.zero": "no results",
    "unit.results.one": "{n} result",
    "unit.results.two": "{n} results",
    "unit.results.few": "{n} results",
    "unit.results.many": "{n} results",
    "unit.results.other": "{n} results",
    "unit.more_sections.zero": "{n} more sections",
    "unit.more_sections.one": "{n} more section",
    "unit.more_sections.two": "{n} more sections",
    "unit.more_sections.few": "{n} more sections",
    "unit.more_sections.many": "{n} more sections",
    "unit.more_sections.other": "{n} more sections",
    "record.history.note": "Changes to this record's fields only; other modules' decisions stay in their cards. One merged timeline is a later phase.",
    "screen.accounting.entry_lines_tab.title": "Entry",
    "screen.invoicing.vendor_bill.title": "Vendor bill",
    "screen.invoicing.vendor_bill.monogram": "VB",
    "screen.invoicing.vendor_bill.column.party_name": "Vendor as at issue",
    "screen.invoicing.vendor_bill.column.party_residency": "Residency",
    "screen.invoicing.vendor_bill.residency.resident": "Resident vendor",
    "screen.invoicing.vendor_bill.residency.non_resident": "Non-resident vendor",
    "screen.invoicing.vendor_bill.column.tax_total": "Input VAT",
    "screen.invoicing.vendor_bill.column.withholding_total": "Withholding tax",
    "screen.invoicing.vendor_bill.input_vat.deductible": "Deductible",
    "screen.invoicing.vendor_bill.input_vat.partly": "Partly deductible",
    "screen.invoicing.vendor_bill.input_vat.not_deductible": "Not deductible",
    "screen.invoicing.vendor_bill.input_vat.none_charged": "None charged",
    "screen.invoicing.vendor_bill.column.vat_quarter": "VAT return",
    "screen.invoicing.vendor_bill.quarter.q1": "Q1",
    "screen.invoicing.vendor_bill.quarter.q2": "Q2",
    "screen.invoicing.vendor_bill.quarter.q3": "Q3",
    "screen.invoicing.vendor_bill.quarter.q4": "Q4",
    "screen.invoicing.vendor_bill.column.withholding_standing": "Vendor",
    "screen.invoicing.vendor_bill.withholding.resident_exempt": "Resident · not subject",
    "screen.invoicing.vendor_bill.withholding.non_resident_withheld": "Non-resident · withheld",
    "screen.invoicing.vendor_bill.withholding.non_resident_none": "Non-resident · nothing withheld",
    "screen.invoicing.vendor_bill.withholding.amount": "Amount",
    "screen.invoicing.vendor_bill.withholding.note": "For a non-resident the withholding rate follows the kind of service, and the bill appears in the monthly withholding statement.",
    "screen.invoicing.vendor_bill.action.pay": "Pay",
    "screen.invoicing.vendor_bill.alert.overdue": "Payment was due on {due_on}",
    "screen.invoicing.vendor_bill.alert.payment_due": "Payment is due on {due_on}",
    "screen.invoicing.vendor_bill.alert.input_vat": "Input VAT {tax_total} is deducted in the {vat_quarter} return",
    "screen.invoicing.vendor_bill.due.late": "{days} overdue",
    "screen.invoicing.vendor_bill.due.today": "Due today",
    "screen.invoicing.vendor_bill.due.in": "In {days}",
    "screen.invoicing.vendor_bill.line.tax": "{tax_amount:money} · {tax_rate_snapshot:number}%",
    "screen.invoicing.vendor_bill.line.deductible": "Deductible",
    "screen.invoicing.vendor_bill.deductible.full": "Yes",
    "screen.invoicing.vendor_bill.deductible.partial": "Partly",
    "screen.invoicing.vendor_bill.deductible.none": "No",
    "screen.invoicing.vendor_bill.lines.note": "A posted bill is not edited: it is corrected by a credit or debit note that names it.",
    "screen.invoicing.vendor_bill.tab.withholding": "Withholding",
    "screen.invoicing.vendor_bill.card.payment.empty": "Not paid yet.",
    "screen.invoicing.payment.title": "Payment",
    "screen.invoicing.payment.head": "Payment {reference}",
    "screen.invoicing.payment.column.reference": "Reference",
    "screen.invoicing.payment.method.bank": "Bank transfer",
    "screen.invoicing.payment.method.cash": "Cash",
    "screen.invoicing.payment.method.other": "Other",
    "screen.invoicing.payment.column.paid_on": "Date",
    "screen.invoicing.payment.column.allocated_total": "Allocated",
    "screen.invoicing.payment.column.open_amount": "Not allocated",
    "screen.invoicing.payment.column.journal_name": "Bank account",
    "screen.invoicing.payment.column.allocation_state": "Allocation",
    "screen.invoicing.payment.allocation.unallocated": "Not allocated",
    "screen.invoicing.payment.allocation.partial": "Partly allocated",
    "screen.invoicing.payment.allocation.allocated": "Allocated",
    "screen.invoicing.payment.column.bank_match": "Bank match",
    "screen.invoicing.payment.bank_match.matched": "Matched",
    "screen.invoicing.payment.bank_match.unmatched": "Not matched",
    "screen.invoicing.payment.bank_match.words": "Matched to the line of {bank_statement_on:moment}",
    "screen.invoicing.payment.column.bank_statement_on": "Statement",
    "screen.invoicing.payment.column.bank_line_no": "Line",
    "screen.invoicing.payment.column.bank_match_kind": "Match kind",
    "screen.invoicing.payment.match_kind.item": "Item",
    "screen.invoicing.payment.match_kind.bank_charge": "Bank charge",
    "screen.invoicing.payment.column.can_allocate": "Can allocate",
    "screen.invoicing.payment.column.has_suggestion": "Has a proposal",
    "screen.invoicing.payment.action.allocate": "Allocate to invoices",
    "screen.invoicing.payment.action.save_allocation": "Save the allocation",
    "screen.invoicing.payment.alert.unallocated": "{open_amount} not allocated; the proposed allocation is ready to save",
    "screen.invoicing.payment.alert.nothing_open": "{open_amount} not allocated, and the party has no open document to allocate it to",
    "screen.invoicing.payment.alert.bank_matched": "Matched to line #{bank_line_no} of the {journal_name} statement of {bank_statement_on}",
    "screen.invoicing.payment.tab.allocation": "Allocation",
    "screen.invoicing.payment.tab.matching": "Matching",
    "screen.invoicing.payment.suggestion.title": "Proposed allocation",
    "screen.invoicing.payment.suggestion.column.number": "Invoice",
    "screen.invoicing.payment.suggestion.column.amount": "To allocate",
    "screen.invoicing.payment.suggestion.empty": "Nothing to propose: the payment is allocated, or the party has no open document.",
    "screen.invoicing.payment.suggestion.note": "Oldest due first; the amounts can be changed before saving.",
    "screen.invoicing.payment.allocations.title": "Allocations",
    "screen.invoicing.payment.allocations.empty": "Nothing is allocated from this payment yet.",
    "screen.invoicing.payment.bank.statement": "{journal_name} · {bank_statement_on:moment}",
    "screen.invoicing.payment.bank.line": "#{bank_line_no} · {bank_line_amount:money}",
    "screen.invoicing.payment.bank.empty": "Not matched to a statement line yet.",
    "screen.invoicing.payment.subtitle.provider_ref": "Bank reference {value}",
    "screen.accounting.entry_lines.open_number": "Open the entry {entry_number}",
    "screen.accounting.entry.title": "Entry",
    "screen.accounting.entry.head": "Entry {display_number}",
    "screen.accounting.entry.state.posted": "Posted",
    "screen.accounting.entry.state.draft": "Draft",
    "screen.accounting.entry.state.reversed": "Reversed",
    "screen.accounting.entry.column.journal_name": "Journal",
    "screen.accounting.entry.column.period_name": "Period",
    "screen.accounting.entry.period_status.open": "Open",
    "screen.accounting.entry.period_status.closing": "Being closed",
    "screen.accounting.entry.period_status.closed": "Closed",
    "screen.accounting.entry.period_status.reopened": "Reopened",
    "screen.accounting.entry.column.source_module": "Source",
    "screen.accounting.entry.source_module.invoicing": "Invoicing",
    "screen.accounting.entry.source_module.payroll": "Payroll",
    "screen.accounting.entry.column.poster": "Posted by",
    "screen.accounting.entry.poster.system": "The system (posting rule)",
    "screen.accounting.entry.poster.person": "A person",
    "screen.accounting.entry.column.posted_at": "Posted at",
    "screen.accounting.entry.posted_at": "{posted_at:at}",
    "screen.accounting.entry.column.debit_total": "Debit = credit",
    "screen.accounting.entry.column.balance": "Balance",
    "screen.accounting.entry.balance.balanced": "Balanced",
    "screen.accounting.entry.balance.unbalanced": "Not balanced",
    "screen.accounting.entry.column.reversed_by_number": "Reversed by",
    "screen.accounting.entry.column.reversal_of_number": "Reverses",
    "screen.accounting.entry.column.reverse_reason": "Reason",
    "screen.accounting.entry.column.reversal_state": "Reversal",
    "screen.accounting.entry.reversal.none": "Not reversed",
    "screen.accounting.entry.reversal.reversed": "Reversed",
    "screen.accounting.entry.reversal.reversal": "A reversing entry",
    "screen.accounting.entry.column.can_reverse": "Can be reversed",
    "screen.accounting.entry.subtitle.period": "Period {value}",
    "screen.accounting.entry.subtitle.source": "From: {value}",
    "screen.accounting.entry.alert.sourced_invoicing": "An entry with a source: it is reversed by a credit note from its document, not here",
    "screen.accounting.entry.alert.sourced": "An entry with a source: it is reversed from its source, not here",
    "screen.accounting.entry.alert.period_closing": "The period {period_name} is being closed: once closed, no entry is dated in it",
    "screen.accounting.entry.tab.lines": "Lines",
    "screen.accounting.entry.line.tax": "Tax",
    "screen.accounting.entry.line.tax_rate": "{tax_rate_snapshot:number}%",
    "screen.accounting.entry.line.no": "#",
    "screen.accounting.entry.card.reversal.text": "Not reversed. A reversal posts an opposite entry dated in an open period, and asks for a reason.",
    "screen.accounting.entry.history.note": "A posted entry does not change; it is corrected by a reversing entry. One merged timeline is a later phase.",
    "screen.invoicing.entry_source.title": "Source",
    "screen.invoicing.entry_source.column.module": "Module",
    "screen.invoicing.entry_source.module.invoicing": 'Invoicing',
    "screen.invoicing.entry_source.column.number": "Document",
    "screen.invoicing.entry_source.column.event": "Event",
    "screen.invoicing.entry_source.column.idempotency_key": "Idempotency key",
    "screen.invoicing.entry_source.empty": "Nothing in invoicing posted this entry.",
    "screen.invoicing.entry_source.note": "An entry with a source is reversed only from its document: the invoice is corrected by a credit note, and the entry is reversed with it.",
    "screen.accounting.entry.column.entry_date": "Entry date",
    "screen.accounting.entry.column.source_document_id": "Source document",
    "screen.accounting.entry.line.party": "Party",
    "unit.areas.zero": "{n} areas",
    "unit.areas.one": "{n} area",
    "unit.areas.two": "{n} areas",
    "unit.areas.few": "{n} areas",
    "unit.areas.many": "{n} areas",
    "unit.areas.other": "{n} areas",
    "unit.items.zero": "{n} items",
    "unit.items.one": "{n} item",
    "unit.items.two": "{n} items",
    "unit.items.few": "{n} items",
    "unit.items.many": "{n} items",
    "unit.items.other": "{n} items",
    "unit.rules.zero": "{n} posting rules",
    "unit.rules.one": "{n} posting rule",
    "unit.rules.two": "{n} posting rules",
    "unit.rules.few": "{n} posting rules",
    "unit.rules.many": "{n} posting rules",
    "unit.rules.other": "{n} posting rules",
    "screen.accounting.account.title": "Account",
    "screen.accounting.account.head": "{code} · {name_ar}",
    "screen.accounting.account.column.name_ar": "Name",
    "screen.accounting.account.field.name_en": "Name (English)",
    "screen.accounting.account.column.status": "Status",
    "screen.accounting.account.status.active": "Active",
    "screen.accounting.account.status.retired": "Retired",
    "screen.accounting.account.column.reconcile_mark": "Reconcilable",
    "screen.accounting.account.reconcile_mark.reconcilable": "Reconcilable",
    "screen.accounting.account.column.account_type": "Type",
    "screen.accounting.account.column.parent_name": "Parent",
    "screen.accounting.account.subtitle.parent": "Parent: {value}",
    "screen.accounting.account.subtitle.presentation": "Shown in the {value}",
    "screen.accounting.account.column.balance": "Balance now",
    "screen.accounting.account.balance": "{balance_abs:money} {balance_side}",
    "screen.accounting.account.column.balance_side": "Side",
    "screen.accounting.account.side.debit": "debit",
    "screen.accounting.account.side.credit": "credit",
    "screen.accounting.account.column.period": "Movement this month",
    "screen.accounting.account.period": "+{period_debit:number} / −{period_credit:number}",
    "screen.accounting.account.column.period_credit": "Credit this month",
    "screen.accounting.account.column.unreconciled_count": "Items not reconciled",
    "screen.accounting.account.column.last_movement_on": "Last movement",
    "screen.accounting.account.column.rules_count": "Posting rules",
    "screen.accounting.account.column.has_rules": "Used by posting rules",
    "screen.accounting.account.column.has_unreconciled": "Has unreconciled items",
    "screen.accounting.account.column.can_rename": "Can be renamed",
    "screen.accounting.account.action.rename": "Rename",
    "screen.accounting.account.action.reconcile": "Reconcile",
    "screen.accounting.account.alert.unreconciled": "{unreconciled_items} not reconciled in this account",
    "screen.accounting.account.alert.rules": "{rules_count} use it: retiring it needs another account for them",
    "screen.accounting.account.tab.ledger": "Ledger",
    "screen.accounting.account.tab.monthly": "Monthly balances",
    "screen.accounting.account.tab.parties": "By party",
    "screen.accounting.account.tab.dimensions": "By dimension",
    "screen.accounting.account.tab.rules": "Posting rules",
    "screen.accounting.account.ledger.column.entry_date": "Date",
    "screen.accounting.account.ledger.column.entry_number": "Entry",
    "screen.accounting.account.ledger.column.balance": "Balance",
    "screen.accounting.account.ledger.empty": "Nothing was posted to this account this month.",
    "screen.accounting.account.monthly.column.month": "Month",
    "screen.accounting.account.monthly.month": "{month:month}",
    "screen.accounting.account.monthly.column.closing_balance": "Closing balance",
    "screen.accounting.account.monthly.empty": "Nothing was ever posted to this account.",
    "screen.accounting.account.dimensions.column.value_name": "Value",
    "screen.accounting.account.dimensions.column.dimension_name": "Dimension",
    "screen.accounting.account.dimensions.empty": "No line of this account is tagged with a dimension.",
    "screen.accounting.account.rules.column.source_module": "Source",
    "screen.accounting.account.rules.column.line_kind": "Line kind",
    "screen.accounting.account.rules.source.invoicing": "Invoicing",
    "screen.accounting.account.rules.source.payroll": "Payroll",
    "screen.accounting.account.rules.empty": "No posting rule posts to this account.",
    "screen.accounting.account.parties.empty": "No line of this account names a party.",
    "screen.accounting.account.ledger.title_month": "Ledger — {entry_date:month}",
    "screen.accounting.account.ledger.export": "Export",
    "screen.accounting.ledger.title": "Ledger",
    "screen.accounting.ledger.lede": "Every posted line with the account's balance after it. Opened from an account's page, the ledger of that account.",
    "nav.accounting.ledger": "Ledger",
    "record.check.open": "Open",
    "record.check.state": "State",
    "unit.entries.zero": "{n} entries",
    "unit.entries.one": "{n} entry",
    "unit.entries.two": "{n} entries",
    "unit.entries.few": "{n} entries",
    "unit.entries.many": "{n} entries",
    "unit.entries.other": "{n} entries",
    "unit.draft_entries.zero": "No draft entries",
    "unit.draft_entries.one": "{n} draft entry",
    "unit.draft_entries.two": "{n} draft entries",
    "unit.draft_entries.few": "{n} draft entries",
    "unit.draft_entries.many": "{n} draft entries",
    "unit.draft_entries.other": "{n} draft entries",
    "unit.lines.zero": "{n} lines",
    "unit.lines.one": "{n} line",
    "unit.lines.two": "{n} lines",
    "unit.lines.few": "{n} lines",
    "unit.lines.many": "{n} lines",
    "unit.lines.other": "{n} lines",
    "unit.unmatched_lines.zero": "No unmatched statement lines",
    "unit.unmatched_lines.one": "A bank statement with {n} unmatched line",
    "unit.unmatched_lines.two": "A bank statement with {n} unmatched lines",
    "unit.unmatched_lines.few": "A bank statement with {n} unmatched lines",
    "unit.unmatched_lines.many": "A bank statement with {n} unmatched lines",
    "unit.unmatched_lines.other": "A bank statement with {n} unmatched lines",
    "screen.accounting.period.title": "Period",
    "screen.accounting.period.head": "Period {name_ar}",
    "screen.accounting.period.column.fiscal_year_name": "Fiscal year",
    "screen.accounting.period.subtitle.fiscal_year": "Fiscal year {value}",
    "screen.accounting.period.column.days": "Days",
    "screen.accounting.period.days": "{starts_on:moment} – {ends_on:moment}",
    "screen.accounting.period.status.open": "Open",
    "screen.accounting.period.status.closing": "Being closed",
    "screen.accounting.period.status.closed": "Closed",
    "screen.accounting.period.status.reopened": "Reopened",
    "screen.accounting.period.column.month_code": "Month",
    "screen.accounting.period.column.posted_count": "Posted entries",
    "screen.accounting.period.column.draft_count": "Drafts",
    "screen.accounting.period.column.revenue": "Revenue",
    "screen.accounting.period.column.expenses": "Expenses",
    "screen.accounting.period.column.net": "Net for the period",
    "screen.accounting.period.column.output_vat": "Output VAT",
    "screen.accounting.period.column.fiscal_lock_on": "Fiscal lock",
    "screen.accounting.period.column.tax_lock_on": "Tax lock",
    "screen.accounting.period.column.has_drafts": "Has drafts",
    "screen.accounting.period.column.can_start_closing": "Can start closing",
    "screen.accounting.period.column.can_close": "Can close",
    "screen.accounting.period.column.can_reopen": "Can reopen",
    "screen.accounting.period.column.is_closed": "Closed",
    "screen.accounting.period.action.start_closing": "Start closing",
    "screen.accounting.period.action.close": "Close the period",
    "screen.accounting.period.action.set_locks": "Change the lock dates",
    "screen.accounting.period.alert.drafts": "{draft_entries} in draft, to be posted or discarded before closing",
    "screen.accounting.period.checklist": "Closing checklist",
    "screen.accounting.period.tab.figures": "Figures",
    "screen.accounting.period.tab.vat": "VAT return",
    "screen.accounting.period.card.meaning": "What closing means",
    "screen.accounting.period.card.meaning.text": "No entry is dated in a closed period. A correction after it is an entry in an open period. Reopening asks for a reason and is recorded in the name of whoever reopens.",
    "screen.accounting.period.check.drafts": "Draft entries",
    "screen.accounting.period.check.detail": "Detail",
    "screen.accounting.period.check.detail.post_or_discard": "Posted or discarded before closing",
    "screen.accounting.period.check.trial": "Trial balance",
    "screen.accounting.period.check.trial.balanced": "The trial balance balances",
    "screen.accounting.period.check.trial.unbalanced": "The trial balance does not balance",
    "screen.accounting.period.check.trial.totals": "Totals",
    "screen.accounting.period.check.trial.totals_words": "Debit = credit = {debit_total:money}",
    "screen.invoicing.period.column.period_open": "Period open",
    "screen.invoicing.period.bank.title": "Bank statements",
    "screen.invoicing.period.bank.column.unmatched_lines": "Unmatched lines",
    "screen.invoicing.period.bank.column.statement": "Statement",
    "screen.invoicing.period.bank.column.statement_on": "Statement day",
    "screen.invoicing.period.bank.statement": "{journal_name} · {statement_on:moment}",
    "screen.invoicing.period.bank.alert": "{journal_name} statement of {statement_on}: {unmatched_lines} not matched",
    "screen.invoicing.period.vat.title": "VAT return",
    "screen.invoicing.period.vat.card": "VAT return of the quarter",
    "screen.invoicing.period.vat.column.filing": "VAT return",
    "screen.invoicing.period.vat.check_title": "The {quarter} VAT return {filing}",
    "screen.invoicing.period.vat.words.filed": "is filed",
    "screen.invoicing.period.vat.words.not_filed": "is not filed",
    "screen.invoicing.period.vat.words.q1": "Q1",
    "screen.invoicing.period.vat.words.q2": "Q2",
    "screen.invoicing.period.vat.words.q3": "Q3",
    "screen.invoicing.period.vat.words.q4": "Q4",
    "screen.invoicing.period.vat.filing.filed": "Filed",
    "screen.invoicing.period.vat.filing.not_filed": "Not filed",
    "screen.invoicing.period.vat.column.timing": "When",
    "screen.invoicing.period.vat.timing.after_period": "Filed after the quarter ends — it does not hold this period's closing",
    "screen.invoicing.period.vat.timing.with_period": "Due with this period's end",
    "screen.invoicing.period.vat.column.quarter": "Quarter",
    "screen.invoicing.period.vat.column.net_due": "Net due",
    "screen.invoicing.period.vat.alert": "The {quarter} VAT return is filed after the quarter ends, and does not hold this period's closing",
    "screen.einvoicing.period.title": "E-invoices reported",
    "screen.einvoicing.period.outcome.all_reported": "Every invoice is reported to the authority",
    "screen.einvoicing.period.outcome.not_all_reported": "Invoices the authority refused or has not answered",
    "screen.einvoicing.period.column.counts": "Refused and waiting",
    "screen.einvoicing.period.counts": "{missing_count} not sent · {rejected_count} refused · {pending_count} waiting",
    "screen.einvoicing.period.column.pending_count": "Waiting",
    "nav.invoicing.bank_accounts": "Bank accounts",
    "entity.invoicing.bank_account": "the bank account",
    "screen.invoicing.bank_accounts.title": "Bank accounts",
    "screen.invoicing.bank_accounts.lede": "Each bank journal with its account in the chart, its last statement and what is not matched yet.",
    "screen.invoicing.bank_account.title": "Bank account",
    "screen.invoicing.bank_account.monogram": "BK",
    "screen.invoicing.bank_account.column.name_ar": "Bank account",
    "screen.invoicing.bank_account.column.account_code": "Account in the chart",
    "screen.invoicing.bank_account.column.code": "Journal",
    "screen.invoicing.bank_account.column.iban": "IBAN",
    "screen.invoicing.bank_account.column.books_balance": "Balance in the books",
    "screen.invoicing.bank_account.column.statement_balance": "Balance on the last statement",
    "screen.invoicing.bank_account.column.difference": "Difference",
    "screen.invoicing.bank_account.column.last_statement_on": "Last statement",
    "screen.invoicing.bank_account.column.unmatched_lines": "Lines not matched",
    "screen.invoicing.bank_account.column.payments_in_transit": "Payments in transit",
    "screen.invoicing.bank_account.column.deposits_not_shown": "Deposits not shown",
    "screen.invoicing.bank_account.column.bank_only": "Statement lines not in the books",
    "screen.invoicing.bank_account.column.unexplained": "Unexplained",
    "screen.invoicing.bank_account.column.last_matched_at": "Last match",
    "screen.invoicing.bank_account.column.has_unmatched": "Has unmatched lines",
    "screen.invoicing.bank_account.column.has_unexplained": "Has an unexplained difference",
    "screen.invoicing.bank_account.column.can_reconcile": "Can reconcile",
    "screen.invoicing.bank_account.column.proposal": "Proposed",
    "screen.invoicing.bank_account.action.change_account": "Change the account in the chart",
    "screen.invoicing.bank_account.action.set_iban": "Change the IBAN",
    "screen.invoicing.bank_account.field.iban.help": "As the bank writes it: SA and twenty-two digits.",
    "screen.invoicing.bank_account.subtitle.code": "Bank journal {value}",
    "screen.invoicing.bank_account.subtitle.iban": "IBAN {value}",
    "screen.invoicing.bank_account.alert.unmatched": "{unmatched_words} not matched on the statements up to {last_statement_on}",
    "screen.invoicing.bank_account.alert.unexplained": "An unexplained difference of {unexplained} between the books and the statement",
    "screen.invoicing.bank_account.alert.last_match": "Last matched {last_matched_at}",
    "screen.invoicing.bank_account.tab.reconciliation": "Reconciliation",
    "screen.invoicing.bank_account.tab.statements": "Statements",
    "screen.invoicing.bank_account.tab.movements": "Movements",
    "screen.invoicing.bank_account.card.difference": "The difference between the books and the statement",
    "screen.invoicing.bank_account.card.difference.empty": "No statement states its closing balance yet: the difference is found once one does.",
    "screen.invoicing.bank_account.unmatched.empty": "Every statement line is matched.",
    "screen.invoicing.bank_account.statements.column.line_count": "Lines",
    "screen.invoicing.bank_account.statements.column.unmatched_count": "Not matched",
    "screen.invoicing.bank_account.statements.column.closing_balance": "Closing balance",
    "screen.invoicing.bank_account.statements.empty": "No statement is imported for this account yet.",
    "screen.invoicing.bank_account.movements.empty": "Nothing moved on this account yet.",
    "screen.invoicing.bank_reconciliation.action.import.field.closing_balance": "Closing balance",
    "screen.invoicing.bank_reconciliation.action.import.field.closing_balance.help": "The balance the statement ends on, as printed on it. Leave it empty if the statement does not say.",
    "screen.accounting.journals.action.edit.field.iban": "IBAN",
    "screen.accounting.journals.action.edit.field.iban.help": "For a bank journal: the account's IBAN, as the bank writes it.",
    "screen.invoicing.bank_account.action.accept": "Accept",
    "screen.invoicing.bank_account.action.search": "Search",
    "screen.invoicing.bank_account.column.has_proposal": "Has a proposal",
    "unit.attempts.zero": "{n} attempts",
    "unit.attempts.one": "{n} attempt",
    "unit.attempts.two": "{n} attempts",
    "unit.attempts.few": "{n} attempts",
    "unit.attempts.many": "{n} attempts",
    "unit.attempts.other": "{n} attempts",
    "screen.einvoicing.device.title": 'EGS unit',
    "screen.einvoicing.device.monogram": "EG",
    "screen.einvoicing.device.column.label": "Device",
    "screen.einvoicing.device.column.standing": "State",
    "screen.einvoicing.device.standing.active_production": "Active · production",
    "screen.einvoicing.device.standing.active_sandbox": "Active · sandbox",
    "screen.einvoicing.device.standing.active_issue_only": "Active · issue only",
    "screen.einvoicing.device.standing.retired": "Retired",
    "screen.einvoicing.device.column.journal_code": "Sales journal",
    "screen.einvoicing.device.column.seller_name": "Seller",
    "screen.einvoicing.device.column.reported_count": "Reported or cleared",
    "screen.einvoicing.device.column.pending_count": "Waiting",
    "screen.einvoicing.device.column.rejected_count": "Refused",
    "screen.einvoicing.device.column.connector_state": "Authority",
    "screen.einvoicing.device.connector_state.available": "Available",
    "screen.einvoicing.device.connector_state.circuit_open": "Not reachable — circuit open",
    "screen.einvoicing.device.connector_state.issue_only": "Issue only",
    "screen.einvoicing.device.reported_words": "{reported_count}",
    "screen.einvoicing.device.pending_words": "{pending_count} waiting",
    "screen.einvoicing.device.rejected_words": "{rejected_count} refused",
    "screen.einvoicing.device.column.next_icv": "Next counter",
    "screen.einvoicing.device.column.last_icv": "Last ICV",
    "screen.einvoicing.device.column.last_hash": "Last hash",
    "screen.einvoicing.device.column.production_csid": "Production certificate (CSID)",
    "screen.einvoicing.device.until_month": "Until {production_csid_expires_on:month}",
    "screen.einvoicing.device.column.onboarded_at": "Onboarded",
    "screen.einvoicing.device.column.circuit": "Connector",
    "screen.einvoicing.device.circuit.closed": "Circuit closed",
    "screen.einvoicing.device.circuit.open": "Circuit open",
    "screen.einvoicing.device.circuit_words": "{circuit} · {consecutive_failures} errors",
    "screen.einvoicing.device.column.consecutive_failures": "Errors",
    "screen.einvoicing.device.column.chain_state": "Chain check",
    "screen.einvoicing.device.chain_state.connected": "Connected",
    "screen.einvoicing.device.chain_state.broken": "Broken",
    "screen.einvoicing.device.column.rejected_number": "Refused document",
    "screen.einvoicing.device.column.attempts": "Attempt",
    "screen.einvoicing.device.column.rejected_at": "Refused on",
    "screen.einvoicing.device.column.pending_number": "Waiting document",
    "screen.einvoicing.device.column.certificate_soon": "Certificate ends soon",
    "screen.einvoicing.device.column.can_onboard": "Can onboard",
    "screen.einvoicing.device.column.can_renew": "Can renew",
    "screen.einvoicing.device.action.onboard": "Onboard with the authority",
    "screen.einvoicing.device.action.renew": "Renew the certificate",
    "screen.einvoicing.device.action.resubmit": "Send again",
    "screen.einvoicing.device.field.production_csid_expires_on": "Production certificate valid until",
    "screen.einvoicing.device.field.production_csid_expires_on.help": "As the authority issued it.",
    "screen.einvoicing.device.subtitle.branch": "Branch {value}",
    "screen.einvoicing.device.subtitle.journal": "Sales journal {value}",
    "screen.einvoicing.device.subtitle.seller": "Seller: {value}",
    "screen.einvoicing.device.alert.rejected": "{rejected_number} refused after {rejected_attempts}",
    "screen.einvoicing.device.alert.waiting": "{pending_number} waiting for the authority's answer · attempt {pending_attempt}",
    "screen.einvoicing.device.alert.certificate_ends": "The production certificate ends on {production_csid_expires_on}",
    "screen.einvoicing.device.alert.certificate": "The production certificate is valid until {production_csid_expires_on}",
    "screen.einvoicing.device.tab.documents": "Documents",
    "screen.einvoicing.device.tab.attempts": "Attempts",
    "screen.einvoicing.device.tab.seller": "Seller",
    "screen.einvoicing.device.tab.certificates": "Certificates",
    "screen.einvoicing.device.card.chain": "Hash chain",
    "screen.einvoicing.device.card.chain.note": "Each document carries the hash of the one before it: a gap in the counter or a break in the chain is refused by the authority.",
    "screen.einvoicing.device.card.attention": "Documents that need action",
    "screen.einvoicing.device.attention.column.number": "Document",
    "screen.einvoicing.device.attention.column.report_status": "State",
    "screen.einvoicing.device.attention.column.can_submit": "Can send",
    "screen.einvoicing.device.attention.empty": "The authority has every document of this device.",
    "screen.einvoicing.device.report_status.rejected": "Refused",
    "screen.einvoicing.device.report_status.pending": "Waiting",
    "screen.einvoicing.device.report_status.unreachable": "Not reached",
    "screen.einvoicing.device.attempts.column.environment": "Environment",
    "screen.einvoicing.device.attempts.column.response_status": "Answer",
    "screen.einvoicing.device.attempts.column.created_at": "When",
    "screen.einvoicing.device.attempts.empty": "Nothing of this device was sent to the authority yet.",
    "screen.einvoicing.device.environment.compliance": "Compliance",
    "screen.einvoicing.device.environment.production": "Production",
    "screen.einvoicing.device.environment.sandbox": "Sandbox",
    "screen.einvoicing.device.environment.issue_only": "Issue only",
    "screen.einvoicing.device.response_status.accepted": "Accepted",
    "screen.einvoicing.device.response_status.accepted_with_warnings": "Accepted with warnings",
    "screen.einvoicing.device.response_status.rejected": "Refused",
    "screen.einvoicing.device.response_status.unreachable": "Not reached",
    "screen.einvoicing.device.response_status.not_sent": "Not sent",
    "screen.einvoicing.device.seller.column.legal_name": "Legal name",
    "screen.einvoicing.device.seller.column.cr_number": "Commercial registration",
    "screen.einvoicing.device.seller.column.address": "Address",
    "screen.einvoicing.device.seller.column.city": "City",
    "screen.einvoicing.device.seller.column.postcode": "Postcode",
    "screen.einvoicing.device.seller.address": "{address_state} · {city} {postcode}",
    "screen.einvoicing.device.address_state.complete": "Complete",
    "screen.einvoicing.device.address_state.incomplete": "Incomplete",
    "screen.einvoicing.device.seller.empty": "No seller is registered for this device's branch.",
    "screen.einvoicing.device.certificates.column.certificate": "Certificate",
    "screen.einvoicing.device.certificates.column.expires_on": "Ends",
    "screen.einvoicing.device.month": "{expires_on:month}",
    "screen.invoicing.device_month_documents.title": "Documents this month",
    "screen.einvoicing.device.column.rejected_reason": "Refusal reason",
    "screen.einvoicing.device.alert.rejected_reason": "{rejected_number} refused after {rejected_attempts}: {rejected_reason}",
    "screen.einvoicing.device.attention.column.reason": "Reason",
    "screen.einvoicing.document_edocument.col.rejected_reason": "Refusal reason",
    // ── finance record pages (end) ──
    "screen.invoicing.document.alert.draft": "A draft: nothing is posted until it is issued",
    "screen.invoicing.document.tab.lines": "Lines",
    "screen.invoicing.document.line.description": "Description",
    "screen.invoicing.document.line.quantity": "Quantity",
    "screen.invoicing.document.line.unit_price": "Price",
    "screen.invoicing.document.line.discount": "Discount",
    "screen.invoicing.document.line.tax_amount": "Tax",
    "screen.invoicing.document.line.line_total": "Total",
    "screen.invoicing.document_allocations.title": "Payments",
    "screen.invoicing.document_allocations.empty": "No payment is allocated to this invoice yet.",
    "screen.einvoicing.document_edocument.title": "E-invoice",
    "screen.einvoicing.document_edocument.column.device": "Device",
    "screen.einvoicing.document_edocument.empty": "No e-document yet: one is made when the invoice is issued.",
    "screen.einvoicing.document_edocument.alert": "The authority has not taken the e-invoice yet",
    "screen.accounting.entry_lines.title": "Journal entry",
    "screen.accounting.entry_lines.column.account": "Account",
    "screen.accounting.entry_lines.column.account_name": "Account name",
    "screen.accounting.entry_lines.column.debit": "Debit",
    "screen.accounting.entry_lines.column.credit": "Credit",
    "screen.accounting.entry_lines.empty": "The entry has no lines.",
    "documents.party_documents.title": "Documents",
    "documents.party_documents.empty": "No document is filed for this party.",
    "entity.parties.party": "the party",
    "entity.accounting.entry": "the journal entry",
    "record.changes.field": "Field",
    "record.changes.from": "From",
    "record.changes.to": "To",
    "record.changes.by": "By",
    "record.changes.when": "When",
    "record.changes.note": "Changes to this record's own fields only; what other modules decide stays in their cards.",
    "record.changes.decision": "decision #{n}",
    "record.history.phase.before_posting": "before posting",
    "unit.years.zero": "{n} years",
    "unit.years.one": "{n} year",
    "unit.years.two": "{n} years",
    "unit.years.few": "{n} years",
    "unit.years.many": "{n} years",
    "unit.years.other": "{n} years",
    "unit.seats.zero": "{n} seats",
    "unit.seats.one": "{n} seat",
    "unit.seats.two": "{n} seats",
    "unit.seats.few": "{n} seats",
    "unit.seats.many": "{n} seats",
    "unit.seats.other": "{n} seats",
    "documents.candidate_documents.empty": "No document is filed for this candidate.",
    "record.changes.record": "Record",
    "record.changes.created": "Created",
    "value.moment.today": "Today {time}",
    "value.span.from": "From {day}",
    "value.span.until": "Until {day}",
    "value.moment.tomorrow": "Tomorrow {time}",
    "value.moment.yesterday": "Yesterday {time}",
    "value.moment.today_day": "Today",
    "value.moment.tomorrow_day": "Tomorrow",
    "value.moment.yesterday_day": "Yesterday",
    "record.due.since": "Since {day}",
    "screen.invoicing.document.kind.customer_invoice": "Invoice",
    "screen.invoicing.document.kind.credit_note": "Credit note",
    "screen.invoicing.document.kind.debit_note": "Debit note",
    "screen.invoicing.document.kind.vendor_bill": "Vendor bill",
    "screen.invoicing.document.state.draft": "Draft",
    "screen.invoicing.document.state.posted": "Posted",
    "screen.invoicing.document.state.validated": "Validated",
    "screen.invoicing.document.state.cancelled_by_note": "Cancelled by a note",
    "screen.invoicing.document.classification.standard": "Standard tax invoice",
    "screen.invoicing.document.classification.simplified": "Simplified tax invoice",
    "screen.invoicing.document.column.payment_state": "Payment",
    "screen.invoicing.document.payment.outstanding": "Not paid",
    "screen.invoicing.document.payment.partial": "Partly paid",
    "screen.invoicing.document.payment.paid": "Paid",
    "screen.invoicing.document.column.party_address": "Address",
    "screen.invoicing.document.column.subtotal": "Before tax",
    "screen.invoicing.document.column.discount_total": "Discount",
    "screen.invoicing.document.column.tax_total": "VAT",
    "screen.invoicing.document.status.posting": "Posting",
    "screen.invoicing.document.status.due": "Due",
    "screen.invoicing.document.due.late": "{days} overdue",
    "screen.invoicing.document.due.today": "Due today",
    "screen.invoicing.document.due.in": "Due in {days}",
    "screen.invoicing.document.head": "{kind} {number}",
    "screen.invoicing.document.as_issued": "As at issue",
    "screen.invoicing.document.subtitle.vat": "VAT number {value}",
    "screen.invoicing.document.lines.note": "A posted invoice is not edited: it is corrected by a credit or debit note that names it.",
    "screen.invoicing.document.tab.payments": "Payments",
    "screen.invoicing.document.tab.notes": "Notes",
    "screen.invoicing.document.card.customer": "The customer as at issue",
    "screen.invoicing.document.card.customer.note": "Kept with the invoice: changing the customer's details later does not change it.",
    "screen.invoicing.document_allocations.action.pay": "Allocate a payment",
    "screen.invoicing.document_notes.title": "Related notes",
    "screen.invoicing.document_notes.empty": "No credit or debit note names this invoice.",
    "screen.einvoicing.document_edocument.note": "A simplified invoice is reported within 24 hours; a standard one is cleared before it is handed to the buyer.",
    "screen.einvoicing.document_cleared.title": 'Accepted by the authority',
    "screen.einvoicing.document_cleared.alert": 'Accepted by the authority ({path}) on {last_attempt_at}',
    "screen.accounting.entry_lines.total": "Total",
    "screen.accounting.entry_lines.open": "Open the entry",
    "change.field.document.due_on": "Due date",
    "hub.flag.no_evidence": "No document attached",
    // ── entity record pages (hr): employee, asset, vacancy, end of service, violation, party ──
    "change.field.party.nationality": "Nationality",
    "change.field.party.phone": "Mobile",
    "change.field.account.account_type": "Type",
    "change.field.account.code": "Code",
    "change.field.account.name_ar": "Name",
    "change.field.account.name_en": "Name (English)",
    "change.field.account.parent_id": "Parent",
    "change.field.account.presentation": "Presentation",
    "change.field.account.reconcilable": "Reconcilable",
    "change.field.account.retired_at": "Retired on",
    "change.field.announcement.audience": "Audience",
    "change.field.announcement.body": "Text",
    "change.field.announcement.created_by": "Created by",
    "change.field.announcement.publication": "Status",
    "change.field.announcement.published_at": "Published",
    "change.field.announcement.published_by": "Published by",
    "change.field.announcement.roles": "Roles",
    "change.field.announcement.title": "Title",
    "change.field.announcement.withdrawn_at": "Withdrawn on",
    "change.field.announcement.withdrawn_by": "Withdrawn by",
    "change.field.announcement.comments_allowed": "Comments allowed",
    "change.field.thanks.from_user": "From",
    "change.field.thanks.to_user": "To",
    "change.field.thanks.message": "Message",
    "change.field.thanks.public": "Shown to everybody",
    "change.field.chat.member_a": "Member",
    "change.field.chat.member_b": "Member",
    "change.field.chat.created_by": "Started by",
    "change.field.chat_settings.retention_days": "Chat messages kept in view (days)",
    "change.field.assignment.created_by": "Created by",
    "change.field.bank_statement.account_id": "Account in the chart",
    "change.field.bank_statement.amount": "Amount",
    "change.field.bank_statement.booked_on": "Date",
    "change.field.bank_statement.closing_balance": "Closing balance",
    "change.field.bank_statement.created_by": "Created by",
    "change.field.bank_statement.fingerprint": "Fingerprint",
    "change.field.bank_statement.id": "Id",
    "change.field.bank_statement.journal_id": "Journal",
    "change.field.bank_statement.line_count": "Lines",
    "change.field.bank_statement.line_no": "Line",
    "change.field.bank_statement.match_kind": "Match kind",
    "change.field.bank_statement.matched_at": "Matched on",
    "change.field.bank_statement.matched_entry_id": "Matched entry",
    "change.field.bank_statement.matched_item_id": "Matched item",
    "change.field.bank_statement.narration": "Narration",
    "change.field.bank_statement.statement_on": "Statement date",
    "change.field.branch.code": "Code",
    "change.field.branch.name": "Branch",
    "change.field.branch.status": "Status",
    "change.field.calendar_settings.hijri_display": "Hijri date on screens",
    "change.field.calendar_settings.language": "Workspace language",
    "change.field.calendar_settings.hijri_reference": "Hijri reference",
    "change.field.calendar_settings.time_zone": "Time zone",
    "change.field.campaign.created_by": "Created by",
    "change.field.campaign.name": "Campaign",
    "change.field.campaign.status": "Status",
    "change.field.case.closed_at": "Closed on",
    "change.field.case.id": "Identifier",
    "change.field.case.note": "Note",
    "change.field.chart_mapping.external_account": "External account",
    "change.field.chart_mapping.source_code": "Local code",
    "change.field.chart_mapping.source_kind": "Kind",
    "change.field.connector.environment": "Environment",
    "change.field.connector.production_switched_at": "Switched to production on",
    "change.field.connector.production_switched_by": "Switched to production by",
    "change.field.connector.vault_secret_ref": "Vault ref",
    "change.field.contract.created_by": "Created by",
    "change.field.contract.reason": "Note",
    "change.field.device.branch_code": "Branch",
    "change.field.device.certificate_ref": "Certificate",
    "change.field.device.compliance_csid_ref": "Compliance CSID vault ref",
    "change.field.device.csr_vault_ref": "CSR vault ref",
    "change.field.device.id": "Identifier",
    "change.field.device.label": "Label",
    "change.field.device.onboarded_at": "Onboarded",
    "change.field.device.otp_vault_ref": "OTP vault ref",
    "change.field.device.production_csid_expires_on": "Production certificate (CSID)",
    "change.field.device.production_csid_ref": "Production CSID vault ref",
    "change.field.device.sales_journal_id": "Sales journal",
    "change.field.device.state": "State",
    "change.field.dimension.code": "Code",
    "change.field.dimension.name_ar": "Name (AR)",
    "change.field.dimension.name_en": "Name (EN)",
    "change.field.dimension.retired_at": "Retired on",
    "change.field.dimension_value.code": "Code",
    "change.field.dimension_value.dimension_id": "Dimension",
    "change.field.dimension_value.name_ar": "Name (AR)",
    "change.field.dimension_value.name_en": "Name (EN)",
    "change.field.dimension_value.retired_at": "Retired on",
    "change.field.document.account_id": "Account in the chart",
    "change.field.document.allocated_total": "Paid",
    "change.field.document.branch_code": "Branch",
    "change.field.document.classification": "Classification",
    "change.field.document.classification_override_reason": "Reason for overriding the classification",
    "change.field.document.created_by": "Created by",
    "change.field.document.currency": "Currency",
    "change.field.document.decision_number": "Decision number",
    "change.field.document.deductible": "Deductible",
    "change.field.document.description_ar": "Description (Arabic)",
    "change.field.document.description_en": "Description (English)",
    "change.field.document.discount": "Discount",
    "change.field.document.discount_total": "Discount",
    "change.field.document.effective_on": "In force from",
    "change.field.document.expires_on": "Ends on",
    "change.field.document.file_name": "Copy",
    "change.field.document.file_size": "File size",
    "change.field.document.file_type": "File type",
    "change.field.document.id": "Id",
    "change.field.document.issue_on": "Issue date",
    "change.field.document.issued_by": "Issued by",
    "change.field.document.issued_on": "Issued on",
    "change.field.document.journal_entry_id": "Journal entry",
    "change.field.document.journal_id": "Journal",
    "change.field.document.kind": "Kind",
    "change.field.document.line_no": "Line",
    "change.field.document.line_total": "Line total",
    "change.field.document.media_id": "Media",
    "change.field.document.source_ref": "Filed from",
    "change.field.document.name": "Name",
    "change.field.document.notes": "Notes",
    "change.field.document.number": "Number",
    "change.field.document.original_document_id": "Original document",
    "change.field.document.owner_kind": "Whose",
    "change.field.document.owner_label": "Owner's name",
    "change.field.document.owner_ref": "Owner reference",
    "change.field.document.party_id": "Party",
    "change.field.document.party_snapshot": "Party as recorded",
    "change.field.document.payment_term_id": "Payment terms",
    "change.field.document.previous_id": "Previous",
    "change.field.document.quantity": "Quantity",
    "change.field.document.reason_code": "Reason",
    "change.field.document.ref_key": "Key",
    "change.field.document.state": "State",
    "change.field.document.status": "Validity",
    "change.field.document.subtotal": "Before tax",
    "change.field.document.superseded_at": "Superseded on",
    "change.field.document.supply_on": "Supply date",
    "change.field.document.tax_amount": "Tax amount",
    "change.field.document.tax_code_id": "Tax code",
    "change.field.document.tax_rate_snapshot": "Tax rate as applied",
    "change.field.document.tax_total": "VAT",
    "change.field.document.total": "Total",
    "change.field.document.type_id": "Type",
    "change.field.document.unit_price": "Unit price",
    "change.field.document.version_no": "Version",
    "change.field.document.withdraw_reason": "Withdrawal reason",
    "change.field.document.withdrawn_at": "Withdrawn on",
    "change.field.document.withdrawn_by": "Withdrawn by",
    "change.field.document.destroyed_at": "Destroyed on",
    "change.field.document.destroyed_by": "Destroyed by",
    "change.field.document.destroyed_keep_until": "Kept until",
    "change.field.document.file_removed_at": "Copy removed on",
    "change.field.document.legal_hold": "Legal hold",
    "change.field.document.legal_hold_reason": "Legal hold reason",
    "change.field.document.legal_hold_at": "Legal hold changed on",
    "change.field.document.legal_hold_by": "Legal hold changed by",
    "change.field.owner_anchor.owner_ref": "Owner reference",
    "change.field.owner_anchor.ended_on": "Relationship ended on",
    "change.field.owner_anchor.reason": "Reason",
    "change.field.owner_anchor.set_by": "Recorded by",
    "change.field.document.withholding_amount": "Withholding amount",
    "change.field.document.withholding_tax_code_id": "Withholding tax code",
    "change.field.document.withholding_total": "Withholding",
    "change.field.edocument.device_id": "Device",
    "change.field.edocument.document_id": "Document",
    "change.field.edocument.hash": "Hash",
    "change.field.edocument.icv": "ICV",
    "change.field.edocument.previous_hash": "Previous hash",
    "change.field.edocument.profile_id": "Profile",
    "change.field.edocument.qr_payload": "QR",
    "change.field.edocument.report_status": "Report status",
    "change.field.edocument.uuid": "UUID",
    "change.field.edocument.xml_hash": "XML hash",
    "change.field.entry.account_id": "Account",
    "change.field.entry.credit": "Credit",
    "change.field.entry.currency": "Currency",
    "change.field.entry.debit": "Debit",
    "change.field.entry.due_on": "Due",
    "change.field.entry.entry_date": "Date",
    "change.field.entry.full_reconcile_id": "Full reconciliation",
    "change.field.entry.id": "Identifier",
    "change.field.entry.journal_id": "Journal",
    "change.field.entry.line_no": "Line",
    "change.field.entry.narration_ar": "Narration",
    "change.field.entry.narration_en": "Narration (English)",
    "change.field.entry.number": "Number",
    "change.field.entry.party_id": "Party",
    "change.field.entry.period_id": "Period",
    "change.field.entry.posted_at": "Posted at",
    "change.field.entry.posted_by": "Posted by",
    "change.field.entry.reconciled_at": "Reconciled on",
    "change.field.entry.reversal_of_id": "Reversal of",
    "change.field.entry.reverse_reason": "Reason",
    "change.field.entry.reversed_by_id": "Reversed by",
    "change.field.entry.source_event_id": "Source event",
    "change.field.entry.source_module": "Source",
    "change.field.entry.source_ref": "Source",
    "change.field.entry.state": "State",
    "change.field.entry.tax_base": "Tax base",
    "change.field.entry.tax_code_id": "Tax code",
    "change.field.entry.tax_rate_snapshot": "Tax rate as applied",
    "change.field.establishment.account_iban": "Account IBAN",
    "change.field.establishment.bank_code": "Bank code",
    "change.field.establishment.bank_name": "Bank",
    "change.field.establishment.compliance_threshold": "Threshold (%)",
    "change.field.establishment.cr_number": "Commercial registration",
    "change.field.establishment.default_layout": "Default layout",
    "change.field.establishment.fine_per_worker": "Fine per worker",
    "change.field.establishment.freeze_after_months": "Freeze after (months)",
    "change.field.establishment.mudad_establishment_id": "Mudad establishment ID",
    "change.field.establishment.name": "Name",
    "change.field.establishment.signatory_id_number": "Signatory's identity number",
    "change.field.establishment.signatory_name": "Signatory",
    "change.field.establishment.transfer_after_months": "Transfer after (months)",
    "change.field.establishment.unified_number": "Unified number",
    "change.field.establishment.upload_window_days": "Upload window (days)",
    "change.field.export_batch.approved_by": "Approved by",
    "change.field.export_batch.booked_on": "Date",
    "change.field.export_batch.confirmed_at": "Confirmed on",
    "change.field.export_batch.credit": "Credit",
    "change.field.export_batch.debit": "Debit",
    "change.field.export_batch.description": "Description",
    "change.field.export_batch.external_account": "External account",
    "change.field.export_batch.external_ref": "External reference",
    "change.field.export_batch.fingerprint": "Fingerprint",
    "change.field.export_batch.format": "Format",
    "change.field.export_batch.id": "Id",
    "change.field.export_batch.line_count": "Lines",
    "change.field.export_batch.line_no": "Line",
    "change.field.export_batch.period_from": "From",
    "change.field.export_batch.period_to": "To",
    "change.field.export_batch.produced_by": "Produced by",
    "change.field.export_batch.scope": "Scope",
    "change.field.export_batch.source_code": "Local code",
    "change.field.export_batch.source_id": "Source record",
    "change.field.export_batch.source_kind": "Kind",
    "change.field.export_batch.state": "State",
    "change.field.file.content": "Content",
    "change.field.file.due_on": "Due on",
    "change.field.file.generated_at": "Generated on",
    "change.field.file.generated_by": "Generated by",
    "change.field.file.kind": "Kind",
    "change.field.file.layout": "Layout",
    "change.field.file.pay_date": "Pay date",
    "change.field.file.rows": "Rows",
    "change.field.file.run_id": "Payroll run",
    "change.field.file.run_period": "Run period",
    "change.field.file.status": "Status",
    "change.field.file.total": "Total",
    "change.field.file.uploaded_at": "Uploaded on",
    "change.field.file.uploaded_on": "Uploaded on",
    "change.field.file.withdraw_reason": "Withdrawal reason",
    "change.field.file.advance_id": "Advance",
    "change.field.bank.code": "Bank code",
    "change.field.bank.name_ar": "Bank name",
    "change.field.bank.name_en": "Bank name in English",
    "change.field.bank.bic": "SWIFT code",
    "change.field.bank.valid_from": "Approved from",
    "change.field.bank.status": "Status",
    "change.field.bank.created_by": "Approved by",
    "change.field.bank.retired_by": "Retired by",
    "change.field.bank.retired_at": "Retired at",
    "change.field.file.withdrawn_at": "Withdrawn on",
    "change.field.file.withdrawn_by": "Withdrawn by",
    "change.field.fiscal_year.calendar": "Calendar",
    "change.field.fiscal_year.ends_on": "To",
    "change.field.fiscal_year.name_ar": "Name",
    "change.field.fiscal_year.name_en": "Name (English)",
    "change.field.fiscal_year.starts_on": "From",
    "change.field.fiscal_year.status": "Status",
    "change.field.form.approver_kind": "Approver",
    "change.field.form.approver_role": "Decided by role",
    "change.field.form.archived_at": "Archived on",
    "change.field.form.archived_by": "Archived by",
    "change.field.form.audience": "For",
    "change.field.form.category": "Category",
    "change.field.form.created_by": "Created by",
    "change.field.form.default_value": "Default value",
    "change.field.form.description_ar": "Description (Arabic)",
    "change.field.form.description_en": "Description (English)",
    "change.field.form.document_type_key": "Document type",
    "change.field.form.help_ar": "Help (Arabic)",
    "change.field.form.help_en": "Help (English)",
    "change.field.form.icon": "Icon",
    "change.field.form.id": "Id",
    "change.field.form.key": "Key",
    "change.field.form.label_ar": "Label (Arabic)",
    "change.field.form.label_en": "Label (English)",
    "change.field.form.may_edit": "May edit",
    "change.field.form.may_return": "May return",
    "change.field.form.name_ar": "Form",
    "change.field.form.name_en": "Name (English)",
    "change.field.form.options": "Options",
    "change.field.form.position": "Order",
    "change.field.form.published_at": "Published",
    "change.field.form.published_by": "Published by",
    "change.field.form.required": "Required",
    "change.field.form.retired_at": "Retired on",
    "change.field.form.revision": "Revision",
    "change.field.form.rules": "Rules",
    "change.field.form.section": "Section",
    "change.field.form.sections": "Sections",
    "change.field.form.sla_hours": "SLA (hours)",
    "change.field.form.status": "Status",
    "change.field.form.type": "Type",
    "change.field.form.visible_when": "Visible when",
    "change.field.gosi_settings.exclude_within_days": "Exclude within (days)",
    "change.field.gosi_settings.last_refreshed_at": "Last refreshed on",
    "change.field.gosi_settings.last_refreshed_by": "Last refreshed by",
    "change.field.gosi_settings.new_scheme_from": "New scheme from",
    "change.field.gosi_settings.maternity_leave_types": "Leave types that are a maternity leave",
    "change.field.gosi_settings.maternity_notice_within_days": "Days to notify a maternity leave",
    "change.field.gosi_settings.register_within_days": "Register within (days)",
    "change.field.item.created_by": "Created by",
    "change.field.item.done_at": "Done on",
    "change.field.item.done_by": "Done by",
    "change.field.item.done_on": "Done on",
    "change.field.item.due_on": "Due by",
    "change.field.item.effective_on": "Takes effect",
    "change.field.item.employment_id": "Employment",
    "change.field.item.fact_key": "Fact",
    "change.field.item.kind": "To report",
    "change.field.item.name": "Rule",
    "change.field.item.note": "Note",
    "change.field.item.purchase_price": "Bought for",
    "change.field.item.reference": "GOSI reference",
    "change.field.item.transfer_from": "Transferred from",
    "change.field.item.last_failure": "Refused by the platform",
    "change.field.item.failed_on": "Refused on",
    "change.field.item.failed_by": "Refusal recorded by",
    "change.field.item.retired_at": "Retired on",
    "change.field.item.scheme": "Scheme",
    "change.field.item.scheme_basis": "Scheme basis",
    "change.field.item.snapshot": "Snapshot",
    "change.field.item.snapshot_at": "Snapshot taken on",
    "change.field.item.source": "Source",
    "change.field.item.source_ref": "Source",
    "change.field.item.status": "Status",
    "change.field.item.submission_id": "Submission",
    "change.field.item_dimension.dimension_id": "Dimension",
    "change.field.item_dimension.item_id": "Item",
    "change.field.item_dimension.value_id": "Value",
    "change.field.journal.code": "Code",
    "change.field.journal.default_account_id": "Default account",
    "change.field.journal.iban": "IBAN",
    "change.field.journal.journal_type": "Type",
    "change.field.journal.name_ar": "Name",
    "change.field.journal.name_en": "Name (English)",
    "change.field.journal.retired_at": "Retired on",
    "change.field.journal.sequence_pattern": "Sequence pattern",
    "change.field.layout.created_by": "Created by",
    "change.field.layout.key": "Key",
    "change.field.layout.name": "Name",
    "change.field.layout.retired_at": "Retired on",
    "change.field.layout.spec": "Layout (JSON)",
    "change.field.layout.status": "Status",
    "change.field.lock_dates.fiscal_lock_on": "Fiscal lock",
    "change.field.lock_dates.set_by": "Set by",
    "change.field.lock_dates.tax_lock_on": "Tax lock",
    "change.field.occasion.approved_at": "Approved on",
    "change.field.occasion.approved_by": "Approved by",
    "change.field.occasion.created_by": "Created by",
    "change.field.occasion.gregorian_from": "From",
    "change.field.occasion.gregorian_to": "To",
    "change.field.occasion.hijri_from": "Hijri from",
    "change.field.occasion.hijri_to": "Hijri to",
    "change.field.occasion.key": "Key",
    "change.field.occasion.kind": "Kind",
    "change.field.occasion.location_ref": "Location",
    "change.field.occasion.name_ar": "Occasion",
    "change.field.occasion.name_en": "Name (English)",
    "change.field.occasion.pack": "From pack",
    "change.field.occasion.proposed_by": "Proposed by",
    "change.field.occasion.scope": "Scope",
    "change.field.occasion.withdrawn_at": "Withdrawn on",
    "change.field.occasion.withdrawn_by": "Withdrawn by",
    "change.field.occasion.withdrawn_reason": "Withdrawal reason",
    "change.field.payment.allocated_total": "Allocated",
    "change.field.payment.amount": "Amount",
    "change.field.payment.created_by": "Created by",
    "change.field.payment.currency": "Currency",
    "change.field.payment.direction": "Direction",
    "change.field.payment.document_id": "Document",
    "change.field.payment.id": "Id",
    "change.field.payment.journal_entry_id": "Journal entry",
    "change.field.payment.journal_id": "Journal",
    "change.field.payment.method": "Method",
    "change.field.payment.paid_on": "Paid on",
    "change.field.payment.party_id": "Party",
    "change.field.payment.provider_ref": 'Bank reference',
    "change.field.payment.state": "State",
    "change.field.payment_term.code": "Code",
    "change.field.payment_term.days": "Days",
    "change.field.payment_term.name_ar": "Name (Arabic)",
    "change.field.payment_term.name_en": "Name (English)",
    "change.field.payment_term.retired_at": "Retired on",
    "change.field.period.closed_at": "Closed on",
    "change.field.period.closed_by": "Closed by",
    "change.field.period.ends_on": "To",
    "change.field.period.fiscal_year_id": "Fiscal year",
    "change.field.period.name_ar": "Period",
    "change.field.period.name_en": "Name (English)",
    "change.field.period.reopen_reason": "Reason for reopening",
    "change.field.period.reopened_at": "Reopened on",
    "change.field.period.reopened_by": "Reopened by",
    "change.field.period.starts_on": "From",
    "change.field.period.status": "Status",
    "change.field.policy.created_by": "Created by",
    "change.field.policy.ends_on": "Ends",
    "change.field.policy.id": "Identifier",
    "change.field.policy.starts_on": "From",
    "change.field.posting_rule.credit_account_id": "Credit account",
    "change.field.posting_rule.debit_account_id": "Debit account",
    "change.field.posting_rule.line_kind": "Line kind",
    "change.field.posting_rule.priority": "Priority",
    "change.field.posting_rule.retired_at": "Retired on",
    "change.field.posting_rule.source_module": "Source module",
    "change.field.posting_rule.tax_code_id": "Tax code",
    "change.field.posting_rule.valid_from": "Valid from",
    "change.field.posting_rule.valid_to": "Valid to",
    "change.field.profile.code": "Code",
    "change.field.profile.deadline_hours": "Deadline (hours)",
    "change.field.profile.document_kind": "Document kind",
    "change.field.profile.effective_from": "Effective from",
    "change.field.profile.path": "Channel",
    "change.field.profile.qr_tag_count": "QR tags",
    "change.field.profile.status": "Status",
    "change.field.rate.branch": "Branch",
    "change.field.rate.confirmed_at": "Confirmed",
    "change.field.rate.confirmed_by": "Confirmed by",
    "change.field.rate.created_by": "Created by",
    "change.field.rate.effective_from": "From",
    "change.field.rate.employee_rate": "Employee %",
    "change.field.rate.employer_rate": "Employer %",
    "change.field.rate.note": "Note",
    "change.field.rate.scheme": "Scheme",
    "change.field.rate.source": "Source",
    "change.field.rate.status": "Status",
    "change.field.rate.wage_ceiling": "Wage ceiling",
    "change.field.rate.wage_floor": "Wage floor",
    "change.field.rate.withdrawn_at": "Withdrawn on",
    "change.field.rate.withdrawn_by": "Withdrawn by",
    "change.field.reason_code.code": "Code",
    "change.field.reason_code.kind": "Kind",
    "change.field.reason_code.name_ar": "Name (Arabic)",
    "change.field.reason_code.name_en": "Name (English)",
    "change.field.reason_code.retired_at": "Retired on",
    "change.field.reconciliation.columns": "Columns",
    "change.field.reconciliation.created_by": "Created by",
    "change.field.reconciliation.filename": "File name",
    "change.field.reconciliation.format": "File",
    "change.field.reconciliation.imported_at": "Imported on",
    "change.field.reconciliation.imported_by": "Imported by",
    "change.field.reconciliation.kind": "Kind",
    "change.field.reconciliation.matched": "Matched",
    "change.field.reconciliation.mismatches": "Differences",
    "change.field.reconciliation.rows": "Rows",
    "change.field.request.actor": "Who",
    "change.field.request.answers": "Answers",
    "change.field.request.at": "At",
    "change.field.request.changes": "Changes",
    "change.field.request.current_step": "Current step",
    "change.field.request.decided_at": "Decided",
    "change.field.request.decided_by": "Decided by",
    "change.field.request.decision": "Decision",
    "change.field.request.definition_id": "Definition",
    "change.field.request.definition_key": "Form",
    "change.field.request.definition_revision": "Revision",
    "change.field.request.event_id": "Event",
    "change.field.request.id": "Id",
    "change.field.request.number": "No.",
    "change.field.request.reason": "Why",
    "change.field.request.status": "Status",
    "change.field.request.step": "Step",
    "change.field.request.submitted_at": "Submitted",
    "change.field.request.submitted_by": "Submitted by",
    "change.field.request.submitter_employment_ref": "Submitter's employment",
    "change.field.rule.active_from": "Active from",
    "change.field.rule.channels": "Channels",
    "change.field.rule.conditions": "Only when",
    "change.field.rule.created_by": "Created by",
    "change.field.rule.escalate_after_minutes": "Escalates after (min)",
    "change.field.rule.escalate_to": "Escalate to",
    "change.field.rule.event_name": "When",
    "change.field.rule.importance": "Importance",
    "change.field.rule.name": "Rule",
    "change.field.band.band": "Band",
    "change.field.band.confirmed": "Confirmed",
    "change.field.band.confirmed_at": "Confirmed on",
    "change.field.band.confirmed_by": "Confirmed by",
    "change.field.band.created_by": "Entered by",
    "change.field.band.from_on": "In force from",
    "change.field.band.min_ratio": "Minimum ratio",
    "change.field.band.note": "Note",
    "change.field.band.retired_at": "Retired on",
    "change.field.item.case_id": "Offboarding case",
    "change.field.item.checked_at": "Checked on",
    "change.field.item.checked_by": "Checked by",
    "change.field.item.contract_id": "Contract",
    "change.field.item.contract_kind": "Contract kind",
    "change.field.item.contract_version": "Contract version",
    "change.field.item.from_on": "From",
    "change.field.item.issued_on": "Issued on",
    "change.field.item.leave_type": "Leave type",
    "change.field.item.movement_id": "Administrative decision",
    "change.field.item.recorded_at": "Recorded on",
    "change.field.item.recorded_by": "Recorded by",
    "change.field.item.request_id": "Leave request",
    "change.field.item.to_on": "To",
    "change.field.item.valid_until": "Valid until",
    "change.field.minimum_wage.amount": "Minimum wage",
    "change.field.minimum_wage.confirmed": "Confirmed",
    "change.field.minimum_wage.confirmed_at": "Confirmed on",
    "change.field.minimum_wage.confirmed_by": "Confirmed by",
    "change.field.minimum_wage.created_by": "Entered by",
    "change.field.minimum_wage.from_on": "In force from",
    "change.field.minimum_wage.note": "Note",
    "change.field.minimum_wage.retired_at": "Retired on",
    "change.field.residence.document_id": "Document",
    "change.field.residence.employment_id": "Employee",
    "change.field.residence.expires_on": "Expires on",
    "change.field.residence.renewed_on": "Renewed on",
    "change.field.residence.residence_number": "Iqama number",
    "change.field.residence.source": "Source",
    "change.field.settings.expiry_warning_days": "Warn days before expiry",
    "change.field.settings.residence_type_keys": "Document types that are an iqama",
    "change.field.settings.warning_margin": "Warning margin (points)",
    "change.field.rule.subject_field": "The person it names",
    "change.field.rule.subject_permission": "Permission the person needs",
    "change.field.rule.pack": "Pack",
    "change.field.rule.pack_item": "Pack item",
    "change.field.rule.pack_version": "Recipe version",
    "change.field.channel_consent.user_id": "Member",
    "change.field.channel_consent.channel": "Channel",
    "change.field.channel_consent.opted_in": "Receives it",
    "change.field.template.kind": "Notice",
    "change.field.template.locale": "Language",
    "change.field.template.provider_name": "Name at Meta",
    "change.field.template.language_code": "Approved language",
    "change.field.template.body": "Text",
    "change.field.template.parameters": "Variables",
    "change.field.template.link": "Link in the app",
    "change.field.template.pack": "Pack",
    "change.field.template.pack_version": "Recipe version",
    "change.field.party.whatsapp_opt_in_at": "WhatsApp consent given",
    "change.field.party.whatsapp_opt_out_at": "WhatsApp consent withdrawn",
    "change.field.party.consent_source": "Consent recorded through",
    "change.field.party.consent_by": "Consent recorded by",
    "change.field.rule.retired_at": "Retired on",
    "change.field.rule.retired_by": "Retired by",
    "change.field.rule.roles": "Tell",
    "change.field.rule.status": "Status",
    "change.field.seller.branch_code": "Branch",
    "change.field.seller.building_number": "Building no.",
    "change.field.seller.city": "City",
    "change.field.seller.country": "Country",
    "change.field.seller.cr_number": "CR",
    "change.field.seller.district": "District",
    "change.field.seller.legal_name_ar": "Legal name",
    "change.field.seller.legal_name_en": "Legal name (EN)",
    "change.field.seller.postcode": "Postal code",
    "change.field.seller.region": "Region",
    "change.field.seller.retired_at": "Retired on",
    "change.field.seller.street": "Street",
    "change.field.seller.vat_number": "VAT",
    "change.field.status_import.file_id": "File",
    "change.field.status_import.filename": "File name",
    "change.field.status_import.format": "Format",
    "change.field.status_import.hr_detail": "HR detail",
    "change.field.status_import.hr_state": "HR state",
    "change.field.status_import.imported_at": "Imported on",
    "change.field.status_import.imported_by": "Imported by",
    "change.field.status_import.matched": "Matched",
    "change.field.status_import.paid": "Paid",
    "change.field.status_import.pending": "Pending",
    "change.field.status_import.rejected": "Rejected",
    "change.field.status_import.rows": "Rows",
    "change.field.status_import.run_id": "Payroll run",
    "change.field.status_import.unmatched": "Unmatched",
    "change.field.submission.alert_50_at": "Alert at 50% on",
    "change.field.submission.alert_80_at": "Alert at 80% on",
    "change.field.submission.attempt": "Attempt",
    "change.field.submission.attempt_no": "Attempt",
    "change.field.submission.authority_reference": "Authority reference",
    "change.field.submission.channel": "How it goes to GOSI",
    "change.field.submission.content_base64": "File content",
    "change.field.submission.content_type": "Content type",
    "change.field.submission.deadline_at": "Deadline",
    "change.field.submission.edocument_id": "E-document",
    "change.field.submission.environment": "Environment",
    "change.field.submission.failure_reason": "Failure reason",
    "change.field.submission.filename": "File name",
    "change.field.submission.format": "File",
    "change.field.submission.id": "Identifier",
    "change.field.submission.idempotency_key": "Idempotency key",
    "change.field.submission.item_id": "Item",
    "change.field.submission.items_count": "Items",
    "change.field.submission.kind": "Item",
    "change.field.submission.masked_request": "Request (masked)",
    "change.field.submission.prepared_at": "Prepared on",
    "change.field.submission.prepared_by": "Prepared by",
    "change.field.submission.request_digest": "Request digest",
    "change.field.submission.resolved_at": "Resolved on",
    "change.field.submission.resolved_by": "Resolved by",
    "change.field.submission.response_status": "Response",
    "change.field.submission.retry_class": "Retry",
    "change.field.submission.rows": "Rows",
    "change.field.submission.status": "Status",
    "change.field.submission.submitted_at": "Submitted on",
    "change.field.submission.submitted_by": "Submitted by",
    "change.field.submission.submitted_on": "Submitted on",
    "change.field.submission.validation_results": "Validation results",
    "change.field.submission.warnings": "Warnings",
    "change.field.submission.withdrawn_at": "Withdrawn on",
    "change.field.submission.withdrawn_by": "Withdrawn by",
    "change.field.tag.colour": "Colour",
    "change.field.tag.group_id": "Group",
    "change.field.tag.key": "Key",
    "change.field.tag.name": "Name",
    "change.field.tag_group.exclusive": "Exclusive",
    "change.field.tag_group.key": "Key",
    "change.field.tag_group.name": "Name",
    "change.field.tagging.attached_at": "Attached on",
    "change.field.tagging.attached_by": "Attached by",
    "change.field.tagging.ref_entity": "Referenced record kind",
    "change.field.tagging.ref_id": "Referenced record",
    "change.field.tagging.ref_module": "Referenced module",
    "change.field.tagging.tag_id": "Tag",
    "change.field.tax_code.base_account_id": "Base account",
    "change.field.tax_code.code": "Code",
    "change.field.tax_code.confirmed_at": "Confirmed on",
    "change.field.tax_code.confirmed_by": "Confirmed by",
    "change.field.tax_code.deductible": "Deductible",
    "change.field.tax_code.enabled": "Enabled",
    "change.field.tax_code.exemption_reason_code": "Exemption reason",
    "change.field.tax_code.name_ar": "Name",
    "change.field.tax_code.name_en": "Name (English)",
    "change.field.tax_code.rate": "Rate %",
    "change.field.tax_code.retired_at": "Retired on",
    "change.field.tax_code.tax_account_id": "Tax account",
    "change.field.tax_code.tax_type": "Type",
    "change.field.tax_code.valid_from": "Valid from",
    "change.field.tax_code.valid_to": "Valid to",
    "change.field.tax_rule.buyer_type": "Buyer type",
    "change.field.tax_rule.line_kind": "Line kind",
    "change.field.tax_rule.priority": "Priority",
    "change.field.tax_rule.retired_at": "Retired on",
    "change.field.tax_rule.supply_destination": "Supply destination",
    "change.field.tax_rule.tax_code_id": "Tax code",
    "change.field.tax_rule.valid_from": "Valid from",
    "change.field.tax_rule.valid_to": "Valid to",
    "change.field.template.created_by": "Created by",
    "change.field.template.id": "Identifier",
    "change.field.template.status": "Status",
    "change.field.type.alert_days": "Alert days before the end",
    "change.field.type.applies_to": "Whose",
    "change.field.type.builtin": "Supplied by the platform",
    "change.field.type.created_by": "Created by",
    "change.field.type.expires": "Ends",
    "change.field.type.key": "Key",
    "change.field.type.legal_hold": "Legal hold",
    "change.field.type.name_ar": "Type",
    "change.field.type.name_en": "Name (English)",
    "change.field.type.retention_category": "Kept as",
    "change.field.type.retention_years": "Years kept after",
    "change.field.type.retired_at": "Retired on",
    "change.field.type.retired_by": "Retired by",
    "change.field.type.status": "Status",
    "documents.party_documents.action.attach": "Attach",
    "documents.party_documents.col.status": "Status",
    "documents.party_expired.alert.2": "{type_name_ar} ended {expires_on}",
    "documents.party_expiring.action.renew": "Record the renewal",
    "documents.party_expiring.alert.2": "{type_name_ar} ends {expires_on}",
    "identity.party_account.empty": "This person has no login account in the workspace.",
    "identity.party_account.title": "Login account",
    "identity.party_portal.title": "Portal",
    "identity.party_portal.empty": "This party does not sign in to the portal.",
    "identity.party_portal.column.status": "Status",
    "identity.party_portal.column.last_seen_at": "Last signed in",
    "identity.party_portal.column.invitation_expires_at": "Invitation expires",
    "identity.party_portal.column.source": "Invited for",
    "identity.party_portal.column.id": "Account",
    "identity.party_portal.action.invite": "Invite to the portal",
    "identity.party_portal.action.invite.field.module": "Portal of",
    "identity.party_portal.action.invite.reveal.link": "Invitation link",
    "identity.party_portal.action.invite.reveal.expires_at": "Works until",
    "identity.party_portal.action.invite.reveal_note": "The link works once. Send it to the party; it is not shown again.",
    "identity.party_portal.action.suspend": "Suspend",
    "identity.party_portal.action.resume": "Resume",
    "identity.portal.status.invited": "Invited",
    "identity.portal.status.expired": "Invitation expired",
    "identity.portal.status.active": "Signs in",
    "identity.portal.status.suspended": "Suspended",
    "nav.identity.portal_members": "Portal members",
    "screen.identity.portal_members.title": "Portal members",
    "screen.identity.portal_members.lede": "The parties outside the workspace who sign in to its portal, and those invited to.",
    "screen.identity.portal_members.column.party_name": "Party",
    "screen.identity.portal_members.column.status": "Status",
    "screen.identity.portal_members.column.source": "Invited for",
    "screen.identity.portal_members.column.last_seen_at": "Last sign-in",
    "screen.identity.portal_members.column.invitation_expires_at": "Invitation expires",
    "screen.identity.portal_members.column.invited_at": "Invited on",
    "screen.identity.portal_members.column.party_id": "Party ID",
    "screen.identity.portal_members.column.id": "Account",
    "screen.identity.portal_members.tab.awaiting": "Awaiting acceptance",
    "screen.identity.portal_members.empty": "No party has been invited to the portal yet.",
    "screen.identity.portal_members.action.invite": "Invite a party",
    "screen.identity.portal_members.action.invite.field.party_id": "Party",
    "screen.identity.portal_members.action.invite.field.module": "Portal of",
    "screen.identity.portal_members.action.invite.reveal.link": "Invitation link",
    "screen.identity.portal_members.action.invite.reveal.expires_at": "Works until",
    "screen.identity.portal_members.action.invite.reveal_note": "The link works once. Send it to the party; it is not shown again.",
    "screen.identity.portal_members.action.invite_again": "Invite again",
    "screen.identity.portal_members.action.invite_again.effect": "The earlier link stops working.",
    "screen.identity.portal_members.action.suspend": "Suspend",
    "screen.identity.portal_members.action.suspend.effect": "The party is signed out of the portal now, and cannot sign in again until resumed.",
    "screen.identity.portal_members.action.resume": "Resume",
    "parties.party.col.nationality": "Nationality",
    "parties.party.col.phone": "Mobile",
    "parties.party_identity.col.scheme": "Scheme",
    "parties.party_iqama.col.value": "Iqama",
    "parties.party_national_id.col.value": "National ID",
    "parties.party_personal.note": "The person’s own record in the parties register: every module that names this person reads it from here.",
    "parties.party_personal.title": "Personal details",
    "parties.party_relation.col.id": "Party",
    "parties.party_relation.col.name": "Person",
    "parties.party_relation.title": "Person",
    "record.card.sensitive": "Restricted",
    "record.card.sensitive.hint": "Shown only to those who hold its permission",
    "record.cards.more_named": "+{n:more_sections}: {names}",
    "record.changes.created_from": "Created from {what}",
    "record.related": "Related to",
    "record.stages.exits": "Exit: {exits}",
    "screen.parties.parties.action.edit.field.nationality": "Nationality",
    "screen.parties.parties.action.edit.field.phone": "Mobile",
    "unit.minutes.few": "{n} minutes",
    "unit.minutes.many": "{n} minutes",
    "unit.minutes.one": "{n} minute",
    "unit.minutes.other": "{n} minutes",
    "unit.minutes.two": "{n} minutes",
    "unit.minutes.zero": "{n} minutes",
    "unit.months.few": "{n} months",
    "unit.months.many": "{n} months",
    "unit.months.one": "{n} month",
    "unit.months.other": "{n} months",
    "unit.months.two": "{n} months",
    "unit.months.zero": "{n} months",
    "unit.times.few": "{n} times",
    "unit.times.many": "{n} times",
    "unit.times.one": "once",
    "unit.times.other": "{n} times",
    "unit.times.two": "twice",
    "unit.times.zero": "never",
    "unit.workdays.few": "{n} working days",
    "unit.workdays.many": "{n} working days",
    "unit.workdays.one": "{n} working day",
    "unit.workdays.other": "{n} working days",
    "unit.workdays.two": "{n} working days",
    "unit.workdays.zero": "{n} working days",
    "value.penalty.none": "None",
    // ── end of the entity record pages block ──
    "screen.invoicing.document.column.overdue": "Overdue",
    "screen.invoicing.document.column.days_overdue": "Days overdue",
    "screen.invoicing.document.alert.overdue": "Past due, and no payment is allocated to it",
    "screen.invoicing.document.card.customer.link": "The customer's current file",
    "screen.invoicing.document.history.note": "After posting no field of the invoice changes: it is corrected by a credit or debit note. Other modules' decisions stay in their cards; one merged timeline is a later phase.",
    "screen.invoicing.document_open_payments.title": "Unallocated payments",
    "screen.invoicing.document_open_payments.col.open": "Open",
    "screen.invoicing.document_open_payments.alert": "Payment {provider_ref} from the same customer, {open_amount}, is not allocated",
    "screen.einvoicing.document_edocument.col.icv": "Counter (ICV)",
    "screen.einvoicing.document_edocument.col.hash": "Hash",
    "screen.einvoicing.document_edocument.col.previous_hash": "Previous hash",
    "screen.einvoicing.document_edocument.col.last_attempt": "Last attempt",
    "screen.einvoicing.document_edocument.last_attempt": "{last_attempt_at} · {report_status}",
    "screen.einvoicing.document_edocument.outcome.cleared": "cleared",
    "screen.einvoicing.document_edocument.outcome.reported": "reported",
    "screen.einvoicing.document_edocument.outcome.rejected": "rejected",
    "screen.einvoicing.document_edocument.outcome.pending": "pending",
    "screen.einvoicing.document_edocument.outcome.unreachable": "unreachable",
    "screen.einvoicing.document_edocument.outcome.not_required": "not required",
    "screen.einvoicing.document_status.title": "Authority (e-invoicing)",
    "screen.einvoicing.document_status.value.cleared": "Cleared · cleared",
    "screen.einvoicing.document_status.value.reported": "Reported · reported",
    "screen.einvoicing.document_status.value.pending": "Not sent yet",
    "screen.einvoicing.document_status.value.unreachable": "Unreachable",
    "screen.einvoicing.document_status.value.rejected": "Rejected",
    "screen.einvoicing.document_status.value.not_required": "Not required",
    "screen.einvoicing.document_cleared.path.clearance": 'Clearance',
    "screen.einvoicing.document_cleared.path.reporting": 'Reporting',
    "screen.accounting.entry_lines.account": "{account_code} · {account_name}",
    // The party page (parties.party) and what accounting adds to it.
    "screen.parties.party.title": "Party",
    "parties.party.col.vat_number": "VAT number",
    "parties.party.col.cr_number": "Commercial registration",
    "parties.party.col.national_address": "National address",
    "parties.party.col.national_short_address": "Short address",
    "parties.party.col.billing_address": "Billing address",
    "parties.party.billing.same": "The same",
    "parties.party.col.contact": "Contact",
    "parties.party.col.contact_phone": "Contact's mobile",
    "parties.party.card.personal.empty": "No mobile or nationality is registered for this person yet.",
    "parties.party.col.bank_account": "Bank account",
    "parties.party.col.bank_name": "Bank",
    "parties.party.col.iban": "IBAN",
    "parties.party.col.bank_status": "Verification",
    "parties.party.bank_status.verified": "Verified",
    "parties.party.bank_status.unverified": "Not verified",
    "parties.party.bank_status.retired": "Retired",
    "parties.party.col.bank_currency": "Currency",
    "parties.party.currency.SAR": "SAR",
    "parties.party.currency.USD": "USD",
    "parties.party.currency.EUR": "EUR",
    "parties.party.currency.AED": "AED",
    "parties.party.subtitle.vat": "VAT number {value}",
    "parties.party.column.merged_into": "Merged into",
    "parties.party.alert.merged": "Merged into {merged_into}: that is the party to use from now on",
    "parties.party.alert.merged.open": "Open it",
    "parties.party.alert.archived": "Archived: kept with its history",
    "parties.party.subtitle.cr": "Commercial registration {value}",
    "parties.party.tab.identities": "Addresses and identifiers",
    "parties.party.tab.bank": "Bank accounts",
    "parties.party.card.identities": "Identifiers and addresses",
    "parties.party.card.identities.empty": "No number, address or contact is registered for this party yet.",
    "parties.party.card.bank.note": "The whole number only for who may pay it.",
    "parties.party.history.note": "Changes to this file's own fields only; other modules' decisions stay in their cards. One merged timeline is a later phase.",
    "parties.party_addresses.title": "Addresses",
    "parties.party_addresses.empty": "No address is registered for this party.",
    "parties.party.purpose.billing": "Billing",
    "parties.party.purpose.shipping": "Shipping",
    "parties.party.purpose.registered": "National (registered)",
    "parties.party.purpose.correspondence": "Correspondence",
    "parties.party_identifiers.title": "Identifiers",
    "parties.party_identifiers.col.valid_from": "From",
    "parties.party_identifiers.col.valid_to": "Until",
    "parties.party_identifiers.empty": "No tax or registration number is registered for this party.",
    "parties.party.scheme.sa_vat": "VAT number",
    "parties.party.scheme.sa_cr": "Commercial registration",
    "parties.party.scheme.sa_nid": "National ID",
    "parties.party.scheme.sa_iqama": "Iqama",
    "parties.party_bank_accounts.col.holder": "Account holder",
    "parties.party_bank_accounts.note": "Masked to its last four. The whole number only for who may pay it, read one account at a time, and each reading is recorded.",
    "parties.party_bank_accounts.empty": "No bank account is registered for this party.",
    "parties.party_bank_accounts.action.add": "Add account",
    "parties.party_bank_accounts.action.retire": "Retire",
    "parties.party_bank_accounts.field.iban.help": "SA and twenty-two digits for a Saudi account. Kept whole, shown by its last four only.",
    "parties.party_addresses.action.retire": "Retire",
    "screen.parties.parties.action.archive": "Archive",
    "screen.parties.parties.action.merge": "Merge into…",
    "screen.parties.parties.action.merge.field.into": "The party that stays",
    "screen.parties.parties.action.merge.field.into.help": "This party is merged into the one chosen and points at it from now on. It cannot be undone.",
    "screen.parties.parties.action.merge.field.reason": "Reason",
    "screen.parties.parties.action.create.field.identifier_scheme": "Number",
    "screen.parties.parties.action.create.field.identifier_scheme.help": "Optional. More numbers are added from the party afterwards.",
    "invoicing.party.balances.title": "Balance",
    "invoicing.party.col.ar_open": "Owed to us",
    "invoicing.party.col.ap_open": "Owed by us",
    "invoicing.party.col.overdue": "Overdue",
    "invoicing.party.ageing.title": "Receivables ageing",
    "invoicing.party.ageing.not_due": "Not yet due",
    "invoicing.party.ageing.d1_30": "1–30 days",
    "invoicing.party.ageing.d31_60": "31–60",
    "invoicing.party.ageing.d61_90": "61–90",
    "invoicing.party.ageing.over_90": "Over 90",
    "invoicing.party.ageing.note": "Each open invoice by the days since its due day; one without a due day is due the day it was issued. The overdue figure above is these past-due buckets added up.",
    "invoicing.party.late.title": "Invoices more than thirty days late",
    "invoicing.party.late.count": "Invoices",
    "invoicing.party.late.amount": "Amount",
    "invoicing.party.late.oldest": "Oldest due on",
    "invoicing.party.late.alert": "{late30_count} more than 30 days late, {late30_amount} in all",
    "unit.invoices.zero": "{n} invoices",
    "unit.invoices.one": "{n} invoice",
    "unit.invoices.two": "{n} invoices",
    "unit.invoices.few": "{n} invoices",
    "unit.invoices.many": "{n} invoices",
    "unit.invoices.other": "{n} invoices",
    "invoicing.party.payments.title": "Latest payments",
    "invoicing.party.payments.tab": "Payments",
    "invoicing.party.payments.allocate": "Allocate",
    "invoicing.party.payments.empty": "No payment has been recorded with this party.",
    "invoicing.party.col.reference": "Reference",
    "invoicing.party.col.date": "Date",
    "invoicing.party.col.unallocated": "Not allocated",
    "invoicing.party.unallocated.title": "Payments not allocated",
    "invoicing.party.unallocated.alert": "Payment {reference} of {open_amount} is not allocated to any invoice",
    "invoicing.party.invoices.title": "Invoices",
    "invoicing.party.invoices.empty": "Nothing has been invoiced to this party.",
    "invoicing.party.col.number": "Number",
    "invoicing.party.col.remaining": "Remaining",
    "invoicing.party.col.standing": "Status",
    "invoicing.party.standing.draft": "Draft",
    "invoicing.party.standing.validated": "Validated",
    "invoicing.party.standing.posted": "Posted",
    "invoicing.party.standing.overdue": "Overdue",
    "invoicing.party.standing.partial": "Part paid",
    "invoicing.party.standing.paid": "Paid",
    "invoicing.party.standing.cancelled_by_note": "Cancelled by a note",
    "invoicing.party.col.einvoice": "E-invoice",
    "invoicing.party.einvoice.cleared": "Cleared",
    "invoicing.party.einvoice.reported": "Reported",
    "invoicing.party.einvoice.pending": "Not sent yet",
    "invoicing.party.einvoice.unreachable": "Unreachable",
    "invoicing.party.einvoice.rejected": "Rejected",
    "invoicing.party.einvoice.not_required": "Not required",
    "invoicing.party.col.kind": "Kind",
    "invoicing.party.col.due_on": "Due",
    "invoicing.party.col.withholding": "Withholding",
    "invoicing.party.vendor_bills.title": "Vendor bills",
    "invoicing.party.vendor_bills.empty": "No bill has been received from this party.",
    "invoicing.party.statement.title": "Statement",
    "invoicing.party.statement.kind.customer_invoice": "Invoice",
    "invoicing.party.statement.kind.credit_note": "Credit note",
    "invoicing.party.statement.kind.debit_note": "Debit note",
    "invoicing.party.statement.kind.vendor_bill": "Vendor bill",
    "invoicing.party.statement.kind.payment": "Payment",
    "invoicing.party.statement.debit": "Debit",
    "invoicing.party.statement.credit": "Credit",
    "invoicing.party.statement.balance": "Balance",
    "invoicing.party.statement.note": "Posted documents and payments over the whole history, each with the balance after it: positive is owed to us.",
    "invoicing.party.statement.empty": "Nothing has been posted with this party.",
    "einvoicing.party.buyer.title": "Buyer profile",
    "einvoicing.party.buyer.standard": "Registered business",
    "einvoicing.party.buyer.simplified": "Consumer or unregistered",
    "record.reveal.failed": "Could not be shown",
    "record.figures.none": "Nothing to show: every figure is zero.",
    "value.statute_source.seed": "Read from summaries of the Labour Law as amended (in force 19 February 2025), not from the gazette; to be confirmed against the official text",
    "value.statute_source.adopted": "Adopted by the owner on 26 September 2026 on the likeliest reading of the amended law, pending the lawyer's review",
    "value.statute_standing.in_force": "In force",
    "value.statute_standing.awaiting": "Awaiting a second person",
    "value.statute_standing.later": "Starts later",
    "value.statute_standing.replaced": "Replaced",
    "value.statute_module.grievances": "Grievances",
    "value.statute_module.discipline": "Discipline",
    "value.statute_module.assets": "Assets",
    "value.statute_module.payroll": "Payroll",
    "value.statute_module.offboarding": "Offboarding",
    "value.statute_unit.days": "days",
    "value.statute_unit.months": "months",
    "value.statute_unit.years": "years",
    "value.statute_unit.fraction": "of the wage",
    "value.statute_unit.percent": "%",
    "value.statute_unit.hours": "hours",
    "value.statute_unit.none": "article only",
    "value.statute_key.grievances.objection_days": "Days to object to a penalty (official holidays excluded)",
    "value.statute_key.grievances.body_decision_days": "Days the employer's body has to decide an objection",
    "value.statute_key.grievances.hearing": "No decision before the worker is heard",
    "value.statute_key.grievances.limitation_months": "Months after the relationship ends within which a claim is heard",
    "value.statute_key.discipline.penalties": "The penalties an employer may impose",
    "value.statute_key.discipline.outside_regulation": "No penalty outside the law or the approved regulation",
    "value.statute_key.discipline.repeat_window_days": "Days after the last notice within which a repeat counts",
    "value.statute_key.discipline.charge_days": "Days from discovery within which the worker is charged",
    "value.statute_key.discipline.penalty_days": "Days from the close of the investigation within which the penalty is decided",
    "value.statute_key.discipline.hearing": "No penalty before the charge in writing, the hearing and the recorded defence",
    "value.statute_key.discipline.oral_hearing_max_fine_days": "The heaviest fine, in days' wage, for which the hearing may be oral",
    "value.statute_key.discipline.notice": "The penalty is served on the worker in writing",
    "value.statute_key.discipline.fine_cap_days": "Heaviest fine for one violation, in days' wage",
    "value.statute_key.discipline.monthly_withholding_days": "Most days' wage withheld in a month",
    "value.statute_key.discipline.monthly_suspension_days": "Most days' suspension without pay in a month",
    "value.statute_key.discipline.dismissal": "Dismissal without award or notice, on the grounds listed",
    "value.statute_key.assets.damage_days_per_month": "Most days' wage a month deducted for damage to the employer's property",
    "value.statute_key.assets.all_deductions_fraction": "Most of the wage all deductions may take in a month",
    "value.statute_key.payroll.period_max_days": "Longest pay period, in days",
    "value.statute_key.payroll.deductions_fraction": "Most of the wage deductions may take",
    "value.statute_key.payroll.overtime_premium_percent": "Overtime premium over the hourly wage",
    "value.statute_key.payroll.hours_per_day": "Hours of the working day",
    "value.statute_key.payroll.sick_unpaid_fraction": "Share of the wage not paid in the unpaid sick-leave tier",
    "value.statute_key.offboarding.award_first_years": "Years of service the half-month award covers",
    "value.statute_key.offboarding.resignation_none_below_years": "Years of service below which a resignation earns no award",
    "value.statute_key.offboarding.resignation_third_to_years": "Years of service up to which a resignation earns a third of the award",
    "value.statute_key.offboarding.resignation_two_thirds_below_years": "Years of service below which a resignation earns two thirds of the award",
    "value.statute_key.offboarding.art87_marriage_months": "Months after marriage within which a woman's resignation earns the full award",
    "value.statute_key.offboarding.art87_childbirth_months": "Months after childbirth within which a woman's resignation earns the full award",
    "value.statute_key.offboarding.dismissal": "Dismissal without award or notice, on the grounds listed",
    "value.statute_key.offboarding.probation": "Ending a contract in its probation",
    "value.statute_key.offboarding.in_lieu": "Pay in lieu of the notice period",
    "value.statute_key.offboarding.art77_per_year_days": "Days' wage of compensation for each year of service on an unlawful end",
    "value.statute_key.offboarding.art77_floor_months": "Least months' wage of compensation for an unlawful end",
    "value.statute_key.offboarding.resign_silence_days": "Days after which an unanswered resignation stands accepted",
    "value.statute_key.offboarding.resign_defer_max_days": "Most days the employer may defer a resignation",
    "value.statute_key.offboarding.resign_withdraw_days": "Days within which a resignation may be withdrawn",
    "value.statute_key.offboarding.settlement_employer_days": "Days the employer has to pay the final settlement when it ends the contract",
    "value.statute_key.offboarding.settlement_worker_days": "Days the employer has to pay the final settlement when the worker ends it",
    "value.statute_key.offboarding.leave": "Leave not taken is paid at the end of service",
    "value.statute_key.offboarding.notice_worker_monthly_days": "Notice a monthly-paid worker gives, in days",
    "value.statute_key.offboarding.notice_worker_other_days": "Notice a worker not paid monthly gives, in days",
    "value.statute_key.offboarding.notice_employer_monthly_days": "Notice the employer gives a monthly-paid worker, in days",
    "value.statute_key.offboarding.notice_employer_other_days": "Notice the employer gives a worker not paid monthly, in days",
    "value.hearing_mode.written": "In writing",
    "value.hearing_mode.oral": "Oral, with minutes",
};
const AR = {
    ...HUBS_AR,
    ...CONNECTIONS_AR,
    ...HR_OPEN_ISSUES_AR,
    ...HR_PM_B_AR,
    ...HR_PM_C_AR,
    ...HR_SMALL_FEATURES_AR,
    ...COMMON_CHANGE_AR,
    ...HR_PAYROLL_FEATURES_AR,
    ...HR_GOV_PAYROLL_AR,
    ...HR_REVIEW_B_AR,
    ...HR_REVIEW_C_AR,
    ...HR_REVIEW_D_AR,
    ...HR_BENEFITS_AR,
    ...EXTENSIONS_AR,
    ...FEEDBACK_AR,
    ...ACTIVITIES_AR,
    ...INVENTORY_AR,
    ...DOC_TEMPLATES_AR,
    ...ATTACHMENTS_AR,
    ...CORE_HOOKS_AR,
    ...COMMENTS_AR,
    ...APPROVALS_AR,
    ...OPPORTUNITIES_AR,
    ...CAMPAIGNS_AR,
    ...TARGETS_AR,
    ...CONSOLE_AR,
    ...GOV_SA_AR,
    ...RENDERER_AR,
    ...OFFLINE_AR,
    ...OUTBOX_AR,
    ...BOARD_AR,
    ...TIMELINE_AR,
    ...CALENDAR_AR,
    ...ASSIGNMENTS_AR,
    ...REPORT_AR,
    ...SETTINGS_AR,
    ...PAPER_AR,
    ...LINES_AR,
    ...CORE_SCREENS_AR,
    ...HR_LISTS_AR,
    ...HR_TIME_AR,
    ...INVOICING_SALES_AR,
    ...HR_CYCLE_AR,
    ...REACH_AR,
    ...EVENTS_AR,
    ...CONSENT_AR,
    ...IMPORTS_AR,
    ...FINANCE_DOCS_AR,
    ...ACCOUNTING_WORK_AR,
    ...INVOICING_AR,
    ...HOME_SHELL_AR,
    ...HOME_AR,
    ...PARTIES_AR,
    ...PRIVACY_AR,
    ...PLATFORM_RECORD_AR,
    ...LIST_QUERY_AR,
    ...INBOX_AR,
    ...AUTOMATION_AR,
    ...SAVED_VIEWS_AR,
    ...TEAMS_AR,
    ...APP_AR,
    ...PERMISSIONS_AR,
    ...FINANCE_DESK_AR,
    ...PROFILE_AR,
    ...LEGAL_AR,
    ...ANALYTICS_AR,
    'state.unavailable': 'غير متاح الآن',
    'state.forbidden': 'لا تملك صلاحية لهذا',
    'state.timeout': 'تأخّر الردّ أكثر من اللازم',
    'state.loading': 'جارٍ التحميل…',
    'state.empty': 'لا شيء هنا بعد',
    'state.narrowed': 'لا شيء يطابق ما تبحث عنه',
    'state.planned': 'ليس جزءًا من هذا الإصدار بعد',
    'state.saving': 'جارٍ الحفظ…',
    'state.saved': 'حُفِظ',
    'screen.unsupported': 'هذه الشاشة تستخدم شيئًا لا يعرف هذا الإصدار رسمه',
    'screen.unsupported.details': 'تفاصيل تقنية',
    'screen.arrivesLater': 'تصل شاشاته مع حزمة المديول في المرحلة 2',
    'screen.noAddress': 'لا عنوان في السجلّ للوحدة التي تستضيف هذا المديول',
    'field.unsupported': 'نوع هذا الإعداد لا يعرف هذا الإصدار تحريره',
    'action.notYet': 'هذا الإجراء معلَن، ولا يعرف هذا الإصدار تنفيذه بعد',
    'action.held.pending': 'جارٍ التحقق من إمكان تنفيذه هنا',
    'action.held.no': 'لا يمكن تنفيذ هذا هنا بعد',
    'action.revealOnce': 'انسخه وأرسله إليه بنفسك. لا يُحفظ، ولن يُعرض مرّة أخرى.',
    'action.refused': 'لم يُقبَل',
    'action.forThisRow': 'لهذا الصفّ',
    'action.more': 'إجراءات أخرى',
    'action.close': 'إغلاق',
    'action.noPath': 'لم يعد هذا الصفّ يدلّ على وجهة الإجراء',
    'action.cancel': 'إلغاء',
    'action.copy': 'نسخ',
    'action.copied': 'نُسِخ',
    'action.follow.working': 'جارٍ الإرسال…',
    'change.listHistory': "سجل التعديلات",
    'change.formHistory': "السجل",
    'change.what': "العملية",
    'change.who': "المستخدم",
    'change.when': "الوقت",
    'change.from': "العنوان",
    'change.record': "السجل",
    'change.fields': "تغيّر {n} حقول",
    'change.field': "الحقل",
    'change.before': "قبل",
    'change.after': "بعد",
    'change.snapshot': "البيانات بعد العملية",
    'change.snapshot.deleted': "البيانات كما كانت عند الحذف",
    'change.hidden': "مخفي — يحتاج صلاحية لا تملكها",
    'change.openForm': "فتح النموذج",
    'change.gone': "حُذف السجل، فلا نموذج يُفتح.",
    'change.system': "النظام",
    'change.origin.service': "النظام",
    'change.origin.migration': "تحديث للنظام",
    'change.origin.anonymous': "قبل تسجيل الدخول",
    'change.none': "لم تُسجَّل تغييرات بعد.",
    'change.yes': "نعم",
    'change.no': "لا",
    'change.summary.create': "أضافه",
    'change.summary.update': "عدّل {n} حقول",
    'change.summary.delete': "حذفه",
    'change.summary.status': "غيّر حالته",
    'change.field.user.email': "البريد الإلكتروني",
    'change.field.user.password_hash': "كلمة المرور",
    'change.field.user.status': "الحالة",
    'change.field.user.locale': "اللغة",
    'change.field.user.name': "الاسم",
    'change.field.user.phone': "الجوال",
    'change.field.user.job_title': "المسمّى الوظيفي",
    'change.field.user.must_change_password': "يغيّر كلمة المرور عند الدخول التالي",
    'change.field.user.kind': "نوع الحساب",
    'change.field.user.password_chosen': "اختار صاحبه كلمة المرور",
    'change.field.portal_account.user_id': "الحساب",
    'change.field.portal_account.party_id': "الطرف",
    'change.field.portal_account.status': "الحالة",
    'change.field.portal_account.source': "دُعي إلى بوابة",
    'change.field.portal_account.invited_by': "دعاه",
    'change.field.portal_account.accepted_at': "قَبِل الدعوة",
    'change.field.portal_account.suspended_at': "عُلِّق",
    'change.field.portal_account.suspended_by': "علّقه",
    'change.field.portal_account.token_hash': "رابط الدعوة",
    'change.field.portal_account.expires_at': "تنتهي الدعوة",
    'change.field.portal_account.cancelled_at': "سُحبت الدعوة",
    'change.field.user.secret_sealed': "سرّ تطبيق المصادقة",
    'change.field.user.confirmed_at': "تاريخ تأكيد الدخول بخطوتين",
    'change.field.user.pending_sealed': "سرّ مصادقة مقترح لم يُؤكَّد بعد",
    'change.field.user.recovery_code_hashes': "رموز الاسترداد",
    'change.field.user.locked_until': "مقفل بعد رموز خاطئة حتى",
    'change.field.user.disabled_at': "تاريخ إيقاف الدخول بخطوتين",
    'change.field.home_layout.pages': "صفحات الرئيسية",
    'change.field.home_layout.archived': "صفحات وبطاقات الرئيسية المزالة",
    'change.field.member.user_id': "المستخدم",
    'change.field.member.invited_by': "دعاه",
    'change.field.member.accepted_at': "تاريخ الانضمام",
    'change.field.member.suspended_at': "تاريخ الإيقاف",
    'change.field.member.suspended_by': "أوقفه",
    'change.field.member.party_id': "الشخص",
    'change.field.member.service_ends_on': "تاريخ انتهاء الخدمة",
    'change.field.member.service_access_until': "الدخول باقٍ حتى",
    'change.field.member.service_end_ref': "مرجع انتهاء الخدمة",
    'change.field.member.source': "طريقة الانضمام",
    'change.field.invitation.name': "الاسم",
    'change.field.invitation.job_title': "المسمّى الوظيفي",
    'change.field.member.role_id': "الدور",
    'change.field.role.key': "المعرّف",
    'change.field.role.name': "الاسم",
    'change.field.role.is_system': "دور أساسي",
    'change.field.role.description': "الوصف",
    'change.field.role.name_ar': "الاسم بالعربية",
    'change.field.role.description_ar': "الوصف بالعربية",
    'change.field.role.colour': "اللون",
    'change.field.role.permission_key': "الصلاحية",
    'change.field.role.requires_second_factor': "يشترط الدخول بخطوتين",
    'change.field.invitation.token_hash': "رابط الدعوة",
    'change.field.invitation.email': "البريد الإلكتروني",
    'change.field.invitation.role_keys': "الأدوار",
    'change.field.invitation.invited_by': "دعاه",
    'change.field.invitation.expires_at': "تنتهي في",
    'change.field.invitation.accepted_at': "قُبلت في",
    'change.field.invitation.cancelled_at': "أُلغيت في",
    'change.field.invitation.cancelled_by': "ألغاها",
    'change.field.invitation.party_id': "الشخص",
    'change.field.workspace.key': "المعرّف",
    'change.field.workspace.name': "الاسم",
    'change.field.workspace.plan': "الخطة",
    'change.field.workspace.status': "الحالة",
    'change.field.workspace.module_key': "المديول",
    'change.field.workspace.unit_key': "الوحدة",
    'change.field.workspace.tier': "المستوى",
    'change.field.workspace.default_unit_tier': "المستوى الافتراضي للوحدات",
    'change.field.workspace.state': "الطلب",
    'change.field.workspace.name_ar': "الاسم بالعربية",
    'change.field.workspace.name_en': "الاسم بالإنجليزية",
    'change.field.workspace.logo_file_id': "الشعار",
    'change.field.post.author_user': "الكاتب",
    'change.field.post.kind': "النوع",
    'change.field.post.body': "النص",
    'change.field.post.poll_closes_at': "إغلاق الاستطلاع",
    'change.field.post.poll_results': "إظهار النتائج",
    'change.field.post.withdrawn_at': "تاريخ السحب",
    'change.field.post.withdrawn_by': "سحبه",
    'change.field.party.kind': "النوع",
    'change.field.party.display_name': "الاسم",
    'change.field.party.status': "الحالة",
    'change.field.party.merged_into': "دُمج في",
    'change.field.party.merged_into_status': "حالة السجل المدموج فيه",
    'change.field.party.residency': "الإقامة",
    'change.field.party.purpose': "نوع العنوان",
    'change.field.party.line1': "سطر العنوان 1",
    'change.field.party.line2': "سطر العنوان 2",
    'change.field.party.city': "المدينة",
    'change.field.party.region': "المنطقة",
    'change.field.party.postcode': "الرمز البريدي",
    'change.field.party.country': "الدولة",
    'change.field.party.is_primary': "رئيسي",
    'change.field.party.street': "الشارع",
    'change.field.party.building_number': "رقم المبنى",
    'change.field.party.district': "الحي",
    'change.field.party.additional_number': "الرقم الإضافي",
    'change.field.party.unit_number': "رقم الوحدة",
    'change.field.party.short_address': "العنوان المختصر",
    'change.field.party.label': "اسم الحساب",
    'change.field.party.holder_name': "صاحب الحساب",
    'change.field.party.account_number': "رقم الحساب",
    'change.field.party.bic': "رمز البنك (BIC)",
    'change.field.party.currency': "العملة",
    'change.field.party.last4': "آخر أربعة أرقام",
    'change.field.party.fingerprint': "بصمة الحساب",
    'change.field.party.verified_at': "تاريخ التحقق",
    'change.field.party.retired_at': "تاريخ الإيقاف",
    'change.field.party.scheme': "نوع المعرّف",
    'change.field.party.value': "المعرّف",
    'change.field.party.valid_from': "ساري من",
    'change.field.party.valid_to': "ساري حتى",
    'change.field.party.buyer_scheme': "نوع معرّف المشتري (زاتكا)",
    'change.field.party.legal_name': "الاسم القانوني",
    'change.field.party.trading_name': "الاسم التجاري",
    'change.field.party.legal_form': "الشكل القانوني",
    'change.field.party.registration_date': "تاريخ التسجيل",
    'change.field.party.given_name': "الاسم الأول",
    'change.field.party.middle_name': "اسم الأب",
    'change.field.party.family_name': "اسم العائلة",
    'change.field.party.prefix': "اللقب",
    'change.field.party.suffix': "اللاحقة",
    'change.field.party.to_id': "الطرف المرتبط",
    'change.field.party.role': "العلاقة",
    'change.field.party.source': "النظام المصدر",
    'change.field.party.source_key': "المعرّف في النظام المصدر",
    'change.field.party.source_id': "السجل المدموج",
    'change.field.party.reason': "السبب",
    'change.field.party.merged_by': "دمجه",
    'change.field.party.merged_at': "تاريخ الدمج",
    'change.field.file.state': "الحالة",
    'change.field.file.content_type': "نوع الملف",
    'change.field.file.filename': "اسم الملف",
    'change.field.file.declared_size': "الحجم المعلن",
    'change.field.file.size': "الحجم",
    'change.field.file.ref_module': "مرفق في الوحدة",
    'change.field.file.ref_entity': "مرفق بـ",
    'change.field.file.ref_id': "مرفق بالسجل",
    'change.field.file.uploaded_by': "رفعه",
    'change.field.file.expires_at': "ينتهي في",
    'change.field.file.ready_at': "جاهز في",
    'change.field.file.failure': "سبب الفشل",
    'change.field.activity_retention.days': "أيام الاحتفاظ",
    'change.field.setting.group_key': "المجموعة",
    'change.field.setting.version': "الإصدار",
    'change.field.setting.key': "الإعداد",
    'change.field.setting.value': "القيمة",
    'nav.audit.changes': "سجل التعديلات",
    'screen.audit.changes.title': "سجل التعديلات",
    'screen.audit.changes.lede': "كل إضافة وتعديل وحذف وتغيير حالة: من فعلها ومتى وما الذي تغيّر، حقلاً بحقل.",
    'screen.audit.changes.column.occurred_at': "الوقت",
    'screen.audit.changes.column.actor_name': "المستخدم",
    'screen.audit.changes.column.action': "العملية",
    'screen.audit.changes.column.label': "السجل",
    'screen.audit.changes.column.screen': "الشاشة",
    'screen.audit.changes.column.change_count': "الحقول",
    'screen.audit.changes.column.ip': "العنوان",
    'screen.audit.changes.filter.action': "العملية",
    'screen.audit.changes.filter.occurred_at': "التاريخ",
    'screen.audit.changes.filter.screen': "الشاشة",
    'screen.audit.changes.filter.actor_name': "المستخدم",
    'screen.audit.changes.stat.all': "العمليات",
    'screen.audit.changes.stat.created': "إضافة",
    'screen.audit.changes.stat.updated': "تعديل",
    'screen.audit.changes.stat.deleted': "حذف",
    'screen.audit.changes.action.details': "التفاصيل",
    'value.action.create': "إضافة",
    'value.action.update': "تعديل",
    'value.action.delete': "حذف",
    'value.action.status': "تغيير حالة",
    'list.linkFilter': "يعرض فقط: {filters}.",
    'list.linkFilter.clear': "عرض الكل",
    'option.days.120': "120 يوماً",
    'option.days.90': "90 يوماً",
    'option.days.60': "60 يوماً",
    'option.days.30': "30 يوماً",
    'option.days.14': "14 يوماً",
    'option.days.7': "7 يوماً",
    'screen.calendar.occasions.action.create.section.occasion': "المناسبة",
    'screen.calendar.occasions.action.create.section.days': "الأيام",
    'screen.calendar.occasions.action.create.section.scope': "النطاق",
    'screen.documents.items.action.attach.section.document': "الوثيقة",
    'screen.documents.items.action.attach.section.owner': "لمن",
    'screen.documents.items.action.attach.section.validity': "الصلاحية",
    'screen.documents.items.action.attach.section.notes': "ملاحظات",
    'screen.documents.types.action.create.section.type': "النوع",
    'screen.documents.types.action.create.section.expiry': "الانتهاء والتنبيه",
    'screen.documents.types.action.create.section.keeping': "الحفظ",
    'screen.notifications.rules.action.create.section.when': "متى",
    'screen.notifications.rules.action.create.section.who': "مَن يُبلَّغ",
    'screen.notifications.rules.action.create.section.importance': "الأهمية والتصعيد",
    'screen.notifications.rules.action.edit.section.when': "متى",
    'screen.notifications.rules.action.edit.section.who': "مَن يُبلَّغ",
    'screen.notifications.rules.action.edit.section.importance': "الأهمية والتصعيد",
    'screen.einvoicing.sellers.action.create.section.seller': "المنشأة",
    'screen.einvoicing.sellers.action.create.section.address': "العنوان الوطني",
    'chips.add': "ابحث للإضافة…",
    'chips.remove': "إزالة {label}",
    'keyvalue.name': "الاسم",
    'keyvalue.value': "القيمة",
    'keyvalue.remove': "حذف هذا الصف",
    'keyvalue.add': "+ إضافة شرط",
    'field.after': "يجب أن يكون في {start} أو بعده.",
    'form.span': "{days}، باحتساب اليومين.",
    'unit.span_days.zero': '{n} يوم',
    'unit.span_days.one': 'يوم واحد',
    'unit.span_days.two': 'يومان',
    'unit.span_days.few': '{n} أيام',
    'unit.span_days.many': '{n} يومًا',
    'unit.span_days.other': '{n} يوم',
    'form.required': "مطلوب.",
    'form.missing': "أكمل: {fields}.",
    'form.unsaved': "لديك تغييرات لم تُحفظ. أتغادر النموذج دونها؟",
    'form.keepEditing': "متابعة التعديل",
    'form.discard': "تجاهلها والمغادرة",
    'form.saveNext': "حفظ وإضافة آخر",
    'form.savedNext': "حُفظ. النموذج جاهز للإدخال التالي.",
    'form.openSaved': "فتح السجل المحفوظ",
    'form.now': "الحالي: {value}",
    'form.secret.current': "الحالي: مضبوط · {value} — اتركه فارغاً للإبقاء عليه",
    'form.secret.unset': "لم يُضبط بعد",
    'screen.parties.parties.action.add_address.section.national': "العنوان الوطني",
    'screen.parties.parties.action.add_address.section.national.help': "العنوان كما هو مسجّل في خدمة العنوان الوطني.",
    'screen.parties.parties.action.add_address.section.abroad': "العنوان خارج المملكة",
    'unit.sar': "ر.س",
    'unit.percent': "٪",
    'unit.day': "يوم",
    'unit.month': "شهر",
    'unit.year': "سنة",
    'unit.minute': "دقيقة",
    'unit.metre': "م",
    'field.format.code': "أحرف لاتينية وأرقام و _ . - @ فقط.",
    'field.format.email': "بريد إلكتروني مثل name@example.com.",
    'field.format.phone': "رقم هاتف من 9 إلى 15 رقماً، ويجوز + في أوله.",
    'field.format.vat': "15 رقماً، يبدأ وينتهي بـ 3.",
    'field.format.cr': "10 أرقام.",
    'field.format.national_id': "10 أرقام، تبدأ بـ 1 للهوية الوطنية أو 2 للإقامة.",
    'field.format.postcode': "5 أرقام.",
    'field.format.building': "4 أرقام.",
    'form.check': "راجع الحقول المعلَّمة.",
    'option.colour.blue': "أزرق",
    'option.colour.green': "أخضر",
    'option.colour.teal': "فيروزي",
    'option.colour.amber': "كهرماني",
    'option.colour.red': "أحمر",
    'option.colour.pink': "وردي",
    'option.colour.violet': "بنفسجي",
    'option.colour.grey': "رمادي",
    'option.sa_region.riyadh': "الرياض",
    'option.sa_region.makkah': "مكة المكرمة",
    'option.sa_region.madinah': "المدينة المنورة",
    'option.sa_region.eastern_province': "المنطقة الشرقية",
    'option.sa_region.qassim': "القصيم",
    'option.sa_region.asir': "عسير",
    'option.sa_region.tabuk': "تبوك",
    'option.sa_region.hail': "حائل",
    'option.sa_region.northern_borders': "الحدود الشمالية",
    'option.sa_region.jazan': "جازان",
    'option.sa_region.najran': "نجران",
    'option.sa_region.al_bahah': "الباحة",
    'option.sa_region.al_jawf': "الجوف",
    'action.done': 'تمّ',
    'value.is_system.true': 'نظامي',
    'value.is_system.false': 'مخصّص',
    'value.second_factor.true': 'مفعّل',
    'value.second_factor.false': 'غير مفعّل',
    'value.requires_second_factor.true': 'مطلوب',
    'value.requires_second_factor.false': 'غير مطلوب',
    'value.status.active': 'نشط',
    'value.status.suspended': 'موقوف',
    'value.status.after_service': 'انتهت الخدمة',
    'value.status.invited': 'مدعوّ',
    'value.status.expired': 'انتهت صلاحيته',
    'value.enabled.true': 'مُشغَّل',
    'value.enabled.false': 'مُطفأ',
    'value.core.true': 'أساسي',
    'value.core.false': 'اختياري',
    'list.all': 'الكل',
    'list.closed': 'مُغلقة',
    'grid.rows': 'المورد',
    'grid.action.view': 'عرض',
    'grid.action.create': 'إنشاء',
    'grid.action.update': 'تعديل',
    'grid.action.delete': 'حذف',
    'grid.action.manage': 'إدارة',
    'grid.others': 'صلاحيات أخرى',
    'grid.count': '{held} من {of}',
    'grid.all': 'الكل',
    'grid.none': 'لا شيء',
    'grid.added': 'أُضيف',
    'grid.removed': 'سُحب',
    'grid.granted': 'ممنوحة',
    'list.search': 'بحث',
    'list.results': '{n:results}',
    'list.showing': 'تعرض {n} من {total}',
    'list.results.filtered': 'بعد الفلترة',
    'list.sort.asc': 'ترتيب تصاعدي',
    'list.sort.desc': 'ترتيب تنازلي',
    'list.sort.none': 'إلغاء الترتيب',
    'list.sort.by': 'ترتيب حسب {column}',
    'list.column.options': 'خيارات {column}',
    'list.column.filter': 'فلترة بهذا العمود…',
    'list.advanced': 'فلترة متقدّمة',
    'list.advanced.description': 'شرطٌ لكل سطر، والمقارنات تأتي من نوع العمود. أنت تختار العلاقة بين الشروط — كلّها أو أيّها — ومجموعةٌ بين قوسين تحمل علاقتَها الخاصّة.',
    'list.advanced.none': 'هذه الشاشة لا تعلن أعمدة للفلترة.',
    'list.match': 'طابِق',
    'list.match.all': 'كلّ الشروط',
    'list.match.any': 'أيّ شرط',
    'list.match.following': 'التالية',
    'list.match.inGroup': 'داخل هذه المجموعة',
    'list.condition.add': 'إضافة شرط',
    'list.condition.remove': 'إزالة الشرط',
    'list.condition.field': 'العمود',
    'list.condition.operator': 'المقارنة',
    'list.condition.value': 'القيمة',
    'list.condition.values': 'القيم',
    'list.group.add': 'إضافة مجموعة',
    'list.group.remove': 'إزالة المجموعة',
    'list.filters.clear': 'مسح الكلّ',
    'list.empty.title': 'لا توجد بيانات متاحة للعرض حالياً',
    'list.narrowed.title': 'لا صفّ يطابق هذه الشروط',
    'list.narrowed.lede': 'الأرقام أعلاه لم تتحرّك: فهي تُحسب على الكلّ لا على ما تركته الفلترة.',
    'list.apply': 'تطبيق',
    'list.and': 'و',
    'list.or': 'أو',
    'list.between.from': 'من',
    'list.between.to': 'إلى',
    'list.between.text': 'بين {from} و {to}',
    'op.contains': 'يحتوي',
    'op.starts': 'يبدأ بـ',
    'op.eq': 'يساوي',
    'op.in': 'واحد من',
    'op.gt': 'أكبر من',
    'op.lt': 'أصغر من',
    'op.between': 'بين',
    'op.on': 'في',
    'op.before': 'قبل',
    'op.after': 'بعد',
    'op.is': 'هو',
    'list.page.range': 'تعرض {from}–{to} من {total}',
    'list.page.size': 'لكل صفحة',
    'list.page.nav': 'الصفحات',
    'list.page.prev': 'الصفحة السابقة',
    'list.page.next': 'الصفحة التالية',
    'list.export': 'تصدير',
    'list.export.description': 'الملفّ يُبنى من الاستعلام نفسه الذي يرسم القائمة — الفرز والفلترة كما ضبطتَها — لا من الصفوف الظاهرة وحدها.',
    'list.export.scope': 'النطاق',
    'list.export.filtered': 'كل النتائج بعد الفلترة ({n})',
    'list.export.page': 'هذه الصفحة فقط ({n})',
    'list.export.selected': 'الصفوف المحدَّدة ({n})',
    'list.export.selected.short': 'تصدير المحدَّد',
    'list.export.format': 'الصيغة',
    'list.export.format.csv': 'يفتحه كل شيء؛ UTF‑8 مع علامة ترتيب البايت كي يقرأ Excel العربية',
    'list.export.columns': 'الأعمدة',
    'list.export.columns.shown': 'المعروضة الآن',
    'list.export.columns.all': 'كلّ أعمدة الشاشة',
    'list.export.download': 'تنزيل',
    'list.selection.count': 'محدَّد {n}',
    'list.selection.onPage': 'منها {n} على هذه الصفحة',
    'list.selection.clear': 'إلغاء التحديد',
    'list.pick': 'تحديد هذا الصفّ',
    'list.pickRow': 'تحديد {name}',
    'action.onRow': '{action}: {name}',
    'list.pickPage': 'تحديد كل صفوف هذه الصفحة',
    'list.bulk.title': '{action} — {n} صفّاً؟',
    'list.bulk.description': 'الخادم يحكم على كل صفّ وحده: ما يخالف قاعدةً يُرفض ويُقال لماذا، والباقي يمرّ.',
    'list.bulk.willRun': 'سيُنفَّذ على',
    'list.bulk.willSkip': 'لا ينطبق على',
    'list.bulk.skipWhy': 'صفوف لا يُعرض عليها هذا الإجراء',
    'list.bulk.outcome': 'تمّ {done}',
    'list.bulk.outcome.refused': 'رُفض {refused}',
    'lookup.placeholder': 'اكتب للبحث…',
    'lookup.add': 'إضافة «{text}»',
    'lookup.none': 'لا شيء يطابق',
    'lookup.clear': 'مسح',
    'lookup.noCreate': 'تلك الشاشة لا تملك إجراء إضافة يُفتح',
    'lookup.createForbidden': 'الإضافة من هنا تحتاج صلاحية لا تملكها',
    'file.choose': 'اختر ملفّاً',
    'file.change': 'تغيير',
    'file.remove': 'إزالة',
    'file.tooLarge': 'أكبر من {limit}',
    'file.storing': 'جارٍ رفع الملف…',
    'file.notStored': 'لم يُرفع الملف: {reason}',
    'file.store.noMedia': 'لا يمكن رفع ملف هنا: مخزن الملفات غير مفعّل في مساحة العمل هذه.',
    'file.store.refused': 'رفض مخزن الملفات رفع الملف.',
    'file.store.unreachable': 'تعذّر الوصول إلى مخزن الملفات.',
    'file.chooseMany': 'اختر ملفات',
    'file.add': 'أضف ملفاً',
    'file.tooMany': 'الحدّ الأقصى {limit} ملفات',
    'audio.record': 'تسجيل',
    'audio.stop': 'إيقاف',
    'audio.recording': 'جارٍ التسجيل {elapsed}',
    'audio.limit': 'حتى {limit}',
    'audio.unsupported': 'هذا المتصفّح لا يسجّل الصوت. أرفق التسجيل ملفاً بدلاً من ذلك.',
    'audio.denied': 'لم يُسمح باستخدام الميكروفون. اسمح به من إعدادات المتصفّح ثم أعد المحاولة.',
    'audio.failed': 'تعذّر استخدام الميكروفون.',
    'value.separator': '، ',
    'value.everything': 'كل شيء',
    'value.yes': 'نعم',
    'value.no': 'لا',
    'value.source.default': 'من المنصّة',
    'value.source.override': 'محدَّد هنا',
    'value.source.unset': 'بلا قيمة بعد',
    'action.save': 'حفظ',
    'action.reset': 'استخدم قيمة المنصّة',
    'action.resetShort': 'استعادة',
    'action.undo': 'تراجع',
    'action.retry': 'أعد المحاولة',
    'action.signOut': 'تسجيل الخروج',
    'wizard.lede': 'مساعدٌ يكتب هذه الأسئلة مما يتيحه النظام وما يقبله كل إعداد. لا يرى بياناتك أبداً، ولن يطلب كلمة مرور أو مفتاحاً. ويمكنك تجاوزها كلها.',
    'wizard.reportFailed': 'كل ما فوق حدث فعلاً، لكن تعذّر إبلاغ المساعد ببعضه. سيُعرض عليك ثانيةً في المرّة القادمة؛ إكماله ثانيةً آمن.',
    'wizard.writing': 'يكتب السؤال التالي…',
    'wizard.question.n': 'السؤال {n}',
    'wizard.byAssistant': 'كتبه المساعد',
    'wizard.answered': 'ما أجبتَ عنه',
    'wizard.change': 'تغيير',
    'wizard.setAside': 'نُحّي {n} من الأجوبة اللاحقة جانباً — تغيّرت الأسئلة.',
    'wizard.nothingChosen': 'لم يُختر شيء',
    'wizard.continue': 'متابعة',
    'wizard.backToQuestions': 'عودة إلى الأسئلة',
    'wizard.review.title': 'ما سيحدث',
    'wizard.review.summaryCaption': 'ملخّص المساعد لما فهمه',
    'wizard.review.turnsOn': 'يُفعَّل',
    'wizard.review.writes': 'يُكتب',
    'wizard.review.pulledInBy': 'يأتي مع {by}',
    'wizard.review.nothing': 'لم تختر شيئاً لتفعيله.',
    'wizard.review.toDefault': 'عودة إلى الافتراضي',
    'wizard.apply.modules': 'فعّل {n}',
    'wizard.apply.settings': 'اكتب {n}',
    'wizard.apply.join': ' و',
    'wizard.apply.and': 'أنهِ: {what}',
    'wizard.apply.nothing': 'أنهِ',
    'wizard.applying': 'يجري التطبيق…',
    'wizard.result.title': 'تمّ',
    'wizard.result.count': '{ok} تمّ · {refused} رُفض',
    'wizard.outcome.ok': 'تمّ',
    'wizard.outcome.rejected': 'رُفض',
    'wizard.outcome.forbidden': 'غير مسموح',
    'wizard.outcome.unavailable': 'غير متاح',
    'wizard.outcome.timeout': 'انتهت المهلة',
    'wizard.outcome.skipped': 'لم يُنفَّذ',
    'wizard.notTried': 'لم يُجرَّب، لأن تفعيل ما اخترته رُفض',
    'wizard.noWorkspaceAddress': 'وحدة مساحة العمل بلا عنوان بعد',
    'wizard.continueAnyway': 'افتح مساحة العمل على أي حال',
    'wizard.open': 'افتح مساحة العمل',
    'wizard.next.title': 'ما تُعدّه بعد ذلك',
    'wizard.next.lede': 'ما فعّلته جاهز للإعداد. ابدأ بالأول، أو عُد إليها من قسم «الإعداد» في كلٍّ منها.',
    'wizard.next.start': 'ابدأ الإعداد',
    'wizard.resume.title': 'شيء لم يكتمل',
    'wizard.resume.lede': 'أُكِّد إعداد سابقاً ولم يكتمل — نُفِّذ منه {n}. المحدَّد أدناه لم يُنفَّذ بعد؛ أزل تحديد ما تفضّل تركه.',
    'wizard.finish': 'أكمل الباقي',
    'wizard.fallback.noAssistant': 'لا مساعد منشور — هذان السؤالان يعملان بدونه.',
    'wizard.fallback.unavailable': 'تعذّر الوصول إلى المساعد — هذان السؤالان يعملان بدونه.',
    'wizard.fallback.refused': 'تعذّر استخدام جواب المساعد — هذان السؤالان يعملان بدونه.',
    'setup.title': 'أهلاً بك',
    'setup.name.title': 'بأي اسم يعرفك زملاؤك؟',
    'setup.name.help': 'يظهر في الشريط الجانبي وعلى كل ما تُعدّه أو تعتمده، بدل عنوان بريدك.',
    'setup.name.required': 'اكتب اسمك، 120 حرفاً على الأكثر.',
    'setup.lede': 'سؤالان، وتصبح مساحة العمل جاهزة.',
    'setup.step.pack': 'فيمَ ستُستخدم مساحة العمل؟',
    'setup.step.modules': 'ما تبدأ به',
    'setup.step.of': 'الخطوة {n} من 2',
    'setup.back': 'رجوع',
    'setup.skip': 'تجاوز',
    'setup.noPacks': 'لا حزم بدء بعد. يُفعَّل ما تستخدمه مساحة العمل من إعداداتها.',
    'setup.finish': 'فعّل {n} وأنهِ',
    'setup.notHere': 'هذا النظام لا يحوي: {keys}. وما عداها يسري.',
    'module.settings': 'الإعدادات',
    'module.activity_log': 'سجلّ النشاط',
    'module.tags': 'التصنيفات',
    'module.media': 'الملفّات',
    'auth.email': 'البريد',
    'auth.identifier': 'البريد الإلكتروني أو رقم الجوال',
    'auth.password': 'كلمة المرور',
    'auth.signIn': 'دخول',
    'invite.heading': 'دعوة',
    'invite.title': 'الانضمام إلى {workspace}',
    'assistant.open': 'اسأل المساعد',
    'assistant.title': 'المساعد',
    'assistant.close': 'إغلاق المساعد',
    'assistant.new': 'محادثة جديدة',
    'assistant.placeholder': 'اسأل عن أي شيء في النظام…',
    'assistant.send': 'إرسال',
    'assistant.pick': 'حدّد جزءاً من الصفحة',
    'assistant.picking': 'اضغط على أي جزء في الصفحة، أو استخدم Tab ثم Enter. Esc للإلغاء.',
    'assistant.pickCancel': 'إلغاء التحديد',
    'assistant.removePick': 'إزالة {what}',
    'assistant.thinking': 'أعمل على ذلك…',
    'assistant.intro': 'أعرف كل أجزاء النظام وأقرأ ما يسمح به حسابك. اسأل عن شاشة أو سجل أو كيف تنجز شيئاً، أو حدّد جزءاً من الصفحة واسأل عنه.',
    'assistant.example.1': 'ماذا أستطيع أن أفعل في هذه المساحة؟',
    'assistant.example.2': 'اشرح لي ما في هذه الصفحة',
    'assistant.example.3': 'كيف أدعو مستخدماً جديداً؟',
    'assistant.explainPage': 'اشرح لي الشاشة الحالية',
    'assistant.howItWorks': 'لا أحتفظ ببيانات نظامك: أعرف بنيته فقط، لا ما فيه. عندما تسأل أقرأ ما أحتاجه فقط، بصلاحياتك، وأصوغ لك الإجابة. وتُحفظ محادثاتك لك وحدك.',
    'assistant.proposal': 'قيم مقترحة لـ{form}',
    'assistant.proposal.form': 'النموذج المفتوح',
    'assistant.apply': 'طبّق على النموذج',
    'assistant.applied': 'طُبّقت — راجعها واضغط «حفظ» بنفسك.',
    'assistant.proposalGone': 'هذا النموذج لم يعد مفتوحاً.',
    'assistant.filledMark': 'المساعد',
    'assistant.yes': 'نعم',
    'assistant.no': 'لا',
    'assistant.photo.button': 'املأ من صورة',
    'assistant.photo.hint': 'التقط صورة المستند أو اخترها؛ يقرؤها المساعد في هذا النموذج، وتطبّق أنت ما توافق عليه.',
    'assistant.photo.reading': 'تُقرأ الصورة…',
    'assistant.photo.trace': 'قرأ صورةً لملء النموذج',
    'assistant.photo.nothing': 'لم يطابق شيءٌ في الصورة حقول هذا النموذج.',
    'assistant.photo.unsure': 'راجع هذه قبل تطبيقها، فالصورة لم تكن واضحة فيها: {fields}',
    'assistant.photo.failed': 'تعذّرت قراءة الصورة. {reason}',
    'assistant.photo.off': 'قراءة الصور بالمساعد غير مفعّلة في مساحة العمل هذه.',
    'assistant.photo.notImage': 'هذا الملف ليس صورة يستطيع المتصفح قراءتها.',
    'assistant.photo.noFields': 'لا حقل في هذا النموذج تستطيع صورة أن تملأه.',
    'assistant.photo.tooLarge': 'الصورة أكبر من {limit}.',
    'assistant.error.limit': 'بلغ المساعد حدّه الآن. حاول لاحقاً.',
    'assistant.error.unavailable': 'لا يمكن الوصول إلى المساعد الآن.',
    'assistant.error.slow': 'تأخّر النموذج في الإجابة. أعد السؤال، أو اسأل سؤالاً أقصر.',
    'assistant.error.key': 'رُفض مفتاح نموذج المساعد. يلزم أن يجدّده مالك المنصّة.',
    'assistant.error.busy': 'النموذج مشغول الآن. حاول بعد دقيقة.',
    'assistant.error.model': 'تعذّرت إجابة النموذج: {detail}',
    'assistant.error.long': 'هذه المحادثة طويلة جداً. ابدأ محادثة جديدة.',
    'assistant.error.context': 'تعذّر على المساعد قبول وصف النظام لهذه الصفحة. أبلغ عن ذلك ليُصلَح.',
    'assistant.error.failed': 'لم يستطع المساعد الإجابة: {detail}',
    'assistant.trace.read': 'قرأ {what}',
    'assistant.trace.describe': 'اطّلع على طريقة عمل {what}',
    'assistant.trace.api': 'اطّلع على مسارات القراءة في {what}',
    'assistant.trace.call': 'قرأ {what}',
    'assistant.trace.page': 'قرأ هذه الصفحة',
    'assistant.trace.find': 'بحث عن {what} في النظام',
    'assistant.trace.open': 'فتح {what}',
    'assistant.trace.form': 'فتح النموذج {what}',
    'assistant.trace.fill': 'اقترح قيماً للنموذج',
    'assistant.trace.highlight': 'أشار إلى جزء من الصفحة',
    'assistant.trace.failed': 'تعذّرت خطوة',
    'assistant.refusal.home.prompt': 'اكتب ما تريد أن تعرضه البطاقة، في {max} حرفاً على الأكثر.',
    'assistant.refusal.home.request': 'تعذّرت قراءة طلب البطاقة. أعد تحميل الصفحة وحاول مرة أخرى.',
    'assistant.refusal.home.catalogue': 'لا توجد مسارات تُبنى منها بطاقة، أو أنها أكثر من {max}. أعد تحميل الصفحة وحاول مرة أخرى.',
    'assistant.refusal.home.actions': 'الإجراءات المعروضة لنماذج البطاقة أكثر من {max}، أو ليست بالشكل المتوقع. أعد تحميل الصفحة وحاول مرة أخرى.',
    'assistant.refusal.home.sample': 'عيّنة الحقول المرسلة مع الطلب ليست أسماءً وأنواعاً فقط، أو فيها أكثر من {max} حقلاً لمسار واحد.',
    'assistant.refusal.home.current': 'البطاقة المراد تعديلها ليست بطاقة صالحة. ابنِ بطاقة جديدة بدلاً منها.',
    'assistant.refusal.home.none': 'لم يقترح المساعد بطاقة. جرّب صياغة الطلب بطريقة أخرى.',
    'assistant.refusal.home.invalid': 'اقترح المساعد بطاقة غير صالحة. جرّب صياغة الطلب بطريقة أخرى.',
    'assistant.refusal.home.write': 'المصدر المقترح {path} يغيّر البيانات أو ليس قراءة مسموحة للبطاقة. البطاقة تقرأ فقط.',
    'assistant.refusal.home.blank': 'المصدر المقترح {path} يترك جزءاً من مساره فارغاً. اطلب قائمة لا سجلاً واحداً.',
    'assistant.refusal.home.route': 'المصدر المقترح {path} ليس من المسارات التي تملك قراءتها.',
    'assistant.refusal.home.param': '«{name}» ليس معاملاً للمسار {path}.',
    'assistant.refusal.home.field': '«{field}» ليس حقلاً في {path}.',
    'assistant.refusal.home.paged_group': 'المسار {path} يجيب صفحةً صفحة، فالرسم منه لا يعدّ إلا تلك الصفحة. اطلب عدداً أو جدولاً بدلاً منه.',
    'assistant.refusal.home.paged_filter': 'المسار {path} يجيب صفحةً صفحة، فالتصفية في البطاقة لا تضيّق إلا تلك الصفحة. ضيّق المسار نفسه بدلاً منها.',
    'assistant.refusal.home.paged_sort': 'المسار {path} يجيب صفحةً صفحة، فالترتيب في البطاقة لا يرتّب إلا تلك الصفحة.',
    'assistant.refusal.home.explanation': 'لم يشرح المساعد البطاقة باللغتين. حاول مرة أخرى.',
    'assistant.refusal.home.conversation': 'تعذّر تحديد محادثة هذه البطاقة بهذه الصيغة. أغلق البطاقة وافتحها من جديد.',
    'assistant.mode.right': 'تثبيت على اليمين',
    'assistant.mode.left': 'تثبيت على اليسار',
    'assistant.mode.box': 'صندوق محادثة — اسحبه إلى أي مكان',
    'assistant.mode.full': 'كامل الصفحة',
    'assistant.drag': 'اسحب لتحريك المساعد، وأفلته عند الحافة اليمنى أو اليسرى لتثبيته',
    'assistant.history': 'المحادثات السابقة',
    'assistant.history.kept': 'تُحفظ محادثاتك لك وحدك، {days} يوماً بعد آخر استخدام لها.',
    'assistant.history.empty': 'لا محادثات سابقة بعد.',
    'assistant.history.meta': '{n} سؤال · {when}',
    'assistant.history.delete': 'حذف «{title}»',
    'invite.lede.new': 'دُعيت إلى مساحة العمل هذه. اختر اسمك وكلمة مرور للانضمام.',
    'invite.lede.account': 'لهذا العنوان حساب قائم. سجّل الدخول بكلمة مروره لتنضم إلى هذه المساحة أيضاً.',
    'invite.name': 'اسمك',
    'invite.newPassword': 'اختر كلمة مرور',
    'invite.passwordAgain': 'أعد كتابة كلمة المرور',
    'invite.passwordHelp': '{n} أحرف على الأقل.',
    'invite.passwordShort': 'تحتاج كلمة المرور إلى {n} أحرف على الأقل.',
    'invite.passwordMismatch': 'كلمتا المرور غير متطابقتين.',
    'invite.accept': 'الانضمام إلى المساحة',
    'invite.acceptSignIn': 'الدخول والانضمام',
    'invite.until': 'يعمل هذا الرابط حتى {date}، ولمرة واحدة.',
    'invite.closed.unknown': 'هذا الرابط لا يعمل: سُحبت الدعوة أو استُبدلت برابط أحدث. اطلب رابطاً جديداً ممن دعاك.',
    'invite.closed.accepted': 'قُبلت هذه الدعوة من قبل. سجّل الدخول للوصول إلى المساحة.',
    'invite.closed.expired': 'انتهت صلاحية هذه الدعوة. اطلب ممن دعاك إرسال رابط جديد.',
    'invite.closed.unavailable': 'تعذّرت قراءة الدعوة الآن. جرّب الرابط بعد قليل.',
    'auth.chooseWorkspace': 'اختر مساحة عمل',
    'auth.choosePortal': 'اختر بوابة',
    'auth.group.workspaces': 'مساحات العمل',
    'auth.group.portals': 'البوابات',
    'auth.portalWord': 'بوابة',
    'portal.title': 'البوابة',
    'portal.menu.label': 'حسابي',
    'portal.menu.account': 'حسابي',
    'portal.menu.switch': 'تبديل إلى بوابة {workspace}',
    'portal.menu.signOut': 'تسجيل الخروج',
    'portal.account.title': 'حسابي',
    'portal.account.back': 'العودة إلى البوابة',
    'portal.empty.title': 'لا يوجد ما تعرضه لك البوابة الآن',
    'portal.empty.description': 'حين تشاركك {workspace} شيئاً يظهر هنا.',
    'portal.tab.failed': 'تعذّر تحميل هذا القسم الآن.',
    'portal.tab.retry': 'إعادة المحاولة',
    'portal.back': 'العودة إلى القائمة',
    'portalInvite.heading': 'دعوة إلى البوابة',
    'portalInvite.lede': 'دُعيت إلى بوابة {workspace}.',
    'portalInvite.lede.by': 'دعاك {inviter} إلى بوابة {workspace}.',
    'portalInvite.hasPassword': 'لديك كلمة مرور من قبل. اقبل الدعوة ثم سجّل الدخول بها.',
    'portalInvite.newPassword': 'اختر كلمة مرور',
    'portalInvite.passwordAgain': 'أعد كتابة كلمة المرور',
    'portalInvite.passwordHelp': '{n} أحرف على الأقل.',
    'portalInvite.passwordShort': 'تحتاج كلمة المرور إلى {n} أحرف على الأقل.',
    'portalInvite.passwordMismatch': 'كلمتا المرور غير متطابقتين.',
    'portalInvite.accept': 'قبول الدعوة',
    'portalInvite.acceptSetPassword': 'قبول الدعوة وإنشاء كلمة المرور',
    'portalInvite.until': 'يعمل هذا الرابط حتى {date}، ولمرة واحدة.',
    'portalInvite.closed.unknown': 'هذا الرابط لا يعمل: سُحبت الدعوة أو استُبدلت برابط أحدث. اطلب دعوة جديدة.',
    'portalInvite.closed.accepted': 'استُخدمت هذه الدعوة من قبل. سجّل الدخول للوصول إلى البوابة.',
    'portalInvite.closed.expired': 'انتهت صلاحية هذه الدعوة؛ اطلب دعوة جديدة.',
    'portalInvite.closed.unavailable': 'تعذّرت قراءة الدعوة الآن. جرّب الرابط بعد قليل.',
    'auth.signOutUnconfirmed': 'خرجتَ من هذا المتصفّح، لكن خدمة الهوية لم تؤكّد ذلك. أعد تسجيل الخروج حين تصبح متاحة.',
    'auth.secondStep.title': 'الدخول بخطوتين',
    'auth.secondStep.lede': 'أدخل الرمز ذا الأرقام الستة الذي يعرضه تطبيق المصادقة لمساحة {workspace}.',
    'auth.secondStep.code': 'الرمز',
    'auth.secondStep.recoveryCode': 'رمز الاسترداد',
    'auth.secondStep.useRecovery': 'هاتفي ليس معي: استعمل رمز استرداد',
    'auth.secondStep.useCode': 'استعمل تطبيق المصادقة بدلاً منه',
    'auth.secondStep.continue': 'متابعة',
    'auth.secondStep.back': 'اختر مساحة عمل أخرى',
    'auth.secondStep.enrolFirst': 'تشترط مساحة {workspace} الدخول بخطوتين. فعّله الآن؛ تدخل حين يُؤكَّد أول رمز.',
    'auth.secondStep.locked': 'رموز خاطئة كثيرة. حاول بعد {minutes} دقيقة.',
    'identity.refusal.second_factor.code_required': 'أدخل الرمز من تطبيق المصادقة.',
    'identity.refusal.second_factor.not_enrolled': 'تشترط هذه المساحة الدخول بخطوتين. فعّله أولاً.',
    'identity.refusal.second_factor.wrong_code': 'هذا الرمز غير صحيح.',
    'identity.refusal.second_factor.locked': 'رموز خاطئة كثيرة. حاول بعد {minutes} دقيقة.',
    'identity.refusal.second_factor.nothing_pending': 'لا يوجد تطبيق مصادقة جديد ينتظر رمزاً. ابدأ من جديد.',
    'identity.refusal.second_factor.not_configured': 'الدخول بخطوتين غير متاح في هذا التنصيب: لا مفتاح لديه لحفظ أسرار المصادقة (SECOND_FACTOR_KEK).',
    'identity.refusal.second_factor.password_required': 'أدخل كلمة مرورك الحالية.',
    'identity.refusal.second_factor.wrong_password': 'هذه ليست كلمة مرورك الحالية.',
    'identity.refusal.home.stale': 'تغيّرت صفحاتك الرئيسية في نافذة أخرى. أعد تحميلها وحاول مجدداً.',
    'identity.refusal.home.version': 'هذا الحفظ لا يذكر نسخة الصفحات التي بُني عليها. أعد تحميلها وحاول مجدداً.',
    'identity.refusal.member.name_required': 'اكتب اسم الشخص. لا يُضاف أحد بعنوان بريده وحده.',
    'identity.refusal.sign_in.wrong_credentials': 'البريد الإلكتروني أو رقم الجوال أو كلمة المرور غير صحيح.',
    'identity.refusal.sign_in.ambiguous_phone': 'رقم الجوال هذا مسجّل لأكثر من حساب. ادخل ببريدك الإلكتروني بدلاً منه.',
    'identity.refusal.sign_in.too_many_attempts': 'محاولات كثيرة. حاول بعد {minutes} دقيقة.',
    'identity.refusal.workspace_unknown': 'لا توجد شركة بهذا الرمز. تحقّق منه وأعد المحاولة.',
    'identity.refusal.branding.nothing': 'اكتب الاسم بالعربية أو بالإنجليزية أو بكليهما.',
    'identity.refusal.branding.name_ar': 'الاسم بالعربية نص حتى 120 حرفًا.',
    'identity.refusal.branding.name_en': 'الاسم بالإنجليزية نص حتى 120 حرفًا.',
    'media.refusal.logo.file_id': 'اختر صورة، أو أزل الشعار.',
    'media.refusal.logo.not_found': 'هذا الملف ليس في مساحة العمل هذه.',
    'media.refusal.logo.not_ready': 'لم يكتمل رفع الصورة بعد.',
    'media.refusal.logo.type': 'الشعار صورة PNG أو JPEG أو WebP.',
    'media.refusal.logo.size': 'الصورة أكبر من أن تكون شعارًا: 2 ميجابايت على الأكثر.',
    'media.refusal.logo.none': 'لا شعار لمساحة العمل هذه.',
    'identity.refusal.workspace_lookup.too_many': 'محاولات كثيرة. انتظر دقيقة ثم أعد المحاولة.',
    'identity.refusal.phone.taken': 'رقم الجوال هذا مستعمل في حساب آخر. لكل شخص رقمه الذي يدخل به.',
    'identity.refusal.portal.party_required': 'اختر الطرف المراد دعوته.',
    'identity.refusal.portal.module_required': 'اختر الوحدة التي يُدعى الطرف إلى بوابتها.',
    'identity.refusal.portal.unknown_party': 'لا يوجد طرف نشط بهذا في مساحة العمل.',
    'identity.refusal.portal.no_contact': 'ليس لهذا الطرف بريد إلكتروني ولا رقم جوال تُرسل إليه الدعوة. أضف أحدهما إلى سجله أولاً.',
    'identity.refusal.portal.no_portal': 'ليس للوحدة {module} بوابة في مساحة العمل هذه.',
    'identity.refusal.portal.already_active': 'هذا الطرف يدخل البوابة فعلاً.',
    'identity.refusal.portal.suspended': 'حساب هذا الطرف في البوابة معلّق. استأنفه بدلاً من دعوته.',
    'identity.refusal.portal.not_suspended': 'حساب البوابة هذا غير معلّق.',
    'identity.refusal.portal.account_taken': 'الحساب الذي يحمل بريد هذا الطرف أو جواله يدخل هذه البوابة باسم طرف آخر.',
    'identity.refusal.portal.ambiguous_phone': 'رقم الجوال هذا مسجّل لأكثر من حساب. أضف للطرف بريداً إلكترونياً.',
    'identity.refusal.portal.unknown_account': 'لا يوجد حساب بوابة بهذا في مساحة العمل.',
    'identity.refusal.portal.no_account': 'ليس لك حساب نشط في بوابة مساحة العمل هذه، أو أنه معلّق.',
    'identity.refusal.portal.external_account': 'هذا الحساب لشخص من خارج مساحة العمل (حساب بوابة)، فلا يكون عضواً فيها.',
    'identity.refusal.portal_invitation.unknown': 'رابط الدعوة هذا غير صالح. اطلب رابطاً جديداً.',
    'identity.refusal.portal_invitation.accepted': 'قُبلت هذه الدعوة من قبل. ادخل بحسابك.',
    'identity.refusal.portal_invitation.expired': 'انتهت صلاحية هذه الدعوة. اطلب دعوة جديدة.',
    'identity.refusal.role.portal_permission': 'صلاحيات البوابة لا تُعطى لدور: {keys}',
    'identity.refusal.password.wrong_current': 'هذه ليست كلمة مرورك الحالية.',
    'identity.refusal.password.too_short': 'كلمة المرور تحتاج {min} أحرف على الأقل.',
    'identity.refusal.password.unchanged': 'اختر كلمة مرور غير التي لديك.',
    'identity.refusal.home.shape': 'هذه ليست قائمة صفحات وبطاقات.',
    'identity.refusal.home.too_many_pages': 'يمكنك أن تملك {max} صفحات رئيسية على الأكثر.',
    'identity.refusal.home.too_many_cards': 'تتسع الصفحة لـ{max} بطاقة على الأكثر.',
    'identity.refusal.home.too_many_hubs': 'صفحة واحدة فقط يمكن أن تكون لوحة المساحة.',
    'identity.refusal.home.page_shape': 'في هذه الصفحة ما لا تحمله صفحة رئيسية.',
    'identity.refusal.home.page_id': 'ليس لهذه الصفحة معرّف صالح.',
    'identity.refusal.home.page_id_duplicate': 'لصفحتين المعرّف نفسه.',
    'identity.refusal.home.page_kind': 'الصفحة إما لوحة المساحة وإما صفحة بطاقات.',
    'identity.refusal.home.hub': 'صفحة اللوحة تسمّي لوحتها، ولا يسمّيها غيرها.',
    'identity.refusal.home.hub_cards': 'صفحة اللوحة تعرض اللوحة نفسها، ولا تحمل بطاقات خاصة بها.',
    'identity.refusal.home.title': 'سمِّ الصفحة بالعربية والإنجليزية، كلٌّ منهما حتى {max} حرفاً.',
    'identity.refusal.home.card_invalid': 'هذه البطاقة غير صالحة: {reason}',
    'identity.refusal.home.card_id_duplicate': 'لبطاقتين المعرّف نفسه.',
    'identity.refusal.home.not_archived': 'لا توجد صفحة أو بطاقة مزالة بهذا المعرّف.',
    'identity.refusal.home.card_page_gone': 'الصفحة التي كانت عليها هذه البطاقة لم تعد في رئيسيتك. استعد الصفحة أولاً.',
    'nav.noModules': 'لا توجد مديولات مفعّلة لمساحة العمل هذه بعد',
    'settings.title': 'الإعدادات',
    'settings.lede': 'ما تقرّره مساحة العمل بنفسها، وما تأخذه من المنصّة.',
    'nav.modules': 'المديولات',
    'nav.globals': 'وصول سريع',
    'nav.home': 'الرئيسية',
    'screen.missing.title': 'هذه الشاشة غير متاحة',
    'screen.missing.module': 'وحدتها غير مفعّلة في هذه المساحة، ويستطيع مدير المساحة تفعيلها.',
    'screen.missing.screen': 'لا تملك صلاحية هذه الشاشة، أو أن الرابط غير صحيح.',
    'screen.missing.home': 'الذهاب إلى الرئيسية',
    'nav.search': 'بحث',
    'nav.favourites': 'المفضّلة',
    'nav.favourites.none': 'لا شيء مثبَّت بعد — علّم شاشة بنجمة من القائمة أدناه.',
    'nav.favourite.add': 'تثبيت في المفضّلة',
    'nav.favourite.remove': 'إلغاء التثبيت',
    'nav.recents': 'الأخيرة',
    'nav.recents.none': 'تظهر هنا الشاشات والسجلات التي تفتحها.',
    'nav.section.follow_up': 'المتابعة',
    'nav.section.setup': 'الإعداد',
    'nav.quick': 'الوصول السريع',
    'nav.category.current': 'المجال الحالي',
    'nav.category.short': 'المجال',
    'nav.units': 'الوحدات',
    'nav.category.switch': 'تغيير المجال',
    'nav.category.in_family': '{family} › {line}',
    'notifications.title': 'التنبيهات',
    'palette.records': 'السجلات',
    'hub.approvals.waiting': '{n} بانتظار قرارك',
    'notifications.none': 'لا تنبيهات',
    'notifications.about': 'بخصوص: {name}',
    'notifications.due': 'كان مستحقاً في {day}',
    'notifications.repeats': 'تكرر {n}',
    'notifications.late_for': 'متأخر منذ {days}',
    'notifications.open_item': 'فتح: {item}',
    'notifications.acknowledge_item': 'إقرار بالاستلام: {item}',
    'notifications.markRead_item': 'تعليم كمقروء: {item}',
    'notifications.open': 'فتح',
    'search.placeholder': 'ابحث عن موظّف، سجلّ، أو شاشة…',
    'palette.title': 'انتقل إلى',
    'palette.hint': 'ابحث عن موظّف أو سجل أو شاشة…',
    'palette.nothing': 'لا شيء يطابق ذلك',
    'palette.actions': 'إجراءات',
    'nav.toggle': 'إظهار قائمة المديولات أو إخفاؤها',
    'nav.skipToContent': 'تخطَّ إلى المحتوى',
    'nav.trail': 'أين أنت',
    'locale.switch': 'اللغة',
    'category.finance': 'المالية',
    'category.people': 'شؤون الموظّفين',
    'category.parties': 'الأطراف',
    'category.platform': 'المنصّة',
    'category.administration': 'الإدارة',
    'category.unit': 'الوحدة',
    'category.unfiled': 'غير مصنّف',
    'group.sales': 'المبيعات',
    'group.purchases': 'المشتريات',
    'group.bank': 'البنك',
    'group.ledger': 'دفتر الأستاذ',
    'group.reports': 'التقارير والتحليلات',
    'group.setup': 'الإعداد',
    'group.einvoicing': 'الفوترة الإلكترونية',
    'group.treasury': 'الخزينة والبنوك',
    'group.general_ledger': 'المحاسبة العامة',
    'group.tax_einvoicing': 'الضريبة',
    'group.statements': 'القوائم المالية',
    'group.settings_export': 'الإعدادات والتصدير',
    'editor.back': 'العودة إلى القائمة',
    'nav.accounting.accounts': 'الحسابات',
    'nav.accounting.balance_sheet': 'قائمة المركز المالي',
    'nav.accounting.deposits': 'الدفعات المقدّمة من العملاء',
    'nav.accounting.dimension_values': 'قيم الأبعاد',
    'nav.accounting.dimensions': 'الأبعاد',
    'nav.accounting.entries': 'قيود اليومية',
    'nav.accounting.fiscal_years': 'السنوات المالية',
    'nav.accounting.income_statement': 'قائمة الدخل',
    'nav.accounting.journals': 'دفاتر اليومية',
    'nav.accounting.lock_dates': 'تواريخ الإقفال',
    'nav.accounting.opening': 'الأرصدة الافتتاحية',
    'nav.accounting.periods': 'الفترات والإقفال',
    'nav.accounting.posting_rules': 'قواعد الترحيل',
    'nav.accounting.receivables': 'الذمم المدينة',
    'nav.accounting.tax_codes': 'رموز الضريبة',
    'nav.accounting.tax_rules': 'قواعد الضريبة',
    'nav.accounting.trial_balance': 'ميزان المراجعة',
    'nav.activity_log.activity': 'النشاط',
    'nav.calendar.occasions': 'المناسبات',
    'nav.documents.items': 'المستندات',
    'nav.notifications.items': 'الإشعارات',
    'nav.einvoicing.connector': 'الربط مع منصّة فاتورة',
    'nav.einvoicing.devices': 'وحدات الحلول التقنية',
    'nav.einvoicing.edocuments': 'الفواتير الإلكترونية',
    'nav.einvoicing.sellers': 'بيانات المنشأة البائعة',
    'nav.einvoicing.submissions': 'سجل التقديم',
    'nav.identity.modules': 'الوحدات',
    'nav.identity.people': 'المستخدمون',
    'nav.identity.roles': 'الأدوار والصلاحيات',
    'nav.invoicing.aging_ap': 'أعمار الذمم الدائنة',
    'nav.invoicing.aging_ar': 'أعمار الذمم المدينة',
    'nav.invoicing.bank_reconciliation': 'تسوية البنك',
    'nav.invoicing.chart_mappings': 'ربط الدليل الخارجي',
    'nav.invoicing.customer_statements': 'أرصدة الأطراف',
    'nav.invoicing.documents': 'الفواتير',
    'nav.invoicing.export_batches': 'تصدير محاسبي خارجي',
    'nav.invoicing.payments': 'سندات القبض والصرف',
    'nav.invoicing.tax_register': 'سجل الفواتير الضريبية',
    'nav.invoicing.vat_return': 'إقرار ضريبة القيمة المضافة',
    'nav.invoicing.vendor_bills': 'فواتير المشتريات',
    'nav.invoicing.wht_statement': 'بيان ضريبة الاستقطاع',
    'nav.media.media': 'الملفات',
    'nav.module.accounting': 'المحاسبة',
    'nav.module.activity_log': 'سجل النشاط',
    'nav.module.audit': 'سجل التعديلات',
    'nav.module.privacy': 'البيانات الشخصية',
    'nav.module.chat': 'محادثة المساعد',
    'nav.module.calendar': 'التقويم',
    'nav.module.documents': 'المستندات',
    'nav.module.notifications': 'الإشعارات',
    'nav.module.einvoicing': 'الفوترة الإلكترونية',
    'nav.module.identity': 'الهوية',
    'nav.module.invoicing': 'الفوترة',
    'nav.module.media': 'الملفات',
    'nav.module.parties': 'الأطراف',
    'nav.module.settings': 'الإعدادات',
    'nav.module.tags': 'الوسوم',
    'nav.parties.parties': 'الأطراف',
    'nav.settings.settings': 'الإعدادات',
    'value.account_type.asset': 'أصل',
    'value.account_type.asset_bank': 'بنك',
    'value.account_type.asset_cash': 'نقدية',
    'value.account_type.asset_current': 'أصل متداول',
    'value.account_type.asset_non_current': 'أصل غير متداول',
    'value.account_type.asset_receivable': 'ذمم مدينة',
    'value.account_type.customer_deposit': 'دفعات مقدّمة من العملاء',
    'value.account_type.equity': 'حقوق ملكية',
    'value.account_type.expense': 'مصروف',
    'value.account_type.income': 'إيراد',
    'value.account_type.liability': 'التزام',
    'value.account_type.liability_current': 'التزام متداول',
    'value.account_type.liability_non_current': 'التزام غير متداول',
    'value.account_type.liability_payable': 'ذمم دائنة',
    'value.account_type.off_balance': 'خارج قائمة المركز المالي',
    'value.bucket.0_30': '0–30 يوماً',
    'value.bucket.31_60': '31–60 يوماً',
    'value.bucket.61_90': '61–90 يوماً',
    'value.bucket.over_90': 'أكثر من 90 يوماً',
    'value.buyer_type.*': 'أي',
    'value.buyer_type.b2b': 'أعمال',
    'value.buyer_type.b2c': 'مستهلك',
    'value.buyer_type.non_resident': 'غير مقيم',
    'value.buyer_type.resident': 'مقيم',
    'value.calendar.gregorian': 'ميلادي',
    'value.calendar.hijri': 'هجري',
    'value.circuit_open.false': 'مغلق',
    'value.circuit_open.true': 'مفتوح',
    'value.classification.simplified': 'مبسّطة',
    'value.classification.standard': 'قياسية',
    'value.direction.inbound': 'وارد',
    'value.direction.outbound': 'صادر',
    'value.deductible.full': 'كامل',
    'value.deductible.none': 'لا شيء',
    'value.deductible.partial': 'جزئي',
    'value.environment.issue_only': 'إصدار فقط',
    'value.environment.production': 'إنتاج',
    'value.environment.sandbox': 'تجريبي',
    'value.format.csv': 'CSV',
    'value.format.json': 'JSON',
    'value.journal_type.bank': 'بنك',
    'value.journal_type.cash': 'نقد',
    'value.journal_type.general': 'عام',
    'value.journal_type.purchase': 'مشتريات',
    'value.journal_type.purchases': 'مشتريات',
    'value.journal_type.sale': 'مبيعات',
    'value.journal_type.sales': 'مبيعات',
    'value.journal_type.zakat': 'زكاة',
    'value.kind.credit_note': 'إشعار دائن',
    'value.kind.customer_invoice': 'فاتورة عميل',
    'value.kind.debit_note': 'إشعار مدين',
    'value.kind.organisation': 'منشأة',
    'value.kind.person': 'شخص',
    'value.kind.vendor_bill': 'فاتورة مورّد',
    'value.match_kind.bank_charge': 'عمولة بنك',
    'value.match_kind.item': 'بند مفتوح',
    'value.method.bank': 'بنك',
    'value.method.card': 'بطاقة',
    'value.method.cash': 'نقد',
    'value.method.other': 'أخرى',
    'value.path.clearance': 'اعتماد',
    'value.path.not_required': 'غير مطلوب',
    'value.path.reporting': 'إبلاغ',
    'value.presentation.credit': 'دائن',
    'value.presentation.debit': 'مدين',
    'value.presentation.income_statement': 'قائمة الدخل',
    'value.presentation.off_balance': 'خارج قائمة المركز المالي',
    'value.presentation.statement_of_financial_position': 'قائمة المركز المالي',
    'value.residency.non_resident': 'غير مقيم',
    'value.residency.resident': 'مقيم',
    'value.report_status.cleared': 'اعتُمدت',
    'value.report_status.not_required': 'غير مطلوبة',
    'value.report_status.pending': 'قيد الانتظار',
    'value.report_status.rejected': 'مرفوضة',
    'value.report_status.reported': 'أُبلغت',
    'value.response_status.error': 'خطأ',
    'value.response_status.ok': 'مقبول',
    'value.response_status.rejected': "مرفوض",
    'value.response_status.unreachable': "تعذّر الوصول",
    'value.retry_class.none': 'لا شيء',
    'value.retry_class.permanent': 'دائم',
    'value.retry_class.retryable': 'قابل لإعادة المحاولة',
    'value.retry_class.terminal': 'نهائي',
    'value.retry_class.transient': 'عابر',
    'value.scope.documents': 'المستندات',
    'value.scope.journal_items': 'بنود اليومية',
    'value.source_kind.account': 'حساب',
    'value.source_kind.import': 'مستورد',
    'value.source_kind.journal': 'يومية',
    'value.source_kind.manual': 'يدوي',
    'value.source_kind.tax_code': 'رمز ضريبة',
    'value.state.closed': 'مغلق',
    'value.state.closing': 'قيد الإغلاق',
    'value.state.confirmed': 'مؤكّد',
    'value.state.exported': 'مُصدَّر',
    'value.state.open': 'مفتوح',
    'value.state.reopened': 'أُعيد فتحه',
    'value.status.closed': 'مغلق',
    'value.status.closing': 'قيد الإغلاق',
    'value.status.open': 'مفتوح',
    'value.status.reopened': 'أُعيد فتحه',
    'value.status.password_pending': "بانتظار كلمة المرور",
    'value.supply_destination.*': 'أي',
    'value.supply_destination.domestic': 'محلي',
    'value.supply_destination.export': 'تصدير',
    'value.supply_destination.gcc': 'خليجي',
    'value.tax_type.exempt': 'معفاة',
    'value.tax_type.out_of_scope': 'خارج النطاق',
    'value.tax_type.standard': 'قياسية',
    'value.tax_type.vat': 'ضريبة القيمة المضافة',
    'value.tax_type.withholding': 'ضريبة الاستقطاع',
    'value.tax_type.zero': 'صفرية',
    'value.state.draft': 'مسودة',
    'value.state.posted': 'مرحّل',
    'value.state.validated': 'مُعتمد',
    'value.state.cancelled_by_note': 'أُلغي بإشعار',
    'value.state.reversed': 'معكوس',
    'value.state.ready': 'جاهز',
    'value.state.pending': 'معلّق',
    'value.state.failed': 'فشل',
    'editor.field.name': 'الاسم',
    'editor.field.date': 'التاريخ',
    'editor.field.csv': 'CSV',
    'editor.address.street': 'الشارع',
    'editor.address.buildingNumber': 'رقم المبنى',
    'editor.address.district': 'الحي',
    'editor.address.city': 'المدينة',
    'editor.address.region': 'المنطقة',
    'editor.address.postcode': 'الرمز البريدي',
    'editor.address.country': 'الدولة',
    'editor.address.additionalNumber': 'الرقم الإضافي',
    'editor.address.unitNumber': 'رقم الوحدة',
    'editor.address.complete': 'العنوان مكتمل',
    'editor.address.incomplete': 'ناقص: {list}',
    'editor.address.buildingDigits': 'رقم المبنى أربعة أرقام',
    'editor.line.description': 'الوصف',
    'editor.line.quantity': 'الكمية',
    'editor.line.unitPrice': 'السعر',
    'editor.line.discount': 'الخصم',
    'editor.line.taxCode': 'رمز الضريبة',
    'editor.line.taxRate': 'النسبة %',
    'editor.line.account': 'الحساب',
    'editor.line.expenseAccount': 'حساب المصروف',
    'editor.line.add': 'سطر إضافي',
    'editor.line.remove': 'إزالة هذا السطر',
    'editor.line.net': 'الصافي',
    'editor.entry.total': 'المجموع',
    'editor.opening.format': 'account_code,debit,credit — سطرٌ لكلٍّ، وصفّ العناوين اختياري.',
    'editor.opening.fromFile': 'اقرأ من ملفّ بدلاً من ذلك',
    'editor.bank.amountHint': 'اتركه فارغاً لمطابقة السطر كلّه.',
    'editor.export.scope.journalItems': 'بنود القيود',
    'editor.export.scope.documents': 'المستندات',
    'editor.export.externalRefHint': 'المرجع الذي أعطاه النظام المستقبِل لهذه الدفعة.',
    'editor.invoice.title': 'فاتورة عميل',
    'editor.invoice.partyId': 'العميل',
    'editor.invoice.vat': 'الرقم الضريبي',
    'editor.invoice.salesJournal': 'يومية المبيعات',
    'editor.invoice.issueOn': 'تاريخ الإصدار',
    'editor.invoice.dueOn': 'تاريخ الاستحقاق',
    'editor.invoice.dueOnHint': 'إن تُرك فارغاً فهو تاريخ الإصدار مضافاً إليه أجل السداد، أو تاريخ الإصدار نفسه.',
    'editor.invoice.address': 'العنوان الوطني',
    'editor.invoice.totals': 'الصافي {net} + الضريبة {tax} = الإجمالي {total} ر.س — تقريب نصف لأعلى، منزلتان، فرق مسموح 0.01',
    'editor.invoice.zatca': 'تصنيف الفاتورة الإلكترونية',
    'editor.invoice.classification': 'التصنيف',
    'editor.invoice.standard': 'قياسية (B2B)',
    'editor.invoice.simplified': 'مبسطة (B2C)',
    'editor.invoice.override': 'سبب التجاوز المسجّل',
    'editor.invoice.saveIssue': 'حفظ وإصدار',
    'editor.saveDraft': 'حفظ مسودة',
    'editor.draft.saved': 'حُفظت مسودة. تبقى مسودة حتى تُصدَر: افتحها من القائمة متى شئت لتكملها.',
    'editor.draft.loading': 'جارٍ فتح المسودة…',
    'editor.draft.failed': 'تعذّر فتح المسودة: {reason}',
    'editor.draft.final': 'هذا المستند {state}. المستند الصادر لا يُعدَّل؛ يُصحَّح بإشعار دائن أو مدين.',
    'editor.draft.status.posted': 'صادر',
    'editor.draft.status.validated': 'معتمد',
    'editor.draft.status.cancelled_by_note': 'ملغى بإشعار',
    'editor.vendor.saveIssue': 'حفظ وإصدار',
    'editor.vendor.held': 'حُفظت مسودة ولم تُصدَر: {reason}. المسودة ما زالت قابلة للتعديل: صحّحها هنا أو عالج ما أوقفها، ثم أعد الإصدار.',
    'editor.vendor.issued': 'صدرت فاتورة المورّد {id}.',
    'editor.invoice.saved': 'صدرت الفاتورة {id}.',
    'editor.invoice.qr': 'QR {qr}',
    'editor.invoice.qrPending': 'رمز QR يظهر بعد الإصدار حين تكتمل بيانات المنشأة البائعة وتوجد وحدة حل تقني',
    'editor.invoice.classificationAuto': "تلقائي حسب الرقم الضريبي",
    'editor.invoice.held': "حُفظت مسودة ولم تُصدَر: {reason}. المسودة ما زالت قابلة للتعديل: صحّحها هنا، أو عالج ما أوقفها (رمز ضريبة يحتاج تأكيداً، فترة مقفلة)، ثم أعد الإصدار.",
    'editor.invoice.issueAgain': "إعادة الإصدار",
    'editor.invoice.party': "العميل",
    'editor.vendor.title': 'فاتورة مشتريات',
    'editor.vendor.partyId': 'معرف المورد',
    'editor.vendor.residency': 'الإقامة',
    'editor.vendor.resident': 'مقيم',
    'editor.vendor.nonResident': 'غير مقيم',
    'editor.vendor.purchaseJournal': 'يومية المشتريات',
    'editor.vendor.wht': 'ضريبة الاستقطاع على غير المقيم',
    'editor.vendor.whtCode': 'رمز ضريبة الاستقطاع',
    'editor.vendor.whtRate': 'نسبة ضريبة الاستقطاع %',
    'editor.vendor.payable': 'الصافي {net} + ضريبة {vat} − ضريبة الاستقطاع {wht} = المستحق {payable}',
    'editor.vendor.whtNote': 'ضريبة الاستقطاع تُرحَّل إلى التزام ولا تدخل في الفاتورة الإلكترونية.',
    'editor.vendor.issueOn': "تاريخ الفاتورة",
    'editor.vendor.dueOn': "تاريخ الاستحقاق",
    'editor.vendor.dueOnHint': "إن تُرك فارغاً فهو تاريخ الفاتورة مضافاً إليه أجل السداد، أو تاريخ الفاتورة نفسه.",
    'editor.vendor.party': "المورّد",
    'editor.entry.periodBanner': 'الفترة حسب التاريخ {date} — الترحيل إلى فترة مقفلة يُرفض (ACC-3). القيد المرحّل لا يُعدَّل.',
    'editor.entry.journalId': 'معرف اليومية',
    'editor.entry.narration': 'البيان',
    'editor.entry.debit': 'مدين',
    'editor.entry.credit': 'دائن',
    'editor.entry.difference': 'الفرق (مدين − دائن): {amount}',
    'editor.entry.post': 'ترحيل',
    'editor.entry.posted': 'مرحّل #{number}',
    'editor.entry.journal': "الدفتر",
    'editor.opening.lede': 'الأرصدة الافتتاحية تُرحَّل عبر يومية عامة فقط. المقابل عادة حقوق ملكية 300000 من الدليل الابتدائي.',
    'editor.opening.import': 'استيراد الافتتاح',
    'editor.opening.posted': 'افتتاح مرحّل #{number}',
    'editor.bank.statement': 'كشف الحساب',
    'editor.bank.journalId': 'معرف يومية البنك',
    'editor.bank.import': 'استيراد',
    'editor.bank.match': 'المطابقة',
    'editor.bank.lineId': 'معرف سطر الكشف',
    'editor.bank.itemId': 'معرف البند المفتوح',
    'editor.bank.amount': 'المبلغ (لا يتجاوز السطر)',
    'editor.bank.matchItem': 'مطابقة بند',
    'editor.bank.charge': 'مطابقة كعمولة بنك',
    'editor.bank.difference': 'كشف {id} الفرق {amount}',
    'editor.bank.chooseFirst': "استورد كشفاً أو افتح كشفاً مستورداً لمطابقة أسطره.",
    'editor.bank.csvHint': "booked_on,amount,narration — مع سطر العناوين أولاً. الخارج بالسالب.",
    'editor.bank.item': "البند المفتوح",
    'editor.bank.journal': "دفتر البنك",
    'editor.bank.line': "سطر الكشف",
    'editor.bank.open': "كشف مستورد سابقاً",
    'editor.export.produce': 'إنتاج',
    'editor.export.periodFrom': 'من الفترة',
    'editor.export.periodTo': 'إلى الفترة',
    'editor.export.scope': 'النطاق',
    'editor.export.format': 'الصيغة',
    'editor.export.produceAction': 'إنتاج التصدير',
    'editor.export.confirm': 'تأكيد (شخص ثانٍ)',
    'editor.export.batchId': 'معرف الدفعة',
    'editor.export.externalRef': 'المرجع الخارجي',
    'editor.export.confirmAction': 'تأكيد',
    'editor.export.result': 'دفعة {id} سطور {lines}',
    'editor.backToList': "العودة إلى القائمة",
    'screen.accounting.accounts.action.create': "حساب جديد",
    'screen.accounting.accounts.action.create.field.account_type': "النوع",
    'screen.accounting.accounts.action.create.field.code': "الرمز",
    'screen.accounting.accounts.action.create.field.name_ar': "الاسم بالعربية",
    'screen.accounting.accounts.action.create.field.name_en': "الاسم بالإنجليزية",
    'screen.accounting.accounts.action.create.field.code.help': "ستة أرقام. الرقم الأول يتبع الدليل: 1 أصول، 2 خصوم، 3 حقوق ملكية، 4 إيرادات، 5 مصروفات.",
    'screen.accounting.accounts.action.create.field.presentation': "القائمة المالية",
    'screen.accounting.accounts.action.create.field.reconcilable': "قابل للمطابقة",
    'screen.accounting.accounts.action.create.field.reconcilable.help': "حسابات الذمم تُطابَق مع الدفعات. لا تظهر في الذمم المدينة إلا الحسابات القابلة للمطابقة.",
    'screen.accounting.accounts.action.import_coa': "استيراد الدليل الابتدائي",
    'screen.accounting.accounts.action.retire': "إيقاف",
    'screen.accounting.accounts.column.account_type': "النوع",
    'screen.accounting.accounts.column.code': "الرمز",
    'screen.accounting.accounts.column.name_ar': "الاسم",
    'screen.accounting.accounts.column.presentation': "العرض",
    'screen.accounting.accounts.title': "الحسابات",
    'screen.accounting.balance_sheet.column.account_type': "النوع",
    'screen.accounting.balance_sheet.column.balance': "الرصيد",
    'screen.accounting.balance_sheet.column.code': "الرمز",
    'screen.accounting.balance_sheet.column.name_ar': "الحساب",
    'screen.accounting.balance_sheet.title': 'قائمة المركز المالي',
    'screen.accounting.deposits.action.post_deposit': 'ترحيل دفعة مقدّمة',
    'screen.accounting.deposits.action.post_deposit.field.amount': "المبلغ",
    'screen.accounting.deposits.action.post_deposit.field.cash_account_id': "حساب النقد أو البنك",
    'screen.accounting.deposits.action.post_deposit.field.date': "التاريخ",
    'screen.accounting.deposits.action.post_deposit.field.deposit_account_id': 'حساب الدفعات المقدّمة من العملاء',
    'screen.accounting.deposits.action.post_deposit.field.journal_id': "الدفتر",
    'screen.accounting.deposits.action.post_deposit.field.narration_ar': "البيان",
    'screen.accounting.deposits.action.post_deposit.field.party_id': "العميل",
    'screen.accounting.deposits.action.post_deposit.field.cash_account_id.help': "حساب من نوع نقدية أو بنك.",
    'screen.accounting.deposits.action.post_deposit.field.deposit_account_id.help': "حساب من نوع دفعة عميل مقدمة.",
    'screen.accounting.deposits.column.account_type': "النوع",
    'screen.accounting.deposits.column.code': "الرمز",
    'screen.accounting.deposits.column.name_ar': "الاسم",
    'screen.accounting.deposits.lede': 'ترحيل دفعة مقدّمة من العميل: مدين النقد أو البنك، دائن حساب الدفعات المقدّمة من العملاء.',
    'screen.accounting.deposits.title': 'الدفعات المقدّمة من العملاء',
    'screen.accounting.deposits.column.entry_date': "التاريخ",
    'screen.accounting.deposits.lede.list': 'ما قبضته من العملاء قبل الفاتورة: مدين النقد أو البنك، دائن حساب الدفعات المقدّمة من العملاء.',
    'screen.accounting.deposits.empty': "لم تُرحَّل دفعات مقدّمة من العملاء بعد.",
    'screen.accounting.opening.lede.short': "الأرصدة الافتتاحية في قيد واحد متوازن: استورد ملفاً يُفحص كل سطر فيه قبل الترحيل، أو الصق الأرصدة.",
    'screen.accounting.opening.empty': "لم تُستورد أرصدة افتتاحية بعد.",
    'screen.einvoicing.period.column.missing_count': "لم تُرسل",
    'screen.accounting.dimension_values.action.create': "قيمة جديدة",
    'screen.accounting.dimension_values.action.create.field.code': "الرمز",
    'screen.accounting.dimension_values.action.create.field.dimension_id': "البُعد",
    'screen.accounting.dimension_values.action.create.field.name_ar': "الاسم (عربي)",
    'screen.accounting.dimension_values.action.create.field.name_en': "الاسم (إنجليزي)",
    'screen.accounting.dimension_values.action.retire': "إيقاف",
    'screen.accounting.dimension_values.column.code': "الرمز",
    'screen.accounting.dimension_values.column.dimension_id': "البُعد",
    'screen.accounting.dimension_values.column.name_ar': "الاسم (عربي)",
    'screen.accounting.dimension_values.column.name_en': "الاسم (إنجليزي)",
    'screen.accounting.dimension_values.title': "قيم الأبعاد",
    'screen.accounting.dimensions.action.create': "بُعد جديد",
    'screen.accounting.dimensions.action.create.field.code': "الرمز",
    'screen.accounting.dimensions.action.create.field.name_ar': "الاسم (عربي)",
    'screen.accounting.dimensions.action.create.field.name_en': "الاسم (إنجليزي)",
    'screen.accounting.dimensions.action.import_pack': "استيراد الأبعاد الابتدائية",
    'screen.accounting.dimensions.action.retire': "إيقاف",
    'screen.accounting.dimensions.column.code': "الرمز",
    'screen.accounting.dimensions.column.name_ar': "الاسم (عربي)",
    'screen.accounting.dimensions.column.name_en': "الاسم (إنجليزي)",
    'screen.accounting.dimensions.title': "الأبعاد",
    'screen.accounting.entries.action.create': "قيد يومية جديد",
    'screen.accounting.entries.action.reverse': "عكس",
    'screen.accounting.entries.action.reverse.field.reason': "السبب (مطلوب إن كنت من رحّل هذا القيد)",
    'screen.accounting.entries.column.branch': "الفرع",
    'screen.accounting.entries.column.entry_date': "التاريخ",
    'screen.accounting.entries.column.narration_ar': "البيان",
    'screen.accounting.entries.column.number': "الرقم",
    'screen.accounting.entries.column.posted_by': "رحّله",
    'screen.accounting.entries.column.state': "الحالة",
    'screen.accounting.entries.filter.branch': "الفرع",
    'screen.accounting.entries.lede': "القيود المرحّلة. صفِّ حسب الفرع بعد استيراد بُعد الفرع.",
    'screen.accounting.entries.title': "قيود اليومية",
    'screen.accounting.entry_new.lede': "اكتب الأسطر ثم رحِّل. القيد المرحّل لا يُعدَّل — اعكسه بدلاً من ذلك.",
    'screen.accounting.entry_new.title': "قيد يومية جديد",
    'screen.accounting.fiscal_years.action.create': "سنة مالية جديدة",
    'screen.accounting.fiscal_years.action.create.field.calendar': "التقويم",
    'screen.accounting.fiscal_years.action.create.field.ends_on': "تنتهي في",
    'screen.accounting.fiscal_years.action.create.field.name_ar': "الاسم بالعربية",
    'screen.accounting.fiscal_years.action.create.field.starts_on': "تبدأ في",
    'screen.accounting.fiscal_years.action.create.field.name_en': "الاسم بالإنجليزية",
    'screen.accounting.fiscal_years.column.calendar': "التقويم",
    'screen.accounting.fiscal_years.column.ends_on': "إلى",
    'screen.accounting.fiscal_years.column.name_ar': "الاسم",
    'screen.accounting.fiscal_years.column.starts_on': "من",
    'screen.accounting.fiscal_years.column.status': "الحالة",
    'screen.accounting.fiscal_years.lede': "أنشئ السنة المالية أولاً، ثم أضف الفترات تحتها.",
    'screen.accounting.fiscal_years.title': "السنوات المالية",
    'screen.accounting.income_statement.column.account_type': "النوع",
    'screen.accounting.income_statement.column.amount': "المبلغ",
    'screen.accounting.income_statement.column.code': "الرمز",
    'screen.accounting.income_statement.column.name_ar': "الحساب",
    'screen.accounting.income_statement.title': "قائمة الدخل",
    'screen.accounting.journals.action.create': "يومية جديدة",
    'screen.accounting.journals.action.create.field.code': "الرمز",
    'screen.accounting.journals.action.create.field.journal_type': "النوع",
    'screen.accounting.journals.action.create.field.name_ar': "الاسم بالعربية",
    'screen.accounting.journals.action.create.field.code.help': "رمز قصير مثل SALES أو BANK1، ولا يمكن تغييره لاحقاً.",
    'screen.accounting.journals.action.create.field.default_account_id': "الحساب الافتراضي",
    'screen.accounting.journals.action.create.field.default_account_id.help': 'الحساب الذي يقيّد عليه الدفتر تلقائياً. دفاتر البنك والنقد تحتاجه قبل استقبال دفعة أو استيراد كشف.',
    'screen.accounting.journals.action.create.field.name_en': "الاسم بالإنجليزية",
    'screen.accounting.journals.action.retire': "إيقاف",
    'screen.accounting.journals.action.edit': "تعديل",
    'screen.accounting.journals.action.edit.field.default_account_id': "الحساب الافتراضي",
    'screen.accounting.journals.action.edit.field.default_account_id.help': "دفاتر البنك والنقد تحتاجه قبل استقبال دفعة أو استيراد كشف.",
    'screen.accounting.journals.action.edit.field.name_ar': "الاسم بالعربية",
    'screen.accounting.journals.action.edit.field.name_en': "الاسم بالإنجليزية",
    'screen.accounting.journals.column.code': "الرمز",
    'screen.accounting.journals.column.journal_type': "النوع",
    'screen.accounting.journals.column.name_ar': "الاسم",
    'screen.accounting.journals.column.next_number': "الرقم التالي",
    'screen.accounting.journals.title': "دفاتر اليومية",
    'screen.accounting.lock_dates.action.set_locks': "تعيين تواريخ الإقفال",
    'screen.accounting.lock_dates.action.set_locks.field.fiscal_lock_on': "إقفال الدفاتر حتى",
    'screen.accounting.lock_dates.action.set_locks.field.tax_lock_on': "إقفال الضريبة حتى",
    'screen.accounting.lock_dates.action.set_locks.field.fiscal_lock_on.help': "لا يُرحَّل ولا يُعدَّل أي قيد مؤرخ في هذا اليوم أو قبله.",
    'screen.accounting.lock_dates.action.set_locks.field.tax_lock_on.help': "عادةً نهاية آخر إقرار ضريبي مقدَّم. يُحفظ التاريخان معاً.",
    'screen.accounting.lock_dates.column.fiscal_lock_on': "الإقفال المالي",
    'screen.accounting.lock_dates.column.set_by': "عيّنه",
    'screen.accounting.lock_dates.column.tax_lock_on': "الإقفال الضريبي",
    'screen.accounting.lock_dates.column.updated_at': "حُدّث",
    'screen.accounting.lock_dates.lede': "تواريخ الإقفال المالي والضريبي. الترحيل في يوم الإقفال أو قبله يُرفض (ACC-3).",
    'screen.accounting.lock_dates.title': "تواريخ الإقفال",
    'screen.accounting.opening.action.import_csv': "استيراد CSV الافتتاح",
    'screen.accounting.opening.action.import_csv.field.csv': "الأرصدة (CSV)",
    'screen.accounting.opening.action.import_csv.field.date': "التاريخ",
    'screen.accounting.opening.action.import_csv.field.journal_id': "الدفتر",
    'screen.accounting.opening.action.import_csv.field.csv.help': "سطر لكل حساب: account_code,debit,credit — مع سطر العناوين هذا أولاً.",
    'screen.accounting.opening.action.import_csv.field.journal_id.help': "دفتر من النوع العام.",
    'screen.accounting.opening.column.entry_date': "التاريخ",
    'screen.accounting.opening.column.narration_ar': "البيان",
    'screen.accounting.opening.column.number': "الرقم",
    'screen.accounting.opening.column.state': "الحالة",
    'screen.accounting.opening.lede': "استيراد الأرصدة الافتتاحية كقيد يومية عامة متوازن. المقابل عادة حقوق ملكية 300000 من الدليل الابتدائي.",
    'screen.accounting.opening.title': "الأرصدة الافتتاحية",
    'screen.accounting.periods.action.close': "إغلاق",
    'screen.accounting.periods.action.review_close': "فحص وإغلاق",
    'screen.accounting.periods.action.create': "فترة جديدة",
    'screen.accounting.periods.action.create.field.ends_on': "ينتهي في",
    'screen.accounting.periods.action.create.field.fiscal_year_id': "السنة المالية",
    'screen.accounting.periods.action.create.field.name_ar': "الاسم (عربي)",
    'screen.accounting.periods.action.create.field.starts_on': "يبدأ في",
    'screen.accounting.periods.action.reopen': "إعادة فتح",
    'screen.accounting.periods.action.reopen.field.reason': "السبب",
    'screen.accounting.periods.column.ends_on': "إلى",
    'screen.accounting.periods.column.name_ar': "الفترة",
    'screen.accounting.periods.column.starts_on': "من",
    'screen.accounting.periods.column.status': "الحالة",
    'screen.accounting.periods.title': "الفترات",
    'screen.accounting.posting_rules.action.create': "قاعدة ترحيل جديدة",
    'screen.accounting.posting_rules.action.create.field.credit_account_id': "الحساب الدائن",
    'screen.accounting.posting_rules.action.create.field.debit_account_id': "الحساب المدين",
    'screen.accounting.posting_rules.action.create.field.line_kind': "نوع السطر",
    'screen.accounting.posting_rules.action.create.field.priority': "الأولوية",
    'screen.accounting.posting_rules.action.create.field.source_module': "المديول المصدر",
    'screen.accounting.posting_rules.action.create.field.priority.help': "الأصغر يُطبَّق أولاً. الفارغ يعني 100.",
    'screen.accounting.posting_rules.action.create.field.tax_code_id': "رمز الضريبة",
    'screen.accounting.posting_rules.action.create.field.valid_from': "سارٍ من",
    'screen.accounting.posting_rules.action.retire': "إيقاف",
    'screen.accounting.posting_rules.column.credit_account_id': "حساب الدائن",
    'screen.accounting.posting_rules.column.debit_account_id': "حساب المدين",
    'screen.accounting.posting_rules.column.line_kind': "نوع السطر",
    'screen.accounting.posting_rules.column.priority': "الأولوية",
    'screen.accounting.posting_rules.column.source_module': "المديول المصدر",
    'screen.accounting.posting_rules.column.valid_from': "ساري من",
    'screen.accounting.posting_rules.title': "قواعد الترحيل",
    'screen.accounting.receivables.action.write_off': 'شطب دين معدوم',
    'screen.accounting.receivables.action.open_entry': 'فتح القيد',
    'screen.accounting.receivables.column.entry_id': 'القيد',
    'screen.accounting.receivables.action.write_off.field.date': "التاريخ",
    'screen.accounting.receivables.action.write_off.field.expense_account_id': "حساب المصروف",
    'screen.accounting.receivables.action.write_off.field.journal_id': "الدفتر",
    'screen.accounting.receivables.action.write_off.field.reason': "السبب",
    'screen.accounting.receivables.action.write_off.field.expense_account_id.help': "حساب مصروف، عادةً الديون المعدومة.",
    'screen.accounting.receivables.column.account_code': "الحساب",
    'screen.accounting.receivables.column.account_name_ar': "الاسم",
    'screen.accounting.receivables.column.debit': "مدين مفتوح",
    'screen.accounting.receivables.column.due_on': "الاستحقاق",
    'screen.accounting.receivables.column.entry_date': "التاريخ",
    'screen.accounting.receivables.column.entry_number': "رقم القيد",
    'screen.accounting.receivables.column.party_id': 'العميل',
    'screen.accounting.receivables.lede': 'سطور العملاء المفتوحة. شطب الدين المعدوم يرحّل مصروفاً ويعلّم السطر كمُسوّى.',
    'screen.accounting.receivables.title': "الذمم المدينة",
    'screen.accounting.tax_codes.action.confirm': "تأكيد",
    'screen.accounting.tax_codes.action.confirm.field.tax_account_id': "حساب الضريبة",
    'screen.accounting.tax_codes.action.confirm.field.tax_account_id.help': 'الحساب الذي تُرحَّل إليه ضريبة هذا الرمز. مطلوب للرموز الأساسية ورموز ضريبة الاستقطاع، ويُترك فارغاً للمعفاة والصفرية وخارج النطاق.',
    'screen.accounting.tax_codes.action.import_pack': "استيراد حزمة ضريبة القيمة المضافة",
    'screen.accounting.tax_codes.action.retire': "إيقاف",
    'screen.accounting.tax_codes.column.code': "الرمز",
    'screen.accounting.tax_codes.column.confirmed_by': "أكّده",
    'screen.accounting.tax_codes.column.enabled': "مفعّل",
    'screen.accounting.tax_codes.column.name_ar': "الاسم",
    'screen.accounting.tax_codes.column.rate': "النسبة %",
    'screen.accounting.tax_codes.column.tax_type': "النوع",
    'screen.accounting.tax_codes.column.valid_from': "ساري من",
    'screen.accounting.tax_codes.lede': "حزمة ضريبة القيمة المضافة (توطين السعودية). الرموز تُستورد معطّلة حتى يؤكّدها شخص مسمّى.",
    'screen.accounting.tax_codes.title': 'رموز الضريبة',
    'screen.accounting.tax_rules.action.create': "قاعدة ضريبة جديدة",
    'screen.accounting.tax_rules.action.create.field.buyer_type': "المشتري",
    'screen.accounting.tax_rules.action.create.field.line_kind': "نوع السطر",
    'screen.accounting.tax_rules.action.create.field.priority': "الأولوية",
    'screen.accounting.tax_rules.action.create.field.supply_destination': "وجهة التوريد",
    'screen.accounting.tax_rules.action.create.field.tax_code_id': "رمز الضريبة",
    'screen.accounting.tax_rules.action.create.field.valid_from': "سارٍ من",
    'screen.accounting.tax_rules.action.create.field.priority.help': "الأصغر يُطبَّق أولاً. الفارغ يعني 100.",
    'screen.accounting.tax_rules.action.create.field.valid_to': "سارٍ حتى",
    'screen.accounting.tax_rules.action.retire': "إيقاف",
    'screen.accounting.tax_rules.column.buyer_type': "نوع المشتري",
    'screen.accounting.tax_rules.column.line_kind': "نوع السطر",
    'screen.accounting.tax_rules.column.priority': "الأولوية",
    'screen.accounting.tax_rules.column.supply_destination': "وجهة التوريد",
    'screen.accounting.tax_rules.column.tax_code_id': "رمز الضريبة",
    'screen.accounting.tax_rules.column.valid_from': "ساري من",
    'screen.accounting.tax_rules.title': "قواعد الضريبة",
    'screen.accounting.trial_balance.column.balance': "الرصيد",
    'screen.accounting.trial_balance.column.code': "الرمز",
    'screen.accounting.trial_balance.column.credit': "دائن",
    'screen.accounting.trial_balance.column.debit': "مدين",
    'screen.accounting.trial_balance.column.name_ar': "الحساب",
    'screen.accounting.trial_balance.title': "ميزان المراجعة",
    'screen.einvoicing.connector.action.configure': "تهيئة صندوق الاختبار",
    'screen.einvoicing.connector.action.configure.field.vault_secret_ref': "مرجع السر في الخزنة",
    'screen.einvoicing.connector.action.production': "الانتقال إلى الإنتاج (لا يُعكس)",
    'screen.einvoicing.connector.action.production.field.vault_secret_ref': "مرجع سر الإنتاج في الخزنة",
    'screen.einvoicing.connector.column.circuit_open': 'الربط موقوف مؤقتاً',
    'screen.einvoicing.connector.column.consecutive_failures': "الإخفاقات",
    'screen.einvoicing.connector.column.environment': "البيئة",
    'screen.einvoicing.connector.column.vault_secret_ref': "مرجع الخزنة",
    'screen.einvoicing.connector.lede': "صندوق الاختبار أولاً. غير المتاح لا يُعدّ مقبولاً أبداً. الانتقال إلى الإنتاج يُسجَّل ولا يُعكس. الشهادات تبقى في الخزنة.",
    'screen.einvoicing.connector.title': 'الربط مع منصّة فاتورة',
    'screen.einvoicing.devices.action.create': 'وحدة حل تقني جديدة',
    'screen.einvoicing.devices.action.create.field.branch_code': "الفرع",
    'screen.einvoicing.devices.action.create.field.label': "التسمية",
    'screen.einvoicing.devices.action.create.field.sales_journal_id': "دفتر المبيعات",
    'screen.einvoicing.devices.action.create.field.sales_journal_id.help': "دفتر من نوع مبيعات.",
    'screen.einvoicing.devices.action.onboard': "تهيئة (مراجع الخزنة فقط)",
    'screen.einvoicing.devices.action.onboard.field.compliance_csid_ref': "مرجع CSID الامتثال في الخزنة",
    'screen.einvoicing.devices.action.onboard.field.csr_vault_ref': "مرجع CSR في الخزنة",
    'screen.einvoicing.devices.action.onboard.field.otp_vault_ref': "مرجع OTP في الخزنة",
    'screen.einvoicing.devices.action.onboard.field.production_csid_ref': "مرجع CSID الإنتاج في الخزنة",
    'screen.einvoicing.devices.column.branch_code': "الفرع",
    'screen.einvoicing.devices.column.label': "التسمية",
    'screen.einvoicing.devices.column.next_icv': 'عدّاد الفاتورة التالي (ICV)',
    'screen.einvoicing.devices.column.sales_journal_id': "يومية المبيعات",
    'screen.einvoicing.devices.column.state': "الحالة",
    'screen.einvoicing.devices.title': 'وحدات الحلول التقنية',
    'screen.einvoicing.edocuments.action.submit': "إرسال إلى الهيئة",
    'screen.einvoicing.edocuments.column.created_at': "أُنشئ",
    'screen.einvoicing.edocuments.column.document_id': "المستند",
    'screen.einvoicing.edocuments.column.icv': 'عدّاد الفاتورة (ICV)',
    'screen.einvoicing.edocuments.column.report_status': 'الحالة لدى الهيئة',
    'screen.einvoicing.edocuments.column.uuid': 'المعرّف الفريد (UUID)',
    'screen.einvoicing.edocuments.title': 'الفواتير الإلكترونية',
    'screen.einvoicing.sellers.action.create': 'منشأة بائعة جديدة',
    'screen.einvoicing.sellers.action.create.field.branch_code': "الفرع",
    'screen.einvoicing.sellers.action.create.field.city': "المدينة",
    'screen.einvoicing.sellers.action.create.field.cr_number': "رقم السجل التجاري",
    'screen.einvoicing.sellers.action.create.field.legal_name_ar': "الاسم القانوني (عربي)",
    'screen.einvoicing.sellers.action.create.field.legal_name_en': "الاسم القانوني (إنجليزي)",
    'screen.einvoicing.sellers.action.create.field.vat_number': "الرقم الضريبي",
    'screen.einvoicing.sellers.column.branch_code': "الفرع",
    'screen.einvoicing.sellers.column.city': "المدينة",
    'screen.einvoicing.sellers.column.cr_number': "السجل التجاري",
    'screen.einvoicing.sellers.column.legal_name_ar': "الاسم القانوني",
    'screen.einvoicing.sellers.column.vat_number': "ضريبة القيمة المضافة",
    'screen.einvoicing.sellers.title': 'بيانات المنشأة البائعة',
    'screen.einvoicing.submissions.column.attempt_no': "المحاولة",
    'screen.einvoicing.submissions.column.created_at': "متى",
    'screen.einvoicing.submissions.column.edocument_id': 'الفاتورة الإلكترونية',
    'screen.einvoicing.submissions.column.document_id': 'المستند',
    'screen.einvoicing.submissions.column.document_number': 'رقم الفاتورة',
    'screen.einvoicing.submissions.column.party_name': 'الطرف',
    'screen.einvoicing.edocuments.column.document_number': 'رقم الفاتورة',
    'screen.einvoicing.edocuments.column.party_name': 'الطرف',
    'screen.einvoicing.submissions.column.environment': "البيئة",
    'screen.einvoicing.submissions.column.response_status': "الرد",
    'screen.einvoicing.submissions.column.retry_class': "إعادة المحاولة",
    'screen.einvoicing.submissions.lede': "سجل طلبات محجوب — لا تظهر فيه الأسرار ولا الشهادات. غير المتاح يُعاد؛ المرفوض لا يُعاد.",
    'screen.einvoicing.submissions.title': 'سجل التقديم',
    'screen.invoicing.aging_ap.column.bucket': "الشريحة",
    'screen.invoicing.aging_ap.column.days': "الأيام",
    'screen.invoicing.aging_ap.column.issue_on': "تاريخ الفاتورة",
    'screen.invoicing.aging_ap.column.number': "الرقم",
    'screen.invoicing.aging_ap.column.open_amount': "المفتوح",
    'screen.invoicing.aging_ap.column.party_id': "المورد",
    'screen.invoicing.aging_ap.title': "أعمار الذمم الدائنة",
    'screen.invoicing.aging_ar.column.bucket': "الشريحة",
    'screen.invoicing.aging_ar.column.days': "الأيام",
    'screen.invoicing.aging_ar.column.issue_on': "إصدار",
    'screen.invoicing.aging_ar.column.number': "الرقم",
    'screen.invoicing.aging_ar.column.open_amount': "المفتوح",
    'screen.invoicing.aging_ar.column.party_id': 'العميل',
    'screen.invoicing.aging_ar.title': "أعمار الذمم المدينة",
    'screen.invoicing.aging_ar.lede.by_party': "ما على كل العميل مفتوحاً، موزّعاً بحسب أيام التأخّر عن الاستحقاق. المستند بلا تاريخ استحقاق يستحقّ يوم إصداره.",
    'screen.invoicing.aging_ar.column.party_name': "العميل",
    'screen.invoicing.aging_ar.column.total': "المفتوح",
    'screen.invoicing.aging_ar.column.overdue': "المتأخّر",
    'screen.invoicing.aging_ar.column.not_due': "غير مستحقّ",
    'screen.invoicing.aging_ar.column.days_1_30': "1–30 يوماً",
    'screen.invoicing.aging_ar.column.days_31_60': "31–60 يوماً",
    'screen.invoicing.aging_ar.column.days_61_90': "61–90 يوماً",
    'screen.invoicing.aging_ar.column.days_over_90': "أكثر من 90 يوماً",
    'screen.invoicing.aging_ar.column.documents': "المستندات",
    'screen.invoicing.aging_ar.column.oldest_days': "أقدم تأخّر بالأيام",
    'screen.invoicing.aging_ar.stat.total': "المفتوح",
    'screen.invoicing.aging_ar.stat.overdue': "المتأخّر",
    'screen.invoicing.aging_ar.column.late': "متأخّر",
    'screen.invoicing.aging_ar.column.very_late': "متأخّر أكثر من 90 يوماً",
    'screen.invoicing.aging_ar.stat.over_90': "أكثر من 90 يوماً",
    'screen.invoicing.aging_ap.lede.by_party': "ما على كل المورّد مفتوحاً، موزّعاً بحسب أيام التأخّر عن الاستحقاق. المستند بلا تاريخ استحقاق يستحقّ يوم إصداره.",
    'screen.invoicing.aging_ap.column.party_name': "المورّد",
    'screen.invoicing.aging_ap.column.total': "المفتوح",
    'screen.invoicing.aging_ap.column.overdue': "المتأخّر",
    'screen.invoicing.aging_ap.column.not_due': "غير مستحقّ",
    'screen.invoicing.aging_ap.column.days_1_30': "1–30 يوماً",
    'screen.invoicing.aging_ap.column.days_31_60': "31–60 يوماً",
    'screen.invoicing.aging_ap.column.days_61_90': "61–90 يوماً",
    'screen.invoicing.aging_ap.column.days_over_90': "أكثر من 90 يوماً",
    'screen.invoicing.aging_ap.column.documents': "المستندات",
    'screen.invoicing.aging_ap.column.oldest_days': "أقدم تأخّر بالأيام",
    'screen.invoicing.aging_ap.stat.total': "المفتوح",
    'screen.invoicing.aging_ap.stat.overdue': "المتأخّر",
    'screen.invoicing.aging_ap.column.late': "متأخّر",
    'screen.invoicing.aging_ap.column.very_late': "متأخّر أكثر من 90 يوماً",
    'screen.invoicing.aging_ap.stat.over_90': "أكثر من 90 يوماً",
    'screen.invoicing.bank_reconciliation.action.import': "استيراد CSV",
    'screen.invoicing.bank_reconciliation.action.import.field.csv': "بنود الكشف (CSV)",
    'screen.invoicing.bank_reconciliation.action.import.field.journal_id': "دفتر البنك",
    'screen.invoicing.bank_reconciliation.action.import.field.statement_on': "تاريخ الكشف",
    'screen.invoicing.bank_reconciliation.action.import.field.csv.help': "سطر لكل حركة: booked_on,amount,narration — مع سطر العناوين أولاً. الخارج بالسالب.",
    'screen.invoicing.bank_reconciliation.action.import.field.journal_id.help': "دفتر بنك له حساب افتراضي.",
    'screen.invoicing.bank_reconciliation.action.reconcile': "مطابقة أو عمولة",
    'screen.invoicing.bank_reconciliation.column.id': "المعرف",
    'screen.invoicing.bank_reconciliation.column.journal_id': "اليومية",
    'screen.invoicing.bank_reconciliation.column.line_count': "السطور",
    'screen.invoicing.bank_reconciliation.column.statement_on': "تاريخ الكشف",
    'screen.invoicing.bank_reconciliation.column.unmatched_count': "غير مطابق",
    'screen.invoicing.bank_reconciliation.lede': "استيراد CSV متكرّر بأمان على البصمة. طابق سطور الكشف ببنود البنك المفتوحة، أو رحّل عمولة بنك. ألغِ المطابقة ما دامت الفترة مفتوحة.",
    'screen.invoicing.bank_reconciliation.title': "تسوية البنك",
    'screen.invoicing.bank_match.lede': "طابق سطر الكشف مع بند مفتوح، أو رحِّله كعمولة بنك.",
    'screen.invoicing.bank_match.title': "مطابقة أو عمولة",
    'screen.invoicing.chart_mappings.action.upsert': "حفظ الربط",
    'screen.invoicing.chart_mappings.action.upsert.field.external_account': "الحساب في النظام الآخر",
    'screen.invoicing.chart_mappings.action.upsert.field.source_code': "الحساب",
    'screen.invoicing.chart_mappings.action.upsert.field.source_kind': "نوع الربط",
    'screen.invoicing.chart_mappings.column.external_account': "الحساب الخارجي",
    'screen.invoicing.chart_mappings.column.source_code': "الرمز المحلي",
    'screen.invoicing.chart_mappings.column.source_kind': "النوع",
    'screen.invoicing.chart_mappings.lede': "اربط رموز الحساب والضريبة واليومية المحلية بحسابات النظام الخارجي. التصدير يرفض ويسمّي أي رمز بلا ربط.",
    'screen.invoicing.chart_mappings.title': "ربط الدليل الخارجي",
    'screen.invoicing.customer_statements.column.ap_open': "دائن مفتوح",
    'screen.invoicing.customer_statements.column.ar_open': "مدين مفتوح",
    'screen.invoicing.customer_statements.column.party_id': "الطرف",
    'screen.invoicing.customer_statements.column.party_name': "الطرف",
    'screen.invoicing.customer_statements.lede': "المبالغ المدينة والدائنة المفتوحة حسب الطرف.",
    'screen.invoicing.customer_statements.title': "أرصدة الأطراف",
    'screen.invoicing.documents.action.create': "فاتورة جديدة",
    'screen.invoicing.documents.action.credit': "إشعار دائن",
    'screen.invoicing.documents.action.credit.field.reason_code': "السبب",
    'screen.invoicing.documents.action.credit.field.reason_code.help': "سبب الإشعار الدائن كما سيظهر عليه.",
    'screen.invoicing.documents.action.issue': "إصدار",
    'screen.invoicing.documents.action.edit': "تعديل المسودة",
    'screen.invoicing.documents.column.branch_code': "الفرع",
    'screen.invoicing.documents.column.can_credit': "يمكن إشعارها",
    'screen.invoicing.documents.column.classification': "التصنيف",
    'screen.invoicing.documents.column.issue_on': "تاريخ الإصدار",
    'screen.invoicing.documents.column.kind': "النوع",
    'screen.invoicing.documents.column.number': "الرقم",
    'screen.invoicing.documents.column.party_id': 'العميل',
    'screen.invoicing.documents.column.state': "الحالة",
    'screen.invoicing.documents.column.total': "الإجمالي",
    'screen.invoicing.documents.filter.branch_code': "الفرع",
    'screen.invoicing.documents.title': "الفواتير",
    'screen.invoicing.invoice_new.lede': 'العميل والعنوان الوطني والأسطر والتصنيف. «حفظ مسودة» يبقيها لتُكمَل لاحقاً؛ و«حفظ وإصدار» يصدرها، والفاتورة الصادرة لا تُصحَّح إلا بإشعار دائن أو مدين.',
    'screen.invoicing.invoice_new.title': "فاتورة جديدة",
    'screen.invoicing.export_batches.action.confirm': "تأكيد بالمراجع الخارجية",
    'screen.invoicing.export_batches.action.confirm.field.external_batch_ref': "مرجع الدفعة الخارجي",
    'screen.invoicing.export_batches.action.create': "إنتاج التصدير",
    'screen.invoicing.export_batches.action.create.field.format': "الصيغة",
    'screen.invoicing.export_batches.action.create.field.period_from': "من",
    'screen.invoicing.export_batches.action.create.field.period_to': "إلى",
    'screen.invoicing.export_batches.action.create.field.scope': "ما يُصدَّر",
    'screen.invoicing.export_batches.column.format': "الصيغة",
    'screen.invoicing.export_batches.column.id': "المعرف",
    'screen.invoicing.export_batches.column.line_count': "السطور",
    'screen.invoicing.export_batches.column.period_from': "من",
    'screen.invoicing.export_batches.column.period_to': "إلى",
    'screen.invoicing.export_batches.column.scope': "النطاق",
    'screen.invoicing.export_batches.column.state': "الحالة",
    'screen.invoicing.export_batches.lede': "دفعات CSV/JSON لكل فترة. النطاق نفسه لا يُصدَّر مرتين. شخص ثانٍ يؤكّد بالمراجع الخارجية.",
    'screen.invoicing.export_batches.title': "تصدير محاسبي خارجي",
    'screen.invoicing.payments.action.allocate': "تخصيص",
    'screen.invoicing.payments.action.allocate.field.amount': "المبلغ",
    'screen.invoicing.payments.action.allocate.field.document_id': "المستند",
    'screen.invoicing.payments.action.allocate.field.document_id.help': "مستند مرحّل للطرف نفسه.",
    'screen.invoicing.payments.action.allocate.field.amount.help': "يبدأ بما لم يُخصَّص من الدفعة بعد.",
    'screen.invoicing.payments.action.create': "تسجيل دفعة",
    'screen.invoicing.payments.action.create.field.amount': "المبلغ",
    'screen.invoicing.payments.action.create.field.direction': "الاتجاه",
    'screen.invoicing.payments.action.create.field.journal_id': "الدفتر",
    'screen.invoicing.payments.action.create.field.method': "الطريقة",
    'screen.invoicing.payments.action.create.field.paid_on': "التاريخ",
    'screen.invoicing.payments.action.create.field.party_id': "الطرف",
    'screen.invoicing.payments.action.create.field.provider_ref': "مرجع البنك",
    'screen.invoicing.payments.action.create.field.journal_id.help': "دفتر بنك أو نقد له حساب افتراضي.",
    'screen.invoicing.payments.action.create.field.paid_on.help': "الفارغ يعني اليوم.",
    'screen.invoicing.payments.action.create.field.provider_ref.help': "مرجع الحوالة. المرجع نفسه لا يُسجَّل مرتين.",
    'screen.invoicing.payments.column.allocated_total': "المخصّص",
    'screen.invoicing.payments.column.amount': "المبلغ",
    'screen.invoicing.payments.column.direction': "الاتجاه",
    'screen.invoicing.payments.column.id': "المعرف",
    'screen.invoicing.payments.column.method': "الطريقة",
    'screen.invoicing.payments.column.open_amount': "المفتوح",
    'screen.invoicing.payments.column.paid_on': "تاريخ الدفع",
    'screen.invoicing.payments.column.party_id': "الطرف",
    'screen.invoicing.payments.column.provider_ref': 'مرجع البنك',
    'screen.invoicing.payments.column.state': "الحالة",
    'screen.invoicing.payments.lede': 'سندات القبض والصرف. مرجع البنك المكرر يعيد السند المحفوظ ولا يرحّله مرتين.',
    'screen.invoicing.payments.title': 'سندات القبض والصرف',
    'screen.invoicing.tax_register.column.classification': "التصنيف",
    'screen.invoicing.tax_register.column.issue_on': "التاريخ",
    'screen.invoicing.tax_register.column.kind': "النوع",
    'screen.invoicing.tax_register.column.number': "الرقم",
    'screen.invoicing.tax_register.column.party_id': "الطرف",
    'screen.invoicing.tax_register.column.party_name': "الطرف",
    'screen.invoicing.tax_register.column.subtotal': "الصافي",
    'screen.invoicing.tax_register.column.tax_total': "الضريبة",
    'screen.invoicing.tax_register.column.total': "الإجمالي",
    'screen.invoicing.tax_register.column.withholding_total': 'ضريبة الاستقطاع',
    'screen.invoicing.tax_register.title': "سجل الفواتير الضريبية",
    'screen.invoicing.vat_return.action.file': "تعليم كمقدَّم (يعيّن الإقفال الضريبي)",
    'screen.invoicing.vat_return.action.file.field.to': "نهاية الفترة",
    'screen.invoicing.vat_return.action.file.field.to.help': "الفارغ يعني اليوم.",
    'screen.invoicing.vat_return.column.amount': "المبلغ",
    'screen.invoicing.vat_return.column.key': 'الخانة',
    'screen.invoicing.vat_return.column.label_ar': "الوصف",
    'screen.invoicing.vat_return.column.net': "الصافي",
    'screen.invoicing.vat_return.column.tax': "الضريبة",
    'screen.invoicing.vat_return.lede': 'خانات الإقرار للفترة بأرقام نموذج الهيئة. «تعليم كمقدَّم» يعيّن تاريخ الإقفال الضريبي، ويُقدَّم الإقرار على بوابة الهيئة.',
    'screen.invoicing.vat_return.title': "إقرار ضريبة القيمة المضافة",
    'screen.invoicing.vendor_bills.action.create': "فاتورة مشتريات جديدة",
    'screen.invoicing.vendor_bills.action.issue': "إصدار",
    'screen.invoicing.vendor_bills.action.edit': "تعديل المسودة",
    'screen.invoicing.vendor_bills.column.branch_code': "الفرع",
    'screen.invoicing.vendor_bills.column.can_pay': "يمكن دفعها",
    'screen.invoicing.vendor_bills.column.issue_on': "تاريخ الفاتورة",
    'screen.invoicing.vendor_bills.column.number': "الرقم",
    'screen.invoicing.vendor_bills.column.open_amount': "المفتوح",
    'screen.invoicing.vendor_bills.column.party_id': "المورد",
    'screen.invoicing.vendor_bills.column.state': "الحالة",
    'screen.invoicing.vendor_bills.column.total': "الإجمالي",
    'screen.invoicing.vendor_bills.column.withholding_total': 'ضريبة الاستقطاع',
    'screen.invoicing.vendor_bills.filter.branch_code': "الفرع",
    'screen.invoicing.vendor_bills.lede': 'فواتير المشتريات. ضريبة الاستقطاع على الموردين غير المقيمين وحدهم، تُرحَّل إلى التزام ولا تدخل في الفاتورة الإلكترونية.',
    'screen.invoicing.vendor_bills.title': "فواتير المشتريات",
    'screen.invoicing.vendor_bill_new.lede': 'المورّد والأسطر وضريبة الاستقطاع لغير المقيمين. الحفظ يُبقي المسودة.',
    'screen.invoicing.vendor_bill_new.title': "فاتورة مشتريات جديدة",
    'screen.invoicing.wht_statement.column.bill_count': "الفواتير",
    'screen.invoicing.wht_statement.column.bill_total': "إجمالي الفواتير",
    'screen.invoicing.wht_statement.column.display_name': "الاسم",
    'screen.invoicing.wht_statement.column.party_id': "المورد",
    'screen.invoicing.wht_statement.column.withholding_total': 'ضريبة الاستقطاع',
    'screen.invoicing.wht_statement.lede': 'ضريبة الاستقطاع على كل مورّد في الفترة المختارة. يُقدَّم البيان على بوابة الهيئة.',
    'screen.invoicing.wht_statement.title': 'بيان ضريبة الاستقطاع',
    'screen.parties.parties.action.add_address': "إضافة عنوان",
    'screen.parties.parties.action.add_address.field.additional_number': "الرقم الإضافي",
    'screen.parties.parties.action.add_address.field.additional_number.help': "أربعة أرقام إن وُجد.",
    'screen.parties.parties.action.add_address.field.short_address': "العنوان المختصر",
    'screen.parties.parties.action.add_address.field.short_address.help': "أربعة أحرف ثم أربعة أرقام، مثل RNAD4521.",
    'screen.parties.parties.action.add_address.field.building_number': "رقم المبنى",
    'screen.parties.parties.action.add_address.field.building_number.help': "أربعة أرقام (العنوان الوطني).",
    'screen.parties.parties.action.add_address.field.city': "المدينة",
    'screen.parties.parties.action.add_address.field.country': "الدولة",
    'screen.parties.parties.action.add_address.field.country.help': "ISO 3166-1 alpha-2 بأحرف كبيرة (مثل SA).",
    'screen.parties.parties.action.add_address.field.district': "الحي",
    'screen.parties.parties.action.add_address.field.line1': "سطر العنوان",
    'screen.parties.parties.action.add_address.field.postcode': "الرمز البريدي",
    'screen.parties.parties.action.add_address.field.purpose': "الغرض",
    'screen.parties.parties.action.add_address.field.purpose.option.billing': "فوترة",
    'screen.parties.parties.action.add_address.field.purpose.option.correspondence': "مراسلة",
    'screen.parties.parties.action.add_address.field.purpose.option.registered': "مسجّل",
    'screen.parties.parties.action.add_address.field.purpose.option.shipping': "شحن",
    'screen.parties.parties.action.add_address.field.region': "المنطقة",
    'screen.parties.parties.action.add_address.field.street': "الشارع",
    'screen.parties.parties.action.add_address.field.unit_number': "رقم الوحدة",
    'screen.parties.parties.action.add_address.field.is_primary': "العنوان الرئيسي",
    'screen.parties.parties.action.add_address.field.is_primary.help': "الذي تستخدمه الفاتورة. اختياره يلغي الرئيسي السابق.",
    'screen.parties.parties.action.add_address.field.line2': "سطر العنوان الثاني",
    'screen.parties.parties.action.add_identifier': "إضافة معرّف",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme': "مخطط مشتري هيئة الزكاة",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.700': "700",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.CRN': "CRN",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.GCC': "GCC",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.IQA': "IQA",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.MLS': "MLS",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.MOM': "MOM",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.NAT': "NAT",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.OTH': "OTH",
    'screen.parties.parties.action.add_identifier.field.buyer_scheme.option.SAG': "SAG",
    'screen.parties.parties.action.add_identifier.field.scheme': "المخطط",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_cr': "السجل التجاري",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_vat': "ضريبة القيمة المضافة (السعودية)",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_iqama': "الإقامة",
    'screen.parties.parties.action.add_identifier.field.scheme.option.sa_nid': "الهوية الوطنية",
    'screen.parties.parties.action.add_identifier.field.value': "القيمة",
    'screen.parties.parties.action.add_identifier.field.value.help': "الرقم الضريبي: 15 رقماً يبدأ وينتهي بـ3. السجل التجاري: 10 أرقام. الهوية الوطنية: 10 أرقام تبدأ بـ1، والإقامة تبدأ بـ2.",
    'screen.parties.parties.action.create': "جديد",
    'screen.parties.parties.action.create.field.display_name': "الاسم",
    'screen.parties.parties.action.create.field.kind': "النوع",
    'screen.parties.parties.action.create.field.kind.option.organisation': "مؤسسة",
    'screen.parties.parties.action.create.field.kind.option.person': "شخص",
    'screen.parties.parties.action.create.field.residency': "الإقامة",
    'screen.parties.parties.action.create.field.residency.option.non_resident': "غير مقيم",
    'screen.parties.parties.action.create.field.residency.option.resident': "مقيم",
    'screen.parties.parties.action.edit': "تعديل",
    'screen.parties.parties.action.edit.field.display_name': "الاسم",
    'screen.parties.parties.action.edit.field.residency': "الإقامة",
    'screen.parties.parties.action.edit.field.residency.option.non_resident': "غير مقيم",
    'screen.parties.parties.action.edit.field.residency.option.resident': "مقيم",
    'screen.parties.parties.column.display_name': "الاسم",
    'screen.parties.parties.column.kind': "النوع",
    'screen.parties.parties.column.residency': "الإقامة",
    'screen.parties.parties.column.status': "الحالة",
    'screen.parties.parties.title': "الأطراف",
    'account.title': 'حسابي',
    'account.lede': 'كيف تُسمّى هنا، وكيف تدخل.',
    'account.about': 'عنك',
    'account.name': 'الاسم',
    'account.jobTitle': 'المسمّى الوظيفي',
    'account.phone': 'الهاتف',
    'account.language': 'اللغة',
    'account.password': 'كلمة المرور',
    'account.passwordWarning': 'تغييرها ينهي كل الجلسات، وهذه منها. ستدخل من جديد.',
    'account.currentPassword': 'كلمة المرور الحالية',
    'account.newPassword': 'كلمة المرور الجديدة',
    'account.repeatPassword': 'أعدها',
    'account.passwordsDiffer': 'الاثنتان غير متطابقتين.',
    'account.changePassword': 'غيّر كلمة مروري',
    'account.open': 'حسابي',
    'account.signedOutAfterPassword': 'غُيّرت كلمة مرورك. ادخل من جديد.',
    'account.workspaces': 'مساحات العمل',
    'theme.label': 'المظهر',
    'theme.light': 'فاتح',
    'theme.dark': 'داكن',
    'theme.system': 'النظام',
    'account.unknown': 'داخل',
    'account.choosePassword': "اختر كلمة مرور جديدة",
    'account.choosePasswordLede': "دخلت بكلمة مرور مؤقتة. لن يعمل شيء حتى تختار كلمتك، ثم تدخل بها من جديد.",
    'account.choosePasswordSave': "حفظ والدخول من جديد",
    'account.passwordChosen': "تم حفظ كلمة مرورك. سجّل الدخول بها.",
    'account.serviceWindow': "انتهت خدمتك في {ended_on}؛ يبقى لك هنا حتى {access_until}.",
    'account.temporaryPassword': "كلمة المرور المؤقتة",
    'account.secondFactor': "الدخول بخطوتين",
    'account.secondFactor.lede': "رمز من تطبيق مصادقة على هاتفك، يُطلب حين تدخل مساحة عمل تشترطه أدوارها.",
    'account.secondFactor.off': "غير مفعّل.",
    'account.secondFactor.on': "مفعّل منذ {date}. بقي {count} من رموز الاسترداد.",
    'account.secondFactor.notConfigured': "غير متاح في هذا التنصيب بعد: لا مفتاح لديه لحفظ أسرار المصادقة. من يشغّله يضبط SECOND_FACTOR_KEK.",
    'account.secondFactor.setUp': "تفعيل",
    'account.secondFactor.replace': "استبدال تطبيق المصادقة",
    'account.secondFactor.newCodes': "رموز استرداد جديدة",
    'account.secondFactor.turnOff': "إيقاف",
    'account.secondFactor.passwordFor': "كلمة مرورك الحالية، للتأكد أنك أنت.",
    'account.secondFactor.secretTitle': "أضف هذا إلى تطبيق المصادقة",
    'account.secondFactor.secretLede': "افتح تطبيق مصادقة (Google Authenticator أو Microsoft Authenticator أو Aegis أو 1Password…) وأضف مدخلاً بكتابة هذا المفتاح، أو بلصق الرابط في تطبيق يقرأ الروابط. يُعرض هذه المرة فقط.",
    'account.secondFactor.secret': "المفتاح",
    'account.secondFactor.uri': "الرابط (otpauth)",
    'account.secondFactor.confirmLede': "ثم أدخل الرمز الذي يعرضه، لإثبات أن المدخل يعمل.",
    'account.secondFactor.confirm': "تأكيد",
    'account.secondFactor.codesTitle': "رموز الاسترداد",
    'account.secondFactor.codesLede': "كلٌّ منها يفتح مساحة عمل مرة واحدة حين لا يكون هاتفك معك. احفظها في مكان آمن: لن تُعرض مرة أخرى، والجديدة تحلّ محلّها.",
    'account.secondFactor.enrolled': "الدخول بخطوتين مفعّل.",
    'account.secondFactor.disabled': "الدخول بخطوتين موقوف.",
    'settings.readOnly': 'للاطّلاع فقط',
    'settings.problems': 'قيم لم تعد تطابق مخطّطها',
    'settings.unaddressable': 'لا يمكن مخاطبة هذا الإعداد بأمان: {key}',
    'settings.search': 'ابحث في المجموعات وإعداداتها',
    'settings.stat.groups': 'المجموعات',
    'settings.stat.overridden': 'محدَّد هنا',
    'settings.problems.count': '{count} مشكلات',
    'settings.changedBy': 'آخر تغيير بيد {by}، {at}',
    'settings.history': 'السجل',
    'settings.restore.title': 'أتستعيد قيمة المنصّة لـ«{name}»؟',
    'settings.restore.description': 'يُلغى ما قرّرته مساحة العمل في {group}، وتسري قيمة المنصّة من الآن. ويحتفظ السجل بما كان.',
    'settings.restore.confirm': 'استعادة',
    'settings.noMatch': 'لا مجموعة ولا إعداد يطابق «{search}». والأرقام أعلاه لا تزال تعدّ كل المجموعات.',
    'screen.accounting.tax_codes.column.exemption_reason_code': "رمز سبب الإعفاء",
    'screen.accounting.tax_codes.column.deductible': "قابلية الخصم",
    'screen.einvoicing.devices.filter.branch_code': "الفرع",
    'screen.einvoicing.edocuments.column.previous_hash': 'تجزئة الفاتورة السابقة (PIH)',
    'screen.einvoicing.edocuments.column.hash': 'تجزئة الفاتورة',
    'screen.einvoicing.edocuments.column.qr_payload': "رمز QR",
    'screen.einvoicing.edocuments.column.can_submit': "قابلة للإرسال",
    'screen.einvoicing.sellers.action.create.field.building_number': "رقم المبنى",
    'screen.einvoicing.sellers.action.create.field.street': "الشارع",
    'screen.einvoicing.sellers.action.create.field.district': "الحيّ",
    'screen.einvoicing.sellers.action.create.field.region': "المنطقة",
    'screen.einvoicing.sellers.action.create.field.postcode': "الرمز البريدي",
    'screen.einvoicing.sellers.action.create.field.country': "الدولة",
    'screen.einvoicing.sellers.filter.branch_code': "الفرع",
    'screen.invoicing.documents.column.currency': "العملة",
    'derived.rows': "عدد الصفوف",
    'screen.einvoicing.sellers.column.building_number': "رقم المبنى",
    'screen.einvoicing.sellers.column.district': "الحيّ",
    'screen.einvoicing.sellers.column.postcode': "الرمز البريدي",
    'screen.einvoicing.sellers.column.address_complete': "العنوان الوطني",
    'screen.einvoicing.sellers.stat.incomplete': "عنوانه الوطني ناقص",
    'screen.einvoicing.edocuments.column.path': "القناة",
    'value.address_complete.true': "مكتمل",
    'value.address_complete.false': "ناقص",
    'group.operations': 'العمليات اليومية',
    'group.reconciliation': 'التسويات والمتابعة',
    'group.closing': 'الإقفال والتقارير',
    'group.configuration': 'الضبط والتهيئة',
    // hr · org — graduated from the screens catalogue
    "group.organisation": "الهيكل التنظيمي",
    "value.status.retired": "غير نشط",
    // hr · scheduling — graduated from the screens catalogue
    "value.rotation.fixed": "ثابت",
    "value.rotation.monthly": "شهري",
    "value.rotation.weekly": "أسبوعي",
    "value.severity.overdue": "حرج",
    "value.severity.warning": "إنذار",
    "value.status.draft": "مسوّدة",
    "value.status.locked": "مقفل",
    "value.status.published": "منشور",
    // hr · leave — graduated from the screens catalogue
    "group.leave": "الإجازات",
    "value.leave_type.annual": "سنوية",
    "value.leave_type.bereavement": "وفاة",
    "value.leave_type.bereavement_sibling": "وفاة أخ أو أخت",
    "value.leave_type.emergency": "اضطرارية",
    "value.leave_type.exams": "اختبارات",
    "value.leave_type.hajj": "حجّ",
    "value.leave_type.iddah": "عدّة",
    "value.leave_type.marriage": "زواج",
    "value.leave_type.maternity": "وضع",
    "value.leave_type.newborn": "مولود",
    "value.leave_type.sick": "مرضية",
    "value.leave_type.unpaid": "بلا أجر",
    "value.leave_type.widowhood": "وفاة الزوج",
    "value.leave_type.maternity_sick_child": "رعاية مولود مريض أو من ذوي الإعاقة",
    "value.leave_type.maternity_extension": "تمديد إجازة الوضع (بلا أجر)",
    "value.leave_type.time_off_in_lieu": "إجازة تعويضية عن العمل الإضافي",
    "value.status.approved": "معتمد",
    "value.status.back_at_work": "عاد من الإجازة",
    "value.status.late_return": "تأخّر عن العودة",
    "value.status.on_leave": "في إجازة",
    "value.status.rejected": "مرفوض",
    "value.status.sent_back": "مُعاد للتعديل",
    "value.status.submitted": "بانتظار الاعتماد",
    "value.status.unconfirmed": "لم يُعتمد بعد",
    "value.tier.full": "بأجر كامل",
    "value.tier.three_quarters": "بثلاثة أرباع الأجر",
    "value.tier.unpaid": "بلا أجر",
    // hr · discipline
    "group.conduct": "الانضباط والتظلّمات",
    "value.art80_ground.absence": "الغياب دون سبب مشروع فوق الحدّ النظامي، بعد الإنذار",
    "value.art80_ground.abuse_of_position": "استغلال المركز الوظيفي بطريقة غير مشروعة للحصول على مكاسب شخصية",
    "value.art80_ground.assault": "الاعتداء على صاحب العمل أو المدير المسؤول أو أحد الرؤساء",
    "value.art80_ground.deliberate_loss": "تعمّد إلحاق خسارة مادية بصاحب العمل (مع إبلاغ الجهات المختصة خلال 24 ساعة)",
    "value.art80_ground.disclosure": "إفشاء الأسرار الصناعية أو التجارية",
    "value.art80_ground.dishonour": "سوء السلوك أو عمل مخلّ بالشرف أو الأمانة",
    "value.art80_ground.essential_duties": "عدم أداء الالتزامات الجوهرية أو عدم إطاعة الأوامر المشروعة أو تعليمات السلامة رغم الإنذار الكتابي",
    "value.art80_ground.forgery": "الحصول على العمل بالتزوير",
    "value.group_name.attendance": "مواعيد العمل",
    "value.group_name.conduct": "السلوك",
    "value.group_name.custody": "العُهد",
    "value.group_name.organisation": "تنظيم العمل",
    "value.group_name.performance": "الأداء",
    "value.group_name.safety": "السلامة",
    "value.outcome.overturned": "يُلغى الجزاء",
    "value.outcome.upheld": "يُثبَّت الجزاء",
    "value.payroll_effect.applied": "مطبَّق",
    "value.payroll_effect.partly_applied": "مطبَّق جزئيًا — أيام مرحَّلة",
    "value.payroll_effect.cancelled": "ملغى",
    "value.payroll_effect.held": "محجوز",
    "value.payroll_effect.none": "بلا أثر مالي",
    "value.payroll_effect.pending": "لم يُطبَّق بعد",
    "value.penalty.deduction": "حسم من الأجر",
    "value.penalty.defer_promotion": "تأجيل الترقية",
    "value.penalty.demotion": "خفض الدرجة",
    "value.penalty.dismissal": "الفصل وفق المادة 80",
    "value.penalty.final_warning": "إنذار كتابي نهائي",
    "value.penalty.suspension": "إيقاف عن العمل بلا أجر",
    "value.penalty.warning": "إنذار كتابي",
    "value.penalty.withhold_increment": "الحرمان من العلاوة الدورية",
    "value.status.cancelled": "ملغى",
    "value.status.held": "معلّق بتظلّم",
    "value.status.investigating": "قيد التحقيق",
    // hr · rewards
    "value.kind.allowance": "بدل",
    "value.kind.one_off": "مكافأة لمرة واحدة",
    "value.kind.periodic": "حافز دوري",
    "value.kind.recognition": "تقدير معنوي",
    "value.status.paid": "مصروف",
    "value.status.proposed": "مقترح",
    // hr · training
    "group.development": "الأداء والتطوير",
    "value.kind.credential": "اعتماد مهني",
    "value.kind.first_aid": "إسعافات أولية",
    "value.kind.induction": "تهيئة وتعريف",
    "value.kind.safety": "السلامة والإخلاء",
    "value.kind.site_orientation": "تعريف بالموقع",
    "value.kind.supervisory": "مهارات إشرافية",
    "value.mandatory_for.everyone": "جميع الموظّفين",
    "value.mandatory_for.new_joiners": "المعيَّنون الجدد",
    "value.mandatory_for.none": "اختياري",
    "value.mandatory_for.site_staff": "العاملون في المواقع",
    "value.mandatory_for.supervisors": "المشرفون",
    "value.result.expired": "انتهت صلاحيته",
    "value.result.failed": "لم يجتز",
    "value.result.passed": "اجتاز",
    "value.result.scheduled": "مجدول",
    "value.result.withdrawn": "منسحب",
    // hr · employees — graduated from the screens catalogue
    "group.employment": "الموظّفون",
    "value.category.external_cover": "تغطية خارجية مؤقّتة",
    "value.category.extra_shift": "دائم بوردية إضافية برقمه",
    "value.category.gosi": "دائم مسجّل في التأمينات",
    "value.category.no_gosi": "دائم غير مسجّل في التأمينات",
    "value.contract_type.fixed_term": "محدّد المدّة",
    "value.contract_type.flexible": "مرن",
    "value.contract_type.indefinite": "غير محدّد المدّة",
    "value.contract_type.seasonal": "موسمي",
    "value.kind.amendment": "ملحق تعديل",
    "value.kind.original": "العقد الأصلي",
    "value.kind.renewal": "تجديد",
    "value.reason_code.art_80": "فصل وفق المادة 80",
    "value.reason_code.art_81": "ترك العمل وفق المادة 81",
    "value.reason_code.contract_end": "انتهاء مدّة العقد",
    "value.reason_code.death": "وفاة",
    "value.reason_code.employer_notice": "إنهاء من صاحب العمل بإشعار",
    "value.reason_code.force_majeure": "قوّة قاهرة",
    "value.reason_code.mutual_agreement": "اتفاق الطرفين",
    "value.reason_code.probation": "إنهاء خلال فترة التجربة",
    "value.reason_code.resignation": "استقالة",
    "value.reason_code.retirement": "بلوغ سنّ التقاعد",
    "value.status.absent": "منقطع",
    "value.status.applied": "سارٍ",
    "value.status.attested": "موثَّق",
    "value.status.blacklisted": "مستبعد من التوظيف",
    "value.status.candidate": "مرشّح",
    "value.status.ended": "منتهٍ",
    "value.status.ending": "ينتهي قريباً",
    "value.status.hiring": "بانتظار المباشرة",
    "value.status.signed": "موقَّع",
    "value.status.superseded": "حلّت محلّه نسخة أحدث",
    "value.status.terminated": "منتهي الخدمة",
    "value.type.allowance_change": "تعديل البدلات",
    "value.type.category_change": "تغيير الفئة",
    "value.type.contract_amendment": "ملحق تعديل العقد",
    "value.type.contract_renewal": "تجديد العقد",
    "value.type.pay_change": "تعديل الأجر",
    "value.type.promotion": "ترقية",
    "value.type.reinstatement": "إعادة إلى العمل",
    "value.type.suspension": "إيقاف عن العمل",
    "value.type.termination": "إنهاء الخدمة",
    "value.type.title_change": "تغيير المسمّى",
    "value.type.transfer": "نقل",
    // hr · leave accounts — opened from the employees module's events
    'screen.activity_log.entries.column.name': "الحدث",
    'screen.activity_log.entries.column.occurred_at': "متى",
    'screen.activity_log.entries.column.producer': "المصدر",
    'screen.activity_log.entries.title': "سجل النشاط",
    'screen.activity_log.entries.lede': "كل ما نشرته الوحدات من وقائع عن مساحة العمل هذه، الأحدث أولاً. وما تغيّر حقلاً حقلاً في سجل التغييرات.",
    'screen.activity_log.entries.column.version': "الإصدار",
    'screen.activity_log.entries.stat.entries': "القيود",
    'screen.activity_log.entries.stat.last_7_days': "في آخر 7 أيام",
    'screen.activity_log.entries.stat.retention_days': "مدة الحفظ (أيام)",
    'screen.activity_log.entries.action.retention': "مدة الحفظ",
    'screen.activity_log.entries.action.retention.field.days': "احفظ القيود مدة (أيام)",
    'screen.activity_log.entries.action.retention.field.days.help': "من 1 إلى 3650. القيمة الحالية هي الرقم فوق القائمة. تُحذف القيود الأقدم عند تشذيب السجل.",
    'screen.activity_log.entries.action.prune': "تشذيب الآن",
    'screen.activity_log.entries.action.prune.note': "حُذفت القيود الأقدم من مدة الحفظ. والتشذيب لاحقاً يحذف ما تقادم بعد ذلك.",
    'screen.activity_log.entries.action.prune.removed': "القيود المحذوفة",
    'screen.activity_log.entries.action.details': "التفاصيل",
    'screen.activity_log.entries.action.details.note': "ما يجوز أن يُعرض من هذا القيد: أي السجلات وما جرى لها. الأسماء والمبالغ وسائر القيم لا تُعرض، وتُذكر مفاتيحها فقط.",
    'screen.activity_log.entries.action.details.event': "الحدث",
    'screen.activity_log.entries.action.details.fields': "السجلات والحالات",
    'screen.activity_log.entries.action.details.hidden': "يحمله القيد ولا يُعرض",
    'activity.producer.identity': "النواة",
    'activity.producer.tags': "الوسوم",
    'activity.producer.common': "الخدمات المشتركة",
    'activity.producer.hr': "الموارد البشرية",
    'activity.producer.accounting': "المحاسبة",
    'activity.producer.gov_sa': "الخدمات الحكومية",
    'activity.producer.assistant': "المساعد",
    'activity.producer.crm': "علاقات العملاء",
    'activity.producer.projects': "المشاريع",
    'activity.producer.ads': "الإعلانات",
    'activity.producer.marketing': "التسويق",
    'value.subject_field.party_ref': "الطرف",
    'value.subject_field.owner_ref': "المالك",
    'value.subject_field.party_id': "الطرف",
    'value.subject_field.employee_id': "الموظّف",
    'value.subject_field.employment_id': "الموظّف",
    'value.subject_field.user_id': "العضو",
    'value.subject_field.member_id': "العضو",
    'value.subject_field.assignee_id': "من أُسند إليه",
    'value.subject_field.requested_by': "صاحب الطلب",
    'value.subject_field.submitted_by': "مقدّمه",
    'value.subject_field.manager_ref': "المدير",
    'activity.event.identity.capture_captcha.set': "ضُبط التحقق البشري للنماذج العامة",
    'activity.event.identity.capture_key.changed': "عُدّل مفتاح استقبال",
    'activity.event.identity.capture_key.issued': "أُصدر مفتاح استقبال لنموذج عام",
    'activity.event.identity.capture_key.revoked': "أُبطل مفتاح استقبال",
    'capture.refusal.bad_key': "مفتاح هذا النموذج غير صالح.",
    'capture.refusal.revoked': "أُلغي مفتاح هذا النموذج.",
    'capture.refusal.wrong_target': "مفتاح هذا النموذج لا يصل إلى الجهة التي يرسل إليها.",
    'capture.refusal.undeclared': "هذا النموذج لم يعد يستقبل الطلبات.",
    'capture.refusal.edge': "لم يصل هذا الطلب من منفذ مسموح له بقبوله.",
    'change.field.capture_captcha.provider': 'مزوّد التحقق البشري',
    'change.field.capture_captcha.secret_sealed': 'سرّ التحقق البشري (مختوم)',
    'change.field.capture_captcha.set_by': 'ضبطه',
    'change.field.capture_captcha.site_key': 'مفتاح الموقع للتحقق البشري',
    'change.field.capture_key.captcha': 'يطلب التحقق البشري',
    'change.field.capture_key.created_by': 'أصدره',
    'change.field.capture_key.name': 'الاسم',
    'change.field.capture_key.origins': 'المواقع المسموح بها',
    'change.field.capture_key.rate_per_minute': 'الطلبات في الدقيقة',
    'change.field.capture_key.revoked_at': 'أُبطل في',
    'change.field.capture_key.revoked_by': 'أبطله',
    'change.field.capture_key.secret_hash': 'المفتاح (مُجزّأ)',
    'change.field.capture_key.target': 'يرسل إلى',
    'change.field.party_match.outcome': 'النتيجة',
    'change.field.party_match.party_id': 'الطرف',
    'change.field.party_match.requested_by': 'طلبه',
    'change.field.party_match.resolution': 'القرار',
    'change.field.party_match.resolved_at': 'تاريخ القرار',
    'change.field.party_match.resolved_by': 'قرّره',
    'change.field.party_match.review_status': 'المراجعة',
    'change.field.party_match.source': 'المصدر',
    'change.field.party_match.source_key': 'مرجع المصدر',
    'change.field.consent_purpose.key': 'المفتاح',
    'change.field.consent_purpose.name_ar': 'الاسم بالعربية',
    'change.field.consent_purpose.name_en': 'الاسم بالإنجليزية',
    'change.field.consent_purpose.retired_at': 'أُوقف في',
    'change.field.consent_purpose.retired_by': 'أوقفه',
    'change.field.consent_purpose.status': 'الحالة',
    'capture.refusal.origin': "هذا النموذج لا يقبل الطلبات من هذا الموقع.",
    'capture.refusal.rate_limited': "طلبات كثيرة في الدقيقة الأخيرة. حاول بعد قليل.",
    'capture.refusal.captcha_failed': "لم يُجتز التحقق البشري.",
    'capture.refusal.captcha_unavailable': "تعذّر فحص التحقق البشري الآن. حاول بعد قليل.",
    'capture.refusal.too_large': "هذا الطلب أكبر مما يقبله النموذج.",
    'capture.refusal.payload': "بعض حقول هذا الطلب ناقصة أو بغير الشكل المطلوب.",
    'capture.refusal.idempotency': "هذا الطلب لا يحمل مفتاح تكرار (Idempotency-Key) صالحًا.",
    'capture.refusal.duplicate': "أُرسل مفتاح التكرار هذا من قبل مع طلب آخر.",
    'capture.refusal.bound': "هذا الطلب ليس الطلب الذي قُبل.",
    'capture.refusal.token': "هذا المسار لا يقبل إلا طلبًا قُبل له.",
    'activity.event.identity.invitation.withdrawn': "سُحبت دعوة",
    'activity.event.identity.member.added': "أُضيف عضو",
    'activity.event.identity.member.party_linked': "رُبط عضو بشخص",
    'activity.event.identity.member.party_unlinked': "فُك ربط عضو بشخص",
    'activity.event.identity.member.password_reset': "أُعيد تعيين كلمة مرور",
    'activity.event.identity.member.roles_changed': "تغيّرت أدوار عضو",
    'activity.event.identity.member.service_ended': "انتهت خدمة عضو",
    'activity.event.identity.member.service_end_kept': "انتهت خدمة عضو وأُبقي دخوله للمراجعة",
    'activity.event.identity.member.sessions_ended': "أُنهيت جلسات عضو",
    'activity.event.identity.member.updated': "عُدّل عضو",
    'activity.event.identity.module.moved': "نُقلت وحدة وظيفية إلى وحدة أخرى",
    'activity.event.identity.module.registered': "سُجّلت وحدة وظيفية",
    'activity.event.identity.permission.registered': "سُجّلت صلاحية",
    'activity.event.identity.role.created': "أُنشئ دور",
    'activity.event.identity.role.deleted': "حُذف دور",
    'activity.event.identity.role.duplicated': "نُسخ دور",
    'activity.event.identity.role.members_changed': "تغيّر أعضاء دور",
    'activity.event.identity.role.permissions_changed': "تغيّرت صلاحيات دور",
    'activity.event.identity.role.updated': "عُدّل دور",
    'activity.event.identity.tenant.created': "أُنشئت مساحة العمل",
    'activity.event.identity.tenant.modules_enabled': "فُعّلت وحدات",
    'activity.event.identity.tenant.tier_changed': "تغيّر المستوى",
    'activity.event.identity.tenant.renamed': "أُعيدت تسمية مساحة العمل",
    'activity.event.identity.tenant.setup_completed': "اكتمل إعداد مساحة العمل",
    'activity.event.identity.unit.registered': "سُجّلت وحدة",
    'activity.event.identity.user.invited': "دُعي مستخدم",
    'activity.event.identity.user.joined': "انضم مستخدم",
    'activity.event.identity.user.removed': "أُزيل مستخدم",
    'activity.event.media.file.uploaded': "رُفع ملف",
    'activity.event.parties.address.changed': "تغيّر عنوان طرف",
    'activity.event.parties.bank_account.changed': "تغيّر حساب بنكي لطرف",
    'activity.event.parties.identifier.changed': "تغيّر رقم طرف",
    'activity.event.parties.party.archived': "أُرشف طرف",
    'activity.event.parties.party.changed': "تغيّر طرف",
    'activity.event.parties.party.created': "أُنشئ طرف",
    'activity.event.parties.party.merged': "دُمج طرفان",
    'activity.event.settings.value.changed': "تغيّر إعداد",
    'activity.event.tags.tag.attached': "أُلحق وسم",
    'screen.calendar.occasions.action.approve': "اعتماد",
    'screen.calendar.occasions.action.create': "مناسبة جديدة",
    'screen.calendar.occasions.action.create.field.gregorian_from': "من",
    'screen.calendar.occasions.action.create.field.gregorian_to': "إلى",
    'screen.calendar.occasions.action.create.field.hijri_from': "من (هجري)",
    'screen.calendar.occasions.action.create.field.hijri_from.help': "اتركه فارغاً ليُحسب من التاريخ الميلادي بمرجع التحويل الهجري في المساحة. اكتبه (YYYY-MM-DD) حين يختلف التاريخ المُعلن عن الجدول.",
    'screen.calendar.occasions.action.create.field.hijri_to': "إلى (هجري)",
    'screen.calendar.occasions.action.create.field.hijri_to.help': "اتركه فارغاً ليُحسب من التاريخ الميلادي بمرجع التحويل الهجري في المساحة. اكتبه (YYYY-MM-DD) حين يختلف التاريخ المُعلن عن الجدول.",
    'screen.calendar.occasions.action.create.field.key': "المفتاح",
    'screen.calendar.occasions.action.create.field.kind': "النوع",
    'screen.calendar.occasions.action.create.field.kind.option.custom': "أخرى",
    'screen.calendar.occasions.action.create.field.kind.option.eid_adha': "عيد الأضحى",
    'screen.calendar.occasions.action.create.field.kind.option.eid_fitr': "عيد الفطر",
    'screen.calendar.occasions.action.create.field.kind.option.founding_day': "يوم التأسيس",
    'screen.calendar.occasions.action.create.field.kind.option.national_day': "اليوم الوطني",
    'screen.calendar.occasions.action.create.field.kind.option.ramadan': "رمضان",
    'screen.calendar.occasions.action.create.field.kind.option.season': "موسم محلي",
    'screen.calendar.occasions.action.create.field.location_ref': "الموقع",
    'screen.calendar.occasions.action.create.field.location_ref.help': "فقط إن كانت تخصّ موقعاً واحداً: مرجع ذلك الموقع كما يكتبه المديول الذي يملك المواقع.",
    'screen.calendar.occasions.action.create.field.name_ar': "الاسم بالعربية",
    'screen.calendar.occasions.action.create.field.name_en': "الاسم بالإنجليزية",
    'screen.calendar.occasions.action.create.field.scope': "يسري على",
    'screen.calendar.occasions.action.create.field.scope.option.all': "المساحة كلها",
    'screen.calendar.occasions.action.create.field.scope.option.location': "موقع واحد",
    'screen.calendar.occasions.action.edit': "تعديل",
    'screen.calendar.occasions.action.edit.field.gregorian_from': "من",
    'screen.calendar.occasions.action.edit.field.gregorian_to': "إلى",
    'screen.calendar.occasions.action.edit.field.hijri_from': "من (هجري)",
    'screen.calendar.occasions.action.edit.field.hijri_from.help': "اتركه فارغاً ليُحسب من التاريخ الميلادي بمرجع التحويل الهجري في المساحة. اكتبه (YYYY-MM-DD) حين يختلف التاريخ المُعلن عن الجدول.",
    'screen.calendar.occasions.action.edit.field.hijri_to': "إلى (هجري)",
    'screen.calendar.occasions.action.edit.field.hijri_to.help': "اتركه فارغاً ليُحسب من التاريخ الميلادي بمرجع التحويل الهجري في المساحة. اكتبه (YYYY-MM-DD) حين يختلف التاريخ المُعلن عن الجدول.",
    'screen.calendar.occasions.action.edit.field.name_ar': "الاسم بالعربية",
    'screen.calendar.occasions.action.edit.field.name_en': "الاسم بالإنجليزية",
    'screen.calendar.occasions.action.withdraw': "سحب",
    'screen.calendar.occasions.action.withdraw.field.reason': "السبب",
    'screen.calendar.occasions.column.gregorian_from': "من",
    'screen.calendar.occasions.column.gregorian_to': "إلى",
    'screen.calendar.occasions.column.hijri_from': "من (هجري)",
    'screen.calendar.occasions.column.id': "المعرّف",
    'screen.calendar.occasions.column.key': "المفتاح",
    'screen.calendar.occasions.column.kind': "النوع",
    'screen.calendar.occasions.column.name_ar': "المناسبة",
    'screen.calendar.occasions.column.name_en': "الاسم بالإنجليزية",
    'screen.calendar.occasions.column.scope': "النطاق",
    'screen.calendar.occasions.column.status': "الحالة",
    'screen.calendar.occasions.lede': "التواريخ التي اعتمدتها هذه المساحة، وما زال منها مقترحاً.",
    'screen.calendar.occasions.stat.approved': "معتمد",
    'screen.calendar.occasions.stat.proposed': "بانتظار الاعتماد",
    'screen.calendar.occasions.title': "المناسبات",
    'screen.documents.items.action.create': "جديد",
    'screen.documents.items.action.create.field.name': "الاسم",
    'screen.documents.items.column.created_at': "أُنشئ",
    'screen.documents.items.column.name': "الاسم",
    'screen.documents.items.title': "المستندات",
    'screen.calendar.occasions.stat.draft': "بانتظار الاعتماد",
    'screen.identity.modules.action.disable': "إيقاف",
    'screen.identity.modules.action.enable': "تفعيل",
    'screen.identity.modules.action.rename': "إعادة تسمية المساحة",
    'screen.identity.modules.action.rename.field.name': "اسم المساحة",
    'screen.identity.modules.action.names': "الاسم بكل لغة",
    'screen.identity.modules.action.names.field.name_ar': "الاسم بالعربية",
    'screen.identity.modules.action.names.field.name_en': "الاسم بالإنجليزية",
    'screen.identity.modules.action.names.field.help': "إن تُرك فارغاً يظهر اسم المساحة.",
    'screen.identity.modules.action.logo': "شعار المساحة",
    'screen.identity.modules.action.logo.field.logo': "الشعار",
    'screen.identity.modules.action.logo.field.logo.help': "صورة PNG أو JPEG أو WebP حتى 2 ميجابايت، يظهر في تطبيق الموظفين وشاشة الدخول.",
    'screen.identity.modules.action.logo.field.remove': "إزالة الشعار الحالي",
    'screen.identity.modules.column.core': "النوع",
    'screen.identity.modules.column.description': "وظيفته",
    'screen.identity.modules.column.enabled': "الحالة",
    'screen.identity.modules.column.key': "المفتاح",
    'screen.identity.modules.column.name': "الوحدة",
    'screen.identity.modules.column.modules': "المديولات",
    'screen.identity.modules.column.requires': "تحتاج إلى",
    'screen.identity.modules.column.required_by': "تحتاجها",
    'screen.identity.modules.lede': "ما تشغّله هذه المساحة، وما يمكنها تشغيله. تُفعَّل الوحدة بكل مديولاتها، ومعها الوحدات التي تحتاجها.",
    'screen.identity.modules.stat.available': "متاح",
    'screen.identity.modules.stat.on': "مفعّل هنا",
    'screen.identity.modules.title': "الوحدات",
    'screen.identity.unit_modules.title': "المديولات",
    'screen.identity.unit_modules.empty': "لا مديول يعرض شيئاً في هذه الوحدة.",
    'screen.identity.unit.title': "الوحدة",
    'screen.identity.unit.tab.modules': "المديولات",
    'screen.identity.unit.column.name': "الوحدة",
    'screen.identity.unit.column.key': "المفتاح",
    'screen.identity.unit.column.enabled': "الحالة",
    'screen.identity.unit.state.true': "مفعّلة",
    'screen.identity.unit.state.false': "غير مفعّلة",
    'screen.identity.unit.column.modules': "المديولات",
    'screen.identity.unit.column.modules_on': "المديولات المفعّلة",
    'screen.identity.unit.column.requires': "تحتاج إلى",
    'screen.identity.unit.column.required_by': "تحتاجها",
    'screen.identity.unit.column.module_control': "التحكم في المديولات مسموح",
    'screen.identity.modules.column.tier': "المستوى",
    'screen.identity.modules.column.tier_requested': "المستوى المطلوب",
    'screen.identity.unit.column.tier': "المستوى",
    'screen.identity.unit.column.tier_requested': "المستوى المطلوب",
    'screen.identity.unit.tier.basic': "أساسي",
    'screen.identity.unit.tier.standard': "متوسط",
    'screen.identity.unit.tier.advanced': "متقدم",
    'screen.identity.modules.action.request_tier': "طلب تغيير المستوى",
    'screen.identity.modules.action.request_tier.field.tier': "المستوى",
    'screen.identity.modules.action.request_tier.field.tier.help': "يوافق مدير النظام على التغيير، وحتى ذلك تبقى الوحدة كما هي. تغيير المستوى يُظهر الشاشات أو يخفيها ولا يغيّر أي بيانات.",
    'screen.identity.modules.action.request_tier.field.reason': "السبب",
    'screen.identity.modules.action.cancel_tier_request': "سحب طلب المستوى",
    'screen.identity.unit_modules.column.name': "المديول",
    'screen.identity.unit_modules.column.key': "المفتاح",
    'screen.identity.unit_modules.column.enabled': "الحالة",
    'screen.identity.unit_modules.column.required_by': "يحتاجه",
    'screen.identity.unit_modules.column.switchable': "يمكن التحكم فيه هنا",
    'screen.identity.unit_modules.action.enable': "تفعيل",
    'screen.identity.unit_modules.action.disable': "إيقاف",
    'screen.identity.people.action.edit': "تعديل",
    'screen.identity.people.action.edit.field.job_title': "المسمّى الوظيفي",
    'screen.identity.people.action.edit.field.name': "الاسم",
    'screen.identity.people.action.edit.field.name.help': "الاسم الذي يُنادى به. إن تُرك فارغاً ظهر بريده.",
    'screen.identity.people.action.edit.field.phone': "الهاتف",
    'screen.identity.people.action.invite': "دعوة برابط",
    'screen.identity.people.action.invite.field.email': "البريد الإلكتروني",
    'screen.identity.people.action.invite.field.roles': "الأدوار",
    'screen.identity.people.action.invite.field.roles.help': "إن لم يُحدَّد شيء يُمنح دور العضو. يختار كلمة مروره بنفسه عند قبول الدعوة.",
    'screen.identity.people.action.invite.reveal.expires_at': "صالح حتى",
    'screen.identity.people.action.invite.reveal.link': "رابط الدعوة",
    'screen.identity.people.action.reissue.reveal.link': "رابط الدعوة",
    'screen.identity.people.action.invite.reveal.email_delivery': "البريد",
    'screen.identity.people.action.reissue.reveal.email_delivery': "البريد",
    'screen.identity.people.action.invite.field.send_email': "إرسال الرابط إليه بالبريد",
    'screen.identity.people.action.reissue.field.send_email': "إرسال الرابط الجديد إليه بالبريد",
    'screen.identity.people.action.invite.field.send_email.help': "يُرسل بإعدادات البريد في هذا التنصيب، ويظهر لك الرابط مرة واحدة لتنسخه أيضاً.",
    'screen.identity.people.action.reissue.field.send_email.help': "يتوقف الرابط القديم عن العمل، ويظهر لك الجديد مرة واحدة لتنسخه أيضاً.",
    'screen.identity.people.follow.sent': "أُرسلت إلى {address}",
    'screen.identity.people.follow.pending': "لم يستلمها خادم البريد بعد؛ ستُعاد المحاولة وتظهر في سجل الإرسال.",
    'screen.identity.people.follow.failed': "لم تُرسل: {last_error}. انسخ الرابط وأرسله بنفسك.",
    'screen.identity.people.follow.skipped': "لم تُرسل بالبريد: انسخ الرابط وأرسله بنفسك.",
    'screen.identity.people.action.reissue': "إرسال رابط جديد",
    'screen.identity.people.action.reissue.reveal.expires_at': "صالح حتى",
    'screen.identity.people.action.reissue_live': "إرسال رابط جديد",
    'screen.identity.people.action.reissue_live.reveal.expires_at': "صالح حتى",
    'screen.identity.people.action.reissue_live.reveal.token': "رمز الدعوة",
    'screen.identity.people.action.remove': "إزالة من المساحة",
    'screen.identity.people.action.resume': "إعادة السماح",
    'screen.identity.people.action.roles': "ضبط الأدوار",
    'screen.identity.people.action.roles.field.roles': "ما يُسمح لهم به هنا",
    'screen.identity.people.action.suspend': "إيقاف مؤقت",
    'screen.identity.people.action.withdraw': "سحب الدعوة",
    'screen.identity.people.action.add': "إضافة مستخدم",
    'screen.identity.people.column.accepted_at': "انضم في",
    'screen.identity.people.column.second_factor': "خطوتان",
    'screen.identity.people.column.service_access_until': "الدخول حتى",
    'screen.identity.people.status.access_until': "دخول حتى {service_access_until}",
    'screen.identity.people.column.email': "البريد الإلكتروني",
    'screen.identity.people.column.job_title': "المسمّى الوظيفي",
    'screen.identity.people.column.name': "المستخدم",
    'screen.identity.people.column.roles': "مفاتيح الأدوار",
    'screen.identity.people.column.status': "الحالة",
    'screen.identity.people.column.last_seen_at': "آخر نشاط",
    'screen.identity.people.column.role_list': "الأدوار",
    'screen.identity.people.filter.roles': "الدور",
    'screen.identity.people.lede': "كل من يستطيع الدخول إلى هذه المساحة، وكل من دُعي إليها.",
    'screen.identity.people.stat.active': "نشطون",
    'screen.identity.people.stat.pending': "دعوات معلّقة",
    'screen.identity.people.stat.people': "المستخدمون",
    'screen.identity.people.stat.suspended': "موقوفون",
    'screen.identity.people.title': "المستخدمون",
    'screen.identity.roles.action.create': "دور جديد",
    'screen.identity.roles.action.create.field.description': "الغرض منه",
    'screen.identity.roles.action.create.field.description.help': "جملة واحدة. من يختار بين أحد عشر دوراً يختار بين أحد عشر اسماً ما لم يُكتب هذا.",
    'screen.identity.roles.action.create.field.key': "المفتاح",
    'screen.identity.roles.action.create.field.key.help': "أحرف لاتينية صغيرة بلا مسافات. هو اسم الدور في الصلاحيات ولا يمكن تغييره.",
    'screen.identity.roles.action.create.field.name': "الاسم",
    'screen.identity.roles.action.delete': "حذف",
    'screen.identity.roles.action.duplicate': "نسخ",
    'screen.identity.roles.action.duplicate.field.key': "المفتاح",
    'screen.identity.roles.action.duplicate.field.key.help': "أحرف لاتينية صغيرة بلا مسافات، ولا يمكن تغييره لاحقاً.",
    'screen.identity.roles.action.duplicate.field.name': "الاسم",
    'screen.identity.roles.action.edit': "تعديل",
    'screen.identity.roles.action.edit.field.colour': "اللون",
    'screen.identity.roles.action.edit.field.colour.option.amber': "كهرماني",
    'screen.identity.roles.action.edit.field.colour.option.blue': "أزرق",
    'screen.identity.roles.action.edit.field.colour.option.green': "أخضر",
    'screen.identity.roles.action.edit.field.colour.option.neutral': "محايد",
    'screen.identity.roles.action.edit.field.colour.option.red': "أحمر",
    'screen.identity.roles.action.edit.field.colour.option.violet': "بنفسجي",
    'screen.identity.roles.action.edit.field.description': "الغرض منه",
    'screen.identity.roles.action.edit.field.name': "الاسم",
    'screen.identity.roles.action.edit.field.name_ar': "الاسم بالعربية",
    'screen.identity.roles.action.edit.field.name_ar.help': "يظهر في الصفحات العربية؛ وإن تُرك فارغاً ظهر الاسم الإنجليزي.",
    'screen.identity.roles.action.edit.field.description_ar': "الغرض منه بالعربية",
    'screen.identity.roles.action.members': "الأعضاء",
    'screen.identity.roles.action.members.field.members': "من يحمل هذا الدور",
    'screen.identity.roles.action.permissions': "ضبط الصلاحيات",
    'screen.identity.roles.action.permissions.field.permissions': "ما يُسمح لهذا الدور به",
    'screen.identity.roles.column.colour': "اللون",
    'screen.identity.roles.column.requires_second_factor': "الدخول بخطوتين",
    'screen.identity.roles.action.second_factor': "الدخول بخطوتين",
    'screen.identity.roles.action.second_factor.field.required': "حمل هذا الدور يشترطه",
    'screen.identity.roles.action.second_factor.field.required.help': "من يحمل هذا الدور يدخل رمزاً من تطبيق مصادقة حين يدخل هذه المساحة. من لا تطبيق له يُطلب منه تفعيله عند دخوله التالي؛ والجلسة المفتوحة تدخل من جديد برمز. لا يغيّر هذا إلا من يحمل كل ما يحمله الدور.",
    'screen.identity.roles.column.description': "الغرض منه",
    'screen.identity.roles.column.is_system': "النوع",
    'screen.identity.roles.column.key': "المفتاح",
    'screen.identity.roles.column.members': "الأعضاء",
    'screen.identity.roles.column.name': "الدور",
    'screen.identity.roles.column.name_ar': "بالعربية",
    'screen.identity.roles.column.description_ar': "الغرض منه بالعربية",
    'screen.identity.roles.column.permission_count': "الصلاحيات",
    'screen.identity.roles.column.permissions': "يصل إلى",
    'screen.identity.roles.lede': "اجمع الصلاحيات في أدوار قابلة لإعادة الاستخدام. يمكن للشخص أن يحمل أكثر من دور.",
    'screen.identity.roles.stat.custom': "مخصّص",
    'screen.identity.roles.stat.system': "نظامي",
    'screen.identity.roles.stat.total': "مجموع الأدوار",
    'screen.identity.roles.title': "الأدوار والصلاحيات",
    'screen.media.files.column.content_type': "النوع",
    'screen.media.files.column.created_at': "أُضيف",
    'screen.media.files.column.filename': "الملف",
    'screen.media.files.column.size': "الحجم",
    'screen.media.files.column.state': "الحالة",
    'screen.media.files.title': "الملفات",
    'screen.media.files.lede': "الملفات المرفوعة إلى هذه المساحة؛ والرفع الذي لم يكتمل يبقى معلّقاً حتى تنتهي صلاحيته.",
    'screen.media.files.column.failure': "سبب الفشل",
    'screen.media.files.stat.files': "الملفات",
    'screen.media.files.stat.ready': "جاهزة",
    'screen.media.files.stat.pending': "معلّقة",
    'screen.media.files.action.prune': "كنس الرفع المنتهي",
    'screen.media.files.action.prune.note': "حُذف الرفع المعلّق الذي انتهى توقيعه، ومعه ما وصل إلى التخزين. والرفع الذي ما زال في مهلته يُترك.",
    'screen.media.files.action.prune.removed': "عمليات الرفع المحذوفة",
    'screen.media.files.action.delete': "حذف",
    'media.state.ready': "جاهز",
    'media.state.pending': "معلّق",
    'media.state.failed': "فشل",
    'screen.notifications.items.action.create': "جديد",
    'screen.notifications.items.action.create.field.name': "الاسم",
    'screen.notifications.items.column.created_at': "أُنشئ",
    'screen.notifications.items.column.name': "الاسم",
    'screen.notifications.items.title': "التنبيهات",
    'screen.parties.parties.stat.active': "نشط",
    'screen.parties.parties.stat.archived': "مؤرشف",
    'screen.parties.parties.stat.merged': "مدموج في غيره",
    'screen.parties.parties.stat.parties': "الأطراف",
    'screen.settings.groups.column.name': "المجموعة",
    'screen.settings.groups.column.problems': "المشكلات",
    'screen.settings.groups.column.version': "الإصدار",
    'screen.settings.groups.title': "الإعدادات",
    'screen.identity.roles.stat.system.detail': "جزء من كل مساحة",
    'screen.identity.roles.stat.custom.detail': "أُنشئ هنا، وقابل للتعديل",
    'screen.identity.people.stat.suspended.detail': "لا يستطيعون العمل هنا حالياً",
    'screen.identity.people.stat.password_pending': "بانتظار كلمة المرور",
    'screen.identity.people.stat.password_pending.detail': "لم يغيّروا كلمة المرور المؤقتة",
    'screen.identity.people.stat.follow_up': "بحاجة إلى متابعة",
    'screen.identity.people.tab.follow_up': "بحاجة إلى متابعة",
    'screen.identity.role.title': "الدور",
    'screen.identity.role.column.modules': "المديولات التي يصل إليها",
    'screen.identity.role.tab.permissions': "الصلاحيات",
    'screen.identity.role.tab.holders': "من يحمله",
    'screen.identity.role.tab.settings': "الإعدادات",
    'screen.identity.role.table.permissions': "ما يستطيع هذا الدور فعله",
    'screen.identity.role.permission.name': "الصلاحية",
    'screen.identity.role.permission.module_name': "المديول",
    'screen.identity.role.permission.key': "المفتاح",
    'screen.identity.role.permission.retired': "متاحة",
    'screen.identity.role.permission.retired.true': "لم تعد متاحة",
    'screen.identity.role.permission.retired.false': "متاحة",
    'screen.identity.role.note.fifteen_minutes': "يصل أي تغيير إلى من يحملون هذا الدور خلال 15 دقيقة، عند تجدد دخولهم.",
    'screen.identity.role_holders.title': "من يحمل هذا الدور",
    'screen.identity.role_holders.column.membership_id': "العضوية",
    'screen.identity.role_holders.empty': "لا أحد يحمل هذا الدور بعد.",
    'screen.identity.role_holders.action.add': "منحه لـ…",
    'screen.identity.role_holders.action.add.field.add': "الأعضاء",
    'screen.identity.role_holders.action.remove': "إزالة من الدور",
    'screen.identity.people.action.add.field.how': "كيف يدخل أول مرة؟",
    'screen.identity.people.action.add.field.how.option.invite': "أرسل له رابط دعوة",
    'screen.identity.people.action.add.field.how.option.password': "أنشئ له كلمة مرور مؤقتة",
    'screen.identity.people.action.add.field.roles.help_any': "دون اختيار: «عضو» بالدعوة، و«موظّف» بكلمة المرور.",
    'screen.identity.member.column.name': "الاسم",
    'screen.identity.member.column.linked': "مرتبط بشخص",
    'screen.identity.member.alert.new_password': "كلمة مرور مؤقتة جديدة",
    'screen.identity.member.table.permissions': "ما يستطيع فعله، والدور الذي يعطيه ذلك",
    'screen.identity.member.permission.from': "من الدور",
    'screen.identity.member.note.fifteen_minutes': "يصل أي تغيير في أدواره إليه خلال 15 دقيقة، عند تجدد دخوله.",
    'screen.identity.member.card.roles': "الأدوار في هذه المساحة",
    'screen.identity.member.card.details': "البيانات",
    'screen.identity.member.card.details.note': "الاسم والهاتف والمسمى تخص حسابه، فتعديلها يظهر في كل مساحة ينتمي إليها.",
    'screen.identity.member.card.membership': "العضوية",
    'screen.identity.member_sessions.title': "الجلسات المفتوحة",
    'screen.identity.member_sessions.column.device': "الجهاز",
    'screen.identity.people.stat.follow_up.detail': "بكلمة مرور مؤقتة، أو لم ينضموا بعد",
    'screen.invoicing.documents.lede': 'الفاتورة المُرحَّلة لا تُعدَّل: تُصحَّح بإشعار دائن أو مدين يسمّيها ويحمل أحد أسباب الهيئة.',
    // hr · attendance
    "group.attendance": "الحضور والجداول",
    "value.day_status.present": "حاضر",
    "value.day_status.late": "متأخّر",
    "value.day_status.left_early": "انصرف مبكّراً",
    "value.day_status.incomplete": "بصمة ناقصة",
    "value.day_status.absent": "غائب",
    "value.day_status.on_leave": "في إجازة",
    "value.day_status.in_shift": "في الوردية",
    "value.source.device": "بصمة",
    "value.source.app": "تطبيق ميداني",
    "value.source.manual": "إدخال يدوي",
    "value.source.review": "تقييم أداء",
    "value.source.imported": "ملف",
    "value.stage.counting": "قيد العدّ",
    "value.stage.warning": "إنذار",
    "value.stage.review": "مراجعة",
    "value.template.daily": "يومي",
    "value.template.historical": "تاريخي",
    "value.template.device": "بصمة",
    "value.import_status.reviewing": "بانتظار القراءة",
    "value.import_status.pending_approval": "بانتظار الاعتماد",
    "value.import_status.approved": "معتمد، جاهز للتطبيق",
    "value.import_status.applied": "طُبِّق",
    "value.import_status.undone": "تُراجع عنه",
    "value.import_status.refused": "مرفوض",
    "value.import_status.cancelled": "مستبعَد",
    // hr · offboarding
    "value.art87_ground.childbirth": "خلال ثلاثة أشهر من وضعها",
    "value.art87_ground.force_majeure": "قوّة قاهرة خارجة عن إرادة العامل",
    "value.art87_ground.marriage": "خلال ستة أشهر من عقد زواجها",
    "value.ended_by.employer": "صاحب العمل",
    "value.ended_by.worker": "الموظّف",
    "value.owner.custody": "العهد",
    "value.owner.employee": "الموظّف",
    "value.owner.finance": "المالية",
    "value.owner.hr": "الموارد البشرية",
    "value.owner.it": "تقنية المعلومات",
    "value.owner.manager": "مدير المدينة",
    "value.status.cleared": "مؤكَّد",
    "value.status.clearing": "إخلاء طرف",
    "value.status.closed_out": "مغلق",
    "value.status.deferred": "مؤجَّلة",
    "value.status.disputed": "محلّ خلاف",
    "value.status.filed": "مقدَّم",
    "value.status.overdue": "تجاوز المهلة",
    "value.status.pending": "معلّق",
    "value.status.settled": "مسدَّد",
    "value.status.unrecovered": "غير مستردّ",
    "value.status.withdrawn": "مسحوبة",
    "value.status.destroyed": "مُتلَفة",
    "value.wage_period.monthly": "أجر شهري",
    "value.wage_period.other": "أجر غير شهري",
    'editor.choices.accounts': "دليل الحسابات",
    'editor.choices.journals': "دفاتر اليومية",
    'editor.choices.noBankJournal': "لا يوجد دفتر بنك بعد. أضفه من دفاتر اليومية بنوع «بنك» مع حساب افتراضي.",
    'editor.choices.noPurchaseJournal': "لا يوجد دفتر مشتريات بعد. أضفه من دفاتر اليومية بنوع «مشتريات».",
    'editor.choices.noSalesJournal': "لا يوجد دفتر مبيعات بعد. أضفه من دفاتر اليومية بنوع «مبيعات».",
    'editor.choices.parties': "سجل الأطراف",
    'editor.choices.taxCodes': "رموز الضريبة",
    'editor.choices.unreachable': "تعذّرت قراءة {what} ({state}).",
    'editor.need.balanced': "تساوي المدين والدائن بمبلغ أكبر من صفر",
    'editor.need.entryLines': "كل سطر بحساب ومبلغ في المدين أو الدائن وحده",
    'editor.need.journal': "الدفتر",
    'editor.need.lines': "كل سطر بوصف وكمية وسعر وحساب",
    'editor.need.party': "العميل",
    'editor.need.purchaseJournal': "دفتر المشتريات",
    'editor.need.salesJournal': "دفتر المبيعات",
    'editor.need.vendor': "المورّد",
    'editor.needs': "لإكمال الحفظ: {list}",
    // hr · benefits
    "group.benefits": "العهد والمزايا",
    "nav.module.gosi": "التأمينات الاجتماعية",
    "nav.module.mudad": "مدد (حماية الأجور)",
    "nav.module.setup": "محادثة التهيئة",
    "value.cover_status.covered": "مغطّى",
    "value.cover_status.ended": "منتهٍ",
    "value.cover_status.ending": "على وشك الانتهاء",
    "value.cover_status.not_covered": "غير مغطّى",
    "value.cover_status.unconfirmed": "بانتظار شركة التأمين",
    "value.covers.employee": "الموظّف وحده",
    "value.covers.employee_spouse": "الموظّف والزوج/الزوجة",
    "value.covers.family": "الموظّف وأسرته",
    "value.covers_parents.false": "الأسرة فقط",
    "value.covers_parents.true": "تشمل الوالدين",
    "value.relation.daughter": "ابنة",
    "value.relation.father": "أب",
    "value.relation.mother": "أم",
    "value.relation.son": "ابن",
    "value.relation.spouse": "زوج / زوجة",
    "value.status.accruing": "قيد الاستحقاق",
    "value.status.cashed": "صُرفت نقداً",
    "value.status.covered": "مغطّى",
    "value.status.due": "مستحقّة",
    "value.status.in_force": "سارية",
    "value.status.ticketed": "صدرت التذكرة",
    "value.statutory.false": "اختياري",
    "value.statutory.true": "إلزامي نظاماً",
    "value.ticket_class.business": "رجال الأعمال",
    "value.ticket_class.economy": "سياحية",
    "value.ticket_class.first": "الأولى",
    // hr · recruitment
    "group.recruitment": "التوظيف والاستقبال",
    "value.channel.agency": "مكتب توظيف",
    "value.channel.job_board": "منصّة توظيف",
    "value.channel.other": "أخرى",
    "value.channel.referral": "ترشيح",
    "value.channel.social": "وسائل التواصل",
    "value.channel.walk_in": "حضور شخصي",
    "value.channel.website": "الموقع الإلكتروني",
    "value.credential_required.false": "غير مطلوب",
    "value.credential_required.true": "مطلوب",
    "value.flag.age_outside_range": "خارج نطاق العمر",
    "value.flag.below_qualification": "دون المؤهّل المطلوب",
    "value.flag.blacklisted": "مستبعد من التوظيف",
    "value.flag.meets_all": "يستوفي المعايير",
    "value.flag.no_credential": "لا يحمل التصريح",
    "value.flag.short_experience": "خبرة أقلّ من المطلوب",
    "value.flag.under_age": "دون سنّ العمل",
    "value.has_credential.false": "لا يحمله",
    "value.has_credential.true": "يحمله",
    "value.min_qualification.bachelor": "بكالوريوس",
    "value.min_qualification.diploma": "دبلوم",
    "value.min_qualification.doctorate": "دكتوراه",
    "value.min_qualification.intermediate": "متوسط",
    "value.min_qualification.master": "ماجستير",
    "value.min_qualification.none": "بدون",
    "value.min_qualification.primary": "ابتدائي",
    "value.min_qualification.secondary": "ثانوي",
    "value.next_step.await_joining": "بانتظار المباشرة",
    "value.next_step.decide": "اتخاذ قرار",
    "value.next_step.hire": "التعيين",
    "value.next_step.interview": "جدولة مقابلة",
    "value.next_step.no_show": "لم يباشر",
    "value.next_step.none": "لا إجراء",
    "value.next_step.offer": "تقديم عرض",
    "value.next_step.record_result": "تسجيل نتيجة المقابلة",
    "value.next_step.screen": "الفرز",
    "value.qualification.bachelor": "بكالوريوس",
    "value.qualification.diploma": "دبلوم",
    "value.qualification.doctorate": "دكتوراه",
    "value.qualification.intermediate": "متوسط",
    "value.qualification.master": "ماجستير",
    "value.qualification.none": "بدون",
    "value.qualification.primary": "ابتدائي",
    "value.qualification.secondary": "ثانوي",
    "value.recommendation.hire": "يُعيَّن",
    "value.recommendation.hold": "يبقى في القائمة",
    "value.recommendation.reject": "يُرفض",
    "value.result.cancelled": "ملغاة",
    "value.status.filled": "مكتملة",
    "value.status.hired": "عُيّن",
    "value.status.interview": "مرحلة المقابلة",
    "value.status.lifted": "مرفوع من القائمة",
    "value.status.offered": "عُرض عليه",
    "value.status.screening": "قيد الفرز",
    "value.status.waiting": "في قائمة الانتظار",
    // hr · grievances
    "value.decision.accepted": "قُبل التظلّم — يسقط الجزاء المتظلَّم منه",
    "value.decision.partly_accepted": "قُبل جزئياً",
    "value.decision.rejected": "رُفض التظلّم — يبقى الجزاء المتظلَّم منه",
    "value.decision.upheld": "ثبتت الشكوى",
    "value.decision.partly_upheld": "ثبتت جزئياً",
    "value.decision.dismissed": "رُدّت الشكوى",
    "value.decision.adopted": "اعتُمد الاقتراح",
    "value.decision.noted": "أُحيط به علماً",
    "value.decision.declined": "لم يُؤخذ به",
    "value.hold_state.applied": "خُصم قبل التظلّم",
    "value.hold_state.held": "معلّق حتى القرار",
    "value.hold_state.none": "لا أثر مالي",
    "value.hold_state.released": "رُفع التعليق",
    "value.kind.colleague": "شكوى على زميل",
    "value.kind.conditions": "ظروف العمل",
    "value.kind.pay": "شكوى راتب",
    "value.kind.penalty": "تظلّم من جزاء",
    "value.kind.suggestion": "اقتراح أو ملاحظة",
    "value.kind.supervisor": "شكوى على مشرف",
    "value.route.committee": "لجنة التظلّمات",
    "value.route.hr": "الموارد البشرية",
    "value.status.decided": "صدر القرار ولم يُبلَّغ",
    "value.status.heard": "سُمع الموظّف",
    // hr · assets
    "group.custody": "العهد",
    "value.category.office": "مكتبية — تُجرد كل 12 شهراً",
    "value.category.operational": "تشغيلية — تُجرد كل 6 أشهر",
    "value.cause.accident": "حادث",
    "value.cause.normal_wear": "استهلاك طبيعي",
    "value.cause.unknown": "غير معروف",
    "value.cause.worker_fault": "خطأ الموظّف",
    "value.condition.damaged": "تالفة",
    "value.condition.good": "سليمة",
    "value.condition.lost": "مفقودة",
    "value.condition.needs_maintenance": "تحتاج صيانة",
    "value.condition.retired": "غير نشط",
    "value.issue_grade.acceptable": "مقبولة",
    "value.issue_grade.excellent": "ممتازة",
    "value.issue_grade.good": "جيدة",
    "value.return_reason.long_leave": "إجازة طويلة",
    "value.return_reason.other": "أخرى",
    "value.return_reason.role_change": "تغيير الوظيفة",
    "value.return_reason.termination": "انتهاء الخدمة",
    "value.return_reason.transfer": "نقل",
    "value.return_state.damaged": "تالفة",
    "value.return_state.intact": "سليمة",
    "value.return_state.lost": "مفقودة",
    "value.return_state.needs_maintenance": "تحتاج صيانة",
    "value.stage.approved": "معتمد",
    "value.stage.cancelled": "ملغى",
    "value.stage.filed": "بانتظار التقدير",
    "value.damage_stage.filed": "بانتظار التقدير",
    "value.damage_stage.review": "بانتظار الاعتماد",
    "value.damage_stage.approved": "معتمد",
    "value.damage_stage.cancelled": "ملغى",
    "value.status.counting": "قيد الجرد",
    "value.status.handed_over": "مسلَّمة",
    "value.status.return_overdue": "متأخرة عن الإعادة",
    "value.status.returned": "أُعيدت",
    'member.activity.forbidden': "قراءة سجل النشاط تحتاج صلاحية خاصة.",
    'member.activity.none': "لم يُسجَّل عنه شيء بعد.",
    'member.back': "العودة إلى المستخدمين",
    'member.field.added_by': "أضافه",
    'member.field.elsewhere': "مساحات أخرى",
    'member.field.email': "البريد الإلكتروني",
    'member.field.job_title': "المسمّى الوظيفي",
    'member.field.joined': "انضم في",
    'member.field.last_seen': "آخر دخول",
    'member.field.phone': "الهاتف",
    'member.field.roles': "الأدوار",
    'member.missing': "افتح مستخدماً من قائمة المستخدمين.",
    'member.never': "لم يدخل بعد",
    'member.nobody': "انضم قبل تسجيل ذلك",
    'member.passwordPending': "ما زال بكلمة مرور مؤقتة: عليه اختيار كلمته عند دخوله التالي.",
    'member.permissions.everything': "كل شيء، الآن ولاحقاً",
    'member.permissions.from': "من دور",
    'member.permissions.none': "لا صلاحيات: يستطيع الدخول وإدارة حسابه فقط.",
    'member.sessions.device': "فُتحت من",
    'member.sessions.end': "إنهاء",
    'member.sessions.endAll': "إنهاء كل الجلسات هنا",
    'member.sessions.lastUsed': "آخر استخدام",
    'member.sessions.none': "لا جلسات مفتوحة هنا.",
    'member.sessions.started': "بدأت",
    'member.sessions.unknownDevice': "جهاز غير معروف",
    'member.suspended': "موقوف هنا: لا يستطيع العمل في هذه المساحة حتى يُعاد السماح له.",
    'member.afterService': "انتهت الخدمة في {service_ends_on}. ويبقى الدخول حتى {service_access_until} إلى ما تسمح به الوحدات بعد انتهاء الخدمة، ولا شيء غيره.",
    'member.tab.activity': "النشاط",
    'member.tab.permissions': "الصلاحيات",
    'member.tab.profile': "الملف",
    'member.tab.sessions': "الجلسات",
    'member.confirm.reset': "تُولَّد كلمة مرور مؤقتة جديدة تُعرض لك مرة واحدة. تتوقف كلمته الحالية، وتنتهي كل جلساته هنا، وعليه اختيار كلمته عند دخوله التالي.",
    'member.confirm.end': "تنتهي كل جلساته المفتوحة في هذه المساحة، ويستطيع الدخول من جديد بكلمة مروره.",
    'member.confirm.suspend': "لن يستطيع العمل في هذه المساحة حتى يُعاد السماح له، وتنتهي جلساته هنا. لا يتأثر في المساحات الأخرى.",
    'member.confirm.resume': "يستطيع الدخول إلى هذه المساحة من جديد بالأدوار التي كانت له.",
    'member.confirm.resetSecondFactor': "يتوقف تطبيق المصادقة ورموز الاسترداد، وتنتهي كل جلساته هنا، ويفعّله من جديد عند دخوله التالي. لمن فقد هاتفه ورموزه.",
    'member.field.second_factor': "الدخول بخطوتين",
    'member.secondFactor.on': "مفعّل",
    'member.secondFactor.off': "غير مفعّل",
    'screen.identity.people.action.reset_second_factor': "إعادة تعيين الدخول بخطوتين",
    'screen.identity.member.lede': "من هو هنا، وما يُسمح له به ولماذا، وأين هو مسجّل الدخول، وما فعله.",
    'screen.identity.member.title': "المستخدم",
    'screen.identity.people.action.add.field.email': "البريد الإلكتروني",
    'screen.identity.people.action.add.field.email.help': "إن كان لهذا البريد حساب في مساحة أخرى يُضاف كما هو ويبقى بكلمة مروره.",
    'screen.identity.people.action.add.field.job_title': "المسمّى الوظيفي",
    'screen.identity.people.action.add.field.name': "الاسم",
    'screen.identity.people.action.add.field.roles': "الأدوار",
    'screen.identity.people.action.add.field.roles.help': "إن لم يُحدَّد شيء يُمنح دور الموظّف. تُولَّد كلمة مرور مؤقتة تُعرض لك مرة واحدة، وتغييرها إلزامي عند أول دخول.",
    'screen.identity.people.action.add.reveal.email': "البريد الإلكتروني",
    'screen.identity.people.action.add.reveal.temporary_password': "كلمة المرور المؤقتة",
    'screen.identity.people.action.end_sessions': "إنهاء كل الجلسات",
    'screen.identity.people.action.open': "فتح",
    'screen.identity.people.action.reset_password': "إعادة تعيين كلمة المرور",
    'screen.identity.people.action.reset_password.reveal.email': "البريد الإلكتروني",
    'screen.identity.people.action.reset_password.reveal.temporary_password': "كلمة المرور المؤقتة",
    'value.roles.admin': "المدير",
    'value.roles.employee': "موظّف",
    'value.roles.member': "عضو",
    'value.roles.owner': "المالك",
    // hr · performance
    "value.band.exceeds": "يفوق المتوقَّع",
    "value.band.meets": "يحقّق المتوقَّع",
    "value.band.needs_improvement": "يحتاج إلى تحسين",
    "value.band.outstanding": "ممتاز",
    "value.band.unsatisfactory": "غير مُرضٍ",
    "value.recommendation.confirm": "التثبيت في الوظيفة",
    "value.recommendation.extend": "تمديد فترة التجربة",
    "value.recommendation.terminate": "الإنهاء خلال فترة التجربة",
    "value.review_kind.periodic": "تقييم دوري",
    "value.review_kind.probation": "تقييم فترة التجربة",
    "value.scope_kind.all": "جميع من هم على رأس العمل",
    "value.scope_kind.department": "إدارة",
    "value.scope_kind.position": "مسمّى وظيفي",
    "value.stage.calibration": "معايرة الموارد البشرية",
    "value.stage.final": "نهائي",
    "value.stage.manager": "تقييم المدير",
    "value.stage.objected": "معترَض عليه",
    "value.stage.self": "التقييم الذاتي",
    "value.stage.withdrawn": "مسحوب",
    "value.status.archived": "مؤرشف",
    "value.status.running": "جارية",
    "value.waiting_on.employee": "الموظّف",
    "value.waiting_on.hr": "الموارد البشرية",
    "value.waiting_on.manager": "المدير",
    // hr · onboarding — the hiring journey
    "value.how.by_owner": "يُنجزه حدث مالكه",
    "value.how.by_hand": "يُسجَّل يدوياً: لا حدث لمالكه بعد",
    "value.how.event": "أنجزه حدث مالكه",
    "value.how.route": "سجّله مالكه",
    "value.how.manual": "سُجِّل يدوياً",
    "value.stage.before_start": "قبل المباشرة",
    "value.stage.start_day": "يوم المباشرة",
    "value.stage.probation": "فترة التجربة",
    "value.stage.completed": "اكتملت",
    // hr · attendance readers (#59)
    "value.device_status.pending": "بانتظار تحديد الموقع",
    "value.device_status.faulty": "معطّل",
    "value.device_status.offline": "غير متّصل",
    "value.device_status.active": "يعمل",
    "value.device_status.retired": "غير نشط",
    "value.match.unmatched": "لا أحد",
    "value.match.explicit": "ربط يدوي",
    "value.match.numeric_part": "بأرقام من الرقم الوظيفي",
    "value.match.exact": "بالرقم الوظيفي كاملاً",
    "value.bridge_status.active": "قيد الاستخدام",
    "value.bridge_status.revoked": "مُبطَلة",
    // hr · payroll
    "value.kind.main": "المسيّر الرئيسي",
    "value.kind.supplementary": "مسيّر إضافي",
    "value.kind.settlement": "تسوية نهائية",
    "value.wps_file.not_generated": "لم يُولَّد",
    "value.wps_file.generated": "مولَّد",
    "value.wps_file.uploaded": "مرفوع",
    "value.wps_file.rejected": "رفضه البنك",
    "value.status.preparing": "قيد الإعداد",
    "value.status.review": "قيد المراجعة",
    "value.origin.contract": "العقد",
    "value.origin.attendance": "الحضور",
    "value.origin.leave": "الإجازات",
    "value.origin.discipline": "الجزاءات",
    "value.origin.assets": "العهد",
    "value.origin.rewards": "المكافآت",
    "value.origin.benefits": "المزايا",
    "value.origin.offboarding": "نهاية الخدمة",
    "value.origin.gosi": "التأمينات",
    "value.origin.entered": "مُدخل يدوياً",
    "value.capped.capped": "حجزه سقف",
    "value.capped.within_cap": "ضمن الحدود",
    "value.kind.earning": "استحقاق",
    "value.kind.deduction": "استقطاع",
    "value.kind.employer_cost": "تكلفة على المنشأة",
    "value.method.fixed": "مبلغ ثابت",
    "value.method.percent": "نسبة",
    "value.method.formula": "معادلة",
    "value.periodicity.monthly": "شهري",
    "value.periodicity.one_off": "مرة واحدة",
    "value.nationality.citizen": "سعودي",
    "value.nationality.non_citizen": "غير سعودي",
    "value.payment_method.bank": "تحويل بنكي (حماية الأجور)",
    "value.payment_method.cash": "نقداً",
    "value.status.details_complete": "مكتملة",
    "value.status.details_missing": "ينقصها شيء",
    "group.payroll": "الرواتب",
    // platform · export
    'list.export.format.xlsx': 'مصنّف Excel: الأرقام والمبالغ والتواريخ خلايا حقيقية، والفلاتر مكتوبة فوق الجدول، وصفّ العناوين مثبَّت',
    'list.export.format.pdf': 'تخطيط طباعة للجدول نفسه. يُفتح مربّع الطباعة في المتصفّح — اختر «حفظ بتنسيق PDF» طابعةً',
    'list.export.format.docx': 'مستند Word للجدول نفسه، والفلاتر مكتوبة فوقه، على مقاس الورق المحدّد للشاشة، ومن اليمين إلى اليسار للعربية',
    'list.export.print': 'فتح عرض الطباعة',
    'export.hijri': 'هجري',
    'export.sort.asc': 'تصاعدي',
    'export.sort.desc': 'تنازلي',
    'export.meta.filters': 'الفلاتر',
    'export.meta.filters.none': 'لا شيء — كل الصفوف',
    'export.meta.sort': 'الترتيب',
    'export.meta.rows': 'الصفوف',
    'export.meta.at': 'تاريخ التصدير',
    'export.meta.by': 'صدَّره',
    'export.meta.by.unknown': 'غير مسجَّل',
    // platform · notifications
    "notifications.unread": "{n} غير مقروء",
    "notifications.criticalOpen": "{n} حرج — بانتظار إقرارك باستلامه",
    "notifications.readAll": "تعليم الكل كمقروء",
    "notifications.markRead": "تعليم كمقروء",
    "notifications.acknowledge": "إقرار بالاستلام",
    "notifications.announcement": "إعلان",
    "notifications.unavailable": "تعذّر جلب التنبيهات الآن.",
    "notifications.emptyHint": "هنا يظهر ما تُبلغك به مساحة العمل.",
    "nav.notifications.rules": "قواعد التنبيه",
    "nav.notifications.deliveries": "سجل التنبيهات",
    "nav.notifications.announcements": "الإعلانات",
    "nav.notifications.receipts": "إيصالات القراءة",
    "value.importance.info": "للعلم",
    "value.importance.warning": "يستدعي الانتباه",
    "value.importance.critical": "حرج — يلزم الإقرار",
    "value.stage.primary": "التبليغ الأول",
    "value.stage.escalation": "تصعيد",
    "value.progress.delivered": "لم يُقرأ بعد",
    "value.progress.pending": "قيد الإرسال",
    "value.progress.sent": "أُرسل",
    "value.progress.failed": "تعذّر الإرسال",
    "value.progress.read": "مقروء",
    "value.progress.awaiting_ack": "بانتظار الإقرار",
    "value.progress.acknowledged": "تم الإقرار",
    "value.channel.in_app": "داخل التطبيق",
    "value.channel.email": "البريد الإلكتروني",
    "value.channel.whatsapp": "واتساب",
    "value.channel.sms": "رسالة نصية",
    "value.channel.portal": "البوابة",
    "value.publication.draft": "مسوّدة",
    "value.publication.published": "منشور",
    "value.publication.withdrawn": "مسحوب",
    "value.audience.all": "جميع أعضاء مساحة العمل",
    "value.audience.roles": "أدوار محدّدة",
    "value.receipt.read": "مقروء",
    "value.receipt.unread": "لم يُقرأ بعد",
    "notifications.refusal.required": "الحقل {field} مطلوب.",
    "notifications.refusal.too_long": "بحدّ أقصى {max} حرفًا.",
    "notifications.refusal.stale": "عدّله شخص آخر منذ فتحته. أعد فتحه وحاول مجددًا.",
    "notifications.refusal.identity_forbidden": "تحديد المستلمين بالأدوار يتطلب صلاحية الاطلاع على أدوار مساحة العمل.",
    "notifications.refusal.identity_unavailable": "تعذّر التحقق من الأدوار الآن. حاول بعد قليل.",
    "notifications.refusal.email_not_configured": "البريد غير مُعدّ في هذا التنصيب، فالرابط يُرسل يدوياً.",
    "notifications.refusal.no_link": "عنوان التطبيق غير مضبوط (SHELL_ORIGINS)، فلا رابط يُرسل.",
    "notifications.refusal.portal_invitation.no_channel": "لا يمكن الوصول إلى بريد هذا الطرف ولا إلى جواله عبر قناة مهيّأة هنا، فالرابط يُرسل يدوياً.",
    "notifications.refusal.portal.no_party": "جلسة البوابة هذه لا تحدّد طرفًا. سجّل الدخول من جديد.",
    "notifications.portal.feed": "الإشعارات",
    "activity.event.identity.portal.invited": "دُعي إلى البوابة",
    "notifications.refusal.invitation.not_found": "لم تعد هذه الدعوة قابلة للقبول: قُبلت أو سُحبت أو أُعيد إصدارها أو انتهت.",
    "notifications.refusal.invitation.identity_forbidden": "لم تُقبل جلستك لهذه الدعوة. سجّل الدخول من جديد وحاول مرة أخرى.",
    "notifications.refusal.invitation.identity_unavailable": "تعذّر التحقق من الدعوة الآن. حاول بعد قليل.",
    "notifications.refusal.rule.event_shape": "يُكتب اسم الحدث بكلمات لاتينية صغيرة تفصلها نقاط، مثل leave.approved.",
    "notifications.refusal.rule.own_event": "لا يمكن لقاعدة أن تستمع لأحداث وحدة التنبيهات نفسها.",
    "notifications.refusal.rule.no_roles": "اختر دورًا واحدًا على الأقل لإبلاغه، أو سمِّ الشخص الذي يسمّيه الحدث.",
    "notifications.refusal.rule.role_shape": "\"{value}\" ليس دورًا.",
    "notifications.refusal.rule.unknown_role": "لا يوجد في مساحة العمل دور باسم \"{value}\".",
    "notifications.refusal.rule.importance": "اختر: للعلم، أو يستدعي الانتباه، أو حرج.",
    "notifications.refusal.rule.no_channels": "اختر قناة واحدة على الأقل.",
    "notifications.refusal.rule.channel_shape": "\"{value}\" ليست قناة.",
    "notifications.refusal.rule.channel_unavailable": "القناة {value} غير مهيّأة في هذا التثبيت.",
    "notifications.refusal.rule.critical_needs_app": "يُقَرّ بالتنبيه الحرج داخل التطبيق، فلا بد أن يُرسل إليه أيضًا.",
    "notifications.refusal.rule.escalation_pair": "التصعيد يحتاج إلى مهلة وإلى الأدوار التي تُبلَّغ معًا.",
    "notifications.refusal.rule.escalation_not_critical": "لا يُصعَّد إلا التنبيه الحرج.",
    "notifications.refusal.rule.escalation_minutes": "بين {min} و{max} دقيقة.",
    "notifications.refusal.rule.condition_shape": "السطر {line}: اكتب الحقل = القيمة.",
    "notifications.refusal.rule.condition_twice": "السطر {line}: الحقل {field} مذكور من قبل.",
    "notifications.refusal.rule.too_many_conditions": "بحدّ أقصى {max} شروط.",
    "notifications.refusal.rule.not_found": "لا توجد هذه القاعدة.",
    "notifications.refusal.rule.already_retired": "هذه القاعدة غير نشطة أصلًا.",
    "notifications.refusal.rule.already_active": "هذه القاعدة مفعّلة أصلًا.",
    "notifications.refusal.delivery.not_found": "لا يوجد لك هذا التنبيه.",
    "notifications.refusal.delivery.not_critical": "لا يُقَرّ إلا بالتنبيه الحرج؛ هذا يكفي أن يُقرأ.",
    "notifications.refusal.delivery.already_acknowledged": "سبق أن أقررت باستلام هذا التنبيه.",
    "notifications.refusal.announcement.audience": "أرسله إلى الجميع أو إلى أدوار محدّدة.",
    "notifications.refusal.announcement.roles_for_all": "الإعلان الموجّه للجميع لا يُحدَّد له أدوار.",
    "notifications.refusal.announcement.not_found": "لا يوجد هذا الإعلان.",
    "notifications.refusal.announcement.withdrawn": "الإعلان المسحوب لا يُعدَّل؛ اكتب إعلانًا جديدًا.",
    "notifications.refusal.announcement.not_draft": "لا يُنشر إلا ما كان مسوّدة.",
    "notifications.refusal.announcement.not_published": "لا يُسحب إلا الإعلان المنشور.",
    "notifications.refusal.announcement.comments_allowed": "حدّد هل يُسمح بالتعليق: نعم أو لا.",
    "notifications.refusal.announcement.comments_closed": "التعليق غير متاح على هذا الإعلان.",
    "notifications.refusal.reaction.kind": "التفاعل إعجاب أو تهنئة أو شكر.",
    "notifications.refusal.thanks.not_a_member": "لا يُشكر إلا عضو في مساحة العمل هذه.",
    "notifications.refusal.thanks.to_self": "لا يمكنك شكر نفسك.",
    "notifications.refusal.thanks.public": "حدّد هل يراه الجميع: نعم أو لا.",
    "notifications.refusal.chat.not_a_member": "لا يُراسَل إلا عضو في مساحة العمل هذه.",
    "notifications.refusal.chat.to_self": "لا يمكنك مراسلة نفسك.",
    "notifications.refusal.chat.not_found": "لا توجد هذه المحادثة.",
    "notifications.refusal.chat.before": "ابدأ من رسالة في هذه المحادثة.",
    "notifications.refusal.chat.limit": "اطلب من 1 إلى 100 رسالة.",
    "notifications.refusal.chat.key_reused": "هذا الطلب استُعمل لرسالة في محادثة أخرى.",
    "notifications.refusal.chat.retention": "تبقى رسائل المحادثات ظاهرة من 30 يومًا إلى عشر سنوات.",
    "notifications.refusal.chat.pinned": "حدّد هل المحادثة مثبّتة: نعم أو لا.",
    "notifications.refusal.chat.mute": "اكتم إلى وقت محدد، أو إلى أن تلغي الكتم — لا كليهما.",
    "notifications.refusal.chat.mute_until": "اكتم إلى وقت بين الآن وسنة من الآن.",
    "notifications.refusal.push.token": "هذا ليس رمز إشعارات أعطاه الهاتف.",
    "notifications.refusal.push.platform": "الهاتف أندرويد أو iOS.",
    "notifications.refusal.push.device_id": "هذا ليس معرّف التطبيق لهذا الهاتف.",
    "notifications.refusal.post.not_found": "لا يوجد هذا المنشور.",
    "notifications.refusal.post.not_yours": "لا يسحب المنشور إلا كاتبه أو من يدير الإعلانات.",
    "notifications.refusal.post.not_a_poll": "هذا المنشور ليس استطلاعًا.",
    "notifications.refusal.post.before": "ابدأ من منشور في الأخبار.",
    "notifications.refusal.post.limit": "اطلب من 1 إلى 50 منشورًا.",
    "notifications.refusal.poll.shape": "الاستطلاع إجاباته، وموعد إغلاقه، ومتى تظهر نتائجه.",
    "notifications.refusal.poll.options": "للاستطلاع من 2 إلى 6 إجابات.",
    "notifications.refusal.poll.option_text": "كل إجابة من حرف إلى 200 حرف.",
    "notifications.refusal.poll.duplicate": "إجابتان متطابقتان.",
    "notifications.refusal.poll.closes_at": "يُغلق الاستطلاع بعد 5 دقائق على الأقل و90 يومًا على الأكثر.",
    "notifications.refusal.poll.results": "تظهر النتائج دائمًا، أو بعد التصويت، أو بعد إغلاق الاستطلاع.",
    "notifications.refusal.poll.closed": "أُغلق هذا الاستطلاع.",
    "notifications.refusal.poll.option": "اختر إحدى إجابات الاستطلاع.",
    "notifications.refusal.poll.already_voted": "صوّتَّ في هذا الاستطلاع من قبل.",
    "screen.notifications.rules.title": "قواعد التنبيه",
    "screen.notifications.rules.lede": "عند وقوع حدث: من يُبلَّغ، وبأي قناة، وبأي درجة أهمية. أي تعديل هنا يسري على الحدث التالي دون أي تطوير.",
    "screen.notifications.rules.stat.active": "مفعّلة",
    "screen.notifications.rules.stat.critical": "حرجة",
    "screen.notifications.rules.stat.critical.detail": "تبقى مفتوحة حتى الإقرار",
    "screen.notifications.rules.stat.retired": "غير نشطة",
    "screen.notifications.rules.column.name": "القاعدة",
    "screen.notifications.rules.column.event_name": "عند",
    "screen.notifications.rules.column.roles": "تُبلِّغ",
    "screen.notifications.rules.column.channels": "القنوات",
    "screen.notifications.rules.column.importance": "الأهمية",
    "screen.notifications.rules.column.escalate_after_minutes": "التصعيد بعد (دقيقة)",
    "screen.notifications.rules.column.alerts": "تنبيهات صدرت",
    "screen.notifications.rules.column.last_alert_at": "آخر تنبيه",
    "screen.notifications.rules.column.status": "الحالة",
    "screen.notifications.rules.column.condition_text": "الشروط",
    "screen.notifications.rules.column.escalate_to": "التصعيد إلى",
    "screen.notifications.rules.column.id": "المعرّف",
    "screen.notifications.rules.action.create": "قاعدة جديدة",
    "screen.notifications.rules.action.edit": "تعديل",
    "screen.notifications.rules.action.retire": "إيقاف",
    "screen.notifications.rules.action.restore": "تفعيل",
    "screen.notifications.rules.field.name": "الاسم",
    "screen.notifications.rules.field.name.help": "ما يقرؤه المستلم في جرس التنبيهات، مثل: اعتُمدت الإجازة.",
    "screen.notifications.rules.field.event_name": "عند وقوع",
    "screen.notifications.rules.field.conditions": "فقط عندما",
    "screen.notifications.rules.field.conditions.help": "اختياري. كل صف حقلٌ من بيانات الحدث والقيمة المطلوبة له. يجب أن تتحقق الصفوف كلها.",
    "screen.notifications.rules.field.roles": "أبلِغ هذه الأدوار",
    "screen.notifications.rules.field.channels": "القنوات",
    "screen.notifications.rules.field.channels.help": "تظهر القنوات كلّها. القناة غير المفعّلة بعد في هذه المساحة يُذكر ذلك بجانبها: تبقى في القاعدة، وتُسجَّل رسائلها غير مُرسلة، وتبدأ حين تُفعَّل.",
    "screen.notifications.rules.field.importance": "الأهمية",
    "screen.notifications.rules.field.escalate_after_minutes": "التصعيد بعد (دقائق)",
    "screen.notifications.rules.field.escalate_after_minutes.help": "للحرج فقط. إن تُرك فارغًا فلا تصعيد.",
    "screen.notifications.rules.field.escalate_to": "التصعيد إلى",
    "screen.notifications.deliveries.title": "سجل التنبيهات",
    "screen.notifications.deliveries.lede": "من أُبلِغ، وبماذا، وبأي قناة — وهل اطّلع، ومن أقرّ بالتنبيه الحرج ومتى. آخر 500 تبليغ.",
    "screen.notifications.deliveries.column.created_at": "وقت التبليغ",
    "screen.notifications.deliveries.column.rule_name": "التنبيه",
    "screen.notifications.deliveries.column.recipient": "المستلم",
    "screen.notifications.deliveries.column.channel": "القناة",
    "screen.notifications.deliveries.column.importance": "الأهمية",
    "screen.notifications.deliveries.column.progress": "الحالة",
    "screen.notifications.deliveries.column.read_at": "قُرئ",
    "screen.notifications.deliveries.column.acknowledged_at": "أُقِرّ",
    "screen.notifications.deliveries.column.acknowledged_by_email": "المُقِرّ",
    "screen.notifications.deliveries.column.stage": "المرحلة",
    "screen.notifications.deliveries.column.escalated_at": "صُعِّد",
    "screen.notifications.deliveries.column.event_name": "الحدث",
    "screen.notifications.deliveries.column.occurred_at": "وقع في",
    "screen.notifications.deliveries.column.last_error": "ردّ مزوّد الإرسال",
    "screen.notifications.deliveries.column.event_id": "معرّف الحدث",
    "screen.notifications.deliveries.column.id": "المعرّف",
    "screen.notifications.deliveries.column.skip_reason": "لم يُرسل لأن",
    "screen.notifications.deliveries.column.provider_status": "تقرير المزوّد",
    "value.progress.skipped": "لم يُرسل",
    "value.skip_reason.no_member": "لا حساب دخول له هنا",
    "value.skip_reason.not_permitted": "لا يُسمح له بالاطلاع",
    "value.skip_reason.opted_out": "أوقف الاستلام",
    "value.skip_reason.not_opted_in": "لم يوافق على الاستلام",
    "value.skip_reason.no_address": "لا عنوان",
    "value.skip_reason.no_phone": "لا رقم واتساب",
    "value.skip_reason.template_not_approved": "القالب غير معتمد",
    "value.skip_reason.muted": "كتمه العضو",
    "value.provider_status.sent": "أُرسل",
    "value.provider_status.delivered": "وصل",
    "value.provider_status.read": "قُرئ",
    "value.provider_status.failed": "تعذّر",
    "screen.notifications.rules.field.roles.help": "أدوار، أو الشخص الذي يسمّيه الحدث، أو كلاهما. القاعدة التي لا تبلّغ أحدًا تُرفض.",
    "screen.notifications.rules.field.subject_field": "أبلِغ الشخص الذي يسمّيه الحدث",
    "screen.notifications.rules.field.subject_field.help": "اختياري. حقل الحمولة الذي يحمل معرّف الشخص — party_ref في أحداث الموارد البشرية، وowner_ref في الوثيقة. يُبلَّغ الشخص فقط إن كان يحق له الاطلاع على موضوعه.",
    "screen.notifications.rules.field.subject_permission": "فقط إن كان يحق له",
    "screen.notifications.rules.field.subject_permission.help": "مطلوب مع حقل الشخص. الصلاحية التي يجب أن يحملها الشخص، عبر أي من أدواره، ليُبلَّغ.",
    "screen.notifications.rules.column.subject_field": "أبلِغ الشخص المسمّى في",
    "screen.notifications.rules.column.subject_permission": "فقط إن كان يحق له",
    "screen.notifications.rules.column.pack": "من الحزمة",
    "screen.notifications.rules.action.import_pack": "استيراد حزمة",
    "screen.notifications.rules.field.pack": "الحزمة",
    "screen.notifications.rules.field.pack.help": "قواعد تبلّغ الشخص الذي يسمّيه الحدث، مع قوالب واتساب كمسوّدات. القاعدة المستوردة من قبل تبقى كما هي.",
    "screen.notifications.rules.field.locale": "سمِّ القواعد بـ",
    "screen.notifications.rules.field.pack_roles.help": "لحزمة تُبلِّغ أدواراً لا الشخصَ نفسه (التأخر في الاعتماد): مَن يُبلَّغ.",
    "screen.notifications.rules.field.pack_escalate_to.help": "لقاعدة حرجة في حزمة كهذه: مَن يُبلَّغ حين لا يقرّ أحدٌ بالاستلام خلال المهلة.",
    "screen.notifications.rules.field.pack_escalate_after.help": "إن تُرك فارغاً فمهلة الحزمة نفسها.",
    "value.locale.ar": "العربية",
    "value.locale.en": "الإنجليزية",
    "nav.notifications.templates": "قوالب واتساب",
    "screen.notifications.templates.title": "قوالب واتساب",
    "screen.notifications.templates.lede": "قوالب واتساب التي اعتمدتها ميتا، واحد لكل نوع إشعار ولغة.",
    "screen.notifications.templates.stat.approved": "اعتمدتها ميتا",
    "screen.notifications.templates.stat.waiting": "لا تُرسل بعد",
    "screen.notifications.templates.stat.waiting.detail": "مسوّدة أو مقدّمة أو مرفوضة أو موقوفة",
    "screen.notifications.templates.column.kind": "الإشعار",
    "screen.notifications.templates.column.locale": "اللغة",
    "screen.notifications.templates.column.provider_name": "الاسم لدى ميتا",
    "screen.notifications.templates.column.language_code": "رمز اللغة لدى ميتا",
    "screen.notifications.templates.column.status": "الحالة",
    "screen.notifications.templates.column.body": "النص المقدَّم",
    "screen.notifications.templates.column.rules": "قواعد تُرسل على واتساب",
    "screen.notifications.templates.column.updated_at": "تغيّر",
    "screen.notifications.templates.column.link": "يفتح في التطبيق",
    "screen.notifications.templates.column.id": "المعرّف",
    "screen.notifications.templates.action.edit": "تسجيل جواب ميتا",
    "screen.notifications.templates.field.provider_name": "الاسم لدى ميتا",
    "screen.notifications.templates.field.provider_name.help": "كما قُدّم تمامًا: أحرف صغيرة وأرقام وشرطات سفلية.",
    "screen.notifications.templates.field.language_code": "رمز اللغة لدى ميتا",
    "screen.notifications.templates.field.status": "جواب ميتا",
    "screen.notifications.templates.field.status.help": "لا يُرسل إلا القالب المعتمد.",
    "value.template_language.ar": "العربية (ar)",
    "value.template_language.en": "الإنجليزية (en)",
    "value.template_language.en_US": "الإنجليزية الأمريكية (en_US)",
    "value.template_language.en_GB": "الإنجليزية البريطانية (en_GB)",
    "value.template_status.draft": "لم يُقدَّم بعد",
    "value.template_status.submitted": "قُدّم وبانتظار المراجعة",
    "value.template_status.approved": "معتمد — يُرسل",
    "value.template_status.rejected": "مرفوض",
    "value.template_status.paused": "أوقفته ميتا",
    "notifications.refusal.rule.subject_shape": "«{value}» ليس حقلًا في حمولة الحدث.",
    "notifications.refusal.rule.permission_without_subject": "الصلاحية تُطلب من الشخص الذي يسمّيه الحدث، وهذه القاعدة لا تسمّي أحدًا.",
    "notifications.refusal.rule.subject_needs_permission": "حدّد ما يجب أن يحق للشخص الاطلاع عليه ليُبلَّغ.",
    "notifications.refusal.rule.permission_shape": "«{value}» ليس مفتاح صلاحية.",
    "notifications.refusal.consent.channel": "الجرس يبقى دائمًا، وواتساب يُختار في سجل شخصك؛ هنا اختر البريد أو الرسائل النصية.",
    "notifications.refusal.consent.choice": "قل نعم أو لا.",
    "notifications.refusal.template.name_shape": "يُسمّى قالب واتساب بأحرف صغيرة وأرقام وشرطات سفلية.",
    "notifications.refusal.template.language_shape": "رمز لغة كما تكتبه ميتا: ar أو en أو en_US.",
    "notifications.refusal.template.status": "حالة تعطيها ميتا: مقدّم أو معتمد أو مرفوض أو موقوف.",
    "notifications.refusal.template.not_found": "لا يوجد قالب بهذا المعرّف.",
    "notifications.refusal.pack.unknown": "لا تشحن هذه النسخة حزمة باسم «{value}»، ولا تشحنها وصفةً وحدةٌ مفعّلة في مساحة العمل هذه.",
    "notifications.refusal.pack.nothing": "الوصفة «{value}» لا تشحن شيئًا للإشعارات: قواعد الأتمتة فيها تُستورد من الأتمتة.",
    "notifications.refusal.recipe.identity_forbidden": "لم تسمح لك الهوية بمعرفة الوحدات المفعّلة في مساحة العمل هذه.",
    "notifications.refusal.recipe.identity_unavailable": "تعذّر على الهوية أن تقول أي الوحدات مفعّلة في مساحة العمل هذه. حاول بعد قليل.",
    "notifications.refusal.permissions_unavailable": "تعذّر التحقق من الصلاحيات الآن. حاول بعد قليل.",
    "notifications.refusal.rule.unknown_permission": "لا توجد وحدة تعرّف الصلاحية «{value}».",
    "notifications.refusal.pack.invalid": "الحزمة «{value}» غير سليمة ولا يمكن استيرادها. أبلغ فريق المنتج.",
    "notifications.refusal.workspace.id": "هذه ليست مساحة عمل.",
    "notifications.refusal.workspace.demo": "اختر هل مساحة العمل تجريبية أم لا.",
    "notifications.refusal.connection.demo_only": "الربط التجريبي لا يرسل شيئًا، ولا يُتاح إلا لمساحة عمل علّمتها المنصّة تجريبية.",
    "webhooks.refusal.required": "الحقل {field} مطلوب.",
    "webhooks.refusal.too_long": "بحدّ أقصى {max} حرفًا.",
    "webhooks.refusal.event_shape": "«{value}» ليس اسم حدث.",
    "webhooks.refusal.own_event": "لا يرسل الويب هوك أحداث وحدة الويب هوك نفسها.",
    "webhooks.refusal.url": "هذا ليس عنوان ويب.",
    "webhooks.refusal.url_https": "تُرسل الأحداث عبر https فقط.",
    "webhooks.refusal.url_credentials": "احذف اسم المستخدم وكلمة المرور من العنوان: التوقيع يثبت من المرسل.",
    "webhooks.refusal.url_host": "اذكر الخادم باسمه لا برقمه.",
    "webhooks.refusal.url_not_allowed": "{value} ليس من الخوادم التي ترسل إليها هذه المنصّة الويب هوك.",
    "webhooks.refusal.condition_shape": "اكتب شرطًا في كل سطر: الحقل = القيمة.",
    "webhooks.refusal.condition_twice": "«{value}» مذكور مرتين.",
    "webhooks.refusal.too_many_conditions": "بحدّ أقصى {max} شروط.",
    "webhooks.refusal.disable_after": "بين {min} و{max} إخفاقًا متتاليًا.",
    "webhooks.refusal.version": "افتح الويب هوك من جديد ثم أعد المحاولة.",
    "webhooks.refusal.stale": "غيّره شخص آخر منذ فتحته. افتحه من جديد.",
    "webhooks.refusal.not_found": "هذا الويب هوك ليس في مساحة العمل هذه.",
    "webhooks.refusal.delivery_not_found": "هذا الإرسال ليس في مساحة العمل هذه.",
    "webhooks.refusal.delivery_not_failed": "لا يُعاد إلا إرسال أخفق.",
    "webhooks.refusal.retired": "هذا الويب هوك موقوف ولا يُعدَّل.",
    "webhooks.refusal.not_active": "لا يُعلَّق إلا ويب هوك مفعّل.",
    "webhooks.refusal.too_many": "بحدّ أقصى {max} ويب هوك في مساحة العمل: أوقف واحدًا أولًا.",
    "webhooks.refusal.no_key": "لا تملك هذه المنصّة مفتاحًا تختم به مفتاح توقيع الويب هوك. يضبطه المشغّل.",
    "notifications.refusal.webhook.handshake": "ليس رمز التحقق الذي ضبطته هذه المنشأة.",
    "notifications.refusal.webhook.signature": "التوقيع لا يتحقق.",
    "screen.notifications.announcements.title": "الإعلانات",
    "screen.notifications.announcements.lede": "رسالة إلى الجميع أو إلى أدوار محدّدة، تظهر في جرس كل مستلم. تعديل إعلان منشور يُنشئ إصدارًا جديدًا يقرؤه الجميع من جديد.",
    "screen.notifications.announcements.stat.published": "منشورة",
    "screen.notifications.announcements.stat.draft": "مسوّدات",
    "screen.notifications.announcements.column.title": "العنوان",
    "screen.notifications.announcements.column.audience": "الجمهور",
    "screen.notifications.announcements.column.roles": "الأدوار",
    "screen.notifications.announcements.column.version": "الإصدار",
    "screen.notifications.announcements.column.recipients": "أُرسل إلى",
    "screen.notifications.announcements.column.read": "قرأه",
    "screen.notifications.announcements.column.published_at": "تاريخ النشر",
    "screen.notifications.announcements.column.publication": "الحالة",
    "screen.notifications.announcements.column.body": "النص",
    "screen.notifications.announcements.column.id": "المعرّف",
    "screen.notifications.announcements.action.create": "إعلان جديد",
    "screen.notifications.announcements.action.edit": "تعديل",
    "screen.notifications.announcements.action.publish": "نشر",
    "screen.notifications.announcements.action.withdraw": "سحب",
    "screen.notifications.announcements.field.title": "العنوان",
    "screen.notifications.announcements.field.body": "النص",
    "screen.notifications.announcements.field.body.help": "تعديل إعلان منشور يعيد إرساله إصدارًا جديدًا.",
    "screen.notifications.announcements.field.audience": "إلى",
    "screen.notifications.announcements.field.roles": "الأدوار",
    "screen.notifications.announcements.field.roles.help": "فقط عند توجيهه إلى أدوار محدّدة.",
    "screen.notifications.announcements.field.comments_allowed": "يُسمح للأعضاء بالتعليق",
    "screen.notifications.receipts.title": "إيصالات القراءة",
    "screen.notifications.receipts.lede": "كل من وصله الإصدار الحالي من كل إعلان، وهل قرأه.",
    "screen.notifications.receipts.stat.read": "مقروءة",
    "screen.notifications.receipts.stat.unread": "لم تُقرأ بعد",
    "screen.notifications.receipts.column.title": "الإعلان",
    "screen.notifications.receipts.column.version": "الإصدار",
    "screen.notifications.receipts.column.recipient": "المستلم",
    "screen.notifications.receipts.column.delivered_at": "أُرسل",
    "screen.notifications.receipts.column.read_at": "قُرئ",
    "screen.notifications.receipts.column.receipt": "الإيصال",
    "screen.notifications.receipts.column.publication": "الحالة",
    "screen.notifications.receipts.column.id": "المعرّف",
    // platform · calendar
    "nav.calendar.year": "عرض السنة",
    "nav.calendar.settings": "إعدادات التقويم",
    "screen.calendar.occasions.stat.withdrawn": "مسحوبة",
    "screen.calendar.occasions.column.hijri_to": "إلى (هجري)",
    "screen.calendar.occasions.column.pack": "من الحزمة",
    "screen.calendar.occasions.column.location_ref": "الموقع",
    "screen.calendar.occasions.column.can_approve": "يمكن اعتمادها",
    "screen.calendar.occasions.column.can_withdraw": "يمكن سحبها",
    "screen.calendar.occasions.action.import": "استيراد سنة",
    "screen.calendar.occasions.action.import.field.pack": "الحزمة",
    "screen.calendar.occasions.action.import.field.year": "السنة",
    "screen.calendar.occasions.action.import.field.year.help": "السنة الميلادية. يصل كل تاريخ بانتظار الاعتماد محسوباً من الجدول: طابِقه مع الإعلان قبل أن يعتمده شخص آخر.",
    "screen.calendar.occasions.action.withdraw.field.reason.help": "يُحفظ مع المناسبة ويُرسل إلى كل مديول قرأ تواريخها.",
    "screen.calendar.settings.title": "إعدادات التقويم",
    "screen.calendar.settings.section.dates": "التواريخ والوقت",
    "screen.calendar.settings.section.dates.lede": "كيف يُحوَّل التاريخ الهجري ويُعرض، وأي يوم هو «اليوم».",
    "screen.calendar.settings.section.workweek": "أسبوع العمل",
    "screen.calendar.settings.section.workweek.lede": "أيام الراحة، والساعات التي يمتد فيها يوم العمل.",
    "screen.calendar.settings.lede": "كيف تُحوَّل التواريخ الهجرية وتُعرض، وبأيّ منطقة زمنية تُعدّ الأيام.",
    "screen.calendar.settings.column.hijri_reference": "مرجع التحويل الهجري",
    "screen.calendar.settings.column.hijri_display": "التاريخ الهجري في الشاشات",
    "screen.calendar.settings.column.time_zone": "المنطقة الزمنية",
    "screen.calendar.settings.column.today": "اليوم هناك",
    "screen.calendar.settings.column.version": "الإصدار",
    "screen.calendar.settings.action.edit": "تغيير",
    "screen.calendar.settings.field.hijri_reference": "مرجع التحويل الهجري",
    "screen.calendar.settings.field.hijri_reference.help": "يُستعمل حين يُحوَّل تاريخ: استيراد حزمة، ومناسبة كُتبت بلا تاريخها الهجري، وعرض السنة.",
    "screen.calendar.settings.field.hijri_display": "التاريخ الهجري في الشاشات",
    "screen.calendar.settings.field.time_zone": "المنطقة الزمنية",
    "screen.calendar.settings.field.time_zone.help": "يحدّد أيّ يوم هو «اليوم» لكل تاريخ في مساحة العمل.",
    "screen.calendar.year.title": "عرض السنة",
    "screen.calendar.year.lede": "السنة شهراً شهراً، كلٌّ بالأشهر الهجرية التي يمتدّ عليها، وكل مناسبة فيها — معتمدة، أو ما زالت تنتظر من يعتمدها.",
    "value.hijri_reference.umm_al_qura": "جدول أم القرى",
    "value.hijri_reference.tabular": "التقويم الحسابي",
    "value.hijri_display.inline": "بجانب التاريخ الميلادي",
    "value.hijri_display.tooltip": "عند المرور فقط",
    "value.kind.ramadan": "رمضان",
    "value.kind.eid_fitr": "عيد الفطر",
    "value.kind.eid_adha": "عيد الأضحى",
    "value.kind.national_day": "اليوم الوطني",
    "value.kind.founding_day": "يوم التأسيس",
    "value.kind.season": "موسم محلي",
    "value.kind.custom": "أخرى",
    "value.scope.all": "المساحة كلها",
    "value.scope.location": "موقع واحد",
    "calendar.hijri.month.1": "محرّم",
    "calendar.hijri.month.2": "صفر",
    "calendar.hijri.month.3": "ربيع الأول",
    "calendar.hijri.month.4": "ربيع الآخر",
    "calendar.hijri.month.5": "جمادى الأولى",
    "calendar.hijri.month.6": "جمادى الآخرة",
    "calendar.hijri.month.7": "رجب",
    "calendar.hijri.month.8": "شعبان",
    "calendar.hijri.month.9": "رمضان",
    "calendar.hijri.month.10": "شوّال",
    "calendar.hijri.month.11": "ذو القعدة",
    "calendar.hijri.month.12": "ذو الحجة",
    "calendar.year.previous": "السنة السابقة",
    "calendar.year.next": "السنة التالية",
    "calendar.year.title_of": "سنة {year}",
    "calendar.year.approved_count": "معتمدة: {n}",
    "calendar.year.proposed_count": "بانتظار الاعتماد: {n}",
    "calendar.year.this_month": "هذا الشهر",
    "calendar.year.month_empty": "لا مناسبات.",
    "calendar.year.empty.title": "لا شيء مخطّط لهذه السنة",
    "calendar.year.empty.description": "استورد السنة من حزمة في شاشة المناسبات، أو أضف مناسبة هناك. تصل كلٌّ منها بانتظار الاعتماد.",
    "calendar.year.location": "في {ref} فقط",
    "calendar.year.status.proposed": "بانتظار الاعتماد",
    "calendar.year.status.approved": "معتمدة",
    "platform.refusal.calendar.required": "هذا الحقل مطلوب.",
    "platform.refusal.calendar.too_long": "أطول من {max} حرفاً.",
    "platform.refusal.calendar.key_shape": "المفتاح حروف لاتينية صغيرة وأرقام وشرطة أو شرطة سفلية، ويبدأ بحرف.",
    "platform.refusal.calendar.key_taken": "هذا المفتاح لمناسبة موجودة في هذه المساحة.",
    "platform.refusal.calendar.kind": "اختر نوعاً من الأنواع المعروضة.",
    "platform.refusal.calendar.day": "اكتب اليوم بالصيغة YYYY-MM-DD، ويوماً موجوداً.",
    "platform.refusal.calendar.hijri_day": "اكتب التاريخ الهجري بالصيغة YYYY-MM-DD، الشهر من 1 إلى 12 واليوم من 1 إلى 30.",
    "platform.refusal.calendar.range": "لا يكون اليوم الأخير قبل الأول.",
    "platform.refusal.calendar.span": "لا تزيد المناسبة على {max} يوماً.",
    "platform.refusal.calendar.range_too_wide": "اطلب {max} يوماً على الأكثر في المرة الواحدة.",
    "platform.refusal.calendar.scope": "تخصّ المساحة كلها أو موقعاً واحداً.",
    "platform.refusal.calendar.location_needed": "مناسبة موقع واحد تسمّي ذلك الموقع.",
    "platform.refusal.calendar.location_not_allowed": "مناسبة المساحة كلها لا تسمّي موقعاً.",
    "platform.refusal.calendar.time_zone": "ليست منطقة زمنية يعرفها الخادم. استعمل اسماً مثل Africa/Cairo، أو UTC.",
    "platform.refusal.calendar.reference": "اختر جدول أم القرى أو التقويم الحسابي.",
    "platform.refusal.calendar.display": "اختر بجانب التاريخ، أو عند المرور فقط.",
    "platform.refusal.calendar.language": "اختر العربية أو الإنجليزية.",
    "platform.refusal.calendar.year": "هذه السنة خارج السنوات التي يغطيها هذا التقويم.",
    "platform.refusal.calendar.pack": "لا توجد حزمة بهذا الاسم في هذا التثبيت.",
    "platform.refusal.calendar.already_approved": "هذه المناسبة معتمدة من قبل.",
    "platform.refusal.calendar.withdrawn": "سُحبت هذه المناسبة. عدّلها لتقترحها من جديد.",
    "platform.refusal.calendar.own_proposal": "من اقترح هذه التواريخ لا يعتمدها. يعتمدها معتمِد آخر.",
    "platform.refusal.calendar.stale": "تغيّرت الإعدادات منذ فتحتها. أعد التحميل وحاول مجدداً.",
    "platform.refusal.calendar.not_found": "لا توجد مناسبة كهذه هنا.",
    // platform · forms — the form builder, and the shared field validator (packages/fields)
    "nav.module.forms": "النماذج",
    "nav.forms.my_requests": "طلباتي",
    "nav.forms.requests": "الطلبات",
    "nav.forms.catalogue": "نماذج الطلبات",
    "nav.forms.builder": "منشئ النماذج",
    "screen.forms.catalogue.title": "نماذج الطلبات",
    "screen.forms.catalogue.lede": "النماذج التي بنتها مساحة العمل، لكل إصدار صفّه.",
    "screen.forms.catalogue.stat.published": "منشورة",
    "screen.forms.catalogue.stat.draft": "مسوّدات",
    "screen.forms.catalogue.stat.open_requests": "طلبات مفتوحة",
    "screen.forms.catalogue.column.name_ar": "النموذج",
    "screen.forms.catalogue.column.name_en": "الاسم بالإنجليزية",
    "screen.forms.catalogue.column.key": "المفتاح",
    "screen.forms.catalogue.column.revision": "الإصدار",
    "screen.forms.catalogue.column.status": "الحالة",
    "screen.forms.catalogue.column.audience": "موجّه إلى",
    "screen.forms.catalogue.column.fields": "الحقول",
    "screen.forms.catalogue.column.steps": "الخطوات",
    "screen.forms.catalogue.column.open_requests": "مفتوحة",
    "screen.forms.catalogue.column.published_at": "نُشر",
    "screen.forms.catalogue.column.category": "الفئة",
    "screen.forms.catalogue.column.updated_at": "آخر تعديل",
    "screen.forms.catalogue.column.can_publish": "قابل للنشر",
    "screen.forms.catalogue.column.can_revise": "قابل للتعديل بإصدار جديد",
    "screen.forms.catalogue.column.can_archive": "قابل للإغلاق",
    "screen.forms.catalogue.column.id": "المعرّف",
    "screen.forms.catalogue.action.create": "نموذج جديد",
    "screen.forms.catalogue.action.create.field.key": "المفتاح",
    "screen.forms.catalogue.action.create.field.key.help": "حروف لاتينية صغيرة وأرقام وشرطة سفلية. لا يتغيّر أبداً: المديول الذي يعمل على اعتمادات هذا النموذج يتعرّف عليه به.",
    "screen.forms.catalogue.action.create.field.name_ar": "الاسم بالعربية",
    "screen.forms.catalogue.action.create.field.name_en": "الاسم بالإنجليزية",
    "screen.forms.catalogue.action.builder": "افتح المنشئ",
    "screen.forms.catalogue.action.publish": "انشر",
    "screen.forms.catalogue.action.revise": "عدّل بإصدار جديد",
    "screen.forms.catalogue.action.archive": "أغلق أمام الطلبات الجديدة",
    "screen.forms.requests.title": "الطلبات",
    "screen.forms.requests.lede": "كل طلب قُدِّم عبر نموذج مبنيّ، وما ينتظر قرارك أولاً. افتح الطلب لتقرأه كما قُدِّم وتقرّر خطوتك.",
    "screen.forms.requests.stat.mine_to_decide": "بانتظارك",
    "screen.forms.requests.stat.overdue": "تجاوزت مهلتها",
    "screen.forms.requests.stat.sent_back": "لدى مقدّم الطلب",
    "screen.forms.requests.stat.approved": "معتمدة",
    "screen.forms.requests.column.number": "الرقم",
    "screen.forms.requests.column.form_ar": "النموذج",
    "screen.forms.requests.column.status": "الحالة",
    "screen.forms.requests.column.step_ar": "بانتظار",
    "screen.forms.requests.column.submitted_by": "مقدّم الطلب",
    "screen.forms.requests.column.submitted_at": "قُدِّم",
    "screen.forms.requests.column.due_at": "القرار قبل",
    "screen.forms.requests.column.decided_at": "تقرّر",
    "screen.forms.requests.column.form_en": "النموذج بالإنجليزية",
    "screen.forms.requests.column.definition_key": "النموذج",
    "screen.forms.requests.column.definition_revision": "الإصدار",
    "screen.forms.requests.column.approver_role": "يقرّره دور",
    "screen.forms.requests.column.overdue": "متأخر",
    "screen.forms.requests.column.can_decide": "قرارك",
    "screen.forms.requests.column.id": "المعرّف",
    "screen.forms.requests.action.decide": "قرّر",
    "screen.forms.requests.action.open": "افتح",
    "screen.forms.builder.title": "منشئ النماذج",
    "screen.forms.builder.lede": "الأقسام والحقول في جهة، وما يطلبه الحقل المختار في الأخرى، ومسار الاعتماد تحتهما، والنموذج كما سيراه جمهوره بجانب ذلك كله.",
    "screen.forms.my_requests.title": "طلباتي",
    "screen.forms.my_requests.lede": "النماذج الموجّهة إليك، وما صار إليه كل طلب أرسلته: أين ينتظر، وماذا تقرّر، وما أُعيد إليك لتصحّحه.",
    "value.forms_request.submitted": "بانتظار القرار",
    "value.forms_request.sent_back": "أُعيد إليك",
    "value.forms_request.approved": "معتمد",
    "value.forms_request.rejected": "مرفوض",
    "value.forms_request.withdrawn": "مسحوب",
    "value.forms_definition.draft": "مسوّدة",
    "value.forms_definition.published": "منشور",
    "value.forms_definition.archived": "مؤرشف",
    "forms.ref.hint.employee_ref": "مرجع الموظّف كما يظهر في شؤون الموظّفين.",
    "forms.ref.hint.location_ref": "مرجع موقع العمل كما يظهر في شؤون الموظّفين.",
    "forms.ref.hint.attachment": "مرجع مستند محفوظ في المستندات.",
    "forms.ref.gap.employee_ref": "يُكتب مرجعاً الآن: هذه الوحدة لا تقرأ شؤون الموظّفين، وقائمة الاختيار تأتي حين تقدّم شؤون الموظّفين بحثاً تستدعيه الواجهة.",
    "forms.ref.gap.location_ref": "يُكتب مرجعاً الآن: هذه الوحدة لا تقرأ مواقع شؤون الموظّفين، وقائمة الاختيار تأتي مع بحث تقدّمه.",
    "forms.ref.gap.attachment": "مرجع مستند الآن: الرفع من داخل النموذج يأتي حين تستقبل المستندات الرفع.",
    "forms.datetime.time": "الوقت",
    "forms.yes": "نعم",
    "forms.no": "لا",
    "forms.step.by_role": "يقرّره من يحمل دور {role}",
    "forms.step.by_manager": "يقرّره مدير مقدّم الطلب",
    "forms.approver.role": "دور",
    "forms.approver.manager_of_submitter": "مدير مقدّم الطلب",
    "forms.review.no_row": "افتح طلباً من القائمة.",
    "forms.review.submitted_by": "مقدّم الطلب",
    "forms.review.submitted_at": "قُدِّم",
    "forms.review.revision": "النموذج والإصدار",
    "forms.review.may_edit": "لهذه الخطوة أن تصحّح ما قُدِّم قبل اعتماده؛ وما تغيّره يُسجَّل.",
    "forms.review.history": "ما جرى",
    "forms.review.reason": "السبب",
    "forms.review.reason.hint": "مطلوب للإعادة أو الرفض: هو ما يقرؤه مقدّم الطلب.",
    "forms.review.approve": "اعتمد",
    "forms.review.return": "أعِد لمقدّمه",
    "forms.review.reject": "ارفض",
    "forms.review.own": "قدّمت هذا الطلب، فلا تقرّر فيه.",
    "forms.history.submit": "قدّمه {actor}",
    "forms.history.resubmit": "أعاد إرساله {actor}",
    "forms.history.approve": "اعتمد {actor} الخطوة {step}",
    "forms.history.return": "أعاده {actor} في الخطوة {step}",
    "forms.history.reject": "رفضه {actor} في الخطوة {step}",
    "forms.history.withdraw": "سحبه {actor}",
    "forms.history.changed": "غيّر {fields}",
    "forms.submit": "قدّم الطلب",
    "forms.resubmit": "أعِد الإرسال",
    "forms.submit.fix": "بعض الإجابات تحتاج تصحيحاً، وكلّ منها معلَّم في مكانه.",
    "forms.submit.done": "أُرسل الطلب {number}.",
    "forms.withdraw.done": "سُحب الطلب {number}.",
    "forms.withdraw.title": "سحب الطلب {number}؟",
    "forms.withdraw.lede": "يبقى في قائمتك موسوماً بالسحب، ولا يترتّب عليه شيء.",
    "forms.mine.available": "نماذج موجّهة إليك",
    "forms.mine.available.lede": "ما يمكنك طلبه هنا دون مراسلة أحد.",
    "forms.mine.none_available": "لا يوجد نموذج موجّه إليك بعد",
    "forms.mine.none_available.lede": "يظهر النموذج هنا حين يُنشر لدور تحمله.",
    "forms.mine.fill": "املأ",
    "forms.mine.steps": "خطوات الاعتماد: {count}",
    "forms.mine.sent": "ما أرسلته",
    "forms.mine.none_sent": "لم ترسل طلباً بعد",
    "forms.mine.waiting_on": "بانتظار: {step}",
    "forms.mine.returned_because": "أُعيد إليك: {reason}",
    "forms.mine.open": "افتح",
    "forms.mine.correct": "صحّح وأعِد الإرسال",
    "forms.mine.correct.lede": "النموذج كما كان حين أرسلته أول مرة.",
    "forms.mine.withdraw": "اسحب",
    "forms.builder.form": "النموذج",
    "forms.builder.choose": "اختر نموذجاً",
    "forms.builder.revision": "الإصدار {n}",
    "forms.builder.unsaved": "غير محفوظ",
    "forms.builder.refresh_roles": "حدّث الأدوار",
    "forms.builder.roles_refreshed": "حُدِّث من يحمل أي دور: {n} عضواً.",
    "forms.builder.holders": "يحمله {n}",
    "forms.builder.new": "نموذج جديد",
    "forms.builder.publish": "انشر",
    "forms.builder.revise": "عدّل بإصدار جديد",
    "forms.builder.saved": "حُفظ.",
    "forms.builder.refused": "لم يُحفظ: {n} أمور تحتاج تصحيحاً.",
    "forms.builder.published": "نُشر إصداراً {revision}، وجمهوره يراه الآن.",
    "forms.builder.not_publishable": "لم يُنشر: تنقصه {n} أمور.",
    "forms.builder.frozen": "هذا الإصدار {status}، يُقرأ هنا ولا يُعدَّل. عدّله بإصدار جديد.",
    "forms.builder.discard": "مغادرة النموذج دون حفظ؟",
    "forms.builder.discard.lede": "تضيع التعديلات التي جرت بعد آخر حفظ.",
    "forms.builder.discard.confirm": "غادر دون حفظ",
    "forms.builder.empty": "لا يوجد نموذج بعد",
    "forms.builder.empty.lede": "ابدأ نموذجاً: مفتاح واسم باللغتين، ثم حقوله ومن يقرّره.",
    "forms.builder.key": "المفتاح",
    "forms.builder.key.help": "حروف لاتينية صغيرة وأرقام وشرطة سفلية؛ ولا يتغيّر أبداً.",
    "forms.builder.field_key.help": "الاسم الذي يحمل به حدثُ الاعتماد هذه الإجابة.",
    "forms.builder.name_ar": "الاسم بالعربية",
    "forms.builder.name_en": "الاسم بالإنجليزية",
    "forms.builder.header": "النموذج",
    "forms.builder.description_ar": "الوصف بالعربية",
    "forms.builder.description_en": "الوصف بالإنجليزية",
    "forms.builder.category": "الفئة",
    "forms.builder.icon": "الرمز",
    "forms.builder.audience": "لمن هذا النموذج",
    "forms.builder.audience.hint": "من يحمل أحد هذه الأدوار يراه ويقدّمه.",
    "forms.builder.no_roles": "لا يُعرف هنا بعدُ من يحمل أي دور — حدّث الأدوار.",
    "forms.builder.structure": "الأقسام والحقول",
    "forms.builder.structure.lede": "بالترتيب الذي يُقرأ به النموذج. اختر حقلاً لتحدّد ما يطلبه.",
    "forms.builder.add_section": "أضف قسماً",
    "forms.builder.add_field": "أضف حقلاً",
    "forms.builder.new_field": "حقل {n}",
    "forms.builder.new_section": "قسم {n}",
    "forms.builder.option": "خيار {n}",
    "forms.builder.no_fields": "لا حقول بعد",
    "forms.builder.no_fields.lede": "أضف أولها من «أضف حقلاً».",
    "forms.builder.remove_section": "احذف هذا القسم",
    "forms.builder.label_ar": "التسمية بالعربية",
    "forms.builder.label_en": "التسمية بالإنجليزية",
    "forms.builder.has_problem": "يحتاج تصحيحاً",
    "forms.builder.conditional": "مشروط",
    "forms.builder.up": "انقل للأعلى",
    "forms.builder.down": "انقل للأسفل",
    "forms.builder.remove_field": "احذف هذا الحقل",
    "forms.builder.conditions_cleared": "{n} حقول كانت تظهر بشرط على الحقل المحذوف صارت تظهر دائماً.",
    "forms.builder.move_breaks_condition": "الحقل المشروط يأتي بعد الحقل الذي يعتمد عليه، وهذا النقل يضعه قبله.",
    "forms.builder.inspector": "الحقل المختار",
    "forms.builder.pick_field": "اختر حقلاً لتحدّد ما يطلبه.",
    "forms.builder.type": "النوع",
    "forms.builder.help_ar": "التلميح بالعربية",
    "forms.builder.help_en": "التلميح بالإنجليزية",
    "forms.builder.section": "القسم",
    "forms.builder.required": "مطلوب",
    "forms.builder.options": "الخيارات",
    "forms.builder.add_option": "أضف خياراً",
    "forms.builder.remove_option": "احذف هذا الخيار",
    "forms.builder.option_value": "القيمة",
    "forms.builder.visible_when": "يظهر",
    "forms.builder.visible_when.hint": "فقط حين تساوي إجابة سابقة قيمة معيّنة — لا أكثر.",
    "forms.builder.always": "دائماً",
    "forms.builder.equals": "حين تكون",
    "forms.builder.steps": "مسار الاعتماد",
    "forms.builder.steps.lede": "كل خطوة يقرّرها من يحمل دورها، ولا يقرّرها مقدّم الطلب أبداً.",
    "forms.builder.add_step": "أضف خطوة",
    "forms.builder.remove_step": "احذف هذه الخطوة",
    "forms.builder.approver_kind": "يقرّرها",
    "forms.builder.approver_role": "الدور",
    "forms.builder.sla_hours": "الساعات",
    "forms.builder.may_return": "تُعيد",
    "forms.builder.may_edit": "تصحّح",
    "forms.builder.preview": "كما سيُرى",
    "forms.builder.preview.lede": "مرسوم بالمكوّن نفسه الذي يملؤه به جمهوره، من هذه المسوّدة كما هي الآن.",
    "forms.builder.as_submitter": "كمقدّم طلب",
    "forms.builder.as_approver": "كمعتمِد",
    "forms.builder.unnamed_step": "الخطوة {n}",
    "forms.builder.no_steps": "لا خطوات اعتماد بعد",
    "forms.builder.clear_preview": "امسح",
    "forms.builder.check": "افحص كأنه قُدِّم",
    "forms.builder.check_ok": "هذه الإجابات ستُقبل.",
    "forms.builder.check_refused": "ستُرفض {n} إجابات، وكلّ منها معلَّم.",
    "forms.icon.file": "ملف",
    "forms.icon.clipboard": "حافظة",
    "forms.icon.calendar": "تقويم",
    "forms.icon.user": "شخص",
    "forms.icon.users": "أشخاص",
    "forms.icon.star": "نجمة",
    "forms.icon.shield": "درع",
    "forms.icon.tag": "وسم",
    "forms.icon.clock": "ساعة",
    "forms.icon.check": "علامة صح",
    "forms.icon.globe": "كرة أرضية",
    "forms.icon.settings": "إعدادات",
    "forms.type.text": "نص قصير",
    "forms.type.textarea": "نص طويل",
    "forms.type.number": "رقم",
    "forms.type.money": "مبلغ",
    "forms.type.date": "تاريخ",
    "forms.type.datetime": "تاريخ ووقت",
    "forms.type.select": "اختيار واحد",
    "forms.type.multiselect": "اختيارات متعددة",
    "forms.type.boolean": "نعم / لا",
    "forms.type.employee_ref": "موظّف",
    "forms.type.location_ref": "موقع عمل",
    "forms.type.attachment": "مرفق",
    "forms.rule.min": "لا يقل عن",
    "forms.rule.max": "لا يزيد على",
    "forms.rule.min_count": "اختيارات لا تقل عن",
    "forms.rule.max_count": "اختيارات لا تزيد على",
    "forms.rule.min_length": "أقصر طول (أحرف)",
    "forms.rule.max_length": "أطول طول (أحرف)",
    "forms.rule.pattern": "النمط",
    "forms.rule.integer": "أعداد صحيحة فقط",
    "forms.refusal.required": "هذا الحقل مطلوب.",
    "forms.refusal.too_long": "لا يزيد على {max} حرفاً.",
    "forms.refusal.version_shape": "رقم النسخة المقروءة عدد صحيح.",
    "forms.refusal.stale": "غيّره أحدٌ بعد أن فتحته؛ افتحه من جديد.",
    "forms.refusal.own_permission": "النموذج لا يعلن صلاحية خاصة به: من يستخدمه تحدّده صلاحيات النماذج وجمهوره من الأدوار.",
    "forms.refusal.key_shape": "المفتاح حروف لاتينية صغيرة وأرقام وشرطة سفلية، ويبدأ بحرف.",
    "forms.refusal.key_taken": "يوجد نموذج بهذا المفتاح.",
    "forms.refusal.draft_exists": "لهذا النموذج مسوّدة قائمة؛ افتحها.",
    "forms.refusal.steps_shape": "مسار الاعتماد قائمة خطوات.",
    "forms.refusal.too_many_steps": "لا يزيد على {max} خطوات.",
    "forms.refusal.step_name_required": "الخطوة {step} تحتاج اسماً باللغتين.",
    "forms.refusal.approver_kind": "هذا ليس نوعاً من المعتمدين.",
    "forms.refusal.approver_role": "الخطوة {step} يقرّرها دور: حدّده.",
    "forms.refusal.sla_hours": "ساعات القرار عدد صحيح من {min} إلى {max}.",
    "forms.refusal.audience_shape": "الجمهور قائمة أدوار.",
    "forms.refusal.audience_unsupported": "جمهور حسب {by} يحتاج مديولاً لا تستطيع هذه الوحدة سؤاله بعد؛ الأدوار فقط.",
    "forms.refusal.role_key": "«{role}» ليس مفتاح دور.",
    "forms.refusal.too_many_roles": "لا يزيد على {max} دوراً.",
    "forms.refusal.publish_no_field": "يحتاج النموذج حقلاً واحداً على الأقل قبل نشره.",
    "forms.refusal.publish_no_step": "يحتاج النموذج مسار اعتماد — خطوة واحدة على الأقل — قبل نشره.",
    "forms.refusal.publish_no_audience": "يحتاج النموذج جمهوراً — دوراً واحداً على الأقل — قبل نشره.",
    "forms.refusal.manager_unresolvable": "الخطوة {step}: لا يمكن تحديد مدير مقدّم الطلب هنا بعد — يحتاج خطّ التبعية وربط المستخدم بتوظيفه.",
    "forms.refusal.roles_unknown": "لا يُعرف هنا بعدُ من يحمل أي دور؛ حدّث الأدوار أولاً.",
    "forms.refusal.role_unheld": "لا أحد يحمل الدور «{role}»، فلن تُقرَّر الخطوة {step} أبداً.",
    "forms.refusal.no_form": "لا يوجد نموذج كهذا.",
    "forms.refusal.definition_frozen": "الإصدار الذي حالته {status} لا يُعدَّل في مكانه؛ عدّله بإصدار جديد.",
    "forms.refusal.icon": "هذا ليس رمزاً ترسمه الشاشة.",
    "forms.refusal.document_type_key": "مفتاح نوع المستند حروف صغيرة وأرقام ونقطة وشرطة وشرطة سفلية.",
    "forms.refusal.not_draft": "لا يُنشر إلا المسوّدة.",
    "forms.refusal.not_published": "لا يُغلق إلا الإصدار المنشور.",
    "forms.refusal.already_draft": "هذا الإصدار مسوّدة أصلاً؛ عدّله.",
    "forms.refusal.roles_forbidden": "رفضت الهوية بيان من يحمل أي دور: يلزم إذن عرض الأعضاء.",
    "forms.refusal.roles_unavailable": "لم تُجب الهوية؛ حاول بعد قليل.",
    "forms.refusal.form_revised": "تغيّر هذا النموذج بعد أن فتحته؛ افتحه من جديد.",
    "forms.refusal.form_closed": "هذا النموذج لم يعد يستقبل طلبات.",
    "forms.refusal.not_in_audience": "هذا النموذج ليس موجّهاً إليك.",
    "forms.refusal.not_yours": "لا يفعل هذا إلا من قدّم الطلب.",
    "forms.refusal.decided": "تقرّر هذا الطلب ولم يعد سحبه ممكناً.",
    "forms.refusal.not_returned": "لا يُعاد إرسال إلا الطلب الذي أُعيد إليك.",
    "forms.refusal.no_request": "لا يوجد طلب كهذا.",
    "forms.refusal.not_waiting": "لا شيء في هذا الطلب ينتظر قراراً.",
    "forms.refusal.own_request": "من قدّم الطلب لا يقرّر فيه.",
    "forms.refusal.not_your_step": "هذه الخطوة يقرّرها من يحمل الدور «{role}».",
    "forms.refusal.reason_required": "اذكر السبب — فهو ما يقرؤه مقدّم الطلب.",
    "forms.refusal.return_not_allowed": "هذه الخطوة لا تُعيد الطلبات؛ اعتمد أو ارفض.",
    "forms.refusal.edit_not_allowed": "هذه الخطوة لا تغيّر ما قُدِّم.",
    "fields.refusal.sections_shape": "للقسم مفتاح وتسمية باللغتين.",
    "fields.refusal.too_many_sections": "لا يزيد على {max} أقسام.",
    "fields.refusal.key_shape": "المفتاح حروف لاتينية صغيرة وأرقام وشرطة سفلية، يبدأ بحرف، ولا يزيد على {max}.",
    "fields.refusal.key_taken": "«{key}» مستخدم مرتين.",
    "fields.refusal.label_required": "التسمية مطلوبة بالعربية والإنجليزية.",
    "fields.refusal.label_too_long": "التسمية لا تزيد على {max} حرفاً.",
    "fields.refusal.rule_shape": "هذه القاعدة ليست مكتوبة بالصيغة المقروءة.",
    "fields.refusal.rule_not_allowed": "حقل من نوع {type} لا يقبل القاعدة «{rule}».",
    "fields.refusal.pattern_invalid": "هذا النمط ليس تعبيراً نمطياً صحيحاً.",
    "fields.refusal.rule_range": "الحدّ الأدنى أعلى من الحدّ الأعلى.",
    "fields.refusal.options_shape": "للخيار قيمة وتسمية باللغتين.",
    "fields.refusal.options_not_allowed": "حقل من نوع {type} لا خيارات له.",
    "fields.refusal.options_required": "حقل الاختيار يحتاج خياراً واحداً على الأقل.",
    "fields.refusal.too_many_options": "لا يزيد على {max} خياراً.",
    "fields.refusal.option_value_shape": "قيمة الخيار حروف وأرقام ومسافة ونقطة وشرطة وشرطة سفلية، ولا تزيد على 64.",
    "fields.refusal.option_duplicate": "الخيار «{value}» مكرّر.",
    "fields.refusal.fields_shape": "الحقول قائمة.",
    "fields.refusal.too_many_fields": "لا يزيد النموذج على {max} حقلاً.",
    "fields.refusal.type_unknown": "«{type}» ليس نوع حقل ترسمه الشاشة.",
    "fields.refusal.section_unknown": "لا يوجد قسم «{section}».",
    "fields.refusal.section_required": "النموذج المقسَّم يضع كل حقل في قسم.",
    "fields.refusal.help_too_long": "التلميح لا يزيد على {max} حرفاً.",
    "fields.refusal.visible_when_shape": "الشرط يسمّي حقلاً واحداً والقيمة التي يجب أن يساويها.",
    "fields.refusal.visible_when_self": "لا يعتمد الحقل على نفسه.",
    "fields.refusal.visible_when_unknown": "«{field}» ليس حقلاً قبل هذا الحقل.",
    "fields.refusal.visible_when_type": "الشرط يقارن اختياراً أو نعم/لا أو نصاً أو رقماً — و«{field}» من نوع {type}.",
    "fields.refusal.visible_when_value": "هذه القيمة ليست مما يحمله «{field}».",
    "fields.refusal.default_invalid": "القيمة الافتراضية نفسها مرفوضة.",
    "fields.refusal.not_text": "هذا ليس نصاً.",
    "fields.refusal.too_short": "لا يقل عن {min} حرفاً.",
    "fields.refusal.too_long": "لا يزيد على {max} حرفاً.",
    "fields.refusal.pattern": "هذا ليس مكتوباً بالصيغة التي يطلبها النموذج.",
    "fields.refusal.not_number": "هذا ليس رقماً.",
    "fields.refusal.not_integer": "عدد صحيح.",
    "fields.refusal.below_min": "لا يقل عن {min}.",
    "fields.refusal.above_max": "لا يزيد على {max}.",
    "fields.refusal.not_money": "هذا ليس مبلغاً.",
    "fields.refusal.money_places": "لا يزيد على {places} منزلة عشرية.",
    "fields.refusal.not_date": "يوم بصيغة YYYY-MM-DD.",
    "fields.refusal.before_min": "في {min} أو بعده.",
    "fields.refusal.after_max": "في {max} أو قبله.",
    "fields.refusal.not_datetime": "يوم ووقت.",
    "fields.refusal.not_choice": "هذا ليس من الخيارات.",
    "fields.refusal.not_choices": "ليست كلها من الخيارات.",
    "fields.refusal.too_few": "اختر {min} على الأقل.",
    "fields.refusal.too_many": "اختر {max} على الأكثر.",
    "fields.refusal.not_boolean": "نعم أو لا.",
    "fields.refusal.not_reference": "هذا ليس مرجعاً.",
    "fields.refusal.values_shape": "تُرسل الإجابات كائناً مفاتيحه الحقول.",
    "fields.refusal.unknown_field": "لا يوجد في النموذج حقل «{field}».",
    "fields.refusal.required": "هذا الحقل مطلوب.",
    "fields.refusal.must_confirm": "يجب التأشير على هذا.",
    // platform · documents
    'nav.documents.owner': "وثائق كلّ مالك",
    'nav.documents.types': "أنواع الوثائق",
    'value.status.valid': "سارية",
    'value.status.expiring': "تنتهي قريباً",
    'value.owner_kind.party': "طرف",
    'value.owner_kind.company': "الشركة",
    'value.applies_to.party': "طرف",
    'value.applies_to.company': "الشركة",
    'value.retention_category.identity': "وثيقة هوية",
    'value.retention_category.licence': "رخصة أو تصريح",
    'value.retention_category.contract': "عقد",
    'value.retention_category.personnel': "سجلّ موظّف",
    'value.retention_category.qualification': "مؤهّل",
    'value.retention_category.regulation': "لائحة أو سياسة",
    'value.retention_category.corporate': "سجلّ الشركة",
    'value.retention_category.general': "عامّ",
    'documents.items.title': "الوثائق",
    'documents.items.lede': "كلّ وثيقة تحفظها مساحة العمل، ولمن هي، ومتى تنتهي صلاحيتها. تاريخ الانتهاء لا يتغيّر إلا بالتجديد مع النسخة الجديدة.",
    'documents.items.stat.valid': "سارية",
    'documents.items.stat.expiring': "تنتهي قريباً",
    'documents.items.stat.expired': "منتهية — تحتاج تجديداً",
    'documents.items.col.type': "الوثيقة",
    'documents.items.col.type_name_en': "الوثيقة (بالإنجليزية)",
    'documents.items.col.owner': "المالك",
    'documents.items.col.owner_kind': "لمن",
    'documents.items.col.owner_ref': "مرجع المالك",
    'documents.items.col.number': "الرقم",
    'documents.items.col.expires_on': "تنتهي في",
    'documents.items.col.days_left': "الأيام المتبقّية",
    'documents.items.col.status': "الصلاحية",
    'documents.items.col.version_no': "النسخة",
    'documents.items.col.file_name': "الملف",
    'documents.items.col.title': "العنوان",
    'documents.items.col.citation': "مرجع الاستشهاد",
    'documents.items.col.issued_on': "تاريخ الإصدار",
    'documents.items.col.keep_until': "تُحفظ حتى",
    'documents.items.col.created_at': "أُرشفت في",
    'documents.items.col.record_status': "حالة السجلّ",
    'documents.items.col.is_regulation': "لائحة",
    'documents.items.col.id': "المعرّف",
    'documents.items.action.attach': "إرفاق وثيقة",
    'documents.items.action.regulation': "لائحة جديدة",
    'documents.items.action.renew': "تجديد",
    'documents.items.action.new_version': "نسخة جديدة",
    'documents.items.action.edit': "تعديل البيانات",
    'documents.items.action.withdraw': "سحب",
    'documents.items.field.type_id': "النوع",
    'documents.items.field.type_key.regulation': "لائحة",
    'documents.items.field.owner_kind': "لمن",
    'documents.items.field.owner_kind.party': "شخص أو جهة",
    'documents.items.field.owner_kind.company': "الشركة",
    'documents.items.field.owner_ref': "مرجع المالك",
    'documents.items.field.owner_ref.help': "يُكتب module.entity:id — مثل parties.party:01J… أو employees.employment:01J…. اتركه فارغاً لوثائق الشركة.",
    'documents.items.field.owner_label': "اسم المالك",
    'documents.items.field.owner_label.help': "كما يظهر المالك في هذا السجلّ.",
    'documents.items.field.number': "الرقم",
    'documents.items.field.issued_on': "تاريخ الإصدار",
    'documents.items.field.expires_on': "تاريخ الانتهاء",
    'documents.items.field.expires_on.help': "مطلوب إذا كان للنوع تاريخ انتهاء.",
    'documents.items.field.new_expires_on': "تاريخ الانتهاء الجديد",
    'documents.items.field.file': "نسخة الوثيقة",
    'documents.items.field.file.help': "ملف PDF أو صورة أو ملف Word، حتى 10 ميغابايت.",
    'documents.items.field.new_file': "النسخة الجديدة",
    'documents.items.field.new_file.help': "لا يُقبل التجديد إلا مع النسخة الجديدة.",
    'documents.items.field.title': "العنوان",
    'documents.items.field.notes': "ملاحظات",
    'documents.items.field.ref_key': "المفتاح",
    'documents.items.field.ref_key.help': "ما تستشهد به الوحدات الأخرى مع رقم النسخة: penalties تصبح penalties@1. حروف لاتينية صغيرة وأرقام وشرطة سفلية.",
    'documents.items.field.decision_number': "رقم القرار",
    'documents.items.field.effective_on': "تاريخ السريان",
    'documents.items.field.reason': "السبب",
    'documents.items.field.reason.help': "تبقى الوثيقة محفوظة مع اسم من سحبها وسبب السحب.",
    'documents.types.title': "أنواع الوثائق",
    'documents.types.lede': "أنواع الوثائق التي تحفظها مساحة العمل: لمن كلّ نوع، وهل له تاريخ انتهاء، ومتى يُنبَّه قبله، وكم يُحفظ بعد أن يتوقّف العمل به.",
    'documents.types.col.name_ar': "النوع",
    'documents.types.col.name_en': "الاسم (بالإنجليزية)",
    'documents.types.col.key': "المفتاح",
    'documents.types.col.applies_to': "لمن",
    'documents.types.col.expires': "له انتهاء",
    'documents.types.col.alerts': "أيام التنبيه قبل الانتهاء",
    'documents.types.col.retention_category': "فئة الحفظ",
    'documents.types.col.retention_years': "سنوات الحفظ بعده",
    'documents.types.col.legal_hold': "تجميد قانوني",
    'documents.types.col.documents': "الوثائق",
    'documents.types.col.status': "الحالة",
    'documents.types.col.builtin': "من المنصّة",
    'documents.types.col.id': "المعرّف",
    'documents.types.action.create': "نوع جديد",
    'documents.types.action.edit': "تعديل",
    'documents.types.action.retire': "إيقاف",
    'documents.types.field.name_ar': "الاسم (بالعربية)",
    'documents.types.field.name_en': "الاسم (بالإنجليزية)",
    'documents.types.field.key': "المفتاح",
    'documents.types.field.key.help': "ما تسمّي به الوحدات الأخرى هذا النوع. حروف لاتينية صغيرة وأرقام وشرطة سفلية، ولا يتغيّر.",
    'documents.types.field.applies_to': "لمن",
    'documents.types.field.expires': "له تاريخ انتهاء",
    'documents.types.field.alert_days': "أيام التنبيه قبل الانتهاء",
    'documents.types.field.alert_days.help': "اختر الأيام قبل الانتهاء التي يُنبَّه فيها، وكلّ تنبيه مرّة واحدة. إن لم تُمسّ فهي 90 و60 و30، وإن أُلغيت كلها فلا تنبيه.",
    'documents.types.field.retention_category': "فئة الحفظ",
    'documents.types.field.retention_years': "سنوات الحفظ بعد انتهاء العمل بها",
    'documents.types.field.retention_years.help': "تُحسب من تجديدها أو سحبها أو انتهائها. لا يُحفظ شيء إلى الأبد تلقائياً.",
    'documents.types.field.legal_hold': "تجميد قانوني",
    'documents.types.field.legal_hold.help': "ما دام مفعّلاً لا تُتلف أيّ وثيقة من هذا النوع مهما قالت مدّة حفظها.",
    'documents.owner.title': "وثائق كلّ مالك",
    'documents.owner.lede': "كلّ ما يحمله شخص أو جهة أو الشركة: ما هو ساري، وما ينتهي قريباً، وما يحتاج تجديداً — مع نسخة كلّ وثيقة.",
    'documents.owner.pick': "وثائق من",
    'documents.owner.pick.hint': "كلّ من له وثائق في السجلّ، والشركة. ومن لا وثيقة له بعد يُفتح بكتابة مرجعه.",
    'documents.owner.pick.placeholder': "اكتب اسماً أو مرجعاً",
    'documents.owner.pick.none': "لا أحد بهذا الاسم له وثيقة",
    'documents.owner.pick.by_reference': "فتح «{ref}»",
    'documents.owner.pick.reference_shape': "المرجع يُكتب module.entity:id، مثل employees.employment:01J…",
    'documents.owner.owner': "المالك",
    'documents.owner.company': "الشركة",
    'documents.owner.counts': "{documents} وثائق · {expiring} تنتهي قريباً · {expired} منتهية",
    'documents.owner.empty.title': "اختر من تريد رؤية وثائقه",
    'documents.owner.empty.description': "اختر شخصاً أو جهة أو الشركة من الأعلى.",
    'documents.owner.none': "لا وثائق بعد",
    'documents.owner.attach': "إرفاق وثيقة",
    'documents.owner.attach.title': "إرفاق وثيقة",
    'documents.owner.attach.submit': "إرفاق",
    'documents.owner.attach.type_placeholder': "اختر النوع",
    'documents.owner.attach.no_types': "لا نوع وثيقة ينطبق على هذا المالك بعد. أضِف نوعاً من «أنواع الوثائق».",
    'documents.owner.attach.no_end': "هذا النوع ليس له تاريخ انتهاء.",
    'documents.owner.attached': "أُرفقت. تبدأ تنبيهاتها من تاريخ انتهائها.",
    'documents.owner.renew': "تجديد",
    'documents.owner.renew.title': "التجديد بالنسخة الجديدة",
    'documents.owner.renew.description': "تبقى النسخة الحالية محفوظة ومرتبطة بالجديدة. لا يُقبل تاريخ انتهاء جديد إلا مع النسخة الجديدة.",
    'documents.owner.renew.submit': "تجديد",
    'documents.owner.renew.was': "كانت تنتهي في {date}.",
    'documents.owner.renewed': "جُدّدت، وبقيت النسخة السابقة محفوظة معها.",
    'documents.owner.new_version': "نسخة جديدة",
    'documents.owner.open': "فتح النسخة",
    'documents.owner.open_failed': "تعذّر فتح النسخة",
    'documents.owner.cancel': "إلغاء",
    'documents.owner.ends_in': "تنتهي في {date} — بقي {days} يوماً",
    'documents.owner.ended': "انتهت في {date} — منذ {days} يوماً",
    'documents.owner.ends_on': "انتهت في {date}",
    'documents.owner.no_end': "بلا تاريخ انتهاء",
    'documents.owner.in_force_from': "سارية منذ {date}",
    'documents.owner.version': "النسخة {n}",
    'documents.refusal.required': "{field} مطلوب.",
    'documents.refusal.too_long': "{field} أطول من {max} حرفاً.",
    'documents.refusal.date': "{field} يجب أن يكون تاريخاً بصيغة YYYY-MM-DD.",
    'documents.refusal.boolean': "{field} إمّا نعم أو لا.",
    'documents.refusal.alert_days': "أيام التنبيه أعداد صحيحة من 1 إلى 365، مثل 90، 60، 30.",
    'documents.refusal.owner_kind': "المالك شخص أو جهة، أو الشركة.",
    'documents.refusal.owner_ref_shape': "المالك يُكتب module.entity:id، مثل parties.party:01J…",
    'documents.refusal.file_type': "نسخة الوثيقة ملف PDF أو صورة أو ملف Word.",
    'documents.refusal.within': "عدد الأيام رقم صحيح من 1 إلى 365.",
    'documents.establishment_documents.title': "وثائق المنشأة",
    'documents.establishment_documents.col.expired': "منتهية",
    'documents.establishment_documents.col.expiring': "تنتهي خلال 30 يوماً",
    'documents.establishment_documents.link': "الوثائق",
    'documents.refusal.file_empty': "الملف فارغ.",
    'documents.refusal.file_too_large': "الملف أكبر من {max_mb} ميغابايت.",
    'documents.refusal.file_required': "لا يتغيّر تاريخ الانتهاء إلا مع النسخة الجديدة من الوثيقة. أرفِقها.",
    'documents.refusal.file_same': "هذه هي النسخة التي تحملها النسخة الحالية. التجديد يحمل نسخة جديدة.",
    'documents.refusal.file_in_use': "هذا الملف نسخةٌ لوثيقة أخرى.",
    'documents.refusal.media_missing': "لا يوجد هذا الملف في مساحة العمل.",
    'documents.refusal.media_refused': "لم يقبل مخزن الملفات الملف: {reason}",
    'documents.refusal.media_forbidden': "لا تملك صلاحية رفع الملفات أو قراءتها هنا. اطلب صلاحية الملفات.",
    'documents.refusal.media_unavailable': "لم يردّ مخزن الملفات. لم يُحفظ شيء؛ حاول مرّة أخرى.",
    'documents.refusal.stale': "غيّر أحدٌ هذا منذ فتحته. اقرأه من جديد.",
    'documents.refusal.conflict': "سبقك تغيير آخر. اقرأه من جديد.",
    'documents.refusal.retention_category': "هذه ليست فئة حفظ.",
    'documents.refusal.retention_years': "مدّة الحفظ عدد صحيح من السنوات من 1 إلى 100. لا يُحفظ شيء إلى الأبد تلقائياً.",
    'documents.refusal.type_key_shape': "المفتاح حروف لاتينية صغيرة وأرقام وشرطة سفلية، ويبدأ بحرف.",
    'documents.refusal.type_key_taken': "المفتاح {key} اسمٌ لنوع موجود.",
    'documents.refusal.type_not_found': "لا يوجد نوع وثيقة كهذا.",
    'documents.refusal.type_retired': "هذا النوع غير نشط ولا تُضاف إليه وثائق جديدة.",
    'documents.refusal.type_builtin': "هذا النوع من المنصّة، وتستشهد به وحدات أخرى.",
    'documents.refusal.type_fixed': "{field} هو ما أُرفقت عليه وثائق هذا النوع، فلا يتغيّر.",
    'documents.refusal.applies_to': "مالك هذا النوع ليس من هذا الصنف.",
    'documents.refusal.expires_not_applicable': "هذا النوع ليس له تاريخ انتهاء.",
    'documents.refusal.expires_before_issued': "لا يمكن أن تنتهي قبل تاريخ إصدارها ({issued_on}).",
    'documents.refusal.not_found': "لا توجد وثيقة كهذه.",
    'documents.refusal.not_current': "هذه ليست النسخة الحالية. تعامل مع الأحدث.",
    'documents.refusal.destroyed': "أُتلفت هذه الوثيقة بانتهاء مدّة حفظها. يبقى سجلّها، ولا تبقى نسختها.",
    'documents.refusal.no_copy': "ليس لهذه الوثيقة نسخة بعد. جدّدها بنسخة.",
    'documents.refusal.not_linked': "حسابك غير مرتبط بشخص في هذه المنشأة، فلا وثائق لك. اطلب من المسؤول ربطه.",
    'documents.refusal.hold_already': "هذه الوثيقة تحت تجميد قانوني من قبل.",
    'documents.refusal.hold_not_set': "هذه الوثيقة ليست تحت تجميد قانوني.",
    'documents.refusal.anchor_not_set': "لم تُسجَّل نهاية علاقة لهذا المالك، فلا شيء يُلغى.",
    'documents.refusal.regulation_fixed': "رقم قرار اللائحة وتاريخ سريانها لا يتغيّران إلا بنسخة جديدة.",
    'documents.refusal.regulation_key_taken': "توجد لائحة بالمفتاح {key}. النسخة الجديدة تجديدٌ لها.",
    'documents.refusal.regulation_not_found': "لا لائحة {key} سارية.",
    'documents.refusal.regulation_version': "رقم النسخة عدد صحيح يبدأ من 1.",
    'documents.refusal.effective_after_previous': "تسري النسخة الجديدة بعد التي تحلّ محلّها ({previous}).",
    // hr · payroll transfers
    "value.id_type.national_id": "هوية وطنية",
    "value.id_type.iqama": "إقامة",
    "value.id_type.passport": "جواز سفر",
    "value.id_type.border": "رقم حدود",
    "value.register.register_checked": "لا اختلاف",
    "value.register.register_differs": "يخالف السجل",
    "value.register.register_unchecked": "لم يُطابَق",
    "value.payment_status.paid": "مصروف",
    "value.payment_status.rejected": "رفضه البنك",
    "value.payment_status.pending": "بانتظار البنك",
    "value.resolution.supplementary": "صُرف في مسيّر إضافي",
    "value.resolution.other": "صُرف بطريقة أخرى",
    // gov_sa · shared words of the unit's screens
    "group.government": "الجهات الحكومية",
    "gov_sa.action.cancel": "إلغاء",
    "gov_sa.action.download": "تنزيل",
    "gov_sa.action.open": "فتح",
    "gov_sa.action.save": "حفظ",
    "gov_sa.field.change_file": "اختر ملفًا آخر",
    "gov_sa.field.choose_file": "اختر ملفًا",
    "gov_sa.field.csv_or_xlsx": "CSV أو Excel ‏(XLSX) كما تصدّره البوابة. حتى 5 ميغابايت.",
    "gov_sa.field.empty_is_today": "إن تُرك فارغًا فهو اليوم.",
    "gov_sa.field.note": "ملاحظة",
    "gov_sa.field.reason": "السبب",
    "gov_sa.field.remove_file": "إزالة",
    "gov_sa.field.required": "مطلوب",
    "gov_sa.format.csv": "CSV",
    "gov_sa.format.xlsx": "Excel ‏(XLSX)",
    "gov_sa.refusal.amount": "أدخل مبلغًا أكبر من الصفر بخانتين عشريتين على الأكثر.",
    "gov_sa.refusal.date": "اكتب التاريخ بالصيغة YYYY-MM-DD.",
    "gov_sa.refusal.duplicate": "سُجِّل هذا من قبل.",
    "gov_sa.refusal.file_empty": "الملف فارغ.",
    "gov_sa.refusal.file_too_large": "الملف أكبر من {max_mb} ميغابايت.",
    "gov_sa.refusal.file_unreadable": "تعذّرت قراءة الملف. احفظه بصيغة CSV ‏(UTF-8) أو XLSX وأعد المحاولة.",
    "gov_sa.refusal.future": "هذا اليوم لم يأتِ بعد.",
    "gov_sa.refusal.hr_forbidden": "رفضت الموارد البشرية الطلب: لا تملك الصلاحية هناك.",
    "gov_sa.refusal.hr_timeout": "لم تُجب الموارد البشرية في الوقت. أعد المحاولة.",
    "gov_sa.refusal.hr_unavailable": "لم تُجب الموارد البشرية ({reason}).",
    "gov_sa.refusal.idempotency_mismatch": "مفتاح الطلب هذا استُخدم لطلب آخر.",
    "gov_sa.refusal.not_found": "غير موجود.",
    "gov_sa.refusal.one_of": "اختر واحدًا من: {values}.",
    "gov_sa.refusal.range": "أدخل قيمة من {min} إلى {max}.",
    "gov_sa.refusal.required": "هذا الحقل مطلوب.",
    "gov_sa.refusal.too_long": "{max} حرفًا على الأكثر.",
    // gov_sa · gosi
    "nav.gosi.worklist": "مهام التأمينات",
    "nav.gosi.submissions": "إرساليات التأمينات",
    "nav.gosi.reconcile": "مطابقة التأمينات",
    "nav.gosi.rates": "نسب اشتراك التأمينات",
    "value.kind.register": "تسجيل",
    "value.kind.wage_update": "تعديل أجر",
    "value.kind.exclude": "استبعاد",
    "value.kind.maternity_notice": "إشعار تعويض الأمومة",
    "value.stage.to_report": "للإبلاغ",
    "value.stage.waiting": "لم يباشر بعد",
    "value.stage.in_submission": "ضمن إرسالية",
    "value.stage.done": "منجز",
    "value.scheme.old": "النظام القديم",
    "value.scheme.new": "النظام الجديد",
    "value.scheme.non_citizen": "غير مواطن",
    "value.branch.annuities": "المعاشات",
    "value.branch.saned": "ساند (التعطل عن العمل)",
    "value.branch.hazards": "الأخطار المهنية",
    "value.source.pack": "حزمة النسب",
    "value.status.confirmed": "معتمد",
    "gov_sa.gosi.channel.file": "ملف يُرفع على البوابة",
    "gov_sa.gosi.channel.portal_manual": "إدخال يدوي على البوابة",
    "gov_sa.gosi.scheme.old.long": "قديم — اشترك قبل 3 يوليو 2024",
    "gov_sa.gosi.scheme.new.long": "جديد — أول تسجيل في 3 يوليو 2024 أو بعده",
    "gov_sa.gosi.scheme.non_citizen.long": "غير مواطن — الأخطار المهنية فقط",
    "gov_sa.gosi.submission_status.prepared": "مُعدّة",
    "gov_sa.gosi.submission_status.submitted": "أُرسلت، بانتظار التأمينات",
    "gov_sa.gosi.submission_status.accepted": "مقبولة",
    "gov_sa.gosi.submission_status.rejected": "مرفوضة",
    "gov_sa.gosi.submission_status.withdrawn": "مسحوبة",
    "gov_sa.gosi.mismatch.missing_contributor": "غير مسجّل في التأمينات",
    "gov_sa.gosi.mismatch.registered_not_employed": "مسجّل ولم يعد يعمل هنا",
    "gov_sa.gosi.mismatch.wage_differs": "الأجر مختلف",
    "gov_sa.gosi.mismatch.scheme_mismatch": "النظام مختلف",
    "gov_sa.gosi.mismatch.missing_contributor.todo": "يعمل هنا وليس في قائمة التأمينات: سجّله — في المهام بند له، أو حدّثها من الموارد البشرية.",
    "gov_sa.gosi.mismatch.registered_not_employed.todo": "في قائمة التأمينات ولا يعمل هنا: استبعده، وإلا بقيت المنشأة تدفع عنه.",
    "gov_sa.gosi.mismatch.wage_differs.todo": "الأساسي + السكن في الموارد البشرية يختلف عن أجر التأمينات: عدّل الأجر الخاضع للاشتراك أو صحّح العقد.",
    "gov_sa.gosi.mismatch.scheme_mismatch.todo": "تختلف التأمينات والموارد البشرية في النظام: راجع تاريخ أول تسجيل — أحدهما خطأ.",
    "gov_sa.gosi.worklist.screen.title": "مهام التأمينات الاجتماعية",
    "gov_sa.gosi.worklist.screen.lede": "ما تبلّغ به المنشأة التأمينات، مرة لكل واقعة ولكلٍّ موعده؛ ولا يصل شيء إليها وحده.",
    "gov_sa.gosi.worklist.col.employee": "الموظّف",
    "gov_sa.gosi.worklist.col.employee_number": "الرقم الوظيفي",
    "gov_sa.gosi.worklist.col.id_number": "رقم الهوية",
    "gov_sa.gosi.worklist.col.kind": "نوع البلاغ",
    "gov_sa.gosi.worklist.col.effective_on": "تاريخ السريان",
    "gov_sa.gosi.worklist.col.due_on": "المهلة حتى",
    "gov_sa.gosi.worklist.col.days_left": "الأيام المتبقية",
    "gov_sa.gosi.worklist.col.overdue": "متأخر",
    "gov_sa.gosi.worklist.col.scheme": "النظام",
    "gov_sa.gosi.worklist.col.needs_review": "النظام بانتظار القرار",
    "gov_sa.gosi.worklist.col.stage": "المرحلة",
    "gov_sa.gosi.worklist.col.reference": "مرجع التأمينات",
    "gov_sa.gosi.worklist.col.refreshed_at": "بيانات الموارد البشرية حتى",
    "gov_sa.gosi.worklist.col.can_done": "يمكنك إغلاقه",
    "gov_sa.gosi.worklist.col.can_reopen": "يمكنك إعادة فتحه",
    "gov_sa.gosi.worklist.col.can_classify": "يمكنك تحديد النظام",
    "gov_sa.gosi.worklist.col.can_withdraw": "يمكنك سحبه",
    "gov_sa.gosi.worklist.stat.overdue": "متأخرة",
    "gov_sa.gosi.worklist.stat.open": "للإبلاغ",
    "gov_sa.gosi.worklist.stat.review": "نظام بانتظار القرار",
    "gov_sa.gosi.worklist.stat.sent": "ضمن إرسالية",
    "gov_sa.gosi.worklist.action.prepare": "إعداد إرسالية",
    "gov_sa.gosi.worklist.action.prepare.field.kind": "ما يُرسَل",
    "gov_sa.gosi.worklist.action.prepare.field.channel": "طريقة الإرسال",
    "gov_sa.gosi.worklist.action.prepare.field.format": "الملف",
    "gov_sa.gosi.worklist.action.prepare.field.format.help": "يتبع الملف قالب هذا المنتج — طابِقه مع صيغة الرفع الجماعي المعتمدة لدى التأمينات قبل الاعتماد عليه.",
    "gov_sa.gosi.worklist.action.refresh": "تحديث من الموارد البشرية",
    "gov_sa.gosi.worklist.action.done": "إغلاق كمنجز",
    "gov_sa.gosi.worklist.action.done.field.reference": "مرجع التأمينات",
    "gov_sa.gosi.worklist.action.done.field.reference.help": "الرقم الذي أعطته البوابة للمعاملة.",
    "gov_sa.gosi.worklist.action.done.field.done_on": "تاريخ الإنجاز",
    "gov_sa.gosi.worklist.action.classify": "تحديد النظام",
    "gov_sa.gosi.worklist.action.classify.field.scheme.help": "يحدّده أول تسجيل في التأمينات أينما كان، لا الالتحاق هنا. من له اشتراك سابق فهو على النظام القديم.",
    "gov_sa.gosi.worklist.action.classify.field.note": "المستند",
    "gov_sa.gosi.worklist.action.classify.field.note.help": "ما يستند إليه القرار — شهادة التأمينات، صاحب العمل السابق.",
    "gov_sa.gosi.worklist.action.reopen": "إعادة فتح",
    "gov_sa.gosi.worklist.action.withdraw": "لا يلزم الإبلاغ",
    "gov_sa.gosi.worklist.action.exempt": "غير خاضع للتأمينات",
    "gov_sa.gosi.worklist.action.exempt.field.reason.help": "تظهر الموارد البشرية الموظّف معفًى من هنا.",
    "gov_sa.gosi.worklist.col.can_exempt": "يمكنك وسمه معفًى",
    "gov_sa.gosi.rates.screen.title": "نسب اشتراك التأمينات",
    "gov_sa.gosi.rates.screen.lede": "نسبة مؤرّخة لكل نظام وفرع على الأساسي والسكن حتى الحدّ الأعلى؛ ولا تُستعمل قبل اعتمادها.",
    "gov_sa.gosi.rates.col.scheme": "النظام",
    "gov_sa.gosi.rates.col.branch": "الفرع",
    "gov_sa.gosi.rates.col.effective_from": "من تاريخ",
    "gov_sa.gosi.rates.col.employee_rate": "حصة الموظّف %",
    "gov_sa.gosi.rates.col.employer_rate": "حصة صاحب العمل %",
    "gov_sa.gosi.rates.col.wage_ceiling": "الحد الأعلى للأجر",
    "gov_sa.gosi.rates.col.in_force": "سارٍ اليوم",
    "gov_sa.gosi.rates.col.source": "المصدر",
    "gov_sa.gosi.rates.col.status": "الحالة",
    "gov_sa.gosi.rates.col.note": "ملاحظة",
    "gov_sa.gosi.rates.col.confirmed_at": "اعتُمد",
    "gov_sa.gosi.rates.col.can_confirm": "يمكنك اعتماده",
    "gov_sa.gosi.rates.col.can_withdraw": "يمكنك سحبه",
    "gov_sa.gosi.rates.stat.unconfirmed": "بانتظار الاعتماد",
    "gov_sa.gosi.rates.stat.in_force": "سارية اليوم",
    "gov_sa.gosi.rates.action.import_pack": "تحميل حزمة النسب",
    "gov_sa.gosi.rates.action.add": "إضافة نسبة مؤرّخة",
    "gov_sa.gosi.rates.action.confirm": "اعتماد",
    "gov_sa.gosi.rates.action.withdraw": "سحب",
    "gov_sa.gosi.rates.field.percent.help": "نسبة مئوية: 9، 0.75، 10.5.",
    "gov_sa.gosi.rates.field.wage_floor": "الحد الأدنى للأجر",
    "gov_sa.gosi.rates.field.wage_ceiling.help": "45,000 ريال كما تذكر المصادر — للتأكيد.",
    "gov_sa.gosi.rates.field.note": "المصدر",
    "gov_sa.gosi.rates.field.note.help": "من أين جاء الرقم — يعتمده شخص آخر بعد مطابقته بذلك النص.",
    "gov_sa.gosi.submissions.screen.title": "إرساليات التأمينات",
    "gov_sa.gosi.submissions.screen.lede": "ما أُرسل إلى التأمينات، محاولةً محاولة. الإرسال ليس قبولًا: تُنجز حين تجيب التأمينات برقم مرجعي. والمرفوضة تبقى حتى تُعاد — الإرسالية نفسها مرة أخرى، فلا يُسجَّل أحد مرتين.",
    "gov_sa.gosi.submissions.template_note": "تتبع الملفات قالب هذا المنتج — طابِقه مع صيغة الرفع الجماعي المعتمدة لدى التأمينات قبل التشغيل. لا يتصل شيء هنا بالتأمينات: ارفع الملف على البوابة بنفسك وسجّل ما أجابت به.",
    "gov_sa.gosi.submissions.empty": "لم يُرسل شيء إلى التأمينات بعد",
    "gov_sa.gosi.submissions.empty.detail": "أعدّ إرسالية من مهام التأمينات: تجمع ما ينتظر الإبلاغ في ملف واحد.",
    "gov_sa.gosi.submissions.tab_empty": "لا شيء هنا.",
    "gov_sa.gosi.submissions.attempt": "المحاولة {n}",
    "gov_sa.gosi.submissions.attempts": "المحاولات",
    "gov_sa.gosi.submissions.items": "{count} شخصًا",
    "gov_sa.gosi.submissions.sent_on": "أُرسلت في {day}",
    "gov_sa.gosi.submissions.prepared_at": "أُعدّت في {day}",
    "gov_sa.gosi.submissions.sent_not_accepted": "الإرسال ليس قبولًا: سجّل جواب التأمينات حين يصل.",
    "gov_sa.gosi.submissions.reference": "مرجع التأمينات: {reference}",
    "gov_sa.gosi.submissions.rejected_because": "مرفوضة: {reason}",
    "gov_sa.gosi.submissions.details": "التفاصيل",
    "gov_sa.gosi.submissions.mark_sent": "تسجيل الإرسال",
    "gov_sa.gosi.submissions.mark_sent.detail": "رُفع الملف على البوابة أو أُدخلت البنود فيها يدويًا. لم تُجب التأمينات بعد.",
    "gov_sa.gosi.submissions.sent_day": "تاريخ الإرسال",
    "gov_sa.gosi.submissions.record_answer": "تسجيل جواب التأمينات",
    "gov_sa.gosi.submissions.record_answer.detail": "القبول يغلق كل البنود بمرجع التأمينات. والرفض يبقيها هنا مع السبب حتى تعيد المحاولة.",
    "gov_sa.gosi.submissions.accepted.detail": "أعطت التأمينات رقمًا مرجعيًا للمعاملة.",
    "gov_sa.gosi.submissions.rejected.detail": "رفضتها التأمينات مع ذكر السبب.",
    "gov_sa.gosi.submissions.reference_label": "مرجع التأمينات",
    "gov_sa.gosi.submissions.reason_label": "سبب التأمينات",
    "gov_sa.gosi.submissions.retry": "إعادة المحاولة",
    "gov_sa.gosi.submissions.retry.detail": "المحاولة التالية للإرسالية نفسها: يُكتب الملف من جديد مما تقوله الموارد البشرية الآن. لا يُضاف أحد مرتين.",
    "gov_sa.gosi.submissions.withdraw": "سحب",
    "gov_sa.gosi.submissions.withdraw.detail": "تُترك الإرسالية ويعود أصحابها إلى قائمة المهام.",
    "gov_sa.gosi.submissions.done.sent": "سُجّل الإرسال.",
    "gov_sa.gosi.submissions.done.accepted": "قُبلت: أُغلق كل بند بمرجع التأمينات.",
    "gov_sa.gosi.submissions.done.rejected": "سُجّل الرفض. عالج السبب وأعد المحاولة.",
    "gov_sa.gosi.submissions.done.retried": "أُعدّت من جديد كمحاولة تالية. نزّل الملف الجديد.",
    "gov_sa.gosi.submissions.done.withdrawn": "سُحبت. عاد أصحابها إلى قائمة المهام.",
    "gov_sa.gosi.settings.open": "المهل",
    "gov_sa.gosi.settings.title": "مهل التأمينات",
    "gov_sa.gosi.settings.detail": "الأرقام التي تُحسب منها مواعيد قائمة المهام. القيم الافتراضية هي القراءة التي اعتمدها المالك في 2026-09-26 (15 يوماً للتسجيل وللاستبعاد)، بانتظار مراجعة المحامي.",
    "gov_sa.gosi.settings.register_within_days": "أيام التسجيل بعد المباشرة",
    "gov_sa.gosi.settings.exclude_within_days": "أيام الاستبعاد بعد آخر يوم عمل",
    "gov_sa.gosi.settings.new_scheme_from": "النظام الجديد من",
    "gov_sa.gosi.settings.new_scheme_from.help": "أول تسجيل في هذا اليوم أو بعده يكون على النظام الجديد (المرسوم الملكي م/273).",
    "gov_sa.gosi.settings.maternity_leave_types": "أنواع الإجازة التي هي إجازة أمومة",
    "gov_sa.gosi.settings.maternity_leave_types.help": "أنواع الإجازة التي تُعدّ إجازة أمومة (إجازة الأمومة افتراضياً). يُرسَل عن كل إجازة منها تُمنح إشعار تعويض واحد للتأمينات.",
    "gov_sa.gosi.settings.maternity_notice_within_days": "أيام إشعار التأمينات بإجازة الأمومة",
    "gov_sa.refusal.gosi.type_key": "مفتاح نوع الإجازة حروف لاتينية صغيرة وأرقام ونقطة وشرطة وشرطة سفلية ({key}).",
    "gov_sa.gosi.settings.confirm": "رأي مرجّح بانتظار مراجعة المحامي.",
    "gov_sa.gosi.settings.saved": "حُفظ. تتبع مواعيد البنود الجديدة الأرقام الجديدة.",
    "gov_sa.gosi.reconcile.screen.title": "مطابقة التأمينات",
    "gov_sa.gosi.reconcile.screen.lede": "قارن تقرير «المشتركين النشطين» من بوابة التأمينات بالموارد البشرية: من ينقص في أيٍّ منهما، ومن يختلف أجره أو نظامه.",
    "gov_sa.gosi.reconcile.import": "تقرير التأمينات",
    "gov_sa.gosi.reconcile.import.detail": "صدّر «المشتركين النشطين» من بوابة التأمينات واختر الملف. تُسأل الموارد البشرية عمّن يعمل هنا بصلاحياتك أنت.",
    "gov_sa.gosi.reconcile.file": "ملف التقرير",
    "gov_sa.gosi.reconcile.compare": "قارن مع الموارد البشرية",
    "gov_sa.gosi.reconcile.expected": "الأعمدة المقروءة (تحت أيٍّ من هذه العناوين بالعربية أو الإنجليزية) — ⚠ للتأكيد على تقرير حقيقي:",
    "gov_sa.gosi.reconcile.column.id_number": "رقم الهوية",
    "gov_sa.gosi.reconcile.column.name": "الاسم",
    "gov_sa.gosi.reconcile.column.basic": "الأجر الأساسي",
    "gov_sa.gosi.reconcile.column.housing": "بدل السكن",
    "gov_sa.gosi.reconcile.column.wage": "الأجر الخاضع للاشتراك",
    "gov_sa.gosi.reconcile.column.joined_on": "تاريخ الالتحاق",
    "gov_sa.gosi.reconcile.column.nationality": "الجنسية",
    "gov_sa.gosi.reconcile.column.scheme": "النظام",
    "gov_sa.gosi.reconcile.result": "ما يقوله {file} مقابل الموارد البشرية",
    "gov_sa.gosi.reconcile.rows": "المشتركون في التقرير",
    "gov_sa.gosi.reconcile.matched": "مطابقون للموارد البشرية",
    "gov_sa.gosi.reconcile.mismatches": "الفروقات",
    "gov_sa.gosi.reconcile.all_match": "تتفق التأمينات والموارد البشرية على الجميع.",
    "gov_sa.gosi.reconcile.none_of_kind": "لا شيء من هذا النوع.",
    "gov_sa.gosi.reconcile.hr_says": "الموارد البشرية",
    "gov_sa.gosi.reconcile.gosi_says": "التأمينات",
    "gov_sa.gosi.reconcile.history": "تقارير سابقة",
    "gov_sa.gosi.reconcile.history.empty": "لم يُستورد أي تقرير بعد.",
    "gov_sa.gosi.reconcile.mismatch_count": "{count} فرقًا",
    "gov_sa.refusal.gosi.days": "عدد أيام صحيح من 1 إلى 90.",
    "gov_sa.refusal.gosi.branch_id": "يُختار الفرع من قائمة الفروع.",
    "gov_sa.refusal.gosi.percent": "النسبة مئوية دون 100 بأربع خانات عشرية على الأكثر: 9، 0.75.",
    "gov_sa.refusal.gosi.floor": "يجب أن يكون الحد الأدنى دون الحد الأعلى.",
    "gov_sa.refusal.gosi.rate_exists": "توجد نسبة {branch} للنظام {scheme} تبدأ في {effective_from}.",
    "gov_sa.refusal.gosi.rate_not_unconfirmed": "لا يُعتمد إلا ما لم يُعتمد بعد.",
    "gov_sa.refusal.gosi.rate_own": "من اقترح نسبة لا يؤكّدها؛ يراجعها شخص آخر على نص التأمينات.",
    "gov_sa.refusal.gosi.rate_published": "النسبة المعتمدة نُشرت وقد تكون الرواتب استخدمتها. أضف صفًا بتاريخ لاحق بدلًا من ذلك.",
    "gov_sa.refusal.gosi.item_not_open": "لا يُعدّل هكذا إلا بند مفتوح (هذا {status}).",
    "gov_sa.refusal.gosi.item_not_done": "لا يُعاد فتح إلا بند منجز.",
    "gov_sa.refusal.gosi.item_in_submission": "البند ضمن إرسالية: نتيجتها تغلقه. اسحب الإرسالية لتعديله.",
    "gov_sa.refusal.gosi.done_by_authority": "قبلته التأمينات ضمن إرسالية. صحّحه بإرسالية جديدة لا بإعادة الفتح.",
    "gov_sa.refusal.gosi.not_registration": "النظام للتسجيل فقط.",
    "gov_sa.refusal.gosi.scheme_unknown": "حدّد أولًا النظام الذي سُجّل عليه {employee}.",
    "gov_sa.refusal.gosi.not_refreshed": "لم تذكر الموارد البشرية بيانات {employee} بعد: حدّث المهام من الموارد البشرية.",
    "gov_sa.refusal.gosi.no_effective_day": "تاريخ السريان لـ {employee} غير معروف بعد.",
    "gov_sa.refusal.gosi.items_not_ready": "بعض البنود غير جاهزة للإرسال. عالجها أو استبعدها.",
    "gov_sa.refusal.gosi.item_unavailable": "أحد البنود المذكورة غير مفتوح أو من نوع آخر أو ضمن إرسالية.",
    "gov_sa.refusal.gosi.nothing_to_submit": "لا شيء من هذا النوع ينتظر الإرسال.",
    "gov_sa.refusal.gosi.submission_status": "الإرسالية {status}، وهذه الخطوة لا تنطبق.",
    "gov_sa.refusal.gosi.report_columns": "لا يحوي التقرير عمودًا لـ {missing}. الموجود: {found}.",
    // gov_sa · mudad
    "nav.mudad.files": "ملفات حماية الأجور",
    "nav.mudad.compliance": "الالتزام بحماية الأجور",
    "nav.mudad.establishment": "بيانات المنشأة (مُدد)",
    "nav.mudad.layouts": "قوالب ملفات حماية الأجور",
    "nav.mudad.advances": "ملفات السُّلف",
    "nav.mudad.banks": "البنوك المعتمدة",
    "value.kind.salary": "ملف مُدد",
    "value.kind.direct_transfer": "تحويل مباشر",
    "value.kind.advance": "سلفة",
    "value.source.builtin": "مضمَّن",
    "value.source.data": "مُضاف",
    "value.standing.meets": "ضمن الحد",
    "value.standing.below": "دون الحد",
    "value.standing.no_data": "لا حالة بعد",
    "gov_sa.mudad.file_status.not_generated": "لا ملف بعد",
    "gov_sa.mudad.file_status.generated": "مُنشأ",
    "gov_sa.mudad.file_status.uploaded": "مرفوع",
    "gov_sa.mudad.file_status.status_imported": "استُوردت الحالة",
    "gov_sa.mudad.file_status.withdrawn": "مسحوب",
    "gov_sa.mudad.line_status.none": "لا حالة بعد",
    "gov_sa.mudad.line_status.paid": "مدفوع",
    "gov_sa.mudad.line_status.rejected": "مرفوض",
    "gov_sa.mudad.line_status.pending": "قيد المعالجة",
    "gov_sa.mudad.clock.no_pay_date": "لم يُصرف بعد: تبدأ مهلة حماية الأجور من يوم الصرف.",
    "gov_sa.mudad.clock.on_time": "ارفع على مُدد قبل {due} — بقي {days} يومًا. ⚠ ثلاثون يومًا بعد يوم الصرف، للتأكيد.",
    "gov_sa.mudad.clock.late": "مضى {days} يومًا على {due}: غرامة محتملة {exposure} ريال (3,000 × {workers} عاملًا) وزيارة تفتيش. ⚠ للتأكيد.",
    "gov_sa.mudad.clock.services_frozen": "متأخر {months} أشهر: غرامة محتملة {exposure} ريال، وإيقاف خدمات الوزارة عدا رخص العمل. ⚠ للتأكيد.",
    "gov_sa.mudad.clock.free_transfer": "متأخر {months} أشهر: غرامة محتملة {exposure} ريال، وإيقاف كل الخدمات، ويحق للعمال نقل خدماتهم دون موافقة صاحب العمل. ⚠ للتأكيد.",
    "gov_sa.mudad.files.screen.title": "ملفات حماية الأجور",
    "gov_sa.mudad.files.screen.lede": "ملف حماية الأجور لمسيّر مصروف، يُفحص صفًا صفًا قبل أن يوجد، مع المهلة التي تحسبها الوزارة عليه. ارفعه على مُدد بنفسك وسجّل اليوم هنا، ثم استورد تقرير حالة مُدد — لا يتصل شيء هنا بمُدد أو بالبنك.",
    "gov_sa.mudad.files.template_note": "يتبع الملف القالب المختار — ملف CSV الموثّق لهذا المنتج ما لم يُضف قالب بنك. طابِقه مع قالب البنك أو مُدد قبل التشغيل.",
    "gov_sa.mudad.files.runs": "مسيّرات للإبلاغ",
    "gov_sa.mudad.files.runs.detail": "المسيّرات المعتمدة والمصروفة من الرواتب، مع مهلة حماية الأجور من يوم كل صرف.",
    "gov_sa.mudad.files.payroll_silent": "لم تُجب الرواتب ({reason})؛ تظهر فقط المسيّرات المعروفة لهذه الشاشة.",
    "gov_sa.mudad.files.no_runs": "لا مسيّر معتمد أو مصروف بعد",
    "gov_sa.mudad.files.no_runs.detail": "يظهر المسيّر هنا بعد اعتماده في الرواتب.",
    "gov_sa.mudad.files.pay_date": "صُرف في {day}",
    "gov_sa.mudad.files.not_paid_yet": "معتمد ولم يُصرف بعد",
    "gov_sa.mudad.files.employees": "{count} موظّفًا",
    "gov_sa.mudad.files.generate": "إنشاء ملف حماية الأجور",
    "gov_sa.mudad.files.generate.detail": "يُفحص كل صف أولًا — الآيبان، رقم الهوية، الصافي، إجمالي المسيّر. ومن ليس مسجّلًا في التأمينات أو لا يُصرف له بالبنك يذهب إلى كشف تحويل مباشر منفصل.",
    "gov_sa.mudad.files.layout": "القالب",
    "gov_sa.mudad.files.layout.hint": "أضف قالب البنك الدقيق من شاشة القوالب.",
    "gov_sa.mudad.files.made": "{kind}: {rows} صفًا، {total} ريال",
    "gov_sa.mudad.files.files": "الملفات",
    "gov_sa.mudad.files.none": "لا ملف بعد",
    "gov_sa.mudad.files.none.detail": "أنشئ ملفًا من أحد المسيّرات أعلاه.",
    "gov_sa.mudad.files.tab_empty": "لا شيء هنا.",
    "gov_sa.mudad.files.rows_total": "{rows} صفًا · {total} ريال",
    "gov_sa.mudad.files.uploaded_on": "رُفع في {day}",
    "gov_sa.mudad.files.direct_note": "ليس لمُدد: من ليس مسجّلًا في التأمينات أو لا يُصرف له بالبنك، يُدفع لهم بتحويل مباشر أو يدويًا.",
    "gov_sa.mudad.files.uploaded_not_paid": "الرفع ليس صرفًا: استورد تقرير حالة مُدد لتعرف من صُرف له.",
    "gov_sa.mudad.files.paid_count": "{count} مدفوع",
    "gov_sa.mudad.files.rejected_count": "{count} مرفوض",
    "gov_sa.mudad.files.pending_count": "{count} قيد المعالجة",
    "gov_sa.mudad.files.lines": "الصفوف والحالات",
    "gov_sa.mudad.files.no_iban": "بلا آيبان",
    "gov_sa.mudad.files.withdraw": "سحب",
    "gov_sa.mudad.files.withdraw.detail": "لم يُرفع الملف ولن يُرفع: يمكن إنشاء ملف جديد.",
    "gov_sa.mudad.files.mark_uploaded": "تسجيل الرفع",
    "gov_sa.mudad.files.mark_uploaded.detail": "رفعت الملف على مُدد. تتوقف المهلة هنا؛ ومن صُرف له يأتي مع تقرير الحالة.",
    "gov_sa.mudad.files.uploaded_day": "تاريخ الرفع",
    "gov_sa.mudad.files.import_status": "استيراد تقرير الحالة",
    "gov_sa.mudad.files.import_status.detail": "تقرير حالة الدفع من مُدد لهذا الملف. يُطابق كل صف برقم الهوية، ويُرسل إلى الرواتب مرة واحدة ما لم تُبلَّغ به.",
    "gov_sa.mudad.files.status_report": "تقرير الحالة",
    "gov_sa.mudad.files.import": "استيراد",
    "gov_sa.mudad.files.imports": "التقارير المستوردة",
    "gov_sa.mudad.files.import_counts": "{matched} مطابقًا، {unmatched} ليسوا في الملف",
    "gov_sa.mudad.files.hr_state.sent": "أُبلغت الرواتب",
    "gov_sa.mudad.files.hr_state.failed": "لم تُبلَّغ الرواتب",
    "gov_sa.mudad.files.hr_state.nothing": "لا جديد",
    "gov_sa.mudad.files.hr.sent": "أُبلغت الرواتب بـ {rows} حالة.",
    "gov_sa.mudad.files.hr.failed": "لم تُجب الرواتب: أعد الإرسال من صفوف الملف.",
    "gov_sa.mudad.files.hr.nothing": "كانت الرواتب تعرف كل الحالات.",
    "gov_sa.mudad.files.resend": "أعد الإرسال إلى الرواتب",
    "gov_sa.mudad.files.done.uploaded": "سُجّل الرفع.",
    "gov_sa.mudad.files.done.withdrawn": "سُحب.",
    "gov_sa.mudad.files.done.imported": "استُورد: {paid} مدفوع، {rejected} مرفوض، {pending} قيد المعالجة، {unmatched} ليسوا في الملف.",
    "gov_sa.mudad.files.done.resent": "أُعيد الإرسال.",
    "gov_sa.mudad.compliance.screen.title": "الالتزام بحماية الأجور",
    "gov_sa.mudad.compliance.screen.lede": "نسبة الصرف لكل شهر من تقارير مُدد؛ والحدّ إعداد، فأكّد الحدّ الذي تُحاسَب عليه منشأتك.",
    "gov_sa.mudad.compliance.col.month": "الشهر",
    "gov_sa.mudad.compliance.col.employees": "الموظّفون",
    "gov_sa.mudad.compliance.col.paid": "مدفوع",
    "gov_sa.mudad.compliance.col.rejected": "مرفوض",
    "gov_sa.mudad.compliance.col.pending": "قيد المعالجة",
    "gov_sa.mudad.compliance.col.unknown": "لا حالة بعد",
    "gov_sa.mudad.compliance.col.ratio": "النسبة",
    "gov_sa.mudad.compliance.col.threshold": "الحد",
    "gov_sa.mudad.compliance.col.standing": "الوضع",
    "gov_sa.mudad.compliance.stat.below": "أشهر دون الحد",
    "gov_sa.mudad.compliance.stat.rejected": "تحويلات مرفوضة",
    "gov_sa.mudad.compliance.stat.pending": "تحويلات قيد المعالجة",
    "gov_sa.mudad.compliance.action.threshold": "تحديد الحد",
    "gov_sa.mudad.compliance.field.threshold": "الحد (%)",
    "gov_sa.mudad.compliance.field.threshold.help": "النسبة الشهرية من الموظّفين المصروف لهم عبر حماية الأجور التي تُحاسَب عليها المنشأة. ⚠ 80 أو 90 — للتأكيد.",
    // gov_sa · the compliance page (mudad.establishment)
    "nav.mudad.establishments": "المنشآت",
    "entity.mudad.establishment": "المنشأة",
    "gov_sa.mudad.establishments.title": "المنشآت",
    "gov_sa.mudad.establishments.lede": "ما تطلبه الجهات في صفحة واحدة، لكل منشأة",
    "gov_sa.mudad.establishment.name": "اسم المنشأة",
    "gov_sa.mudad.establishment.name.help": "كيف تُسمّى المنشأة في صفحة الامتثال، مثل «المقر الرئيسي».",
    "screen.mudad.overview.title": "الامتثال",
    "gov_sa.mudad.overview.col.label": "المنشأة",
    "gov_sa.mudad.overview.col.name": "الاسم",
    "gov_sa.mudad.overview.col.wps_run_id": "المسيّر",
    "gov_sa.mudad.overview.col.wps_period": "فترة المسيّر",
    "gov_sa.mudad.overview.col.wps_pay_date": "يوم الصرف",
    "gov_sa.mudad.overview.col.wps_file": "ملف حماية الأجور",
    "gov_sa.mudad.overview.col.wps_due_on": "موعد رفع الملف",
    "gov_sa.mudad.overview.col.wps_days_left": "الأيام المتبقية",
    "gov_sa.mudad.overview.col.wps_stage": "مهلة حماية الأجور",
    "gov_sa.mudad.overview.col.wps_month": "آخر شهر",
    "gov_sa.mudad.overview.col.wps_ratio": "نسبة الالتزام",
    "gov_sa.mudad.overview.col.wps_threshold": "الحد",
    "gov_sa.mudad.overview.col.wps_standing": "الوضع",
    "gov_sa.mudad.overview.col.can_manage": "يملك تعديل البيانات",
    "gov_sa.mudad.overview.wps_file.not_generated": "لم يُنشأ الملف بعد",
    "gov_sa.mudad.overview.wps_file.generated": "أُنشئ ولم يُرفع",
    "gov_sa.mudad.overview.wps_stage.on_time": "ضمن المهلة",
    "gov_sa.mudad.overview.wps_stage.late": "متأخر",
    "gov_sa.mudad.overview.wps_stage.services_frozen": "إيقاف الخدمات",
    "gov_sa.mudad.overview.wps_stage.free_transfer": "نقل الخدمات دون موافقة",
    "gov_sa.mudad.overview.wps_stage.no_pay_date": "بلا يوم صرف",
    "gov_sa.mudad.overview.wps_stage.uploaded": "مرفوع",
    "gov_sa.mudad.overview.action.settings": "بيانات المنشأة",
    "gov_sa.mudad.overview.subtitle.cr": "السجل التجاري {value}",
    "gov_sa.mudad.overview.subtitle.mudad": "مُدد {value}",
    "gov_sa.mudad.overview.monogram": "من",
    "gov_sa.mudad.overview.alert.wps_due": "ملف حماية الأجور للمسيّر المصروف في {wps_pay_date} لم يُرفع إلى مُدد",
    "gov_sa.mudad.overview.alert.wps_below": "المصروف عبر حماية الأجور في {wps_month}: {wps_ratio}%، دون الحد المطلوب {wps_threshold}%",
    "gov_sa.mudad.establishment_wps.title": "حماية الأجور (مُدد) — {month:month}",
    "gov_sa.mudad.establishment_wps.col.month": "الشهر",
    "gov_sa.mudad.establishment_wps.col.standing": "مقابل الحد",
    "gov_sa.mudad.establishment_wps.standing.meets": "يحقق الحد",
    "gov_sa.mudad.establishment_wps.standing.below": "دون الحد",
    "gov_sa.mudad.establishment_wps.standing.no_data": "بلا حالة بعد",
    "gov_sa.mudad.establishment_wps.col.paid": "المقبول",
    "gov_sa.mudad.establishment_wps.paid_words": "{paid} من {employees}",
    "gov_sa.mudad.establishment_wps.col.rejected": "المرفوض",
    "gov_sa.mudad.establishment_wps.col.ratio": "نسبة الالتزام",
    "gov_sa.mudad.establishment_wps.ratio_words": "{ratio}%",
    "gov_sa.mudad.establishment_wps.col.top_reason": "سبب الرفض",
    "gov_sa.mudad.establishment_wps.link": "ملفات مُدد",
    "gov_sa.mudad.establishment_wps.empty": "لم يُستورد تقرير حالة من مُدد بعد.",
    "gov_sa.gosi.establishment.title": "التأمينات الاجتماعية",
    "gov_sa.gosi.establishment.col.kind": "البند",
    "gov_sa.gosi.establishment.kind.register": "تسجيل",
    "gov_sa.gosi.establishment.kind.wage_update": "تعديل أجر",
    "gov_sa.gosi.establishment.kind.exclude": "استبعاد",
    "gov_sa.gosi.establishment.col.stage": "الحالة",
    "gov_sa.gosi.establishment.stage.waiting": "لم يباشر بعد",
    "gov_sa.gosi.establishment.stage.to_report": "للإبلاغ",
    "gov_sa.gosi.establishment.stage.in_submission": "ضمن تقديم",
    "gov_sa.gosi.establishment.col.employment_id": "التوظيف",
    "gov_sa.gosi.establishment.link": "قائمة التأمينات",
    "gov_sa.gosi.establishment.empty": "لا شيء بانتظار الإبلاغ للتأمينات.",
    "gov_sa.gosi.establishment.due.title": "بنود التأمينات للإبلاغ",
    "gov_sa.gosi.establishment.due.alert": "بنود للإبلاغ إلى التأمينات: {count}",
    "gov_sa.gosi.establishment.reconciliation.title": "المطابقة الشهرية مع التأمينات",
    "gov_sa.gosi.establishment.reconciliation.col.mismatches": "الفروق",
    "gov_sa.gosi.establishment.reconciliation.col.differs": "فيها فروق",
    "gov_sa.gosi.establishment.reconciliation.alert": "المطابقة الشهرية مع التأمينات: {mismatches}",
    "unit.differences.zero": "{n} فرق",
    "unit.differences.one": "فرق واحد",
    "unit.differences.two": "فرقان",
    "unit.differences.few": "{n} فروق",
    "unit.differences.many": "{n} فرقاً",
    "unit.differences.other": "{n} فرق",
    "gov_sa.mudad.establishment.screen.title": "بيانات المنشأة (مُدد)",
    "gov_sa.mudad.establishment.screen.lede": "كيف تعرف الوزارة ومُدد والبنك هذه المنشأة، وأرقام حماية الأجور التي تُحسب بها المهلة ونسبة الالتزام. كل رقم عليه ⚠ للتأكيد قبل التشغيل.",
    "gov_sa.mudad.establishment.identity": "المنشأة",
    "gov_sa.mudad.establishment.identity.detail": "تُفحص صيغتها عند الحفظ؛ ويحملها ملف حماية الأجور.",
    "gov_sa.mudad.establishment.figures": "أرقام حماية الأجور ⚠",
    "gov_sa.mudad.establishment.figures.detail": "ما تُحسب به المهلة والغرامة والنسبة. القيم الافتراضية مما تذكره المصادر العامة؛ أكّد كلًّا منها.",
    "gov_sa.mudad.establishment.read_only": "يمكنك رؤية هذه الإعدادات؛ وتعديلها يتطلب صلاحية إعدادات المنشأة.",
    "gov_sa.mudad.establishment.saved": "حُفظ.",
    "gov_sa.mudad.establishment.cr_number": "السجل التجاري",
    "gov_sa.mudad.establishment.cr_number.help": "عشرة أرقام.",
    "gov_sa.mudad.establishment.unified_number": "الرقم الموحّد",
    "gov_sa.mudad.establishment.unified_number.help": "رقم المنشأة لدى الوزارة: عشرة أرقام تبدأ بـ 7 (700…).",
    "gov_sa.mudad.establishment.mudad_establishment_id": "رقم المنشأة في مُدد",
    "gov_sa.mudad.establishment.mudad_establishment_id.help": "كما تُظهره مُدد بعد تسجيل المنشأة.",
    "gov_sa.mudad.establishment.bank_name": "البنك",
    "gov_sa.mudad.establishment.bank_name.help": "البنك الذي تُصرف منه الأجور.",
    "gov_sa.mudad.establishment.account_iban": "آيبان المنشأة",
    "gov_sa.mudad.establishment.account_iban.help": "SA و22 رقمًا؛ تُتحقق أرقام التحقق فيه.",
    "gov_sa.mudad.establishment.bank_code": "رمز البنك",
    "gov_sa.mudad.establishment.bank_code.help": "رقمان: الخانتان 5–6 من الآيبان.",
    "gov_sa.mudad.establishment.signatory_name": "المفوَّض بالتوقيع",
    "gov_sa.mudad.establishment.signatory_name.help": "من يعتمد المدفوعات في مُدد والبنك.",
    "gov_sa.mudad.establishment.signatory_id_number": "رقم هوية المفوَّض",
    "gov_sa.mudad.establishment.signatory_id_number.help": "هوية وطنية (1…) أو إقامة (2…).",
    "gov_sa.mudad.establishment.default_layout": "قالب الملف الافتراضي",
    "gov_sa.mudad.establishment.default_layout.help": "ما يُكتب به الملف ما لم يُختر قالب آخر.",
    "gov_sa.mudad.establishment.upload_window_days": "أيام الرفع بعد يوم الصرف",
    "gov_sa.mudad.establishment.upload_window_days.help": "⚠ ثلاثون منذ 1 مارس 2025 (كانت ستين).",
    "gov_sa.mudad.establishment.fine_per_worker": "الغرامة عن كل عامل (ريال)",
    "gov_sa.mudad.establishment.fine_per_worker.help": "⚠ 3,000 وفق صفحة الوزارة؛ ولم يُقرأ جدول المخالفات لعام 2026.",
    "gov_sa.mudad.establishment.freeze_after_months": "أشهر التأخر قبل إيقاف الخدمات",
    "gov_sa.mudad.establishment.freeze_after_months.help": "⚠ شهران.",
    "gov_sa.mudad.establishment.transfer_after_months": "أشهر التأخر قبل النقل دون موافقة",
    "gov_sa.mudad.establishment.transfer_after_months.help": "⚠ ثلاثة أشهر.",
    "gov_sa.mudad.establishment.compliance_threshold": "حد الالتزام (%)",
    "gov_sa.mudad.establishment.compliance_threshold.help": "⚠ 80 أو 90 — تختلف المصادر.",
    "gov_sa.mudad.layouts.screen.title": "قوالب ملفات حماية الأجور",
    "gov_sa.mudad.layouts.screen.lede": "قوالب ملفات حماية الأجور؛ طابِق كل قالب مع قالب البنك أو مُدد قبل التشغيل.",
    "gov_sa.mudad.layouts.col.key": "المفتاح",
    "gov_sa.mudad.layouts.col.name": "الاسم",
    "gov_sa.mudad.layouts.col.source": "النوع",
    "gov_sa.mudad.layouts.col.status": "الحالة",
    "gov_sa.mudad.layouts.col.created_at": "أُضيف",
    "gov_sa.mudad.layouts.col.can_retire": "يمكنك إيقافه",
    "gov_sa.mudad.layouts.action.add": "إضافة قالب بنك",
    "gov_sa.mudad.layouts.action.retire": "إيقاف",
    "gov_sa.mudad.advances.screen.title": "ملفات السُّلف",
    "gov_sa.mudad.advances.screen.lede": "لكل سلفة مصروفة ملف حماية أجور بعلامة السلفة، منفصل عن ملف المسيّر.",
    "gov_sa.mudad.advances.col.employment_id": "الموظّف",
    "gov_sa.mudad.advances.col.paid_on": "تاريخ الصرف",
    "gov_sa.mudad.advances.col.file_status": "الملف",
    "gov_sa.mudad.advances.col.filename": "اسم الملف",
    "gov_sa.mudad.advances.col.total": "المبلغ",
    "gov_sa.mudad.advances.col.run_id": "المسيّر",
    "gov_sa.mudad.advances.col.advance_id": "السلفة",
    "gov_sa.mudad.advances.col.can_generate": "يمكنك كتابة ملفها",
    "gov_sa.mudad.advances.file_status.not_generated": "لم يُكتب",
    "gov_sa.mudad.advances.file_status.generated": "مكتوب",
    "gov_sa.mudad.advances.file_status.uploaded": "مرفوع",
    "gov_sa.mudad.advances.file_status.status_imported": "استُورِدت حالته",
    "gov_sa.mudad.advances.action.generate": "كتابة ملف السلفة",
    "gov_sa.mudad.banks.screen.title": "البنوك المعتمدة",
    "gov_sa.mudad.banks.screen.lede": "البنوك التي تصرف عبرها مساحة العمل؛ وما دام فيها بنك معتمد يُرفض السطر لبنك غير مدرج.",
    "gov_sa.mudad.banks.col.code": "الرمز",
    "gov_sa.mudad.banks.col.name_ar": "الاسم",
    "gov_sa.mudad.banks.col.name_en": "الاسم بالإنجليزية",
    "gov_sa.mudad.banks.col.bic": "رمز سويفت",
    "gov_sa.mudad.banks.col.valid_from": "من",
    "gov_sa.mudad.banks.col.lines": "صفوف صُرفت عبره",
    "gov_sa.mudad.banks.col.status": "الحالة",
    "gov_sa.mudad.banks.col.can_retire": "يمكنك إيقافه",
    "gov_sa.mudad.banks.status.approved": "معتمد",
    "gov_sa.mudad.banks.status.retired": "موقوف",
    "gov_sa.mudad.banks.action.add": "اعتماد بنك",
    "gov_sa.mudad.banks.action.retire": "إيقاف",
    "gov_sa.mudad.banks.field.code.help": "الرقمان اللذان يحملهما الآيبان السعودي بعد SA وخانتي التحقق (SA03 80…: 80).",
    "gov_sa.mudad.layouts.field.key.help": "حروف إنجليزية صغيرة وأرقام وشرطة: alrajhi-sif.",
    "gov_sa.mudad.layouts.field.spec": "القالب (JSON)",
    "gov_sa.mudad.layouts.field.spec.help": "delimiter (\",\" \";\" \"|\" أو \"\" للعرض الثابت)، وheader_row وbom وeol ‏(crlf|lf) وextension ‏(csv|txt)، وrecords.header / line / footer: قوائم أعمدة، كلٌّ منها حقل (line.id_number، line.iban، line.net، file.total، file.rows، establishment.unified_number …) أو نص ثابت، مع format ‏(amount، halalas، yyyymmdd، ddmmyyyy، hhmm، digits) وwidth.",
    "gov_sa.refusal.mudad.iban_missing": "الصف {row} ‏({employee}) يُصرف له بالبنك وليس له آيبان.",
    "gov_sa.refusal.mudad.iban_shape": "الصف {row} ‏({employee}): الآيبان SA و22 رقمًا.",
    "gov_sa.refusal.mudad.iban_checksum": "الصف {row} ‏({employee}): الآيبان لا يجتاز أرقام التحقق.",
    "gov_sa.refusal.mudad.bank_code": "رمز البنك {bank_code} ليس رمز الآيبان ({iban_bank}).",
    "gov_sa.refusal.mudad.bank_code_shape": "رمز البنك هو الرقمان اللذان يحملهما الآيبان السعودي بعد SA وخانتي التحقق.",
    "gov_sa.refusal.mudad.id_missing": "الصف {row} ‏({employee}) بلا رقم هوية.",
    "gov_sa.refusal.mudad.id_type": "الصف {row} ‏({employee}): نوع هوية لا يعرفه الملف.",
    "gov_sa.refusal.mudad.id_shape": "الصف {row} ‏({employee}): الرقم ليس بصيغة {id_type} (الهوية الوطنية 1…، الإقامة 2…، عشرة أرقام).",
    "gov_sa.refusal.mudad.amount": "الصف {row} ‏({employee}): {fields} ليس مبلغًا.",
    "gov_sa.refusal.mudad.net": "الصف {row} ‏({employee}): الصافي {net} لا يساوي الأساسي + السكن + النقل + البدلات الأخرى − الاستقطاعات ({expected}).",
    "gov_sa.refusal.mudad.net_negative": "الصف {row} ‏({employee}): لا يُحوَّل صافٍ سالب ({net}).",
    "gov_sa.refusal.mudad.total": "مجموع الصفوف {lines} وصافي المسيّر {run}.",
    "gov_sa.refusal.mudad.advance_unknown": "لم تقل الرواتب إنها صرفت هذه السلفة.",
    "gov_sa.refusal.mudad.advance_lines_unavailable": "لم تُجب الرواتب عن هذه السلفة ({reason})، فلم يُكتب ملف.",
    "gov_sa.refusal.mudad.advance_other": "سطر الرواتب لسلفة أو موظّف آخر ({answered}).",
    "gov_sa.refusal.mudad.advance_general": "ملف السلفة لا يحمل الاستحقاق العام أبداً: السطر يحمل {fields}.",
    "gov_sa.refusal.mudad.advance_amount": "السلفة ليست مبلغاً أكبر من صفر.",
    "gov_sa.refusal.mudad.bank_not_approved": "الصف {row} ({name}): الآيبان يسمّي البنك {bank_code}، وهو غير معتمد في السجل يوم الصرف.",
    "gov_sa.warning.mudad.banks_empty": "لا بنك معتمداً في السجل بعد، فلم تُفحص البنوك.",
    "gov_sa.refusal.mudad.bic_shape": "رمز سويفت السعودي أربعة حروف ثم SA ثم خانتان وفرع اختياري.",
    "gov_sa.refusal.mudad.bank_exists": "البنك {code} معتمد من قبل؛ أوقفه قبل اعتماد صف آخر.",
    "gov_sa.refusal.mudad.bank_retired": "البنك موقوف من قبل.",
    "gov_sa.refusal.mudad.run_total_unknown": "لم تذكر الرواتب صافي المسيّر.",
    "gov_sa.refusal.mudad.file_invalid": "في صفوف المسيّر مشكلات؛ لم يُكتب أي ملف.",
    "gov_sa.refusal.mudad.run_unknown": "لا يوجد هذا المسيّر في الرواتب.",
    "gov_sa.refusal.mudad.run_status": "المسيّر {status}: يُكتب ملف حماية الأجور لمسيّر معتمد أو مصروف.",
    "gov_sa.refusal.mudad.no_lines": "لا صفوف تحويل في المسيّر.",
    "gov_sa.refusal.mudad.file_exists": "يوجد ملف {kind} لهذا المسيّر ({status}). اسحبه قبل كتابة غيره.",
    "gov_sa.refusal.mudad.file_status": "الملف {status}، وهذه الخطوة لا تنطبق.",
    "gov_sa.refusal.mudad.file_withdrawn": "لا يُسلَّم ملف مسحوب.",
    "gov_sa.refusal.mudad.not_for_mudad": "كشف التحويل المباشر لا يُرفع على مُدد.",
    "gov_sa.refusal.mudad.establishment_missing": "يحتاج القالب {field} للمنشأة: أدخله في شاشة بيانات المنشأة.",
    "gov_sa.refusal.mudad.cr_number": "رقم السجل التجاري عشرة أرقام.",
    "gov_sa.refusal.mudad.unified_number": "الرقم الموحّد عشرة أرقام تبدأ بـ 7.",
    "gov_sa.refusal.mudad.signatory_id": "رقم هوية المفوَّض عشرة أرقام تبدأ بـ 1 أو 2.",
    "gov_sa.refusal.mudad.layout_key": "مفتاح القالب حروف صغيرة وأرقام وشرطة أو شرطة سفلية، وليس «default».",
    "gov_sa.refusal.mudad.layout_key_taken": "هذا المفتاح مستخدم.",
    "gov_sa.refusal.mudad.layout_spec": "القالب غير صالح: {detail}",
    "gov_sa.refusal.mudad.layout_unknown": "لا قالب نشط بهذا المفتاح.",
    "gov_sa.refusal.mudad.layout_retired": "القالب موقوف من قبل.",
    "gov_sa.refusal.mudad.layout_in_use": "هذا القالب الافتراضي للمنشأة؛ اختر غيره أولًا.",
    "gov_sa.refusal.mudad.report_columns": "لا يحوي التقرير عمودًا لـ {missing}. الموجود: {found}.",
    "gov_sa.refusal.mudad.no_import": "لم يُستورد تقرير حالة لهذا الملف.",
    "gov_sa.warning.mudad.id_check_digit": "الصف {row} ‏({employee}): رقم التحقق في الهوية لا يتطابق. أُبقي الصف — ⚠ الخوارزمية غير مؤكدة؛ راجع الرقم.",
    // identity · member ↔ person (#58)
    "screen.identity.people.column.person": "الشخص",
    "screen.identity.people.action.link_person": "هذا المستخدم هو…",
    "screen.identity.people.action.link_person.field.party_id": "الشخص",
    "screen.identity.people.action.link_person.field.party_id.help": "الشخص المسجَّل الذي يمثّله هذا المستخدم. لا يُعرض إلا من لم يُربط بمستخدم آخر. من دخوله التالي يرى وظيفته وكشوف راتبه وإجازاته وحضوره هو وحده.",
    "screen.identity.people.action.unlink_person": "فكّ الربط بالشخص",
    "screen.identity.people.action.unlink_person.field.reason": "السبب",
    "screen.identity.people.action.unlink_person.field.reason.help": "يُحفظ في سجل النشاط. تنتهي جلساته في مساحة العمل هذه، فلا يبقى شيء يعرض له بيانات ذلك الشخص.",
    "member.field.person": "الشخص",
    "member.person.none": "غير مربوط بشخص",
    "member.field.service_ends_on": "آخر يوم عمل",
    "member.field.source": "طريقة الانضمام",
    "member.source.bootstrap": "أنشأ مساحة العمل",
    "member.source.invitation": "قبِل دعوة",
    "member.source.added": "أضافه مسؤول",
    "member.source.admin_invitation": "قبِل دعوة من مسؤول",
    "member.source.unrecorded": "غير مسجّلة (انضمّ قبل تسجيلها)",
    "member.field.service_end_kept": "انتهاء الخدمة",
    "member.serviceEndKept": "أنهت الموارد البشرية خدمة هذا الشخص ({ref}). أُبقي هذا الدخول لأنه لم يأتِ من التوظيف ويحمل أدواراً أخرى؛ راجِع أدواره.",
    // hr · self_service (#58)
    "group.self_service": "خدماتي",
    "value.has_geofence.true": "محدّد",
    "value.has_geofence.false": "غير محدّد",
    "value.invitation.not_asked": "لم تُطلب",
    "value.invitation.sent": "أُنشئت — انسخ الرمز أدناه",
    "value.invitation.forbidden": "لم تُنشأ: لا تملك صلاحية الدعوة أو منح دور «موظّف»",
    "value.invitation.already_linked": "لم تُنشأ: العنوان مستخدم مسبقاً أو الشخص مربوط بمستخدم",
    "value.invitation.unavailable": "لم تُنشأ: خدمة الدخول لم تستجب — ادعُه من شاشة المستخدمين",
    // التعيين صفحةً، وربط الموظّف الجديد بمستخدم موجود في مساحة العمل.
    "value.system_access.none": "بلا وصول إلى النظام",
    "value.system_access.invite": "دعوته بالبريد الإلكتروني",
    "value.system_access.user": "ربطه بمستخدم موجود",
    "value.user_link.not_asked": "لم يُطلب",
    "value.user_link.linked": "رُبط — يرى سجلّاته من دخوله التالي",
    "value.user_link.forbidden": "لم يُربط: لا تملك صلاحية ربط المستخدمين بالأشخاص",
    "value.user_link.already_linked": "لم يُربط: المستخدم مرتبط بشخص آخر، أو الشخص مرتبط بمستخدم آخر",
    "value.user_link.refused": "لم يُربط: رفضته خدمة الدخول — السبب أدناه",
    "value.user_link.unavailable": "لم يُربط: خدمة الدخول لم تستجب — اربطه من شاشة المستخدمين",
    // جدول القائمة يعرض خمسة أعمدة (ثلاثة على الهاتف)، والباقي يُفتح تحت الصف.
    'list.columns.shown': 'تُعرض {shown} أعمدة من {total}',
    'list.columns.all': 'عرض كل الأعمدة',
    'list.stat.narrow': 'عرض الصفوف التي تعدّها هذه البطاقة فقط',
    'list.columns.few': 'عرض {n} أعمدة',
    'list.expand.head': 'باقي الأعمدة',
    'list.row.expand': 'عرض باقي الأعمدة',
    'list.row.collapse': 'طيّ',
    'list.folded.options': 'الترتيب أو الفلترة بباقي الأعمدة',
    'list.folded.asc': '{column} — تصاعدياً',
    'list.folded.desc': '{column} — تنازلياً',
    'list.folded.filter': 'فلترة حسب {column}…',
    'list.export.columns.heads': 'أعمدة الجدول الظاهرة ({n})',
    "record.position": "{at} من {of}",
    "record.prev": "السابق",
    "record.next": "التالي",
    "record.back": "العودة إلى {list}",
    "record.more": "إجراءات أخرى",
    "record.tab.overview": "نظرة عامة",
    "record.tab.history": "سجل التعديلات",
    "record.alert.act": "مطلوب منك",
    "record.alert.wait": "بانتظار غيرك",
    "record.alert.info": "للعلم",
    "record.alert.more": "+{n} مطلوبة منك",
    "record.alert.open": "افتحه",
    "record.door.own": "ملفك",
    "record.door.team": "بصفتك مديراً",
    "record.card.asOf": "كما في {at}",
    "record.due.late": "متأخر {days}",
    "record.due.today": "اليوم",
    "record.due.in": "بعد {days}",
    "record.change.direct": "تعديل مباشر",
    "record.change.correction": "طلب تصحيح",
    "record.change.decision": "بقرار",
    "record.change.immutable": "لا يتغيّر",
    "record.show": "إظهار",
    "record.hide": "إخفاء",
    "record.card.forbidden": "لا تملك صلاحية عرض هذا القسم",
    "record.card.unavailable": "تعذّر تحميل {title} الآن",
    "record.card.timeout": "تأخّر {title} في الردّ",
    "record.open": "افتح السجل",
    "record.open.named": "افتح السجل: {name}",
    "ref.col.employment": "الموظّف",
    "ref.col.manager": "المدير",
    "ref.col.department": "الإدارة",
    "ref.col.candidate": "المرشّح",
    "ref.col.party": "الطرف",
    "ref.col.item": "الأصل",
    "record.card.all": "عرض الكل",
    "record.card.ungrouped": "بلا تصنيف",
    "record.card.allCount": "عرض الكل ({n})",
    "record.card.meter.of": "{figure} من {whole}",
    "record.card.meter.share": "{share}٪",
    "record.card.meter.none": "لم يُحدَّد هدف",
    "record.cards.more": "{n:more_sections}",
    "record.cards.fewer": "عرض بطاقات أقل",
    "record.from": "من {module}",
    "record.via": "عبر {entity}",
    "record.asIssued": "كما عند الإصدار",
    "record.notFound": "لم يُعثر على هذا الملف، أو أنه ليس في هذه المساحة",
    "record.navLabel": "التنقل في القائمة",
    "record.headLabel": "رأس الملف",
    "record.alertsLabel": "التنبيهات",
    "screen.invoicing.document.action.pay": "تسجيل دفعة",
    "screen.invoicing.document.title": "فاتورة",
    "screen.invoicing.document.column.party_name": "العميل كما عند الإصدار",
    "screen.invoicing.document.column.party_vat": "الرقم الضريبي",
    "screen.invoicing.document.column.supply_on": "تاريخ التوريد",
    "screen.invoicing.document.column.due_on": "الاستحقاق",
    "screen.invoicing.document.column.allocated_total": "المسدَّد",
    "screen.invoicing.document.column.open_amount": "المتبقي",
    "screen.invoicing.document.column.can_pay": "قابلة للسداد",
    "screen.invoicing.document.column.journal_entry_id": "القيد المحاسبي",
    "screen.invoicing.document.alert.payment_due": "متبقٍّ عليها مبلغ — سجّل دفعة أو وزّع واحدة",
    // ── finance record pages (begin) ──
    "unit.days.zero": "{n} يوم",
    "unit.days.one": "يوم واحد",
    "unit.days.two": "يومين",
    "unit.days.few": "{n} أيام",
    "unit.days.many": "{n} يوماً",
    "unit.days.other": "{n} يوم",
    "unit.results.zero": "لا نتائج",
    "unit.results.one": "نتيجة واحدة",
    "unit.results.two": "نتيجتان",
    "unit.results.few": "{n} نتائج",
    "unit.results.many": "{n} نتيجة",
    "unit.results.other": "{n} نتيجة",
    "unit.more_sections.zero": "لا بطاقات أخرى",
    "unit.more_sections.one": "بطاقة أخرى",
    "unit.more_sections.two": "بطاقتان أخريان",
    "unit.more_sections.few": "{n} بطاقات أخرى",
    "unit.more_sections.many": "{n} بطاقة أخرى",
    "unit.more_sections.other": "{n} بطاقة أخرى",
    "record.history.note": "تغييرات حقول هذا الملف فقط؛ قرارات المديولات الأخرى تبقى في بطاقاتها. الخط الزمني المدمج مرحلة لاحقة.",
    "screen.accounting.entry_lines_tab.title": "القيد",
    "screen.invoicing.vendor_bill.title": "فاتورة مورد",
    "screen.invoicing.vendor_bill.monogram": "مو",
    "screen.invoicing.vendor_bill.column.party_name": "المورد كما عند الإصدار",
    "screen.invoicing.vendor_bill.column.party_residency": "الإقامة",
    "screen.invoicing.vendor_bill.residency.resident": "مورد مقيم",
    "screen.invoicing.vendor_bill.residency.non_resident": "مورد غير مقيم",
    "screen.invoicing.vendor_bill.column.tax_total": "ضريبة المدخلات",
    "screen.invoicing.vendor_bill.column.withholding_total": "ضريبة الاستقطاع",
    "screen.invoicing.vendor_bill.input_vat.deductible": "قابلة للخصم",
    "screen.invoicing.vendor_bill.input_vat.partly": "قابلة للخصم جزئياً",
    "screen.invoicing.vendor_bill.input_vat.not_deductible": "غير قابلة للخصم",
    "screen.invoicing.vendor_bill.input_vat.none_charged": "لا ضريبة عليها",
    "screen.invoicing.vendor_bill.column.vat_quarter": "الإقرار الضريبي",
    "screen.invoicing.vendor_bill.quarter.q1": "الأول",
    "screen.invoicing.vendor_bill.quarter.q2": "الثاني",
    "screen.invoicing.vendor_bill.quarter.q3": "الثالث",
    "screen.invoicing.vendor_bill.quarter.q4": "الرابع",
    "screen.invoicing.vendor_bill.column.withholding_standing": "المورد",
    "screen.invoicing.vendor_bill.withholding.resident_exempt": "مقيم · لا يخضع",
    "screen.invoicing.vendor_bill.withholding.non_resident_withheld": "غير مقيم · يخضع",
    "screen.invoicing.vendor_bill.withholding.non_resident_none": 'غير مقيم · لا ضريبة استقطاع',
    "screen.invoicing.vendor_bill.withholding.amount": "المبلغ",
    "screen.invoicing.vendor_bill.withholding.note": 'لغير المقيم تُحسب نسبة ضريبة الاستقطاع من نوع الخدمة، وتظهر في بيان ضريبة الاستقطاع الشهري',
    "screen.invoicing.vendor_bill.action.pay": "سداد",
    "screen.invoicing.vendor_bill.alert.overdue": "السداد كان مستحقاً {due_on}",
    "screen.invoicing.vendor_bill.alert.payment_due": "السداد مستحق {due_on}",
    "screen.invoicing.vendor_bill.alert.input_vat": "ضريبة المدخلات {tax_total} تُخصم في إقرار الربع {vat_quarter}",
    "screen.invoicing.vendor_bill.due.late": "متأخرة {days}",
    "screen.invoicing.vendor_bill.due.today": "مستحقة اليوم",
    "screen.invoicing.vendor_bill.due.in": "بعد {days}",
    "screen.invoicing.vendor_bill.line.tax": "{tax_amount:money} · {tax_rate_snapshot:number}%",
    "screen.invoicing.vendor_bill.line.deductible": "قابلة للخصم",
    "screen.invoicing.vendor_bill.deductible.full": "نعم",
    "screen.invoicing.vendor_bill.deductible.partial": "جزئياً",
    "screen.invoicing.vendor_bill.deductible.none": "لا",
    "screen.invoicing.vendor_bill.lines.note": "فاتورة المورد المرحّلة لا تُعدَّل: التصحيح بإشعار دائن أو مدين يشير إليها.",
    "screen.invoicing.vendor_bill.tab.withholding": 'ضريبة الاستقطاع',
    "screen.invoicing.vendor_bill.card.payment.empty": "لم تُسدَّد بعد.",
    "screen.invoicing.payment.title": "دفعة",
    "screen.invoicing.payment.head": "دفعة {reference}",
    "screen.invoicing.payment.column.reference": "المرجع",
    "screen.invoicing.payment.method.bank": "تحويل بنكي",
    "screen.invoicing.payment.method.cash": "نقداً",
    "screen.invoicing.payment.method.other": "طريقة أخرى",
    "screen.invoicing.payment.column.paid_on": "التاريخ",
    "screen.invoicing.payment.column.allocated_total": "الموزع",
    "screen.invoicing.payment.column.open_amount": "غير الموزع",
    "screen.invoicing.payment.column.journal_name": "الحساب البنكي",
    "screen.invoicing.payment.column.allocation_state": "التوزيع",
    "screen.invoicing.payment.allocation.unallocated": "غير موزعة",
    "screen.invoicing.payment.allocation.partial": "موزعة جزئياً",
    "screen.invoicing.payment.allocation.allocated": "موزعة",
    "screen.invoicing.payment.column.bank_match": "المطابقة البنكية",
    "screen.invoicing.payment.bank_match.matched": "مطابقة",
    "screen.invoicing.payment.bank_match.unmatched": "غير مطابقة",
    "screen.invoicing.payment.bank_match.words": "مطابقة لسطر {bank_statement_on:moment}",
    "screen.invoicing.payment.column.bank_statement_on": "كشف",
    "screen.invoicing.payment.column.bank_line_no": "السطر",
    "screen.invoicing.payment.column.bank_match_kind": "نوع المطابقة",
    "screen.invoicing.payment.match_kind.item": "بند",
    "screen.invoicing.payment.match_kind.bank_charge": "رسوم بنكية",
    "screen.invoicing.payment.column.can_allocate": "قابلة للتوزيع",
    "screen.invoicing.payment.column.has_suggestion": "لها توزيع مقترح",
    "screen.invoicing.payment.action.allocate": "توزيع على فواتير",
    "screen.invoicing.payment.action.save_allocation": "حفظ التوزيع",
    "screen.invoicing.payment.alert.unallocated": "{open_amount} غير موزعة؛ التوزيع المقترح جاهز للحفظ",
    "screen.invoicing.payment.alert.nothing_open": "{open_amount} غير موزعة، ولا مستند مفتوح للطرف نفسه يوزَّع عليه",
    "screen.invoicing.payment.alert.bank_matched": "مطابقة لسطر #{bank_line_no} في كشف {journal_name} {bank_statement_on}",
    "screen.invoicing.payment.tab.allocation": "التوزيع",
    "screen.invoicing.payment.tab.matching": "المطابقة",
    "screen.invoicing.payment.suggestion.title": "التوزيع المقترح",
    "screen.invoicing.payment.suggestion.column.number": "الفاتورة",
    "screen.invoicing.payment.suggestion.column.amount": "يوزَّع",
    "screen.invoicing.payment.suggestion.empty": "لا توزيع مقترح: الدفعة موزعة، أو لا مستند مفتوح للطرف.",
    "screen.invoicing.payment.suggestion.note": "الأقدم استحقاقاً أولاً؛ يمكن تغيير المبالغ قبل الحفظ",
    "screen.invoicing.payment.allocations.title": "التوزيعات",
    "screen.invoicing.payment.allocations.empty": "لم يوزَّع شيء من هذه الدفعة بعد.",
    "screen.invoicing.payment.bank.statement": "{journal_name} · {bank_statement_on:moment}",
    "screen.invoicing.payment.bank.line": "{bank_line_amount:money} · #{bank_line_no}",
    "screen.invoicing.payment.bank.empty": "لم تُطابَق بسطر في كشف بعد.",
    "screen.invoicing.payment.subtitle.provider_ref": "مرجع البنك {value}",
    "screen.accounting.entry_lines.open_number": "فتح القيد {entry_number}",
    "screen.accounting.entry.title": "قيد",
    "screen.accounting.entry.head": "قيد {display_number}",
    "screen.accounting.entry.state.posted": "مرحّل",
    "screen.accounting.entry.state.draft": "مسودة",
    "screen.accounting.entry.state.reversed": "معكوس",
    "screen.accounting.entry.column.journal_name": "الدفتر",
    "screen.accounting.entry.column.period_name": "الفترة",
    "screen.accounting.entry.period_status.open": "مفتوحة",
    "screen.accounting.entry.period_status.closing": "قيد الإقفال",
    "screen.accounting.entry.period_status.closed": "مقفلة",
    "screen.accounting.entry.period_status.reopened": "أُعيد فتحها",
    "screen.accounting.entry.column.source_module": "المصدر",
    "screen.accounting.entry.source_module.invoicing": "الفوترة",
    "screen.accounting.entry.source_module.payroll": "الرواتب",
    "screen.accounting.entry.column.poster": "رحّله",
    "screen.accounting.entry.poster.system": "النظام (قاعدة ترحيل)",
    "screen.accounting.entry.poster.person": "مستخدم",
    "screen.accounting.entry.column.posted_at": "وقت الترحيل",
    "screen.accounting.entry.posted_at": "{posted_at:at}",
    "screen.accounting.entry.column.debit_total": "مدين = دائن",
    "screen.accounting.entry.column.balance": "التوازن",
    "screen.accounting.entry.balance.balanced": "متوازن",
    "screen.accounting.entry.balance.unbalanced": "غير متوازن",
    "screen.accounting.entry.column.reversed_by_number": "عكسه",
    "screen.accounting.entry.column.reversal_of_number": "يعكس",
    "screen.accounting.entry.column.reverse_reason": "السبب",
    "screen.accounting.entry.column.reversal_state": "العكس",
    "screen.accounting.entry.reversal.none": "غير معكوس",
    "screen.accounting.entry.reversal.reversed": "معكوس",
    "screen.accounting.entry.reversal.reversal": "قيد عكسي",
    "screen.accounting.entry.column.can_reverse": "قابل للعكس",
    "screen.accounting.entry.subtitle.period": "فترة {value}",
    "screen.accounting.entry.subtitle.source": "مصدره: {value}",
    "screen.accounting.entry.alert.sourced_invoicing": "قيد له مصدر: يُعكس بإشعار دائن من مستنده، لا من هنا",
    "screen.accounting.entry.alert.sourced": "قيد له مصدر: يُعكس من مصدره، لا من هنا",
    "screen.accounting.entry.alert.period_closing": "فترة {period_name} قيد الإقفال: بعد إقفالها لا قيد بتاريخ فيها",
    "screen.accounting.entry.tab.lines": "السطور",
    "screen.accounting.entry.line.tax": "الضريبة",
    "screen.accounting.entry.line.tax_rate": "{tax_rate_snapshot:number}%",
    "screen.accounting.entry.line.no": "#",
    "screen.accounting.entry.card.reversal.text": "غير معكوس. العكس يُنشئ قيداً مقابلاً بتاريخ في فترة مفتوحة ويطلب سبباً.",
    "screen.accounting.entry.history.note": "القيد المرحّل لا يتغيّر؛ التصحيح بقيد عكسي. الخط الزمني المدمج مرحلة لاحقة.",
    "screen.invoicing.entry_source.title": "المصدر",
    "screen.invoicing.entry_source.column.module": "الوحدة",
    "screen.invoicing.entry_source.module.invoicing": 'الفوترة',
    "screen.invoicing.entry_source.column.number": "المستند",
    "screen.invoicing.entry_source.column.event": "الحدث",
    "screen.invoicing.entry_source.column.idempotency_key": "مفتاح عدم التكرار",
    "screen.invoicing.entry_source.empty": "لم يُرحِّل هذا القيدَ شيءٌ من الفوترة.",
    "screen.invoicing.entry_source.note": "قيد له مصدر لا يُعكس إلا من مستنده: الفاتورة تُصحَّح بإشعار دائن، فيُعكس القيد تبعاً له",
    "screen.accounting.entry.column.entry_date": "تاريخ القيد",
    "screen.accounting.entry.column.source_document_id": "المستند المصدر",
    "screen.accounting.entry.line.party": "الطرف",
    "unit.areas.zero": "{n} مجال",
    "unit.areas.one": "مجال واحد",
    "unit.areas.two": "مجالان",
    "unit.areas.few": "{n} مجالات",
    "unit.areas.many": "{n} مجالاً",
    "unit.areas.other": "{n} مجال",
    "unit.items.zero": "{n} بند",
    "unit.items.one": "بند واحد",
    "unit.items.two": "بندان",
    "unit.items.few": "{n} بنود",
    "unit.items.many": "{n} بنداً",
    "unit.items.other": "{n} بند",
    "unit.rules.zero": "{n} قاعدة ترحيل",
    "unit.rules.one": "قاعدة ترحيل واحدة",
    "unit.rules.two": "قاعدتا ترحيل",
    "unit.rules.few": "{n} قواعد ترحيل",
    "unit.rules.many": "{n} قاعدة ترحيل",
    "unit.rules.other": "{n} قاعدة ترحيل",
    "screen.accounting.account.title": "حساب",
    "screen.accounting.account.head": "{code} · {name_ar}",
    "screen.accounting.account.column.name_ar": "الاسم",
    "screen.accounting.account.field.name_en": "الاسم بالإنجليزية",
    "screen.accounting.account.column.status": "الحالة",
    "screen.accounting.account.status.active": "نشط",
    "screen.accounting.account.status.retired": "موقوف",
    "screen.accounting.account.column.reconcile_mark": "المطابقة",
    "screen.accounting.account.reconcile_mark.reconcilable": "قابل للمطابقة",
    "screen.accounting.account.column.account_type": "النوع",
    "screen.accounting.account.column.parent_name": "الأصل",
    "screen.accounting.account.subtitle.parent": "الأصل: {value}",
    "screen.accounting.account.subtitle.presentation": "يظهر في {value}",
    "screen.accounting.account.column.balance": "الرصيد الآن",
    "screen.accounting.account.balance": "{balance_abs:money} {balance_side}",
    "screen.accounting.account.column.balance_side": "الجانب",
    "screen.accounting.account.side.debit": "مدين",
    "screen.accounting.account.side.credit": "دائن",
    "screen.accounting.account.column.period": "حركة الفترة",
    "screen.accounting.account.period": "+{period_debit:number} / −{period_credit:number}",
    "screen.accounting.account.column.period_credit": "دائن الفترة",
    "screen.accounting.account.column.unreconciled_count": "بنود غير مطابقة",
    "screen.accounting.account.column.last_movement_on": "آخر حركة",
    "screen.accounting.account.column.rules_count": "قواعد الترحيل",
    "screen.accounting.account.column.has_rules": "تستخدمه قواعد ترحيل",
    "screen.accounting.account.column.has_unreconciled": "فيه بنود غير مطابقة",
    "screen.accounting.account.column.can_rename": "يمكن تعديل اسمه",
    "screen.accounting.account.action.rename": "تعديل الاسم",
    "screen.accounting.account.action.reconcile": "مطابقة",
    "screen.accounting.account.alert.unreconciled": "{unreconciled_items} غير مطابق في هذا الحساب",
    "screen.accounting.account.alert.rules": "{rules_count} تستخدمه: إيقافه يتطلب بديلاً لها",
    "screen.accounting.account.tab.ledger": "دفتر الأستاذ",
    "screen.accounting.account.tab.monthly": "الأرصدة الشهرية",
    "screen.accounting.account.tab.parties": "حسب الطرف",
    "screen.accounting.account.tab.dimensions": "حسب البُعد",
    "screen.accounting.account.tab.rules": "قواعد الترحيل",
    "screen.accounting.account.ledger.column.entry_date": "التاريخ",
    "screen.accounting.account.ledger.column.entry_number": "القيد",
    "screen.accounting.account.ledger.column.balance": "الرصيد",
    "screen.accounting.account.ledger.empty": "لم يُرحَّل شيء إلى هذا الحساب هذا الشهر.",
    "screen.accounting.account.monthly.column.month": "الشهر",
    "screen.accounting.account.monthly.month": "{month:month}",
    "screen.accounting.account.monthly.column.closing_balance": "رصيد الإقفال",
    "screen.accounting.account.monthly.empty": "لم يُرحَّل إلى هذا الحساب شيء بعد.",
    "screen.accounting.account.dimensions.column.value_name": "القيمة",
    "screen.accounting.account.dimensions.column.dimension_name": "البُعد",
    "screen.accounting.account.dimensions.empty": "لا سطر في هذا الحساب موسوم ببُعد.",
    "screen.accounting.account.rules.column.source_module": "المصدر",
    "screen.accounting.account.rules.column.line_kind": "نوع السطر",
    "screen.accounting.account.rules.source.invoicing": "المبيعات",
    "screen.accounting.account.rules.source.payroll": "الرواتب",
    "screen.accounting.account.rules.empty": "لا قاعدة ترحيل تُرحِّل إلى هذا الحساب.",
    "screen.accounting.account.parties.empty": "لا سطر في هذا الحساب يسمّي طرفاً.",
    "screen.accounting.account.ledger.title_month": "دفتر الأستاذ — {entry_date:month}",
    "screen.accounting.account.ledger.export": "تصدير",
    "screen.accounting.ledger.title": "دفتر الأستاذ",
    "screen.accounting.ledger.lede": "كل سطر مرحّل ورصيد حسابه بعده. من صفحة حساب: دفتر ذلك الحساب وحده.",
    "nav.accounting.ledger": "دفتر الأستاذ",
    "record.check.open": "افتح",
    "record.check.state": "الحالة",
    "unit.entries.zero": "{n} قيد",
    "unit.entries.one": "قيد واحد",
    "unit.entries.two": "قيدان",
    "unit.entries.few": "{n} قيود",
    "unit.entries.many": "{n} قيداً",
    "unit.entries.other": "{n} قيد",
    "unit.draft_entries.zero": "لا قيود في المسودة",
    "unit.draft_entries.one": "قيد واحد في المسودة",
    "unit.draft_entries.two": "قيدان في المسودة",
    "unit.draft_entries.few": "{n} قيود في المسودة",
    "unit.draft_entries.many": "{n} قيداً في المسودة",
    "unit.draft_entries.other": "{n} قيد في المسودة",
    "unit.lines.zero": "{n} سطر",
    "unit.lines.one": "سطر واحد",
    "unit.lines.two": "سطران",
    "unit.lines.few": "{n} سطور",
    "unit.lines.many": "{n} سطراً",
    "unit.lines.other": "{n} سطر",
    "unit.unmatched_lines.zero": "لا سطور غير مطابقة في الكشوف",
    "unit.unmatched_lines.one": "كشف بنكي بسطر واحد غير مطابق",
    "unit.unmatched_lines.two": "كشف بنكي بسطرين غير مطابقين",
    "unit.unmatched_lines.few": "كشف بنكي بـ {n} سطور غير مطابقة",
    "unit.unmatched_lines.many": "كشف بنكي بـ {n} سطراً غير مطابق",
    "unit.unmatched_lines.other": "كشف بنكي بـ {n} سطر غير مطابق",
    "screen.accounting.period.title": "فترة",
    "screen.accounting.period.head": "فترة {name_ar}",
    "screen.accounting.period.column.fiscal_year_name": "السنة المالية",
    "screen.accounting.period.subtitle.fiscal_year": "السنة المالية {value}",
    "screen.accounting.period.column.days": "الأيام",
    "screen.accounting.period.days": "{starts_on:moment} – {ends_on:moment}",
    "screen.accounting.period.status.open": "مفتوحة",
    "screen.accounting.period.status.closing": "قيد الإقفال",
    "screen.accounting.period.status.closed": "مقفلة",
    "screen.accounting.period.status.reopened": "أُعيد فتحها",
    "screen.accounting.period.column.month_code": "الشهر",
    "screen.accounting.period.column.posted_count": "قيود مرحّلة",
    "screen.accounting.period.column.draft_count": "مسودات",
    "screen.accounting.period.column.revenue": "الإيرادات",
    "screen.accounting.period.column.expenses": "المصروفات",
    "screen.accounting.period.column.net": "صافي الفترة",
    "screen.accounting.period.column.output_vat": "ضريبة المخرجات",
    "screen.accounting.period.column.fiscal_lock_on": "قفل الفترة المالية",
    "screen.accounting.period.column.tax_lock_on": "قفل الضريبة",
    "screen.accounting.period.column.has_drafts": "فيها مسودات",
    "screen.accounting.period.column.can_start_closing": "يمكن بدء إقفالها",
    "screen.accounting.period.column.can_close": "يمكن إقفالها",
    "screen.accounting.period.column.can_reopen": "يمكن إعادة فتحها",
    "screen.accounting.period.column.is_closed": "مقفلة",
    "screen.accounting.period.action.start_closing": "بدء الإقفال",
    "screen.accounting.period.action.close": "إقفال الفترة",
    "screen.accounting.period.action.set_locks": "تغيير تواريخ القفل",
    "screen.accounting.period.alert.drafts": "{draft_entries} في المسودة تُرحَّل أو تُحذف قبل الإقفال",
    "screen.accounting.period.checklist": "قائمة الإقفال",
    "screen.accounting.period.tab.figures": "الأرقام",
    "screen.accounting.period.tab.vat": "الإقرار الضريبي",
    "screen.accounting.period.card.meaning": "ما يعنيه الإقفال",
    "screen.accounting.period.card.meaning.text": "لا قيد بتاريخ في فترة مقفلة. التصحيح بعدها قيد في فترة مفتوحة. إعادة الفتح تطلب سبباً وتُسجَّل باسم فاعلها.",
    "screen.accounting.period.check.drafts": "قيود المسودة",
    "screen.accounting.period.check.detail": "التفصيل",
    "screen.accounting.period.check.detail.post_or_discard": "تُرحَّل أو تُحذف قبل الإقفال",
    "screen.accounting.period.check.trial": "ميزان المراجعة",
    "screen.accounting.period.check.trial.balanced": "ميزان المراجعة متوازن",
    "screen.accounting.period.check.trial.unbalanced": "ميزان المراجعة غير متوازن",
    "screen.accounting.period.check.trial.totals": "المجاميع",
    "screen.accounting.period.check.trial.totals_words": "مدين = دائن = {debit_total:money}",
    "screen.invoicing.period.column.period_open": "الفترة مفتوحة",
    "screen.invoicing.period.bank.title": "الكشوف البنكية",
    "screen.invoicing.period.bank.column.unmatched_lines": "سطور غير مطابقة",
    "screen.invoicing.period.bank.column.statement": "الكشف",
    "screen.invoicing.period.bank.column.statement_on": "تاريخ الكشف",
    "screen.invoicing.period.bank.statement": "{journal_name} · {statement_on:moment}",
    "screen.invoicing.period.bank.alert": "كشف {journal_name} {statement_on}: {unmatched_lines} غير مطابقة",
    "screen.invoicing.period.vat.title": "الإقرار الضريبي",
    "screen.invoicing.period.vat.card": "إقرار الربع",
    "screen.invoicing.period.vat.column.filing": "الإقرار الضريبي",
    "screen.invoicing.period.vat.check_title": "الإقرار الضريبي للربع {quarter} {filing}",
    "screen.invoicing.period.vat.words.filed": "مقدَّم",
    "screen.invoicing.period.vat.words.not_filed": "لم يُقدَّم",
    "screen.invoicing.period.vat.words.q1": "الأول",
    "screen.invoicing.period.vat.words.q2": "الثاني",
    "screen.invoicing.period.vat.words.q3": "الثالث",
    "screen.invoicing.period.vat.words.q4": "الرابع",
    "screen.invoicing.period.vat.filing.filed": "مقدَّم",
    "screen.invoicing.period.vat.filing.not_filed": "لم يُقدَّم",
    "screen.invoicing.period.vat.column.timing": "موعده",
    "screen.invoicing.period.vat.timing.after_period": "يُقدَّم بعد نهاية الربع — لا يمنع إقفال هذه الفترة",
    "screen.invoicing.period.vat.timing.with_period": "يُستحق مع نهاية هذه الفترة",
    "screen.invoicing.period.vat.column.quarter": "الربع",
    "screen.invoicing.period.vat.column.net_due": "صافي المستحق",
    "screen.invoicing.period.vat.alert": "إقرار الربع {quarter} يُقدَّم بعد نهاية الربع، ولا يمنع إقفال هذه الفترة",
    "screen.einvoicing.period.title": "إبلاغ الفواتير للهيئة",
    "screen.einvoicing.period.outcome.all_reported": 'كل الفواتير أُبلغت للهيئة أو اعتمدتها',
    "screen.einvoicing.period.outcome.not_all_reported": "فواتير رفضتها الهيئة أو لم تردّ عليها",
    "screen.einvoicing.period.column.counts": "المرفوضة والمنتظرة",
    "screen.einvoicing.period.counts": "{missing_count} لم تُرسل · {rejected_count} مرفوضة · {pending_count} بانتظار الردّ",
    "screen.einvoicing.period.column.pending_count": "بانتظار",
    "nav.invoicing.bank_accounts": "الحسابات البنكية",
    "entity.invoicing.bank_account": "الحساب البنكي",
    "screen.invoicing.bank_accounts.title": "الحسابات البنكية",
    "screen.invoicing.bank_accounts.lede": "كل دفتر بنك وحسابه في الدليل وآخر كشف له وما لم يُطابَق بعد.",
    "screen.invoicing.bank_account.title": "حساب بنكي",
    "screen.invoicing.bank_account.monogram": "بن",
    "screen.invoicing.bank_account.column.name_ar": "الحساب البنكي",
    "screen.invoicing.bank_account.column.account_code": "الحساب في الدليل",
    "screen.invoicing.bank_account.column.code": "الدفتر",
    "screen.invoicing.bank_account.column.iban": "الآيبان",
    "screen.invoicing.bank_account.column.books_balance": "الرصيد في الدفاتر",
    "screen.invoicing.bank_account.column.statement_balance": "الرصيد في آخر كشف",
    "screen.invoicing.bank_account.column.difference": "الفرق",
    "screen.invoicing.bank_account.column.last_statement_on": "آخر كشف",
    "screen.invoicing.bank_account.column.unmatched_lines": "سطور غير مطابقة",
    "screen.invoicing.bank_account.column.payments_in_transit": "دفعات في الطريق",
    "screen.invoicing.bank_account.column.deposits_not_shown": "إيداعات لم تظهر",
    "screen.invoicing.bank_account.column.bank_only": "سطور الكشف غير المسجلة",
    "screen.invoicing.bank_account.column.unexplained": "غير مفسَّر",
    "screen.invoicing.bank_account.column.last_matched_at": "آخر مطابقة",
    "screen.invoicing.bank_account.column.has_unmatched": "فيه سطور غير مطابقة",
    "screen.invoicing.bank_account.column.has_unexplained": "فيه فرق غير مفسَّر",
    "screen.invoicing.bank_account.column.can_reconcile": "قابل للمطابقة",
    "screen.invoicing.bank_account.column.proposal": "مقترح",
    "screen.invoicing.bank_account.action.change_account": "تغيير الحساب في الدليل",
    "screen.invoicing.bank_account.action.set_iban": "تعديل الآيبان",
    "screen.invoicing.bank_account.field.iban.help": "كما يكتبه البنك: SA واثنان وعشرون رقماً.",
    "screen.invoicing.bank_account.subtitle.code": "دفتر البنك {value}",
    "screen.invoicing.bank_account.subtitle.iban": "الآيبان {value}",
    "screen.invoicing.bank_account.alert.unmatched": "{unmatched_words} غير مطابقة في كشوف حتى {last_statement_on}",
    "screen.invoicing.bank_account.alert.unexplained": "فرق غير مفسَّر {unexplained} بين الدفاتر والكشف",
    "screen.invoicing.bank_account.alert.last_match": "آخر مطابقة {last_matched_at}",
    "screen.invoicing.bank_account.tab.reconciliation": "المطابقة",
    "screen.invoicing.bank_account.tab.statements": "الكشوف",
    "screen.invoicing.bank_account.tab.movements": "الحركات",
    "screen.invoicing.bank_account.card.difference": "الفرق بين الدفاتر والكشف",
    "screen.invoicing.bank_account.card.difference.empty": "لا كشف يذكر رصيده الختامي بعد: يُحسب الفرق حين يذكره.",
    "screen.invoicing.bank_account.unmatched.empty": "كل سطور الكشوف مطابقة.",
    "screen.invoicing.bank_account.statements.column.line_count": "السطور",
    "screen.invoicing.bank_account.statements.column.unmatched_count": "غير مطابق",
    "screen.invoicing.bank_account.statements.column.closing_balance": "الرصيد الختامي",
    "screen.invoicing.bank_account.statements.empty": "لم يُستورد كشف لهذا الحساب بعد.",
    "screen.invoicing.bank_account.movements.empty": "لا حركة على هذا الحساب بعد.",
    "screen.invoicing.bank_reconciliation.action.import.field.closing_balance": "الرصيد الختامي",
    "screen.invoicing.bank_reconciliation.action.import.field.closing_balance.help": "الرصيد الذي ينتهي به الكشف كما هو مطبوع فيه. اتركه فارغاً إن لم يذكره الكشف.",
    "screen.accounting.journals.action.edit.field.iban": "الآيبان",
    "screen.accounting.journals.action.edit.field.iban.help": "لدفتر البنك: آيبان الحساب كما يكتبه البنك.",
    "screen.invoicing.bank_account.action.accept": "قبول",
    "screen.invoicing.bank_account.action.search": "بحث",
    "screen.invoicing.bank_account.column.has_proposal": "له مقترح",
    "unit.attempts.zero": "{n} محاولة",
    "unit.attempts.one": "محاولة واحدة",
    "unit.attempts.two": "محاولتين",
    "unit.attempts.few": "{n} محاولات",
    "unit.attempts.many": "{n} محاولة",
    "unit.attempts.other": "{n} محاولة",
    "screen.einvoicing.device.title": 'وحدة الحل التقني',
    "screen.einvoicing.device.monogram": "EG",
    "screen.einvoicing.device.column.label": 'الوحدة',
    "screen.einvoicing.device.column.standing": "الحالة",
    "screen.einvoicing.device.standing.active_production": "نشط · بيئة الإنتاج",
    "screen.einvoicing.device.standing.active_sandbox": "نشط · بيئة التجربة",
    "screen.einvoicing.device.standing.active_issue_only": "نشط · إصدار فقط",
    "screen.einvoicing.device.standing.retired": "موقوف",
    "screen.einvoicing.device.column.journal_code": "دفتر المبيعات",
    "screen.einvoicing.device.column.seller_name": 'المنشأة البائعة',
    "screen.einvoicing.device.column.reported_count": 'أُبلغت أو اعتُمدت',
    "screen.einvoicing.device.column.pending_count": "بانتظار",
    "screen.einvoicing.device.column.rejected_count": "مرفوضة",
    "screen.einvoicing.device.column.connector_state": "الهيئة",
    "screen.einvoicing.device.connector_state.available": "متاحة",
    "screen.einvoicing.device.connector_state.circuit_open": 'غير متاحة — الربط موقوف مؤقتاً بعد إخفاقات متتالية',
    "screen.einvoicing.device.connector_state.issue_only": "إصدار فقط",
    "screen.einvoicing.device.reported_words": "{reported_count}",
    "screen.einvoicing.device.pending_words": "{pending_count} بانتظار",
    "screen.einvoicing.device.rejected_words": "{rejected_count} مرفوضة",
    "screen.einvoicing.device.column.next_icv": 'عدّاد الفاتورة التالي (ICV)',
    "screen.einvoicing.device.column.last_icv": 'آخر عدّاد فاتورة (ICV)',
    "screen.einvoicing.device.column.last_hash": 'آخر تجزئة فاتورة',
    "screen.einvoicing.device.column.production_csid": "شهادة الإنتاج (CSID)",
    "screen.einvoicing.device.until_month": "حتى {production_csid_expires_on:month}",
    "screen.einvoicing.device.column.onboarded_at": "فُعِّل",
    "screen.einvoicing.device.column.circuit": 'الربط',
    "screen.einvoicing.device.circuit.closed": 'الربط يعمل',
    "screen.einvoicing.device.circuit.open": 'الربط موقوف مؤقتاً',
    "screen.einvoicing.device.circuit_words": "{circuit} · {consecutive_failures} أخطاء",
    "screen.einvoicing.device.column.consecutive_failures": "الأخطاء",
    "screen.einvoicing.device.column.chain_state": "التحقق من السلسلة",
    "screen.einvoicing.device.chain_state.connected": "متصلة",
    "screen.einvoicing.device.chain_state.broken": "مكسورة",
    "screen.einvoicing.device.column.rejected_number": "المستند المرفوض",
    "screen.einvoicing.device.column.attempts": "المحاولة",
    "screen.einvoicing.device.column.rejected_at": "رُفض في",
    "screen.einvoicing.device.column.pending_number": "المستند المنتظر",
    "screen.einvoicing.device.column.certificate_soon": "الشهادة تنتهي قريباً",
    "screen.einvoicing.device.column.can_onboard": "يمكن تسجيله",
    "screen.einvoicing.device.column.can_renew": "يمكن تجديد شهادته",
    "screen.einvoicing.device.action.onboard": 'تسجيل الوحدة لدى الهيئة',
    "screen.einvoicing.device.action.renew": "تجديد الشهادة",
    "screen.einvoicing.device.action.resubmit": "إعادة الإرسال",
    "screen.einvoicing.device.field.production_csid_expires_on": "شهادة الإنتاج سارية حتى",
    "screen.einvoicing.device.field.production_csid_expires_on.help": "كما أصدرتها الهيئة.",
    "screen.einvoicing.device.subtitle.branch": "فرع {value}",
    "screen.einvoicing.device.subtitle.journal": "دفتر المبيعات {value}",
    "screen.einvoicing.device.subtitle.seller": 'المنشأة البائعة: {value}',
    "screen.einvoicing.device.alert.rejected": "{rejected_number} مرفوضة بعد {rejected_attempts}",
    "screen.einvoicing.device.alert.waiting": "{pending_number} بانتظار رد الهيئة · المحاولة {pending_attempt}",
    "screen.einvoicing.device.alert.certificate_ends": "تنتهي شهادة الإنتاج في {production_csid_expires_on}",
    "screen.einvoicing.device.alert.certificate": "شهادة الإنتاج سارية حتى {production_csid_expires_on}",
    "screen.einvoicing.device.tab.documents": "المستندات",
    "screen.einvoicing.device.tab.attempts": "المحاولات",
    "screen.einvoicing.device.tab.seller": 'المنشأة البائعة',
    "screen.einvoicing.device.tab.certificates": "الشهادات",
    "screen.einvoicing.device.card.chain": 'سلسلة التجزئة',
    "screen.einvoicing.device.card.chain.note": 'كل فاتورة تحمل تجزئة الفاتورة السابقة (PIH): فجوة في العدّاد أو كسر في السلسلة تُرفض عند الهيئة',
    "screen.einvoicing.device.card.attention": "مستندات تحتاج تصرفاً",
    "screen.einvoicing.device.attention.column.number": "المستند",
    "screen.einvoicing.device.attention.column.report_status": "الحالة",
    "screen.einvoicing.device.attention.column.can_submit": "يمكن إرساله",
    "screen.einvoicing.device.attention.empty": 'كل فواتير هذه الوحدة عند الهيئة.',
    "screen.einvoicing.device.report_status.rejected": "مرفوضة",
    "screen.einvoicing.device.report_status.pending": "بانتظار",
    "screen.einvoicing.device.report_status.unreachable": "تعذّر الوصول",
    "screen.einvoicing.device.attempts.column.environment": "البيئة",
    "screen.einvoicing.device.attempts.column.response_status": "الرد",
    "screen.einvoicing.device.attempts.column.created_at": "متى",
    "screen.einvoicing.device.attempts.empty": 'لم يُرسل شيء من هذه الوحدة إلى الهيئة بعد.',
    "screen.einvoicing.device.environment.compliance": "امتثال",
    "screen.einvoicing.device.environment.production": "إنتاج",
    "screen.einvoicing.device.environment.sandbox": "تجربة",
    "screen.einvoicing.device.environment.issue_only": "إصدار فقط",
    "screen.einvoicing.device.response_status.accepted": "مقبول",
    "screen.einvoicing.device.response_status.accepted_with_warnings": "مقبول بملاحظات",
    "screen.einvoicing.device.response_status.rejected": "مرفوض",
    "screen.einvoicing.device.response_status.unreachable": "تعذّر الوصول",
    "screen.einvoicing.device.response_status.not_sent": "لم يُرسل",
    "screen.einvoicing.device.seller.column.legal_name": "الاسم القانوني",
    "screen.einvoicing.device.seller.column.cr_number": "السجل التجاري",
    "screen.einvoicing.device.seller.column.address": "العنوان",
    "screen.einvoicing.device.seller.column.city": "المدينة",
    "screen.einvoicing.device.seller.column.postcode": "الرمز البريدي",
    "screen.einvoicing.device.seller.address": "{address_state} · {city} {postcode}",
    "screen.einvoicing.device.address_state.complete": "مكتمل",
    "screen.einvoicing.device.address_state.incomplete": "ناقص",
    "screen.einvoicing.device.seller.empty": 'لا بيانات منشأة بائعة لفرع هذه الوحدة.',
    "screen.einvoicing.device.certificates.column.certificate": "الشهادة",
    "screen.einvoicing.device.certificates.column.expires_on": "تنتهي",
    "screen.einvoicing.device.month": "{expires_on:month}",
    "screen.invoicing.device_month_documents.title": "مستندات هذا الشهر",
    "screen.einvoicing.device.column.rejected_reason": "سبب الرفض",
    "screen.einvoicing.device.alert.rejected_reason": "{rejected_number} مرفوضة بعد {rejected_attempts}: {rejected_reason}",
    "screen.einvoicing.device.attention.column.reason": "السبب",
    "screen.einvoicing.document_edocument.col.rejected_reason": "سبب الرفض",
    // ── finance record pages (end) ──
    "screen.invoicing.document.alert.draft": "مسودة: لا يُرحَّل شيء حتى تُصدَر",
    "screen.invoicing.document.tab.lines": "السطور",
    "screen.invoicing.document.line.description": "البيان",
    "screen.invoicing.document.line.quantity": "الكمية",
    "screen.invoicing.document.line.unit_price": "السعر",
    "screen.invoicing.document.line.discount": "الخصم",
    "screen.invoicing.document.line.tax_amount": "الضريبة",
    "screen.invoicing.document.line.line_total": "المجموع",
    "screen.invoicing.document_allocations.title": "السداد",
    "screen.invoicing.document_allocations.empty": "لا دفعة موزعة على هذه الفاتورة بعد.",
    "screen.einvoicing.document_edocument.title": "الفاتورة الإلكترونية",
    "screen.einvoicing.document_edocument.column.device": 'وحدة الحل التقني',
    "screen.einvoicing.document_edocument.empty": 'لا فاتورة إلكترونية بعد: تُنشأ عند إصدار الفاتورة.',
    "screen.einvoicing.document_edocument.alert": "لم تستلم الهيئة الفاتورة الإلكترونية بعد",
    "screen.accounting.entry_lines.title": "القيد المحاسبي",
    "screen.accounting.entry_lines.column.account": "الحساب",
    "screen.accounting.entry_lines.column.account_name": "اسم الحساب",
    "screen.accounting.entry_lines.column.debit": "مدين",
    "screen.accounting.entry_lines.column.credit": "دائن",
    "screen.accounting.entry_lines.empty": "لا سطور في القيد.",
    "documents.party_documents.title": "الوثائق",
    "documents.party_documents.empty": "لا وثيقة محفوظة لهذا الطرف.",
    "entity.parties.party": "الطرف",
    "entity.accounting.entry": "القيد",
    "record.changes.field": "الحقل",
    "record.changes.from": "من",
    "record.changes.to": "إلى",
    "record.changes.by": "بواسطة",
    "record.changes.when": "متى",
    "record.changes.note": "تغييرات حقول هذا الملف فقط؛ قرارات المديولات الأخرى تبقى في بطاقاتها.",
    "record.changes.decision": "قرار #{n}",
    "record.history.phase.before_posting": "قبل الترحيل",
    "unit.years.zero": "{n} سنة",
    "unit.years.one": "سنة واحدة",
    "unit.years.two": "سنتان",
    "unit.years.few": "{n} سنوات",
    "unit.years.many": "{n} سنة",
    "unit.years.other": "{n} سنة",
    "unit.seats.zero": "{n} مقعد",
    "unit.seats.one": "مقعد واحد",
    "unit.seats.two": "مقعدان",
    "unit.seats.few": "{n} مقاعد",
    "unit.seats.many": "{n} مقعدًا",
    "unit.seats.other": "{n} مقعد",
    "documents.candidate_documents.empty": "لا توجد وثيقة محفوظة لهذا المرشح.",
    "record.changes.record": "الملف",
    "record.changes.created": "أُنشئ",
    "value.moment.today": "اليوم {time}",
    "value.span.from": "من {day}",
    "value.span.until": "حتى {day}",
    "value.moment.tomorrow": "غدًا {time}",
    "value.moment.yesterday": "أمس {time}",
    "value.moment.today_day": "اليوم",
    "value.moment.tomorrow_day": "غدًا",
    "value.moment.yesterday_day": "أمس",
    "record.due.since": "منذ {day}",
    "screen.invoicing.document.kind.customer_invoice": "فاتورة",
    "screen.invoicing.document.kind.credit_note": "إشعار دائن",
    "screen.invoicing.document.kind.debit_note": "إشعار مدين",
    "screen.invoicing.document.kind.vendor_bill": "فاتورة مورد",
    "screen.invoicing.document.state.draft": "مسودة",
    "screen.invoicing.document.state.posted": "مرحّلة",
    "screen.invoicing.document.state.validated": "معتمدة",
    "screen.invoicing.document.state.cancelled_by_note": "ملغاة بإشعار",
    "screen.invoicing.document.classification.standard": "ضريبية قياسية",
    "screen.invoicing.document.classification.simplified": "ضريبية مبسطة",
    "screen.invoicing.document.column.payment_state": "السداد",
    "screen.invoicing.document.payment.outstanding": "غير مسدَّدة",
    "screen.invoicing.document.payment.partial": "مسدَّدة جزئيًا",
    "screen.invoicing.document.payment.paid": "مسدَّدة",
    "screen.invoicing.document.column.party_address": "العنوان",
    "screen.invoicing.document.column.subtotal": "قبل الضريبة",
    "screen.invoicing.document.column.discount_total": "الخصم",
    "screen.invoicing.document.column.tax_total": "ضريبة القيمة المضافة",
    "screen.invoicing.document.status.posting": "الترحيل",
    "screen.invoicing.document.status.due": "الاستحقاق",
    "screen.invoicing.document.due.late": "متأخرة {days}",
    "screen.invoicing.document.due.today": "مستحقة اليوم",
    "screen.invoicing.document.due.in": "تُستحق بعد {days}",
    "screen.invoicing.document.head": "{kind} {number}",
    "screen.invoicing.document.as_issued": "كما عند الإصدار",
    "screen.invoicing.document.subtitle.vat": "الرقم الضريبي {value}",
    "screen.invoicing.document.lines.note": "فاتورة مرحّلة لا تُعدَّل: التصحيح بإشعار دائن أو مدين يشير إليها.",
    "screen.invoicing.document.tab.payments": "السداد",
    "screen.invoicing.document.tab.notes": "الإشعارات",
    "screen.invoicing.document.card.customer": "العميل كما كان عند الإصدار",
    "screen.invoicing.document.card.customer.note": "لقطة محفوظة مع الفاتورة: تغيير بيانات العميل لاحقاً لا يغيّر الفاتورة.",
    "screen.invoicing.document_allocations.action.pay": "توزيع دفعة",
    "screen.invoicing.document_notes.title": "الإشعارات المرتبطة",
    "screen.invoicing.document_notes.empty": "لا إشعار دائن ولا مدين على هذه الفاتورة.",
    "screen.einvoicing.document_edocument.note": 'المبسّطة تُبلَّغ خلال 24 ساعة، والقياسية تُعتمد (التخليص) قبل تسليمها للعميل.',
    "screen.einvoicing.document_cleared.title": 'قبلتها الهيئة',
    "screen.einvoicing.document_cleared.alert": 'قبلتها الهيئة ({path}) في {last_attempt_at}',
    "screen.accounting.entry_lines.total": "المجموع",
    "screen.accounting.entry_lines.open": "فتح القيد",
    "change.field.document.due_on": "تاريخ الاستحقاق",
    "hub.flag.no_evidence": "بلا مستند",
    // ── entity record pages (hr): employee, asset, vacancy, end of service, violation, party ──
    "change.field.party.nationality": "الجنسية",
    "change.field.party.phone": "الجوال",
    "change.field.account.account_type": "النوع",
    "change.field.account.code": "الرمز",
    "change.field.account.name_ar": "الاسم",
    "change.field.account.name_en": "الاسم بالإنجليزية",
    "change.field.account.parent_id": "الأصل",
    "change.field.account.presentation": "العرض",
    "change.field.account.reconcilable": "قابل للمطابقة",
    "change.field.account.retired_at": "تاريخ الإيقاف",
    "change.field.announcement.audience": "الجمهور",
    "change.field.announcement.body": "النص",
    "change.field.announcement.created_by": "أنشأه",
    "change.field.announcement.publication": "الحالة",
    "change.field.announcement.published_at": "تاريخ النشر",
    "change.field.announcement.published_by": "نشره",
    "change.field.announcement.roles": "الأدوار",
    "change.field.announcement.title": "العنوان",
    "change.field.announcement.withdrawn_at": "تاريخ السحب",
    "change.field.announcement.withdrawn_by": "سحبه",
    "change.field.announcement.comments_allowed": "التعليق مسموح",
    "change.field.thanks.from_user": "من",
    "change.field.thanks.to_user": "إلى",
    "change.field.thanks.message": "الرسالة",
    "change.field.thanks.public": "يراه الجميع",
    "change.field.chat.member_a": "العضو",
    "change.field.chat.member_b": "العضو",
    "change.field.chat.created_by": "بدأها",
    "change.field.chat_settings.retention_days": "مدة ظهور رسائل المحادثات (بالأيام)",
    "change.field.assignment.created_by": "أنشأه",
    "change.field.bank_statement.account_id": "الحساب في الدليل",
    "change.field.bank_statement.amount": "المبلغ",
    "change.field.bank_statement.booked_on": "التاريخ",
    "change.field.bank_statement.closing_balance": "الرصيد الختامي",
    "change.field.bank_statement.created_by": "أنشأه",
    "change.field.bank_statement.fingerprint": "البصمة",
    "change.field.bank_statement.id": "المعرف",
    "change.field.bank_statement.journal_id": "اليومية",
    "change.field.bank_statement.line_count": "السطور",
    "change.field.bank_statement.line_no": "السطر",
    "change.field.bank_statement.match_kind": "نوع المطابقة",
    "change.field.bank_statement.matched_at": "تاريخ المطابقة",
    "change.field.bank_statement.matched_entry_id": "القيد المطابَق",
    "change.field.bank_statement.matched_item_id": "البند المطابَق",
    "change.field.bank_statement.narration": "البيان",
    "change.field.bank_statement.statement_on": "تاريخ الكشف",
    "change.field.branch.code": "الرمز",
    "change.field.branch.name": "الفرع",
    "change.field.branch.status": "الحالة",
    "change.field.calendar_settings.hijri_display": "التاريخ الهجري في الشاشات",
    "change.field.calendar_settings.language": "لغة مساحة العمل",
    "change.field.calendar_settings.hijri_reference": "مرجع التحويل الهجري",
    "change.field.calendar_settings.time_zone": "المنطقة الزمنية",
    "change.field.campaign.created_by": "أنشأه",
    "change.field.campaign.name": "الحملة",
    "change.field.campaign.status": "الحالة",
    "change.field.case.closed_at": "تاريخ الإغلاق",
    "change.field.case.id": "المعرّف",
    "change.field.case.note": "ملاحظة",
    "change.field.chart_mapping.external_account": "الحساب الخارجي",
    "change.field.chart_mapping.source_code": "الرمز المحلي",
    "change.field.chart_mapping.source_kind": "النوع",
    "change.field.connector.environment": "البيئة",
    "change.field.connector.production_switched_at": "تاريخ الانتقال إلى الإنتاج",
    "change.field.connector.production_switched_by": "نقله إلى الإنتاج",
    "change.field.connector.vault_secret_ref": "مرجع الخزنة",
    "change.field.contract.created_by": "أنشأه",
    "change.field.contract.reason": "ملاحظة",
    "change.field.device.branch_code": "الفرع",
    "change.field.device.certificate_ref": "الشهادة",
    "change.field.device.compliance_csid_ref": "مرجع CSID الامتثال في الخزنة",
    "change.field.device.csr_vault_ref": "مرجع CSR في الخزنة",
    "change.field.device.id": "المعرّف",
    "change.field.device.label": "التسمية",
    "change.field.device.onboarded_at": "فُعِّل",
    "change.field.device.otp_vault_ref": "مرجع OTP في الخزنة",
    "change.field.device.production_csid_expires_on": "شهادة الإنتاج (CSID)",
    "change.field.device.production_csid_ref": "مرجع CSID الإنتاج في الخزنة",
    "change.field.device.sales_journal_id": "يومية المبيعات",
    "change.field.device.state": "الحالة",
    "change.field.dimension.code": "الرمز",
    "change.field.dimension.name_ar": "الاسم (عربي)",
    "change.field.dimension.name_en": "الاسم (إنجليزي)",
    "change.field.dimension.retired_at": "تاريخ الإيقاف",
    "change.field.dimension_value.code": "الرمز",
    "change.field.dimension_value.dimension_id": "البُعد",
    "change.field.dimension_value.name_ar": "الاسم (عربي)",
    "change.field.dimension_value.name_en": "الاسم (إنجليزي)",
    "change.field.dimension_value.retired_at": "تاريخ الإيقاف",
    "change.field.document.account_id": "الحساب في الدليل",
    "change.field.document.allocated_total": "المسدَّد",
    "change.field.document.branch_code": "الفرع",
    "change.field.document.classification": "التصنيف",
    "change.field.document.classification_override_reason": "سبب تجاوز التصنيف",
    "change.field.document.created_by": "أنشأه",
    "change.field.document.currency": "العملة",
    "change.field.document.decision_number": "رقم القرار",
    "change.field.document.deductible": "قابل للخصم",
    "change.field.document.description_ar": "الوصف (عربي)",
    "change.field.document.description_en": "الوصف (إنجليزي)",
    "change.field.document.discount": "الخصم",
    "change.field.document.discount_total": "الخصم",
    "change.field.document.effective_on": "تاريخ السريان",
    "change.field.document.expires_on": "تنتهي في",
    "change.field.document.file_name": "الملف",
    "change.field.document.file_size": "حجم الملف",
    "change.field.document.file_type": "نوع الملف",
    "change.field.document.id": "المعرف",
    "change.field.document.issue_on": "تاريخ الإصدار",
    "change.field.document.issued_by": "أصدره",
    "change.field.document.issued_on": "تاريخ الإصدار",
    "change.field.document.journal_entry_id": "القيد المحاسبي",
    "change.field.document.journal_id": "الدفتر",
    "change.field.document.kind": "النوع",
    "change.field.document.line_no": "السطر",
    "change.field.document.line_total": "إجمالي السطر",
    "change.field.document.media_id": "الوسائط",
    "change.field.document.source_ref": 'المرجع المصدر',
    "change.field.document.name": "الاسم",
    "change.field.document.notes": "ملاحظات",
    "change.field.document.number": "الرقم",
    "change.field.document.original_document_id": "المستند الأصلي",
    "change.field.document.owner_kind": "لمن",
    "change.field.document.owner_label": "اسم المالك",
    "change.field.document.owner_ref": "مرجع المالك",
    "change.field.document.party_id": "الطرف",
    "change.field.document.party_snapshot": "الطرف كما سُجّل",
    "change.field.document.payment_term_id": "شروط الدفع",
    "change.field.document.previous_id": "السابق",
    "change.field.document.quantity": "الكمية",
    "change.field.document.reason_code": "السبب",
    "change.field.document.ref_key": "المفتاح",
    "change.field.document.state": "الحالة",
    "change.field.document.status": "الصلاحية",
    "change.field.document.subtotal": "قبل الضريبة",
    "change.field.document.superseded_at": "تاريخ الاستبدال",
    "change.field.document.supply_on": "تاريخ التوريد",
    "change.field.document.tax_amount": "مبلغ الضريبة",
    "change.field.document.tax_code_id": "رمز الضريبة",
    "change.field.document.tax_rate_snapshot": "نسبة الضريبة المطبّقة",
    "change.field.document.tax_total": "ضريبة القيمة المضافة",
    "change.field.document.total": "الإجمالي",
    "change.field.document.type_id": "النوع",
    "change.field.document.unit_price": "سعر الوحدة",
    "change.field.document.version_no": "النسخة",
    "change.field.document.withdraw_reason": "سبب السحب",
    "change.field.document.withdrawn_at": "تاريخ السحب",
    "change.field.document.withdrawn_by": "سحبه",
    "change.field.document.destroyed_at": "تاريخ الإتلاف",
    "change.field.document.destroyed_by": "أتلفها",
    "change.field.document.destroyed_keep_until": "محفوظة حتى",
    "change.field.document.file_removed_at": "تاريخ حذف النسخة",
    "change.field.document.legal_hold": "تجميد قانوني",
    "change.field.document.legal_hold_reason": "سبب التجميد القانوني",
    "change.field.document.legal_hold_at": "تاريخ تغيير التجميد القانوني",
    "change.field.document.legal_hold_by": "غيّر التجميد القانوني",
    "change.field.owner_anchor.owner_ref": "مرجع المالك",
    "change.field.owner_anchor.ended_on": "تاريخ انتهاء العلاقة",
    "change.field.owner_anchor.reason": "السبب",
    "change.field.owner_anchor.set_by": "سجّلها",
    "change.field.document.withholding_amount": 'مبلغ ضريبة الاستقطاع',
    "change.field.document.withholding_tax_code_id": "رمز ضريبة الاستقطاع",
    "change.field.document.withholding_total": 'ضريبة الاستقطاع',
    "change.field.edocument.device_id": 'وحدة الحل التقني',
    "change.field.edocument.document_id": "المستند",
    "change.field.edocument.hash": 'تجزئة الفاتورة',
    "change.field.edocument.icv": 'عدّاد الفاتورة (ICV)',
    "change.field.edocument.previous_hash": 'تجزئة الفاتورة السابقة (PIH)',
    "change.field.edocument.profile_id": "الملف التعريفي",
    "change.field.edocument.qr_payload": "رمز QR",
    "change.field.edocument.report_status": 'الحالة لدى الهيئة',
    "change.field.edocument.uuid": 'المعرّف الفريد (UUID)',
    "change.field.edocument.xml_hash": 'تجزئة ملف XML',
    "change.field.entry.account_id": "الحساب",
    "change.field.entry.credit": "دائن",
    "change.field.entry.currency": "العملة",
    "change.field.entry.debit": "مدين",
    "change.field.entry.due_on": "الاستحقاق",
    "change.field.entry.entry_date": "التاريخ",
    "change.field.entry.full_reconcile_id": "التسوية الكاملة",
    "change.field.entry.id": "المعرّف",
    "change.field.entry.journal_id": "الدفتر",
    "change.field.entry.line_no": "السطر",
    "change.field.entry.narration_ar": "البيان",
    "change.field.entry.narration_en": "البيان (إنجليزي)",
    "change.field.entry.number": "الرقم",
    "change.field.entry.party_id": "الطرف",
    "change.field.entry.period_id": "الفترة",
    "change.field.entry.posted_at": "وقت الترحيل",
    "change.field.entry.posted_by": "رحّله",
    "change.field.entry.reconciled_at": "تاريخ التسوية",
    "change.field.entry.reversal_of_id": "عكس للقيد",
    "change.field.entry.reverse_reason": "السبب",
    "change.field.entry.reversed_by_id": "عُكس بالقيد",
    "change.field.entry.source_event_id": "الحدث المصدر",
    "change.field.entry.source_module": "المصدر",
    "change.field.entry.source_ref": "المصدر",
    "change.field.entry.state": "الحالة",
    "change.field.entry.tax_base": "الوعاء الضريبي",
    "change.field.entry.tax_code_id": "رمز الضريبة",
    "change.field.entry.tax_rate_snapshot": "نسبة الضريبة المطبّقة",
    "change.field.establishment.account_iban": "آيبان الحساب",
    "change.field.establishment.bank_code": "رمز البنك",
    "change.field.establishment.bank_name": "البنك",
    "change.field.establishment.compliance_threshold": "الحد (%)",
    "change.field.establishment.cr_number": "السجل التجاري",
    "change.field.establishment.default_layout": "التخطيط الافتراضي",
    "change.field.establishment.fine_per_worker": "الغرامة لكل عامل",
    "change.field.establishment.freeze_after_months": "التجميد بعد (أشهر)",
    "change.field.establishment.mudad_establishment_id": "رقم المنشأة في مُدد",
    "change.field.establishment.name": "الاسم",
    "change.field.establishment.signatory_id_number": "رقم هوية الموقّع",
    "change.field.establishment.signatory_name": "الموقّع",
    "change.field.establishment.transfer_after_months": "النقل بعد (أشهر)",
    "change.field.establishment.unified_number": "الرقم الموحّد",
    "change.field.establishment.upload_window_days": "مهلة الرفع (أيام)",
    "change.field.export_batch.approved_by": "اعتمده",
    "change.field.export_batch.booked_on": "التاريخ",
    "change.field.export_batch.confirmed_at": "تاريخ التأكيد",
    "change.field.export_batch.credit": "دائن",
    "change.field.export_batch.debit": "مدين",
    "change.field.export_batch.description": "الوصف",
    "change.field.export_batch.external_account": "الحساب الخارجي",
    "change.field.export_batch.external_ref": "المرجع الخارجي",
    "change.field.export_batch.fingerprint": "البصمة",
    "change.field.export_batch.format": "الصيغة",
    "change.field.export_batch.id": "المعرف",
    "change.field.export_batch.line_count": "السطور",
    "change.field.export_batch.line_no": "السطر",
    "change.field.export_batch.period_from": "من",
    "change.field.export_batch.period_to": "إلى",
    "change.field.export_batch.produced_by": "أنتجه",
    "change.field.export_batch.scope": "النطاق",
    "change.field.export_batch.source_code": "الرمز المحلي",
    "change.field.export_batch.source_id": "السجل المصدر",
    "change.field.export_batch.source_kind": "النوع",
    "change.field.export_batch.state": "الحالة",
    "change.field.file.content": "المحتوى",
    "change.field.file.due_on": "تاريخ الاستحقاق",
    "change.field.file.generated_at": "تاريخ التوليد",
    "change.field.file.generated_by": "ولّده",
    "change.field.file.kind": "النوع",
    "change.field.file.layout": "التخطيط",
    "change.field.file.pay_date": "تاريخ الصرف",
    "change.field.file.rows": "الصفوف",
    "change.field.file.run_id": "مسيّر الرواتب",
    "change.field.file.run_period": "فترة المسيّر",
    "change.field.file.status": "الحالة",
    "change.field.file.total": "الإجمالي",
    "change.field.file.uploaded_at": "تاريخ الرفع",
    "change.field.file.uploaded_on": "تاريخ الرفع",
    "change.field.file.withdraw_reason": "سبب السحب",
    "change.field.file.advance_id": "السلفة",
    "change.field.bank.code": "رمز البنك",
    "change.field.bank.name_ar": "اسم البنك",
    "change.field.bank.name_en": "اسم البنك بالإنجليزية",
    "change.field.bank.bic": "رمز سويفت",
    "change.field.bank.valid_from": "معتمد من",
    "change.field.bank.status": "الحالة",
    "change.field.bank.created_by": "اعتمده",
    "change.field.bank.retired_by": "أوقفه",
    "change.field.bank.retired_at": "وقت الإيقاف",
    "change.field.file.withdrawn_at": "تاريخ السحب",
    "change.field.file.withdrawn_by": "سحبه",
    "change.field.fiscal_year.calendar": "التقويم",
    "change.field.fiscal_year.ends_on": "إلى",
    "change.field.fiscal_year.name_ar": "الاسم",
    "change.field.fiscal_year.name_en": "الاسم بالإنجليزية",
    "change.field.fiscal_year.starts_on": "من",
    "change.field.fiscal_year.status": "الحالة",
    "change.field.form.approver_kind": "نوع المعتمد",
    "change.field.form.approver_role": "يقرّره دور",
    "change.field.form.archived_at": "تاريخ الأرشفة",
    "change.field.form.archived_by": "أرشفه",
    "change.field.form.audience": "موجّه إلى",
    "change.field.form.category": "الفئة",
    "change.field.form.created_by": "أنشأه",
    "change.field.form.default_value": "القيمة الافتراضية",
    "change.field.form.description_ar": "الوصف (عربي)",
    "change.field.form.description_en": "الوصف (إنجليزي)",
    "change.field.form.document_type_key": "نوع الوثيقة",
    "change.field.form.help_ar": "المساعدة (عربي)",
    "change.field.form.help_en": "المساعدة (إنجليزي)",
    "change.field.form.icon": "الأيقونة",
    "change.field.form.id": "المعرّف",
    "change.field.form.key": "المفتاح",
    "change.field.form.label_ar": "التسمية (عربي)",
    "change.field.form.label_en": "التسمية (إنجليزي)",
    "change.field.form.may_edit": "يجوز التعديل",
    "change.field.form.may_return": "يجوز الإرجاع",
    "change.field.form.name_ar": "النموذج",
    "change.field.form.name_en": "الاسم بالإنجليزية",
    "change.field.form.options": "الخيارات",
    "change.field.form.position": "الترتيب",
    "change.field.form.published_at": "نُشر",
    "change.field.form.published_by": "نشره",
    "change.field.form.required": "مطلوب",
    "change.field.form.retired_at": "تاريخ الإيقاف",
    "change.field.form.revision": "الإصدار",
    "change.field.form.rules": "القواعد",
    "change.field.form.section": "القسم",
    "change.field.form.sections": "الأقسام",
    "change.field.form.sla_hours": "مستوى الخدمة (ساعات)",
    "change.field.form.status": "الحالة",
    "change.field.form.type": "النوع",
    "change.field.form.visible_when": "يظهر عندما",
    "change.field.gosi_settings.exclude_within_days": "الاستبعاد خلال (أيام)",
    "change.field.gosi_settings.last_refreshed_at": "آخر تحديث في",
    "change.field.gosi_settings.last_refreshed_by": "آخر من حدّثه",
    "change.field.gosi_settings.new_scheme_from": "النظام الجديد من",
    "change.field.gosi_settings.maternity_leave_types": "أنواع الإجازة التي هي إجازة أمومة",
    "change.field.gosi_settings.maternity_notice_within_days": "أيام إشعار إجازة الأمومة",
    "change.field.gosi_settings.register_within_days": "التسجيل خلال (أيام)",
    "change.field.item.created_by": "أنشأه",
    "change.field.item.done_at": "تاريخ الإنجاز",
    "change.field.item.done_by": "أنجزه",
    "change.field.item.done_on": "تاريخ الإنجاز",
    "change.field.item.due_on": "المهلة حتى",
    "change.field.item.effective_on": "تاريخ السريان",
    "change.field.item.employment_id": "التوظيف",
    "change.field.item.fact_key": "الحقيقة",
    "change.field.item.kind": "نوع البلاغ",
    "change.field.item.name": "القاعدة",
    "change.field.item.note": "ملاحظة",
    "change.field.item.purchase_price": "سعر الشراء",
    "change.field.item.reference": "مرجع التأمينات",
    "change.field.item.transfer_from": "منقول من",
    "change.field.item.last_failure": "رفض المنصّة",
    "change.field.item.failed_on": "تاريخ الرفض",
    "change.field.item.failed_by": "سجّل الرفض",
    "change.field.item.retired_at": "تاريخ الإيقاف",
    "change.field.item.scheme": "النظام",
    "change.field.item.scheme_basis": "أساس النظام",
    "change.field.item.snapshot": "اللقطة",
    "change.field.item.snapshot_at": "تاريخ اللقطة",
    "change.field.item.source": "المصدر",
    "change.field.item.source_ref": "المصدر",
    "change.field.item.status": "الحالة",
    "change.field.item.submission_id": "الإرسال",
    "change.field.item_dimension.dimension_id": "البُعد",
    "change.field.item_dimension.item_id": "البند",
    "change.field.item_dimension.value_id": "القيمة",
    "change.field.journal.code": "الرمز",
    "change.field.journal.default_account_id": "الحساب الافتراضي",
    "change.field.journal.iban": "الآيبان",
    "change.field.journal.journal_type": "النوع",
    "change.field.journal.name_ar": "الاسم",
    "change.field.journal.name_en": "الاسم بالإنجليزية",
    "change.field.journal.retired_at": "تاريخ الإيقاف",
    "change.field.journal.sequence_pattern": "نمط التسلسل",
    "change.field.layout.created_by": "أنشأه",
    "change.field.layout.key": "المفتاح",
    "change.field.layout.name": "الاسم",
    "change.field.layout.retired_at": "تاريخ الإيقاف",
    "change.field.layout.spec": "القالب (JSON)",
    "change.field.layout.status": "الحالة",
    "change.field.lock_dates.fiscal_lock_on": "الإقفال المالي",
    "change.field.lock_dates.set_by": "عيّنه",
    "change.field.lock_dates.tax_lock_on": "الإقفال الضريبي",
    "change.field.occasion.approved_at": "تاريخ الاعتماد",
    "change.field.occasion.approved_by": "اعتمده",
    "change.field.occasion.created_by": "أنشأه",
    "change.field.occasion.gregorian_from": "من",
    "change.field.occasion.gregorian_to": "إلى",
    "change.field.occasion.hijri_from": "من (هجري)",
    "change.field.occasion.hijri_to": "إلى (هجري)",
    "change.field.occasion.key": "المفتاح",
    "change.field.occasion.kind": "النوع",
    "change.field.occasion.location_ref": "الموقع",
    "change.field.occasion.name_ar": "المناسبة",
    "change.field.occasion.name_en": "الاسم بالإنجليزية",
    "change.field.occasion.pack": "من الحزمة",
    "change.field.occasion.proposed_by": "اقترحه",
    "change.field.occasion.scope": "النطاق",
    "change.field.occasion.withdrawn_at": "تاريخ السحب",
    "change.field.occasion.withdrawn_by": "سحبه",
    "change.field.occasion.withdrawn_reason": "سبب السحب",
    "change.field.payment.allocated_total": "المخصّص",
    "change.field.payment.amount": "المبلغ",
    "change.field.payment.created_by": "أنشأه",
    "change.field.payment.currency": "العملة",
    "change.field.payment.direction": "الاتجاه",
    "change.field.payment.document_id": "المستند",
    "change.field.payment.id": "المعرف",
    "change.field.payment.journal_entry_id": "القيد المحاسبي",
    "change.field.payment.journal_id": "الدفتر",
    "change.field.payment.method": "الطريقة",
    "change.field.payment.paid_on": "تاريخ الدفع",
    "change.field.payment.party_id": "الطرف",
    "change.field.payment.provider_ref": 'مرجع البنك',
    "change.field.payment.state": "الحالة",
    "change.field.payment_term.code": "الرمز",
    "change.field.payment_term.days": "الأيام",
    "change.field.payment_term.name_ar": "الاسم (عربي)",
    "change.field.payment_term.name_en": "الاسم (إنجليزي)",
    "change.field.payment_term.retired_at": "تاريخ الإيقاف",
    "change.field.period.closed_at": "تاريخ الإغلاق",
    "change.field.period.closed_by": "أغلقه",
    "change.field.period.ends_on": "إلى",
    "change.field.period.fiscal_year_id": "السنة المالية",
    "change.field.period.name_ar": "الفترة",
    "change.field.period.name_en": "الاسم بالإنجليزية",
    "change.field.period.reopen_reason": "سبب إعادة الفتح",
    "change.field.period.reopened_at": "تاريخ إعادة الفتح",
    "change.field.period.reopened_by": "أعاد فتحه",
    "change.field.period.starts_on": "من",
    "change.field.period.status": "الحالة",
    "change.field.policy.created_by": "أنشأه",
    "change.field.policy.ends_on": "تاريخ الانتهاء",
    "change.field.policy.id": "المعرّف",
    "change.field.policy.starts_on": "من",
    "change.field.posting_rule.credit_account_id": "حساب الدائن",
    "change.field.posting_rule.debit_account_id": "حساب المدين",
    "change.field.posting_rule.line_kind": "نوع السطر",
    "change.field.posting_rule.priority": "الأولوية",
    "change.field.posting_rule.retired_at": "تاريخ الإيقاف",
    "change.field.posting_rule.source_module": "المديول المصدر",
    "change.field.posting_rule.tax_code_id": "رمز الضريبة",
    "change.field.posting_rule.valid_from": "ساري من",
    "change.field.posting_rule.valid_to": "سارٍ حتى",
    "change.field.profile.code": "الرمز",
    "change.field.profile.deadline_hours": "المهلة (ساعات)",
    "change.field.profile.document_kind": "نوع المستند",
    "change.field.profile.effective_from": "نافذ من",
    "change.field.profile.path": "القناة",
    "change.field.profile.qr_tag_count": "عدد وسوم QR",
    "change.field.profile.status": "الحالة",
    "change.field.rate.branch": "الفرع",
    "change.field.rate.confirmed_at": "اعتُمد",
    "change.field.rate.confirmed_by": "أكّده",
    "change.field.rate.created_by": "أنشأه",
    "change.field.rate.effective_from": "من تاريخ",
    "change.field.rate.employee_rate": "حصة الموظّف %",
    "change.field.rate.employer_rate": "حصة صاحب العمل %",
    "change.field.rate.note": "ملاحظة",
    "change.field.rate.scheme": "النظام",
    "change.field.rate.source": "المصدر",
    "change.field.rate.status": "الحالة",
    "change.field.rate.wage_ceiling": "الحد الأعلى للأجر",
    "change.field.rate.wage_floor": "الحد الأدنى للأجر",
    "change.field.rate.withdrawn_at": "تاريخ السحب",
    "change.field.rate.withdrawn_by": "سحبه",
    "change.field.reason_code.code": "الرمز",
    "change.field.reason_code.kind": "النوع",
    "change.field.reason_code.name_ar": "الاسم (عربي)",
    "change.field.reason_code.name_en": "الاسم (إنجليزي)",
    "change.field.reason_code.retired_at": "تاريخ الإيقاف",
    "change.field.reconciliation.columns": "الأعمدة",
    "change.field.reconciliation.created_by": "أنشأه",
    "change.field.reconciliation.filename": "اسم الملف",
    "change.field.reconciliation.format": "الملف",
    "change.field.reconciliation.imported_at": "تاريخ الاستيراد",
    "change.field.reconciliation.imported_by": "استورده",
    "change.field.reconciliation.kind": "النوع",
    "change.field.reconciliation.matched": "مطابَق",
    "change.field.reconciliation.mismatches": "الفروق",
    "change.field.reconciliation.rows": "الصفوف",
    "change.field.request.actor": "من قام به",
    "change.field.request.answers": "الإجابات",
    "change.field.request.at": "في",
    "change.field.request.changes": "التغييرات",
    "change.field.request.current_step": "الخطوة الحالية",
    "change.field.request.decided_at": "تقرّر",
    "change.field.request.decided_by": "قرّره",
    "change.field.request.decision": "القرار",
    "change.field.request.definition_id": "التعريف",
    "change.field.request.definition_key": "النموذج",
    "change.field.request.definition_revision": "الإصدار",
    "change.field.request.event_id": "الحدث",
    "change.field.request.id": "المعرّف",
    "change.field.request.number": "الرقم",
    "change.field.request.reason": "السبب",
    "change.field.request.status": "الحالة",
    "change.field.request.step": "الخطوة",
    "change.field.request.submitted_at": "قُدِّم",
    "change.field.request.submitted_by": "مقدّم الطلب",
    "change.field.request.submitter_employment_ref": "توظيف مقدّم الطلب",
    "change.field.rule.active_from": "نافذ من",
    "change.field.rule.channels": "القنوات",
    "change.field.rule.conditions": "فقط عندما",
    "change.field.rule.created_by": "أنشأه",
    "change.field.rule.escalate_after_minutes": "التصعيد بعد (دقيقة)",
    "change.field.rule.escalate_to": "التصعيد إلى",
    "change.field.rule.event_name": "عند",
    "change.field.rule.importance": "الأهمية",
    "change.field.rule.name": "القاعدة",
    "change.field.band.band": "النطاق",
    "change.field.band.confirmed": "معتمد",
    "change.field.band.confirmed_at": "تاريخ الاعتماد",
    "change.field.band.confirmed_by": "اعتمده",
    "change.field.band.created_by": "أدخله",
    "change.field.band.from_on": "ساري من",
    "change.field.band.min_ratio": "الحد الأدنى للنسبة",
    "change.field.band.note": "ملاحظة",
    "change.field.band.retired_at": "أُوقف في",
    "change.field.item.case_id": "ملف انتهاء الخدمة",
    "change.field.item.checked_at": "تاريخ المراجعة",
    "change.field.item.checked_by": "راجعه",
    "change.field.item.contract_id": "العقد",
    "change.field.item.contract_kind": "نوع العقد",
    "change.field.item.contract_version": "إصدار العقد",
    "change.field.item.from_on": "من",
    "change.field.item.issued_on": "تاريخ الإصدار",
    "change.field.item.leave_type": "نوع الإجازة",
    "change.field.item.movement_id": "القرار الإداري",
    "change.field.item.recorded_at": "تاريخ التسجيل",
    "change.field.item.recorded_by": "سجّله",
    "change.field.item.request_id": "طلب الإجازة",
    "change.field.item.to_on": "إلى",
    "change.field.item.valid_until": "صالح حتى",
    "change.field.minimum_wage.amount": "الحد الأدنى للأجر",
    "change.field.minimum_wage.confirmed": "معتمد",
    "change.field.minimum_wage.confirmed_at": "تاريخ الاعتماد",
    "change.field.minimum_wage.confirmed_by": "اعتمده",
    "change.field.minimum_wage.created_by": "أدخله",
    "change.field.minimum_wage.from_on": "ساري من",
    "change.field.minimum_wage.note": "ملاحظة",
    "change.field.minimum_wage.retired_at": "أُوقف في",
    "change.field.residence.document_id": "الوثيقة",
    "change.field.residence.employment_id": "الموظّف",
    "change.field.residence.expires_on": "تاريخ الانتهاء",
    "change.field.residence.renewed_on": "تاريخ التجديد",
    "change.field.residence.residence_number": "رقم الإقامة",
    "change.field.residence.source": "المصدر",
    "change.field.settings.expiry_warning_days": "التنبيه قبل الانتهاء بأيام",
    "change.field.settings.residence_type_keys": "أنواع الوثائق التي تُعد إقامة",
    "change.field.settings.warning_margin": "هامش التنبيه (نقاط)",
    "change.field.rule.subject_field": "الشخص الذي يسمّيه الحدث",
    "change.field.rule.subject_permission": "الصلاحية التي يحتاجها الشخص",
    "change.field.rule.pack": "الحزمة",
    "change.field.rule.pack_item": "بند الحزمة",
    "change.field.rule.pack_version": "إصدار الوصفة",
    "change.field.channel_consent.user_id": "العضو",
    "change.field.channel_consent.channel": "القناة",
    "change.field.channel_consent.opted_in": "يستلمها",
    "change.field.template.kind": "الإشعار",
    "change.field.template.locale": "اللغة",
    "change.field.template.provider_name": "الاسم لدى ميتا",
    "change.field.template.language_code": "لغة الاعتماد",
    "change.field.template.body": "النص",
    "change.field.template.parameters": "المتغيرات",
    "change.field.template.link": "الرابط في التطبيق",
    "change.field.template.pack": "الحزمة",
    "change.field.template.pack_version": "إصدار الوصفة",
    "change.field.party.whatsapp_opt_in_at": "موافقة واتساب",
    "change.field.party.whatsapp_opt_out_at": "سحب موافقة واتساب",
    "change.field.party.consent_source": "سُجّلت الموافقة عبر",
    "change.field.party.consent_by": "سجّل الموافقة",
    "change.field.rule.retired_at": "تاريخ الإيقاف",
    "change.field.rule.retired_by": "أوقفه",
    "change.field.rule.roles": "تُبلِّغ",
    "change.field.rule.status": "الحالة",
    "change.field.seller.branch_code": "الفرع",
    "change.field.seller.building_number": "رقم المبنى",
    "change.field.seller.city": "المدينة",
    "change.field.seller.country": "الدولة",
    "change.field.seller.cr_number": "السجل التجاري",
    "change.field.seller.district": "الحيّ",
    "change.field.seller.legal_name_ar": "الاسم القانوني",
    "change.field.seller.legal_name_en": "الاسم القانوني (إنجليزي)",
    "change.field.seller.postcode": "الرمز البريدي",
    "change.field.seller.region": "المنطقة",
    "change.field.seller.retired_at": "تاريخ الإيقاف",
    "change.field.seller.street": "الشارع",
    "change.field.seller.vat_number": "ضريبة القيمة المضافة",
    "change.field.status_import.file_id": "الملف",
    "change.field.status_import.filename": "اسم الملف",
    "change.field.status_import.format": "الصيغة",
    "change.field.status_import.hr_detail": "تفصيل الموارد البشرية",
    "change.field.status_import.hr_state": "حالة الموارد البشرية",
    "change.field.status_import.imported_at": "تاريخ الاستيراد",
    "change.field.status_import.imported_by": "استورده",
    "change.field.status_import.matched": "مطابَق",
    "change.field.status_import.paid": "مدفوع",
    "change.field.status_import.pending": "قيد المعالجة",
    "change.field.status_import.rejected": "مرفوض",
    "change.field.status_import.rows": "الصفوف",
    "change.field.status_import.run_id": "مسيّر الرواتب",
    "change.field.status_import.unmatched": "غير مطابَق",
    "change.field.submission.alert_50_at": "تنبيه 50% في",
    "change.field.submission.alert_80_at": "تنبيه 80% في",
    "change.field.submission.attempt": "المحاولة",
    "change.field.submission.attempt_no": "المحاولة",
    "change.field.submission.authority_reference": "مرجع الجهة",
    "change.field.submission.channel": "طريقة الإرسال",
    "change.field.submission.content_base64": "محتوى الملف",
    "change.field.submission.content_type": "نوع المحتوى",
    "change.field.submission.deadline_at": "الموعد النهائي",
    "change.field.submission.edocument_id": 'الفاتورة الإلكترونية',
    "change.field.submission.environment": "البيئة",
    "change.field.submission.failure_reason": "سبب الفشل",
    "change.field.submission.filename": "اسم الملف",
    "change.field.submission.format": "الملف",
    "change.field.submission.id": "المعرّف",
    "change.field.submission.idempotency_key": "مفتاح عدم التكرار",
    "change.field.submission.item_id": "البند",
    "change.field.submission.items_count": "عدد البنود",
    "change.field.submission.kind": "البند",
    "change.field.submission.masked_request": "الطلب (مقنّع)",
    "change.field.submission.prepared_at": "تاريخ الإعداد",
    "change.field.submission.prepared_by": "أعدّه",
    "change.field.submission.request_digest": "ملخّص الطلب",
    "change.field.submission.resolved_at": "تاريخ الحل",
    "change.field.submission.resolved_by": "حلّه",
    "change.field.submission.response_status": "الرد",
    "change.field.submission.retry_class": "إعادة المحاولة",
    "change.field.submission.rows": "الصفوف",
    "change.field.submission.status": "الحالة",
    "change.field.submission.submitted_at": "تاريخ التقديم",
    "change.field.submission.submitted_by": "قدّمه",
    "change.field.submission.submitted_on": "تاريخ التقديم",
    "change.field.submission.validation_results": "نتائج التحقق",
    "change.field.submission.warnings": "التحذيرات",
    "change.field.submission.withdrawn_at": "تاريخ السحب",
    "change.field.submission.withdrawn_by": "سحبه",
    "change.field.tag.colour": "اللون",
    "change.field.tag.group_id": "المجموعة",
    "change.field.tag.key": "المفتاح",
    "change.field.tag.name": "الاسم",
    "change.field.tag_group.exclusive": "حصري",
    "change.field.tag_group.key": "المفتاح",
    "change.field.tag_group.name": "الاسم",
    "change.field.tagging.attached_at": "تاريخ الإرفاق",
    "change.field.tagging.attached_by": "أرفقه",
    "change.field.tagging.ref_entity": "نوع السجل المشار إليه",
    "change.field.tagging.ref_id": "السجل المشار إليه",
    "change.field.tagging.ref_module": "المديول المشار إليه",
    "change.field.tagging.tag_id": "الوسم",
    "change.field.tax_code.base_account_id": "الحساب الأساس",
    "change.field.tax_code.code": "الرمز",
    "change.field.tax_code.confirmed_at": "تاريخ التأكيد",
    "change.field.tax_code.confirmed_by": "أكّده",
    "change.field.tax_code.deductible": "قابلية الخصم",
    "change.field.tax_code.enabled": "مفعّل",
    "change.field.tax_code.exemption_reason_code": "رمز سبب الإعفاء",
    "change.field.tax_code.name_ar": "الاسم",
    "change.field.tax_code.name_en": "الاسم بالإنجليزية",
    "change.field.tax_code.rate": "النسبة %",
    "change.field.tax_code.retired_at": "تاريخ الإيقاف",
    "change.field.tax_code.tax_account_id": "حساب الضريبة",
    "change.field.tax_code.tax_type": "النوع",
    "change.field.tax_code.valid_from": "ساري من",
    "change.field.tax_code.valid_to": "سارٍ حتى",
    "change.field.tax_rule.buyer_type": "نوع المشتري",
    "change.field.tax_rule.line_kind": "نوع السطر",
    "change.field.tax_rule.priority": "الأولوية",
    "change.field.tax_rule.retired_at": "تاريخ الإيقاف",
    "change.field.tax_rule.supply_destination": "وجهة التوريد",
    "change.field.tax_rule.tax_code_id": "رمز الضريبة",
    "change.field.tax_rule.valid_from": "ساري من",
    "change.field.tax_rule.valid_to": "سارٍ حتى",
    "change.field.template.created_by": "أنشأه",
    "change.field.template.id": "المعرّف",
    "change.field.template.status": "الحالة",
    "change.field.type.alert_days": "أيام التنبيه قبل الانتهاء",
    "change.field.type.applies_to": "لمن",
    "change.field.type.builtin": "من المنصّة",
    "change.field.type.created_by": "أنشأه",
    "change.field.type.expires": "له انتهاء",
    "change.field.type.key": "المفتاح",
    "change.field.type.legal_hold": "تجميد قانوني",
    "change.field.type.name_ar": "النوع",
    "change.field.type.name_en": "الاسم (بالإنجليزية)",
    "change.field.type.retention_category": "فئة الحفظ",
    "change.field.type.retention_years": "سنوات الحفظ بعده",
    "change.field.type.retired_at": "تاريخ الإيقاف",
    "change.field.type.retired_by": "أوقفه",
    "change.field.type.status": "الحالة",
    "documents.party_documents.action.attach": "إرفاق",
    "documents.party_documents.col.status": "الحالة",
    "documents.party_expired.alert.2": "{type_name_ar} انتهت {expires_on}",
    "documents.party_expiring.action.renew": "تسجيل التجديد",
    "documents.party_expiring.alert.2": "{type_name_ar} تنتهي {expires_on}",
    "identity.party_account.empty": "لا حساب دخول لهذا الشخص في مساحة العمل.",
    "identity.party_account.title": "حساب الدخول",
    "identity.party_portal.title": "البوابة",
    "identity.party_portal.empty": "لا يدخل هذا الطرف البوابة.",
    "identity.party_portal.column.status": "الحالة",
    "identity.party_portal.column.last_seen_at": "آخر دخول",
    "identity.party_portal.column.invitation_expires_at": "تنتهي الدعوة",
    "identity.party_portal.column.source": "دُعي إلى بوابة",
    "identity.party_portal.column.id": "الحساب",
    "identity.party_portal.action.invite": "دعوة إلى البوابة",
    "identity.party_portal.action.invite.field.module": "بوابة",
    "identity.party_portal.action.invite.reveal.link": "رابط الدعوة",
    "identity.party_portal.action.invite.reveal.expires_at": "صالح حتى",
    "identity.party_portal.action.invite.reveal_note": "الرابط يُستعمل مرة واحدة. أرسله إلى الطرف؛ لن يظهر مرة أخرى.",
    "identity.party_portal.action.suspend": "تعليق",
    "identity.party_portal.action.resume": "استئناف",
    "identity.portal.status.invited": "مدعو",
    "identity.portal.status.expired": "انتهت الدعوة",
    "identity.portal.status.active": "يدخل البوابة",
    "identity.portal.status.suspended": "معلّق",
    "nav.identity.portal_members": "أعضاء البوابة",
    "screen.identity.portal_members.title": "أعضاء البوابة",
    "screen.identity.portal_members.lede": "الأطراف من خارج مساحة العمل الذين يدخلون بوابتها، ومن دُعوا إليها.",
    "screen.identity.portal_members.column.party_name": "الطرف",
    "screen.identity.portal_members.column.status": "الحالة",
    "screen.identity.portal_members.column.source": "الدعوة إلى",
    "screen.identity.portal_members.column.last_seen_at": "آخر دخول",
    "screen.identity.portal_members.column.invitation_expires_at": "تنتهي الدعوة",
    "screen.identity.portal_members.column.invited_at": "تاريخ الدعوة",
    "screen.identity.portal_members.column.party_id": "معرّف الطرف",
    "screen.identity.portal_members.column.id": "الحساب",
    "screen.identity.portal_members.tab.awaiting": "بانتظار القبول",
    "screen.identity.portal_members.empty": "لم تُدعَ أي جهة إلى البوابة بعد.",
    "screen.identity.portal_members.action.invite": "دعوة طرف",
    "screen.identity.portal_members.action.invite.field.party_id": "الطرف",
    "screen.identity.portal_members.action.invite.field.module": "بوابة",
    "screen.identity.portal_members.action.invite.reveal.link": "رابط الدعوة",
    "screen.identity.portal_members.action.invite.reveal.expires_at": "صالح حتى",
    "screen.identity.portal_members.action.invite.reveal_note": "الرابط يُستعمل مرة واحدة. أرسله إلى الطرف؛ لن يظهر مرة أخرى.",
    "screen.identity.portal_members.action.invite_again": "إعادة الدعوة",
    "screen.identity.portal_members.action.invite_again.effect": "يتوقف الرابط السابق عن العمل.",
    "screen.identity.portal_members.action.suspend": "إيقاف",
    "screen.identity.portal_members.action.suspend.effect": "سيُخرَج الطرف من البوابة فورًا، ولن يدخلها حتى يُعاد تفعيله.",
    "screen.identity.portal_members.action.resume": "إعادة التفعيل",
    "parties.party.col.nationality": "الجنسية",
    "parties.party.col.phone": "الجوال",
    "parties.party_identity.col.scheme": "النوع",
    "parties.party_iqama.col.value": "الإقامة",
    "parties.party_national_id.col.value": "الهوية الوطنية",
    "parties.party_personal.note": "سجل الشخص نفسه في سجل الأطراف: كل وحدة تسمّي هذا الشخص تقرؤه من هنا.",
    "parties.party_personal.title": "البيانات الشخصية",
    "parties.party_relation.col.id": "الطرف",
    "parties.party_relation.col.name": "الشخص",
    "parties.party_relation.title": "الشخص",
    "record.card.sensitive": "صلاحية خاصة",
    "record.card.sensitive.hint": "يظهر فقط لمن يملك صلاحيته",
    "record.cards.more_named": "{n:more_sections}: {names}",
    "record.changes.created_from": "أُنشئ من {what}",
    "record.related": "مرتبط بـ",
    "record.stages.exits": "خروج: {exits}",
    "screen.parties.parties.action.edit.field.nationality": "الجنسية",
    "screen.parties.parties.action.edit.field.phone": "الجوال",
    "unit.minutes.few": "{n} دقائق",
    "unit.minutes.many": "{n} دقيقة",
    "unit.minutes.one": "دقيقة واحدة",
    "unit.minutes.other": "{n} دقيقة",
    "unit.minutes.two": "دقيقتان",
    "unit.minutes.zero": "{n} دقيقة",
    "unit.months.few": "{n} أشهر",
    "unit.months.many": "{n} شهراً",
    "unit.months.one": "شهر",
    "unit.months.other": "{n} شهر",
    "unit.months.two": "شهران",
    "unit.months.zero": "{n} شهر",
    "unit.times.few": "{n} مرات",
    "unit.times.many": "{n} مرة",
    "unit.times.one": "مرة واحدة",
    "unit.times.other": "{n} مرة",
    "unit.times.two": "مرتان",
    "unit.times.zero": "لا مرة",
    "unit.workdays.few": "{n} أيام عمل",
    "unit.workdays.many": "{n} يوم عمل",
    "unit.workdays.one": "يوم عمل واحد",
    "unit.workdays.other": "{n} يوم عمل",
    "unit.workdays.two": "يوما عمل",
    "unit.workdays.zero": "{n} يوم عمل",
    "value.penalty.none": "لا يوجد",
    // ── end of the entity record pages block ──
    "screen.invoicing.document.column.overdue": "متأخرة",
    "screen.invoicing.document.column.days_overdue": "أيام التأخر",
    "screen.invoicing.document.alert.overdue": "متأخرة عن الاستحقاق ولا دفعة موزعة عليها",
    "screen.invoicing.document.card.customer.link": "الملف الحالي للعميل",
    "screen.invoicing.document.history.note": "بعد الترحيل لا يتغيّر حقل في الفاتورة: التصحيح بإشعار دائن أو مدين. قرارات المديولات الأخرى تبقى في بطاقاتها؛ الخط الزمني المدمج مرحلة لاحقة.",
    "screen.invoicing.document_open_payments.title": "دفعات غير موزعة",
    "screen.invoicing.document_open_payments.col.open": "غير موزع",
    "screen.invoicing.document_open_payments.alert": "دفعة {provider_ref} من العميل نفسه بمبلغ {open_amount} غير موزعة",
    "screen.einvoicing.document_edocument.col.icv": 'عدّاد الفاتورة (ICV)',
    "screen.einvoicing.document_edocument.col.hash": 'تجزئة الفاتورة',
    "screen.einvoicing.document_edocument.col.previous_hash": 'تجزئة الفاتورة السابقة (PIH)',
    "screen.einvoicing.document_edocument.col.last_attempt": "آخر محاولة",
    "screen.einvoicing.document_edocument.last_attempt": "{last_attempt_at} · {report_status}",
    "screen.einvoicing.document_edocument.outcome.cleared": "اعتُمدت",
    "screen.einvoicing.document_edocument.outcome.reported": "أُبلغت",
    "screen.einvoicing.document_edocument.outcome.rejected": "رُفضت",
    "screen.einvoicing.document_edocument.outcome.pending": "بانتظار الإرسال",
    "screen.einvoicing.document_edocument.outcome.unreachable": "تعذّر الوصول",
    "screen.einvoicing.document_edocument.outcome.not_required": "غير مطلوبة",
    "screen.einvoicing.document_status.title": "الهيئة (الفوترة الإلكترونية)",
    "screen.einvoicing.document_status.value.cleared": 'اعتُمدت',
    "screen.einvoicing.document_status.value.reported": 'أُبلغت',
    "screen.einvoicing.document_status.value.pending": "لم تُرسل بعد",
    "screen.einvoicing.document_status.value.unreachable": "تعذّر الوصول",
    "screen.einvoicing.document_status.value.rejected": "مرفوضة",
    "screen.einvoicing.document_status.value.not_required": "غير مطلوبة",
    "screen.einvoicing.document_cleared.path.clearance": 'الاعتماد',
    "screen.einvoicing.document_cleared.path.reporting": 'الإبلاغ',
    "screen.accounting.entry_lines.account": "{account_code} · {account_name}",
    // The party page (parties.party) and what accounting adds to it.
    "screen.parties.party.title": "ملف الطرف",
    "parties.party.col.vat_number": "الرقم الضريبي",
    "parties.party.col.cr_number": "السجل التجاري",
    "parties.party.col.national_address": "العنوان الوطني",
    "parties.party.col.national_short_address": "العنوان المختصر",
    "parties.party.col.billing_address": "عنوان الفوترة",
    "parties.party.billing.same": "نفسه",
    "parties.party.col.contact": "جهة الاتصال",
    "parties.party.col.contact_phone": "جوال جهة الاتصال",
    "parties.party.card.personal.empty": "لم يُسجَّل لهذا الشخص جوال أو جنسية بعد.",
    "parties.party.col.bank_account": "الحساب البنكي",
    "parties.party.col.bank_name": "البنك",
    "parties.party.col.iban": "الآيبان",
    "parties.party.col.bank_status": "التحقق",
    "parties.party.bank_status.verified": "مُتحقَّق منه",
    "parties.party.bank_status.unverified": "غير مُتحقَّق منه",
    "parties.party.bank_status.retired": "موقوف",
    "parties.party.col.bank_currency": "العملة",
    "parties.party.currency.SAR": "ر.س",
    "parties.party.currency.USD": "دولار أمريكي",
    "parties.party.currency.EUR": "يورو",
    "parties.party.currency.AED": "درهم إماراتي",
    "parties.party.subtitle.vat": "الرقم الضريبي {value}",
    "parties.party.column.merged_into": "دُمج في",
    "parties.party.alert.merged": "دُمج في {merged_into}: وهو الطرف الذي يُستعمل من الآن",
    "parties.party.alert.merged.open": "افتحه",
    "parties.party.alert.archived": "مؤرشف: محفوظ بسجله",
    "parties.party.subtitle.cr": "السجل التجاري {value}",
    "parties.party.tab.identities": "العناوين والهويات",
    "parties.party.tab.bank": "الحسابات البنكية",
    "parties.party.card.identities": "الهويات والعناوين",
    "parties.party.card.identities.empty": "لم يُسجَّل لهذا الطرف رقم أو عنوان أو جهة اتصال بعد.",
    "parties.party.card.bank.note": "الرقم الكامل لمن يملك صلاحية الصرف فقط",
    "parties.party.history.note": "تغييرات حقول هذا الملف فقط؛ قرارات المديولات الأخرى تبقى في بطاقاتها. الخط الزمني المدمج مرحلة لاحقة.",
    "parties.party_addresses.title": "العناوين",
    "parties.party_addresses.empty": "لا عنوان مسجَّل لهذا الطرف.",
    "parties.party.purpose.billing": "فوترة",
    "parties.party.purpose.shipping": "شحن",
    "parties.party.purpose.registered": "وطني (المسجَّل)",
    "parties.party.purpose.correspondence": "مراسلة",
    "parties.party_identifiers.title": "المعرّفات",
    "parties.party_identifiers.col.valid_from": "من",
    "parties.party_identifiers.col.valid_to": "حتى",
    "parties.party_identifiers.empty": "لا رقم ضريبي أو سجل مسجَّل لهذا الطرف.",
    "parties.party.scheme.sa_vat": "الرقم الضريبي",
    "parties.party.scheme.sa_cr": "السجل التجاري",
    "parties.party.scheme.sa_nid": "الهوية الوطنية",
    "parties.party.scheme.sa_iqama": "الإقامة",
    "parties.party_bank_accounts.col.holder": "صاحب الحساب",
    "parties.party_bank_accounts.note": "مُقنَّع إلى آخر أربعة أرقام. الرقم الكامل لمن يملك صلاحية الصرف فقط، حساباً حساباً، وتُسجَّل كل قراءة.",
    "parties.party_bank_accounts.empty": "لا حساب بنكي مسجَّل لهذا الطرف.",
    "parties.party_bank_accounts.action.add": "إضافة حساب",
    "parties.party_bank_accounts.action.retire": "إيقاف",
    "parties.party_bank_accounts.field.iban.help": "SA واثنان وعشرون رقماً للحساب السعودي. يُحفظ كاملاً ولا يُعرض منه إلا آخر أربعة أرقام.",
    "parties.party_addresses.action.retire": "إيقاف",
    "screen.parties.parties.action.archive": "أرشفة",
    "screen.parties.parties.action.merge": "دمج في…",
    "screen.parties.parties.action.merge.field.into": "الطرف الباقي",
    "screen.parties.parties.action.merge.field.into.help": "يُدمج هذا الطرف في الطرف المختار ويُحال إليه من الآن. لا يمكن التراجع عن ذلك.",
    "screen.parties.parties.action.merge.field.reason": "السبب",
    "screen.parties.parties.action.create.field.identifier_scheme": "الرقم",
    "screen.parties.parties.action.create.field.identifier_scheme.help": "اختياري. تُضاف أرقام أخرى من ملف الطرف لاحقاً.",
    "invoicing.party.balances.title": "الرصيد",
    "invoicing.party.col.ar_open": "مستحق لنا",
    "invoicing.party.col.ap_open": "مستحق علينا",
    "invoicing.party.col.overdue": "متأخر",
    "invoicing.party.ageing.title": "أعمار الذمم المدينة",
    "invoicing.party.ageing.not_due": "غير مستحق",
    "invoicing.party.ageing.d1_30": "1–30 يوماً",
    "invoicing.party.ageing.d31_60": "31–60",
    "invoicing.party.ageing.d61_90": "61–90",
    "invoicing.party.ageing.over_90": "أكثر من 90",
    "invoicing.party.ageing.note": "كل فاتورة مفتوحة بعدد الأيام منذ تاريخ استحقاقها، ومن لا تاريخ استحقاق لها تُستحق يوم إصدارها. رقم «متأخر» في الرأس هو مجموع الشرائح المتأخرة هنا.",
    "invoicing.party.late.title": "فواتير متأخرة أكثر من 30 يوماً",
    "invoicing.party.late.count": "الفواتير",
    "invoicing.party.late.amount": "المبلغ",
    "invoicing.party.late.oldest": "أقدم استحقاق",
    "invoicing.party.late.alert": "{late30_count} متأخرة أكثر من 30 يوماً بقيمة {late30_amount}",
    "unit.invoices.zero": "{n} فاتورة",
    "unit.invoices.one": "فاتورة واحدة",
    "unit.invoices.two": "فاتورتان",
    "unit.invoices.few": "{n} فواتير",
    "unit.invoices.many": "{n} فاتورة",
    "unit.invoices.other": "{n} فاتورة",
    "invoicing.party.payments.title": 'آخر السندات',
    "invoicing.party.payments.tab": 'السندات',
    "invoicing.party.payments.allocate": "توزيع",
    "invoicing.party.payments.empty": 'لم يُسجَّل سند مع هذا الطرف.',
    "invoicing.party.col.reference": "المرجع",
    "invoicing.party.col.date": "التاريخ",
    "invoicing.party.col.unallocated": "غير موزع",
    "invoicing.party.unallocated.title": "دفعات غير موزعة",
    "invoicing.party.unallocated.alert": "دفعة {reference} بمبلغ {open_amount} غير موزعة على فواتير",
    "invoicing.party.invoices.title": "الفواتير",
    "invoicing.party.invoices.empty": 'لم تصدر فاتورة لهذا العميل.',
    "invoicing.party.col.number": "الرقم",
    "invoicing.party.col.remaining": "المتبقي",
    "invoicing.party.col.standing": "الحالة",
    "invoicing.party.standing.draft": "مسودة",
    "invoicing.party.standing.validated": "معتمدة",
    "invoicing.party.standing.posted": "مرحَّلة",
    "invoicing.party.standing.overdue": "متأخرة",
    "invoicing.party.standing.partial": "مدفوعة جزئياً",
    "invoicing.party.standing.paid": "مسددة",
    "invoicing.party.standing.cancelled_by_note": "ملغاة بإشعار",
    "invoicing.party.col.einvoice": "فاتورة إلكترونية",
    "invoicing.party.einvoice.cleared": "مقبولة",
    "invoicing.party.einvoice.reported": 'أُبلغت',
    "invoicing.party.einvoice.pending": "لم تُرسل بعد",
    "invoicing.party.einvoice.unreachable": "تعذّر الوصول",
    "invoicing.party.einvoice.rejected": "مرفوضة",
    "invoicing.party.einvoice.not_required": "غير مطلوبة",
    "invoicing.party.col.kind": "النوع",
    "invoicing.party.col.due_on": "الاستحقاق",
    "invoicing.party.col.withholding": 'ضريبة الاستقطاع',
    "invoicing.party.vendor_bills.title": "فواتير المورد",
    "invoicing.party.vendor_bills.empty": 'لم تُستلم فاتورة من هذا المورّد.',
    "invoicing.party.statement.title": "كشف الحساب",
    "invoicing.party.statement.kind.customer_invoice": "فاتورة",
    "invoicing.party.statement.kind.credit_note": "إشعار دائن",
    "invoicing.party.statement.kind.debit_note": "إشعار مدين",
    "invoicing.party.statement.kind.vendor_bill": "فاتورة مورد",
    "invoicing.party.statement.kind.payment": "دفعة",
    "invoicing.party.statement.debit": "مدين",
    "invoicing.party.statement.credit": "دائن",
    "invoicing.party.statement.balance": "الرصيد",
    "invoicing.party.statement.note": 'المستندات المرحَّلة والسندات على كامل التاريخ، مع الرصيد بعد كل سطر: الموجب مستحق لنا.',
    "invoicing.party.statement.empty": "لم يُرحَّل شيء مع هذا الطرف.",
    "einvoicing.party.buyer.title": "مخطط المشتري",
    "einvoicing.party.buyer.standard": "منشأة مسجلة",
    "einvoicing.party.buyer.simplified": "مستهلك أو غير مسجل",
    "record.reveal.failed": "تعذّر الإظهار",
    "record.figures.none": "لا شيء لعرضه: كل الأرقام صفر.",
    "value.statute_source.seed": "مقروء من ملخّصات نظام العمل المعدَّل (النافذ في 19 فبراير 2025) لا من الجريدة الرسمية؛ يُؤكَّد من النص الرسمي",
    "value.statute_source.adopted": "اعتمده المالك في 26 سبتمبر 2026 على أرجح قراءة للنظام المعدَّل، بانتظار مراجعة المحامي",
    "value.statute_standing.in_force": "نافذ",
    "value.statute_standing.awaiting": "بانتظار شخص ثانٍ",
    "value.statute_standing.later": "يبدأ لاحقاً",
    "value.statute_standing.replaced": "استُبدل",
    "value.statute_module.grievances": "التظلّمات",
    "value.statute_module.discipline": "الجزاءات",
    "value.statute_module.assets": "العُهد",
    "value.statute_module.payroll": "الرواتب",
    "value.statute_module.offboarding": "إنهاء الخدمة",
    "value.statute_unit.days": "يوماً",
    "value.statute_unit.months": "شهراً",
    "value.statute_unit.years": "سنة",
    "value.statute_unit.fraction": "من الأجر",
    "value.statute_unit.percent": "%",
    "value.statute_unit.hours": "ساعة",
    "value.statute_unit.none": "مادة فقط",
    "value.statute_key.grievances.objection_days": "أيام التظلّم من الجزاء (دون العطل الرسمية)",
    "value.statute_key.grievances.body_decision_days": "أيام جهة صاحب العمل للبتّ في التظلّم",
    "value.statute_key.grievances.hearing": "لا قرار قبل سماع العامل",
    "value.statute_key.grievances.limitation_months": "الأشهر بعد انتهاء العلاقة التي تُسمع خلالها الدعوى",
    "value.statute_key.discipline.penalties": "الجزاءات التي يجوز لصاحب العمل توقيعها",
    "value.statute_key.discipline.outside_regulation": "لا جزاء خارج النظام أو اللائحة المعتمدة",
    "value.statute_key.discipline.repeat_window_days": "الأيام بعد آخر إبلاغ التي يُعدّ التكرار خلالها",
    "value.statute_key.discipline.charge_days": "أيام اتهام العامل من اكتشاف المخالفة",
    "value.statute_key.discipline.penalty_days": "أيام توقيع الجزاء من انتهاء التحقيق",
    "value.statute_key.discipline.hearing": "لا جزاء قبل الاتهام كتابةً والسماع وتدوين الدفاع",
    "value.statute_key.discipline.oral_hearing_max_fine_days": "أثقل غرامة، بأجر أيام، يجوز معها السماع شفهياً",
    "value.statute_key.discipline.notice": "يُبلَّغ العامل بالجزاء كتابةً",
    "value.statute_key.discipline.fine_cap_days": "أثقل غرامة عن مخالفة واحدة، بأجر أيام",
    "value.statute_key.discipline.monthly_withholding_days": "أكثر ما يُحسم من الأجر في الشهر، بالأيام",
    "value.statute_key.discipline.monthly_suspension_days": "أكثر أيام الإيقاف بلا أجر في الشهر",
    "value.statute_key.discipline.dismissal": "الفصل بلا مكافأة ولا إشعار، في الحالات المذكورة",
    "value.statute_key.assets.damage_days_per_month": "أكثر ما يُحسم في الشهر عن إتلاف ممتلكات صاحب العمل، بأجر أيام",
    "value.statute_key.assets.all_deductions_fraction": "أكثر ما تأخذه الحسومات كلّها من الأجر في الشهر",
    "value.statute_key.payroll.period_max_days": "أطول فترة أجر، بالأيام",
    "value.statute_key.payroll.deductions_fraction": "أكثر ما تأخذه الحسومات من الأجر",
    "value.statute_key.payroll.overtime_premium_percent": "علاوة العمل الإضافي فوق أجر الساعة",
    "value.statute_key.payroll.hours_per_day": "ساعات يوم العمل",
    "value.statute_key.payroll.sick_unpaid_fraction": "الجزء من الأجر الذي لا يُدفع في شريحة الإجازة المرضية غير المدفوعة",
    "value.statute_key.offboarding.award_first_years": "سنوات الخدمة التي تُحسب بمكافأة نصف شهر",
    "value.statute_key.offboarding.resignation_none_below_years": "سنوات الخدمة التي لا تستحقّ الاستقالة دونها مكافأة",
    "value.statute_key.offboarding.resignation_third_to_years": "سنوات الخدمة التي تستحقّ الاستقالة حتى بلوغها ثلث المكافأة",
    "value.statute_key.offboarding.resignation_two_thirds_below_years": "سنوات الخدمة التي تستحقّ الاستقالة دونها ثلثي المكافأة",
    "value.statute_key.offboarding.art87_marriage_months": "الأشهر بعد الزواج التي تستحقّ العاملة باستقالتها خلالها المكافأة كاملة",
    "value.statute_key.offboarding.art87_childbirth_months": "الأشهر بعد الوضع التي تستحقّ العاملة باستقالتها خلالها المكافأة كاملة",
    "value.statute_key.offboarding.dismissal": "الفصل بلا مكافأة ولا إشعار، في الحالات المذكورة",
    "value.statute_key.offboarding.probation": "إنهاء العقد في فترة التجربة",
    "value.statute_key.offboarding.in_lieu": "بدل مهلة الإشعار",
    "value.statute_key.offboarding.art77_per_year_days": "أجر أيام التعويض عن كل سنة خدمة عند الإنهاء غير المشروع",
    "value.statute_key.offboarding.art77_floor_months": "أقلّ أشهر أجر تعويضاً عن الإنهاء غير المشروع",
    "value.statute_key.offboarding.resign_silence_days": "الأيام التي تُعدّ الاستقالة بعدها مقبولة إن لم يُردّ عليها",
    "value.statute_key.offboarding.resign_defer_max_days": "أكثر أيام يجوز لصاحب العمل تأجيل الاستقالة",
    "value.statute_key.offboarding.resign_withdraw_days": "الأيام التي يجوز خلالها سحب الاستقالة",
    "value.statute_key.offboarding.settlement_employer_days": "أيام سداد التسوية النهائية حين ينهي صاحبُ العمل العقد",
    "value.statute_key.offboarding.settlement_worker_days": "أيام سداد التسوية النهائية حين ينهي العاملُ العقد",
    "value.statute_key.offboarding.leave": "تُدفع الإجازة غير المستنفدة عند انتهاء الخدمة",
    "value.statute_key.offboarding.notice_worker_monthly_days": "مدة الإشعار التي يعطيها العامل ذو الأجر الشهري بالأيام",
    "value.statute_key.offboarding.notice_worker_other_days": "مدة الإشعار التي يعطيها العامل غير ذي الأجر الشهري بالأيام",
    "value.statute_key.offboarding.notice_employer_monthly_days": "مدة الإشعار التي يعطيها صاحب العمل للعامل ذي الأجر الشهري بالأيام",
    "value.statute_key.offboarding.notice_employer_other_days": "مدة الإشعار التي يعطيها صاحب العمل للعامل غير ذي الأجر الشهري بالأيام",
    "value.hearing_mode.written": "كتابةً",
    "value.hearing_mode.oral": "شفهياً بمحضر",
};
/**
 * A count in its unit from `unit.<unit>.<plural form>`, or null when the value is no count or the
 * unit has no words. A number is written the reader's way; a figure the caller already wrote
 * («4.72», «1,004») is kept as written and only read for its plural form.
 */
function countIn(messages, locale, unit, value) {
    const n = typeof value === 'number' ? value : typeof value === 'string' && /^\s*-?[\d,]+(\.\d+)?\s*$/.test(value) ? Number(value.replace(/[,\s]/g, '')) : NaN;
    if (!Number.isFinite(n))
        return null;
    let form = 'other';
    try {
        form = new Intl.PluralRules(locale).select(n);
    }
    catch { /* an unknown locale counts as "other" */ }
    const template = messages[`unit.${unit}.${form}`] ?? messages[`unit.${unit}.other`];
    if (template === undefined)
        return null;
    const figure = typeof value === 'string' ? value.trim() : n.toLocaleString(locale === 'ar' ? 'ar-u-nu-latn' : locale);
    return template.replace(/\{n\}/g, figure);
}
// A letter that reads left to right (Latin with its accents, Greek, Cyrillic) and one that reads
// right to left (Hebrew, Arabic, Syriac, Thaana, the presentation forms).
// × and ÷ sit among the accented letters and are not letters.
const STRONG_LTR = /[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F\u0370-\u03FF\u0400-\u04FF]/;
const STRONG_RTL = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;
const ALREADY_ISOLATED = /^[\u2066-\u2068][\s\S]*\u2069$/;
/**
 * A value said inside words of the other direction, kept in its own order: FSI … PDI (U+2068/U+2069)
 * around what the bidi algorithm would otherwise reorder — «1045-T», «+966 50 222 3344», «−5» inside
 * Arabic; «محمد علي 1045» inside English. Digits alone, a value in the paragraph's own script, and one
 * already isolated (formatCell's signed «⁦+12⁩») are left as they are: an isolate is a character a
 * file, a search and a test all carry, so none is added where the algorithm already reads it right
 * (the Arabic content review of 2026-10-27, AR-19).
 */
export function isolate(value, dir) {
    if (!value || ALREADY_ISOLATED.test(value))
        return value;
    const other = dir === 'rtl' ? STRONG_LTR.test(value) || /^[+\-\u2212]\s?\d/.test(value) : STRONG_RTL.test(value);
    return other ? `\u2068${value}\u2069` : value;
}
/** The first letter that has a direction: a Latin (or Greek, Cyrillic) one, or an Arabic (or Hebrew) one. */
const FIRST_STRONG = /([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F\u0370-\u03FF\u0400-\u04FF])|([\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF])/;
/**
 * The language a value is written in, when it is not the page's: an Arabic name in the English
 * screen is `ar`, a Latin one in the Arabic screen `en`, told by its first letter that has a
 * direction. Undefined when it is the page's own, or has no letters (a figure, a date). A reader
 * given no `lang` read «مشغل رافعة شوكية» with an English voice, letter by letter (P08-10).
 */
export function otherLang(text, page) {
    const first = FIRST_STRONG.exec(text);
    if (!first)
        return undefined;
    const lang = first[2] ? 'ar' : 'en';
    return lang === page ? undefined : lang;
}
/**
 * Two values as one span, «{from}–{to}», isolated together so the dash cannot flip them: isolating
 * each alone leaves the dash between two neutrals, laid out by the paragraph. A catalogue says
 * «{span}», never «{from}–{to}».
 */
export function isolateSpan(from, to) {
    return `\u2068${from}\u2013${to}\u2069`;
}
/** The isolates `isolate` and formatCell add, taken out — for a file a machine reads, a search needle, a test. */
export function plainWords(text) {
    return text.replace(/[\u2066-\u2069]/g, '');
}
export function createI18n(locale, extra = {}) {
    const base = locale === 'ar' ? AR : EN;
    const messages = { ...base, ...(extra[locale] ?? {}) };
    const dir = locale === 'ar' ? 'rtl' : 'ltr';
    return {
        locale,
        dir,
        t(key, vars) {
            const template = messages[key] ?? key;
            if (!vars)
                return template;
            return template.replace(/\{(\w+)(?::(\w+))?\}/g, (whole, name, unit) => {
                // A unit with no words here (`{amount:money}`, `{on:month}`) is left as written for templateWords.
                if (unit)
                    return countIn(messages, locale, unit, vars[name]) ?? whole;
                const v = vars[name];
                return v === undefined || v === null ? whole : isolate(String(v), dir);
            });
        },
    };
}
export const catalogues = { ar: AR, en: EN };
/**
 * A shared word in the page's language — its `lang`, which the shell sets — for a primitive drawn
 * with no I18n at hand: Confirm's «إلغاء» when its caller names no cancel word. An English literal
 * there reached an Arabic page (EMP-22).
 */
/** A shared word in a language named by a field (`ar`, `en-GB`), for a primitive with no catalogue of its own. */
export function wordIn(locale, key, vars = {}) {
    const said = (/^ar\b/i.test(locale) ? catalogues.ar[key] : undefined) ?? catalogues.en[key] ?? key;
    return said.replace(/\{(\w+)\}/g, (m, name) => vars[name] ?? m);
}
export function pageWord(key) {
    const ar = typeof document !== 'undefined' && /^ar\b/i.test(document.documentElement.lang ?? '');
    return (ar ? catalogues.ar[key] : undefined) ?? catalogues.en[key] ?? key;
}
//# sourceMappingURL=i18n.js.map